import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** An arbitrary precision decimal value. Often used for dollar amounts */
  Decimal: string & { __scalar: "Decimal" };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: string | boolean | number | Record<string, any> | string[] | boolean[] | number[];
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: string & { __scalar: "UUID" };
};

export type AddAssignmentGroupToBrokerDto = {
  assignmentGroup: AssignmentGroup;
  brokerId: Scalars['String'];
};

export type AddAttachmentToDraftInputDto = {
  fileUploadId: Scalars['ID'];
  id: Scalars['ID'];
};

export type AddConversationLabelInput = {
  conversationId: Scalars['String'];
  label: Scalars['String'];
};

export type AddSubmissionRuleOutReasonInput = {
  details: Scalars['String'];
  id: Scalars['ID'];
};

export type AgenciesFilterInput = {
  term?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export enum AgentActionType {
  ClientData = 'ClientData',
  Custom = 'Custom',
  RespondToInformationRequest = 'RespondToInformationRequest',
  UploadFile = 'UploadFile'
}

export type AgentInput = {
  agencyId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum AlbyQuoteConversionAction {
  EditInPortal = 'EDIT_IN_PORTAL',
  Use = 'USE'
}

export type AlbyQuoteConversionInput = {
  expectedVersion: Scalars['Int'];
  idempotencyKey: Scalars['String'];
  opportunityId: Scalars['ID'];
  quoteId: Scalars['ID'];
  sourceVersion: Scalars['Int'];
};

export enum AlbyQuoteFileDisposition {
  Attachment = 'ATTACHMENT',
  Inline = 'INLINE'
}

export type AllPlaybookRunsInput = {
  orderBy?: InputMaybe<PlaybookRunOrderByField>;
  page?: InputMaybe<Scalars['Int']>;
  rowsPerPage?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<PlaybookRunSortOrder>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']>;
};

export enum AscendInvoiceAcknowledgement {
  /** The broker attached the invoice to the email themselves. */
  HandAttached = 'hand_attached',
  /** The broker chose to send without an invoice. */
  SendWithoutInvoice = 'send_without_invoice'
}

export enum AscendInvoiceLookupOutcome {
  /** More than one live invoice. None is chosen. */
  Ambiguous = 'ambiguous',
  /** Ascend failed, timed out, ran out of budget, or has no key in this environment. */
  AscendError = 'ascend_error',
  /** Exactly one live invoice on the policy's new-business billable. */
  Matched = 'matched',
  /** The whole lookup window was searched and no live invoice was found. */
  NoBillable = 'no_billable',
  /** The policy is direct bill, or is a test deal. Ascend was not called. */
  NotAgencyBill = 'not_agency_bill',
  /** Nothing was found, but the window ended in the past, so the billable may have been created later. */
  OutsideWindow = 'outside_window'
}

export type AscendInvoiceSendInput = {
  acknowledgement?: InputMaybe<AscendInvoiceAcknowledgement>;
  invoiceId?: InputMaybe<Scalars['ID']>;
  outcome: AscendInvoiceLookupOutcome;
};

/** The assignment group for the broker. */
export enum AssignmentGroup {
  Binding = 'Binding',
  Brokerage = 'Brokerage',
  Property = 'Property'
}

/** How a row's membership in the broker's attention feed changed (brief 009). */
export enum AttentionFeedChangeType {
  Created = 'CREATED',
  Removed = 'REMOVED'
}

/** The kind of attention item in the broker's attention feed (brief 009). */
export enum AttentionItemType {
  AwaitingInput = 'AWAITING_INPUT',
  InterruptedRun = 'INTERRUPTED_RUN'
}

export type AttributionArmAttributedIncentivesInput = {
  armEmail: Scalars['String'];
  transactionYear: Scalars['Int'];
};

export type AttributionArmAttributedPremiumInput = {
  armEmail: Scalars['String'];
  transactionYear: Scalars['Int'];
};

export type AttributionArmMyBookInput = {
  armEmail?: InputMaybe<Scalars['String']>;
  composition?: InputMaybe<Scalars['String']>;
  dateSetting?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type AttributionArmPerformanceOverviewDetailsInput = {
  applicationType?: InputMaybe<Scalars['String']>;
  armEmail?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['String']>;
  transactionYear: Scalars['Int'];
};

export type AttributionProducerAttributedIncentivesInput = {
  attributeToEmail: Scalars['String'];
  transactionYear: Scalars['Int'];
};

export type AttributionProducerAttributedPremiumInput = {
  attributeToEmail: Scalars['String'];
  transactionYear: Scalars['Int'];
};

export type AttributionProducerAttributedRollsInput = {
  attributeToEmail?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
  metricLevel: Scalars['String'];
  transactionYear: Scalars['Int'];
};

export type AttributionProducerLostDealsInput = {
  attributeToEmail?: InputMaybe<Scalars['String']>;
  composition?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type AttributionProducerLostDealsMetricsInput = {
  attributeToEmail?: InputMaybe<Scalars['String']>;
  composition?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type AttributionProducerMyBookInput = {
  attributeToEmail?: InputMaybe<Scalars['String']>;
  composition?: InputMaybe<Scalars['String']>;
  dateSetting?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type AttributionProducerPerformanceOverviewDetailsInput = {
  applicationType?: InputMaybe<Scalars['String']>;
  attributeToEmail?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['String']>;
  transactionYear: Scalars['Int'];
};

export enum AttributionQuotedNotBoundExportModeInput {
  AllRoles = 'ALL_ROLES',
  CurrentScope = 'CURRENT_SCOPE',
  Table = 'TABLE'
}

export type AttributionQuotedNotBoundInput = {
  activeViewRole?: InputMaybe<AttributionQuotedNotBoundScopeRoleInput>;
  attributeToEmail?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['String']>;
  exportMode?: InputMaybe<AttributionQuotedNotBoundExportModeInput>;
  startDate?: InputMaybe<Scalars['String']>;
};

export enum AttributionQuotedNotBoundScopeRoleInput {
  Arm = 'ARM',
  Producer = 'PRODUCER'
}

export type AttributionReassignmentsInput = {
  attributeToEmail?: InputMaybe<Scalars['String']>;
  composition?: InputMaybe<Scalars['String']>;
  exportAllAttributionRoles?: InputMaybe<Scalars['Boolean']>;
};

export enum AttributionRole {
  Broker = 'Broker',
  Underwriter = 'Underwriter'
}

export type AttributionTeamAttributedPremiumInput = {
  breakdownType: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  period: Scalars['String'];
  transactionYear: Scalars['Int'];
};

export type AuthTokenInput = {
  /** JWT access token */
  accessToken: Scalars['String'];
  /** JWT refresh token */
  refreshToken: Scalars['String'];
};

export type BankanMarketingPlanColumnInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  brokerId?: InputMaybe<Scalars['String']>;
  column: MarketingPlanBankanColumn;
  ownedOnly?: InputMaybe<Scalars['Boolean']>;
  ownerId?: InputMaybe<Scalars['String']>;
  renewals?: InputMaybe<Scalars['Boolean']>;
};

export enum BankanPolicyColumn {
  AwaitingBinderFromCarrier = 'AwaitingBinderFromCarrier',
  AwaitingPolicyFromCarrier = 'AwaitingPolicyFromCarrier',
  AwaitingSubjectivities = 'AwaitingSubjectivities',
  BinderProcessed = 'BinderProcessed',
  ExpiringSoon = 'ExpiringSoon',
  IssuedEndorsementsRequested = 'IssuedEndorsementsRequested',
  ReceivedBinderFromCarrier = 'ReceivedBinderFromCarrier',
  ReceivedPolicyFromCarrier = 'ReceivedPolicyFromCarrier',
  TaxDocumentsRequired = 'TaxDocumentsRequired'
}

export type BankanPolicyColumnInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  brokerId?: InputMaybe<Scalars['String']>;
  column: BankanPolicyColumn;
  ownerId?: InputMaybe<Scalars['String']>;
  renewals?: InputMaybe<Scalars['Boolean']>;
};

export enum BankanQuoteColumn {
  BindRequestReceived = 'BindRequestReceived',
  Delivered = 'Delivered',
  ReadyToSend = 'ReadyToSend'
}

export type BankanQuoteColumnInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  brokerId?: InputMaybe<Scalars['String']>;
  column: BankanQuoteColumn;
  ownerId?: InputMaybe<Scalars['String']>;
  renewals?: InputMaybe<Scalars['Boolean']>;
};

export type BatchAddLabelToConversationsInput = {
  conversationIds: Array<Scalars['String']>;
  label: Scalars['String'];
};

export type BatchDeleteConversationsInput = {
  conversationIds: Array<Scalars['String']>;
};

export type BatchDeleteDraftsInputDto = {
  draftIds: Array<Scalars['String']>;
};

export type BatchRemoveLabelFromConversationsInput = {
  conversationIds: Array<Scalars['String']>;
  label: Scalars['String'];
};

export enum BindHqApplicationType {
  Extension = 'Extension',
  New = 'New',
  Renewal = 'Renewal',
  Rewrite = 'Rewrite'
}

export type BindHqFetchAgentsInput = {
  bindHqAgencyId?: InputMaybe<Scalars['String']>;
};

export enum BindHqFigureCheckStatus {
  Differs = 'Differs',
  Matches = 'Matches',
  NotChecked = 'NotChecked'
}

export enum BindHqInsuredType {
  Corporation = 'Corporation',
  Individual = 'Individual',
  Individuals = 'Individuals',
  JointVenture = 'JointVenture',
  LimitedCorporation = 'LimitedCorporation',
  LimitedLiabilityCompany = 'LimitedLiabilityCompany',
  LimitedPartnership = 'LimitedPartnership',
  NonProfit = 'NonProfit',
  Other = 'Other',
  Partnership = 'Partnership',
  Proprietorship = 'Proprietorship',
  SoleProprietor = 'SoleProprietor',
  SubchapterSCorporation = 'SubchapterSCorporation',
  Trust = 'Trust'
}

export enum BindHqLineOfBusiness {
  Acct = 'ACCT',
  Ache = 'ACHE',
  ActiveShooter = 'ACTIVE_SHOOTER',
  Agent = 'AGENT',
  Aglia = 'AGLIA',
  Agop = 'AGOP',
  Agpp = 'AGPP',
  Agpr = 'AGPR',
  Airc = 'AIRC',
  Airpfb = 'AIRPFB',
  Apkge = 'APKGE',
  Aprod = 'APROD',
  Arch = 'ARCH',
  Art = 'ART',
  Auto = 'AUTO',
  Autob = 'AUTOB',
  Autop = 'AUTOP',
  Avpkg = 'AVPKG',
  Bail = 'BAIL',
  Bandm = 'BANDM',
  Blank = 'BLANK',
  Bmisc = 'BMISC',
  Boat = 'BOAT',
  Bop = 'BOP',
  Bopgl = 'BOPGL',
  Boppr = 'BOPPR',
  Bpp = 'BPP',
  BuildersRisk = 'BUILDERS_RISK',
  Cavn = 'CAVN',
  Cfire = 'CFIRE',
  Cfrm = 'CFRM',
  Comr = 'COMR',
  ContingentAuto = 'CONTINGENT_AUTO',
  ContingentCargo = 'CONTINGENT_CARGO',
  Contr = 'CONTR',
  ContractorsEquipment = 'CONTRACTORS_EQUIPMENT',
  Cop = 'COP',
  Cp = 'CP',
  Cpkge = 'CPKGE',
  Cpl = 'CPL',
  Cpmp = 'CPMP',
  Crim = 'CRIM',
  Crime = 'CRIME',
  Cyber = 'CYBER',
  Dfire = 'DFIRE',
  Disab = 'DISAB',
  Do = 'DO',
  Eil = 'EIL',
  El = 'EL',
  Eo = 'EO',
  Epkg = 'EPKG',
  Epli = 'EPLI',
  Eq = 'EQ',
  Eqfltr = 'EQFLTR',
  Eqlia = 'EQLIA',
  Exlia = 'EXLIA',
  Expl = 'EXPL',
  Fidty = 'FIDTY',
  Fiduc = 'FIDUC',
  Flood = 'FLOOD',
  Garag = 'GARAG',
  Gl = 'GL',
  Hang = 'HANG',
  Hbb = 'HBB',
  Hlth = 'HLTH',
  Home = 'HOME',
  Il = 'IL',
  Inmar = 'INMAR',
  Inmrc = 'INMRC',
  Inmrp = 'INMRP',
  InstallationFloater = 'INSTALLATION_FLOATER',
  Judcl = 'JUDCL',
  Kidra = 'KIDRA',
  Law = 'LAW',
  Licpt = 'LICPT',
  Ll = 'LL',
  Lmort = 'LMORT',
  Logpckg = 'LOGPCKG',
  Lstin = 'LSTIN',
  Lvstk = 'LVSTK',
  Media = 'MEDIA',
  Mhome = 'MHOME',
  Mmal = 'MMAL',
  Mpl = 'MPL',
  Mpp = 'MPP',
  Mtc = 'MTC',
  Mtrcr = 'MTRCR',
  Motorcycle = 'Motorcycle',
  Nwfgr = 'NWFGR',
  Ocp = 'OCP',
  Olib = 'OLIB',
  Phys = 'PHYS',
  Pkg = 'PKG',
  Pl = 'PL',
  Plib = 'PLIB',
  Plmsc = 'PLMSC',
  Ppkge = 'PPKGE',
  Ppl = 'PPL',
  ProductRecall = 'PRODUCT_RECALL',
  Prsl = 'PRSL',
  Pubof = 'PUBOF',
  Recv = 'RECV',
  Rrprl = 'RRPRL',
  Scap = 'SCAP',
  Sfrnc = 'SFRNC',
  Shipintr = 'SHIPINTR',
  Smp = 'SMP',
  Stkth = 'STKTH',
  Stock = 'STOCK',
  Stpl = 'STPL',
  Sure = 'SURE',
  Tech = 'TECH',
  TripTransit = 'TRIP_TRANSIT',
  Truck = 'TRUCK',
  Umbrc = 'UMBRC',
  Umbrl = 'UMBRL',
  Umbrp = 'UMBRP',
  Un = 'UN',
  Warel = 'WAREL',
  Wcma = 'WCMA',
  Wind = 'WIND',
  Work = 'WORK',
  Workp = 'WORKP',
  Workv = 'WORKV',
  Yacht = 'YACHT'
}

export enum BindHqQuoteBillingType {
  AgencyBill = 'AgencyBill',
  DirectBill = 'DirectBill',
  Filing = 'Filing',
  InsuredDirectBill = 'InsuredDirectBill',
  Manual = 'Manual'
}

export enum BindHqQuoteBusinessType {
  Binding = 'Binding',
  Brokerage = 'Brokerage'
}

export type BindHqQuoteLineItemInput = {
  amount: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  lineOfBusiness: BindHqLineOfBusiness;
  type: BindHqQuoteLineItemType;
};

export enum BindHqQuoteLineItemType {
  AgentFee = 'AgentFee',
  CarrierFee = 'CarrierFee',
  CarrierInspectionFee = 'CarrierInspectionFee',
  Clearinghouse = 'Clearinghouse',
  Empa = 'Empa',
  FireMarshallTax = 'FireMarshallTax',
  HealthyHomes = 'HealthyHomes',
  InspectionFee = 'InspectionFee',
  MgaFee = 'MgaFee',
  MunicipalTax = 'MunicipalTax',
  OptIns = 'OptIns',
  Premium = 'Premium',
  RiskManagementFee = 'RiskManagementFee',
  StampingFee = 'StampingFee',
  StateTax = 'StateTax',
  Surcharge = 'Surcharge',
  TechnologyFee = 'TechnologyFee',
  WillComply = 'WillComply',
  WindpoolFee = 'WindpoolFee'
}

export enum BindHqQuoteTaxesCollectedBy {
  Agent = 'Agent',
  MarketingCompany = 'MarketingCompany',
  Mga = 'Mga'
}

export type BindQuoteInput = {
  createApplication: CreateBindHqApplicationInput;
  createPolicy: CreatePolicyInputNew;
  createQuote: CreateBindHqQuoteInput;
  quoteId?: InputMaybe<Scalars['ID']>;
};

export enum BindingAuthority {
  InAuthority = 'InAuthority',
  Prohibited = 'Prohibited',
  Submit = 'Submit'
}

export type BrokerCreateAgentAction = {
  externalReason?: InputMaybe<Scalars['String']>;
  opportunityId: Scalars['String'];
  reason?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type BrokerLostOpportunitiesInput = {
  showActive?: Scalars['Boolean'];
};

export type BrokerOpportunitiesInput = {
  showExpired?: Scalars['Boolean'];
};

export type BrokerPoliciesInput = {
  beginYear?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  notStates?: InputMaybe<Array<PolicyState>>;
  states?: InputMaybe<Array<PolicyState>>;
};

export type BrokerQuotesInput = {
  isExpired?: Scalars['Boolean'];
};

export type BulkEditAttributionEndorsementReassignmentsInput = {
  bindhqEndorsementIds?: InputMaybe<Array<Scalars['String']>>;
  reattributeToEmail?: InputMaybe<Scalars['String']>;
};

export enum BusinessClassSystem {
  IsoGl = 'ISO_GL',
  Naics = 'NAICS'
}

export type BusinessClassificationsSearchInput = {
  classCodes?: InputMaybe<Array<Scalars['String']>>;
  classSystems?: InputMaybe<Array<BusinessClassSystem>>;
  term?: InputMaybe<Scalars['String']>;
};

export type CancelVaveQuoteInput = {
  EffectiveDate: Scalars['DateTime'];
  OverrideMEP?: InputMaybe<Scalars['Int']>;
  OverrideMethod?: InputMaybe<Scalars['String']>;
  TransactionReason: Scalars['String'];
  vaveQuoteId: Scalars['String'];
};

export type CarrierContactConnectorInput = {
  appetiteProductId: Scalars['String'];
  id: Scalars['ID'];
  type: CarrierContactType;
};

export enum CarrierContactType {
  Reference = 'Reference',
  Submission = 'Submission'
}

export enum CarrierContractExtractionStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum CarrierTriaTerms {
  Excluded = 'Excluded',
  Included = 'Included',
  NotShown = 'NotShown',
  Offered = 'Offered'
}

export type ChatSessionFilterInput = {
  insuredId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<ChatSessionMetadataEntryInput>>;
  status?: InputMaybe<ChatSessionStatus>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ChatSessionMetadataEntryInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

/** The status of a chat session */
export enum ChatSessionStatus {
  Aborted = 'ABORTED',
  AwaitingChildPlaybook = 'AWAITING_CHILD_PLAYBOOK',
  AwaitingUserInput = 'AWAITING_USER_INPUT',
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Resuming = 'RESUMING',
  Streaming = 'STREAMING',
  Timeout = 'TIMEOUT'
}

/** Discriminated kind of the chat session stream state machine. */
export enum ChatSessionStreamStateKind {
  Completed = 'COMPLETED',
  Enqueued = 'ENQUEUED',
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  NotStarted = 'NOT_STARTED',
  Streaming = 'STREAMING',
  Unknown = 'UNKNOWN'
}

export type ClientDataFilterInput = {
  insuredId: Scalars['String'];
  keys?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Scalars['String']>;
};

export enum Code_Path {
  Policy = 'POLICY',
  ProcessedQuote = 'PROCESSED_QUOTE',
  RawQuote = 'RAW_QUOTE'
}

export type CompleteAgentActionInput = {
  id: Scalars['String'];
};

export enum ConversationWakeUpSourceReason {
  QuoteFollowUp = 'QuoteFollowUp'
}

export type CreateBindHqApplicationInput = {
  agentBindHqId: Scalars['String'];
  linesOfBusiness: Array<BindHqLineOfBusiness>;
  type: BindHqApplicationType;
};

export type CreateBindHqQuoteInput = {
  agentCommissionPercentage: Scalars['String'];
  billingType: BindHqQuoteBillingType;
  businessType: BindHqQuoteBusinessType;
  carrierId: Scalars['String'];
  grossCommissionPercentage: Scalars['String'];
  lineItems: Array<BindHqQuoteLineItemInput>;
  marketingCompanyId: Scalars['String'];
  minimumEarnedPremiumPercentage: Scalars['String'];
  taxationHomeState: Scalars['String'];
  taxesCollectedBy: BindHqQuoteTaxesCollectedBy;
};

export type CreateCarrierContactInput = {
  appetiteProductId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type: CarrierContactType;
};

export type CreateChatSessionInput = {
  insuredId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<ChatSessionMetadataEntryInput>>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateClientDataInput = {
  clientDataInputs: Array<CreateClientDatumInput>;
  insuredId: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
};

export type CreateClientDataPdfInput = {
  css: Scalars['String'];
  filename: Scalars['String'];
  html: Scalars['String'];
  opportunityId: Scalars['String'];
};

export type CreateClientDatumInput = {
  index?: InputMaybe<Scalars['Int']>;
  key: Scalars['String'];
  value: Scalars['JSON'];
};

export type CreateCommentInput = {
  isPublic?: Scalars['Boolean'];
  opportunityId: Scalars['String'];
  text: Scalars['String'];
};

export type CreateDraftMessageInputDto = {
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  classification?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  inReplyTo?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['ID']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  opportunityId?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['String']>;
  referenceMessageId?: InputMaybe<Scalars['ID']>;
  references?: InputMaybe<Array<Scalars['String']>>;
  replyTo?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateEmailDraftInput = {
  cc?: InputMaybe<Array<Scalars['String']>>;
  opportunityId: Scalars['String'];
  subject: Scalars['String'];
  text: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type CreateEmailLabelInput = {
  name: Scalars['String'];
};

export type CreateEmailTemplateDraftInput = {
  fileIds?: Array<Scalars['String']>;
  submissionId: Scalars['String'];
  template: OpportunityEmailTemplate;
};

export type CreateForwardDraftInputDto = {
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  classification?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['ID']>;
  messageId?: InputMaybe<Scalars['String']>;
  opportunityId?: InputMaybe<Scalars['ID']>;
  replyTo?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateInsuredAndAgentInput = {
  agentInput: AgentInput;
  cglCode?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exposures?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  naicsCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  primaryState?: InputMaybe<Scalars['String']>;
  revenue?: InputMaybe<Scalars['Int']>;
};

export type CreateInsuredInput = {
  cglCode?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  exposures?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  primaryState?: InputMaybe<Scalars['String']>;
  revenue?: InputMaybe<Scalars['Int']>;
};

export type CreateMarketingCompanyAddressInput = {
  city: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export type CreateMarketingCompanyInput = {
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  mailingAddress?: InputMaybe<CreateMarketingCompanyAddressInput>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateMessageClassificationInput = {
  associatedPlaybookId?: InputMaybe<Scalars['String']>;
  autoRunPlaybook?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  label: Scalars['String'];
};

export type CreateOpportunityInput = {
  desiredEffectiveDate: Scalars['DateTime'];
  insuredId: Scalars['String'];
  selectedLinesOfBusiness?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateOpportunityNoteInput = {
  opportunityId: Scalars['String'];
  text: Scalars['String'];
};

export type CreatePlaybookInput = {
  description?: InputMaybe<Scalars['String']>;
  fileUploadIds?: InputMaybe<Array<Scalars['String']>>;
  /** Model tier this playbook's LLM frames run at. Null = the runtime default for playbook execution (expert). */
  modelTier?: InputMaybe<ModelTier>;
  name: Scalars['String'];
  /** Describes the parameters this playbook expects when invoked via executePlaybook */
  parametersDescription?: InputMaybe<Scalars['String']>;
  /** Typed declared parameters for deterministic Template playbooks. */
  templateParamSchema?: InputMaybe<Scalars['JSON']>;
  /** Tool filter: null = all tools allowed, {whitelist: []} = only these tools, {blacklist: []} = all except these */
  toolFilter?: InputMaybe<ToolFilterInput>;
  /** Playbook type. Defaults to `Workflow` if omitted. */
  type?: InputMaybe<PlaybookType>;
  workflow: Scalars['String'];
};

export type CreatePlaybookSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreatePolicyInputNew = {
  effectiveDate: Scalars['DateTime'];
  expirationDate: Scalars['DateTime'];
  invoiceDueDate: Scalars['DateTime'];
  policyLimit?: InputMaybe<Scalars['Int']>;
  policyNumber: Scalars['String'];
  renewalOfPolicies?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateProcessedBinderInput = {
  bindHqPolicyOverrides?: InputMaybe<FigureBindHqOverridesInput>;
  outstandingSubjectivities: Scalars['String'];
  policyId: Scalars['String'];
  quoteOverrides?: InputMaybe<FigureQuoteOverridesInput>;
  /** The `reviewToken` from the `binderCoverFigures` read these corrections were made against. Required whenever a correction actually changes a figure, because every figure the reviewer left alone is taken from those same rows at generation time. */
  reviewToken?: InputMaybe<Scalars['String']>;
};

export type CreateProcessedQuoteInput = {
  admitted: Scalars['Boolean'];
  agentCommission: Scalars['Float'];
  brokerFee: Scalars['Float'];
  carrierFee?: InputMaybe<Scalars['Float']>;
  carrierName: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  grossCommission?: InputMaybe<Scalars['Float']>;
  homeState: Scalars['String'];
  inspectionFee?: InputMaybe<Scalars['Float']>;
  inspectionFeeTreatment?: InputMaybe<InspectionFeeTreatment>;
  insuredName: Scalars['String'];
  mep: Scalars['Float'];
  premium: Scalars['Float'];
  quoteId: Scalars['String'];
  subjectivities?: Array<Scalars['String']>;
  submissionId: Scalars['String'];
};

/** Input for creating a new product */
export type CreateProductInput = {
  /** Carrier ID for this product */
  carrierId?: InputMaybe<Scalars['ID']>;
  /** Whether the product is enabled (defaults to false) */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** File upload IDs to attach to this product */
  fileUploadIds?: InputMaybe<Array<Scalars['String']>>;
  /** Line of business IDs for this product */
  lineOfBusinessIds?: InputMaybe<Array<Scalars['String']>>;
  /** Market type: binding authority or brokerage */
  marketType?: InputMaybe<MarketTypes>;
  /** Product name */
  name: Scalars['String'];
  /** The workflow/instructions for this product */
  workflow: Scalars['String'];
};

export type CreateRenewalInput = {
  policyId: Scalars['UUID'];
};

export type CreateReplyDraftInputDto = {
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  classification?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['ID']>;
  messageId?: InputMaybe<Scalars['String']>;
  opportunityId?: InputMaybe<Scalars['ID']>;
  replyAll?: InputMaybe<Scalars['Boolean']>;
  replyTo?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  targetRecipientEmail?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateStampedPolicyInput = {
  bindHqPolicyOverrides?: InputMaybe<FigureBindHqOverridesInput>;
  policyId: Scalars['String'];
  quoteOverrides?: InputMaybe<FigureQuoteOverridesInput>;
  /** The `reviewToken` from the `stampedPolicyFigures` read these corrections were made against. Required: a stamped policy is a reviewed document, so the caller has to say which version of the figures it reviewed. */
  reviewToken: Scalars['String'];
};

export type CreateSubmissionMarketSummaryNoteInput = {
  submissionId: Scalars['UUID'];
  text: Scalars['String'];
};

export type CreateTagInput = {
  label: Scalars['String'];
  parentTag?: InputMaybe<Scalars['String']>;
};

export type CreateTeamInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateVaveQuoteInput = {
  data: Scalars['String'];
  submissionId: Scalars['String'];
};

export type DeactivateAgentInput = {
  agentId: Scalars['UUID'];
  successorAgentId?: InputMaybe<Scalars['UUID']>;
};

export type DefaultPromptInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  brokerId?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  /** Current authoring draft content */
  draftContent?: InputMaybe<Scalars['String']>;
  /** Authoring entity ID */
  entityId?: InputMaybe<Scalars['String']>;
  /** Authoring entity type, e.g. 'playbook' or 'product' */
  entityType?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  /** Chat mode, e.g. 'deal-chat' or 'book-chat' */
  mode?: InputMaybe<Scalars['String']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  /** Event type that triggered this execution */
  triggerEventType?: InputMaybe<Scalars['String']>;
};

export type DeleteClientDataInput = {
  index?: InputMaybe<Scalars['Int']>;
  insuredId: Scalars['String'];
  key: Scalars['String'];
  source: Scalars['String'];
};

export type DeleteFileUploadInput = {
  id: Scalars['String'];
};

export type DeleteTagInput = {
  label: Scalars['String'];
};

export type EditAttributionEndorsementReassignmentInput = {
  bindhqEndorsementId?: InputMaybe<Scalars['String']>;
  reattributeToEmail?: InputMaybe<Scalars['String']>;
};

export type EditVaveQuoteInput = {
  data: Scalars['String'];
  vaveQuoteId: Scalars['String'];
};

export type FigureBindHqOverridesInput = {
  /** Policy effective date in YYYY-MM-DD format. */
  effectiveDate?: InputMaybe<Scalars['String']>;
  /** Policy expiration date in YYYY-MM-DD format. */
  expirationDate?: InputMaybe<Scalars['String']>;
  policyNumber?: InputMaybe<Scalars['String']>;
};

export type FigureQuoteOverridesInput = {
  brokerFee?: InputMaybe<Scalars['Float']>;
  carrierFee?: InputMaybe<Scalars['Float']>;
  countyFee?: InputMaybe<Scalars['Float']>;
  empaTax?: InputMaybe<Scalars['Float']>;
  fireMarshallTax?: InputMaybe<Scalars['Float']>;
  inspectionFee?: InputMaybe<Scalars['Float']>;
  municipalFee?: InputMaybe<Scalars['Float']>;
  premium?: InputMaybe<Scalars['Float']>;
  stampingFee?: InputMaybe<Scalars['Float']>;
  surplusLinesServiceCharge?: InputMaybe<Scalars['Float']>;
  surplusLinesTax?: InputMaybe<Scalars['Float']>;
};

/** Allowed fields for ordering file results */
export enum FileOrderByField {
  CreatedAt = 'CREATED_AT',
  Filename = 'FILENAME',
  Size = 'SIZE'
}

/** Sort order direction */
export enum FileSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum File_Audience {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export enum File_Key_Document_Role {
  Acord_125 = 'ACORD_125',
  Policy = 'POLICY',
  ProcessedBinder = 'PROCESSED_BINDER',
  ProcessedQuote = 'PROCESSED_QUOTE',
  RawQuote = 'RAW_QUOTE',
  RedactedBinder = 'REDACTED_BINDER',
  RedactedQuote = 'REDACTED_QUOTE',
  StampedPolicy = 'STAMPED_POLICY'
}

export enum File_Source {
  Converted = 'CONVERTED',
  CorrespondencePdf = 'CORRESPONDENCE_PDF',
  EmailAttachment = 'EMAIL_ATTACHMENT',
  GeneratedSov = 'GENERATED_SOV',
  GenerateAcord = 'GENERATE_ACORD',
  InscipherStateDocument = 'INSCIPHER_STATE_DOCUMENT',
  LossRunDoc = 'LOSS_RUN_DOC',
  ManualUpload = 'MANUAL_UPLOAD',
  OutboundEmailAttachment = 'OUTBOUND_EMAIL_ATTACHMENT',
  PolicyPdf = 'POLICY_PDF',
  QuotePdf = 'QUOTE_PDF',
  RawQuotePdf = 'RAW_QUOTE_PDF',
  RedactedQuote = 'REDACTED_QUOTE'
}

export type FindDraftsForEmailInputDto = {
  insuredId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  rowsPerPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
};

export type FindFileInput = {
  id: Scalars['String'];
};

export type FindFilesByInsuredInput = {
  deletedAt?: Scalars['Boolean'];
  includeCorrespondence?: Scalars['Boolean'];
  insuredId: Scalars['String'];
};

export type FindFilesByLabelInput = {
  deletedAt?: Scalars['Boolean'];
  includeCorrespondence?: Scalars['Boolean'];
  includeGmailAttachments?: Scalars['Boolean'];
  insuredId?: InputMaybe<Scalars['String']>;
  labels: Array<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type FindManyFileUploadByUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  fileSource?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['String']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  uploaderId?: InputMaybe<Scalars['String']>;
};

export type FindManyFileUploadInput = {
  insuredId: Scalars['UUID'];
};

export type FindTagsInput = {
  label?: InputMaybe<Scalars['String']>;
  parentTag?: InputMaybe<Scalars['String']>;
};

export type GetConversationInput = {
  conversationId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  messagesLimit?: InputMaybe<Scalars['Int']>;
  messagesOffset?: InputMaybe<Scalars['Int']>;
};

export type GetConversationsByOpportunityInput = {
  opportunityId: Scalars['String'];
};

export type GetConversationsInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  inboxIds: Array<Scalars['String']>;
  includeCollaboratedDeals?: Scalars['Boolean'];
  insuredId?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  limit?: InputMaybe<Scalars['Int']>;
  notLabels?: InputMaybe<Array<Scalars['String']>>;
  offset?: InputMaybe<Scalars['Int']>;
  priorityLabels?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  senderSearch?: InputMaybe<Scalars['String']>;
  skipBodySearch?: Scalars['Boolean'];
  skipCount?: Scalars['Boolean'];
  subjectSearch?: InputMaybe<Scalars['String']>;
  unlinked?: Scalars['Boolean'];
};

export type GetLabelUnreadCountsInput = {
  insuredId?: InputMaybe<Scalars['String']>;
  labels: Array<Scalars['String']>;
};

export type GetMessageByIdInput = {
  messageId: Scalars['String'];
};

export type GetTagInput = {
  label: Scalars['String'];
};

export type GroupedMarketingPlansInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  brokerId?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<MarketingPlanState>>;
};

export type GroupedQuotesInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  brokerId?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<QuoteState>>;
};

export type InspectionAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export enum InspectionAddressSource {
  PhysicalAddress = 'PhysicalAddress',
  Premises = 'Premises',
  Sts = 'Sts'
}

export type InspectionContactInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  unknown: Scalars['Boolean'];
};

export enum InspectionFeeTreatment {
  Broker = 'BROKER',
  Carrier = 'CARRIER'
}

export enum InspectionGap {
  AddressMissing = 'AddressMissing',
  ContactMissing = 'ContactMissing',
  ContactUnknown = 'ContactUnknown',
  EffectiveDateMissing = 'EffectiveDateMissing',
  PolicyNumberMissing = 'PolicyNumberMissing',
  SurveyTypeUnmapped = 'SurveyTypeUnmapped'
}

export enum InspectionOrderStatus {
  Cancelled = 'Cancelled',
  CarrierOrdersOwn = 'CarrierOrdersOwn',
  Closed = 'Closed',
  Complete = 'Complete',
  InspectionReceived = 'InspectionReceived',
  NeedsInfo = 'NeedsInfo',
  Ordered = 'Ordered',
  OrderedElsewhere = 'OrderedElsewhere',
  Ordering = 'Ordering',
  Ready = 'Ready',
  WaitingOnInspection = 'WaitingOnInspection',
  WaitingOnRecLetterSignature = 'WaitingOnRecLetterSignature'
}

export enum InspectionRecEditOp {
  Add = 'Add',
  Edit = 'Edit',
  Remove = 'Remove',
  Reorder = 'Reorder'
}

export enum InspectionRecEditReason {
  ExtractionError = 'ExtractionError',
  Waived = 'Waived'
}

export enum InspectionReportCountCheck {
  Mismatch = 'Mismatch',
  Passed = 'Passed',
  Unverified = 'Unverified'
}

export enum InspectionReportFlagReason {
  CountMismatch = 'CountMismatch',
  ExtractionEmpty = 'ExtractionEmpty',
  NoRecommendationsSection = 'NoRecommendationsSection'
}

export enum InspectionReportSource {
  Mueller = 'Mueller',
  Upload = 'Upload'
}

export enum InspectionReportStatus {
  Extracting = 'Extracting',
  FetchFailed = 'FetchFailed',
  Flagged = 'Flagged',
  NoRecs = 'NoRecs',
  ReadyToSend = 'ReadyToSend',
  Sending = 'Sending',
  Sent = 'Sent',
  Signed = 'Signed',
  Superseded = 'Superseded'
}

export enum InspectionSurveyRequest {
  ExteriorOnly = 'ExteriorOnly',
  JobSite = 'JobSite',
  Other = 'Other',
  PhoneOnly = 'PhoneOnly',
  Standard = 'Standard'
}

export enum InspectionSurveyTypeSource {
  LinesOfBusiness = 'LinesOfBusiness',
  Producer = 'Producer',
  Sts = 'Sts'
}

export type InsuredFilterInput = {
  agencyId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  isTest?: Scalars['Boolean'];
  /** Has no marketing plans */
  orphaned?: Scalars['Boolean'];
  term?: InputMaybe<Scalars['String']>;
  /** Has marketing plans, but none are assigned */
  unassigned?: Scalars['Boolean'];
};

export type IssuePolicyInput = {
  /** What the send form's Ascend invoice card showed. */
  ascendInvoice?: InputMaybe<AscendInvoiceSendInput>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  emailComment?: InputMaybe<Scalars['String']>;
  emailCommentFormat?: InputMaybe<SendQuoteEmailCommentFormat>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  policyId?: InputMaybe<Scalars['ID']>;
};

export enum JsonDocumentScope {
  Opportunity = 'OPPORTUNITY',
  Submission = 'SUBMISSION'
}

export enum KnownIdentityProviders {
  Google = 'Google'
}

export type LinkConversationToInsuredInput = {
  conversationId: Scalars['String'];
  insuredId: Scalars['String'];
};

export type LinkConversationToOpportunityInput = {
  conversationId: Scalars['String'];
  opportunityId: Scalars['String'];
};

export type LinkConversationToSubmissionInput = {
  conversationId: Scalars['String'];
  submissionId: Scalars['String'];
};

export type McpToolsMetadataInput = {
  platforms?: InputMaybe<Array<Scalars['String']>>;
};

export type ManualAssignOpportunityDto = {
  brokerId: Scalars['ID'];
  id: Scalars['ID'];
};

export type MarkRenewalNotesReadInput = {
  noteIds: Array<Scalars['String']>;
  opportunityId: Scalars['String'];
};

export enum MarketTypes {
  BindingAuthority = 'bindingAuthority',
  Brokerage = 'brokerage'
}

export enum MarketingPlanAction {
  CompleteMarketing = 'CompleteMarketing',
  GatherMoreInformation = 'GatherMoreInformation',
  Reopen = 'Reopen',
  ReviewInformation = 'ReviewInformation',
  SelectCoverages = 'SelectCoverages',
  StartMarketing = 'StartMarketing'
}

export enum MarketingPlanBankanColumn {
  InformationGathering = 'InformationGathering',
  InformationReview = 'InformationReview',
  MarketingInfoRequired = 'MarketingInfoRequired',
  MarketingReady = 'MarketingReady',
  UnassignedInformationGathering = 'UnassignedInformationGathering',
  UnassignedOther = 'UnassignedOther',
  UnassignedWaitingForCoverages = 'UnassignedWaitingForCoverages',
  WaitingForCoverages = 'WaitingForCoverages'
}

export enum MarketingPlanState {
  Complete = 'Complete',
  InformationGathering = 'InformationGathering',
  InformationReview = 'InformationReview',
  Marketing = 'Marketing',
  WaitingForCoverages = 'WaitingForCoverages'
}

export type MergeInsuredInput = {
  deprecatedId: Scalars['UUID'];
  previewHash?: InputMaybe<Scalars['String']>;
  survivorId: Scalars['UUID'];
};

export type MergeTagsInput = {
  remainingLabels: Array<Scalars['String']>;
  retainedLabel: Scalars['String'];
};

export enum MessageClassificationSource {
  System = 'System',
  User = 'User'
}

/** A model-registry capability tier, cheapest to most capable. Selects which model an inference call runs on, and with it the price per token and the thinking budget. */
export enum ModelTier {
  Advanced = 'ADVANCED',
  Expert = 'EXPERT',
  Micro = 'MICRO',
  Nano = 'NANO',
  Small = 'SMALL',
  Standard = 'STANDARD'
}

export type OpportunitiesInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  insuredId?: InputMaybe<Scalars['String']>;
};

export enum OpportunityEmailTemplate {
  PolicyCheck = 'PolicyCheck',
  RequestBinder = 'RequestBinder',
  RequestQuote = 'RequestQuote',
  SendBinder = 'SendBinder',
  SendPolicy = 'SendPolicy',
  SendQuote = 'SendQuote',
  SubmitToCarrier = 'SubmitToCarrier',
  SubmitToInHouseAuthority = 'SubmitToInHouseAuthority'
}

export enum OpportunityEventType {
  ActionApproved = 'ActionApproved',
  ActionDismissed = 'ActionDismissed',
  ActionRejected = 'ActionRejected',
  ActionRequested = 'ActionRequested',
  AgencyTransfer = 'AgencyTransfer',
  AlbyUpdate = 'AlbyUpdate',
  ApplicationSubmitted = 'ApplicationSubmitted',
  AssignmentChange = 'AssignmentChange',
  AutomatedFollowUp = 'AutomatedFollowUp',
  BotComment = 'BotComment',
  BusinessClassCodesChanged = 'BusinessClassCodesChanged',
  CollaboratorsChanged = 'CollaboratorsChanged',
  CoveragesChanged = 'CoveragesChanged',
  Created = 'Created',
  DesiredEffectiveDateChange = 'DesiredEffectiveDateChange',
  Email = 'Email',
  FileUpload = 'FileUpload',
  GmailMessage = 'GmailMessage',
  GmailRelay = 'GmailRelay',
  OutcomeChange = 'OutcomeChange',
  PolicyRenewabilityChanged = 'PolicyRenewabilityChanged',
  ProductsAdded = 'ProductsAdded',
  ProductsRemoved = 'ProductsRemoved',
  RequirementAdded = 'RequirementAdded',
  StatusChange = 'StatusChange',
  SubmissionStatusChange = 'SubmissionStatusChange',
  TriageAssignment = 'TriageAssignment',
  TriageReassignment = 'TriageReassignment',
  UserComment = 'UserComment'
}

export type OpportunityEventsFilterInput = {
  opportunityId: Scalars['String'];
  types?: InputMaybe<Array<OpportunityEventType>>;
};

/** The initial select coverages step */
export type OpportunitySelectCoveragesInput = {
  id: Scalars['ID'];
  propertyTIV?: InputMaybe<Scalars['Int']>;
  selectedLinesOfBusiness: Array<Scalars['String']>;
};

export type OpportunityUpdateInput = {
  brokerId?: InputMaybe<Scalars['UUID']>;
  desiredEffectiveDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  selectedLinesOfBusiness?: InputMaybe<Array<Scalars['String']>>;
};

export type PaginatedFilesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  fileSource?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  orderBy?: FileOrderByField;
  skip?: InputMaybe<Scalars['Int']>;
  sort?: FileSortOrder;
  take: Scalars['Int'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']>;
  rowsPerPage?: InputMaybe<Scalars['Int']>;
};

export enum PlacementDeliveryEvidenceKind {
  CurrentDelivered = 'CURRENT_DELIVERED',
  EnteredDelivered = 'ENTERED_DELIVERED',
  ExitedDelivered = 'EXITED_DELIVERED'
}

export enum PlacementDeskDetailSource {
  Live = 'LIVE',
  Stored = 'STORED'
}

export type PlacementDeskFilterInput = {
  /** Placement or lane attention kind; UNKNOWN matches an absent kind. */
  attentionKind?: InputMaybe<Scalars['String']>;
  /** Standing decision status, PENDING, or decided. */
  decision?: InputMaybe<Scalars['String']>;
  everReached?: InputMaybe<Scalars['Boolean']>;
  funnel?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['String']>;
  /** Unsupported lane issue code. */
  issueCode?: InputMaybe<Scalars['String']>;
  /** Current lane status. */
  laneStatus?: InputMaybe<Scalars['String']>;
  /** Launch attempt outcome in the selected period; includes unmapped deals. */
  launchOutcome?: InputMaybe<Scalars['String']>;
  /** Refusal reason or failure error code; UNKNOWN matches an absent code. */
  launchReason?: InputMaybe<Scalars['String']>;
  /** Contract market identifier. */
  marketId?: InputMaybe<Scalars['String']>;
  /** Attention queue: person, team_ask (live deals with team asks regardless of primary waiting reason), plan-review, quote-review, attention, authority, ended, stalled, stale, unsupported, missing, reviewed, declined, closed (open runs on closed deals), or launch. */
  queue?: InputMaybe<Scalars['String']>;
  revision?: InputMaybe<Scalars['String']>;
  /** Current or observed historical desk step. */
  step?: InputMaybe<Scalars['String']>;
};

export enum PlacementDeskJourneyActor {
  App2Automatic = 'APP2_AUTOMATIC',
  BrokerByHand = 'BROKER_BY_HAND',
  Carrier = 'CARRIER',
  Desk = 'DESK',
  PersonInReview = 'PERSON_IN_REVIEW',
  PlanReviewer = 'PLAN_REVIEWER',
  QuotewellTeam = 'QUOTEWELL_TEAM',
  Unknown = 'UNKNOWN'
}

export enum PlacementDeskJourneyEvidence {
  None = 'NONE',
  Observed = 'OBSERVED',
  Recorded = 'RECORDED'
}

export enum PlacementDeskJourneyKind {
  Appetite = 'APPETITE',
  CarrierAnswer = 'CARRIER_ANSWER',
  DealCreated = 'DEAL_CREATED',
  Facts = 'FACTS',
  InApp2 = 'IN_APP2',
  PlanApproval = 'PLAN_APPROVAL',
  PlanProposed = 'PLAN_PROPOSED',
  PortalSubmission = 'PORTAL_SUBMISSION',
  QuoteReview = 'QUOTE_REVIEW',
  SentToDesk = 'SENT_TO_DESK'
}

export enum PlacementDeskJourneyState {
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  NotReached = 'NOT_REACHED',
  NotRecorded = 'NOT_RECORDED',
  Skipped = 'SKIPPED',
  Stopped = 'STOPPED'
}

export enum PlacementDeskJourneyTimeBasis {
  App2Record = 'APP2_RECORD',
  DeskCreated = 'DESK_CREATED',
  FirstObserved = 'FIRST_OBSERVED',
  LaunchReceipt = 'LAUNCH_RECEIPT',
  MappingCreated = 'MAPPING_CREATED',
  Observed = 'OBSERVED',
  ReceivedByApp2 = 'RECEIVED_BY_APP2'
}

export enum PlacementDeskProgressTier {
  CarrierAnswer = 'CARRIER_ANSWER',
  DeclinedBeforePortal = 'DECLINED_BEFORE_PORTAL',
  GatheringFacts = 'GATHERING_FACTS',
  NoDeskRun = 'NO_DESK_RUN',
  PlanApproval = 'PLAN_APPROVAL',
  PortalActivity = 'PORTAL_ACTIVITY',
  QuoteRecorded = 'QUOTE_RECORDED',
  Starting = 'STARTING',
  Stopped = 'STOPPED',
  TeamRequest = 'TEAM_REQUEST'
}

export enum PlacementDeskStep {
  Cancelled = 'CANCELLED',
  CarrierSubmission = 'CARRIER_SUBMISSION',
  GatheringFacts = 'GATHERING_FACTS',
  NeedsAttention = 'NEEDS_ATTENTION',
  NoQuotes = 'NO_QUOTES',
  PlanReview = 'PLAN_REVIEW',
  Quoted = 'QUOTED',
  QuoteReview = 'QUOTE_REVIEW',
  Starting = 'STARTING',
  Unknown = 'UNKNOWN'
}

export enum PlacementDeskWaitingOn {
  Desk = 'DESK',
  None = 'NONE',
  Person = 'PERSON'
}

export enum PlacementDeskWaitingReason {
  Attention = 'ATTENTION',
  AuthorityHold = 'AUTHORITY_HOLD',
  Cancelling = 'CANCELLING',
  Done = 'DONE',
  PlanReview = 'PLAN_REVIEW',
  QuoteReview = 'QUOTE_REVIEW',
  Stalled = 'STALLED',
  Unknown = 'UNKNOWN',
  Working = 'WORKING'
}

export type PlacementWorkflowDashboardInput = {
  /** Desk launch window when createdAfter is absent: false selects the v3 apply; true, null or omission selects all history. Explicit createdAfter wins. */
  allHistory?: InputMaybe<Scalars['Boolean']>;
  /** Scope to a specific broker's deals (internal picking a broker). */
  brokerId?: InputMaybe<Scalars['ID']>;
  /** Start of the window. Defaults to max(now - 30d, the date the trigger went live). */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** When present, dates select first desk launches (or launch attempts), not opportunity creation. An empty object selects all mapped deals in the period. */
  desk?: InputMaybe<PlacementDeskFilterInput>;
  /** Legacy alias for rowsPerPage; used only when rowsPerPage is absent. */
  limit?: InputMaybe<Scalars['Int']>;
  /** true = only my deals; false = every deal in scope. When omitted, a broker-role user defaults to their own deals and other internal users default to all. */
  mine?: InputMaybe<Scalars['Boolean']>;
  /** Legacy row offset; used only when page is absent. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Field used to sort placement workflow dashboard rows. */
  orderBy?: InputMaybe<PlacementWorkflowSortField>;
  /** 1-based page. Falls back to legacy offset/limit when absent. */
  page?: InputMaybe<Scalars['Int']>;
  /** Rows per page (clamped 1–150). Falls back to legacy `limit` when absent. */
  rowsPerPage?: InputMaybe<Scalars['Int']>;
  /** Case-insensitive insured-name search. */
  search?: InputMaybe<Scalars['String']>;
  /** Sort direction for placement workflow dashboard rows. */
  sort?: InputMaybe<PlacementWorkflowSortDirection>;
  /** Include test deals (opportunity, insured, or agency). */
  testDeals?: InputMaybe<Scalars['Boolean']>;
};

/** Sort direction for placement workflow dashboard rows. */
export enum PlacementWorkflowSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Fields available for sorting placement workflow dashboard rows. */
export enum PlacementWorkflowSortField {
  CreatedAt = 'CREATED_AT',
  EffectiveDate = 'EFFECTIVE_DATE',
  FurthestAlong = 'FURTHEST_ALONG'
}

export enum PlacementWorkflowSubmissionCountSource {
  ActiveSubmissions = 'ACTIVE_SUBMISSIONS'
}

export type PlacementWorkflowSummaryInput = {
  /** When createdAfter is absent: false selects the v3 apply cutoff; true selects all history. Null or omission preserves each summary’s legacy window (desk: all history; workflow: max(now - 30d, trigger launch)). Explicit createdAfter wins. */
  allHistory?: InputMaybe<Scalars['Boolean']>;
  /** Scope to a specific broker's deals (internal picking a broker). */
  brokerId?: InputMaybe<Scalars['ID']>;
  /** Inclusive lower bound, overriding allHistory. Filters desk launch creation in Desk Summary and opportunity creation in workflow Summary. */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** true = only my deals; false = every deal in scope. When omitted, a broker-role user defaults to their own deals and other internal users default to all. */
  mine?: InputMaybe<Scalars['Boolean']>;
  /** Include test deals (opportunity, insured, or agency). */
  testDeals?: InputMaybe<Scalars['Boolean']>;
};

/** Fields available for sorting playbook runs */
export enum PlaybookRunOrderByField {
  PlaybookName = 'PLAYBOOK_NAME',
  StartedAt = 'STARTED_AT',
  Status = 'STATUS'
}

/** Sort order direction */
export enum PlaybookRunSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** How a playbook is exposed to the LLM: Workflow (discoverable via playbookDiscovery and invokable from any surface), Knowledge (embedded in the system prompt as context, never executable), Template (deterministic fill target, never executable), or WorkflowStep (hidden from foreground playbookDiscovery so the LLM can't auto-invoke; invokable from user-mediated surfaces such as the slash menu, classifications, and triggers, and from a parent orchestrator via in-execution playbookDiscovery). */
export enum PlaybookType {
  Knowledge = 'Knowledge',
  Template = 'Template',
  Workflow = 'Workflow',
  WorkflowStep = 'WorkflowStep'
}

export enum PolicyAction {
  Cancel = 'Cancel',
  DeliverBinder = 'DeliverBinder',
  GenerateBinderCover = 'GenerateBinderCover',
  Issue = 'Issue',
  ReceiveBinder = 'ReceiveBinder',
  ReceivePolicy = 'ReceivePolicy',
  Reinstate = 'Reinstate',
  SkipBinder = 'SkipBinder',
  UploadNewBinder = 'UploadNewBinder'
}

export enum PolicyAgentEmailKind {
  Binder = 'Binder',
  Policy = 'Policy'
}

export enum PolicyFileType {
  Policy = 'Policy',
  ProcessedBinder = 'ProcessedBinder',
  RedactedBinder = 'RedactedBinder',
  TaxFilingDocument = 'TaxFilingDocument'
}

export type PolicyFilterInput = {
  /** Filter for active policies (currently within the [effectiveDate-30d]->[expirationDate+30d] window). */
  active?: InputMaybe<Scalars['Boolean']>;
  insuredId?: InputMaybe<Scalars['String']>;
  marketingPlanId?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['String']>;
};

export enum PolicyState {
  AwaitingBinderFromCarrier = 'AwaitingBinderFromCarrier',
  AwaitingPolicyFromCarrier = 'AwaitingPolicyFromCarrier',
  BinderProcessed = 'BinderProcessed',
  Canceled = 'Canceled',
  Issued = 'Issued',
  ReceivedBinderFromCarrier = 'ReceivedBinderFromCarrier',
  ReceivedPolicyFromCarrier = 'ReceivedPolicyFromCarrier'
}

export type ProcessVaveQuoteInput = {
  admitted: Scalars['Boolean'];
  agentCommission: Scalars['Float'];
  brokerFee?: InputMaybe<Scalars['Float']>;
  carrierFee?: InputMaybe<Scalars['Float']>;
  carrierName: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  grossCommission?: InputMaybe<Scalars['Float']>;
  homeState: Scalars['String'];
  inspectionFee?: InputMaybe<Scalars['Float']>;
  inspectionFeeTreatment?: InputMaybe<InspectionFeeTreatment>;
  insuredName: Scalars['String'];
  mep?: InputMaybe<Scalars['Float']>;
  noInspectionFee: Scalars['Boolean'];
  premium?: InputMaybe<Scalars['Float']>;
  subjectivities: Array<Scalars['String']>;
  vaveQuoteId: Scalars['String'];
};

export enum ProductExclusionStatus {
  Approved = 'Approved',
  PendingReview = 'PendingReview',
  Rejected = 'Rejected'
}

export type ProductExclusionUpdateInput = {
  approvedReason?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  naics?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductExclusionStatus>;
};

export type ProductExclusionWhere = {
  statuses?: InputMaybe<Array<ProductExclusionStatus>>;
};

export enum QuoteAction {
  Bind = 'Bind',
  Deliver = 'Deliver',
  Invalidate = 'Invalidate',
  Process = 'Process',
  ReceiveBindRequest = 'ReceiveBindRequest',
  ReceiveNotTaken = 'ReceiveNotTaken',
  UploadRawQuote = 'UploadRawQuote',
  UploadRedactedQuote = 'UploadRedactedQuote'
}

export enum QuoteNotTakenReason {
  AdmittedOption = 'AdmittedOption',
  Competitor = 'Competitor',
  CoverageOrTerms = 'CoverageOrTerms',
  InsuredDidNotProceed = 'InsuredDidNotProceed',
  NoResponse = 'NoResponse',
  Other = 'Other',
  Price = 'Price',
  Skipped = 'Skipped',
  Timing = 'Timing',
  Unspecified = 'Unspecified'
}

export type QuoteProposalValuesInput = {
  quoteId?: InputMaybe<Scalars['ID']>;
  submissionId?: InputMaybe<Scalars['ID']>;
};

export enum QuoteState {
  BindRequestReceived = 'BindRequestReceived',
  Bound = 'Bound',
  Created = 'Created',
  Delivered = 'Delivered',
  Invalid = 'Invalid',
  NotTaken = 'NotTaken',
  Processed = 'Processed',
  Redacted = 'Redacted',
  Unredacted = 'Unredacted'
}

export type QuotesInput = {
  insuredId?: InputMaybe<Scalars['String']>;
  marketingPlanId?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['String']>;
};

export type RecordSubmissionIndicationInput = {
  expectedState: SubmissionState;
  id: Scalars['UUID'];
  indicationPremium?: InputMaybe<Scalars['Decimal']>;
  noteText: Scalars['String'];
};

export type ReinstateVaveQuoteInput = {
  PolicyId: Scalars['String'];
  TransactionReason: Scalars['String'];
  vaveQuoteId: Scalars['String'];
};

export type RejectAlbyQuoteInput = {
  expectedVersion: Scalars['Int'];
  opportunityId: Scalars['ID'];
  quoteId: Scalars['ID'];
  reason: Scalars['String'];
  sourceVersion: Scalars['Int'];
};

export type RemoveAssignmentGroupFromBrokerDto = {
  assignmentGroup: AssignmentGroup;
  brokerId: Scalars['String'];
};

export type RemoveAttachmentFromDraftInputDto = {
  attachmentId: Scalars['ID'];
  id: Scalars['ID'];
};

export type RemoveConversationLabelInput = {
  conversationId: Scalars['String'];
  label: Scalars['String'];
};

export type RenewalsDataInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ReplaceMarketingPlanSubmissionsInput = {
  appetiteProductIds: Array<Scalars['String']>;
  marketingPlanId: Scalars['ID'];
};

export type RescheduleSendDraftInputDto = {
  id: Scalars['ID'];
  scheduledSendAt: Scalars['DateTime'];
};

export enum Roles {
  Arm = 'ARM',
  Admin = 'Admin',
  Agent = 'Agent',
  Binding = 'Binding',
  Broker = 'Broker',
  Dj = 'DJ',
  UnderwritingAssistant = 'UnderwritingAssistant'
}

export type SaveVaveQuoteChangesInput = {
  admitted: Scalars['Boolean'];
  agentCommission: Scalars['Float'];
  brokerFee?: InputMaybe<Scalars['Float']>;
  carrierFee?: InputMaybe<Scalars['Float']>;
  carrierName: Scalars['String'];
  data: Scalars['String'];
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  grossCommission?: InputMaybe<Scalars['Float']>;
  homeState?: InputMaybe<Scalars['String']>;
  inspectionFee?: InputMaybe<Scalars['Float']>;
  inspectionFeeTreatment?: InputMaybe<InspectionFeeTreatment>;
  insuredName?: InputMaybe<Scalars['String']>;
  mep?: InputMaybe<Scalars['Float']>;
  noInspectionFee: Scalars['Boolean'];
  subjectivities: Array<Scalars['String']>;
  vaveQuoteId: Scalars['String'];
};

export type ScheduleSendDraftInputDto = {
  id: Scalars['ID'];
  scheduledSendAt: Scalars['DateTime'];
};

export type SearchInboxAgenciesInput = {
  inboxIds: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  showExpired?: InputMaybe<Scalars['Boolean']>;
  term: Scalars['String'];
};

export type SearchInboxAgentsInput = {
  inboxIds: Array<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  term: Scalars['String'];
};

/** The resource type of search result */
export enum SearchResultType {
  Insured = 'Insured',
  Policy = 'Policy'
}

export type SendBindRequestInput = {
  carrierContactInformation?: InputMaybe<Scalars['String']>;
  inspectionContactEmail?: InputMaybe<Scalars['String']>;
  inspectionContactName?: InputMaybe<Scalars['String']>;
  inspectionContactPhone?: InputMaybe<Scalars['String']>;
  inspectionContactUnknown?: Scalars['Boolean'];
  /** What the inspection needs. Required when the request is Other. */
  inspectionSurveyNote?: InputMaybe<Scalars['String']>;
  /** The kind of inspection the producer asked for. Omitted means Standard. */
  inspectionSurveyRequest?: InputMaybe<InspectionSurveyRequest>;
  isRenewable?: Scalars['Boolean'];
  outstandingSubjectivities: Scalars['String'];
  policyDesiredEffectiveDate: Scalars['DateTime'];
  policyDesiredExpirationDate: Scalars['DateTime'];
  premisesCity?: InputMaybe<Scalars['String']>;
  premisesState?: InputMaybe<Scalars['String']>;
  premisesStreetAddress?: InputMaybe<Scalars['String']>;
  premisesZip?: InputMaybe<Scalars['String']>;
  quoteId: Scalars['ID'];
  tria: Scalars['String'];
};

export enum SendQuoteEmailCommentFormat {
  Plain = 'PLAIN',
  Rich = 'RICH'
}

export type SendQuoteInput = {
  agentEmail?: InputMaybe<Scalars['String']>;
  agentPhone?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  emailComment?: InputMaybe<Scalars['String']>;
  emailCommentFormat?: InputMaybe<SendQuoteEmailCommentFormat>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  quoteId?: InputMaybe<Scalars['ID']>;
  replyToConversationId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
};

export type SendSubmissionToCarrierInput = {
  emailComment?: InputMaybe<Scalars['String']>;
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  submissionId: Scalars['ID'];
};

export type SetInspectionOrderedElsewhereInput = {
  inspectionOrderId: Scalars['ID'];
  /** Who the inspection was ordered from, when known. */
  vendor?: InputMaybe<Scalars['String']>;
};

export type SetMessageClassificationInput = {
  classificationLabel: Scalars['String'];
  messageId: Scalars['ID'];
};

export type SetOpportunityCollaboratorsInput = {
  /** The full collaborator set. Pass an empty list to clear collaborators. */
  collaboratorIds: Array<Scalars['UUID']>;
  id: Scalars['UUID'];
};

export type SetPlaybookTriggerInput = {
  /** The event type that triggers this playbook, e.g. 'Opportunity.assignedToBroker' */
  eventType: Scalars['String'];
  /** The ID of the playbook to execute when the event fires */
  playbookId: Scalars['String'];
  /** Optional configuration for parameterized event types. E.g., for 'Renewal.expiringInDays': { daysUntil: 30 } */
  triggerConfig?: InputMaybe<Scalars['JSONObject']>;
};

export type SetViewerThreadReadStateInput = {
  read: Scalars['Boolean'];
  teamConversationId: Scalars['UUID'];
};

export type SnoozeOpportunityInput = {
  id: Scalars['String'];
  snoozeUntil: Scalars['DateTime'];
};

export enum SubmissionAction {
  BlockMarket = 'BlockMarket',
  Decline = 'Decline',
  Indicate = 'Indicate',
  Quote = 'Quote',
  ReadyToSubmit = 'ReadyToSubmit',
  Refer = 'Refer',
  Revert = 'Revert',
  RuleOut = 'RuleOut',
  Submit = 'Submit'
}

export enum SubmissionState {
  Declined = 'Declined',
  Indicated = 'Indicated',
  MarketBlocked = 'MarketBlocked',
  Pending = 'Pending',
  Quoted = 'Quoted',
  ReadyToSubmit = 'ReadyToSubmit',
  Referred = 'Referred',
  Revert = 'Revert',
  RuledOut = 'RuledOut',
  Submitted = 'Submitted'
}

export type SubmissionsFilterInput = {
  appetiteProductIds?: InputMaybe<Array<Scalars['String']>>;
  appetiteProductMarketTypes?: InputMaybe<Array<Scalars['String']>>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  opportunityId?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<SubmissionsSortBy>;
  states?: InputMaybe<Array<SubmissionState>>;
};

export enum SubmissionsSortBy {
  CreatedAt = 'createdAt',
  DesiredEffectiveDate = 'desiredEffectiveDate',
  EffectiveDate = 'effectiveDate',
  UpdatedAt = 'updatedAt'
}

export enum SupplementalForm {
  BuildersRisk = 'BuildersRisk',
  ContractorsGeneralLiability = 'ContractorsGeneralLiability',
  ContractorsPollutionLiability = 'ContractorsPollutionLiability',
  Cyber = 'Cyber',
  Daycare = 'Daycare',
  Garage = 'Garage',
  ResidentialLro = 'ResidentialLro',
  SubmissionSupplemental = 'SubmissionSupplemental'
}

/** Tool filter configuration for playbook execution */
export type ToolFilterInput = {
  /** If set, all tools except these are allowed (mutually exclusive with whitelist) */
  blacklist?: InputMaybe<Array<Scalars['String']>>;
  /** If set, only these tools are allowed (mutually exclusive with blacklist) */
  whitelist?: InputMaybe<Array<Scalars['String']>>;
};

export type TransitionMarketingPlanInput = {
  action: MarketingPlanAction;
  expectedState: MarketingPlanState;
  id: Scalars['UUID'];
};

export type TransitionPolicyInput = {
  action: PolicyAction;
  expectedState: PolicyState;
  id: Scalars['UUID'];
};

export type TransitionQuoteInput = {
  action: QuoteAction;
  expectedState: QuoteState;
  id: Scalars['UUID'];
  notTakenNote?: InputMaybe<Scalars['String']>;
  notTakenReason?: InputMaybe<QuoteNotTakenReason>;
};

export type TransitionSubmissionInput = {
  action: SubmissionAction;
  details?: InputMaybe<Scalars['String']>;
  expectedState: SubmissionState;
  id: Scalars['UUID'];
  repairToState?: InputMaybe<SubmissionState>;
};

export type UnlinkConversationFromInsuredInput = {
  conversationId: Scalars['String'];
};

export type UnlinkConversationFromOpportunityInput = {
  conversationId: Scalars['String'];
  opportunityId: Scalars['String'];
};

export type UnlinkConversationFromSubmissionInput = {
  conversationId: Scalars['String'];
  submissionId: Scalars['String'];
};

export type UpdateAgencyInput = {
  agencyId: Scalars['String'];
  bindHqId?: InputMaybe<Scalars['String']>;
  defaultSecondaryAgentIds?: InputMaybe<Array<Scalars['String']>>;
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ownerId?: InputMaybe<Scalars['String']>;
};

export type UpdateAppetiteProductInput = {
  id: Scalars['ID'];
  portalLink?: InputMaybe<Scalars['String']>;
  submissionInstructions?: InputMaybe<Scalars['String']>;
};

export type UpdateBindHqAgencyInput = {
  billingContactFirstName?: InputMaybe<Scalars['String']>;
  billingContactLastName?: InputMaybe<Scalars['String']>;
  bindHqId: Scalars['String'];
  city: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type UpdateCarrierContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateCarrierInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fax?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  phone?: InputMaybe<Scalars['String']>;
  portalUrl?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  qwAppointed?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateCommentInput = {
  id: Scalars['UUID'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftMessageInputDto = {
  bcc?: InputMaybe<Array<Scalars['String']>>;
  cc?: InputMaybe<Array<Scalars['String']>>;
  classification?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  html?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  inReplyTo?: InputMaybe<Scalars['String']>;
  insuredId?: InputMaybe<Scalars['ID']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  opportunityId?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['String']>;
  referenceMessageId?: InputMaybe<Scalars['ID']>;
  references?: InputMaybe<Array<Scalars['String']>>;
  subject?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
  threadId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateFileUploadInput = {
  audience?: InputMaybe<File_Audience>;
  filename?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  insuredId?: InputMaybe<Scalars['String']>;
  opportunityId?: InputMaybe<Scalars['String']>;
  sha256Checksum?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['String']>;
};

export type UpdateFileUploadTagInput = {
  id: Scalars['String'];
  label: Scalars['String'];
};

export type UpdateInformationRequestDraftInput = {
  draftEmailId: Scalars['ID'];
  html?: InputMaybe<Scalars['String']>;
  opportunityId: Scalars['ID'];
  subject?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateInspectionPacketInput = {
  /** Replaces the packet's addresses. */
  addresses?: InputMaybe<Array<InspectionAddressInput>>;
  contact?: InputMaybe<InspectionContactInput>;
  inspectionOrderId: Scalars['ID'];
  /** Omit to keep the survey type; null clears it. */
  surveyTypeCode?: InputMaybe<Scalars['String']>;
};

export type UpdateInsuredInput = {
  agentId?: InputMaybe<Scalars['UUID']>;
  bindHqId?: InputMaybe<Scalars['String']>;
  cglCode?: InputMaybe<Scalars['String']>;
  dba?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  exposures?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isoCglCodes?: InputMaybe<Array<Scalars['String']>>;
  legalEntityType?: InputMaybe<BindHqInsuredType>;
  naicsCode?: InputMaybe<Scalars['String']>;
  naicsCodes?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
  primaryState?: InputMaybe<Scalars['String']>;
  revenue?: InputMaybe<Scalars['Int']>;
  secondaryAgentIds?: InputMaybe<Array<Scalars['String']>>;
  sicCodes?: InputMaybe<Array<Scalars['String']>>;
  stsAssigneeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateMessageClassificationInput = {
  associatedPlaybookId?: InputMaybe<Scalars['String']>;
  autoRunPlaybook?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdatePlaybookInput = {
  description?: InputMaybe<Scalars['String']>;
  fileUploadIds?: InputMaybe<Array<Scalars['String']>>;
  /** Model tier this playbook's LLM frames run at. Pass null to clear a declared tier and go back to the runtime default (expert). */
  modelTier?: InputMaybe<ModelTier>;
  name?: InputMaybe<Scalars['String']>;
  /** Describes the parameters this playbook expects when invoked via executePlaybook */
  parametersDescription?: InputMaybe<Scalars['String']>;
  /** Typed declared parameters for deterministic Template playbooks. */
  templateParamSchema?: InputMaybe<Scalars['JSON']>;
  /** Tool filter: null = all tools allowed, {whitelist: []} = only these tools, {blacklist: []} = all except these */
  toolFilter?: InputMaybe<ToolFilterInput>;
  type?: InputMaybe<PlaybookType>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type UpdatePlaybookSetInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyInput = {
  awaitingSubjectivities?: InputMaybe<Scalars['Boolean']>;
  endorsementsRequested?: InputMaybe<Scalars['Boolean']>;
  isRenewable?: InputMaybe<Scalars['Boolean']>;
  policyFileId?: InputMaybe<Scalars['String']>;
  policyId: Scalars['String'];
};

/** Input for updating a product */
export type UpdateProductInput = {
  /** Carrier ID for this product */
  carrierId?: InputMaybe<Scalars['ID']>;
  /** Whether the product is enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** File upload IDs to attach to this product */
  fileUploadIds?: InputMaybe<Array<Scalars['String']>>;
  /** Gross commission percentage (0-100) */
  grossCommission?: InputMaybe<Scalars['Float']>;
  /** Line of business IDs for this product */
  lineOfBusinessIds?: InputMaybe<Array<Scalars['String']>>;
  /** Market type: binding authority or brokerage */
  marketType?: InputMaybe<MarketTypes>;
  /** Product name */
  name?: InputMaybe<Scalars['String']>;
  /** The workflow/instructions for this product */
  workflow?: InputMaybe<Scalars['String']>;
};

export type UpdateRenewalNoteInput = {
  opportunityId: Scalars['String'];
  text: Scalars['String'];
};

export type UpdateRenewalStatusInput = {
  /** Binding team's status */
  bindingStatus?: InputMaybe<Scalars['String']>;
  opportunityId: Scalars['String'];
  /** Brokerage team's status */
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateSubmissionInput = {
  bindHqUrl?: InputMaybe<Scalars['String']>;
  cancellationDate?: InputMaybe<Scalars['DateTime']>;
  coverage?: InputMaybe<Scalars['String']>;
  declinationReason?: InputMaybe<Scalars['String']>;
  declinedDueToNaics?: InputMaybe<Scalars['Boolean']>;
  declinedDueToState?: InputMaybe<Scalars['Boolean']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  indicationPremium?: InputMaybe<Scalars['Decimal']>;
  personalizedEmailSubmissionBody?: InputMaybe<Scalars['String']>;
  referralReason?: InputMaybe<Scalars['String']>;
  submissionEmailAttachmentFileIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateTagInput = {
  childTags?: InputMaybe<Array<Scalars['String']>>;
  label: Scalars['String'];
  newLabel?: InputMaybe<Scalars['String']>;
  parentTags?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateTagsInput = {
  find?: InputMaybe<Scalars['String']>;
  labels: Array<Scalars['String']>;
  parentTag?: InputMaybe<Scalars['String']>;
  replace?: InputMaybe<Scalars['String']>;
};

export type UpdateTeamInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UploadCarrierContractInput = {
  /** Optional product IDs to scope this contract to */
  appetiteProductIds?: InputMaybe<Array<Scalars['ID']>>;
  carrierId: Scalars['ID'];
  fileUploadId: Scalars['ID'];
};

export type UpsertAttributionArmRevenueTargetsInput = {
  armEmail: Scalars['String'];
  targets: Scalars['JSONObject'];
  year: Scalars['Int'];
};

export type UpsertAttributionProducerLabelInput = {
  label: Scalars['String'];
  producerEmail: Scalars['String'];
};

export type UpsertAttributionProducerRevenueTargetsInput = {
  producerEmail: Scalars['String'];
  targets: Scalars['JSONObject'];
  year: Scalars['Int'];
};

export type UserAccountFindManyFilter = {
  agencyId?: InputMaybe<Scalars['String']>;
  emailDomainVerified?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Roles>>;
};

export type UserAccountUpdateInput = {
  attributionRole?: InputMaybe<AttributionRole>;
  bindHqId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Roles>>;
  verifyEmailDomain?: InputMaybe<Scalars['Boolean']>;
};

export type ActionApprovedEventFragment = { __typename?: 'ActionApprovedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type ActionDismissedEventFragment = { __typename?: 'ActionDismissedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type ActionRejectedEventFragment = { __typename?: 'ActionRejectedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type ActionRequestedEventFragment = { __typename?: 'ActionRequestedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type AgencyFragment = { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean };

export type AgencyAffiliationFragment = { __typename?: 'AgencyAffiliation', id: string, name: string, shortName?: string | null, logoUrl?: string | null, bindingCommission?: string & { __scalar: "Decimal" } | null, brokerageCommission?: string & { __scalar: "Decimal" } | null };

export type AgencyTransferEventFragment = { __typename?: 'AgencyTransferEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type AlbyUpdateEventFragment = { __typename?: 'AlbyUpdateEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type AppetiteProductFragment = { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null };

export type ApplicationSubmittedEventFragment = { __typename?: 'ApplicationSubmittedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type AssignmentChangeEventFragment = { __typename?: 'AssignmentChangeEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type AuthTokenFragment = { __typename?: 'AuthToken', accessToken: string, refreshToken: string };

export type AutomatedFollowUpEventFragment = { __typename?: 'AutomatedFollowUpEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type BindHqAgencyFragment = { __typename?: 'BindHqAgency', id: string, name: string, phone?: string | null, email?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, okToBind: boolean };

export type BotCommentEventFragment = { __typename?: 'BotCommentEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type BusinessClassFragment = { __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string };

export type BusinessClassCodesChangedEventFragment = { __typename?: 'BusinessClassCodesChangedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type CarrierFragment = { __typename: 'Carrier', id: string, name: string, slug: string, pdf: boolean, api: boolean, portalUrl?: string | null, url?: string | null, foregroundColor: string, backgroundColor: string, bindHqCarrierIds: Array<string> };

export type CarrierContactFragment = { __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null };

export type ChatMessageFragment = { __typename?: 'ChatMessage', id: string, externalMessageId?: string | null, sessionId: string, parts: string, role: string, status: string, createdAt: any, isElicitation: boolean, elicitationResolvedBy?: string | null, frameId?: string | null };

export type ChatSessionFragment = { __typename?: 'ChatSession', id: string, title?: string | null, status?: ChatSessionStatus | null, userId: string, viewerCanSendMessages: boolean, createdAt: any, updatedAt?: any | null, lastMessageAt?: any | null, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, messages: Array<{ __typename?: 'ChatMessage', id: string, externalMessageId?: string | null, sessionId: string, parts: string, role: string, status: string, createdAt: any, isElicitation: boolean, elicitationResolvedBy?: string | null, frameId?: string | null }>, metadata: Array<{ __typename?: 'ChatSessionMetadataEntry', key: string, value: string }> };

export type ClassCodeFragment = { __typename?: 'ClassCode', id: string, description: string, classCode: string, classSystem: string };

export type ClientDataFragment = { __typename?: 'ClientData', id: string, insuredId: string, index?: number | null, key: string, value: string, source?: string | null };

export type CollaboratorsChangedEventFragment = { __typename?: 'CollaboratorsChangedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type ConversationMessageFragment = { __typename?: 'ConversationMessage', id: string, externalMessageId: string, renderKey: string, sourceSessionId: string, rootSessionId: string, role: string, parts: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], status: string, sequence?: number | null, createdAt: any };

export type CoveragesChangedEventFragment = { __typename?: 'CoveragesChangedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type CreatedEventFragment = { __typename?: 'CreatedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type DesiredEffectiveDateChangeEventFragment = { __typename?: 'DesiredEffectiveDateChangeEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type DraftMessageFragment = { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> };

export type DraftMessageAttachmentFragment = { __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } };

export type EmailEventFragment = { __typename?: 'EmailEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, email: { __typename?: 'Email', id: string & { __scalar: "UUID" }, to: string, from: string, subject: string, cc?: string | null, body: string, extractedBody: string, dateReceived: any, linkToEmailInGoogleGroups?: string | null } };

export type FileUploadFragment = { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number };

export type FileUploadEventFragment = { __typename?: 'FileUploadEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type GmailMessageFragment = { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> };

export type GmailMessageEventFragment = { __typename?: 'GmailMessageEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailMessage: { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

export type GmailRelayEventFragment = { __typename?: 'GmailRelayEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailRelay: { __typename?: 'GmailRelay', recipientEmail: string, initiator: { __typename?: 'UserAccount', email: string } }, gmailMessage: { __typename?: 'GmailMessage', html: string, id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

export type InboxAgencySearchResultFragment = { __typename?: 'AgencySearchResult', id: string, name: string, accountCount: number, agentCount: number };

export type InboxAgentActionFragment = { __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean };

export type InboxAgentContactFragment = { __typename?: 'AgentContact', id: string, firstName: string, lastName: string, email: string, agencyName: string, mobilePhone?: string | null, workPhone?: string | null };

export type InboxAgentSearchResultFragment = { __typename?: 'AgentSearchResult', id: string, firstName: string, lastName: string, email: string, agencyName?: string | null };

export type InboxContactFragment = { __typename?: 'InboxContact', displayName: string, email: string };

export type InboxConversationFragment = { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } };

export type InboxConversationsByOpportunityConversationFragment = { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null };

export type InboxConversationsConversationFragment = { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> };

export type InboxConversationsListConversationFragment = { __typename?: 'Conversation', teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, internalParticipantEmails: Array<string>, lastMessageFrom?: string | null, id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, sourceReason: ConversationWakeUpSourceReason, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> };

export type InboxFullMessageFragment = { __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, to: Array<string>, from: string, cc: Array<string>, replyTo?: string | null, priority?: string | null, date: any, conversationId: string & { __scalar: "UUID" }, inboxId: string & { __scalar: "UUID" }, subject?: string | null, text?: string | null, html?: string | null, labels: Array<string>, summary?: string | null, headers?: string | null, annotatedHtml?: string | null, canReplyAll?: boolean | null };

export type InboxInsuredFragment = { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any };

export type InboxInsuredDetailFragment = { __typename?: 'Insured', id: string & { __scalar: "UUID" }, dba?: string | null, description?: string | null, primaryState?: string | null, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type InboxLabelFragment = { __typename?: 'EmailLabel', externalId: string, name: string, type?: string | null };

export type InboxMessageFragment = { __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> };

export type InboxOpportunityFragment = { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> };

export type InboxSearchSuggestionConversationFragment = { __typename?: 'Conversation', id: string, subject: string, participants: Array<string>, lastMessageFrom?: string | null };

export type InboxSubmissionFragment = { __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> };

export type InspectionOrderFragment = { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> };

export type InspectionRecFragment = { __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean };

export type InspectionReportFragment = { __typename?: 'InspectionReport', id: string, inspectionOrderId: string, source: InspectionReportSource, vendorOrderId?: string | null, locationIndex: number, locationText: string, fileId?: string | null, status: InspectionReportStatus, flagReason?: InspectionReportFlagReason | null, summaryCount?: number | null, countCheck?: InspectionReportCountCheck | null, letterFileId?: string | null, templateVersion?: string | null, recsHash?: string | null, sentAt?: any | null, sentById?: string | null, sentTo?: string | null, proofFileIds: Array<string>, signedConfirmedById?: string | null, followUpDueAt?: any | null, error?: string | null, updatedAt: any, vendorRiskCounts?: { __typename?: 'InspectionVendorRiskCounts', major?: number | null, minor?: number | null } | null, extractedRecs: Array<{ __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean }>, recs: Array<{ __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean }>, recEdits: Array<{ __typename?: 'InspectionRecEdit', op: InspectionRecEditOp, reason: InspectionRecEditReason, byId: string, at: any, before?: { __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean } | null, after?: { __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean } | null }> };

export type InsuredFragment = { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } };

export type LineOfBusinessFragment = { __typename?: 'LineOfBusiness', id: string, displayName: string };

export type MarketingPlanStateTransitionFragment = { __typename?: 'MarketingPlanStateTransition', id: string, marketingPlanId: string, previousState: MarketingPlanState, state: MarketingPlanState, createdAt: any, originatorId: string };

export type MessageAttachmentFragment = { __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } };

export type ModelEvaluationFragment = { __typename?: 'ModelEvaluation', id: string, createdAt: any, completedAt?: any | null, status: string, totalSamples: number, failedPredictions: number, mae?: number | null, rmse?: number | null, r2?: number | null, mape?: number | null, minError?: number | null, maxError?: number | null, meanError?: number | null, medianError?: number | null, modelMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, percentiles?: { __typename?: 'ModelEvaluationPercentiles', p25: number, p50: number, p75: number, p90: number, p95: number } | null, accuracyBuckets?: { __typename?: 'ModelEvaluationAccuracyBuckets', within100: number, within500: number, within1000: number, within10Percent: number, within25Percent: number } | null };

export type NotificationFragment = { __typename?: 'Notification', id: string, createdAt: any, readAt?: any | null, event: { __typename: 'ActionApprovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'ActionDismissedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'ActionRejectedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'ActionRequestedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'AgencyTransferEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'AlbyUpdateEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'ApplicationSubmittedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'AssignmentChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'AutomatedFollowUpEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'BotCommentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'BusinessClassCodesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'CollaboratorsChangedEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'CoveragesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'CreatedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'DesiredEffectiveDateChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'EmailEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, email: { __typename?: 'Email', id: string & { __scalar: "UUID" }, to: string, from: string, subject: string, cc?: string | null, body: string, extractedBody: string, dateReceived: any, linkToEmailInGoogleGroups?: string | null } } | { __typename: 'FileUploadEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'GmailMessageEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, gmailMessage: { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } } | { __typename: 'GmailRelayEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, gmailRelay: { __typename?: 'GmailRelay', recipientEmail: string, initiator: { __typename?: 'UserAccount', email: string } }, gmailMessage: { __typename?: 'GmailMessage', html: string, id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } } | { __typename: 'OutcomeChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'PolicyRenewabilityChangedEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'ProductsAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'ProductsRemovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'RequirementAddedEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'StatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'SubmissionStatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'TriageAssignmentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } } | { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } } };

type NotificationOpportunityEvent_ActionApprovedEvent_Fragment = { __typename: 'ActionApprovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_ActionDismissedEvent_Fragment = { __typename: 'ActionDismissedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_ActionRejectedEvent_Fragment = { __typename: 'ActionRejectedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_ActionRequestedEvent_Fragment = { __typename: 'ActionRequestedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_AgencyTransferEvent_Fragment = { __typename: 'AgencyTransferEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_AlbyUpdateEvent_Fragment = { __typename: 'AlbyUpdateEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_ApplicationSubmittedEvent_Fragment = { __typename: 'ApplicationSubmittedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_AssignmentChangeEvent_Fragment = { __typename: 'AssignmentChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_AutomatedFollowUpEvent_Fragment = { __typename: 'AutomatedFollowUpEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_BotCommentEvent_Fragment = { __typename: 'BotCommentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_BusinessClassCodesChangedEvent_Fragment = { __typename: 'BusinessClassCodesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_CollaboratorsChangedEvent_Fragment = { __typename: 'CollaboratorsChangedEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_CoveragesChangedEvent_Fragment = { __typename: 'CoveragesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_CreatedEvent_Fragment = { __typename: 'CreatedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_DesiredEffectiveDateChangeEvent_Fragment = { __typename: 'DesiredEffectiveDateChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_EmailEvent_Fragment = { __typename: 'EmailEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, email: { __typename?: 'Email', id: string & { __scalar: "UUID" }, to: string, from: string, subject: string, cc?: string | null, body: string, extractedBody: string, dateReceived: any, linkToEmailInGoogleGroups?: string | null } };

type NotificationOpportunityEvent_FileUploadEvent_Fragment = { __typename: 'FileUploadEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_GmailMessageEvent_Fragment = { __typename: 'GmailMessageEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, gmailMessage: { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

type NotificationOpportunityEvent_GmailRelayEvent_Fragment = { __typename: 'GmailRelayEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, gmailRelay: { __typename?: 'GmailRelay', recipientEmail: string, initiator: { __typename?: 'UserAccount', email: string } }, gmailMessage: { __typename?: 'GmailMessage', html: string, id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

type NotificationOpportunityEvent_OutcomeChangeEvent_Fragment = { __typename: 'OutcomeChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_PolicyRenewabilityChangedEvent_Fragment = { __typename: 'PolicyRenewabilityChangedEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_ProductsAddedEvent_Fragment = { __typename: 'ProductsAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_ProductsRemovedEvent_Fragment = { __typename: 'ProductsRemovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_RequirementAddedEvent_Fragment = { __typename: 'RequirementAddedEvent', type: OpportunityEventType, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_StatusChangeEvent_Fragment = { __typename: 'StatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_SubmissionStatusChangeEvent_Fragment = { __typename: 'SubmissionStatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_TriageAssignmentEvent_Fragment = { __typename: 'TriageAssignmentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

type NotificationOpportunityEvent_UserComment_Fragment = { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, insured: { __typename?: 'Insured', name: string, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }, broker?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type NotificationOpportunityEventFragment = NotificationOpportunityEvent_ActionApprovedEvent_Fragment | NotificationOpportunityEvent_ActionDismissedEvent_Fragment | NotificationOpportunityEvent_ActionRejectedEvent_Fragment | NotificationOpportunityEvent_ActionRequestedEvent_Fragment | NotificationOpportunityEvent_AgencyTransferEvent_Fragment | NotificationOpportunityEvent_AlbyUpdateEvent_Fragment | NotificationOpportunityEvent_ApplicationSubmittedEvent_Fragment | NotificationOpportunityEvent_AssignmentChangeEvent_Fragment | NotificationOpportunityEvent_AutomatedFollowUpEvent_Fragment | NotificationOpportunityEvent_BotCommentEvent_Fragment | NotificationOpportunityEvent_BusinessClassCodesChangedEvent_Fragment | NotificationOpportunityEvent_CollaboratorsChangedEvent_Fragment | NotificationOpportunityEvent_CoveragesChangedEvent_Fragment | NotificationOpportunityEvent_CreatedEvent_Fragment | NotificationOpportunityEvent_DesiredEffectiveDateChangeEvent_Fragment | NotificationOpportunityEvent_EmailEvent_Fragment | NotificationOpportunityEvent_FileUploadEvent_Fragment | NotificationOpportunityEvent_GmailMessageEvent_Fragment | NotificationOpportunityEvent_GmailRelayEvent_Fragment | NotificationOpportunityEvent_OutcomeChangeEvent_Fragment | NotificationOpportunityEvent_PolicyRenewabilityChangedEvent_Fragment | NotificationOpportunityEvent_ProductsAddedEvent_Fragment | NotificationOpportunityEvent_ProductsRemovedEvent_Fragment | NotificationOpportunityEvent_RequirementAddedEvent_Fragment | NotificationOpportunityEvent_StatusChangeEvent_Fragment | NotificationOpportunityEvent_SubmissionStatusChangeEvent_Fragment | NotificationOpportunityEvent_TriageAssignmentEvent_Fragment | NotificationOpportunityEvent_UserComment_Fragment;

export type OpportunityFragment = { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, renewalOfPolicies: Array<string>, insuredId: string & { __scalar: "UUID" }, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProductId: string, bindHqApplicationId?: string | null, state: SubmissionState, createdAt: any, updatedAt?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> }>, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, primaryState?: string | null, naicsCodes: Array<string>, description?: string | null, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, agencyId: string & { __scalar: "UUID" }, email: string, firstName: string, lastName: string } }, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null };

export type OpportunityDetailsFragment = { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, isTest: boolean, insuredId: string & { __scalar: "UUID" }, splitOf?: string | null, splitOfInsuredId?: string | null, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, renewalOfPolicies: Array<string>, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } } | null, collaborators: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProductId: string, state: SubmissionState, createdAt: any, indicationPremium?: string & { __scalar: "Decimal" } | null, appetiteProduct: { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null }>, marketSummaryNotes: Array<{ __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> }>, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }, secondaryAgents: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }> } };

export type MarketingPlanSubmissionFragment = { __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProductId: string, state: SubmissionState, createdAt: any, indicationPremium?: string & { __scalar: "Decimal" } | null, appetiteProduct: { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null }>, marketSummaryNotes: Array<{ __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> };

export type MarketingPlanMarketSummaryNoteFragment = { __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } };

export type MarketingPlanQuoteFragment = { __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null };

export type MarketingPlanAppetiteProductFragment = { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null };

type OpportunityEvent_ActionApprovedEvent_Fragment = { __typename: 'ActionApprovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_ActionDismissedEvent_Fragment = { __typename: 'ActionDismissedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_ActionRejectedEvent_Fragment = { __typename: 'ActionRejectedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_ActionRequestedEvent_Fragment = { __typename: 'ActionRequestedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_AgencyTransferEvent_Fragment = { __typename: 'AgencyTransferEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_AlbyUpdateEvent_Fragment = { __typename: 'AlbyUpdateEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_ApplicationSubmittedEvent_Fragment = { __typename: 'ApplicationSubmittedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_AssignmentChangeEvent_Fragment = { __typename: 'AssignmentChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_AutomatedFollowUpEvent_Fragment = { __typename: 'AutomatedFollowUpEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_BotCommentEvent_Fragment = { __typename: 'BotCommentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_BusinessClassCodesChangedEvent_Fragment = { __typename: 'BusinessClassCodesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_CollaboratorsChangedEvent_Fragment = { __typename: 'CollaboratorsChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_CoveragesChangedEvent_Fragment = { __typename: 'CoveragesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_CreatedEvent_Fragment = { __typename: 'CreatedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_DesiredEffectiveDateChangeEvent_Fragment = { __typename: 'DesiredEffectiveDateChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_EmailEvent_Fragment = { __typename: 'EmailEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, email: { __typename?: 'Email', id: string & { __scalar: "UUID" }, to: string, from: string, subject: string, cc?: string | null, body: string, extractedBody: string, dateReceived: any, linkToEmailInGoogleGroups?: string | null } };

type OpportunityEvent_FileUploadEvent_Fragment = { __typename: 'FileUploadEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_GmailMessageEvent_Fragment = { __typename: 'GmailMessageEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailMessage: { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

type OpportunityEvent_GmailRelayEvent_Fragment = { __typename: 'GmailRelayEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailRelay: { __typename?: 'GmailRelay', recipientEmail: string, initiator: { __typename?: 'UserAccount', email: string } }, gmailMessage: { __typename?: 'GmailMessage', html: string, id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

type OpportunityEvent_OutcomeChangeEvent_Fragment = { __typename: 'OutcomeChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_PolicyRenewabilityChangedEvent_Fragment = { __typename: 'PolicyRenewabilityChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_ProductsAddedEvent_Fragment = { __typename: 'ProductsAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_ProductsRemovedEvent_Fragment = { __typename: 'ProductsRemovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_RequirementAddedEvent_Fragment = { __typename: 'RequirementAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_StatusChangeEvent_Fragment = { __typename: 'StatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_SubmissionStatusChangeEvent_Fragment = { __typename: 'SubmissionStatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_TriageAssignmentEvent_Fragment = { __typename: 'TriageAssignmentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

type OpportunityEvent_UserComment_Fragment = { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type OpportunityEventFragment = OpportunityEvent_ActionApprovedEvent_Fragment | OpportunityEvent_ActionDismissedEvent_Fragment | OpportunityEvent_ActionRejectedEvent_Fragment | OpportunityEvent_ActionRequestedEvent_Fragment | OpportunityEvent_AgencyTransferEvent_Fragment | OpportunityEvent_AlbyUpdateEvent_Fragment | OpportunityEvent_ApplicationSubmittedEvent_Fragment | OpportunityEvent_AssignmentChangeEvent_Fragment | OpportunityEvent_AutomatedFollowUpEvent_Fragment | OpportunityEvent_BotCommentEvent_Fragment | OpportunityEvent_BusinessClassCodesChangedEvent_Fragment | OpportunityEvent_CollaboratorsChangedEvent_Fragment | OpportunityEvent_CoveragesChangedEvent_Fragment | OpportunityEvent_CreatedEvent_Fragment | OpportunityEvent_DesiredEffectiveDateChangeEvent_Fragment | OpportunityEvent_EmailEvent_Fragment | OpportunityEvent_FileUploadEvent_Fragment | OpportunityEvent_GmailMessageEvent_Fragment | OpportunityEvent_GmailRelayEvent_Fragment | OpportunityEvent_OutcomeChangeEvent_Fragment | OpportunityEvent_PolicyRenewabilityChangedEvent_Fragment | OpportunityEvent_ProductsAddedEvent_Fragment | OpportunityEvent_ProductsRemovedEvent_Fragment | OpportunityEvent_RequirementAddedEvent_Fragment | OpportunityEvent_StatusChangeEvent_Fragment | OpportunityEvent_SubmissionStatusChangeEvent_Fragment | OpportunityEvent_TriageAssignmentEvent_Fragment | OpportunityEvent_UserComment_Fragment;

export type OpportunityNotesFragment = { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, notes: Array<{ __typename?: 'OpportunityNote', id: string, createdAt: any, authoredByModel: boolean, text: string, creator: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }> };

export type OutcomeChangeEventFragment = { __typename?: 'OutcomeChangeEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type PlacementDeliveryWitnessFragment = { __typename?: 'PlacementDeliveryWitness', opportunityId: string, submissionId: string, quoteId: string, quoteState: string, evidenceKind: PlacementDeliveryEvidenceKind, deliveredAt?: any | null, placementTaskId?: string | null, creationProvenance?: string | null };

export type PlacementDeskSnapshotFragment = { __typename?: 'PlacementDeskSnapshot', progressTier?: PlacementDeskProgressTier | null, progressEvidenceError?: string | null, recordedDecline?: boolean | null, observerEventsError?: string | null, waitingReason: PlacementDeskWaitingReason, waitingSince?: any | null, furthestStep?: PlacementDeskStep | null, lastDeskActivityAt: any, placementId: string, runNumber: number, runCount: number, signals: Array<string>, undecidedMarketIds: Array<string>, reason?: string | null, status: string, stage?: string | null, outcome?: string | null, revision?: number | null, step: PlacementDeskStep, waitingOn: PlacementDeskWaitingOn, quietMinutes: number, suspectedStall: boolean, nextAction: string, holds: Array<string>, lastProgressAt: any, fetchedAt: any, syncError?: string | null, receipts: Array<{ __typename?: 'PlacementDeskReceipt', placementId?: string | null, runNumber?: number | null, marketId?: string | null, milestone?: string | null, receivedAt?: any | null, eventId?: string | null, attemptId?: string | null, quoteFileId?: string | null, reviewFileId?: string | null, disposition?: string | null, carrierAnswerFileId?: string | null }>, cycleEnded?: { __typename?: 'PlacementDeskCycleEnded', key?: string | null, reason?: string | null } | null, attentionRequests: Array<{ __typename?: 'PlacementDeskAttentionRequest', placementId: string, runNumber?: number | null, attentionId: string, occurrence?: number | null, kind?: string | null, marketId?: string | null, detail?: string | null, targetKind?: string | null, targetSlug?: string | null, taskKey?: string | null, requiredAt?: any | null, resolvedAt?: any | null, resolution?: string | null, open: boolean, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, marketSettlements: Array<{ __typename?: 'PlacementDeskMarketSettlement', placementId: string, runNumber?: number | null, marketId: string, reason?: string | null, attemptId?: string | null, disposition?: string | null, executionStatus?: string | null, terminal?: boolean | null, receivedAt: any, eventId: string, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null }>, marketAnswers: Array<{ __typename?: 'PlacementDeskMarketAnswer', verdict?: string | null, currentness?: string | null, placementId: string, runNumber?: number | null, marketId: string, stage: string, disposition?: string | null, terminal?: boolean | null, executionStatus?: string | null, attemptId?: string | null, resultFileId?: string | null, carrierAnswerFileId?: string | null, receivedAt: any, eventId: string }>, contractMarkets?: Array<{ __typename?: 'PlacementDeskContractMarket', marketId: string, displayName: string }> | null, attention: Array<{ __typename?: 'PlacementDeskAttention', kind: string, marketId?: string | null, detail?: string | null, workerId?: string | null, awaitingTaskId?: string | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, decisions: Array<{ __typename?: 'PlacementDeskMarketDecision', marketId: string, displayName: string, status: string, runNumber: number, placementId: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null }>, lanes: Array<{ __typename?: 'PlacementDeskLane', marketId: string, displayName: string, status: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, phase: string, channel?: string | null, holds: Array<string>, unsupportedIssueCodes: Array<string>, attentionKinds: Array<string>, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null, attention: Array<{ __typename?: 'PlacementDeskLaneAttention', kind: string, detail?: string | null, workerId?: string | null, taskId?: string | null, hook?: string | null, asks?: number | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, portal?: { __typename?: 'PlacementDeskPortal', segmentOrdinal?: number | null, status?: string | null, currentStepId?: string | null, tier?: number | null, currentStepNumber?: number | null, stepCount?: number | null, composition?: Array<{ __typename?: 'PlacementDeskPortalStep', stepId?: string | null, kind?: string | null, coverage?: string | null }> | null, discoveredRequirements?: Array<{ __typename?: 'PlacementDeskPortalRequirement', key?: string | null, label?: string | null, reason?: string | null, type?: string | null, values?: Array<string> | null, min?: number | null, max?: number | null, pageKey?: string | null, source?: string | null }> | null } | null }>, openReviews: Array<{ __typename?: 'PlacementDeskReview', superseded: boolean, hook: string, marketId?: string | null, openedAt: any, taskId: string, humanBound: boolean, awaitingTaskId?: string | null }> };

export type PlacementDeskWorkGroupFragment = { __typename?: 'PlacementDeskWorkGroup', submissionsCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, submissionsSent?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesDelivered?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null };

export type PlacementWorkflowRowFragment = { __typename?: 'PlacementWorkflowDashboardRow', dealDeleted?: boolean | null, dealClosed?: boolean | null, isTestDeal?: boolean | null, outcome?: string | null, outcomeReason?: string | null, opportunity: { __typename?: 'PlacementWorkflowOpportunitySummary', id: string, insuredId: string, insuredName: string, insuredDescription?: string | null, primaryState?: string | null, isoCglCodes: Array<string>, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, createdAt: any, state: string, broker?: { __typename?: 'PlacementWorkflowBrokerSummary', id?: string | null, name?: string | null, email?: string | null } | null }, desk?: { __typename?: 'PlacementDeskSnapshot', progressTier?: PlacementDeskProgressTier | null, progressEvidenceError?: string | null, recordedDecline?: boolean | null, observerEventsError?: string | null, waitingReason: PlacementDeskWaitingReason, waitingSince?: any | null, furthestStep?: PlacementDeskStep | null, lastDeskActivityAt: any, placementId: string, runNumber: number, runCount: number, signals: Array<string>, undecidedMarketIds: Array<string>, reason?: string | null, status: string, stage?: string | null, outcome?: string | null, revision?: number | null, step: PlacementDeskStep, waitingOn: PlacementDeskWaitingOn, quietMinutes: number, suspectedStall: boolean, nextAction: string, holds: Array<string>, lastProgressAt: any, fetchedAt: any, syncError?: string | null, receipts: Array<{ __typename?: 'PlacementDeskReceipt', placementId?: string | null, runNumber?: number | null, marketId?: string | null, milestone?: string | null, receivedAt?: any | null, eventId?: string | null, attemptId?: string | null, quoteFileId?: string | null, reviewFileId?: string | null, disposition?: string | null, carrierAnswerFileId?: string | null }>, cycleEnded?: { __typename?: 'PlacementDeskCycleEnded', key?: string | null, reason?: string | null } | null, attentionRequests: Array<{ __typename?: 'PlacementDeskAttentionRequest', placementId: string, runNumber?: number | null, attentionId: string, occurrence?: number | null, kind?: string | null, marketId?: string | null, detail?: string | null, targetKind?: string | null, targetSlug?: string | null, taskKey?: string | null, requiredAt?: any | null, resolvedAt?: any | null, resolution?: string | null, open: boolean, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, marketSettlements: Array<{ __typename?: 'PlacementDeskMarketSettlement', placementId: string, runNumber?: number | null, marketId: string, reason?: string | null, attemptId?: string | null, disposition?: string | null, executionStatus?: string | null, terminal?: boolean | null, receivedAt: any, eventId: string, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null }>, marketAnswers: Array<{ __typename?: 'PlacementDeskMarketAnswer', verdict?: string | null, currentness?: string | null, placementId: string, runNumber?: number | null, marketId: string, stage: string, disposition?: string | null, terminal?: boolean | null, executionStatus?: string | null, attemptId?: string | null, resultFileId?: string | null, carrierAnswerFileId?: string | null, receivedAt: any, eventId: string }>, contractMarkets?: Array<{ __typename?: 'PlacementDeskContractMarket', marketId: string, displayName: string }> | null, attention: Array<{ __typename?: 'PlacementDeskAttention', kind: string, marketId?: string | null, detail?: string | null, workerId?: string | null, awaitingTaskId?: string | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, decisions: Array<{ __typename?: 'PlacementDeskMarketDecision', marketId: string, displayName: string, status: string, runNumber: number, placementId: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null }>, lanes: Array<{ __typename?: 'PlacementDeskLane', marketId: string, displayName: string, status: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, phase: string, channel?: string | null, holds: Array<string>, unsupportedIssueCodes: Array<string>, attentionKinds: Array<string>, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null, attention: Array<{ __typename?: 'PlacementDeskLaneAttention', kind: string, detail?: string | null, workerId?: string | null, taskId?: string | null, hook?: string | null, asks?: number | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, portal?: { __typename?: 'PlacementDeskPortal', segmentOrdinal?: number | null, status?: string | null, currentStepId?: string | null, tier?: number | null, currentStepNumber?: number | null, stepCount?: number | null, composition?: Array<{ __typename?: 'PlacementDeskPortalStep', stepId?: string | null, kind?: string | null, coverage?: string | null }> | null, discoveredRequirements?: Array<{ __typename?: 'PlacementDeskPortalRequirement', key?: string | null, label?: string | null, reason?: string | null, type?: string | null, values?: Array<string> | null, min?: number | null, max?: number | null, pageKey?: string | null, source?: string | null }> | null } | null }>, openReviews: Array<{ __typename?: 'PlacementDeskReview', superseded: boolean, hook: string, marketId?: string | null, openedAt: any, taskId: string, humanBound: boolean, awaitingTaskId?: string | null }> } | null, wrote: { __typename?: 'PlacementWorkflowSubmissionWriteSummary', count: number, source: PlacementWorkflowSubmissionCountSource } };

export type PlaybookFragment = { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> };

export type PlaybookFileFragment = { __typename?: 'PlaybookFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number };

export type PlaybookRunFragment = { __typename?: 'PlaybookRunDto', id: string, playbookId: string, parentPlaybookRunId?: string | null, parentChatSessionId?: string | null, rootChatSessionId?: string | null, depth?: number | null, toolInvocationId?: string | null, chatSessionId?: string | null, conversationId?: string | null, opportunityId?: string | null, triggerEventType?: string | null, parameterValues?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, status: string, errorMessage?: string | null, startedAt: any, finishedAt?: any | null, totalInputTokens?: number | null, totalOutputTokens?: number | null, aiCallCount?: number | null, playbook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string }, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, toolInvocations: Array<{ __typename?: 'McpToolInvocationDto', id: string, status: string, toolName: string, toolCallId?: string | null, calledAt: any, finishedAt?: any | null, toolInput: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], toolOutput?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null }> };

export type PlaybookSetFragment = { __typename?: 'PlaybookSet', id: string, name: string, description?: string | null, playbookCount: number, isSubscribed: boolean };

export type PlaybookSetWithPlaybooksFragment = { __typename?: 'PlaybookSet', id: string, name: string, description?: string | null, playbookCount: number, isSubscribed: boolean, playbooks?: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> | null };

export type PlaybookTriggerFragment = { __typename?: 'PlaybookTrigger', id: string, userId: string, playbookId: string, eventType: string, triggerConfig?: any | null, lastFiredOn?: any | null, createdAt: any, updatedAt?: any | null, playbook: { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> } };

export type PolicyFragment = { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } };

export type PolicyListFragment = { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null } };

export type PolicyRenewabilityChangedEventFragment = { __typename?: 'PolicyRenewabilityChangedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type PolicyStateTransitionFragment = { __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string };

export type ProductFragment = { __typename?: 'Product', id: string, userId: string, name: string, workflow: string, createdAt: any, updatedAt?: any | null, enabled: boolean, marketType?: MarketTypes | null, carrierId?: string | null, lineOfBusinessIds?: Array<string> | null, grossCommission?: number | null, carrier?: { __typename?: 'Carrier', id: string, name: string, slug: string } | null, linesOfBusiness?: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> | null, files: Array<{ __typename?: 'ProductFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, submissionCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }>, referenceCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> };

export type ProductExclusionFragment = { __typename?: 'ProductExclusion', id: string, appetiteProductId: string, reason?: string | null, state?: string | null, naicsCode?: string | null };

export type ProductsAddedEventFragment = { __typename?: 'ProductsAddedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type ProductsRemovedEventFragment = { __typename?: 'ProductsRemovedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type QuoteFragment = { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> };

export type QuoteStateTransitionFragment = { __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string };

export type QuoteSubmissionFragment = { __typename?: 'Submission', id: string & { __scalar: "UUID" }, state: SubmissionState, exclusionReason?: { __typename?: 'ProductExclusion', id: string, appetiteProductId: string, reason?: string | null, state?: string | null, naicsCode?: string | null } | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null } };

export type RenewalNoteFragment = { __typename?: 'RenewalNote', id: string, text: string, updatedAt: any, isRead: boolean, author: { __typename?: 'RenewalNoteAuthor', id: string, firstName: string, lastName: string } };

export type RequirementAddedEventFragment = { __typename?: 'RequirementAddedEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type ScoredAppetiteProductFragment = { __typename?: 'ScoredAppetiteProduct', score: number, reasons?: Array<string> | null, previouslyQuotedCount: number, estimatedQwSpread?: number | null, product: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierSlug?: string | null, carrierProductName?: string | null, productDescription?: string | null, coverages: string, coreLines: Array<string>, marketType?: MarketTypes | null, grossCommission?: number | null } };

export type SearchResultFragment = { __typename?: 'SearchResult', id: string, insuredId: string & { __scalar: "UUID" }, insuredName: string, type: SearchResultType };

export type StandardEmailMessageAttachmentFragment = { __typename?: 'StandardEmailMessageAttachment', filename?: string | null, contentType?: string | null, size?: number | null, hash?: string | null };

export type MarketingPlanStateTransitionFragmentFragment = { __typename?: 'MarketingPlanStateTransition', id: string, marketingPlanId: string, originatorId: string, previousState: MarketingPlanState, state: MarketingPlanState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null };

export type SubmissionStateTransitionFragmentFragment = { __typename?: 'SubmissionStateTransition', id: string, submissionId: string, originatorId: string, previousState: SubmissionState, state: SubmissionState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null };

export type QuoteStateTransitionFragmentFragment = { __typename?: 'QuoteStateTransition', id: string, quoteId: string, originatorId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null };

export type PolicyStateTransitionFragmentFragment = { __typename?: 'PolicyStateTransition', id: string, policyId: string, originatorId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null };

export type SlimAppetiteProductFragmentFragment = { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null };

export type StatusChangeEventFragment = { __typename?: 'StatusChangeEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type SubmissionFragment = { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProductId: string, bindHqApplicationId?: string | null, state: SubmissionState, createdAt: any, updatedAt?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> };

export type SubmissionDetailsFragment = { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, state: SubmissionState, createdAt: any, updatedAt?: any | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, insured: { __typename?: 'Insured', primaryState?: string | null } } };

export type SubmissionStateTransitionFragment = { __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string };

export type SubmissionStatusChangeEventFragment = { __typename?: 'SubmissionStatusChangeEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type SubmissionResponseFragment = { __typename?: 'SubmissionResponse', submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, state: SubmissionState, personalizedEmailSubmissionBody?: string | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', email: string }> | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, desiredEffectiveDate: any, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string }, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null } }> };

export type TriageAssignmentEventFragment = { __typename?: 'TriageAssignmentEvent', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean };

export type UserAccountFragment = { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } };

export type UserCommentFragment = { __typename?: 'UserComment', id: string & { __scalar: "UUID" }, type: OpportunityEventType, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type VaveQuoteFragment = { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } };

export type CreateAgentActionLogMutationVariables = Exact<{
  agentActionId: Scalars['String'];
  type: Scalars['String'];
  fileId?: InputMaybe<Scalars['String']>;
  response?: InputMaybe<Scalars['String']>;
}>;


export type CreateAgentActionLogMutation = { __typename?: 'Mutation', createAgentActionLog: { __typename?: 'AgentActionLog', id: string, agentActionId: string, type: string, fileId?: string | null, response?: string | null } };

export type AddAssignmentGroupToBrokerMutationVariables = Exact<{
  input: AddAssignmentGroupToBrokerDto;
}>;


export type AddAssignmentGroupToBrokerMutation = { __typename?: 'Mutation', addAssignmentGroupToBroker: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type AddAttachmentToInboxDraftMutationVariables = Exact<{
  input: AddAttachmentToDraftInputDto;
}>;


export type AddAttachmentToInboxDraftMutation = { __typename?: 'Mutation', addAttachmentToInboxDraft: { __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } } };

export type AddCarrierContactToAppetiteProductMutationVariables = Exact<{
  input: CarrierContactConnectorInput;
}>;


export type AddCarrierContactToAppetiteProductMutation = { __typename?: 'Mutation', addCarrierContactToAppetiteProduct: { __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null } };

export type AddInboxConversationLabelMutationVariables = Exact<{
  input: AddConversationLabelInput;
}>;


export type AddInboxConversationLabelMutation = { __typename?: 'Mutation', addInboxConversationLabel?: { __typename?: 'Conversation', teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, internalParticipantEmails: Array<string>, lastMessageFrom?: string | null, id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, sourceReason: ConversationWakeUpSourceReason, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> } | null };

export type AddPlaybookToSetMutationVariables = Exact<{
  playbookId: Scalars['String'];
  setId: Scalars['ID'];
}>;


export type AddPlaybookToSetMutation = { __typename?: 'Mutation', addPlaybookToSet: boolean };

export type AddSubmissionRuleOutReasonMutationVariables = Exact<{
  input: AddSubmissionRuleOutReasonInput;
}>;


export type AddSubmissionRuleOutReasonMutation = { __typename?: 'Mutation', addSubmissionRuleOutReason: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProductId: string, bindHqApplicationId?: string | null, state: SubmissionState, createdAt: any, updatedAt?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> } };

export type UseAlbyQuoteMutationVariables = Exact<{
  input: AlbyQuoteConversionInput;
}>;


export type UseAlbyQuoteMutation = { __typename?: 'Mutation', useAlbyQuote: { __typename?: 'AlbyQuoteDecisionResult', operationId: string, status: string, retryable: boolean, submissionId?: string | null, quoteId?: string | null, quoteNumber?: string | null, rawFileId?: string | null, selectedFileId?: string | null, portalUrl?: string | null, quote?: { __typename?: 'AlbyQuote', id: string, opportunityId: string, sourceVersion: number, gate: { __typename?: 'AlbyProducerGate', opportunityId: string, mode: string, owned: boolean, reason?: string | null } } | null } };

export type EditAlbyQuoteInPortalMutationVariables = Exact<{
  input: AlbyQuoteConversionInput;
}>;


export type EditAlbyQuoteInPortalMutation = { __typename?: 'Mutation', editAlbyQuoteInPortal: { __typename?: 'AlbyQuoteDecisionResult', operationId: string, status: string, retryable: boolean, submissionId?: string | null, quoteId?: string | null, quoteNumber?: string | null, rawFileId?: string | null, selectedFileId?: string | null, portalUrl?: string | null, quote?: { __typename?: 'AlbyQuote', id: string, opportunityId: string, sourceVersion: number, gate: { __typename?: 'AlbyProducerGate', opportunityId: string, mode: string, owned: boolean, reason?: string | null } } | null } };

export type RejectAlbyQuoteMutationVariables = Exact<{
  input: RejectAlbyQuoteInput;
}>;


export type RejectAlbyQuoteMutation = { __typename?: 'Mutation', rejectAlbyQuote: { __typename?: 'AlbyQuoteDecisionResult', operationId: string, status: string, retryable: boolean, submissionId?: string | null, quoteId?: string | null, quoteNumber?: string | null, rawFileId?: string | null, selectedFileId?: string | null, portalUrl?: string | null } };

export type AlbyQuoteDecisionOutcomeFragment = { __typename?: 'AlbyQuoteDecisionResult', operationId: string, status: string, retryable: boolean, submissionId?: string | null, quoteId?: string | null, quoteNumber?: string | null, rawFileId?: string | null, selectedFileId?: string | null, portalUrl?: string | null };

export type AlbyQuoteDecisionIdentityFragment = { __typename?: 'AlbyQuote', id: string, opportunityId: string, sourceVersion: number, gate: { __typename?: 'AlbyProducerGate', opportunityId: string, mode: string, owned: boolean, reason?: string | null } };

export type ApplyDefaultSecondaryAgentsToAllInsuredsMutationVariables = Exact<{
  agencyId: Scalars['ID'];
}>;


export type ApplyDefaultSecondaryAgentsToAllInsuredsMutation = { __typename?: 'Mutation', applyDefaultSecondaryAgentsToAllInsureds: number };

export type ArchiveFileUploadMutationVariables = Exact<{
  input: DeleteFileUploadInput;
}>;


export type ArchiveFileUploadMutation = { __typename?: 'Mutation', archiveFileUpload: { __typename?: 'FileUpload', id: string } };

export type CreateAttributionProducerBaseIncentiveMutationVariables = Exact<{
  input: Scalars['JSONObject'];
}>;


export type CreateAttributionProducerBaseIncentiveMutation = { __typename?: 'Mutation', createAttributionProducerBaseIncentive: { __typename?: 'AttributionBaseIncentive', id: string, producerEmails: Array<string>, startDate: any, endDate: any, bandStart: number, bandEnd: number, incentivePayPercentage: number, createdAt: any, updatedAt: any } };

export type UpdateAttributionProducerBaseIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
  input: Scalars['JSONObject'];
}>;


export type UpdateAttributionProducerBaseIncentiveMutation = { __typename?: 'Mutation', updateAttributionProducerBaseIncentive: { __typename?: 'AttributionBaseIncentive', id: string, producerEmails: Array<string>, startDate: any, endDate: any, bandStart: number, bandEnd: number, incentivePayPercentage: number, createdAt: any, updatedAt: any } };

export type DeleteAttributionProducerBaseIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAttributionProducerBaseIncentiveMutation = { __typename?: 'Mutation', deleteAttributionProducerBaseIncentive: { __typename?: 'AttributionDeleteIncentiveResponse', success: boolean } };

export type CreateAttributionProducerBookBasedIncentiveMutationVariables = Exact<{
  input: Scalars['JSONObject'];
}>;


export type CreateAttributionProducerBookBasedIncentiveMutation = { __typename?: 'Mutation', createAttributionProducerBookBasedIncentive: { __typename?: 'AttributionBookBasedIncentive', id: string, producerEmail: string, bindhqLobs: Array<string>, bindhqLobsInclude: boolean, bindhqPolicyBusinessType?: string | null, naicsCode: Array<string>, naicsCodeInclude: boolean, cglCode: Array<string>, cglCodeInclude: boolean, startDate: any, endDate: any, incentivePayPercentage: number, createdAt: any, updatedAt: any } };

export type UpdateAttributionProducerBookBasedIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
  input: Scalars['JSONObject'];
}>;


export type UpdateAttributionProducerBookBasedIncentiveMutation = { __typename?: 'Mutation', updateAttributionProducerBookBasedIncentive: { __typename?: 'AttributionBookBasedIncentive', id: string, producerEmail: string, bindhqLobs: Array<string>, bindhqLobsInclude: boolean, bindhqPolicyBusinessType?: string | null, naicsCode: Array<string>, naicsCodeInclude: boolean, cglCode: Array<string>, cglCodeInclude: boolean, startDate: any, endDate: any, incentivePayPercentage: number, createdAt: any, updatedAt: any } };

export type DeleteAttributionProducerBookBasedIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAttributionProducerBookBasedIncentiveMutation = { __typename?: 'Mutation', deleteAttributionProducerBookBasedIncentive: { __typename?: 'AttributionDeleteIncentiveResponse', success: boolean } };

export type BulkDeleteAttributionProducerBookBasedIncentivesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkDeleteAttributionProducerBookBasedIncentivesMutation = { __typename?: 'Mutation', bulkDeleteAttributionProducerBookBasedIncentives: { __typename?: 'AttributionBulkDeleteIncentivesResponse', success: boolean, deletedCount: number } };

export type CreateAttributionProducerManagementBasedIncentiveMutationVariables = Exact<{
  input: Scalars['JSONObject'];
}>;


export type CreateAttributionProducerManagementBasedIncentiveMutation = { __typename?: 'Mutation', createAttributionProducerManagementBasedIncentive: { __typename?: 'AttributionManagementBasedIncentive', id: string, managerEmail: string, producerEmail: string, startDate: any, endDate: any, revenuePercentage: number, createdAt: any, updatedAt: any } };

export type UpdateAttributionProducerManagementBasedIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
  input: Scalars['JSONObject'];
}>;


export type UpdateAttributionProducerManagementBasedIncentiveMutation = { __typename?: 'Mutation', updateAttributionProducerManagementBasedIncentive: { __typename?: 'AttributionManagementBasedIncentive', id: string, managerEmail: string, producerEmail: string, startDate: any, endDate: any, revenuePercentage: number, createdAt: any, updatedAt: any } };

export type DeleteAttributionProducerManagementBasedIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAttributionProducerManagementBasedIncentiveMutation = { __typename?: 'Mutation', deleteAttributionProducerManagementBasedIncentive: { __typename?: 'AttributionDeleteIncentiveResponse', success: boolean } };

export type BulkDeleteAttributionProducerManagementBasedIncentivesMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type BulkDeleteAttributionProducerManagementBasedIncentivesMutation = { __typename?: 'Mutation', bulkDeleteAttributionProducerManagementBasedIncentives: { __typename?: 'AttributionBulkDeleteIncentivesResponse', success: boolean, deletedCount: number } };

export type CreateAttributionArmIncentiveMutationVariables = Exact<{
  input: Scalars['JSONObject'];
}>;


export type CreateAttributionArmIncentiveMutation = { __typename?: 'Mutation', createAttributionArmIncentive: { __typename?: 'AttributionArmIncentiveParameterResponse', incentive: { __typename?: 'AttributionArmIncentiveParameter', id: string, armEmails: Array<string>, startDate: any, endDate: any, renewalBaseRate: number, newBusinessBaseRate: number, agencyGraduationThreshold: number, agencyGraduationBonusRate: number, previousYearEstimatedRevenue?: number | null, previousYearEstimatedVariable?: number | null, updatedByEmail: string, createdAt: any, updatedAt: any, kickerTiers: Array<{ __typename?: 'AttributionKickerTier', targetAchievementPercent: number, kickerRate: number }> } } };

export type UpdateAttributionArmIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
  input: Scalars['JSONObject'];
}>;


export type UpdateAttributionArmIncentiveMutation = { __typename?: 'Mutation', updateAttributionArmIncentive: { __typename?: 'AttributionArmIncentiveParameterResponse', incentive: { __typename?: 'AttributionArmIncentiveParameter', id: string, armEmails: Array<string>, startDate: any, endDate: any, renewalBaseRate: number, newBusinessBaseRate: number, agencyGraduationThreshold: number, agencyGraduationBonusRate: number, previousYearEstimatedRevenue?: number | null, previousYearEstimatedVariable?: number | null, updatedByEmail: string, createdAt: any, updatedAt: any, kickerTiers: Array<{ __typename?: 'AttributionKickerTier', targetAchievementPercent: number, kickerRate: number }> } } };

export type DeleteAttributionArmIncentiveMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteAttributionArmIncentiveMutation = { __typename?: 'Mutation', deleteAttributionArmIncentive: { __typename?: 'AttributionDeleteIncentiveResponse', success: boolean } };

export type UpsertAttributionProducerLabelMutationVariables = Exact<{
  input: UpsertAttributionProducerLabelInput;
}>;


export type UpsertAttributionProducerLabelMutation = { __typename?: 'Mutation', upsertAttributionProducerLabel: { __typename?: 'AttributionProducerLabel', producerEmail: string, label: string, updatedByEmail: string, updatedAt: any } };

export type DeleteAttributionProducerLabelMutationVariables = Exact<{
  producerEmail: Scalars['String'];
}>;


export type DeleteAttributionProducerLabelMutation = { __typename?: 'Mutation', deleteAttributionProducerLabel: boolean };

export type EditAttributionEndorsementReassignmentMutationVariables = Exact<{
  input: EditAttributionEndorsementReassignmentInput;
}>;


export type EditAttributionEndorsementReassignmentMutation = { __typename?: 'Mutation', editAttributionEndorsementReassignment: { __typename?: 'AttributionReassignmentMutationResponse', success: boolean, message: string, count?: number | null } };

export type BulkEditAttributionEndorsementReassignmentsMutationVariables = Exact<{
  input: BulkEditAttributionEndorsementReassignmentsInput;
}>;


export type BulkEditAttributionEndorsementReassignmentsMutation = { __typename?: 'Mutation', bulkEditAttributionEndorsementReassignments: { __typename?: 'AttributionReassignmentMutationResponse', success: boolean, message: string, count?: number | null } };

export type UpsertAttributionProducerRevenueTargetsMutationVariables = Exact<{
  input: UpsertAttributionProducerRevenueTargetsInput;
}>;


export type UpsertAttributionProducerRevenueTargetsMutation = { __typename?: 'Mutation', upsertAttributionProducerRevenueTargets: { __typename?: 'AttributionRevenueTargetsResponse', targets: Array<{ __typename?: 'AttributionMonthlyRevenueTarget', id: string, producerEmail: string, year: number, month: number, revenueTarget: number, updatedByEmail: string, createdAt: any, updatedAt: any }> } };

export type UpsertAttributionArmRevenueTargetsMutationVariables = Exact<{
  input: UpsertAttributionArmRevenueTargetsInput;
}>;


export type UpsertAttributionArmRevenueTargetsMutation = { __typename?: 'Mutation', upsertAttributionArmRevenueTargets: { __typename?: 'AttributionRevenueTargetsResponse', targets: Array<{ __typename?: 'AttributionMonthlyRevenueTarget', id: string, producerEmail: string, year: number, month: number, revenueTarget: number, updatedByEmail: string, createdAt: any, updatedAt: any }> } };

export type DeleteAttributionProducerRevenueTargetsMutationVariables = Exact<{
  producerEmail: Scalars['String'];
  year: Scalars['Int'];
}>;


export type DeleteAttributionProducerRevenueTargetsMutation = { __typename?: 'Mutation', deleteAttributionProducerRevenueTargets: { __typename?: 'DeleteAttributionRevenueTargetsResponse', success: boolean, deletedCount: number } };

export type DeleteAttributionArmRevenueTargetsMutationVariables = Exact<{
  armEmail: Scalars['String'];
  year: Scalars['Int'];
}>;


export type DeleteAttributionArmRevenueTargetsMutation = { __typename?: 'Mutation', deleteAttributionArmRevenueTargets: { __typename?: 'DeleteAttributionRevenueTargetsResponse', success: boolean, deletedCount: number } };

export type BatchAddLabelToInboxConversationsMutationVariables = Exact<{
  input: BatchAddLabelToConversationsInput;
}>;


export type BatchAddLabelToInboxConversationsMutation = { __typename?: 'Mutation', batchAddLabelToInboxConversations: Array<{ __typename?: 'Conversation', teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, internalParticipantEmails: Array<string>, lastMessageFrom?: string | null, id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, sourceReason: ConversationWakeUpSourceReason, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> }> };

export type BatchDeleteInboxConversationsMutationVariables = Exact<{
  input: BatchDeleteConversationsInput;
}>;


export type BatchDeleteInboxConversationsMutation = { __typename?: 'Mutation', batchDeleteInboxConversations: { __typename?: 'BatchDeleteConversationsOutput', count: number } };

export type BatchDeleteInboxDraftsMutationVariables = Exact<{
  input: BatchDeleteDraftsInputDto;
}>;


export type BatchDeleteInboxDraftsMutation = { __typename?: 'Mutation', batchDeleteInboxDrafts: { __typename?: 'BatchDeleteDraftsOutputDto', count: number } };

export type BatchRemoveLabelFromInboxConversationsMutationVariables = Exact<{
  input: BatchRemoveLabelFromConversationsInput;
}>;


export type BatchRemoveLabelFromInboxConversationsMutation = { __typename?: 'Mutation', batchRemoveLabelFromInboxConversations: Array<{ __typename?: 'Conversation', teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, internalParticipantEmails: Array<string>, lastMessageFrom?: string | null, id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, sourceReason: ConversationWakeUpSourceReason, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> }> };

export type BindQuoteMutationVariables = Exact<{
  input: BindQuoteInput;
}>;


export type BindQuoteMutation = { __typename?: 'Mutation', bindQuote: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type BrokerCreateAgentActionMutationVariables = Exact<{
  input: BrokerCreateAgentAction;
}>;


export type BrokerCreateAgentActionMutation = { __typename?: 'Mutation', brokerCreateAgentAction: { __typename?: 'AgentAction', id: string & { __scalar: "UUID" } } };

export type ClearInspectionOrderedElsewhereMutationVariables = Exact<{
  inspectionOrderId: Scalars['ID'];
}>;


export type ClearInspectionOrderedElsewhereMutation = { __typename?: 'Mutation', clearInspectionOrderedElsewhere: { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> } };

export type CompleteAgentActionMutationVariables = Exact<{
  input: CompleteAgentActionInput;
}>;


export type CompleteAgentActionMutation = { __typename?: 'Mutation', completeAgentAction: { __typename?: 'AgentAction', id: string & { __scalar: "UUID" } } };

export type CreateBindHqMarketingCompanyMutationVariables = Exact<{
  input: CreateMarketingCompanyInput;
}>;


export type CreateBindHqMarketingCompanyMutation = { __typename?: 'Mutation', createBindHqMarketingCompany: { __typename?: 'BindHqMarketingCompany', id: string, name: string } };

export type CreateCarrierContactMutationVariables = Exact<{
  input: CreateCarrierContactInput;
}>;


export type CreateCarrierContactMutation = { __typename?: 'Mutation', createCarrierContact: { __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null } };

export type CreateChatSessionMutationVariables = Exact<{
  input?: InputMaybe<CreateChatSessionInput>;
}>;


export type CreateChatSessionMutation = { __typename?: 'Mutation', createChatSession: { __typename?: 'ChatSession', id: string, title?: string | null, status?: ChatSessionStatus | null, userId: string, viewerCanSendMessages: boolean, createdAt: any, updatedAt?: any | null, lastMessageAt?: any | null, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, messages: Array<{ __typename?: 'ChatMessage', id: string, externalMessageId?: string | null, sessionId: string, parts: string, role: string, status: string, createdAt: any, isElicitation: boolean, elicitationResolvedBy?: string | null, frameId?: string | null }>, metadata: Array<{ __typename?: 'ChatSessionMetadataEntry', key: string, value: string }> } };

export type CreateClientDataMutationVariables = Exact<{
  input: CreateClientDataInput;
}>;


export type CreateClientDataMutation = { __typename?: 'Mutation', createClientData: Array<{ __typename?: 'ClientData', id: string, insuredId: string, index?: number | null, key: string, value: string, source?: string | null }> };

export type CreateClientDataPdfMutationVariables = Exact<{
  input: CreateClientDataPdfInput;
}>;


export type CreateClientDataPdfMutation = { __typename?: 'Mutation', createClientDataPDF: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } } };

export type CreateEmailDraftMutationVariables = Exact<{
  input: CreateEmailDraftInput;
}>;


export type CreateEmailDraftMutation = { __typename?: 'Mutation', createEmailDraft: string };

export type CreateEmailTemplateDraftMutationVariables = Exact<{
  input: CreateEmailTemplateDraftInput;
}>;


export type CreateEmailTemplateDraftMutation = { __typename?: 'Mutation', createEmailTemplateDraft: string };

export type CreateInboxDraftMutationVariables = Exact<{
  input: CreateDraftMessageInputDto;
}>;


export type CreateInboxDraftMutation = { __typename?: 'Mutation', createInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type CreateInboxForwardDraftMutationVariables = Exact<{
  input: CreateForwardDraftInputDto;
}>;


export type CreateInboxForwardDraftMutation = { __typename?: 'Mutation', createInboxForwardDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type CreateInboxLabelMutationVariables = Exact<{
  input: CreateEmailLabelInput;
}>;


export type CreateInboxLabelMutation = { __typename?: 'Mutation', createInboxLabel: { __typename?: 'EmailLabel', externalId: string, name: string, type?: string | null } };

export type CreateInboxMessageClassificationMutationVariables = Exact<{
  input: CreateMessageClassificationInput;
}>;


export type CreateInboxMessageClassificationMutation = { __typename?: 'Mutation', createInboxMessageClassification: { __typename?: 'MessageClassification', id: string, label: string, description: string, autoRunPlaybook: boolean, source: MessageClassificationSource } };

export type CreateInboxReplyDraftMutationVariables = Exact<{
  input: CreateReplyDraftInputDto;
}>;


export type CreateInboxReplyDraftMutation = { __typename?: 'Mutation', createInboxReplyDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type CreateInsuredMutationVariables = Exact<{
  input: CreateInsuredInput;
}>;


export type CreateInsuredMutation = { __typename?: 'Mutation', createInsured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } };

export type CreateInsuredAndAgentMutationVariables = Exact<{
  input: CreateInsuredAndAgentInput;
}>;


export type CreateInsuredAndAgentMutation = { __typename?: 'Mutation', createInsuredAndAgent: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } };

export type CreateOpportunityMutationVariables = Exact<{
  input: CreateOpportunityInput;
}>;


export type CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" } } };

export type CreateOpportunityNoteMutationVariables = Exact<{
  input: CreateOpportunityNoteInput;
}>;


export type CreateOpportunityNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'OpportunityNote', id: string } };

export type CreatePlaybookMutationVariables = Exact<{
  input: CreatePlaybookInput;
}>;


export type CreatePlaybookMutation = { __typename?: 'Mutation', createPlaybook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, updatedAt?: any | null } };

export type CreatePlaybookSetMutationVariables = Exact<{
  input: CreatePlaybookSetInput;
}>;


export type CreatePlaybookSetMutation = { __typename?: 'Mutation', createPlaybookSet: { __typename?: 'PlaybookSet', id: string, name: string, description?: string | null, playbookCount: number, isSubscribed: boolean } };

export type CreateProcessedBinderMutationVariables = Exact<{
  input: CreateProcessedBinderInput;
}>;


export type CreateProcessedBinderMutation = { __typename?: 'Mutation', createProcessedBinder: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type CreateProcessedQuotePdfMutationVariables = Exact<{
  input: CreateProcessedQuoteInput;
}>;


export type CreateProcessedQuotePdfMutation = { __typename?: 'Mutation', createProcessedQuotePDF: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string, name: string, workflow: string, updatedAt?: any | null } };

export type CreateRenewalMutationVariables = Exact<{
  input: CreateRenewalInput;
}>;


export type CreateRenewalMutation = { __typename?: 'Mutation', createRenewal: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" } } };

export type CreateStampedPolicyMutationVariables = Exact<{
  input: CreateStampedPolicyInput;
}>;


export type CreateStampedPolicyMutation = { __typename?: 'Mutation', createStampedPolicy: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type CreateSubmissionMarketSummaryNoteMutationVariables = Exact<{
  input: CreateSubmissionMarketSummaryNoteInput;
}>;


export type CreateSubmissionMarketSummaryNoteMutation = { __typename?: 'Mutation', createSubmissionMarketSummaryNote: { __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" } } };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createFileTag: { __typename?: 'FileTag', label: string, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null } };

export type DeactivateAgentMutationVariables = Exact<{
  input: DeactivateAgentInput;
}>;


export type DeactivateAgentMutation = { __typename?: 'Mutation', deactivateAgent: number };

export type DeactivateUserAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateUserAccountMutation = { __typename?: 'Mutation', deactivateUser: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type DeleteAgentActionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAgentActionMutation = { __typename?: 'Mutation', deleteAgentAction: { __typename?: 'AgentAction', id: string & { __scalar: "UUID" } } };

export type DeleteCarrierContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type DeleteCarrierContractMutation = { __typename?: 'Mutation', deleteCarrierContract: boolean };

export type DeleteClientDataRowMutationVariables = Exact<{
  input: DeleteClientDataInput;
}>;


export type DeleteClientDataRowMutation = { __typename?: 'Mutation', deleteClientDataRow: { __typename?: 'ClientData', id: string, insuredId: string, index?: number | null, key: string, value: string, source?: string | null } };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } } };

export type DeleteInboxConversationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInboxConversationMutation = { __typename?: 'Mutation', deleteInboxConversation?: { __typename?: 'Conversation', id: string } | null };

export type DeleteInboxDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInboxDraftMutation = { __typename?: 'Mutation', deleteInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type DeleteInboxMessageClassificationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteInboxMessageClassificationMutation = { __typename?: 'Mutation', deleteInboxMessageClassification: boolean };

export type DeleteInsuredMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInsuredMutation = { __typename?: 'Mutation', deleteInsured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } | null };

export type DeleteOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOpportunityMutation = { __typename?: 'Mutation', deleteOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" } } };

export type DeletePlaybookMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeletePlaybookMutation = { __typename?: 'Mutation', deletePlaybook: boolean };

export type DeletePlaybookSetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePlaybookSetMutation = { __typename?: 'Mutation', deletePlaybookSet: boolean };

export type DeletePlaybookTriggerMutationVariables = Exact<{
  eventType: Scalars['String'];
  playbookId?: InputMaybe<Scalars['String']>;
  triggerConfig?: InputMaybe<Scalars['JSONObject']>;
}>;


export type DeletePlaybookTriggerMutation = { __typename?: 'Mutation', deletePlaybookTrigger: boolean };

export type DeletePlaybookTriggerByIdMutationVariables = Exact<{
  triggerId: Scalars['ID'];
}>;


export type DeletePlaybookTriggerByIdMutation = { __typename?: 'Mutation', deletePlaybookTriggerById: boolean };

export type DeleteFileTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;


export type DeleteFileTagMutation = { __typename?: 'Mutation', deleteFileTag: { __typename?: 'FileTag', label: string } };

export type DeliverBinderMutationVariables = Exact<{
  input: IssuePolicyInput;
}>;


export type DeliverBinderMutation = { __typename?: 'Mutation', deliverBinder: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type DisableAssignmentsForBrokerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisableAssignmentsForBrokerMutation = { __typename?: 'Mutation', disableAssignmentsForBroker: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type DismissAttentionItemMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DismissAttentionItemMutation = { __typename?: 'Mutation', dismissAttentionItem: { __typename?: 'DismissAttentionItemResult', id: string, success: boolean } };

export type EditVaveQuoteMutationVariables = Exact<{
  input: EditVaveQuoteInput;
}>;


export type EditVaveQuoteMutation = { __typename?: 'Mutation', edit: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type EnableAssignmentsForBrokerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EnableAssignmentsForBrokerMutation = { __typename?: 'Mutation', enableAssignmentsForBroker: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type ForgotPasswordMutationVariables = Exact<{
  authClientId: Scalars['String'];
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ImpersonateUserMutationVariables = Exact<{
  authClientId: Scalars['String'];
  userIdToImpersonate?: InputMaybe<Scalars['String']>;
  emailToImpersonate?: InputMaybe<Scalars['String']>;
}>;


export type ImpersonateUserMutation = { __typename?: 'Mutation', impersonateUser: { __typename?: 'ImpersonationAuth', accessToken: string, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, roles: Array<Roles>, agency: { __typename?: 'Agency', id: string, name: string } } | null } };

export type ImportPlaybookFromUserMutationVariables = Exact<{
  playbookId: Scalars['String'];
}>;


export type ImportPlaybookFromUserMutation = { __typename?: 'Mutation', importPlaybookFromUser: { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> } };

export type IssuePolicyMutationVariables = Exact<{
  input: IssuePolicyInput;
}>;


export type IssuePolicyMutation = { __typename?: 'Mutation', issuePolicy: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type IssuePolicyInBindHqMutationVariables = Exact<{
  policyId: Scalars['ID'];
}>;


export type IssuePolicyInBindHqMutation = { __typename?: 'Mutation', issuePolicyInBindHq: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type LinkConversationToInsuredMutationVariables = Exact<{
  input: LinkConversationToInsuredInput;
}>;


export type LinkConversationToInsuredMutation = { __typename?: 'Mutation', linkConversationToInsured?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insuredLinkRedirect?: { __typename?: 'InsuredLinkRedirect', insuredId: string & { __scalar: "UUID" }, name: string, mergedAt?: any | null, depth: number, survivorName: string, message: string } | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type LinkConversationToOpportunityMutationVariables = Exact<{
  input: LinkConversationToOpportunityInput;
}>;


export type LinkConversationToOpportunityMutation = { __typename?: 'Mutation', linkConversationToOpportunity?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type LinkConversationToSubmissionMutationVariables = Exact<{
  input: LinkConversationToSubmissionInput;
}>;


export type LinkConversationToSubmissionMutation = { __typename?: 'Mutation', linkConversationToSubmission?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type LoginEmailPasswordMutationVariables = Exact<{
  authClientId: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginEmailPasswordMutation = { __typename?: 'Mutation', loginEmailPassword: { __typename?: 'Auth', token: { __typename?: 'AuthToken', accessToken: string, refreshToken: string }, user: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, roles: Array<Roles>, agency: { __typename?: 'Agency', id: string, name: string } } } };

export type LoginIdentityProviderMutationVariables = Exact<{
  authClientId: Scalars['String'];
  provider: KnownIdentityProviders;
  providerJwt: Scalars['String'];
}>;


export type LoginIdentityProviderMutation = { __typename?: 'Mutation', loginIdentityProvider: { __typename?: 'Auth', token: { __typename?: 'AuthToken', accessToken: string, refreshToken: string }, user: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, roles: Array<Roles>, agency: { __typename?: 'Agency', id: string, name: string } } } };

export type LogoutMutationVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ManualAssignOpportunityMutationVariables = Exact<{
  input: ManualAssignOpportunityDto;
}>;


export type ManualAssignOpportunityMutation = { __typename?: 'Mutation', manualAssignOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } } | null } };

export type MarkAlbyUpdatesSeenMutationVariables = Exact<{
  opportunityId: Scalars['String'];
}>;


export type MarkAlbyUpdatesSeenMutation = { __typename?: 'Mutation', markAlbyUpdatesSeen: number };

export type MarkConversationWakeUpFollowedUpMutationVariables = Exact<{
  wakeUpId: Scalars['UUID'];
}>;


export type MarkConversationWakeUpFollowedUpMutation = { __typename?: 'Mutation', markConversationWakeUpFollowedUp: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } };

export type MarkRenewalNotesAsReadMutationVariables = Exact<{
  input: MarkRenewalNotesReadInput;
}>;


export type MarkRenewalNotesAsReadMutation = { __typename?: 'Mutation', markRenewalNotesAsRead: Array<{ __typename?: 'RenewalNote', id: string, text: string, updatedAt: any, isRead: boolean, author: { __typename?: 'RenewalNoteAuthor', id: string, firstName: string, lastName: string } }> };

export type MergeInsuredMutationVariables = Exact<{
  input: MergeInsuredInput;
}>;


export type MergeInsuredMutation = { __typename?: 'Mutation', mergeInsured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } };

export type MergeFileTagsMutationVariables = Exact<{
  input: MergeTagsInput;
}>;


export type MergeFileTagsMutation = { __typename?: 'Mutation', mergeFileTags: { __typename?: 'FileTag', label: string, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null, childTags?: Array<{ __typename?: 'FileTag', label: string }> | null } };

export type OfferVaveQuoteMutationVariables = Exact<{
  submissionId: Scalars['String'];
}>;


export type OfferVaveQuoteMutation = { __typename?: 'Mutation', offer: { __typename?: 'VaveQuote', id: string, quoteId?: string | null } };

export type PasswordResetMutationVariables = Exact<{
  changePasswordId: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', passwordReset: boolean };

export type PlaceInspectionOrderMutationVariables = Exact<{
  inspectionOrderId: Scalars['ID'];
  expectedUpdatedAt: Scalars['DateTime'];
}>;


export type PlaceInspectionOrderMutation = { __typename?: 'Mutation', placeInspectionOrder: { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> } };

export type PriceNewVaveQuoteMutationVariables = Exact<{
  input: CreateVaveQuoteInput;
}>;


export type PriceNewVaveQuoteMutation = { __typename?: 'Mutation', priceNew: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type ReassignOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReassignOpportunityMutation = { __typename?: 'Mutation', reassignOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, isTest: boolean, insuredId: string & { __scalar: "UUID" }, splitOf?: string | null, splitOfInsuredId?: string | null, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, renewalOfPolicies: Array<string>, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } } | null, collaborators: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProductId: string, state: SubmissionState, createdAt: any, indicationPremium?: string & { __scalar: "Decimal" } | null, appetiteProduct: { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null }>, marketSummaryNotes: Array<{ __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> }>, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }, secondaryAgents: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }> } } };

export type ReconcileInspectionOrderMutationVariables = Exact<{
  inspectionOrderId: Scalars['ID'];
}>;


export type ReconcileInspectionOrderMutation = { __typename?: 'Mutation', reconcileInspectionOrder: { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> } };

export type RecordSubmissionIndicationMutationVariables = Exact<{
  input: RecordSubmissionIndicationInput;
}>;


export type RecordSubmissionIndicationMutation = { __typename?: 'Mutation', recordSubmissionIndication: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProductId: string, state: SubmissionState, createdAt: any, indicationPremium?: string & { __scalar: "Decimal" } | null, appetiteProduct: { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null }>, marketSummaryNotes: Array<{ __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> } };

export type RecoverStrandedRecordsMutationVariables = Exact<{
  survivorId: Scalars['UUID'];
  previewHash: Scalars['String'];
}>;


export type RecoverStrandedRecordsMutation = { __typename?: 'Mutation', recoverStrandedRecords: { __typename?: 'InsuredRecoveryCounts', conversations: number, drafts: number, opportunities: number, files: number, gmailThreads: number } };

export type RefreshInboxMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshInboxMutation = { __typename?: 'Mutation', refreshInbox: { __typename?: 'InboxRefreshResult', changeCount: number, initialized: boolean, startedWorkflowCount: number } };

export type RefreshTokenMutationVariables = Exact<{
  token: AuthTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'AuthToken', accessToken: string, refreshToken: string } };

export type RegenerateProcessedPdfMutationVariables = Exact<{
  vaveQuoteId: Scalars['String'];
}>;


export type RegenerateProcessedPdfMutation = { __typename?: 'Mutation', regenerateProcessedPdf: { __typename?: 'VaveQuote', id: string } };

export type RemoveAssignmentGroupFromBrokerMutationVariables = Exact<{
  input: RemoveAssignmentGroupFromBrokerDto;
}>;


export type RemoveAssignmentGroupFromBrokerMutation = { __typename?: 'Mutation', removeAssignmentGroupFromBroker: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type RemoveAttachmentFromInboxDraftMutationVariables = Exact<{
  input: RemoveAttachmentFromDraftInputDto;
}>;


export type RemoveAttachmentFromInboxDraftMutation = { __typename?: 'Mutation', removeAttachmentFromInboxDraft: { __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } } };

export type RemoveCarrierContactFromAppetiteProductMutationVariables = Exact<{
  input: CarrierContactConnectorInput;
}>;


export type RemoveCarrierContactFromAppetiteProductMutation = { __typename?: 'Mutation', removeCarrierContactFromAppetiteProduct: { __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null } };

export type RemoveInboxConversationLabelMutationVariables = Exact<{
  input: RemoveConversationLabelInput;
}>;


export type RemoveInboxConversationLabelMutation = { __typename?: 'Mutation', removeInboxConversationLabel?: { __typename?: 'Conversation', teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, internalParticipantEmails: Array<string>, lastMessageFrom?: string | null, id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, sourceReason: ConversationWakeUpSourceReason, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> } | null };

export type RemovePlaybookFromSetMutationVariables = Exact<{
  playbookId: Scalars['String'];
  setId: Scalars['ID'];
}>;


export type RemovePlaybookFromSetMutation = { __typename?: 'Mutation', removePlaybookFromSet: boolean };

export type ReplaceMarketingPlanSubmissionsMutationVariables = Exact<{
  input: ReplaceMarketingPlanSubmissionsInput;
}>;


export type ReplaceMarketingPlanSubmissionsMutation = { __typename?: 'Mutation', replaceMarketingPlanSubmissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" } }> };

export type RescheduleSendInboxDraftMutationVariables = Exact<{
  input: RescheduleSendDraftInputDto;
}>;


export type RescheduleSendInboxDraftMutation = { __typename?: 'Mutation', rescheduleSendInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type ResendVaveBindRequestMutationVariables = Exact<{
  vaveQuoteId: Scalars['String'];
}>;


export type ResendVaveBindRequestMutation = { __typename?: 'Mutation', resendBindRequest: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type RetryContractExtractionMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type RetryContractExtractionMutation = { __typename?: 'Mutation', retryContractExtraction: { __typename?: 'CarrierContract', id: string, extractionStatus: CarrierContractExtractionStatus } };

export type RetryInsuredMergeDriveMutationVariables = Exact<{
  eventId: Scalars['String'];
}>;


export type RetryInsuredMergeDriveMutation = { __typename?: 'Mutation', retryInsuredMergeDrive: boolean };

export type SaveQuoteChangesMutationVariables = Exact<{
  input: SaveVaveQuoteChangesInput;
}>;


export type SaveQuoteChangesMutation = { __typename?: 'Mutation', saveQuoteChanges: { __typename?: 'Quote', id: string & { __scalar: "UUID" } } };

export type ScheduleSendInboxDraftMutationVariables = Exact<{
  input: ScheduleSendDraftInputDto;
}>;


export type ScheduleSendInboxDraftMutation = { __typename?: 'Mutation', scheduleSendInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type SelectOpportunityCoveragesMutationVariables = Exact<{
  input: OpportunitySelectCoveragesInput;
}>;


export type SelectOpportunityCoveragesMutation = { __typename?: 'Mutation', selectOpportunityCoverages: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" } } };

export type SendBindRequestMutationVariables = Exact<{
  input: SendBindRequestInput;
}>;


export type SendBindRequestMutation = { __typename?: 'Mutation', sendBindRequest: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type SendInboxDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SendInboxDraftMutation = { __typename?: 'Mutation', sendInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type SendQuoteEmailMutationVariables = Exact<{
  input: SendQuoteInput;
}>;


export type SendQuoteEmailMutation = { __typename?: 'Mutation', sendQuote: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type SendSubmissionToCarrierMutationVariables = Exact<{
  input: SendSubmissionToCarrierInput;
}>;


export type SendSubmissionToCarrierMutation = { __typename?: 'Mutation', sendSubmissionToCarrier: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProductId: string, bindHqApplicationId?: string | null, state: SubmissionState, createdAt: any, updatedAt?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> } };

export type SetInboxMessageClassificationMutationVariables = Exact<{
  input: SetMessageClassificationInput;
}>;


export type SetInboxMessageClassificationMutation = { __typename?: 'Mutation', setInboxMessageClassification: { __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type SetInspectionOrderedElsewhereMutationVariables = Exact<{
  input: SetInspectionOrderedElsewhereInput;
}>;


export type SetInspectionOrderedElsewhereMutation = { __typename?: 'Mutation', setInspectionOrderedElsewhere: { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> } };

export type SetOpportunityCollaboratorsMutationVariables = Exact<{
  input: SetOpportunityCollaboratorsInput;
}>;


export type SetOpportunityCollaboratorsMutation = { __typename?: 'Mutation', setOpportunityCollaborators: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, collaborators: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }> } };

export type SetPlaybookTriggerMutationVariables = Exact<{
  input: SetPlaybookTriggerInput;
}>;


export type SetPlaybookTriggerMutation = { __typename?: 'Mutation', setPlaybookTrigger: { __typename?: 'PlaybookTrigger', id: string, userId: string, playbookId: string, eventType: string, triggerConfig?: any | null, lastFiredOn?: any | null, createdAt: any, updatedAt?: any | null, playbook: { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> } } };

export type SetViewerInboxThreadReadStateMutationVariables = Exact<{
  input: SetViewerThreadReadStateInput;
}>;


export type SetViewerInboxThreadReadStateMutation = { __typename?: 'Mutation', setViewerInboxThreadReadState: boolean };

export type SnoozeOpportunityMutationVariables = Exact<{
  input: SnoozeOpportunityInput;
}>;


export type SnoozeOpportunityMutation = { __typename?: 'Mutation', snoozeOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, snoozeUntil?: any | null } };

export type StopImpersonatingUserMutationVariables = Exact<{
  authClientId: Scalars['String'];
  impersonatorEmail: Scalars['String'];
}>;


export type StopImpersonatingUserMutation = { __typename?: 'Mutation', stopImpersonatingUser: { __typename?: 'Auth', token: { __typename?: 'AuthToken', accessToken: string, refreshToken: string }, user: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, roles: Array<Roles>, agency: { __typename?: 'Agency', id: string, name: string } } } };

export type SubscribeToPlaybookMutationVariables = Exact<{
  playbookId: Scalars['String'];
}>;


export type SubscribeToPlaybookMutation = { __typename?: 'Mutation', subscribeToPlaybook: boolean };

export type SubscribeToPlaybookSetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubscribeToPlaybookSetMutation = { __typename?: 'Mutation', subscribeToPlaybookSet: boolean };

export type SyncBindHqAgenciesAndAgentsMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncBindHqAgenciesAndAgentsMutation = { __typename?: 'Mutation', syncBindHqAgenciesAndAgents: boolean };

export type SyncBindHqAgencyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SyncBindHqAgencyMutation = { __typename?: 'Mutation', syncBindHqAgency: boolean };

export type SyncBindHqAgentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SyncBindHqAgentMutation = { __typename?: 'Mutation', syncBindHqAgent: boolean };

export type SyncInboxDraftToExternalDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SyncInboxDraftToExternalDraftMutation = { __typename?: 'Mutation', syncInboxDraftToExternalDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, description?: string | null, createdAt: any, updatedAt?: any | null } };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, description?: string | null, createdAt: any, updatedAt?: any | null } };

export type DeleteTeamMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: { __typename?: 'Team', id: string } };

export type AddTeamMemberMutationVariables = Exact<{
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type AddTeamMemberMutation = { __typename?: 'Mutation', addTeamMember: { __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" } }> } };

export type RemoveTeamMemberMutationVariables = Exact<{
  teamId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type RemoveTeamMemberMutation = { __typename?: 'Mutation', removeTeamMember: { __typename?: 'Team', id: string, name: string, members: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" } }> } };

export type TransitionMarketingPlanMutationVariables = Exact<{
  input: TransitionMarketingPlanInput;
}>;


export type TransitionMarketingPlanMutation = { __typename?: 'Mutation', transitionMarketingPlan: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" } } };

export type TransitionPolicyMutationVariables = Exact<{
  input: TransitionPolicyInput;
}>;


export type TransitionPolicyMutation = { __typename?: 'Mutation', transitionPolicy: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type TransitionQuoteMutationVariables = Exact<{
  input: TransitionQuoteInput;
}>;


export type TransitionQuoteMutation = { __typename?: 'Mutation', transitionQuote: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type TransitionSubmissionMutationVariables = Exact<{
  input: TransitionSubmissionInput;
}>;


export type TransitionSubmissionMutation = { __typename?: 'Mutation', transitionSubmission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProductId: string, state: SubmissionState, createdAt: any, indicationPremium?: string & { __scalar: "Decimal" } | null, appetiteProduct: { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null }>, marketSummaryNotes: Array<{ __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> } };

export type TriggerPolicyExpirationCheckMutationVariables = Exact<{ [key: string]: never; }>;


export type TriggerPolicyExpirationCheckMutation = { __typename?: 'Mutation', triggerPolicyExpirationCheck: boolean };

export type UncompleteAgentActionMutationVariables = Exact<{
  input: CompleteAgentActionInput;
}>;


export type UncompleteAgentActionMutation = { __typename?: 'Mutation', uncompleteAgentAction: { __typename?: 'AgentAction', id: string & { __scalar: "UUID" } } };

export type UndeleteOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UndeleteOpportunityMutation = { __typename?: 'Mutation', undeleteOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, deletedAt?: any | null } };

export type UnlinkConversationFromInsuredMutationVariables = Exact<{
  input: UnlinkConversationFromInsuredInput;
}>;


export type UnlinkConversationFromInsuredMutation = { __typename?: 'Mutation', unlinkConversationFromInsured?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type UnlinkConversationFromOpportunityMutationVariables = Exact<{
  input: UnlinkConversationFromOpportunityInput;
}>;


export type UnlinkConversationFromOpportunityMutation = { __typename?: 'Mutation', unlinkConversationFromOpportunity?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type UnlinkConversationFromSubmissionMutationVariables = Exact<{
  input: UnlinkConversationFromSubmissionInput;
}>;


export type UnlinkConversationFromSubmissionMutation = { __typename?: 'Mutation', unlinkConversationFromSubmission?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type UnscheduleSendInboxDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnscheduleSendInboxDraftMutation = { __typename?: 'Mutation', unscheduleSendInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type UnsubscribeFromPlaybookMutationVariables = Exact<{
  playbookId: Scalars['String'];
}>;


export type UnsubscribeFromPlaybookMutation = { __typename?: 'Mutation', unsubscribeFromPlaybook: boolean };

export type UnsubscribeFromPlaybookSetMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnsubscribeFromPlaybookSetMutation = { __typename?: 'Mutation', unsubscribeFromPlaybookSet: boolean };

export type UpdateAgencyMutationVariables = Exact<{
  input: UpdateAgencyInput;
}>;


export type UpdateAgencyMutation = { __typename?: 'Mutation', updateAgency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean, defaultSecondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> } };

export type UpdateAgencyDefaultSecondaryAgentsMutationVariables = Exact<{
  input: UpdateAgencyInput;
}>;


export type UpdateAgencyDefaultSecondaryAgentsMutation = { __typename?: 'Mutation', updateAgency: { __typename?: 'Agency', id: string, defaultSecondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> } };

export type UpdateAgencyOwnerMutationVariables = Exact<{
  input: UpdateAgencyInput;
}>;


export type UpdateAgencyOwnerMutation = { __typename?: 'Mutation', updateAgency: { __typename?: 'Agency', id: string, name: string, isTest: boolean, isPrivate: boolean, owner?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null } };

export type UpdateAppetiteProductMutationVariables = Exact<{
  input: UpdateAppetiteProductInput;
}>;


export type UpdateAppetiteProductMutation = { __typename?: 'Mutation', updateAppetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } };

export type UpdateBindHqAgencyMutationVariables = Exact<{
  input: UpdateBindHqAgencyInput;
}>;


export type UpdateBindHqAgencyMutation = { __typename?: 'Mutation', updateBindHqAgency: { __typename?: 'BindHqAgency', id: string, name: string, phone?: string | null, email?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, okToBind: boolean } };

export type UpdateCarrierMutationVariables = Exact<{
  input: UpdateCarrierInput;
}>;


export type UpdateCarrierMutation = { __typename?: 'Mutation', updateCarrier: { __typename?: 'Carrier', id: string, url?: string | null, portalUrl?: string | null, qwAppointed: boolean, phone?: string | null, fax?: string | null, email?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null } };

export type UpdateCarrierContactMutationVariables = Exact<{
  input: UpdateCarrierContactInput;
}>;


export type UpdateCarrierContactMutation = { __typename?: 'Mutation', updateCarrierContact: { __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null } };

export type UpdateCommentMutationVariables = Exact<{
  input: UpdateCommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } } };

export type UpdateFileUploadTagsMutationVariables = Exact<{
  input: UpdateFileUploadTagInput;
}>;


export type UpdateFileUploadTagsMutation = { __typename?: 'Mutation', updateFileUploadTags: { __typename?: 'FileTag', label: string } };

export type UpdateFileUploadMutationVariables = Exact<{
  input: UpdateFileUploadInput;
}>;


export type UpdateFileUploadMutation = { __typename?: 'Mutation', updateFileUpload: { __typename?: 'FileUpload', id: string } };

export type UpdateInboxDraftMutationVariables = Exact<{
  input: UpdateDraftMessageInputDto;
}>;


export type UpdateInboxDraftMutation = { __typename?: 'Mutation', updateInboxDraft: { __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type UpdateInboxMessageClassificationMutationVariables = Exact<{
  input: UpdateMessageClassificationInput;
}>;


export type UpdateInboxMessageClassificationMutation = { __typename?: 'Mutation', updateInboxMessageClassification: { __typename?: 'MessageClassification', id: string, label: string, description: string, autoRunPlaybook: boolean, source: MessageClassificationSource, associatedPlaybookId?: string | null, playbook?: { __typename?: 'Playbook', id: string, name: string } | null } };

export type UpdateInspectionPacketMutationVariables = Exact<{
  input: UpdateInspectionPacketInput;
}>;


export type UpdateInspectionPacketMutation = { __typename?: 'Mutation', updateInspectionPacket: { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> } };

export type UpdateInsuredMutationVariables = Exact<{
  input: UpdateInsuredInput;
}>;


export type UpdateInsuredMutation = { __typename?: 'Mutation', updateInsured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } };

export type UpdateOpportunityMutationVariables = Exact<{
  input: OpportunityUpdateInput;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, desiredEffectiveDate: any } };

export type UpdatePlaybookMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdatePlaybookInput;
}>;


export type UpdatePlaybookMutation = { __typename?: 'Mutation', updatePlaybook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null } };

export type UpdatePlaybookSetMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdatePlaybookSetInput;
}>;


export type UpdatePlaybookSetMutation = { __typename?: 'Mutation', updatePlaybookSet: { __typename?: 'PlaybookSet', id: string, name: string, description?: string | null, playbookCount: number, isSubscribed: boolean } };

export type UpdatePlaybookSetsMutationVariables = Exact<{
  playbookId: Scalars['String'];
  setIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UpdatePlaybookSetsMutation = { __typename?: 'Mutation', updatePlaybookSets: boolean };

export type UpdatePolicyMutationVariables = Exact<{
  input: UpdatePolicyInput;
}>;


export type UpdatePolicyMutation = { __typename?: 'Mutation', updatePolicy: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, userId: string, name: string, workflow: string, createdAt: any, updatedAt?: any | null, enabled: boolean, marketType?: MarketTypes | null, carrierId?: string | null, lineOfBusinessIds?: Array<string> | null, grossCommission?: number | null, carrier?: { __typename?: 'Carrier', id: string, name: string, slug: string } | null, linesOfBusiness?: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> | null, files: Array<{ __typename?: 'ProductFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, submissionCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }>, referenceCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> } };

export type UpdateProductExclusionMutationVariables = Exact<{
  input: ProductExclusionUpdateInput;
}>;


export type UpdateProductExclusionMutation = { __typename?: 'Mutation', productExclusionUpdate: { __typename?: 'ProductExclusion', id: string } };

export type UpdateRenewalNoteMutationVariables = Exact<{
  input: UpdateRenewalNoteInput;
}>;


export type UpdateRenewalNoteMutation = { __typename?: 'Mutation', updateRenewalNote: { __typename?: 'RenewalNote', id: string, text: string, updatedAt: any, isRead: boolean, author: { __typename?: 'RenewalNoteAuthor', id: string, firstName: string, lastName: string } } };

export type UpdateRenewalStatusMutationVariables = Exact<{
  input: UpdateRenewalStatusInput;
}>;


export type UpdateRenewalStatusMutation = { __typename?: 'Mutation', updateRenewalStatus: { __typename?: 'RenewalStatus', status?: string | null, updatedAt: any, latestLog?: { __typename?: 'RenewalStatusLog', id: string, previousStatus?: string | null, newStatus: string, createdAt: any } | null } };

export type UpdateSubmissionMutationVariables = Exact<{
  input: UpdateSubmissionInput;
}>;


export type UpdateSubmissionMutation = { __typename?: 'Mutation', updateSubmission: { __typename?: 'Submission', id: string & { __scalar: "UUID" } } };

export type UpdateFileTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateFileTagMutation = { __typename?: 'Mutation', updateFileTag: { __typename?: 'FileTag', label: string } };

export type UpdateTagsFindAndReplaceMutationVariables = Exact<{
  input: UpdateTagsInput;
}>;


export type UpdateTagsFindAndReplaceMutation = { __typename?: 'Mutation', updateTagsFindAndReplace: Array<{ __typename?: 'FileTag', label: string }> };

export type UpdateTagsParentMutationVariables = Exact<{
  input: UpdateTagsInput;
}>;


export type UpdateTagsParentMutation = { __typename?: 'Mutation', updateTagsParent: Array<{ __typename?: 'FileTag', label: string, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null }> };

export type UpdateUserAccountMutationVariables = Exact<{
  id: Scalars['String'];
  input: UserAccountUpdateInput;
}>;


export type UpdateUserAccountMutation = { __typename?: 'Mutation', updateUserAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type UploadCarrierContractMutationVariables = Exact<{
  input: UploadCarrierContractInput;
}>;


export type UploadCarrierContractMutation = { __typename?: 'Mutation', uploadCarrierContract: { __typename?: 'CarrierContract', id: string, carrierId: string, fileUploadId?: string | null, extractionStatus: CarrierContractExtractionStatus, appetiteProductIds: Array<string>, createdAt: any, fileUpload?: { __typename?: 'FileUpload', id: string, filename: string, mimeType: string, size: number, createdAt: any } | null, incentives: Array<{ __typename?: 'CarrierIncentive', id: string, incentiveType: string, summary: string, details?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, appetiteProductId?: string | null, sortOrder: number }> } };

export type AdminAccountsQueryVariables = Exact<{
  input?: UserAccountFindManyFilter;
}>;


export type AdminAccountsQuery = { __typename?: 'Query', userAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type AgenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type AgenciesQuery = { __typename?: 'Query', agencies: Array<{ __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean }> };

export type AgenciesWithOwnerQueryVariables = Exact<{ [key: string]: never; }>;


export type AgenciesWithOwnerQuery = { __typename?: 'Query', agencies: Array<{ __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean, owner?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null }> };

export type AgencyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AgencyQuery = { __typename?: 'Query', agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean, owner?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null } };

export type AgencyAccountsQueryVariables = Exact<{
  input: UserAccountFindManyFilter;
}>;


export type AgencyAccountsQuery = { __typename?: 'Query', agencyAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type AgencyAffiliationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AgencyAffiliationQuery = { __typename?: 'Query', agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean, affiliations?: Array<{ __typename?: 'AgencyAffiliation', id: string, name: string, shortName?: string | null, logoUrl?: string | null, bindingCommission?: string & { __scalar: "Decimal" } | null, brokerageCommission?: string & { __scalar: "Decimal" } | null }> | null } };

export type AgencyAppointmentsQueryVariables = Exact<{
  agencyId: Scalars['String'];
}>;


export type AgencyAppointmentsQuery = { __typename?: 'Query', agencyAppointments: Array<{ __typename?: 'AgencyAppointment', id: string, agencyId: string, carrierSlug: string }> };

export type AgencyOwnersQueryVariables = Exact<{ [key: string]: never; }>;


export type AgencyOwnersQuery = { __typename?: 'Query', agencyOwners: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type AgencyWithDefaultSecondaryAgentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AgencyWithDefaultSecondaryAgentsQuery = { __typename?: 'Query', agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean, defaultSecondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> } };

export type AgentAccountsQueryVariables = Exact<{
  input?: UserAccountFindManyFilter;
}>;


export type AgentAccountsQuery = { __typename?: 'Query', userAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type AgentActionTitlesQueryVariables = Exact<{
  actionType: Scalars['String'];
}>;


export type AgentActionTitlesQuery = { __typename?: 'Query', agentActionTitles: Array<string> };

export type AiGuessBusinessClassesQueryVariables = Exact<{
  description: Scalars['String'];
}>;


export type AiGuessBusinessClassesQuery = { __typename?: 'Query', aiGuessBusinessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }> };

export type AlbyMarketsForPlanQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
  historyOffset?: InputMaybe<Scalars['Int']>;
  historyLimit?: InputMaybe<Scalars['Int']>;
  includeHistoryAnchor?: Scalars['Boolean'];
}>;


export type AlbyMarketsForPlanQuery = { __typename?: 'Query', albyMarketsAwaitingLaunch: boolean, albyMarkets?: { __typename?: 'AlbyMarkets', opportunityId: string, evidenceError?: string | null, app2ReadAt: any, quoteTotalCount: number, quoteHistoryOffset: number, quoteHistoryLimit: number, quotesTruncated: boolean, gate: { __typename?: 'AlbyProducerGate', opportunityId: string, mode: string, owned: boolean, reason?: string | null }, quoteHistory: Array<{ __typename?: 'AlbyQuoteSummary', id: string, version: number, placementId: string, laneId: string, runNumber: number, logicalLaneKey?: string | null, sourceIdentityReason?: string | null, productMappingReason?: string | null, extractionStatus: string, deskReviewState?: string | null, producerState?: string | null, quoteNumber?: string | null, currentness: string, currentnessReason?: string | null, printedPremium?: number | null, printedCurrency?: string | null, convertedQuoteId?: string | null, producerDecisionReason?: string | null, app2ProducerDecidedAt?: any | null }>, lanes: Array<{ __typename?: 'AlbyMarket', placementId: string, runNumber: number, generation?: number | null, currentnessGeneration?: number | null, laneId: string, marketId: string, productId?: string | null, productLine?: string | null, displayName: string, status: string, sourceStatus: string, phase: string, holds: Array<string>, failureReason?: string | null, currentness: string, currentnessReason?: string | null, app2StateFetchedAt: any, progressTruncated: boolean, portalUrl?: string | null, quotesTruncated: boolean, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, handoffTaskId?: string | null } | null, assessment?: { __typename?: 'AlbyAssessment', id: string, verdict?: string | null, reason?: string | null, accountState: string, app2FirstReceivedAt: any, currentness: string, account?: { __typename?: 'AlbyAppetiteAccount', reasons: Array<string>, uncheckedExclusions: Array<string>, uncheckedReferralReasons: Array<string>, requiredConfirmations: Array<string>, classCode?: { __typename?: 'AlbyAppetiteClassCode', code: string, description: string } | null } | null } | null, ending?: { __typename?: 'AlbyLaneEnding', sentence: string, note?: string | null, saidBy: string } | null, progress: Array<{ __typename?: 'AlbyMarketProgress', milestone: string, receiptEventId: string, app2ReceivedAt: any, generation?: number | null, attemptId?: string | null }>, quotes: Array<{ __typename?: 'AlbyQuoteSummary', id: string, version: number, placementId: string, laneId: string, runNumber: number, logicalLaneKey?: string | null, sourceIdentityReason?: string | null, productMappingReason?: string | null, extractionStatus: string, deskReviewState?: string | null, producerState?: string | null, quoteNumber?: string | null, currentness: string, currentnessReason?: string | null, printedPremium?: number | null, printedCurrency?: string | null, convertedQuoteId?: string | null, producerDecisionReason?: string | null, app2ProducerDecidedAt?: any | null }> }> } | null, historyAnchor?: { __typename?: 'AlbyMarkets', opportunityId: string, quoteTotalCount: number, quoteHistoryLimit: number, quoteHistory: Array<{ __typename?: 'AlbyQuoteSummary', id: string, version: number, currentnessReason?: string | null }> } | null };

export type AlbyMarketQuoteFragment = { __typename?: 'AlbyQuoteSummary', id: string, version: number, placementId: string, laneId: string, runNumber: number, logicalLaneKey?: string | null, sourceIdentityReason?: string | null, productMappingReason?: string | null, extractionStatus: string, deskReviewState?: string | null, producerState?: string | null, quoteNumber?: string | null, currentness: string, currentnessReason?: string | null, printedPremium?: number | null, printedCurrency?: string | null, convertedQuoteId?: string | null, producerDecisionReason?: string | null, app2ProducerDecidedAt?: any | null };

export type AlbyQuoteDetailQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
  quoteId: Scalars['ID'];
}>;


export type AlbyQuoteDetailQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string> } | null, albyQuote?: { __typename?: 'AlbyQuote', id: string, version: number, opportunityId: string, placementId: string, laneId: string, runNumber: number, sourceMarket?: string | null, sourceProduct?: string | null, marketId?: string | null, productId?: string | null, marketDisplayName?: string | null, productLine?: string | null, logicalLaneKey?: string | null, sourceIdentityReason?: string | null, productMappingReason?: string | null, attemptId?: string | null, workOrderId?: string | null, sourceVersion: number, sourceGeneration?: number | null, currentnessGeneration?: number | null, currentnessReceiptEventId?: string | null, app2StateFetchedAt?: any | null, deskUpdatedAt?: any | null, deskReview?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, currentness: string, currentnessReason?: string | null, deskQuoteFileId: string, receiptEventId?: string | null, receiptDedupeKey?: string | null, provenance: string, extractionStatus: string, extractionVersion?: number | null, terms?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, termsCurrency?: string | null, quoteNumber?: string | null, quoteNumberSource?: string | null, originalAvailability: string, retainedFileUploadId?: string | null, retainedFileSha256?: string | null, retainedFileSize?: number | null, retainedFileMimeType?: string | null, assumptionsAvailability?: string | null, assumptions?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, portalAssumptions?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, portalAssumptionsAvailability: string, deskReviewState?: string | null, deskReviewTaskId?: string | null, producerState?: string | null, actionable: boolean, actionHoldReasons: Array<string>, actionableAt: string, preparationErrorCategory?: string | null, preparationRetryable: boolean, app2ReceiptPersistedAt: any, app2ReadyAt?: any | null, deskQuoteReceivedAt?: any | null, deskQuoteApprovedAt?: any | null, conversionAudit: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], producerDecidedByName?: string | null, app2ReadAt: any, gate: { __typename?: 'AlbyProducerGate', opportunityId: string, mode: string, owned: boolean, reason?: string | null, enrolledAt?: any | null }, actionAvailability: { __typename?: 'AlbyQuoteActionAvailability', use: { __typename?: 'AlbyQuoteActionState', eligible: boolean, holdReasons: Array<string> }, editInPortal: { __typename?: 'AlbyQuoteActionState', eligible: boolean, holdReasons: Array<string> }, reject: { __typename?: 'AlbyQuoteActionState', eligible: boolean, holdReasons: Array<string> }, resumeConversion?: { __typename?: 'AlbyQuoteConversionResume', operationId: string, action: AlbyQuoteConversionAction, idempotencyKey: string, sourceVersion: number, attemptCount: number, eligible: boolean, holdReasons: Array<string> } | null } } | null };

export type AlbyQuoteActionDetailFragment = { __typename?: 'AlbyQuote', id: string, version: number, opportunityId: string, placementId: string, laneId: string, runNumber: number, sourceMarket?: string | null, sourceProduct?: string | null, marketId?: string | null, productId?: string | null, marketDisplayName?: string | null, productLine?: string | null, logicalLaneKey?: string | null, sourceIdentityReason?: string | null, productMappingReason?: string | null, attemptId?: string | null, workOrderId?: string | null, sourceVersion: number, sourceGeneration?: number | null, currentnessGeneration?: number | null, currentnessReceiptEventId?: string | null, app2StateFetchedAt?: any | null, deskUpdatedAt?: any | null, deskReview?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, currentness: string, currentnessReason?: string | null, deskQuoteFileId: string, receiptEventId?: string | null, receiptDedupeKey?: string | null, provenance: string, extractionStatus: string, extractionVersion?: number | null, terms?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, termsCurrency?: string | null, quoteNumber?: string | null, quoteNumberSource?: string | null, originalAvailability: string, retainedFileUploadId?: string | null, retainedFileSha256?: string | null, retainedFileSize?: number | null, retainedFileMimeType?: string | null, assumptionsAvailability?: string | null, assumptions?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, portalAssumptions?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, portalAssumptionsAvailability: string, deskReviewState?: string | null, deskReviewTaskId?: string | null, producerState?: string | null, actionable: boolean, actionHoldReasons: Array<string>, actionableAt: string, preparationErrorCategory?: string | null, preparationRetryable: boolean, app2ReceiptPersistedAt: any, app2ReadyAt?: any | null, deskQuoteReceivedAt?: any | null, deskQuoteApprovedAt?: any | null, conversionAudit: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], producerDecidedByName?: string | null, app2ReadAt: any, gate: { __typename?: 'AlbyProducerGate', opportunityId: string, mode: string, owned: boolean, reason?: string | null, enrolledAt?: any | null }, actionAvailability: { __typename?: 'AlbyQuoteActionAvailability', use: { __typename?: 'AlbyQuoteActionState', eligible: boolean, holdReasons: Array<string> }, editInPortal: { __typename?: 'AlbyQuoteActionState', eligible: boolean, holdReasons: Array<string> }, reject: { __typename?: 'AlbyQuoteActionState', eligible: boolean, holdReasons: Array<string> }, resumeConversion?: { __typename?: 'AlbyQuoteConversionResume', operationId: string, action: AlbyQuoteConversionAction, idempotencyKey: string, sourceVersion: number, attemptCount: number, eligible: boolean, holdReasons: Array<string> } | null } };

export type AlbyQuoteOriginalFileQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
  quoteId: Scalars['ID'];
  disposition: AlbyQuoteFileDisposition;
}>;


export type AlbyQuoteOriginalFileQuery = { __typename?: 'Query', albyQuoteFile?: { __typename?: 'AlbyQuoteFileDownload', url: string, app2ExpiresAt: any, sha256: string, size: number, mimeType: string } | null };

export type AllMyPlaybooksQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMyPlaybooksQuery = { __typename?: 'Query', myPlaybooks: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }>, mySubscribedPlaybooks: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> };

export type AllPlaybookRunsQueryVariables = Exact<{
  input: AllPlaybookRunsInput;
}>;


export type AllPlaybookRunsQuery = { __typename?: 'Query', allPlaybookRuns: { __typename?: 'AllPlaybookRunsOutput', numRecords: number, numPages: number, playbookRuns: Array<{ __typename?: 'PlaybookRunDto', id: string, playbookId: string, parentPlaybookRunId?: string | null, parentChatSessionId?: string | null, rootChatSessionId?: string | null, depth?: number | null, toolInvocationId?: string | null, chatSessionId?: string | null, conversationId?: string | null, opportunityId?: string | null, triggerEventType?: string | null, parameterValues?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, status: string, errorMessage?: string | null, startedAt: any, finishedAt?: any | null, totalInputTokens?: number | null, totalOutputTokens?: number | null, aiCallCount?: number | null, playbook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string }, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, toolInvocations: Array<{ __typename?: 'McpToolInvocationDto', id: string, status: string, toolName: string, toolCallId?: string | null, calledAt: any, finishedAt?: any | null, toolInput: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], toolOutput?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null }> }> } };

export type AppetiteFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppetiteFilterOptionsQuery = { __typename?: 'Query', appetiteFilterOptions: { __typename?: 'AppetiteFilterOptions', linesOfBusiness: Array<{ __typename?: 'AppetiteLineOfBusiness', id: string, name: string }> } };

export type AppetiteGuidesForOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
}>;


export type AppetiteGuidesForOpportunityQuery = { __typename?: 'Query', appetiteGuidesForOpportunity: Array<{ __typename?: 'AppetiteGuide', carrierName: string, authority: BindingAuthority, code?: string | null, lob?: string | null, state?: string | null, parsedText?: string | null, googleDriveUrl?: string | null, fileType?: string | null }> };

export type AppetiteProductLinesQueryVariables = Exact<{ [key: string]: never; }>;


export type AppetiteProductLinesQuery = { __typename?: 'Query', appetiteProductLines: Array<string> };

export type AppetiteProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppetiteProductsQuery = { __typename?: 'Query', appetiteProducts: Array<{ __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }> };

export type AppetiteProductsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type AppetiteProductsCountQuery = { __typename?: 'Query', productsCount: number };

export type AttentionFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type AttentionFeedQuery = { __typename?: 'Query', attentionFeed: { __typename?: 'AttentionFeedResult', hasMore: boolean, totalCount: number, items: Array<{ __typename?: 'AttentionFeedItem', id: string, itemType: AttentionItemType, displayTitle: string, chatSessionId: string, occurredAt: any, insuredId?: string | null, inboxConversationId?: string | null, playbookId?: string | null, productId?: string | null, rootChatSessionId?: string | null }> } };

export type AttributionUserViewRoleQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
}>;


export type AttributionUserViewRoleQuery = { __typename?: 'Query', attributionUserViewRole: { __typename?: 'AttributionUserViewRole', id: string, email: string, name: string, viewRole: string } };

export type AttributionUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionUsersQuery = { __typename?: 'Query', attributionUsers: { __typename?: 'AttributionUsersLookup', count: number, users: Array<{ __typename?: 'AttributionLookupUser', id: string, email: string, name: string, viewRole: string }> } };

export type AttributionProducersQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionProducersQuery = { __typename?: 'Query', attributionProducers: { __typename?: 'AttributionProducersLookup', count: number, producers: Array<{ __typename?: 'AttributionLookupProducer', id: string, email: string, name: string }> } };

export type AttributionLobsQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionLobsQuery = { __typename?: 'Query', attributionLobs: { __typename?: 'AttributionLobsLookup', lobs: Array<string>, count: number } };

export type AttributionNaicsCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionNaicsCodesQuery = { __typename?: 'Query', attributionNaicsCodes: { __typename?: 'AttributionNaicsCodesLookup', count: number, naicsCodes: Array<{ __typename?: 'AttributionCodeLookup', code: string, description: string }> } };

export type AttributionCglCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionCglCodesQuery = { __typename?: 'Query', attributionCglCodes: { __typename?: 'AttributionCglCodesLookup', count: number, cglCodes: Array<{ __typename?: 'AttributionCodeLookup', code: string, description: string }> } };

export type AttributionDataFreshnessQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionDataFreshnessQuery = { __typename?: 'Query', attributionDataFreshness: { __typename?: 'AttributionDataFreshness', lastUpdated?: string | null } };

export type AttributionAdminCheckQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionAdminCheckQuery = { __typename?: 'Query', attributionAdminCheck: { __typename?: 'AttributionAdminCheck', isAdmin: boolean, email?: string | null } };

export type AttributionProducerIncentivesQueryVariables = Exact<{
  email: Scalars['String'];
  year: Scalars['Int'];
}>;


export type AttributionProducerIncentivesQuery = { __typename?: 'Query', attributionProducerIncentives: { __typename?: 'AttributionProducerIncentivesResponse', year: number, bookBased: Array<{ __typename?: 'AttributionBookBasedIncentive', id: string, producerEmail: string, bindhqLobs: Array<string>, bindhqLobsInclude: boolean, bindhqPolicyBusinessType?: string | null, naicsCode: Array<string>, naicsCodeInclude: boolean, cglCode: Array<string>, cglCodeInclude: boolean, startDate: any, endDate: any, incentivePayPercentage: number, createdAt: any, updatedAt: any }>, managementBased: Array<{ __typename?: 'AttributionManagementBasedIncentive', id: string, managerEmail: string, producerEmail: string, startDate: any, endDate: any, revenuePercentage: number, createdAt: any, updatedAt: any }>, base: Array<{ __typename?: 'AttributionBaseIncentive', id: string, producerEmails: Array<string>, startDate: any, endDate: any, bandStart: number, bandEnd: number, incentivePayPercentage: number, createdAt: any, updatedAt: any }> } };

export type AttributionArmIncentivesQueryVariables = Exact<{
  armEmail: Scalars['String'];
  year: Scalars['Int'];
}>;


export type AttributionArmIncentivesQuery = { __typename?: 'Query', attributionArmIncentives: { __typename?: 'AttributionArmIncentivesResponse', year: number, incentives: Array<{ __typename?: 'AttributionArmIncentiveParameter', id: string, armEmails: Array<string>, startDate: any, endDate: any, renewalBaseRate: number, newBusinessBaseRate: number, agencyGraduationThreshold: number, agencyGraduationBonusRate: number, previousYearEstimatedRevenue?: number | null, previousYearEstimatedVariable?: number | null, updatedByEmail: string, createdAt: any, updatedAt: any, kickerTiers: Array<{ __typename?: 'AttributionKickerTier', targetAchievementPercent: number, kickerRate: number }> }>, defaultIncentives: Array<{ __typename?: 'AttributionArmIncentiveParameter', id: string, armEmails: Array<string> }>, specificIncentives: Array<{ __typename?: 'AttributionArmIncentiveParameter', id: string, armEmails: Array<string> }>, incentive?: { __typename?: 'AttributionArmIncentiveParameter', id: string, armEmails: Array<string> } | null } };

export type AttributionProducerLostDealsCancellationsQueryVariables = Exact<{
  input: AttributionProducerLostDealsInput;
}>;


export type AttributionProducerLostDealsCancellationsQuery = { __typename?: 'Query', attributionProducerLostDealsCancellations: { __typename?: 'AttributionLostDealsResponse', count: number, records: Array<{ __typename?: 'AttributionLostDealRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, applicationType?: string | null, policyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredId?: string | null, insuredName?: string | null, agencyName?: string | null, agentName?: string | null, brokerAssigned?: string | null, type: string, segment: string, endorsementPremium: number, endorsementRevenue: number, revenueFromPremium: number, commissionRevenue: number, feeRevenue: number, yield: number, endorsementType?: string | null, effectiveDate?: string | null, expirationDate?: string | null }> } };

export type AttributionProducerLostDealsNonRenewalsQueryVariables = Exact<{
  input: AttributionProducerLostDealsInput;
}>;


export type AttributionProducerLostDealsNonRenewalsQuery = { __typename?: 'Query', attributionProducerLostDealsNonRenewals: { __typename?: 'AttributionLostDealsResponse', count: number, records: Array<{ __typename?: 'AttributionLostDealRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, applicationType?: string | null, policyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredId?: string | null, insuredName?: string | null, agencyName?: string | null, agentName?: string | null, brokerAssigned?: string | null, type: string, segment: string, endorsementPremium: number, endorsementRevenue: number, revenueFromPremium: number, commissionRevenue: number, feeRevenue: number, yield: number, endorsementType?: string | null, effectiveDate?: string | null, expirationDate?: string | null }> } };

export type AttributionProducerLostDealsMetricsQueryVariables = Exact<{
  input: AttributionProducerLostDealsMetricsInput;
}>;


export type AttributionProducerLostDealsMetricsQuery = { __typename?: 'Query', attributionProducerLostDealsMetrics: { __typename?: 'AttributionLostDealsMetricsResponse', total: { __typename?: 'AttributionLostDealsTotalMetrics', count: number, cancellationRate: number, nonRenewalRate: number }, cancellations: { __typename?: 'AttributionLostDealsCancellationMetrics', count: number, premium: number, revenue: number, originallyBookedPremium: number, returnedPremium: number, capturedPremium: number, originallyBookedRevenue: number, returnedRevenue: number, capturedRevenue: number }, nonRenewals: { __typename?: 'AttributionLostDealsNonRenewalMetrics', count: number, premium: number, revenue: number } } };

export type AttributionProducerMyBookQueryVariables = Exact<{
  input: AttributionProducerMyBookInput;
}>;


export type AttributionProducerMyBookQuery = { __typename?: 'Query', attributionProducerMyBook: { __typename?: 'AttributionMyBookResponse', count: number, records: Array<{ __typename?: 'AttributionMyBookRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, transactionDate?: string | null, applicationType?: string | null, policyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredId?: string | null, insuredName?: string | null, agencyId?: string | null, agencyName?: string | null, agentName?: string | null, brokerAssigned?: string | null, type: string, isRenewable: boolean, segment: string, endorsementPremium: number, endorsementRevenue: number, revenueFromPremium: number, commissionRevenue: number, feeRevenue: number, yield: number, endorsementType?: string | null, effectiveDate?: string | null, expirationDate?: string | null }> } };

export type AttributionArmMyBookQueryVariables = Exact<{
  input: AttributionArmMyBookInput;
}>;


export type AttributionArmMyBookQuery = { __typename?: 'Query', attributionArmMyBook: { __typename?: 'AttributionMyBookResponse', count: number, records: Array<{ __typename?: 'AttributionMyBookRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, transactionDate?: string | null, applicationType?: string | null, policyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredId?: string | null, insuredName?: string | null, agencyId?: string | null, agencyName?: string | null, agentName?: string | null, brokerAssigned?: string | null, type: string, isRenewable: boolean, segment: string, endorsementPremium: number, endorsementRevenue: number, revenueFromPremium: number, commissionRevenue: number, feeRevenue: number, yield: number, endorsementType?: string | null, effectiveDate?: string | null, expirationDate?: string | null }>, agencyMetrics?: Array<{ __typename?: 'AttributionAgencyMetric', agencyId: string, agencyName: string, agencyTier?: string | null, agencySegment?: string | null, totalPolicyPremium: number, coverageRequests: number, submittedCoverageRequests: number, quotedCoverageRequests: number, boundCoverageRequests: number, createToSubmit: number, submitToQuote: number, quoteToBind: number, hitRatio: number }> | null } };

export type AttributionProducerAttributedIncentivesQueryVariables = Exact<{
  input: AttributionProducerAttributedIncentivesInput;
}>;


export type AttributionProducerAttributedIncentivesQuery = { __typename?: 'Query', attributionProducerAttributedIncentives: { __typename?: 'AttributionAdditionalAttributionData', ruleDetails: any, transactionYear: number, attributeToEmail?: string | null, armEmail?: string | null, chartData: Array<{ __typename?: 'AttributionAdditionalRevenueChartPoint', month: string, rules: any }> } };

export type AttributionArmAttributedIncentivesQueryVariables = Exact<{
  input: AttributionArmAttributedIncentivesInput;
}>;


export type AttributionArmAttributedIncentivesQuery = { __typename?: 'Query', attributionArmAttributedIncentives: { __typename?: 'AttributionAdditionalAttributionData', ruleDetails: any, transactionYear: number, attributeToEmail?: string | null, armEmail?: string | null, chartData: Array<{ __typename?: 'AttributionAdditionalRevenueChartPoint', month: string, rules: any }> } };

export type AttributionProducerPerformanceOverviewDetailsQueryVariables = Exact<{
  input: AttributionProducerPerformanceOverviewDetailsInput;
}>;


export type AttributionProducerPerformanceOverviewDetailsQuery = { __typename?: 'Query', attributionProducerPerformanceOverviewDetails: { __typename?: 'AttributionPerformanceOverviewDetailResponse', count: number, records: Array<{ __typename?: 'AttributionPerformanceOverviewDetailRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, transactionDate?: string | null, applicationType?: string | null, policyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredName?: string | null, agencyName?: string | null, agentName?: string | null, brokerAssigned?: string | null, type: string, segment: string, endorsementPremium: number, endorsementRevenue: number, revenueFromPremium: number, commissionRevenue: number, feeRevenue: number, yield: number, endorsementType?: string | null, effectiveDate?: string | null, expirationDate?: string | null }> } };

export type AttributionArmPerformanceOverviewDetailsQueryVariables = Exact<{
  input: AttributionArmPerformanceOverviewDetailsInput;
}>;


export type AttributionArmPerformanceOverviewDetailsQuery = { __typename?: 'Query', attributionArmPerformanceOverviewDetails: { __typename?: 'AttributionPerformanceOverviewDetailResponse', count: number, records: Array<{ __typename?: 'AttributionPerformanceOverviewDetailRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, transactionDate?: string | null, applicationType?: string | null, policyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredName?: string | null, agencyName?: string | null, agentName?: string | null, brokerAssigned?: string | null, type: string, segment: string, endorsementPremium: number, endorsementRevenue: number, revenueFromPremium: number, commissionRevenue: number, feeRevenue: number, yield: number, endorsementType?: string | null, effectiveDate?: string | null, expirationDate?: string | null }> } };

export type AttributionProducerAttributedPremiumQueryVariables = Exact<{
  input: AttributionProducerAttributedPremiumInput;
}>;


export type AttributionProducerAttributedPremiumQuery = { __typename?: 'Query', attributionProducerAttributedPremium: { __typename?: 'AttributionAttributedPremiumResponse', transactionYear: number, attributeToEmail?: string | null, armEmail?: string | null, stats: { __typename?: 'AttributionPremiumStats', totalRevenue: number, newBusinessRevenue: number, renewalRevenue: number, totalCount: number, newBusinessCount: number, renewalCount: number }, chartData: Array<{ __typename?: 'AttributionChartDataPoint', month: string, total: number, newBusiness: number, renewal: number }> } };

export type AttributionArmAttributedPremiumQueryVariables = Exact<{
  input: AttributionArmAttributedPremiumInput;
}>;


export type AttributionArmAttributedPremiumQuery = { __typename?: 'Query', attributionArmAttributedPremium: { __typename?: 'AttributionAttributedPremiumResponse', transactionYear: number, attributeToEmail?: string | null, armEmail?: string | null, stats: { __typename?: 'AttributionPremiumStats', totalRevenue: number, newBusinessRevenue: number, renewalRevenue: number, totalCount: number, newBusinessCount: number, renewalCount: number }, chartData: Array<{ __typename?: 'AttributionChartDataPoint', month: string, total: number, newBusiness: number, renewal: number }> } };

export type AttributionProducerAttributedRollsQueryVariables = Exact<{
  input: AttributionProducerAttributedRollsInput;
}>;


export type AttributionProducerAttributedRollsQuery = { __typename?: 'Query', attributionProducerAttributedRolls: { __typename?: 'AttributionAttributedRollsResponse', data: any, byEmail?: any | null } };

export type AttributionProducerLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionProducerLabelsQuery = { __typename?: 'Query', attributionProducerLabels: Array<{ __typename?: 'AttributionProducerLabelRow', producerEmail: string, producerName: string, label?: string | null, updatedAt?: any | null }> };

export type AttributionProducerLabelQueryVariables = Exact<{
  producerEmail: Scalars['String'];
}>;


export type AttributionProducerLabelQuery = { __typename?: 'Query', attributionProducerLabel?: { __typename?: 'AttributionProducerLabel', producerEmail: string, label: string, updatedByEmail: string, updatedAt: any } | null };

export type AttributionProducerLabelOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributionProducerLabelOptionsQuery = { __typename?: 'Query', attributionProducerLabelOptions: Array<string> };

export type AttributionQuotedNotBoundQueryVariables = Exact<{
  input: AttributionQuotedNotBoundInput;
}>;


export type AttributionQuotedNotBoundQuery = { __typename?: 'Query', attributionQuotedNotBound: { __typename?: 'AttributionQuotedNotBoundResponse', count: number, truncated: boolean, records: Array<{ __typename?: 'AttributionQuotedNotBoundRecord', id: string, insuredName?: string | null, insuredId?: string | null, insuredPrimaryState?: string | null, lineOfBusiness?: string | null, desiredEffectiveDate?: string | null, createdAt?: string | null, earliestDeliveredAt?: string | null, agencyName?: string | null, agentName?: string | null, brokerName?: string | null, brokerEmail?: string | null, opportunityId?: string | null, isRenewal?: boolean | null, opportunitySource?: string | null, quotesDelivered?: number | null, minQuotePremium?: number | null, submitToQuoteHours?: number | null, quoteToBindHours?: number | null, carrierNames?: string | null, brokerType: string }>, summary: { __typename?: 'AttributionQuotedNotBoundSummary', count: number, distinctInsureds: number, distinctInsuredLobPairs: number, sumMinQuotePremium?: number | null } } };

export type AttributionReassignmentsQueryVariables = Exact<{
  input: AttributionReassignmentsInput;
}>;


export type AttributionReassignmentsQuery = { __typename?: 'Query', attributionReassignments: { __typename?: 'AttributionReassignmentsResponse', count: number, reassignments: Array<{ __typename?: 'AttributionReassignmentRecord', id: string, endorsementId?: string | null, endorsementNumber?: string | null, adjustedPostingDate?: string | null, revenue?: number | null, revenueFromPremium?: number | null, premium?: number | null, quotewellCommission?: number | null, mgaFee?: number | null, applicationType?: string | null, isRenewal: boolean, productMarketType?: string | null, policyId?: string | null, appPolicyId?: string | null, policyNumber?: string | null, policyStatus?: string | null, insuredId?: string | null, appInsuredId?: string | null, insuredName?: string | null, agencyName?: string | null, agentName?: string | null, attributeToName?: string | null, originalAttributeToEmail?: string | null, wasRenewed: boolean, reattributeToEmail?: string | null, reassignedByEmail?: string | null, reassignmentCreatedAt: string, reassignmentUpdatedAt: string }> } };

export type AttributionProducerRevenueTargetsQueryVariables = Exact<{
  producerEmail: Scalars['String'];
  year: Scalars['Int'];
}>;


export type AttributionProducerRevenueTargetsQuery = { __typename?: 'Query', attributionProducerRevenueTargets: { __typename?: 'AttributionRevenueTargetsResponse', targets: Array<{ __typename?: 'AttributionMonthlyRevenueTarget', id: string, producerEmail: string, year: number, month: number, revenueTarget: number, updatedByEmail: string, createdAt: any, updatedAt: any }> } };

export type AttributionArmRevenueTargetsQueryVariables = Exact<{
  armEmail: Scalars['String'];
  year: Scalars['Int'];
}>;


export type AttributionArmRevenueTargetsQuery = { __typename?: 'Query', attributionArmRevenueTargets: { __typename?: 'AttributionRevenueTargetsResponse', targets: Array<{ __typename?: 'AttributionMonthlyRevenueTarget', id: string, producerEmail: string, year: number, month: number, revenueTarget: number, updatedByEmail: string, createdAt: any, updatedAt: any }> } };

export type AttributionProducerRevenueTargetsByTeamQueryVariables = Exact<{
  transactionYear: Scalars['Int'];
  period: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
}>;


export type AttributionProducerRevenueTargetsByTeamQuery = { __typename?: 'Query', attributionProducerRevenueTargetsByTeam: { __typename?: 'AttributionTeamRevenueTargetsResponse', targets: any, year: number, period: string } };

export type AttributionTeamAttributedPremiumQueryVariables = Exact<{
  input: AttributionTeamAttributedPremiumInput;
}>;


export type AttributionTeamAttributedPremiumQuery = { __typename?: 'Query', attributionTeamAttributedPremium: { __typename?: 'AttributionTeamAttributedPremiumResponse', chartData: Array<any>, transactionYear: number, breakdownType: string, filterLabel?: string | null, period: string } };

export type BankanMarketingPlanColumnQueryVariables = Exact<{
  input: BankanMarketingPlanColumnInput;
}>;


export type BankanMarketingPlanColumnQuery = { __typename?: 'Query', bankanMarketingPlanColumn: { __typename?: 'BankanMarketingPlansResponse', groupedMarketingPlans: Array<{ __typename?: 'GroupedMarketingPlans', insuredId: string, insuredName: string, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any, isoCglCodes: Array<string>, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string, affiliations?: Array<{ __typename?: 'AgencyAffiliation', id: string, name: string, shortName?: string | null, logoUrl?: string | null, bindingCommission?: string & { __scalar: "Decimal" } | null, brokerageCommission?: string & { __scalar: "Decimal" } | null }> | null } } }, marketingPlans: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, createdAt: any, state: MarketingPlanState, desiredEffectiveDate: any, lastTransitionAt: any, selectedLinesOfBusiness: Array<string>, snoozeUntil?: any | null, hasUnseenAlbyUpdates: boolean, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null }> }> } };

export type BankanPolicyColumnQueryVariables = Exact<{
  input: BankanPolicyColumnInput;
}>;


export type BankanPolicyColumnQuery = { __typename?: 'Query', bankanPolicyColumn: { __typename?: 'BankanPoliciesResponse', groupedPolicies: Array<{ __typename?: 'GroupedPolicies', insuredId: string, insuredName: string, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any, isoCglCodes: Array<string>, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string, affiliations?: Array<{ __typename?: 'AgencyAffiliation', id: string, name: string, shortName?: string | null, logoUrl?: string | null, bindingCommission?: string & { __scalar: "Decimal" } | null, brokerageCommission?: string & { __scalar: "Decimal" } | null }> | null } } }, policies: Array<{ __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, state: PolicyState, policyNumber: string, expirationDate?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null } }> }> } };

export type BankanQuoteColumnQueryVariables = Exact<{
  input: BankanQuoteColumnInput;
}>;


export type BankanQuoteColumnQuery = { __typename?: 'Query', bankanQuoteColumn: { __typename?: 'BankanQuotesResponse', groupedQuotes: Array<{ __typename?: 'BankanGroupedQuotes', insuredId: string, insuredName: string, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any, isoCglCodes: Array<string>, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string, affiliations?: Array<{ __typename?: 'AgencyAffiliation', id: string, name: string, shortName?: string | null, logoUrl?: string | null, bindingCommission?: string & { __scalar: "Decimal" } | null, brokerageCommission?: string & { __scalar: "Decimal" } | null }> | null } } }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, state: QuoteState, premium?: number | null, effectiveDate?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null } }> }> } };

export type BindHqAgenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type BindHqAgenciesQuery = { __typename?: 'Query', bindHqAgencies: Array<{ __typename?: 'BindHqAgency', id: string, name: string }> };

export type BindHqAgencyQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type BindHqAgencyQuery = { __typename?: 'Query', bindHqAgency: { __typename?: 'BindHqAgency', id: string, name: string, phone?: string | null, email?: string | null, line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null, okToBind: boolean } };

export type BindHqAgentsQueryVariables = Exact<{
  input: BindHqFetchAgentsInput;
}>;


export type BindHqAgentsQuery = { __typename?: 'Query', bindHqAgents: Array<{ __typename?: 'BindHqAgent', id: string, firstName: string, lastName: string }> };

export type BindHqCarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type BindHqCarriersQuery = { __typename?: 'Query', bindHqCarriers: Array<{ __typename?: 'BindHqCarrier', id: string, name: string }> };

export type BindHqInsuredsQueryVariables = Exact<{ [key: string]: never; }>;


export type BindHqInsuredsQuery = { __typename?: 'Query', bindHqInsureds: Array<{ __typename?: 'BindHqInsured', id: string, name: string, type: string }> };

export type BindHqMarketingCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type BindHqMarketingCompaniesQuery = { __typename?: 'Query', bindHqMarketingCompanies: Array<{ __typename?: 'BindHqMarketingCompany', id: string, name: string }> };

export type BinderCoverFiguresQueryVariables = Exact<{
  policyId: Scalars['ID'];
}>;


export type BinderCoverFiguresQuery = { __typename?: 'Query', binderCoverFigures: { __typename?: 'BinderCoverFigures', premium?: number | null, surplusLinesTax?: number | null, stampingFee?: number | null, surplusLinesServiceCharge?: number | null, fireMarshallTax?: number | null, municipalFee?: number | null, countyFee?: number | null, empaTax?: number | null, carrierFee?: number | null, inspectionFee?: number | null, brokerFee?: number | null, policyNumber: string, effectiveDate?: string | null, expirationDate?: string | null, totalPremium?: number | null, outstandingSubjectivities?: string | null, reviewToken: string, bindHqFigureChecks?: Array<{ __typename?: 'BindHqFigureCheck', fields: Array<string>, status: BindHqFigureCheckStatus, ours: number, bindHq?: number | null }> | null } };

export type BrokerAccountsQueryVariables = Exact<{
  input?: UserAccountFindManyFilter;
}>;


export type BrokerAccountsQuery = { __typename?: 'Query', userAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type BrokerHasCollaborationsQueryVariables = Exact<{
  brokerId: Scalars['String'];
}>;


export type BrokerHasCollaborationsQuery = { __typename?: 'Query', brokerHasCollaborations: boolean };

export type BrokerLostOpportunitiesQueryVariables = Exact<{
  input: BrokerLostOpportunitiesInput;
}>;


export type BrokerLostOpportunitiesQuery = { __typename?: 'Query', brokerLostOpportunities: Array<{ __typename?: 'BrokerOpportunity', id: string, desiredEffectiveDate?: any | null, state: MarketingPlanState, renewalStatus?: string | null, insured: { __typename?: 'BrokerInsured', id: string, name: string, agent?: { __typename?: 'BrokerUser', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency?: { __typename?: 'BrokerAgency', id: string, name: string } | null } | null } }> };

export type BrokerOpportunitiesQueryVariables = Exact<{
  input: BrokerOpportunitiesInput;
}>;


export type BrokerOpportunitiesQuery = { __typename?: 'Query', brokerOpportunities: Array<{ __typename?: 'BrokerOpportunity', id: string, brokerId?: string | null, desiredEffectiveDate?: any | null, snoozeUntil?: any | null, state: MarketingPlanState, classificationLabels: Array<string>, renewalStatus?: string | null, insured: { __typename?: 'BrokerInsured', id: string, name: string, agent?: { __typename?: 'BrokerUser', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency?: { __typename?: 'BrokerAgency', id: string, name: string } | null } | null }, submissions?: Array<{ __typename?: 'BrokerSubmission', id: string, state: SubmissionState, quotes: Array<{ __typename?: 'BrokerQuote', id: string, state: QuoteState }> }> | null }> };

export type BrokerPoliciesQueryVariables = Exact<{
  input: BrokerPoliciesInput;
}>;


export type BrokerPoliciesQuery = { __typename?: 'Query', brokerPolicies: Array<{ __typename?: 'BrokerPolicy', id: string, effectiveDate?: any | null, expirationDate?: any | null, state: PolicyState, insured: { __typename?: 'BrokerInsured', id: string, name: string, agent?: { __typename?: 'BrokerUser', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency?: { __typename?: 'BrokerAgency', id: string, name: string } | null } | null } }> };

export type BrokerQuotesQueryVariables = Exact<{
  input?: InputMaybe<BrokerQuotesInput>;
}>;


export type BrokerQuotesQuery = { __typename?: 'Query', brokerQuotes: Array<{ __typename?: 'BrokerQuote', id: string, effectiveDate?: any | null, state: QuoteState, insured: { __typename?: 'BrokerInsured', id: string, name: string, agent?: { __typename?: 'BrokerUser', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency?: { __typename?: 'BrokerAgency', id: string, name: string } | null } | null } }> };

export type BrokerRenewalsQueryVariables = Exact<{
  input: BrokerOpportunitiesInput;
}>;


export type BrokerRenewalsQuery = { __typename?: 'Query', brokerRenewals: Array<{ __typename?: 'BrokerOpportunity', id: string, desiredEffectiveDate?: any | null, state: MarketingPlanState, classificationLabels: Array<string>, renewalStatus?: string | null, insured: { __typename?: 'BrokerInsured', id: string, name: string, agent?: { __typename?: 'BrokerUser', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency?: { __typename?: 'BrokerAgency', id: string, name: string } | null } | null }, submissions?: Array<{ __typename?: 'BrokerSubmission', id: string, state: SubmissionState, quotes: Array<{ __typename?: 'BrokerQuote', id: string, state: QuoteState }> }> | null }> };

export type BrokerUpcomingRenewalsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrokerUpcomingRenewalsQuery = { __typename?: 'Query', brokerUpcomingRenewals: Array<{ __typename?: 'BrokerPolicy', id: string, effectiveDate?: any | null, expirationDate?: any | null, state: PolicyState, insured: { __typename?: 'BrokerInsured', id: string, name: string, agent?: { __typename?: 'BrokerUser', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency?: { __typename?: 'BrokerAgency', id: string, name: string } | null } | null } }> };

export type CancelVaveQuoteMutationVariables = Exact<{
  input: CancelVaveQuoteInput;
}>;


export type CancelVaveQuoteMutation = { __typename?: 'Mutation', cancel: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type CarrierContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type CarrierContactsQuery = { __typename?: 'Query', carrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> };

export type CarrierDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CarrierDetailQuery = { __typename?: 'Query', carrier: { __typename?: 'Carrier', id: string, name: string, slug: string, url?: string | null, portalUrl?: string | null, qwAppointed: boolean, bindHqMarketingCompanyId?: string | null, bindHqMarketingCompanyName?: string | null, bindHqCarrierIds: Array<string>, phone?: string | null, fax?: string | null, email?: string | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, backgroundColor: string, foregroundColor: string, contracts?: Array<{ __typename?: 'CarrierContract', id: string, fileUploadId?: string | null, extractionStatus: CarrierContractExtractionStatus, appetiteProductIds: Array<string>, createdAt: any, agreementType?: string | null, effectiveDate?: any | null, expirationDate?: any | null, producerCode?: string | null, marketType?: string | null, contractStatus?: string | null, hasBindingAuthority?: boolean | null, bindingAuthorityLimit?: number | null, aggregateLimit?: number | null, maxPolicyTermMonths?: number | null, premiumFinanceAllowed?: boolean | null, premiumGuarantee?: string | null, paymentTerms?: string | null, terminationNoticeDays?: number | null, defaultCurePeriodDays?: number | null, eoMinimumCoverage?: number | null, eoRatingRequirement?: string | null, fidelityBondRequired?: boolean | null, dataBreachNotifyHours?: number | null, recordRetentionYears?: number | null, diligentSearchRequired?: boolean | null, subProducerAllowed?: boolean | null, changeOfControlPct?: number | null, governingLawState?: string | null, disputeMethod?: string | null, arbitrationVenue?: string | null, authorizedStates: Array<string>, fileUpload?: { __typename?: 'FileUpload', id: string, filename: string, mimeType: string, size: number, createdAt: any } | null, incentives: Array<{ __typename?: 'CarrierIncentive', id: string, incentiveType: string, summary: string, details?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, appetiteProductId?: string | null, sortOrder: number }>, commissions: Array<{ __typename?: 'CarrierContractCommission', id: string, lineOfBusiness: string, rate: number, premiumThresholdMin?: number | null, premiumThresholdMax?: number | null, appetiteProductId?: string | null, notes?: string | null, sortOrder: number }> }> | null, incentives?: Array<{ __typename?: 'CarrierIncentive', id: string, carrierContractId: string, incentiveType: string, summary: string, details?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, appetiteProductId?: string | null, sortOrder: number }> | null } };

export type ChatSessionQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ChatSessionQuery = { __typename?: 'Query', chatSession: { __typename?: 'ChatSession', id: string, title?: string | null, status?: ChatSessionStatus | null, userId: string, viewerCanSendMessages: boolean, createdAt: any, updatedAt?: any | null, lastMessageAt?: any | null, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, messages: Array<{ __typename?: 'ChatMessage', id: string, externalMessageId?: string | null, sessionId: string, parts: string, role: string, status: string, createdAt: any, isElicitation: boolean, elicitationResolvedBy?: string | null, frameId?: string | null }>, metadata: Array<{ __typename?: 'ChatSessionMetadataEntry', key: string, value: string }> } };

export type ChatSessionNotificationMetadataQueryVariables = Exact<{
  chatSessionId: Scalars['String'];
}>;


export type ChatSessionNotificationMetadataQuery = { __typename?: 'Query', chatSessionNotificationMetadata: { __typename?: 'ChatSessionNotificationMetadata', displayTitle: string, insuredId?: string | null, inboxConversationId?: string | null, opportunityId?: string | null } };

export type ChatSessionStreamStateQueryVariables = Exact<{
  chatSessionId: Scalars['String'];
}>;


export type ChatSessionStreamStateQuery = { __typename?: 'Query', chatSessionStreamState: { __typename?: 'ChatSessionStreamState', chatSessionId: string, kind: ChatSessionStreamStateKind, error?: string | null, userId?: string | null, formatVersion: string } };

export type ChatSessionUsageQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ChatSessionUsageQuery = { __typename?: 'Query', chatSessionUsage: { __typename?: 'ChatSessionUsage', id: string, lastInputTokens: number, contextLimit: number } };

export type ChatSessionsQueryVariables = Exact<{
  input: ChatSessionFilterInput;
}>;


export type ChatSessionsQuery = { __typename?: 'Query', chatSessions: Array<{ __typename?: 'ChatSession', id: string, title?: string | null, status?: ChatSessionStatus | null, userId: string, viewerCanSendMessages: boolean, createdAt: any, updatedAt?: any | null, lastMessageAt?: any | null, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, messages: Array<{ __typename?: 'ChatMessage', id: string, externalMessageId?: string | null, sessionId: string, parts: string, role: string, status: string, createdAt: any, isElicitation: boolean, elicitationResolvedBy?: string | null, frameId?: string | null }>, metadata: Array<{ __typename?: 'ChatSessionMetadataEntry', key: string, value: string }> }> };

export type ChildPlaybookRunsQueryVariables = Exact<{
  parentPlaybookRunId: Scalars['String'];
}>;


export type ChildPlaybookRunsQuery = { __typename?: 'Query', childPlaybookRuns: Array<{ __typename?: 'PlaybookRunDto', id: string, playbookId: string, parentPlaybookRunId?: string | null, parentChatSessionId?: string | null, rootChatSessionId?: string | null, depth?: number | null, toolInvocationId?: string | null, chatSessionId?: string | null, conversationId?: string | null, opportunityId?: string | null, triggerEventType?: string | null, parameterValues?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, status: string, errorMessage?: string | null, startedAt: any, finishedAt?: any | null, totalInputTokens?: number | null, totalOutputTokens?: number | null, aiCallCount?: number | null, playbook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string }, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, toolInvocations: Array<{ __typename?: 'McpToolInvocationDto', id: string, status: string, toolName: string, toolCallId?: string | null, calledAt: any, finishedAt?: any | null, toolInput: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], toolOutput?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null }> }> };

export type ClassCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClassCodesQuery = { __typename?: 'Query', classCodes: Array<{ __typename?: 'ClassCode', id: string, description: string, classCode: string, classSystem: string }> };

export type ClientDataQueryVariables = Exact<{
  input: ClientDataFilterInput;
}>;


export type ClientDataQuery = { __typename?: 'Query', clientData: Array<{ __typename?: 'ClientData', id: string, insuredId: string, index?: number | null, key: string, value: string, source?: string | null }> };

export type ConversationMessagesQueryVariables = Exact<{
  rootChatSessionId: Scalars['String'];
}>;


export type ConversationMessagesQuery = { __typename?: 'Query', conversationMessages: { __typename?: 'ConversationMessages', messages: Array<{ __typename?: 'ConversationMessage', id: string, externalMessageId: string, renderKey: string, sourceSessionId: string, rootSessionId: string, role: string, parts: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], status: string, sequence?: number | null, createdAt: any }> } | { __typename?: 'UnsupportedRuntime', reason: string } };

export type DefaultPromptQueryVariables = Exact<{
  input: DefaultPromptInput;
}>;


export type DefaultPromptQuery = { __typename?: 'Query', defaultPrompt: { __typename?: 'ConversationPrompt', systemPrompt: string, assistantMessage?: string | null, chatSession?: { __typename?: 'ChatSession', id: string, title?: string | null, status?: ChatSessionStatus | null, userId: string, viewerCanSendMessages: boolean, createdAt: any, updatedAt?: any | null, lastMessageAt?: any | null, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, messages: Array<{ __typename?: 'ChatMessage', id: string, externalMessageId?: string | null, sessionId: string, parts: string, role: string, status: string, createdAt: any, isElicitation: boolean, elicitationResolvedBy?: string | null, frameId?: string | null }>, metadata: Array<{ __typename?: 'ChatSessionMetadataEntry', key: string, value: string }> } | null } };

export type DiscoverPlaybooksQueryVariables = Exact<{ [key: string]: never; }>;


export type DiscoverPlaybooksQuery = { __typename?: 'Query', discoverPlaybooks: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> };

export type EnabledProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledProductsQuery = { __typename?: 'Query', enabledProducts: Array<{ __typename?: 'Product', id: string, userId: string, name: string, workflow: string, createdAt: any, updatedAt?: any | null, enabled: boolean, marketType?: MarketTypes | null, carrierId?: string | null, lineOfBusinessIds?: Array<string> | null, grossCommission?: number | null, carrier?: { __typename?: 'Carrier', id: string, name: string, slug: string } | null, linesOfBusiness?: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> | null, files: Array<{ __typename?: 'ProductFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, submissionCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }>, referenceCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> }> };

export type FileQueryVariables = Exact<{
  input: FindFileInput;
}>;


export type FileQuery = { __typename?: 'Query', file: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } };

export type FileTagQueryVariables = Exact<{
  input: GetTagInput;
}>;


export type FileTagQuery = { __typename?: 'Query', fileTag: { __typename?: 'FileTag', label: string, isSystem: boolean, fileCount: number, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null, childTags?: Array<{ __typename?: 'FileTag', label: string }> | null } };

export type FileTagsQueryVariables = Exact<{
  input: FindTagsInput;
}>;


export type FileTagsQuery = { __typename?: 'Query', fileTags: Array<{ __typename?: 'FileTag', label: string, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null, childTags?: Array<{ __typename?: 'FileTag', label: string }> | null }> };

export type FilePathsQueryVariables = Exact<{ [key: string]: never; }>;


export type FilePathsQuery = { __typename?: 'Query', paths: Code_Path };

export type FilesQueryVariables = Exact<{
  input: FindManyFileUploadInput;
}>;


export type FilesQuery = { __typename?: 'Query', files: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> };

export type FilesByInsuredQueryVariables = Exact<{
  input: FindFilesByInsuredInput;
}>;


export type FilesByInsuredQuery = { __typename?: 'Query', filesByInsured: Array<{ __typename?: 'FileUpload', keyDocumentRole?: File_Key_Document_Role | null, id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number, uploader?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, labels: Array<{ __typename?: 'FileTag', label: string, isSystem: boolean, parentTags?: Array<{ __typename?: 'FileTag', label: string, parentTags?: Array<{ __typename?: 'FileTag', label: string, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null }> | null }> | null }> }> };

export type FilesByLabelQueryVariables = Exact<{
  input: FindFilesByLabelInput;
}>;


export type FilesByLabelQuery = { __typename?: 'Query', filesByLabel: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number, uploader?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, labels: Array<{ __typename?: 'FileTag', label: string, isSystem: boolean }> }> };

export type FilesByUserQueryVariables = Exact<{
  input: FindManyFileUploadByUserInput;
}>;


export type FilesByUserQuery = { __typename?: 'Query', filesByUser: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string } | null }> };

export type FindFileUploadQueryVariables = Exact<{
  input: FindFileInput;
}>;


export type FindFileUploadQuery = { __typename?: 'Query', findFile: { __typename?: 'FileUpload', audience?: string | null, id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, size: number, labels: Array<{ __typename?: 'FileTag', label: string, isSystem: boolean }> } };

export type FindProductExclusionsQueryVariables = Exact<{
  where?: InputMaybe<ProductExclusionWhere>;
}>;


export type FindProductExclusionsQuery = { __typename?: 'Query', productExclusionsFind: Array<{ __typename?: 'ProductExclusion', id: string, reason?: string | null, state?: string | null, naicsCode?: string | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null }, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } }> };

export type CarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type CarriersQuery = { __typename?: 'Query', carriers: Array<{ __typename?: 'Carrier', id: string, name: string, slug: string }> };

export type LinesOfBusinessQueryVariables = Exact<{ [key: string]: never; }>;


export type LinesOfBusinessQuery = { __typename?: 'Query', linesOfBusiness: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> };

export type GroupedMarketingPlansQueryVariables = Exact<{
  input: GroupedMarketingPlansInput;
}>;


export type GroupedMarketingPlansQuery = { __typename?: 'Query', groupedMarketingPlans: { __typename?: 'BankanMarketingPlansResponse', groupedMarketingPlans: Array<{ __typename?: 'GroupedMarketingPlans', insuredId: string, insuredName: string, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any, isoCglCodes: Array<string>, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } } }, marketingPlans: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, createdAt: any, state: MarketingPlanState, desiredEffectiveDate: any, lastTransitionAt: any, selectedLinesOfBusiness: Array<string>, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null }> }> } };

export type GroupedQuotesQueryVariables = Exact<{
  input: GroupedQuotesInput;
}>;


export type GroupedQuotesQuery = { __typename?: 'Query', groupedQuotes: { __typename?: 'BankanQuotesResponse', groupedQuotes: Array<{ __typename?: 'BankanGroupedQuotes', insuredId: string, insuredName: string, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, state: QuoteState, premium?: number | null, effectiveDate?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null } }> }> } };

export type ImpersonatableAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpersonatableAccountsQuery = { __typename?: 'Query', impersonatableAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type InboxQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxQuery = { __typename?: 'Query', inbox?: { __typename?: 'Inbox', id: string, email: string } | null };

export type InboxAgencySearchQueryVariables = Exact<{
  input: SearchInboxAgenciesInput;
}>;


export type InboxAgencySearchQuery = { __typename?: 'Query', inboxAgencySearch: Array<{ __typename?: 'AgencySearchResult', id: string, name: string, accountCount: number, agentCount: number }> };

export type InboxAgentQueryVariables = Exact<{
  agentId: Scalars['ID'];
}>;


export type InboxAgentQuery = { __typename?: 'Query', inboxAgent?: { __typename?: 'AgentContact', id: string, firstName: string, lastName: string, email: string, agencyName: string, mobilePhone?: string | null, workPhone?: string | null } | null };

export type InboxAgentSearchQueryVariables = Exact<{
  input: SearchInboxAgentsInput;
}>;


export type InboxAgentSearchQuery = { __typename?: 'Query', inboxAgentSearch: Array<{ __typename?: 'AgentSearchResult', id: string, firstName: string, lastName: string, email: string, agencyName?: string | null }> };

export type InboxContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxContactsQuery = { __typename?: 'Query', inboxContacts: Array<{ __typename?: 'InboxContact', displayName: string, email: string }> };

export type InboxConversationQueryVariables = Exact<{
  input: GetConversationInput;
}>;


export type InboxConversationQuery = { __typename?: 'Query', inboxConversation?: { __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, isPending: boolean, teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, insuredId?: string & { __scalar: "UUID" } | null, attachmentCount: number, subject: string, participants: Array<string>, internalParticipantEmails: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, lastMessageFrom?: string | null, insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any } | null, opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, allRequirementsCompleted: boolean, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, complete: boolean }> }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, submissionId: string, state: QuoteState, premium?: number | null, totalPremium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, carrierFee?: number | null, brokerFee?: number | null, inspectionFee?: number | null, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, outstandingSubjectivities?: string | null, isRenewable: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> }>, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, agentEmail: string, agentPhone?: string | null, sourceReason: ConversationWakeUpSourceReason, conversationId?: string & { __scalar: "UUID" } | null, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }>, inbox: { __typename?: 'Inbox', id: string, email: string } } | null };

export type InboxConversationMessageBodiesQueryVariables = Exact<{
  input: GetConversationInput;
}>;


export type InboxConversationMessageBodiesQuery = { __typename?: 'Query', inboxConversationMessageBodies: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, to: Array<string>, from: string, cc: Array<string>, replyTo?: string | null, priority?: string | null, date: any, conversationId: string & { __scalar: "UUID" }, inboxId: string & { __scalar: "UUID" }, subject?: string | null, text?: string | null, html?: string | null, labels: Array<string>, summary?: string | null, headers?: string | null, annotatedHtml?: string | null, canReplyAll?: boolean | null }> };

export type InboxConversationsQueryVariables = Exact<{
  input: GetConversationsInput;
}>;


export type InboxConversationsQuery = { __typename?: 'Query', inboxConversations: { __typename?: 'PaginatedConversations', numRecords: number, numPages: number, conversations: Array<{ __typename?: 'Conversation', teamConversationId?: string & { __scalar: "UUID" } | null, viewerCanReplyAsCollaborator: boolean, viewerIsUnread: boolean, internalParticipantEmails: Array<string>, lastMessageFrom?: string | null, id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messageCount: number, attachmentCount: number, draftCount: number, dueWakeUp?: { __typename?: 'ConversationWakeUp', id: string & { __scalar: "UUID" }, dueAt: any, sourceReason: ConversationWakeUpSourceReason, displayMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null } | null, attachmentPreviews: Array<{ __typename?: 'ConversationAttachmentPreview', fileUploadId: string & { __scalar: "UUID" }, filename: string, mimeType: string }> }> } };

export type InboxConversationsByOpportunityQueryVariables = Exact<{
  input: GetConversationsByOpportunityInput;
}>;


export type InboxConversationsByOpportunityQuery = { __typename?: 'Query', inboxConversationsByOpportunity: Array<{ __typename?: 'Conversation', id: string, externalId: string, inboxId: string & { __scalar: "UUID" }, insuredId?: string & { __scalar: "UUID" } | null, isPending: boolean, subject: string, participants: Array<string>, labels: Array<string>, summary?: string | null, lastMessageAt?: any | null, messages: Array<{ __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, conversationId: string & { __scalar: "UUID" }, to: Array<string>, from: string, cc: Array<string>, date: any, labels: Array<string>, summary?: string | null, preview?: string | null, canReplyAll?: boolean | null, replyTo?: string | null, priority?: string | null, attachments: Array<{ __typename?: 'MessageAttachment', id: string, fileUploadId: string & { __scalar: "UUID" }, messageId: string & { __scalar: "UUID" }, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }> }> };

export type InboxDraftQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InboxDraftQuery = { __typename?: 'Query', inboxDraft: { __typename?: 'DraftMessage', opportunityId?: string | null, insuredId?: string | null, id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type InboxDraftAttachmentsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InboxDraftAttachmentsQuery = { __typename?: 'Query', inboxDraftAttachments: { __typename?: 'DraftAttachmentsDto', attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }>, sizeSummary: { __typename?: 'DraftAttachmentSizeSummary', totalSize: number, sizeLimit: number, exceedsSizeLimit: boolean, isNearSizeLimit: boolean } } };

export type InboxDraftSignatureQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxDraftSignatureQuery = { __typename?: 'Query', inboxDraftSignature: { __typename?: 'DraftSignatureDto', signature?: string | null } };

export type InboxDraftsQueryVariables = Exact<{
  input: FindDraftsForEmailInputDto;
}>;


export type InboxDraftsQuery = { __typename?: 'Query', inboxDrafts: { __typename?: 'FindDraftsForEmailDto', numRecords: number, numPages: number, drafts: Array<{ __typename?: 'DraftMessage', id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> }> } };

export type InboxDraftsCountQueryVariables = Exact<{
  input: FindDraftsForEmailInputDto;
}>;


export type InboxDraftsCountQuery = { __typename?: 'Query', inboxDraftsCount: number };

export type InboxDraftsFailedScheduledSendsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxDraftsFailedScheduledSendsCountQuery = { __typename?: 'Query', inboxDraftsFailedScheduledSendsCount: number };

export type InboxInsuredQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InboxInsuredQuery = { __typename?: 'Query', insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, createdAt: any, dba?: string | null, description?: string | null, primaryState?: string | null, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } } | null };

export type InboxLabelUnreadCountsQueryVariables = Exact<{
  input: GetLabelUnreadCountsInput;
}>;


export type InboxLabelUnreadCountsQuery = { __typename?: 'Query', inboxLabelUnreadCounts: Array<{ __typename?: 'LabelUnreadCount', label: string, count: number }> };

export type InboxLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxLabelsQuery = { __typename?: 'Query', inboxLabels: Array<{ __typename?: 'EmailLabel', externalId: string, name: string, type?: string | null }> };

export type InboxMailHorizonQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxMailHorizonQuery = { __typename?: 'Query', inbox?: { __typename?: 'Inbox', id: string, earliestMessageAt?: any | null } | null };

export type InboxMessageQueryVariables = Exact<{
  input: GetMessageByIdInput;
}>;


export type InboxMessageQuery = { __typename?: 'Query', inboxMessage?: { __typename?: 'Message', id: string, status: string, classification?: string | null, externalId: string, messageId: string, to: Array<string>, from: string, cc: Array<string>, replyTo?: string | null, priority?: string | null, date: any, conversationId: string & { __scalar: "UUID" }, inboxId: string & { __scalar: "UUID" }, subject?: string | null, text?: string | null, html?: string | null, labels: Array<string>, summary?: string | null, headers?: string | null, annotatedHtml?: string | null, canReplyAll?: boolean | null } | null };

export type InboxMessageClassificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxMessageClassificationsQuery = { __typename?: 'Query', inboxMessageClassifications: Array<{ __typename?: 'MessageClassification', id: string, label: string, description: string, autoRunPlaybook: boolean, source: MessageClassificationSource, associatedPlaybookId?: string | null, playbook?: { __typename?: 'Playbook', id: string, name: string } | null }> };

export type InboxSearchSuggestionsQueryVariables = Exact<{
  input: GetConversationsInput;
}>;


export type InboxSearchSuggestionsQuery = { __typename?: 'Query', inboxConversations: { __typename?: 'PaginatedConversations', conversations: Array<{ __typename?: 'Conversation', id: string, subject: string, participants: Array<string>, lastMessageFrom?: string | null }> } };

export type InboxUnreadQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxUnreadQuery = { __typename?: 'Query', inboxUnread: number };

export type InboxesQueryVariables = Exact<{ [key: string]: never; }>;


export type InboxesQuery = { __typename?: 'Query', inboxes: Array<{ __typename?: 'Inbox', id: string, email: string }> };

export type InformationRequestEmailDraftQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
  draftEmailId: Scalars['ID'];
}>;


export type InformationRequestEmailDraftQuery = { __typename?: 'Query', informationRequestDraft: { __typename?: 'DraftMessage', opportunityId?: string | null, insuredId?: string | null, sentAt?: any | null, id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type UpdateInformationRequestDraftMutationVariables = Exact<{
  input: UpdateInformationRequestDraftInput;
}>;


export type UpdateInformationRequestDraftMutation = { __typename?: 'Mutation', updateInformationRequestDraft: { __typename?: 'DraftMessage', opportunityId?: string | null, insuredId?: string | null, sentAt?: any | null, id: string, externalId?: string | null, externalMessageId?: string | null, subject?: string | null, from: string, to: Array<string>, cc: Array<string>, bcc: Array<string>, replyTo?: string | null, threadId?: string | null, inReplyTo?: string | null, references?: Array<string> | null, date?: any | null, text?: string | null, html?: string | null, labels: Array<string>, priority?: string | null, referenceMessageId?: string | null, scheduledSend?: { __typename?: 'DraftMessageScheduledSend', id: string, sendAt: any, queuedAt?: any | null, sentAt?: any | null, failedAt?: any | null, failedReason?: string | null, cancelledAt?: any | null, status: string, createdAt: any, updatedAt: any } | null, attachments: Array<{ __typename?: 'DraftMessageAttachment', id: string, fileUploadId: string, filename?: string | null, contentType?: string | null, size?: number | null, fileUpload: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } }> } };

export type InspectionOrderByPolicyQueryVariables = Exact<{
  policyId: Scalars['ID'];
}>;


export type InspectionOrderByPolicyQuery = { __typename?: 'Query', inspectionOrderByPolicy?: { __typename?: 'InspectionOrder', id: string, quoteId: string, policyId?: string | null, vendor?: string | null, status: InspectionOrderStatus, gaps: Array<InspectionGap>, orderedAt?: any | null, orderedElsewhereById?: string | null, updatedAt: any, packet: { __typename?: 'InspectionPacket', surveyTypeCode?: string | null, surveyTypeSource?: InspectionSurveyTypeSource | null, effectiveDate?: string | null, policyNumber?: string | null, orderAndForward: boolean, addresses: Array<{ __typename?: 'InspectionAddress', street?: string | null, city?: string | null, state?: string | null, zip?: string | null, source: InspectionAddressSource }>, contact: { __typename?: 'InspectionContact', name?: string | null, phone?: string | null, email?: string | null, unknown: boolean }, requestedSurvey?: { __typename?: 'InspectionRequestedSurvey', request: InspectionSurveyRequest, note?: string | null } | null }, vendorOrders: Array<{ __typename?: 'InspectionVendorOrder', orderId: string, controlIdNumber?: string | null, reference?: string | null, placedAt: any }> } | null };

export type InspectionOrderMuellerCaseQueryVariables = Exact<{
  inspectionOrderId: Scalars['ID'];
}>;


export type InspectionOrderMuellerCaseQuery = { __typename?: 'Query', inspectionOrderMuellerCase?: { __typename?: 'MuellerCase', orderId: string, status: string, fieldAppointmentDate?: string | null, fieldRepresentativeName?: string | null, surveyRemarks?: string | null } | null };

export type InspectionReportsQueryVariables = Exact<{
  inspectionOrderId: Scalars['ID'];
}>;


export type InspectionReportsQuery = { __typename?: 'Query', inspectionReports: Array<{ __typename?: 'InspectionReport', id: string, inspectionOrderId: string, source: InspectionReportSource, vendorOrderId?: string | null, locationIndex: number, locationText: string, fileId?: string | null, status: InspectionReportStatus, flagReason?: InspectionReportFlagReason | null, summaryCount?: number | null, countCheck?: InspectionReportCountCheck | null, letterFileId?: string | null, templateVersion?: string | null, recsHash?: string | null, sentAt?: any | null, sentById?: string | null, sentTo?: string | null, proofFileIds: Array<string>, signedConfirmedById?: string | null, followUpDueAt?: any | null, error?: string | null, updatedAt: any, vendorRiskCounts?: { __typename?: 'InspectionVendorRiskCounts', major?: number | null, minor?: number | null } | null, extractedRecs: Array<{ __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean }>, recs: Array<{ __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean }>, recEdits: Array<{ __typename?: 'InspectionRecEdit', op: InspectionRecEditOp, reason: InspectionRecEditReason, byId: string, at: any, before?: { __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean } | null, after?: { __typename?: 'InspectionRec', vendorNumber?: string | null, level?: string | null, text: string, refersToMedia: boolean } | null }> }> };

export type InsuredQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InsuredQuery = { __typename?: 'Query', insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } | null };

export type InsuredAcquisitionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InsuredAcquisitionQuery = { __typename?: 'Query', insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, acquisition?: { __typename?: 'InsuredAcquisition', canViewTransfer: boolean, acquired: Array<{ __typename?: 'AcquisitionTransferIn', runId: string & { __scalar: "UUID" }, bookType: string, movedAt: any, acquiringAgencyId: string & { __scalar: "UUID" }, acquiringAgencyName?: string | null, sellingAgencyName?: string | null, insuredId: string & { __scalar: "UUID" }, originalInsuredId?: string & { __scalar: "UUID" } | null, originalInsuredName?: string | null }>, transferredOut: Array<{ __typename?: 'AcquisitionTransferOut', runId: string & { __scalar: "UUID" }, movedAt: any, acquiringAgencyId: string & { __scalar: "UUID" }, acquiringAgencyName?: string | null, destinationInsuredId: string & { __scalar: "UUID" }, policyNumbers: Array<string>, policyCount: number, originalOpportunityIds: Array<string & { __scalar: "UUID" }> }> } | null } | null };

export type InsuredAcquisitionsQueryVariables = Exact<{
  insuredIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type InsuredAcquisitionsQuery = { __typename?: 'Query', insuredAcquisitions: Array<{ __typename?: 'InsuredAcquisitionSummary', insuredId: string & { __scalar: "UUID" }, runId: string & { __scalar: "UUID" }, bookType: string, movedAt: any, sellingAgencyName?: string | null, originalInsuredId?: string & { __scalar: "UUID" } | null, originalInsuredName?: string | null }> };

export type InsuredFileTagsQueryVariables = Exact<{
  input: FindTagsInput;
  insuredId: Scalars['ID'];
}>;


export type InsuredFileTagsQuery = { __typename?: 'Query', fileTags: Array<{ __typename?: 'FileTag', label: string, hasFile: boolean, parentTags?: Array<{ __typename?: 'FileTag', label: string }> | null, childTags?: Array<{ __typename?: 'FileTag', label: string }> | null }> };

export type InsuredMergeDriveFailuresQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InsuredMergeDriveFailuresQuery = { __typename?: 'Query', insured?: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, mergeDriveFailures: Array<{ __typename?: 'InsuredMergeDriveFailure', status: string, eventId: string & { __scalar: "UUID" }, deprecatedName: string, error?: string | null, createdAt: any }> } | null };

export type InsuredMergePreviewQueryVariables = Exact<{
  deprecatedId: Scalars['UUID'];
  survivorId: Scalars['UUID'];
}>;


export type InsuredMergePreviewQuery = { __typename?: 'Query', insuredMergePreview: { __typename?: 'InsuredMergePreview', deprecatedId: string, survivorId: string, crossAgency: boolean, canMerge: boolean, reason?: string | null, previewHash: string, deprecatedAgency: { __typename?: 'InsuredMergePreviewAgency', id: string, name: string }, survivorAgency: { __typename?: 'InsuredMergePreviewAgency', id: string, name: string }, deprecatedDrive: { __typename?: 'InsuredMergePreviewDrive', hasFolder: boolean, moveWillBeAttempted: boolean }, survivorDrive: { __typename?: 'InsuredMergePreviewDrive', hasFolder: boolean, moveWillBeAttempted: boolean }, opportunities: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, name?: string | null, state?: string | null }> }, files: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, name?: string | null }> }, gmailThreads: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, subject?: string | null }> }, clientData: { __typename?: 'InsuredMergePreviewClientData', count: number, keys: Array<string> }, conversations: { __typename?: 'InsuredMergePreviewConversations', count: number, inboxes: Array<{ __typename?: 'InsuredMergePreviewInbox', inboxId: string, email: string, ownerId?: string | null, ownerName?: string | null, ownerEmail?: string | null, inboxDeleted: boolean, userDeleted: boolean, count: number, conversations: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, subject?: string | null }> }> }, drafts: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, subject?: string | null, sent?: boolean | null }> } } };

export type InsuredWithDuplicateFlagQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type InsuredWithDuplicateFlagQuery = { __typename?: 'Query', insured?: { __typename?: 'Insured', isTest: boolean, id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, possibleDuplicates: Array<{ __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, name: string }>, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } } | null };

export type InsuredsQueryVariables = Exact<{
  input: InsuredFilterInput;
}>;


export type InsuredsQuery = { __typename?: 'Query', insureds: Array<{ __typename?: 'Insured', id: string & { __scalar: "UUID" }, createdAt: any, deletedAt?: any | null, bindHqId?: string | null, name: string, dba?: string | null, legalEntityType?: string | null, description?: string | null, primaryState?: string | null, naicsCodes: Array<string>, isoCglCodes: Array<string>, sicCodes: Array<string>, exposures?: string | null, mergedIntoId?: string & { __scalar: "UUID" } | null, revenue?: number | null, agentId: string & { __scalar: "UUID" }, businessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }>, agent: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }, secondaryAgents: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }>, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isPrivate: boolean, isTest: boolean } }> };

export type LicensesQueryVariables = Exact<{ [key: string]: never; }>;


export type LicensesQuery = { __typename?: 'Query', licenses: Array<{ __typename?: 'License', id: string, name: string, licenseState: string, licenseNumber: string, licenseType: string, loa?: string | null, effectiveDate?: string | null, expirationDate?: string | null, createdAt: any, updatedAt?: any | null }> };

export type LicenseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LicenseQuery = { __typename?: 'Query', license?: { __typename?: 'License', id: string, name: string, licenseState: string, licenseNumber: string, licenseType: string, loa?: string | null, effectiveDate?: string | null, expirationDate?: string | null, createdAt: any, updatedAt?: any | null } | null };

export type LicensesByStateQueryVariables = Exact<{
  state: Scalars['String'];
}>;


export type LicensesByStateQuery = { __typename?: 'Query', licensesByState: Array<{ __typename?: 'License', id: string, name: string, licenseState: string, licenseNumber: string, licenseType: string, loa?: string | null, effectiveDate?: string | null, expirationDate?: string | null, createdAt: any, updatedAt?: any | null }> };

export type McpToolsMetadataQueryVariables = Exact<{
  input?: InputMaybe<McpToolsMetadataInput>;
}>;


export type McpToolsMetadataQuery = { __typename?: 'Query', mcpToolsMetadata: Array<{ __typename?: 'MCPToolMetadata', name: string, description: string, shortDescription?: string | null, platforms?: Array<string> | null }> };

export type MimeTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type MimeTypesQuery = { __typename?: 'Query', mimeTypes: Array<{ __typename?: 'MimeTypeCount', mimeType: string, count: number }> };

export type ModelEvaluationQueryVariables = Exact<{
  id: Scalars['String'];
  includeResults: Scalars['Boolean'];
  resultsLimit: Scalars['Int'];
}>;


export type ModelEvaluationQuery = { __typename?: 'Query', modelEvaluation?: { __typename?: 'ModelEvaluation', id: string, createdAt: any, completedAt?: any | null, status: string, totalSamples: number, failedPredictions: number, mae?: number | null, rmse?: number | null, r2?: number | null, mape?: number | null, minError?: number | null, maxError?: number | null, meanError?: number | null, medianError?: number | null, modelMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, results?: Array<{ __typename?: 'ModelEvaluationResult', id: string, quoteId: string, submissionId: string, carrier: string, product: string, state: string, actualPremium: number, predictedPremium: number, absoluteError: number, percentageError: number }> | null, percentiles?: { __typename?: 'ModelEvaluationPercentiles', p25: number, p50: number, p75: number, p90: number, p95: number } | null, accuracyBuckets?: { __typename?: 'ModelEvaluationAccuracyBuckets', within100: number, within500: number, within1000: number, within10Percent: number, within25Percent: number } | null } | null };

export type ModelEvaluationsQueryVariables = Exact<{
  limit: Scalars['Int'];
}>;


export type ModelEvaluationsQuery = { __typename?: 'Query', modelEvaluations: Array<{ __typename?: 'ModelEvaluation', id: string, createdAt: any, completedAt?: any | null, status: string, totalSamples: number, failedPredictions: number, mae?: number | null, rmse?: number | null, r2?: number | null, mape?: number | null, minError?: number | null, maxError?: number | null, meanError?: number | null, medianError?: number | null, modelMetadata?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, percentiles?: { __typename?: 'ModelEvaluationPercentiles', p25: number, p50: number, p75: number, p90: number, p95: number } | null, accuracyBuckets?: { __typename?: 'ModelEvaluationAccuracyBuckets', within100: number, within500: number, within1000: number, within10Percent: number, within25Percent: number } | null }> };

export type MuellerSurveyTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type MuellerSurveyTypesQuery = { __typename?: 'Query', muellerSurveyTypes: { __typename?: 'MuellerSurveyTypes', configured: boolean, orderingEnabled: boolean, surveyTypes: Array<{ __typename?: 'MuellerSurveyType', code: string, name: string }> } };

export type MyAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAccountQuery = { __typename?: 'Query', myAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } };

export type MyInvokablePlaybooksQueryVariables = Exact<{ [key: string]: never; }>;


export type MyInvokablePlaybooksQuery = { __typename?: 'Query', myInvokablePlaybooks: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> };

export type MyPlaybookTriggerQueryVariables = Exact<{
  eventType: Scalars['String'];
  triggerConfig?: InputMaybe<Scalars['JSONObject']>;
}>;


export type MyPlaybookTriggerQuery = { __typename?: 'Query', myPlaybookTrigger?: { __typename?: 'PlaybookTrigger', id: string, userId: string, playbookId: string, eventType: string, triggerConfig?: any | null, lastFiredOn?: any | null, createdAt: any, updatedAt?: any | null, playbook: { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> } } | null };

export type MyPlaybookTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPlaybookTriggersQuery = { __typename?: 'Query', myPlaybookTriggers: Array<{ __typename?: 'PlaybookTrigger', id: string, userId: string, playbookId: string, eventType: string, triggerConfig?: any | null, lastFiredOn?: any | null, createdAt: any, updatedAt?: any | null, playbook: { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> } }> };

export type MyPlaybooksQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPlaybooksQuery = { __typename?: 'Query', myPlaybooks: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> };

export type MySubscribedPlaybooksQueryVariables = Exact<{ [key: string]: never; }>;


export type MySubscribedPlaybooksQuery = { __typename?: 'Query', mySubscribedPlaybooks: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> };

export type NotifyBindVaveQuoteMutationVariables = Exact<{
  vaveQuoteId: Scalars['String'];
}>;


export type NotifyBindVaveQuoteMutation = { __typename?: 'Mutation', bindNotification: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type OpportunitiesQueryVariables = Exact<{
  input: OpportunitiesInput;
}>;


export type OpportunitiesQuery = { __typename?: 'Query', opportunities: Array<{ __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, deletedAt?: any | null, createdAt: any, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, renewalOfPolicies: Array<string>, insuredId: string & { __scalar: "UUID" }, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, state: SubmissionState, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, portalLink?: string | null, isApiSubmission: boolean }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, state: SubmissionState, details?: string | null, createdAt: any }> }> }> };

export type OpportunityBrokerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpportunityBrokerQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null } | null };

export type OpportunityDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpportunityDetailsQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', aiPlacementLaunched: boolean, id: string & { __scalar: "UUID" }, state: MarketingPlanState, isTest: boolean, insuredId: string & { __scalar: "UUID" }, splitOf?: string | null, splitOfInsuredId?: string | null, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, renewalOfPolicies: Array<string>, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } } | null, collaborators: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProductId: string, state: SubmissionState, createdAt: any, indicationPremium?: string & { __scalar: "Decimal" } | null, appetiteProduct: { __typename?: 'AppetiteProduct', portalLink?: string | null, submissionInstructions?: string | null, isApiSubmission: boolean, id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, state: QuoteState, premium?: number | null }>, marketSummaryNotes: Array<{ __typename?: 'SubmissionMarketSummaryNote', id: string & { __scalar: "UUID" }, text: string, createdAt: any, creator: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> }>, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }, secondaryAgents: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, agency: { __typename?: 'Agency', id: string, name: string } }> } } | null };

export type OpportunityEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpportunityEventQuery = { __typename?: 'Query', opportunityEvent: { __typename: 'ActionApprovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ActionDismissedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ActionRejectedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ActionRequestedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AgencyTransferEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AlbyUpdateEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ApplicationSubmittedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AssignmentChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AutomatedFollowUpEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'BotCommentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'BusinessClassCodesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'CollaboratorsChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'CoveragesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'CreatedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'DesiredEffectiveDateChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'EmailEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, email: { __typename?: 'Email', id: string & { __scalar: "UUID" }, to: string, from: string, subject: string, cc?: string | null, body: string, extractedBody: string, dateReceived: any, linkToEmailInGoogleGroups?: string | null } } | { __typename: 'FileUploadEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'GmailMessageEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailMessage: { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } } | { __typename: 'GmailRelayEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailRelay: { __typename?: 'GmailRelay', recipientEmail: string, initiator: { __typename?: 'UserAccount', email: string } }, gmailMessage: { __typename?: 'GmailMessage', html: string, id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } } | { __typename: 'OutcomeChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'PolicyRenewabilityChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ProductsAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ProductsRemovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'RequirementAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'StatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'SubmissionStatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'TriageAssignmentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } } };

export type OpportunityEventsQueryVariables = Exact<{
  input: OpportunityEventsFilterInput;
}>;


export type OpportunityEventsQuery = { __typename?: 'Query', opportunityEvents: Array<{ __typename: 'ActionApprovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ActionDismissedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ActionRejectedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ActionRequestedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AgencyTransferEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AlbyUpdateEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ApplicationSubmittedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AssignmentChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'AutomatedFollowUpEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'BotCommentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'BusinessClassCodesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'CollaboratorsChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'CoveragesChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'CreatedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'DesiredEffectiveDateChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'EmailEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, email: { __typename?: 'Email', id: string & { __scalar: "UUID" }, to: string, from: string, subject: string, cc?: string | null, body: string, extractedBody: string, dateReceived: any, linkToEmailInGoogleGroups?: string | null } } | { __typename: 'FileUploadEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'GmailMessageEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailMessage: { __typename?: 'GmailMessage', id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } } | { __typename: 'GmailRelayEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean, gmailRelay: { __typename?: 'GmailRelay', recipientEmail: string, initiator: { __typename?: 'UserAccount', email: string } }, gmailMessage: { __typename?: 'GmailMessage', html: string, id: string & { __scalar: "UUID" }, headerMessageId: string, to: string, from: string, subject: string, cc?: string | null, replyTo?: string | null, textAsHtml: string, dateReceived: any, attachments: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } } | { __typename: 'OutcomeChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'PolicyRenewabilityChangedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ProductsAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'ProductsRemovedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'RequirementAddedEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'StatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'SubmissionStatusChangeEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'TriageAssignmentEvent', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, opportunityId: string & { __scalar: "UUID" }, createdAt: any, isPublic: boolean } | { __typename: 'UserComment', type: OpportunityEventType, id: string & { __scalar: "UUID" }, text: string, createdAt: any, updatedAt?: any | null, isPublic: boolean, userAccountId: string & { __scalar: "UUID" }, opportunityId: string & { __scalar: "UUID" }, userAccount: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }> };

export type OpportunityJsonDocumentQueryVariables = Exact<{
  opportunityId: Scalars['String'];
  documentId: Scalars['String'];
}>;


export type OpportunityJsonDocumentQuery = { __typename?: 'Query', opportunityJsonDocument: { __typename?: 'OpportunityJsonDocumentPayload', version: number, document: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] } };

export type OpportunityJsonDocumentsQueryVariables = Exact<{
  opportunityId: Scalars['String'];
}>;


export type OpportunityJsonDocumentsQuery = { __typename?: 'Query', opportunityJsonDocuments: Array<{ __typename?: 'OpportunityJsonDocument', id: string, name: string, entityLabel?: string | null, scope: JsonDocumentScope, opportunityId?: string | null, submissionId?: string | null, version: number, updatedAt: any }> };

export type OpportunityNotesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpportunityNotesQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, notes: Array<{ __typename?: 'OpportunityNote', id: string, createdAt: any, authoredByModel: boolean, text: string, creator: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } }> } | null };

export type OpportunityRequirementQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpportunityRequirementQuery = { __typename?: 'Query', agentAction: { __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, actionType: AgentActionType, supplementalForm?: SupplementalForm | null, complete: boolean, expeditedRequirement: boolean } };

export type OpportunityRequirementsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OpportunityRequirementsQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string, agent: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } }, agentActions: Array<{ __typename?: 'AgentAction', id: string & { __scalar: "UUID" }, title: string, description?: string | null, actionType: AgentActionType, supplementalForm?: SupplementalForm | null, complete: boolean, updatedAt?: any | null, completedAt?: any | null, expeditedRequirement: boolean, ui?: { __typename?: 'AgentActionUI', title: string, description: string, steps: Array<{ __typename?: 'AgentActionUIStep', title: string, description: string, elements: Array<{ __typename?: 'AgentActionUIElement', element: string, clientDataKey: string, array: boolean, props: string }> }> } | null, logs: Array<{ __typename?: 'AgentActionLog', id: string, response?: string | null, file?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number, uploader?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null } | null }> }> } | null };

export type OpportunitySubmissionPlacementQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
}>;


export type OpportunitySubmissionPlacementQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, createdByPlacement?: { __typename?: 'SubmissionCreatedByPlacement', taskId: string, provenance: string } | null }> } | null };

export type PaginatedAgenciesQueryVariables = Exact<{
  args?: InputMaybe<AgenciesFilterInput>;
  pagination: PaginationInput;
}>;


export type PaginatedAgenciesQuery = { __typename?: 'Query', paginatedAgencies: { __typename?: 'PaginatedAgencies', numRecords: number, numPages: number, agencies: Array<{ __typename?: 'Agency', id: string, name: string, isTest: boolean, createdAt: any, owner?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null }> } };

export type PaginatedFilesQueryVariables = Exact<{
  input: PaginatedFilesInput;
}>;


export type PaginatedFilesQuery = { __typename?: 'Query', paginatedFiles: { __typename?: 'PaginatedFilesOutput', numRecords: number, files: Array<{ __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number }> } };

export type PaginatedInsuredsQueryVariables = Exact<{
  args?: InputMaybe<InsuredFilterInput>;
  pagination: PaginationInput;
}>;


export type PaginatedInsuredsQuery = { __typename?: 'Query', paginatedInsureds: { __typename?: 'PaginatedInsureds', numRecords: number, numPages: number, insureds: Array<{ __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string }> } };

export type PlacementDeliveryResultsQueryVariables = Exact<{
  input?: InputMaybe<PlacementWorkflowDashboardInput>;
}>;


export type PlacementDeliveryResultsQuery = { __typename?: 'Query', placementDeliveryResults?: { __typename?: 'PlacementDeliveryResults', totalCount: number, offset: number, limit: number, hasMore: boolean, windowStart: any, createdBefore?: any | null, generatedAt: any, rows: Array<{ __typename?: 'PlacementDeliveryResultRow', opportunity: { __typename?: 'PlacementWorkflowOpportunitySummary', id: string, insuredId: string, insuredName: string, createdAt: any, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, broker?: { __typename?: 'PlacementWorkflowBrokerSummary', id?: string | null, name?: string | null } | null }, delivery: { __typename?: 'PlacementDeliveryWitness', opportunityId: string, submissionId: string, quoteId: string, quoteState: string, evidenceKind: PlacementDeliveryEvidenceKind, deliveredAt?: any | null, placementTaskId?: string | null, creationProvenance?: string | null } }> } | null };

export type PlacementDeskDetailQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
  placementId?: InputMaybe<Scalars['ID']>;
  timelineLimit?: InputMaybe<Scalars['Int']>;
  timelineOffset?: InputMaybe<Scalars['Int']>;
}>;


export type PlacementDeskDetailQuery = { __typename?: 'Query', placementDeskDetail?: { __typename?: 'PlacementDeskDetail', timelineError?: string | null, onDesk: boolean, source: PlacementDeskDetailSource, asOf?: any | null, error?: string | null, latestWakeError?: string | null, placement?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, storedState?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, pinnedRun?: { __typename?: 'PlacementDeskPinnedRun', requestedPlacementId?: string | null, placementId?: string | null, latestPlacementId?: string | null, runNumber?: number | null, runCount?: number | null, error?: string | null } | null, runs: Array<{ __typename?: 'PlacementDeskRun', placementId?: string | null, runNumber?: number | null, status?: string | null, createdAt?: any | null }>, journey?: { __typename?: 'PlacementDeskJourney', placementId?: string | null, runNumber?: number | null, runCount?: number | null, launchedAt?: any | null, launchTimeBasis?: PlacementDeskJourneyTimeBasis | null, requestedCoverage: Array<string>, personRequested?: boolean | null, evidenceErrors: Array<string>, brokerageWorkError?: string | null, steps: Array<{ __typename?: 'PlacementDeskJourneyStep', kind?: PlacementDeskJourneyKind | null, marketId?: string | null, marketName?: string | null, state?: PlacementDeskJourneyState | null, evidence?: PlacementDeskJourneyEvidence | null, at?: any | null, timeBasis?: PlacementDeskJourneyTimeBasis | null, actor?: PlacementDeskJourneyActor | null, resultCode?: string | null, detail?: string | null, carriedFromRun?: number | null }>, brokerageWork?: { __typename?: 'PlacementDeskBrokerageWork', after?: any | null, error?: string | null, byHand?: { __typename?: 'PlacementDeskWorkGroup', submissionsCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, submissionsSent?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesDelivered?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null } | null, automatic?: { __typename?: 'PlacementDeskWorkGroup', submissionsCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, submissionsSent?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesDelivered?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null } | null, unattributed?: { __typename?: 'PlacementDeskWorkGroup', submissionsCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, submissionsSent?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesCreated?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null, quotesDelivered?: { __typename?: 'PlacementDeskWorkCount', count?: number | null, firstAt?: any | null } | null } | null } | null } | null, latestWake?: { __typename?: 'PlacementDeskWake', placementId: string, taskId: string, status: string, blockedReason?: string | null, reason?: string | null, createdAt: any, updatedAt: any, readAt: any } | null, desk?: { __typename?: 'PlacementDeskSnapshot', progressTier?: PlacementDeskProgressTier | null, progressEvidenceError?: string | null, recordedDecline?: boolean | null, observerEventsError?: string | null, waitingReason: PlacementDeskWaitingReason, waitingSince?: any | null, furthestStep?: PlacementDeskStep | null, lastDeskActivityAt: any, placementId: string, runNumber: number, runCount: number, signals: Array<string>, undecidedMarketIds: Array<string>, reason?: string | null, status: string, stage?: string | null, outcome?: string | null, revision?: number | null, step: PlacementDeskStep, waitingOn: PlacementDeskWaitingOn, quietMinutes: number, suspectedStall: boolean, nextAction: string, holds: Array<string>, lastProgressAt: any, fetchedAt: any, syncError?: string | null, receipts: Array<{ __typename?: 'PlacementDeskReceipt', placementId?: string | null, runNumber?: number | null, marketId?: string | null, milestone?: string | null, receivedAt?: any | null, eventId?: string | null, attemptId?: string | null, quoteFileId?: string | null, reviewFileId?: string | null, disposition?: string | null, carrierAnswerFileId?: string | null }>, cycleEnded?: { __typename?: 'PlacementDeskCycleEnded', key?: string | null, reason?: string | null } | null, attentionRequests: Array<{ __typename?: 'PlacementDeskAttentionRequest', placementId: string, runNumber?: number | null, attentionId: string, occurrence?: number | null, kind?: string | null, marketId?: string | null, detail?: string | null, targetKind?: string | null, targetSlug?: string | null, taskKey?: string | null, requiredAt?: any | null, resolvedAt?: any | null, resolution?: string | null, open: boolean, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, marketSettlements: Array<{ __typename?: 'PlacementDeskMarketSettlement', placementId: string, runNumber?: number | null, marketId: string, reason?: string | null, attemptId?: string | null, disposition?: string | null, executionStatus?: string | null, terminal?: boolean | null, receivedAt: any, eventId: string, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null }>, marketAnswers: Array<{ __typename?: 'PlacementDeskMarketAnswer', verdict?: string | null, currentness?: string | null, placementId: string, runNumber?: number | null, marketId: string, stage: string, disposition?: string | null, terminal?: boolean | null, executionStatus?: string | null, attemptId?: string | null, resultFileId?: string | null, carrierAnswerFileId?: string | null, receivedAt: any, eventId: string }>, contractMarkets?: Array<{ __typename?: 'PlacementDeskContractMarket', marketId: string, displayName: string }> | null, attention: Array<{ __typename?: 'PlacementDeskAttention', kind: string, marketId?: string | null, detail?: string | null, workerId?: string | null, awaitingTaskId?: string | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, decisions: Array<{ __typename?: 'PlacementDeskMarketDecision', marketId: string, displayName: string, status: string, runNumber: number, placementId: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null }>, lanes: Array<{ __typename?: 'PlacementDeskLane', marketId: string, displayName: string, status: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, phase: string, channel?: string | null, holds: Array<string>, unsupportedIssueCodes: Array<string>, attentionKinds: Array<string>, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null, attention: Array<{ __typename?: 'PlacementDeskLaneAttention', kind: string, detail?: string | null, workerId?: string | null, taskId?: string | null, hook?: string | null, asks?: number | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, portal?: { __typename?: 'PlacementDeskPortal', segmentOrdinal?: number | null, status?: string | null, currentStepId?: string | null, tier?: number | null, currentStepNumber?: number | null, stepCount?: number | null, composition?: Array<{ __typename?: 'PlacementDeskPortalStep', stepId?: string | null, kind?: string | null, coverage?: string | null }> | null, discoveredRequirements?: Array<{ __typename?: 'PlacementDeskPortalRequirement', key?: string | null, label?: string | null, reason?: string | null, type?: string | null, values?: Array<string> | null, min?: number | null, max?: number | null, pageKey?: string | null, source?: string | null }> | null } | null }>, openReviews: Array<{ __typename?: 'PlacementDeskReview', superseded: boolean, hook: string, marketId?: string | null, openedAt: any, taskId: string, humanBound: boolean, awaitingTaskId?: string | null }> } | null, timeline: { __typename?: 'PlacementDeskTimeline', limit: number, offset: number, hasMore: boolean, items: Array<{ __typename?: 'PlacementDeskTimelineItem', id: string, source: string, kind: string, occurredAt: any, observedAt: any, payload: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], milestone?: { __typename?: 'PlacementDeskTimelineMilestone', milestone: string, settlementReason?: string | null, marketId?: string | null, stage?: string | null, disposition?: string | null, terminal?: boolean | null, executionStatus?: string | null, attemptId?: string | null, targetRoleSlug?: string | null, detail?: string | null, attentionId?: string | null, attentionKind?: string | null, taskKey?: string | null, occurrence?: number | null, resolution?: string | null, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null } | null }> } } | null };

export type PlacementDeskSummaryQueryVariables = Exact<{
  input?: InputMaybe<PlacementWorkflowSummaryInput>;
  carrier?: InputMaybe<Scalars['String']>;
}>;


export type PlacementDeskSummaryQuery = { __typename?: 'Query', placementDeskSummary?: { __typename?: 'PlacementDeskSummary', lastLaunchAt?: any | null, lastDeskActivityAt?: any | null, totalPlacements: number, cohortStartedAt?: any | null, closedDealCount?: number | null, closedDealRunCount?: number | null, generatedAt: any, stallThresholdMinutes: number, funnel: { __typename?: 'PlacementDeskFunnel', launched: number, appetiteAnswered?: number | null, reachedPortal: number, carrierAnswered: number, inApp2: number }, teamAsks?: { __typename?: 'PlacementDeskTeamAsks', totalDeals?: number | null, rawMessages: Array<string>, groups: Array<{ __typename?: 'PlacementDeskTeamAskGroup', factKey?: string | null, label?: string | null, dealCount?: number | null }> } | null, carrierMetrics: Array<{ __typename?: 'PlacementDeskCarrierMetric', marketId?: string | null, displayName?: string | null, metric?: { __typename?: 'PlacementCarrierMetric', total: { __typename?: 'PlacementCarrierPeriod', automatedSubmissions: number, manualSubmissions: number, automatedQuoted: number, manualQuoted: number } } | null }>, blockers: Array<{ __typename?: 'PlacementDeskBlocker', id: string, count: number, label: string, marketNames: Array<string>, rawMessages: Array<string>, filters: Array<{ __typename?: 'PlacementDeskDrillFilter', key: string, value: string }> }>, planReviews: { __typename?: 'PlacementDeskPlanReviews', count: number, oldestMinutes?: number | null, tasks: Array<{ __typename?: 'PlacementDeskPersonQueueItem', opportunityId: string, marketId?: string | null }> }, endedUndecidedQueue: Array<{ __typename?: 'PlacementDeskEndedUndecidedItem', opportunityId: string }>, steps: Array<{ __typename?: 'PlacementDeskStepCount', step: PlacementDeskStep, everReachedCount: number }>, launchHealth: { __typename?: 'PlacementDeskLaunchHealth', refusedByReason: Array<{ __typename?: 'PlacementDeskReasonCount', reason: string, count: number }>, failedByErrorCode: Array<{ __typename?: 'PlacementDeskReasonCount', reason: string, count: number }> }, freshness: { __typename?: 'PlacementDeskFreshness', lastSuccessAt?: any | null, lastError?: string | null } } | null };

export type PlacementOpportunityDeliveryEvidenceQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
}>;


export type PlacementOpportunityDeliveryEvidenceQuery = { __typename?: 'Query', placementOpportunityDeliveryEvidence?: { __typename?: 'PlacementOpportunityDeliveryEvidence', opportunityId: string, placementMember: boolean, generatedAt: any, witness?: { __typename?: 'PlacementDeliveryWitness', opportunityId: string, submissionId: string, quoteId: string, quoteState: string, evidenceKind: PlacementDeliveryEvidenceKind, deliveredAt?: any | null, placementTaskId?: string | null, creationProvenance?: string | null } | null } | null };

export type PlacementOpportunityLaunchAttemptsQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
}>;


export type PlacementOpportunityLaunchAttemptsQuery = { __typename?: 'Query', placementOpportunityLaunchAttempts: { __typename?: 'PlacementOpportunityLaunchAttempts', attemptCount: number, failedAttemptCount: number, latestLaunchAttempt?: { __typename?: 'PlacementLaunchAttempt', outcome: string, trigger?: string | null, reason?: string | null, classification?: string | null, errorDomainCode?: string | null, errorCode?: string | null, errorMessage?: string | null, failingOperation?: string | null, observedAt: any } | null, launchAttempts: Array<{ __typename?: 'PlacementLaunchAttempt', outcome: string, trigger?: string | null, reason?: string | null, classification?: string | null, errorDomainCode?: string | null, errorCode?: string | null, errorMessage?: string | null, failingOperation?: string | null, observedAt: any }> } };

export type PlacementWorkflowAttributedDeliveryQueryVariables = Exact<{
  input?: InputMaybe<PlacementWorkflowSummaryInput>;
}>;


export type PlacementWorkflowAttributedDeliveryQuery = { __typename?: 'Query', placementWorkflowSummary: { __typename?: 'PlacementWorkflowSummary', generatedAt?: any | null, windowStart?: any | null, createdBefore?: any | null, quoteDelivery?: { __typename?: 'PlacementWorkflowQuoteDelivery', placementCreatedDeliveredOpportunityCount?: number | null, placementCreatedDeliveredSubmissionCount?: number | null } | null } };

export type PlacementWorkflowDashboardQueryVariables = Exact<{
  input?: InputMaybe<PlacementWorkflowDashboardInput>;
}>;


export type PlacementWorkflowDashboardQuery = { __typename?: 'Query', placementWorkflowDashboard: { __typename?: 'PlacementWorkflowDashboardPage', totalCount: number, numRecords: number, hasMore: boolean, limit: number, offset: number, cohortStartedAt?: any | null, windowStart: any, windowEnd: any, generatedAt: any, freshness: { __typename?: 'PlacementDeskFreshness', lastSuccessAt?: any | null, lastError?: string | null }, rows: Array<{ __typename?: 'PlacementWorkflowDashboardRow', dealDeleted?: boolean | null, dealClosed?: boolean | null, isTestDeal?: boolean | null, outcome?: string | null, outcomeReason?: string | null, opportunity: { __typename?: 'PlacementWorkflowOpportunitySummary', id: string, insuredId: string, insuredName: string, insuredDescription?: string | null, primaryState?: string | null, isoCglCodes: Array<string>, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, createdAt: any, state: string, broker?: { __typename?: 'PlacementWorkflowBrokerSummary', id?: string | null, name?: string | null, email?: string | null } | null }, desk?: { __typename?: 'PlacementDeskSnapshot', progressTier?: PlacementDeskProgressTier | null, progressEvidenceError?: string | null, recordedDecline?: boolean | null, observerEventsError?: string | null, waitingReason: PlacementDeskWaitingReason, waitingSince?: any | null, furthestStep?: PlacementDeskStep | null, lastDeskActivityAt: any, placementId: string, runNumber: number, runCount: number, signals: Array<string>, undecidedMarketIds: Array<string>, reason?: string | null, status: string, stage?: string | null, outcome?: string | null, revision?: number | null, step: PlacementDeskStep, waitingOn: PlacementDeskWaitingOn, quietMinutes: number, suspectedStall: boolean, nextAction: string, holds: Array<string>, lastProgressAt: any, fetchedAt: any, syncError?: string | null, receipts: Array<{ __typename?: 'PlacementDeskReceipt', placementId?: string | null, runNumber?: number | null, marketId?: string | null, milestone?: string | null, receivedAt?: any | null, eventId?: string | null, attemptId?: string | null, quoteFileId?: string | null, reviewFileId?: string | null, disposition?: string | null, carrierAnswerFileId?: string | null }>, cycleEnded?: { __typename?: 'PlacementDeskCycleEnded', key?: string | null, reason?: string | null } | null, attentionRequests: Array<{ __typename?: 'PlacementDeskAttentionRequest', placementId: string, runNumber?: number | null, attentionId: string, occurrence?: number | null, kind?: string | null, marketId?: string | null, detail?: string | null, targetKind?: string | null, targetSlug?: string | null, taskKey?: string | null, requiredAt?: any | null, resolvedAt?: any | null, resolution?: string | null, open: boolean, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, marketSettlements: Array<{ __typename?: 'PlacementDeskMarketSettlement', placementId: string, runNumber?: number | null, marketId: string, reason?: string | null, attemptId?: string | null, disposition?: string | null, executionStatus?: string | null, terminal?: boolean | null, receivedAt: any, eventId: string, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null }>, marketAnswers: Array<{ __typename?: 'PlacementDeskMarketAnswer', verdict?: string | null, currentness?: string | null, placementId: string, runNumber?: number | null, marketId: string, stage: string, disposition?: string | null, terminal?: boolean | null, executionStatus?: string | null, attemptId?: string | null, resultFileId?: string | null, carrierAnswerFileId?: string | null, receivedAt: any, eventId: string }>, contractMarkets?: Array<{ __typename?: 'PlacementDeskContractMarket', marketId: string, displayName: string }> | null, attention: Array<{ __typename?: 'PlacementDeskAttention', kind: string, marketId?: string | null, detail?: string | null, workerId?: string | null, awaitingTaskId?: string | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, decisions: Array<{ __typename?: 'PlacementDeskMarketDecision', marketId: string, displayName: string, status: string, runNumber: number, placementId: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null }>, lanes: Array<{ __typename?: 'PlacementDeskLane', marketId: string, displayName: string, status: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, phase: string, channel?: string | null, holds: Array<string>, unsupportedIssueCodes: Array<string>, attentionKinds: Array<string>, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null, attention: Array<{ __typename?: 'PlacementDeskLaneAttention', kind: string, detail?: string | null, workerId?: string | null, taskId?: string | null, hook?: string | null, asks?: number | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, portal?: { __typename?: 'PlacementDeskPortal', segmentOrdinal?: number | null, status?: string | null, currentStepId?: string | null, tier?: number | null, currentStepNumber?: number | null, stepCount?: number | null, composition?: Array<{ __typename?: 'PlacementDeskPortalStep', stepId?: string | null, kind?: string | null, coverage?: string | null }> | null, discoveredRequirements?: Array<{ __typename?: 'PlacementDeskPortalRequirement', key?: string | null, label?: string | null, reason?: string | null, type?: string | null, values?: Array<string> | null, min?: number | null, max?: number | null, pageKey?: string | null, source?: string | null }> | null } | null }>, openReviews: Array<{ __typename?: 'PlacementDeskReview', superseded: boolean, hook: string, marketId?: string | null, openedAt: any, taskId: string, humanBound: boolean, awaitingTaskId?: string | null }> } | null, wrote: { __typename?: 'PlacementWorkflowSubmissionWriteSummary', count: number, source: PlacementWorkflowSubmissionCountSource } }> } };

export type PlacementWorkflowDispositionsQueryVariables = Exact<{
  input?: InputMaybe<PlacementWorkflowSummaryInput>;
}>;


export type PlacementWorkflowDispositionsQuery = { __typename?: 'Query', placementWorkflowSummary: { __typename?: 'PlacementWorkflowSummary', generatedAt?: any | null, windowStart?: any | null, createdBefore?: any | null, reconciledDispositions?: { __typename?: 'PlacementWorkflowReconciledDispositions', invalidEvidenceCount: number, totalOpportunities: number, noRecordedLaunchEvidence: number, terminalStates: { __typename?: 'PlacementWorkflowTerminalStateSummary', launched: number, refused: number, refusedUnmapped: number, failed: number, abandoned: number, other: number }, refusalReasons: Array<{ __typename?: 'PlacementWorkflowRefusalReason', reason: string, count: number }> } | null } };

export type PlacementWorkflowOpportunityQueryVariables = Exact<{
  opportunityId: Scalars['ID'];
}>;


export type PlacementWorkflowOpportunityQuery = { __typename?: 'Query', placementWorkflowOpportunity?: { __typename?: 'PlacementWorkflowOpportunityDetail', generatedAt: any, row: { __typename?: 'PlacementWorkflowDashboardRow', dealDeleted?: boolean | null, dealClosed?: boolean | null, isTestDeal?: boolean | null, outcome?: string | null, outcomeReason?: string | null, opportunity: { __typename?: 'PlacementWorkflowOpportunitySummary', id: string, insuredId: string, insuredName: string, insuredDescription?: string | null, primaryState?: string | null, isoCglCodes: Array<string>, selectedLinesOfBusiness: Array<string>, desiredEffectiveDate: any, createdAt: any, state: string, broker?: { __typename?: 'PlacementWorkflowBrokerSummary', id?: string | null, name?: string | null, email?: string | null } | null }, desk?: { __typename?: 'PlacementDeskSnapshot', progressTier?: PlacementDeskProgressTier | null, progressEvidenceError?: string | null, recordedDecline?: boolean | null, observerEventsError?: string | null, waitingReason: PlacementDeskWaitingReason, waitingSince?: any | null, furthestStep?: PlacementDeskStep | null, lastDeskActivityAt: any, placementId: string, runNumber: number, runCount: number, signals: Array<string>, undecidedMarketIds: Array<string>, reason?: string | null, status: string, stage?: string | null, outcome?: string | null, revision?: number | null, step: PlacementDeskStep, waitingOn: PlacementDeskWaitingOn, quietMinutes: number, suspectedStall: boolean, nextAction: string, holds: Array<string>, lastProgressAt: any, fetchedAt: any, syncError?: string | null, receipts: Array<{ __typename?: 'PlacementDeskReceipt', placementId?: string | null, runNumber?: number | null, marketId?: string | null, milestone?: string | null, receivedAt?: any | null, eventId?: string | null, attemptId?: string | null, quoteFileId?: string | null, reviewFileId?: string | null, disposition?: string | null, carrierAnswerFileId?: string | null }>, cycleEnded?: { __typename?: 'PlacementDeskCycleEnded', key?: string | null, reason?: string | null } | null, attentionRequests: Array<{ __typename?: 'PlacementDeskAttentionRequest', placementId: string, runNumber?: number | null, attentionId: string, occurrence?: number | null, kind?: string | null, marketId?: string | null, detail?: string | null, targetKind?: string | null, targetSlug?: string | null, taskKey?: string | null, requiredAt?: any | null, resolvedAt?: any | null, resolution?: string | null, open: boolean, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, marketSettlements: Array<{ __typename?: 'PlacementDeskMarketSettlement', placementId: string, runNumber?: number | null, marketId: string, reason?: string | null, attemptId?: string | null, disposition?: string | null, executionStatus?: string | null, terminal?: boolean | null, receivedAt: any, eventId: string, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null }>, marketAnswers: Array<{ __typename?: 'PlacementDeskMarketAnswer', verdict?: string | null, currentness?: string | null, placementId: string, runNumber?: number | null, marketId: string, stage: string, disposition?: string | null, terminal?: boolean | null, executionStatus?: string | null, attemptId?: string | null, resultFileId?: string | null, carrierAnswerFileId?: string | null, receivedAt: any, eventId: string }>, contractMarkets?: Array<{ __typename?: 'PlacementDeskContractMarket', marketId: string, displayName: string }> | null, attention: Array<{ __typename?: 'PlacementDeskAttention', kind: string, marketId?: string | null, detail?: string | null, workerId?: string | null, awaitingTaskId?: string | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, decisions: Array<{ __typename?: 'PlacementDeskMarketDecision', marketId: string, displayName: string, status: string, runNumber: number, placementId: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null }>, lanes: Array<{ __typename?: 'PlacementDeskLane', marketId: string, displayName: string, status: string, outcome?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quote?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, quoteReviewOpen?: boolean | null, phase: string, channel?: string | null, holds: Array<string>, unsupportedIssueCodes: Array<string>, attentionKinds: Array<string>, dispositionReasons?: Array<{ __typename?: 'PlacementDeskDispositionReason', code?: string | null, text?: string | null }> | null, premium?: { __typename?: 'PlacementDeskPremium', amount?: number | null, currency?: string | null, basis?: string | null } | null, quoteReference?: { __typename?: 'PlacementDeskQuoteReference', fileId?: string | null, mediaType?: string | null, size?: number | null } | null, attention: Array<{ __typename?: 'PlacementDeskLaneAttention', kind: string, detail?: string | null, workerId?: string | null, taskId?: string | null, hook?: string | null, asks?: number | null, handoff?: { __typename?: 'PlacementDeskHandoff', kind: string, role?: string | null, wantedFacts: Array<string>, moreFactsOmitted: boolean, ladderStage?: number | null, reviewTaskId?: string | null, handoffTaskId?: string | null, raw?: string | null } | null }>, portal?: { __typename?: 'PlacementDeskPortal', segmentOrdinal?: number | null, status?: string | null, currentStepId?: string | null, tier?: number | null, currentStepNumber?: number | null, stepCount?: number | null, composition?: Array<{ __typename?: 'PlacementDeskPortalStep', stepId?: string | null, kind?: string | null, coverage?: string | null }> | null, discoveredRequirements?: Array<{ __typename?: 'PlacementDeskPortalRequirement', key?: string | null, label?: string | null, reason?: string | null, type?: string | null, values?: Array<string> | null, min?: number | null, max?: number | null, pageKey?: string | null, source?: string | null }> | null } | null }>, openReviews: Array<{ __typename?: 'PlacementDeskReview', superseded: boolean, hook: string, marketId?: string | null, openedAt: any, taskId: string, humanBound: boolean, awaitingTaskId?: string | null }> } | null, wrote: { __typename?: 'PlacementWorkflowSubmissionWriteSummary', count: number, source: PlacementWorkflowSubmissionCountSource } }, submissions: Array<{ __typename?: 'PlacementWorkflowSubmissionSummary', id: string, state: string, createdAt: any, appetiteProductId: string, carrierName?: string | null, productName?: string | null }> } | null };

export type PlacementWorkflowSummaryQueryVariables = Exact<{
  input?: InputMaybe<PlacementWorkflowSummaryInput>;
}>;


export type PlacementWorkflowSummaryQuery = { __typename?: 'Query', placementWorkflowSummary: { __typename?: 'PlacementWorkflowSummary', totalOpportunities: number, createdNotEvaluated: number, quoteDelivery?: { __typename?: 'PlacementWorkflowQuoteDelivery', opportunitiesReachedUploadQuote?: number | null, opportunitiesWithUploadQuoteEvidence?: number | null, deliveredSubmissionCount?: number | null, deliveredOpportunityCount?: number | null, deliveryRate?: number | null, observedDeliveryRate?: number | null } | null, terminalStates: { __typename?: 'PlacementWorkflowTerminalStateSummary', launched: number, refused: number, refusedUnmapped: number, failed: number, abandoned: number, other: number } } };

export type PlaybookQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlaybookQuery = { __typename?: 'Query', playbook: { __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, files: Array<{ __typename?: 'PlaybookFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> } };

export type PlaybookRunQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type PlaybookRunQuery = { __typename?: 'Query', playbookRun?: { __typename?: 'PlaybookRunDto', id: string, playbookId: string, parentPlaybookRunId?: string | null, parentChatSessionId?: string | null, rootChatSessionId?: string | null, depth?: number | null, toolInvocationId?: string | null, chatSessionId?: string | null, conversationId?: string | null, opportunityId?: string | null, triggerEventType?: string | null, parameterValues?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, status: string, errorMessage?: string | null, startedAt: any, finishedAt?: any | null, totalInputTokens?: number | null, totalOutputTokens?: number | null, aiCallCount?: number | null, playbook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string }, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, toolInvocations: Array<{ __typename?: 'McpToolInvocationDto', id: string, status: string, toolName: string, toolCallId?: string | null, calledAt: any, finishedAt?: any | null, toolInput: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], toolOutput?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null }> } | null };

export type PlaybookRunsQueryVariables = Exact<{
  chatSessionId?: InputMaybe<Scalars['String']>;
}>;


export type PlaybookRunsQuery = { __typename?: 'Query', playbookRuns: Array<{ __typename?: 'PlaybookRunDto', id: string, playbookId: string, parentPlaybookRunId?: string | null, parentChatSessionId?: string | null, rootChatSessionId?: string | null, depth?: number | null, toolInvocationId?: string | null, chatSessionId?: string | null, conversationId?: string | null, opportunityId?: string | null, triggerEventType?: string | null, parameterValues?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, status: string, errorMessage?: string | null, startedAt: any, finishedAt?: any | null, totalInputTokens?: number | null, totalOutputTokens?: number | null, aiCallCount?: number | null, playbook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string }, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, toolInvocations: Array<{ __typename?: 'McpToolInvocationDto', id: string, status: string, toolName: string, toolCallId?: string | null, calledAt: any, finishedAt?: any | null, toolInput: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], toolOutput?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null }> }> };

export type PlaybookRunsForConversationQueryVariables = Exact<{
  conversationId: Scalars['String'];
}>;


export type PlaybookRunsForConversationQuery = { __typename?: 'Query', playbookRunsForConversation: Array<{ __typename?: 'PlaybookRunDto', id: string, playbookId: string, parentPlaybookRunId?: string | null, parentChatSessionId?: string | null, rootChatSessionId?: string | null, depth?: number | null, toolInvocationId?: string | null, chatSessionId?: string | null, conversationId?: string | null, opportunityId?: string | null, triggerEventType?: string | null, parameterValues?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, status: string, errorMessage?: string | null, startedAt: any, finishedAt?: any | null, totalInputTokens?: number | null, totalOutputTokens?: number | null, aiCallCount?: number | null, playbook: { __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string }, user?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null, toolInvocations: Array<{ __typename?: 'McpToolInvocationDto', id: string, status: string, toolName: string, toolCallId?: string | null, calledAt: any, finishedAt?: any | null, toolInput: string | boolean | number | Record<string, any> | string[] | boolean[] | number[], toolOutput?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null }> }> };

export type PlaybookSetByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PlaybookSetByIdQuery = { __typename?: 'Query', playbookSet: { __typename?: 'PlaybookSet', id: string, name: string, description?: string | null, playbookCount: number, isSubscribed: boolean, playbooks?: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> | null } };

export type PlaybookSetMembershipsQueryVariables = Exact<{
  playbookId: Scalars['String'];
}>;


export type PlaybookSetMembershipsQuery = { __typename?: 'Query', playbookSetMemberships: Array<string> };

export type PlaybookSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaybookSetsQuery = { __typename?: 'Query', playbookSets: Array<{ __typename?: 'PlaybookSet', id: string, name: string, description?: string | null, playbookCount: number, isSubscribed: boolean, playbooks?: Array<{ __typename?: 'Playbook', id: string, userId: string, copiedFromPlaybookId?: string | null, name: string, description?: string | null, workflow: string, type: PlaybookType, parametersDescription?: string | null, templateParamSchema?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, modelTier?: ModelTier | null, createdAt: any, updatedAt?: any | null, toolFilter?: { __typename?: 'ToolFilterType', whitelist?: Array<string> | null, blacklist?: Array<string> | null } | null, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, subscribers: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string }> }> | null }> };

export type PoliciesListQueryVariables = Exact<{
  input: PolicyFilterInput;
}>;


export type PoliciesListQuery = { __typename?: 'Query', policies: Array<{ __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null } }> };

export type PolicyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PolicyQuery = { __typename?: 'Query', policy: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, insuredId: string, opportunityId: string, quoteId: string, state: PolicyState, policyNumber: string, effectiveDate?: any | null, expirationDate?: any | null, createdAt: any, lastTransitionAt: any, awaitingSubjectivities: boolean, endorsementsRequested: boolean, policyFileId?: string | null, stampedPolicyFileId?: string | null, redactedBinderFileId?: string | null, processedBinderFileId?: string | null, bindHqPolicyId?: string | null, isRenewable?: boolean | null, bindHqPolicy: { __typename?: 'BindHqPolicy', id: string, status?: string | null }, attributedTo?: { __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } } | null, taxDocumentRequirements?: Array<{ __typename?: 'TaxDocumentRequirement', taxDocument: { __typename?: 'StateDocument', id: string, transactionId: string, code: string, name: string, documentNote: string, requiredForFiling: boolean, requiredForBinding: boolean, uploadRequired: boolean }, fileUpload?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null }> | null, policyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stampedPolicyFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedBinderFile?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originatorId: string }>, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null } } };

export type PolicyFileTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type PolicyFileTypesQuery = { __typename?: 'Query', policyFileTypes: PolicyFileType };

export type PolicyAgentEmailPreviewQueryVariables = Exact<{
  policyId: Scalars['ID'];
  kind: PolicyAgentEmailKind;
}>;


export type PolicyAgentEmailPreviewQuery = { __typename?: 'Query', policyAgentEmailPreview: { __typename?: 'PolicyAgentEmailPreview', html: string } };

export type PolicyAscendInvoiceQueryVariables = Exact<{
  policyId: Scalars['ID'];
}>;


export type PolicyAscendInvoiceQuery = { __typename?: 'Query', policyAscendInvoice: { __typename?: 'AscendInvoiceLookup', outcome: AscendInvoiceLookupOutcome, invoiceId?: string | null, invoiceNumber?: string | null, totalCents?: number | null, status?: string | null, emailLine?: string | null, pdfFilename?: string | null, matchedPolicyNumber?: string | null, ascendUrl?: string | null, candidateUrls?: Array<string> | null, policyPremium?: number | null } };

export type ProcessVaveQuoteMutationVariables = Exact<{
  input: ProcessVaveQuoteInput;
}>;


export type ProcessVaveQuoteMutation = { __typename?: 'Mutation', processQuote: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type ProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', historicalInsights?: string | boolean | number | Record<string, any> | string[] | boolean[] | number[] | null, id: string, userId: string, name: string, workflow: string, createdAt: any, updatedAt?: any | null, enabled: boolean, marketType?: MarketTypes | null, carrierId?: string | null, lineOfBusinessIds?: Array<string> | null, grossCommission?: number | null, carrier?: { __typename?: 'Carrier', id: string, name: string, slug: string } | null, linesOfBusiness?: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> | null, files: Array<{ __typename?: 'ProductFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, submissionCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }>, referenceCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> } };

export type ProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: string, userId: string, name: string, workflow: string, createdAt: any, updatedAt?: any | null, enabled: boolean, marketType?: MarketTypes | null, carrierId?: string | null, lineOfBusinessIds?: Array<string> | null, grossCommission?: number | null, carrier?: { __typename?: 'Carrier', id: string, name: string, slug: string } | null, linesOfBusiness?: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> | null, files: Array<{ __typename?: 'ProductFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, submissionCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }>, referenceCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> }> };

export type ProductsByCarrierQueryVariables = Exact<{
  carrierSlug: Scalars['String'];
}>;


export type ProductsByCarrierQuery = { __typename?: 'Query', productsByCarrier: Array<{ __typename?: 'Product', id: string, userId: string, name: string, workflow: string, createdAt: any, updatedAt?: any | null, enabled: boolean, marketType?: MarketTypes | null, carrierId?: string | null, lineOfBusinessIds?: Array<string> | null, grossCommission?: number | null, carrier?: { __typename?: 'Carrier', id: string, name: string, slug: string } | null, linesOfBusiness?: Array<{ __typename?: 'LineOfBusiness', id: string, displayName: string, code?: string | null }> | null, files: Array<{ __typename?: 'ProductFile', id: string, fileUploadId: string, filename: string, mimeType: string, size: number }>, author?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null, submissionCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }>, referenceCarrierContacts: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> }> };

export type ProposalValuesQueryVariables = Exact<{
  input: QuoteProposalValuesInput;
}>;


export type ProposalValuesQuery = { __typename?: 'Query', proposalValues?: { __typename?: 'QuoteProposalValues', stampingFee?: number | null, mep?: number | null, carrierName?: string | null, premium?: number | null, subjectivities?: Array<string> | null, insuredName?: string | null, effectiveDate?: string | null, lines?: Array<string> | null, homeState?: string | null, agentFirstName?: string | null, agencyName?: string | null, agentCommission?: number | null, grossCommission?: number | null, surplusLinesTaxes?: number | null, brokerFee?: number | null, inspectionFee?: number | null, totalPremium?: number | null, admitted: boolean } | null };

export type QuoteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuoteQuery = { __typename?: 'Query', quote: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> } };

export type QuoteEmailPreviewQueryVariables = Exact<{
  quoteId: Scalars['ID'];
}>;


export type QuoteEmailPreviewQuery = { __typename?: 'Query', quoteEmailPreview: { __typename?: 'QuoteEmailPreview', html: string, newEmailSubject: string, replyThreadCandidates: Array<{ __typename?: 'QuoteEmailReplyThreadCandidate', id: string, subject: string, lastMessageAt?: any | null }> } };

export type QuoteInspectionSurveyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuoteInspectionSurveyQuery = { __typename?: 'Query', quote: { __typename?: 'Quote', id: string & { __scalar: "UUID" }, inspectionSurveyRequest?: InspectionSurveyRequest | null, inspectionSurveyNote?: string | null } };

export type QuotesQueryVariables = Exact<{
  input: QuotesInput;
}>;


export type QuotesQuery = { __typename?: 'Query', quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }> };

export type RecentChatSessionsMenuItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentChatSessionsMenuItemsQuery = { __typename?: 'Query', recentChatSessionsMenuItems: Array<{ __typename?: 'ChatSessionMenuItem', id: string, displayTitle: string, insuredId?: string | null, inboxConversationId?: string | null, lastMessageAt?: any | null }> };

export type ReinstateVaveQuoteMutationVariables = Exact<{
  input: ReinstateVaveQuoteInput;
}>;


export type ReinstateVaveQuoteMutation = { __typename?: 'Mutation', reinstate: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type EndorsementDataFieldsFragment = { __typename?: 'EndorsementData', totalPremium: number, totalRevenue: number, endorsements: Array<{ __typename?: 'EndorsementRevenueComponent', type: string, grossCommissionPercentage: number, agentCommissionPercentage: number, premium: number, brokerFee: number, total: number }> };

export type RenewalsDataQueryVariables = Exact<{
  input?: InputMaybe<RenewalsDataInput>;
}>;


export type RenewalsDataQuery = { __typename?: 'Query', renewalsData: Array<{ __typename?: 'ExpiringPolicy', id: string, policyId: string, state: string, isRenewable?: boolean | null, policyHasRenewal: boolean, attributedTo?: { __typename?: 'RenewalDataBroker', firstName: string, lastName: string, attributionRole?: string | null } | null, renewalOpportunity?: { __typename?: 'RenewalOpportunity', id: string, classificationLabels: Array<string>, selectedLinesOfBusiness: Array<string>, renewalStatusRecord?: { __typename?: 'RenewalStatus', status?: string | null, bindingStatus?: string | null, updatedAt: any, latestLog?: { __typename?: 'RenewalStatusLog', id: string, previousStatus?: string | null, newStatus: string, createdAt: any } | null } | null, renewalNotes: Array<{ __typename?: 'RenewalNote', id: string, text: string, updatedAt: any, isRead: boolean, author: { __typename?: 'RenewalNoteAuthor', id: string, firstName: string, lastName: string } }>, broker?: { __typename?: 'RenewalDataBroker', id: string, firstName: string, lastName: string } | null, submissions: Array<{ __typename?: 'RenewalSubmission', id: string, appetiteProduct: { __typename?: 'RenewalAppetiteProduct', carrierName: string, carrierProductName: string }, quotes: Array<{ __typename?: 'RenewalQuote', id: string, state: string, premium?: number | null, brokerFee?: number | null, agentCommission?: number | null, grossCommission?: number | null, policy?: { __typename?: 'RenewalPolicy', id: string, endorsementData?: { __typename?: 'EndorsementData', totalPremium: number, totalRevenue: number, endorsements: Array<{ __typename?: 'EndorsementRevenueComponent', type: string, grossCommissionPercentage: number, agentCommissionPercentage: number, premium: number, brokerFee: number, total: number }> } | null } | null }> }> } | null, bindHqPolicy: { __typename?: 'ExpiringBindHqPolicy', id: string, policyNumber: string, businessType?: string | null, linesOfBusiness: Array<string>, effectiveDate?: string | null, expirationDate?: string | null, status?: string | null, marketingCompanyName?: string | null, endorsementData?: { __typename?: 'EndorsementData', totalPremium: number, totalRevenue: number, endorsements: Array<{ __typename?: 'EndorsementRevenueComponent', type: string, grossCommissionPercentage: number, agentCommissionPercentage: number, premium: number, brokerFee: number, total: number }> } | null }, quote: { __typename?: 'ExpiringQuote', id: string, premium?: number | null, brokerFee?: number | null, agentCommission?: number | null, grossCommission?: number | null, submission: { __typename?: 'ExpiringSubmission', id: string, opportunity: { __typename?: 'ExpiringOpportunity', id: string, insured: { __typename?: 'RenewalDataInsured', id: string, name: string, agent: { __typename?: 'RenewalDataAgent', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, agency: { __typename?: 'RenewalDataAgency', id: string, name: string } }, secondaryAgents: Array<{ __typename?: 'RenewalDataAgent', id: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, agency: { __typename?: 'RenewalDataAgency', id: string, name: string } }> } } } } }> };

export type RequestBindVaveQuoteMutationVariables = Exact<{
  vaveQuoteId: Scalars['String'];
}>;


export type RequestBindVaveQuoteMutation = { __typename?: 'Mutation', bindRequest: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type SearchAppetiteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SearchAppetiteQuery = { __typename?: 'Query', appetiteSearchForOpportunity: { __typename?: 'AppetiteSearchResult', scoredProducts: Array<{ __typename?: 'ScoredAppetiteProduct', product: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, authority: Array<string>, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, bindingGuideResults: Array<{ __typename?: 'BindingGuideResult', id: string, cgl: string, lob: string, result: BindingAuthority, explanation?: string | null }> } }> } };

export type SearchAppetiteForOpportunityQueryVariables = Exact<{
  id: Scalars['ID'];
  includeAiScores?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchAppetiteForOpportunityQuery = { __typename?: 'Query', appetiteSearchForOpportunity: { __typename?: 'AppetiteSearchResult', scoredProducts: Array<{ __typename?: 'ScoredAppetiteProduct', score: number, reasons?: Array<string> | null, previouslyQuotedCount: number, estimatedQwSpread?: number | null, product: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierSlug?: string | null, carrierProductName?: string | null, productDescription?: string | null, coverages: string, coreLines: Array<string>, marketType?: MarketTypes | null, grossCommission?: number | null } }> } };

export type SearchBusinessClassesQueryVariables = Exact<{
  input: BusinessClassificationsSearchInput;
}>;


export type SearchBusinessClassesQuery = { __typename?: 'Query', searchBusinessClasses: Array<{ __typename?: 'BusinessClass', id?: string | null, description?: string | null, system: BusinessClassSystem, code: string }> };

export type SelectProductsOpportunityQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectProductsOpportunityQuery = { __typename?: 'Query', appetiteProductLines: Array<string> };

export type StampedPolicyFiguresQueryVariables = Exact<{
  policyId: Scalars['ID'];
}>;


export type StampedPolicyFiguresQuery = { __typename?: 'Query', stampedPolicyFigures: { __typename?: 'StampedPolicyFigures', premium?: number | null, surplusLinesTax?: number | null, stampingFee?: number | null, surplusLinesServiceCharge?: number | null, fireMarshallTax?: number | null, municipalFee?: number | null, countyFee?: number | null, empaTax?: number | null, carrierFee?: number | null, inspectionFee?: number | null, brokerFee?: number | null, policyNumber: string, effectiveDate?: string | null, expirationDate?: string | null, reviewToken: string, bindHqFigureChecks?: Array<{ __typename?: 'BindHqFigureCheck', fields: Array<string>, status: BindHqFigureCheckStatus, ours: number, bindHq?: number | null }> | null } };

export type StateTransitionsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StateTransitionsQuery = { __typename?: 'Query', opportunity?: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, stateTransitions: Array<{ __typename?: 'MarketingPlanStateTransition', id: string, marketingPlanId: string, originatorId: string, previousState: MarketingPlanState, state: MarketingPlanState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null }>, submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null }, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, originatorId: string, previousState: SubmissionState, state: SubmissionState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null }>, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, originatorId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null }>, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" }, stateTransitions: Array<{ __typename?: 'PolicyStateTransition', id: string, policyId: string, originatorId: string, previousState: PolicyState, state: PolicyState, createdAt: any, originator?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string } | null }> } | null }> }> } | null };

export type StrandedRecordsBannerQueryVariables = Exact<{
  survivorId: Scalars['UUID'];
}>;


export type StrandedRecordsBannerQuery = { __typename?: 'Query', strandedRecordsForInsured: { __typename?: 'InsuredRecoveryPreview', survivorId: string, hasStrandedRecords: boolean, unfinishedMerges: Array<{ __typename?: 'InsuredUnfinishedMerge', id: string, name: string }> } };

export type StrandedRecordsForInsuredQueryVariables = Exact<{
  survivorId: Scalars['UUID'];
}>;


export type StrandedRecordsForInsuredQuery = { __typename?: 'Query', strandedRecordsForInsured: { __typename?: 'InsuredRecoveryPreview', survivorId: string, hasStrandedRecords: boolean, previewHash: string, totals: { __typename?: 'InsuredRecoveryCounts', conversations: number, drafts: number, opportunities: number, files: number, gmailThreads: number }, unfinishedMerges: Array<{ __typename?: 'InsuredUnfinishedMerge', id: string, name: string, reason: string, unfinishedInsuredName?: string | null }>, sources: Array<{ __typename?: 'InsuredRecoverySource', id: string, name: string, crossAgency: boolean, deprecatedAgency: { __typename?: 'InsuredMergePreviewAgency', id: string, name: string }, survivorAgency: { __typename?: 'InsuredMergePreviewAgency', id: string, name: string }, opportunities: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, name?: string | null, state?: string | null }> }, files: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, name?: string | null }> }, gmailThreads: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, subject?: string | null }> }, drafts: { __typename?: 'InsuredMergePreviewRecords', count: number, records: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, subject?: string | null, sent?: boolean | null }> }, conversations: { __typename?: 'InsuredMergePreviewConversations', count: number, inboxes: Array<{ __typename?: 'InsuredMergePreviewInbox', inboxId: string, email: string, ownerId?: string | null, ownerName?: string | null, ownerEmail?: string | null, inboxDeleted: boolean, userDeleted: boolean, count: number, conversations: Array<{ __typename?: 'InsuredMergePreviewRecord', id: string, subject?: string | null }> }> } }> } };

export type SubmissionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmissionQuery = { __typename?: 'Query', submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProductId: string, bindHqApplicationId?: string | null, state: SubmissionState, createdAt: any, updatedAt?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> } };

export type SubmissionContextQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmissionContextQuery = { __typename?: 'Query', submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, selectedLinesOfBusiness: Array<string>, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string } } } };

export type SubmissionDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubmissionDetailsQuery = { __typename?: 'Query', submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, state: SubmissionState, createdAt: any, updatedAt?: any | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, insured: { __typename?: 'Insured', primaryState?: string | null } } } };

export type SubmissionsQueryVariables = Exact<{
  args: SubmissionsFilterInput;
}>;


export type SubmissionsQuery = { __typename?: 'Query', submissions: { __typename?: 'SubmissionResponse', submissions: Array<{ __typename?: 'Submission', id: string & { __scalar: "UUID" }, state: SubmissionState, personalizedEmailSubmissionBody?: string | null, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', email: string }> | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState, desiredEffectiveDate: any, insured: { __typename?: 'Insured', id: string & { __scalar: "UUID" }, name: string }, broker?: { __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string } | null } }> } };

export type TeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamsQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: string, name: string, description?: string | null, createdAt: any, updatedAt?: any | null, members: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" } }> }> };

export type TeamQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TeamQuery = { __typename?: 'Query', team?: { __typename?: 'Team', id: string, name: string, description?: string | null, createdAt: any, updatedAt?: any | null, members: Array<{ __typename?: 'UserAccount', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, roles: Array<Roles> }> } | null };

export type TranscriptionContextQueryVariables = Exact<{
  chatSessionId: Scalars['String'];
}>;


export type TranscriptionContextQuery = { __typename?: 'Query', transcriptionContext: { __typename?: 'TranscriptionContext', prompt: string } };

export type UnderwritingAssistantAccountsQueryVariables = Exact<{
  input?: UserAccountFindManyFilter;
}>;


export type UnderwritingAssistantAccountsQuery = { __typename?: 'Query', userAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type UniversalSearchQueryVariables = Exact<{
  term: Scalars['String'];
}>;


export type UniversalSearchQuery = { __typename?: 'Query', search: Array<{ __typename?: 'SearchResult', id: string, insuredId: string & { __scalar: "UUID" }, insuredName: string, type: SearchResultType }> };

export type UserAccountsQueryVariables = Exact<{
  input: UserAccountFindManyFilter;
}>;


export type UserAccountsQuery = { __typename?: 'Query', userAccounts: Array<{ __typename: 'UserAccount', id: string & { __scalar: "UUID" }, createdAt: any, bindHqId?: string | null, firstName: string, lastName: string, email: string, roles: Array<Roles>, internal: boolean, agencyId: string & { __scalar: "UUID" }, assignmentsEnabled: boolean, assignmentGroups?: Array<AssignmentGroup> | null, avatarUrl?: string | null, phone?: string | null, agency: { __typename?: 'Agency', id: string, name: string, bindHqId?: string | null, isTest: boolean } }> };

export type UserPlaybooksQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UserPlaybooksQuery = { __typename?: 'Query', userPlaybooks: Array<{ __typename?: 'Playbook', id: string, name: string, description?: string | null, workflow: string, type: PlaybookType, updatedAt?: any | null }> };

export type VaveQuoteQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type VaveQuoteQuery = { __typename?: 'Query', vaveQuote: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type VaveQuoteByPolicyQueryVariables = Exact<{
  policyId: Scalars['String'];
}>;


export type VaveQuoteByPolicyQuery = { __typename?: 'Query', vaveQuoteByPolicyId: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } };

export type VaveQuoteByQuoteIdQueryVariables = Exact<{
  quoteId: Scalars['String'];
}>;


export type VaveQuoteByQuoteIdQuery = { __typename?: 'Query', vaveQuoteByQuoteId?: { __typename?: 'VaveQuote', bindRequestedAt?: any | null, bindRequestedExpiry?: any | null, bindRequestedInception?: any | null, externalPolicyId?: string | null, id: string, quoteId?: string | null, policyId?: string | null, policyReference?: string | null, submissionId: string, updatedAt?: any | null, validUntil?: any | null, input: { __typename?: 'VavePricingPayload', DomainName: string, EnhancementEndorsement: string, EquipmentBreakdown: boolean, EquipmentBreakdownBIEEDed?: string | null, EquipmentBreakdownContactName?: string | null, EquipmentBreakdownContactNumber?: string | null, EquipmentBreakdownPropertyDed?: number | null, Expiry: string, Inception: string, IsCommercialCondoUnit: boolean, IsLessorsRisk: boolean, PolicyholderName: string, TRIACoverage: boolean, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, BuildingInformation: Array<{ __typename?: 'VavePricingBuilding', BuildingId?: string | null, BuildingName: string, BuildingNo: number, BuildingDescription: string, Form: string, Address: { __typename?: 'VavePricingAddress', City: string, State: string, StreetAddress: string, ZipCode: string }, Attributes: { __typename?: 'VavePricingBuildingAttributes', AutomaticWaterShutOff?: boolean | null, BasementType?: string | null, BurglarySafeguards: Array<string>, CladdingType: string, Construction: string, ElectricType: string, ElectricUpgradeType?: string | null, ElectricUpgradeYear?: number | null, FireProtectionClass: string, FireSafeguards: Array<string>, FloorAreaSqFt: number, HeatingType: string, HeatingUpgradeType?: string | null, HeatingUpgradeYear?: number | null, NumberOfStories: number, NumberOfUnitsInBuilding?: number | null, Occupancy: string, OriginalYearBuilt: number, PlumbingType: string, PlumbingUpgradeType?: string | null, PlumbingUpgradeYear?: number | null, RentalType?: string | null, RoofAnchorageMethod?: string | null, RoofCoveringMaterial: string, RoofGeometry: string, RoofUpgradeType?: string | null, RoofUpgradeYear?: number | null, Sprinklers: boolean, StructuralUpgradeYear?: number | null, WindowProtectionType?: string | null, EarthquakeInfo?: { __typename?: 'VavePricingEarthquakeInfo', RetrofittedMasonry: boolean, SoftStory: boolean } | null, FloodInfo?: { __typename?: 'VavePricingFloodInfo', FloodZone: string, PropertyOverWater: boolean } | null }, ClaimsLast3Years?: Array<{ __typename?: 'VavePricingClaims', Amount: number, ClaimDate: string, Description: string, FullyRepaired: boolean, Type: string }> | null, Coverages: { __typename?: 'VavePricingBuildingCoverages', BIExtraExpenseIncluded?: boolean | null, BusinessIncomeCoInsurance?: string | null, BusinessIncomeLimit: number, BusinessPersonalPropertyLimit: number, BusinessPersonalPropertyCoInsurance: string, BusinessPersonalPropertyValuation: string, BuildingValueCoInsurance: string, BuildingValueLimit: number, BuildingValueValuation: string }, LimitsAndDeductibles: { __typename?: 'VavePricingLimitsAndDeductibles', ACVOnRoof: boolean, AOPDeductibleValue?: number | null, EarthquakeDed?: string | null, ExcludeRoofCover: boolean, FloodBuildingLimit?: number | null, FloodContentsLimit?: number | null, FloodDeductible?: number | null, IncludeAopCover: boolean, IncludeEarthquakeCover: boolean, IncludeFloodCover: boolean, IncludeSinkholeCover: boolean, IncludeSprinklerLeakageCover: boolean, IncludeTheftCover: boolean, IncludeVandalismCover: boolean, IncludeWaterDamageCover: boolean, IncludeWindCover: boolean, TheftDeductible?: number | null, TheftSublimit?: number | null, WaterDamageSublimit?: number | null, WindDed?: string | null, WindDedType?: string | null }, OptionalEndorsements: { __typename?: 'VavePricingOptionalEndorsements', LossAssessmentForCondo?: { __typename?: 'VaveLossAssessmentForCondo', Deductible: number, Limit: number } | null, OutdoorSignsCover?: Array<{ __typename?: 'VaveOutdoorSignsCover', Construction: string, Description: string, Limit: number }> | null, OrdinanceAndLawCover?: { __typename?: 'VaveOrdinanceAndLawCover', CoverageA: boolean, CoverageB?: number | null, CoverageC?: number | null, CoverageBAndCCombined?: number | null } | null, PeakSeasonCover?: Array<{ __typename?: 'VavePeakSeasonCover', CoveredProperty: string, From: string, Limit: number, To: string }> | null } }> }, pricingOptions?: Array<{ __typename?: 'VavePricingOption', enhancementsPremium: number, equipmentBreakdownPremium: number, policyPremium: number, pricingOptionId: string, totalGrossPremium: number, triaPremium: number, buildings: Array<{ __typename?: 'VavePricingOptionBuilding', buildingId: string, biPremium: number, buildingNo: number, buildingPremium: number, contentsPremium: number, earthquakePremium?: number | null, floodPremium?: number | null, totalPremium: number, optionalEndorsementPremiums: { __typename?: 'VavePricingOptionalEndorsementPremiums', lossAssessmentForCondo: number, ordinanceAndLawPremium: number, outdoorSignsCover: number, peakSeasonCover: number } }>, extraProposedOptions?: { __typename?: 'VaveExtraProposedOptions', proposedTriaPremium: number } | null }> | null, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string } } | null };

export type VaveQuoteProposalQueryVariables = Exact<{
  vaveQuoteId: Scalars['String'];
}>;


export type VaveQuoteProposalQuery = { __typename?: 'Query', vaveQuoteProposal: { __typename?: 'VaveQuoteProposalValues', agentCommission: number, agentFirstName: string, agencyName: string, brokerFee: number, carrierFee: number, carrierName: string, effectiveDate: string, grossCommission?: number | null, homeState: string, inspectionFee: number, insuredName: string, lines: Array<string>, mep: number, premium: number, subjectivities: Array<string> } };

export type AttentionFeedChangedSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type AttentionFeedChangedSubscription = { __typename?: 'Subscription', attentionFeedChanged: { __typename?: 'AttentionFeedChangedOutput', recipientId: string, changeType?: AttentionFeedChangeType | null, attentionItemId?: string | null } };

export type ChatSessionCompletedSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type ChatSessionCompletedSubscription = { __typename?: 'Subscription', chatSessionCompleted: { __typename?: 'ChatSessionCompletedOutput', chatSessionId: string, status: ChatSessionStatus, userId?: string | null } };

export type ChatSessionLiveStreamStartedSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type ChatSessionLiveStreamStartedSubscription = { __typename?: 'Subscription', chatSessionLiveStreamStarted: { __typename?: 'ChatSessionLiveStreamStartedOutput', chatSessionId: string, userId?: string | null } };

export type ChatSessionStatusChangedSubscriptionVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>;
}>;


export type ChatSessionStatusChangedSubscription = { __typename?: 'Subscription', chatSessionStatusChanged: { __typename?: 'ChatSessionStatusChangedOutput', chatSessionId: string, status: ChatSessionStatus, userId?: string | null } };

export type ChatSessionStreamStateChangedSubscriptionVariables = Exact<{
  chatSessionId: Scalars['String'];
}>;


export type ChatSessionStreamStateChangedSubscription = { __typename?: 'Subscription', chatSessionStreamStateChanged: { __typename?: 'ChatSessionStreamState', chatSessionId: string, kind: ChatSessionStreamStateKind, error?: string | null, userId?: string | null, formatVersion: string } };

export type ConversationHistoryChangedSubscriptionVariables = Exact<{
  rootChatSessionId: Scalars['String'];
}>;


export type ConversationHistoryChangedSubscription = { __typename?: 'Subscription', conversationHistoryChanged: { __typename?: 'ConversationHistoryChangedOutput', rootChatSessionId: string } };

export type InboxConversationUpdatedSubscriptionVariables = Exact<{
  conversationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  inboxId?: InputMaybe<Scalars['String']>;
}>;


export type InboxConversationUpdatedSubscription = { __typename?: 'Subscription', inboxConversationUpdated: { __typename?: 'InboxConversationUpdatedOutput', conversationId: string, email: string, inboxId?: string | null } };

export type InboxDraftSentSubscriptionVariables = Exact<{
  email: Scalars['String'];
}>;


export type InboxDraftSentSubscription = { __typename?: 'Subscription', inboxDraftSent: { __typename?: 'InboxDraftSentEventOutput', email: string, draftId: string } };

export type InboxLabelCountsUpdatedSubscriptionVariables = Exact<{
  email: Scalars['String'];
}>;


export type InboxLabelCountsUpdatedSubscription = { __typename?: 'Subscription', inboxLabelCountsUpdated: { __typename?: 'InboxLabelCountsUpdatedOutput', email: string } };

export type InboxMessageCreatedSubscriptionVariables = Exact<{
  email: Scalars['String'];
}>;


export type InboxMessageCreatedSubscription = { __typename?: 'Subscription', inboxMessageCreated: { __typename?: 'InboxMessageEventOutput', email: string, messageId: string } };

export type InboxMessageReadySubscriptionVariables = Exact<{
  email: Scalars['String'];
}>;


export type InboxMessageReadySubscription = { __typename?: 'Subscription', inboxMessageReady: { __typename?: 'InboxMessageEventOutput', email: string, messageId: string } };

export type OnOpportunityStateChangedSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnOpportunityStateChangedSubscription = { __typename?: 'Subscription', opportunityStateChanged: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, state: MarketingPlanState } };

export type OnSubmissionStateChangedSubscriptionVariables = Exact<{
  id: Scalars['String'];
}>;


export type OnSubmissionStateChangedSubscription = { __typename?: 'Subscription', submissionStateChanged: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProductId: string, bindHqApplicationId?: string | null, state: SubmissionState, createdAt: any, updatedAt?: any | null, lastTransitionAt: any, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, coverages: string, endorsements: string, coreLines: Array<string>, productDescription?: string | null, portalLink?: string | null, submissionInstructions?: string | null, grossCommission?: number | null, isApiSubmission: boolean, submissionCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null, referenceCarrierContacts?: Array<{ __typename?: 'CarrierContact', id: string & { __scalar: "UUID" }, firstName: string, lastName: string, email: string, phone?: string | null, title?: string | null }> | null }, quotes: Array<{ __typename?: 'Quote', id: string & { __scalar: "UUID" }, insuredId: string, insuredName?: string | null, submissionId: string, state: QuoteState, homeState?: string | null, premium?: number | null, mep?: number | null, agentCommission?: number | null, grossCommission?: number | null, extractedCommission?: number | null, carrierFee?: number | null, carrierName?: string | null, carrierTriaTerms?: CarrierTriaTerms | null, brokerFee?: number | null, inspectionFee?: number | null, inspectionFeeTreatment?: InspectionFeeTreatment | null, effectiveDate?: any | null, expirationDate?: any | null, policyDesiredEffectiveDate?: any | null, policyDesiredExpirationDate?: any | null, createdAt: any, outstandingSubjectivities?: string | null, subjectivities: Array<string>, linesOfBusinessIds: Array<string>, admitted: boolean, redactedQuoteId?: string | null, processedQuoteId?: string | null, rawQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, redactedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, processedQuote?: { __typename?: 'FileUpload', id: string, createdAt: any, deletedAt?: any | null, insuredId?: string | null, opportunityId?: string | null, quoteId?: string | null, uploaderId?: string | null, emailId?: string | null, gmailMessageId?: string | null, filename: string, mimeType: string, fileSource?: File_Source | null, audience?: string | null, size: number } | null, policy?: { __typename?: 'Policy', id: string & { __scalar: "UUID" } } | null, stateTransitions: Array<{ __typename?: 'QuoteStateTransition', id: string, quoteId: string, previousState: QuoteState, state: QuoteState, createdAt: any, originatorId: string }>, submission: { __typename?: 'Submission', id: string & { __scalar: "UUID" }, opportunityId: string, appetiteProduct: { __typename?: 'AppetiteProduct', id: string, carrierName: string, carrierProductName?: string | null, marketType?: MarketTypes | null, grossCommission?: number | null, coreLines: Array<string>, isApiSubmission: boolean, carrier?: { __typename?: 'Carrier', bindHqCarrierIds: Array<string>, bindHqMarketingCompanyId?: string | null } | null }, opportunity: { __typename?: 'Opportunity', id: string & { __scalar: "UUID" }, insuredId: string & { __scalar: "UUID" }, desiredEffectiveDate: any, selectedLinesOfBusiness: Array<string>, renewalOfPolicies: Array<string>, attributedProducer: { __typename?: 'UserAccount', firstName: string, lastName: string, email: string } } }, notes: Array<{ __typename?: 'QuoteNote', id: string & { __scalar: "UUID" }, text: string }> }>, stateTransitions: Array<{ __typename?: 'SubmissionStateTransition', id: string, submissionId: string, previousState: SubmissionState, details?: string | null, state: SubmissionState, createdAt: any, originatorId: string }> } };

export type OpportunityChangedSubscriptionVariables = Exact<{
  insuredId: Scalars['String'];
}>;


export type OpportunityChangedSubscription = { __typename?: 'Subscription', opportunityChanged: { __typename?: 'OpportunityChangedOutput', insuredId: string, opportunityId: string } };

export type PlaybookRunsChangedSubscriptionVariables = Exact<{
  chatSessionId?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
}>;


export type PlaybookRunsChangedSubscription = { __typename?: 'Subscription', playbookRunsChanged: { __typename?: 'PlaybookRunChangedOutput', playbookRunId: string } };

export type SubmissionChangedSubscriptionVariables = Exact<{
  opportunityId: Scalars['String'];
}>;


export type SubmissionChangedSubscription = { __typename?: 'Subscription', submissionChanged: { __typename?: 'SubmissionChangedOutput', opportunityId: string, submissionId: string } };

export type ToolInvocationsChangedSubscriptionVariables = Exact<{
  playbookRunId: Scalars['String'];
}>;


export type ToolInvocationsChangedSubscription = { __typename?: 'Subscription', toolInvocationsChanged: { __typename?: 'ToolInvocationsChangedOutput', playbookRunId: string } };

export const AgencyAffiliationFragmentDoc = gql`
    fragment AgencyAffiliation on AgencyAffiliation {
  id
  name
  shortName
  logoUrl
  bindingCommission
  brokerageCommission
}
    `;
export const AuthTokenFragmentDoc = gql`
    fragment AuthToken on AuthToken {
  accessToken
  refreshToken
}
    `;
export const BindHqAgencyFragmentDoc = gql`
    fragment BindHqAgency on BindHqAgency {
  id
  name
  phone
  email
  line1
  line2
  city
  state
  zip
  okToBind
}
    `;
export const CarrierFragmentDoc = gql`
    fragment Carrier on Carrier {
  __typename
  id
  name
  slug
  pdf
  api
  portalUrl
  url
  foregroundColor
  backgroundColor
  bindHqCarrierIds
}
    `;
export const ChatMessageFragmentDoc = gql`
    fragment ChatMessage on ChatMessage {
  id
  externalMessageId
  sessionId
  parts
  role
  status
  createdAt
  isElicitation
  elicitationResolvedBy
  frameId
}
    `;
export const ChatSessionFragmentDoc = gql`
    fragment ChatSession on ChatSession {
  id
  title
  status
  userId
  viewerCanSendMessages
  user {
    id
    firstName
    lastName
  }
  messages {
    ...ChatMessage
  }
  createdAt
  updatedAt
  lastMessageAt
  metadata {
    key
    value
  }
}
    `;
export const ClassCodeFragmentDoc = gql`
    fragment ClassCode on ClassCode {
  id
  description
  classCode
  classSystem
}
    `;
export const ClientDataFragmentDoc = gql`
    fragment ClientData on ClientData {
  id
  insuredId
  index
  key
  value
  source
}
    `;
export const ConversationMessageFragmentDoc = gql`
    fragment ConversationMessage on ConversationMessage {
  id
  externalMessageId
  renderKey
  sourceSessionId
  rootSessionId
  role
  parts
  status
  sequence
  createdAt
}
    `;
export const FileUploadFragmentDoc = gql`
    fragment FileUpload on FileUpload {
  id
  createdAt
  deletedAt
  insuredId
  opportunityId
  quoteId
  uploaderId
  emailId
  gmailMessageId
  filename
  mimeType
  fileSource
  audience
  size
}
    `;
export const DraftMessageAttachmentFragmentDoc = gql`
    fragment DraftMessageAttachment on DraftMessageAttachment {
  id
  fileUploadId
  fileUpload {
    ...FileUpload
  }
  filename
  contentType
  size
}
    `;
export const DraftMessageFragmentDoc = gql`
    fragment DraftMessage on DraftMessage {
  id
  externalId
  externalMessageId
  subject
  from
  to
  cc
  bcc
  replyTo
  threadId
  inReplyTo
  references
  date
  text
  html
  labels
  priority
  scheduledSend {
    id
    sendAt
    queuedAt
    sentAt
    failedAt
    failedReason
    cancelledAt
    status
    createdAt
    updatedAt
  }
  attachments {
    ...DraftMessageAttachment
  }
  referenceMessageId
}
    `;
export const InboxAgencySearchResultFragmentDoc = gql`
    fragment InboxAgencySearchResult on AgencySearchResult {
  id
  name
  accountCount
  agentCount
}
    `;
export const InboxAgentContactFragmentDoc = gql`
    fragment InboxAgentContact on AgentContact {
  id
  firstName
  lastName
  email
  agencyName
  mobilePhone
  workPhone
}
    `;
export const InboxAgentSearchResultFragmentDoc = gql`
    fragment InboxAgentSearchResult on AgentSearchResult {
  id
  firstName
  lastName
  email
  agencyName
}
    `;
export const InboxContactFragmentDoc = gql`
    fragment InboxContact on InboxContact {
  displayName
  email
}
    `;
export const InboxInsuredFragmentDoc = gql`
    fragment InboxInsured on Insured {
  id
  name
  createdAt
}
    `;
export const InboxAgentActionFragmentDoc = gql`
    fragment InboxAgentAction on AgentAction {
  id
  title
  description
  complete
}
    `;
export const InboxOpportunityFragmentDoc = gql`
    fragment InboxOpportunity on Opportunity {
  id
  selectedLinesOfBusiness
  allRequirementsCompleted
  agentActions {
    ...InboxAgentAction
  }
}
    `;
export const InboxSubmissionFragmentDoc = gql`
    fragment InboxSubmission on Submission {
  id
  quotes {
    id
    insuredId
    submissionId
    state
    premium
    totalPremium
    mep
    agentCommission
    grossCommission
    carrierFee
    brokerFee
    inspectionFee
    effectiveDate
    expirationDate
    createdAt
    lastTransitionAt
    outstandingSubjectivities
    isRenewable
    redactedQuoteId
    redactedQuote {
      ...FileUpload
    }
    processedQuoteId
    processedQuote {
      ...FileUpload
    }
  }
}
    `;
export const MessageAttachmentFragmentDoc = gql`
    fragment MessageAttachment on MessageAttachment {
  id
  fileUploadId
  messageId
  fileUpload {
    ...FileUpload
  }
}
    `;
export const InboxMessageFragmentDoc = gql`
    fragment InboxMessage on Message {
  id
  status
  classification
  externalId
  messageId
  conversationId
  to
  from
  cc
  date
  labels
  summary
  preview
  canReplyAll
  replyTo
  priority
  attachments {
    ...MessageAttachment
  }
}
    `;
export const InboxConversationFragmentDoc = gql`
    fragment InboxConversation on Conversation {
  id
  externalId
  inboxId
  isPending
  teamConversationId
  viewerCanReplyAsCollaborator
  viewerIsUnread
  insuredId
  attachmentCount
  insured {
    ...InboxInsured
  }
  opportunities {
    ...InboxOpportunity
  }
  submissions {
    ...InboxSubmission
  }
  subject
  participants
  internalParticipantEmails
  labels
  summary
  dueWakeUp {
    id
    dueAt
    agentEmail
    agentPhone
    sourceReason
    conversationId
    displayMetadata
  }
  messages {
    ...InboxMessage
  }
  lastMessageAt
  lastMessageFrom
  inbox {
    id
    email
  }
}
    `;
export const InboxConversationsByOpportunityConversationFragmentDoc = gql`
    fragment InboxConversationsByOpportunityConversation on Conversation {
  id
  externalId
  inboxId
  insuredId
  isPending
  subject
  participants
  labels
  summary
  lastMessageAt
}
    `;
export const InboxConversationsConversationFragmentDoc = gql`
    fragment InboxConversationsConversation on Conversation {
  id
  externalId
  inboxId
  insuredId
  isPending
  subject
  participants
  labels
  summary
  lastMessageAt
  messageCount
  attachmentCount
  attachmentPreviews {
    fileUploadId
    filename
    mimeType
  }
  draftCount
}
    `;
export const InboxConversationsListConversationFragmentDoc = gql`
    fragment InboxConversationsListConversation on Conversation {
  ...InboxConversationsConversation
  teamConversationId
  viewerCanReplyAsCollaborator
  viewerIsUnread
  internalParticipantEmails
  lastMessageFrom
  dueWakeUp {
    id
    dueAt
    sourceReason
    displayMetadata
  }
}
    `;
export const InboxFullMessageFragmentDoc = gql`
    fragment InboxFullMessage on Message {
  id
  status
  classification
  externalId
  messageId
  to
  from
  cc
  replyTo
  priority
  date
  conversationId
  inboxId
  subject
  text
  html
  labels
  summary
  headers
  annotatedHtml
  canReplyAll
}
    `;
export const UserAccountFragmentDoc = gql`
    fragment UserAccount on UserAccount {
  __typename
  id
  createdAt
  bindHqId
  firstName
  lastName
  email
  roles
  internal
  agencyId
  assignmentsEnabled
  assignmentGroups
  avatarUrl
  phone
  agency {
    id
    name
    bindHqId
    isTest
  }
}
    `;
export const InboxInsuredDetailFragmentDoc = gql`
    fragment InboxInsuredDetail on Insured {
  id
  dba
  description
  primaryState
  agent {
    ...UserAccount
  }
}
    `;
export const InboxLabelFragmentDoc = gql`
    fragment InboxLabel on EmailLabel {
  externalId
  name
  type
}
    `;
export const InboxSearchSuggestionConversationFragmentDoc = gql`
    fragment InboxSearchSuggestionConversation on Conversation {
  id
  subject
  participants
  lastMessageFrom
}
    `;
export const InspectionOrderFragmentDoc = gql`
    fragment InspectionOrder on InspectionOrder {
  id
  quoteId
  policyId
  vendor
  status
  gaps
  packet {
    addresses {
      street
      city
      state
      zip
      source
    }
    contact {
      name
      phone
      email
      unknown
    }
    surveyTypeCode
    surveyTypeSource
    effectiveDate
    policyNumber
    orderAndForward
    requestedSurvey {
      request
      note
    }
  }
  vendorOrders {
    orderId
    controlIdNumber
    reference
    placedAt
  }
  orderedAt
  orderedElsewhereById
  updatedAt
}
    `;
export const InspectionRecFragmentDoc = gql`
    fragment InspectionRec on InspectionRec {
  vendorNumber
  level
  text
  refersToMedia
}
    `;
export const InspectionReportFragmentDoc = gql`
    fragment InspectionReport on InspectionReport {
  id
  inspectionOrderId
  source
  vendorOrderId
  locationIndex
  locationText
  fileId
  status
  flagReason
  vendorRiskCounts {
    major
    minor
  }
  summaryCount
  countCheck
  extractedRecs {
    ...InspectionRec
  }
  recs {
    ...InspectionRec
  }
  recEdits {
    op
    reason
    before {
      ...InspectionRec
    }
    after {
      ...InspectionRec
    }
    byId
    at
  }
  letterFileId
  templateVersion
  recsHash
  sentAt
  sentById
  sentTo
  proofFileIds
  signedConfirmedById
  followUpDueAt
  error
  updatedAt
}
    `;
export const BusinessClassFragmentDoc = gql`
    fragment BusinessClass on BusinessClass {
  id
  description
  system
  code
}
    `;
export const AgencyFragmentDoc = gql`
    fragment Agency on Agency {
  id
  name
  bindHqId
  isPrivate
  isTest
}
    `;
export const InsuredFragmentDoc = gql`
    fragment Insured on Insured {
  id
  createdAt
  deletedAt
  bindHqId
  name
  dba
  legalEntityType
  description
  primaryState
  naicsCodes
  isoCglCodes
  sicCodes
  exposures
  mergedIntoId
  businessClasses {
    ...BusinessClass
  }
  revenue
  agentId
  agent {
    ...UserAccount
  }
  secondaryAgents {
    ...UserAccount
  }
  agency {
    ...Agency
  }
}
    `;
export const LineOfBusinessFragmentDoc = gql`
    fragment LineOfBusiness on LineOfBusiness {
  id
  displayName
}
    `;
export const MarketingPlanStateTransitionFragmentDoc = gql`
    fragment MarketingPlanStateTransition on MarketingPlanStateTransition {
  id
  marketingPlanId
  previousState
  state
  createdAt
  originatorId
}
    `;
export const ModelEvaluationFragmentDoc = gql`
    fragment ModelEvaluation on ModelEvaluation {
  id
  createdAt
  completedAt
  status
  totalSamples
  failedPredictions
  mae
  rmse
  r2
  mape
  minError
  maxError
  meanError
  medianError
  percentiles {
    p25
    p50
    p75
    p90
    p95
  }
  accuracyBuckets {
    within100
    within500
    within1000
    within10Percent
    within25Percent
  }
  modelMetadata
}
    `;
export const UserCommentFragmentDoc = gql`
    fragment UserComment on UserComment {
  id
  type
  text
  createdAt
  updatedAt
  isPublic
  userAccountId
  userAccount {
    ...UserAccount
  }
  opportunityId
}
    `;
export const AssignmentChangeEventFragmentDoc = gql`
    fragment AssignmentChangeEvent on AssignmentChangeEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const TriageAssignmentEventFragmentDoc = gql`
    fragment TriageAssignmentEvent on TriageAssignmentEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const EmailEventFragmentDoc = gql`
    fragment EmailEvent on EmailEvent {
  id
  type
  text
  opportunityId
  createdAt
  email {
    id
    to
    from
    subject
    cc
    body
    extractedBody
    dateReceived
    linkToEmailInGoogleGroups
  }
  isPublic
}
    `;
export const GmailMessageFragmentDoc = gql`
    fragment GmailMessage on GmailMessage {
  id
  headerMessageId
  to
  from
  subject
  cc
  replyTo
  textAsHtml
  dateReceived
  attachments {
    ...FileUpload
  }
}
    `;
export const GmailMessageEventFragmentDoc = gql`
    fragment GmailMessageEvent on GmailMessageEvent {
  id
  type
  text
  opportunityId
  createdAt
  gmailMessage {
    ...GmailMessage
  }
  isPublic
}
    `;
export const GmailRelayEventFragmentDoc = gql`
    fragment GmailRelayEvent on GmailRelayEvent {
  id
  type
  text
  opportunityId
  createdAt
  gmailRelay {
    recipientEmail
    initiator {
      email
    }
  }
  gmailMessage {
    ...GmailMessage
    html
  }
  isPublic
}
    `;
export const FileUploadEventFragmentDoc = gql`
    fragment FileUploadEvent on FileUploadEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const StatusChangeEventFragmentDoc = gql`
    fragment StatusChangeEvent on StatusChangeEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const SubmissionStatusChangeEventFragmentDoc = gql`
    fragment SubmissionStatusChangeEvent on SubmissionStatusChangeEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const CreatedEventFragmentDoc = gql`
    fragment CreatedEvent on CreatedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const OutcomeChangeEventFragmentDoc = gql`
    fragment OutcomeChangeEvent on OutcomeChangeEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const DesiredEffectiveDateChangeEventFragmentDoc = gql`
    fragment DesiredEffectiveDateChangeEvent on DesiredEffectiveDateChangeEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ApplicationSubmittedEventFragmentDoc = gql`
    fragment ApplicationSubmittedEvent on ApplicationSubmittedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ProductsAddedEventFragmentDoc = gql`
    fragment ProductsAddedEvent on ProductsAddedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ProductsRemovedEventFragmentDoc = gql`
    fragment ProductsRemovedEvent on ProductsRemovedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const BotCommentEventFragmentDoc = gql`
    fragment BotCommentEvent on BotCommentEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const AutomatedFollowUpEventFragmentDoc = gql`
    fragment AutomatedFollowUpEvent on AutomatedFollowUpEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ActionRequestedEventFragmentDoc = gql`
    fragment ActionRequestedEvent on ActionRequestedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ActionApprovedEventFragmentDoc = gql`
    fragment ActionApprovedEvent on ActionApprovedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ActionRejectedEventFragmentDoc = gql`
    fragment ActionRejectedEvent on ActionRejectedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const ActionDismissedEventFragmentDoc = gql`
    fragment ActionDismissedEvent on ActionDismissedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const CoveragesChangedEventFragmentDoc = gql`
    fragment CoveragesChangedEvent on CoveragesChangedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const BusinessClassCodesChangedEventFragmentDoc = gql`
    fragment BusinessClassCodesChangedEvent on BusinessClassCodesChangedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const NotificationOpportunityEventFragmentDoc = gql`
    fragment NotificationOpportunityEvent on OpportunityEvent {
  __typename
  ... on UserComment {
    ...UserComment
  }
  ... on AssignmentChangeEvent {
    ...AssignmentChangeEvent
  }
  ... on TriageAssignmentEvent {
    ...TriageAssignmentEvent
  }
  ... on EmailEvent {
    ...EmailEvent
  }
  ... on GmailMessageEvent {
    ...GmailMessageEvent
  }
  ... on GmailRelayEvent {
    ...GmailRelayEvent
  }
  ... on FileUploadEvent {
    ...FileUploadEvent
  }
  ... on StatusChangeEvent {
    ...StatusChangeEvent
  }
  ... on SubmissionStatusChangeEvent {
    ...SubmissionStatusChangeEvent
  }
  ... on CreatedEvent {
    ...CreatedEvent
  }
  ... on OutcomeChangeEvent {
    ...OutcomeChangeEvent
  }
  ... on DesiredEffectiveDateChangeEvent {
    ...DesiredEffectiveDateChangeEvent
  }
  ... on ApplicationSubmittedEvent {
    ...ApplicationSubmittedEvent
  }
  ... on ProductsAddedEvent {
    ...ProductsAddedEvent
  }
  ... on ProductsRemovedEvent {
    ...ProductsRemovedEvent
  }
  ... on BotCommentEvent {
    ...BotCommentEvent
  }
  ... on AutomatedFollowUpEvent {
    ...AutomatedFollowUpEvent
  }
  ... on ActionRequestedEvent {
    ...ActionRequestedEvent
  }
  ... on ActionApprovedEvent {
    ...ActionApprovedEvent
  }
  ... on ActionRejectedEvent {
    ...ActionRejectedEvent
  }
  ... on ActionDismissedEvent {
    ...ActionDismissedEvent
  }
  ... on CoveragesChangedEvent {
    ...CoveragesChangedEvent
  }
  ... on BusinessClassCodesChangedEvent {
    ...BusinessClassCodesChangedEvent
  }
  ... on OpportunityEventBase {
    type
    opportunity {
      id
      insuredId
      insured {
        name
        agent {
          ...UserAccount
        }
      }
      broker {
        ...UserAccount
      }
    }
  }
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on Notification {
  id
  createdAt
  readAt
  event {
    ...NotificationOpportunityEvent
  }
}
    `;
export const CarrierContactFragmentDoc = gql`
    fragment CarrierContact on CarrierContact {
  id
  firstName
  lastName
  email
  phone
  title
}
    `;
export const AppetiteProductFragmentDoc = gql`
    fragment AppetiteProduct on AppetiteProduct {
  id
  carrierName
  carrierProductName
  marketType
  coverages
  endorsements
  coreLines
  productDescription
  portalLink
  submissionInstructions
  grossCommission
  isApiSubmission
  submissionCarrierContacts {
    ...CarrierContact
  }
  referenceCarrierContacts {
    ...CarrierContact
  }
}
    `;
export const QuoteStateTransitionFragmentDoc = gql`
    fragment QuoteStateTransition on QuoteStateTransition {
  id
  quoteId
  previousState
  state
  createdAt
  originatorId
}
    `;
export const QuoteFragmentDoc = gql`
    fragment Quote on Quote {
  id
  insuredId
  insuredName
  submissionId
  state
  homeState
  premium
  mep
  agentCommission
  grossCommission
  extractedCommission
  carrierFee
  carrierName
  carrierTriaTerms
  brokerFee
  inspectionFee
  inspectionFeeTreatment
  effectiveDate
  expirationDate
  policyDesiredEffectiveDate
  policyDesiredExpirationDate
  createdAt
  outstandingSubjectivities
  subjectivities
  linesOfBusinessIds
  admitted
  rawQuote {
    ...FileUpload
  }
  redactedQuoteId
  redactedQuote {
    ...FileUpload
  }
  processedQuoteId
  processedQuote {
    ...FileUpload
  }
  policy {
    id
  }
  stateTransitions {
    ...QuoteStateTransition
  }
  submission {
    id
    appetiteProduct {
      id
      carrierName
      carrierProductName
      marketType
      grossCommission
      coreLines
      isApiSubmission
      carrier {
        bindHqCarrierIds
        bindHqMarketingCompanyId
      }
    }
    opportunityId
    opportunity {
      id
      insuredId
      desiredEffectiveDate
      selectedLinesOfBusiness
      renewalOfPolicies
      attributedProducer {
        firstName
        lastName
        email
      }
    }
  }
  notes {
    id
    text
  }
}
    `;
export const SubmissionStateTransitionFragmentDoc = gql`
    fragment SubmissionStateTransition on SubmissionStateTransition {
  id
  submissionId
  previousState
  details
  state
  createdAt
  originatorId
}
    `;
export const SubmissionFragmentDoc = gql`
    fragment Submission on Submission {
  id
  opportunityId
  appetiteProductId
  bindHqApplicationId
  state
  createdAt
  updatedAt
  lastTransitionAt
  appetiteProduct {
    ...AppetiteProduct
  }
  quotes {
    ...Quote
  }
  stateTransitions {
    ...SubmissionStateTransition
  }
}
    `;
export const OpportunityFragmentDoc = gql`
    fragment Opportunity on Opportunity {
  id
  state
  selectedLinesOfBusiness
  desiredEffectiveDate
  renewalOfPolicies
  submissions {
    ...Submission
  }
  insured {
    id
    name
    primaryState
    naicsCodes
    description
    agent {
      id
      agencyId
      email
      firstName
      lastName
    }
  }
  insuredId
  broker {
    id
    firstName
    lastName
  }
}
    `;
export const SlimAppetiteProductFragmentFragmentDoc = gql`
    fragment SlimAppetiteProductFragment on AppetiteProduct {
  id
  carrierName
  carrierProductName
  marketType
}
    `;
export const MarketingPlanAppetiteProductFragmentDoc = gql`
    fragment MarketingPlanAppetiteProduct on AppetiteProduct {
  ...SlimAppetiteProductFragment
  portalLink
  submissionInstructions
  isApiSubmission
  submissionCarrierContacts {
    ...CarrierContact
  }
  referenceCarrierContacts {
    ...CarrierContact
  }
}
    `;
export const MarketingPlanQuoteFragmentDoc = gql`
    fragment MarketingPlanQuote on Quote {
  id
  state
  premium
}
    `;
export const MarketingPlanMarketSummaryNoteFragmentDoc = gql`
    fragment MarketingPlanMarketSummaryNote on SubmissionMarketSummaryNote {
  id
  text
  createdAt
  creator {
    id
    firstName
    lastName
  }
}
    `;
export const MarketingPlanSubmissionFragmentDoc = gql`
    fragment MarketingPlanSubmission on Submission {
  id
  appetiteProductId
  state
  createdAt
  indicationPremium
  appetiteProduct {
    ...MarketingPlanAppetiteProduct
  }
  quotes {
    ...MarketingPlanQuote
  }
  marketSummaryNotes {
    ...MarketingPlanMarketSummaryNote
  }
  stateTransitions {
    ...SubmissionStateTransition
  }
}
    `;
export const OpportunityDetailsFragmentDoc = gql`
    fragment OpportunityDetails on Opportunity {
  id
  state
  isTest
  insuredId
  splitOf
  splitOfInsuredId
  broker {
    id
    firstName
    lastName
    email
    agency {
      id
      name
    }
  }
  collaborators {
    id
    firstName
    lastName
    email
    agency {
      id
      name
    }
  }
  submissions {
    ...MarketingPlanSubmission
  }
  selectedLinesOfBusiness
  desiredEffectiveDate
  renewalOfPolicies
  insured {
    id
    name
    agent {
      id
      firstName
      lastName
      email
      agency {
        id
        name
      }
    }
    secondaryAgents {
      id
      firstName
      lastName
      email
      agency {
        id
        name
      }
    }
  }
}
    `;
export const CollaboratorsChangedEventFragmentDoc = gql`
    fragment CollaboratorsChangedEvent on CollaboratorsChangedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const AlbyUpdateEventFragmentDoc = gql`
    fragment AlbyUpdateEvent on AlbyUpdateEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const RequirementAddedEventFragmentDoc = gql`
    fragment RequirementAddedEvent on RequirementAddedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const PolicyRenewabilityChangedEventFragmentDoc = gql`
    fragment PolicyRenewabilityChangedEvent on PolicyRenewabilityChangedEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const AgencyTransferEventFragmentDoc = gql`
    fragment AgencyTransferEvent on AgencyTransferEvent {
  id
  type
  text
  opportunityId
  createdAt
  isPublic
}
    `;
export const OpportunityEventFragmentDoc = gql`
    fragment OpportunityEvent on OpportunityEvent {
  __typename
  ... on UserComment {
    ...UserComment
  }
  ... on AssignmentChangeEvent {
    ...AssignmentChangeEvent
  }
  ... on CollaboratorsChangedEvent {
    ...CollaboratorsChangedEvent
  }
  ... on TriageAssignmentEvent {
    ...TriageAssignmentEvent
  }
  ... on EmailEvent {
    ...EmailEvent
  }
  ... on GmailMessageEvent {
    ...GmailMessageEvent
  }
  ... on GmailRelayEvent {
    ...GmailRelayEvent
  }
  ... on FileUploadEvent {
    ...FileUploadEvent
  }
  ... on StatusChangeEvent {
    ...StatusChangeEvent
  }
  ... on SubmissionStatusChangeEvent {
    ...SubmissionStatusChangeEvent
  }
  ... on CreatedEvent {
    ...CreatedEvent
  }
  ... on OutcomeChangeEvent {
    ...OutcomeChangeEvent
  }
  ... on DesiredEffectiveDateChangeEvent {
    ...DesiredEffectiveDateChangeEvent
  }
  ... on ApplicationSubmittedEvent {
    ...ApplicationSubmittedEvent
  }
  ... on ProductsAddedEvent {
    ...ProductsAddedEvent
  }
  ... on ProductsRemovedEvent {
    ...ProductsRemovedEvent
  }
  ... on BotCommentEvent {
    ...BotCommentEvent
  }
  ... on AlbyUpdateEvent {
    ...AlbyUpdateEvent
  }
  ... on AutomatedFollowUpEvent {
    ...AutomatedFollowUpEvent
  }
  ... on ActionRequestedEvent {
    ...ActionRequestedEvent
  }
  ... on ActionApprovedEvent {
    ...ActionApprovedEvent
  }
  ... on ActionRejectedEvent {
    ...ActionRejectedEvent
  }
  ... on ActionDismissedEvent {
    ...ActionDismissedEvent
  }
  ... on CoveragesChangedEvent {
    ...CoveragesChangedEvent
  }
  ... on BusinessClassCodesChangedEvent {
    ...BusinessClassCodesChangedEvent
  }
  ... on OpportunityEventBase {
    type
  }
  ... on RequirementAddedEvent {
    ...RequirementAddedEvent
  }
  ... on PolicyRenewabilityChangedEvent {
    ...PolicyRenewabilityChangedEvent
  }
  ... on AgencyTransferEvent {
    ...AgencyTransferEvent
  }
}
    `;
export const OpportunityNotesFragmentDoc = gql`
    fragment OpportunityNotes on Opportunity {
  id
  notes {
    id
    createdAt
    authoredByModel
    creator {
      ...UserAccount
    }
    text
  }
}
    `;
export const PlacementDeliveryWitnessFragmentDoc = gql`
    fragment PlacementDeliveryWitness on PlacementDeliveryWitness {
  opportunityId
  submissionId
  quoteId
  quoteState
  evidenceKind
  deliveredAt
  placementTaskId
  creationProvenance
}
    `;
export const PlacementDeskWorkGroupFragmentDoc = gql`
    fragment PlacementDeskWorkGroup on PlacementDeskWorkGroup {
  submissionsCreated {
    count
    firstAt
  }
  submissionsSent {
    count
    firstAt
  }
  quotesCreated {
    count
    firstAt
  }
  quotesDelivered {
    count
    firstAt
  }
}
    `;
export const PlacementDeskSnapshotFragmentDoc = gql`
    fragment PlacementDeskSnapshot on PlacementDeskSnapshot {
  progressTier
  progressEvidenceError
  recordedDecline
  receipts {
    placementId
    runNumber
    marketId
    milestone
    receivedAt
    eventId
    attemptId
    quoteFileId
    reviewFileId
    disposition
    carrierAnswerFileId
  }
  observerEventsError
  cycleEnded {
    key
    reason
  }
  attentionRequests {
    placementId
    runNumber
    attentionId
    occurrence
    kind
    marketId
    detail
    targetKind
    targetSlug
    taskKey
    requiredAt
    resolvedAt
    resolution
    open
    handoff {
      kind
      role
      wantedFacts
      moreFactsOmitted
      ladderStage
      reviewTaskId
      handoffTaskId
      raw
    }
  }
  marketSettlements {
    placementId
    runNumber
    marketId
    reason
    attemptId
    disposition
    executionStatus
    terminal
    dispositionReasons {
      code
      text
    }
    receivedAt
    eventId
  }
  marketAnswers {
    verdict
    currentness
    placementId
    runNumber
    marketId
    stage
    disposition
    terminal
    executionStatus
    attemptId
    resultFileId
    carrierAnswerFileId
    receivedAt
    eventId
  }
  waitingReason
  waitingSince
  furthestStep
  lastDeskActivityAt
  contractMarkets {
    marketId
    displayName
  }
  attention {
    kind
    marketId
    detail
    workerId
    awaitingTaskId
    handoff {
      kind
      role
      wantedFacts
      moreFactsOmitted
      ladderStage
      reviewTaskId
      handoffTaskId
      raw
    }
  }
  placementId
  runNumber
  runCount
  signals
  undecidedMarketIds
  reason
  decisions {
    marketId
    displayName
    status
    runNumber
    placementId
    outcome
    quote
    premium {
      amount
      currency
      basis
    }
    quoteReference {
      fileId
      mediaType
      size
    }
    quoteReviewOpen
  }
  status
  stage
  outcome
  revision
  step
  waitingOn
  quietMinutes
  suspectedStall
  nextAction
  holds
  lastProgressAt
  fetchedAt
  syncError
  lanes {
    marketId
    displayName
    status
    outcome
    dispositionReasons {
      code
      text
    }
    quote
    premium {
      amount
      currency
      basis
    }
    quoteReference {
      fileId
      mediaType
      size
    }
    quoteReviewOpen
    phase
    channel
    holds
    unsupportedIssueCodes
    attention {
      kind
      detail
      workerId
      taskId
      hook
      asks
      handoff {
        kind
        role
        wantedFacts
        moreFactsOmitted
        ladderStage
        reviewTaskId
        handoffTaskId
        raw
      }
    }
    portal {
      segmentOrdinal
      status
      currentStepId
      tier
      currentStepNumber
      stepCount
      composition {
        stepId
        kind
        coverage
      }
      discoveredRequirements {
        key
        label
        reason
        type
        values
        min
        max
        pageKey
        source
      }
    }
    attentionKinds
  }
  openReviews {
    superseded
    hook
    marketId
    openedAt
    taskId
    humanBound
    awaitingTaskId
  }
}
    `;
export const PlacementWorkflowRowFragmentDoc = gql`
    fragment PlacementWorkflowRow on PlacementWorkflowDashboardRow {
  dealDeleted
  dealClosed
  isTestDeal
  opportunity {
    id
    insuredId
    insuredName
    insuredDescription
    primaryState
    isoCglCodes
    selectedLinesOfBusiness
    desiredEffectiveDate
    createdAt
    state
    broker {
      id
      name
      email
    }
  }
  desk {
    ...PlacementDeskSnapshot
  }
  outcome
  outcomeReason
  wrote {
    count
    source
  }
}
    `;
export const PlaybookFileFragmentDoc = gql`
    fragment PlaybookFile on PlaybookFile {
  id
  fileUploadId
  filename
  mimeType
  size
}
    `;
export const PlaybookRunFragmentDoc = gql`
    fragment PlaybookRun on PlaybookRunDto {
  id
  playbookId
  parentPlaybookRunId
  parentChatSessionId
  rootChatSessionId
  depth
  toolInvocationId
  chatSessionId
  conversationId
  opportunityId
  triggerEventType
  parameterValues
  playbook {
    id
    name
    description
    workflow
  }
  user {
    id
    firstName
    lastName
  }
  status
  errorMessage
  startedAt
  finishedAt
  toolInvocations {
    id
    status
    toolName
    toolCallId
    calledAt
    finishedAt
    toolInput
    toolOutput
  }
  totalInputTokens
  totalOutputTokens
  aiCallCount
}
    `;
export const PlaybookSetFragmentDoc = gql`
    fragment PlaybookSet on PlaybookSet {
  id
  name
  description
  playbookCount
  isSubscribed
}
    `;
export const PlaybookFragmentDoc = gql`
    fragment Playbook on Playbook {
  id
  userId
  copiedFromPlaybookId
  name
  description
  workflow
  type
  parametersDescription
  templateParamSchema
  modelTier
  toolFilter {
    whitelist
    blacklist
  }
  createdAt
  updatedAt
  author {
    id
    firstName
    lastName
    email
  }
  subscribers {
    id
    firstName
    lastName
    email
  }
}
    `;
export const PlaybookSetWithPlaybooksFragmentDoc = gql`
    fragment PlaybookSetWithPlaybooks on PlaybookSet {
  id
  name
  description
  playbookCount
  isSubscribed
  playbooks {
    ...Playbook
  }
}
    `;
export const PlaybookTriggerFragmentDoc = gql`
    fragment PlaybookTrigger on PlaybookTrigger {
  id
  userId
  playbookId
  eventType
  triggerConfig
  lastFiredOn
  createdAt
  updatedAt
  playbook {
    ...Playbook
  }
}
    `;
export const PolicyStateTransitionFragmentDoc = gql`
    fragment PolicyStateTransition on PolicyStateTransition {
  id
  policyId
  previousState
  state
  createdAt
  originatorId
}
    `;
export const PolicyFragmentDoc = gql`
    fragment Policy on Policy {
  id
  insuredId
  opportunityId
  quoteId
  state
  policyNumber
  effectiveDate
  expirationDate
  createdAt
  lastTransitionAt
  awaitingSubjectivities
  endorsementsRequested
  policyFileId
  stampedPolicyFileId
  redactedBinderFileId
  processedBinderFileId
  bindHqPolicyId
  bindHqPolicy {
    id
    status
  }
  isRenewable
  attributedTo {
    ...UserAccount
  }
  taxDocumentRequirements {
    taxDocument {
      id
      transactionId
      code
      name
      documentNote
      requiredForFiling
      requiredForBinding
      uploadRequired
    }
    fileUpload {
      ...FileUpload
    }
  }
  policyFile {
    ...FileUpload
  }
  stampedPolicyFile {
    ...FileUpload
  }
  redactedBinderFile {
    ...FileUpload
  }
  processedBinderFile {
    ...FileUpload
  }
  stateTransitions {
    ...PolicyStateTransition
  }
  appetiteProduct {
    ...AppetiteProduct
  }
}
    `;
export const PolicyListFragmentDoc = gql`
    fragment PolicyList on Policy {
  id
  insuredId
  quoteId
  state
  policyNumber
  effectiveDate
  expirationDate
  appetiteProduct {
    ...SlimAppetiteProductFragment
  }
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  userId
  name
  workflow
  createdAt
  updatedAt
  enabled
  marketType
  carrierId
  lineOfBusinessIds
  grossCommission
  carrier {
    id
    name
    slug
  }
  linesOfBusiness {
    id
    displayName
    code
  }
  files {
    id
    fileUploadId
    filename
    mimeType
    size
  }
  author {
    id
    firstName
    lastName
    email
  }
  submissionCarrierContacts {
    id
    firstName
    lastName
    email
    phone
    title
  }
  referenceCarrierContacts {
    id
    firstName
    lastName
    email
    phone
    title
  }
}
    `;
export const ProductExclusionFragmentDoc = gql`
    fragment ProductExclusion on ProductExclusion {
  id
  appetiteProductId
  reason
  state
  naicsCode
}
    `;
export const QuoteSubmissionFragmentDoc = gql`
    fragment QuoteSubmission on Submission {
  id
  state
  exclusionReason {
    ...ProductExclusion
  }
  appetiteProduct {
    id
    carrierName
    carrierProductName
    marketType
  }
}
    `;
export const RenewalNoteFragmentDoc = gql`
    fragment RenewalNote on RenewalNote {
  id
  text
  updatedAt
  isRead
  author {
    id
    firstName
    lastName
  }
}
    `;
export const ScoredAppetiteProductFragmentDoc = gql`
    fragment ScoredAppetiteProduct on ScoredAppetiteProduct {
  score
  reasons
  previouslyQuotedCount
  estimatedQwSpread
  product {
    id
    carrierName
    carrierSlug
    carrierProductName
    productDescription
    coverages
    coreLines
    marketType
    grossCommission
  }
}
    `;
export const SearchResultFragmentDoc = gql`
    fragment SearchResult on SearchResult {
  id
  insuredId
  insuredName
  type
}
    `;
export const StandardEmailMessageAttachmentFragmentDoc = gql`
    fragment StandardEmailMessageAttachment on StandardEmailMessageAttachment {
  filename
  contentType
  size
  hash
}
    `;
export const MarketingPlanStateTransitionFragmentFragmentDoc = gql`
    fragment MarketingPlanStateTransitionFragment on MarketingPlanStateTransition {
  id
  marketingPlanId
  originatorId
  previousState
  state
  createdAt
  originator {
    id
    firstName
    lastName
  }
}
    `;
export const SubmissionStateTransitionFragmentFragmentDoc = gql`
    fragment SubmissionStateTransitionFragment on SubmissionStateTransition {
  id
  submissionId
  originatorId
  previousState
  state
  createdAt
  originator {
    id
    firstName
    lastName
  }
}
    `;
export const QuoteStateTransitionFragmentFragmentDoc = gql`
    fragment QuoteStateTransitionFragment on QuoteStateTransition {
  id
  quoteId
  originatorId
  previousState
  state
  createdAt
  originator {
    id
    firstName
    lastName
  }
}
    `;
export const PolicyStateTransitionFragmentFragmentDoc = gql`
    fragment PolicyStateTransitionFragment on PolicyStateTransition {
  id
  policyId
  originatorId
  previousState
  state
  createdAt
  originator {
    id
    firstName
    lastName
  }
}
    `;
export const SubmissionDetailsFragmentDoc = gql`
    fragment SubmissionDetails on Submission {
  id
  opportunityId
  state
  createdAt
  updatedAt
  appetiteProduct {
    id
    carrierName
    carrierProductName
    marketType
  }
  opportunity {
    id
    desiredEffectiveDate
    selectedLinesOfBusiness
    insured {
      primaryState
    }
  }
}
    `;
export const SubmissionResponseFragmentDoc = gql`
    fragment SubmissionResponse on SubmissionResponse {
  submissions {
    id
    state
    personalizedEmailSubmissionBody
    appetiteProduct {
      id
      carrierName
      carrierProductName
      marketType
      submissionCarrierContacts {
        email
      }
    }
    opportunity {
      id
      state
      desiredEffectiveDate
      insured {
        id
        name
      }
      broker {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;
export const VaveQuoteFragmentDoc = gql`
    fragment VaveQuote on VaveQuote {
  bindRequestedAt
  bindRequestedExpiry
  bindRequestedInception
  externalPolicyId
  id
  input {
    Address {
      City
      State
      StreetAddress
      ZipCode
    }
    BuildingInformation {
      Address {
        City
        State
        StreetAddress
        ZipCode
      }
      Attributes {
        AutomaticWaterShutOff
        BasementType
        BurglarySafeguards
        CladdingType
        Construction
        ElectricType
        ElectricUpgradeType
        ElectricUpgradeYear
        EarthquakeInfo {
          RetrofittedMasonry
          SoftStory
        }
        FireProtectionClass
        FireSafeguards
        FloodInfo {
          FloodZone
          PropertyOverWater
        }
        FloorAreaSqFt
        HeatingType
        HeatingUpgradeType
        HeatingUpgradeYear
        NumberOfStories
        NumberOfUnitsInBuilding
        Occupancy
        OriginalYearBuilt
        PlumbingType
        PlumbingUpgradeType
        PlumbingUpgradeYear
        RentalType
        RoofAnchorageMethod
        RoofCoveringMaterial
        RoofGeometry
        RoofUpgradeType
        RoofUpgradeYear
        Sprinklers
        StructuralUpgradeYear
        WindowProtectionType
      }
      BuildingId
      BuildingName
      BuildingNo
      BuildingDescription
      ClaimsLast3Years {
        Amount
        ClaimDate
        Description
        FullyRepaired
        Type
      }
      Coverages {
        BIExtraExpenseIncluded
        BusinessIncomeCoInsurance
        BusinessIncomeLimit
        BusinessPersonalPropertyLimit
        BusinessPersonalPropertyCoInsurance
        BusinessPersonalPropertyValuation
        BuildingValueCoInsurance
        BuildingValueLimit
        BuildingValueValuation
      }
      Form
      LimitsAndDeductibles {
        ACVOnRoof
        AOPDeductibleValue
        EarthquakeDed
        ExcludeRoofCover
        FloodBuildingLimit
        FloodContentsLimit
        FloodDeductible
        IncludeAopCover
        IncludeEarthquakeCover
        IncludeFloodCover
        IncludeSinkholeCover
        IncludeSprinklerLeakageCover
        IncludeTheftCover
        IncludeVandalismCover
        IncludeWaterDamageCover
        IncludeWindCover
        TheftDeductible
        TheftSublimit
        WaterDamageSublimit
        WindDed
        WindDedType
      }
      OptionalEndorsements {
        LossAssessmentForCondo {
          Deductible
          Limit
        }
        OutdoorSignsCover {
          Construction
          Description
          Limit
        }
        OrdinanceAndLawCover {
          CoverageA
          CoverageB
          CoverageC
          CoverageBAndCCombined
        }
        PeakSeasonCover {
          CoveredProperty
          From
          Limit
          To
        }
      }
    }
    DomainName
    EnhancementEndorsement
    EquipmentBreakdown
    EquipmentBreakdownBIEEDed
    EquipmentBreakdownContactName
    EquipmentBreakdownContactNumber
    EquipmentBreakdownPropertyDed
    Expiry
    Inception
    IsCommercialCondoUnit
    IsLessorsRisk
    PolicyholderName
    TRIACoverage
  }
  quoteId
  policyId
  policyReference
  pricingOptions {
    buildings {
      buildingId
      biPremium
      buildingNo
      buildingPremium
      contentsPremium
      earthquakePremium
      floodPremium
      optionalEndorsementPremiums {
        lossAssessmentForCondo
        ordinanceAndLawPremium
        outdoorSignsCover
        peakSeasonCover
      }
      totalPremium
    }
    enhancementsPremium
    equipmentBreakdownPremium
    extraProposedOptions {
      proposedTriaPremium
    }
    policyPremium
    pricingOptionId
    totalGrossPremium
    triaPremium
  }
  submission {
    id
    opportunityId
  }
  submissionId
  updatedAt
  validUntil
}
    `;
export const AlbyQuoteDecisionOutcomeFragmentDoc = gql`
    fragment AlbyQuoteDecisionOutcome on AlbyQuoteDecisionResult {
  operationId
  status
  retryable
  submissionId
  quoteId
  quoteNumber
  rawFileId
  selectedFileId
  portalUrl
}
    `;
export const AlbyQuoteDecisionIdentityFragmentDoc = gql`
    fragment AlbyQuoteDecisionIdentity on AlbyQuote {
  id
  opportunityId
  sourceVersion
  gate {
    opportunityId
    mode
    owned
    reason
  }
}
    `;
export const AlbyMarketQuoteFragmentDoc = gql`
    fragment AlbyMarketQuote on AlbyQuoteSummary {
  id
  version
  placementId
  laneId
  runNumber
  logicalLaneKey
  sourceIdentityReason
  productMappingReason
  extractionStatus
  deskReviewState
  producerState
  quoteNumber
  currentness
  currentnessReason
  printedPremium
  printedCurrency
  convertedQuoteId
  producerDecisionReason
  app2ProducerDecidedAt
}
    `;
export const AlbyQuoteActionDetailFragmentDoc = gql`
    fragment AlbyQuoteActionDetail on AlbyQuote {
  id
  version
  opportunityId
  placementId
  laneId
  runNumber
  sourceMarket
  sourceProduct
  marketId
  productId
  marketDisplayName
  productLine
  logicalLaneKey
  sourceIdentityReason
  productMappingReason
  attemptId
  workOrderId
  sourceVersion
  sourceGeneration
  currentnessGeneration
  currentnessReceiptEventId
  app2StateFetchedAt
  deskUpdatedAt
  deskReview
  currentness
  currentnessReason
  deskQuoteFileId
  receiptEventId
  receiptDedupeKey
  provenance
  gate {
    opportunityId
    mode
    owned
    reason
    enrolledAt
  }
  extractionStatus
  extractionVersion
  terms
  termsCurrency
  quoteNumber
  quoteNumberSource
  originalAvailability
  retainedFileUploadId
  retainedFileSha256
  retainedFileSize
  retainedFileMimeType
  assumptionsAvailability
  assumptions
  portalAssumptions
  portalAssumptionsAvailability
  deskReviewState
  deskReviewTaskId
  producerState
  actionable
  actionHoldReasons
  actionableAt
  preparationErrorCategory
  preparationRetryable
  app2ReceiptPersistedAt
  app2ReadyAt
  deskQuoteReceivedAt
  deskQuoteApprovedAt
  conversionAudit
  producerDecidedByName
  app2ReadAt
  actionAvailability {
    use {
      eligible
      holdReasons
    }
    editInPortal {
      eligible
      holdReasons
    }
    reject {
      eligible
      holdReasons
    }
    resumeConversion {
      operationId
      action
      idempotencyKey
      sourceVersion
      attemptCount
      eligible
      holdReasons
    }
  }
}
    `;
export const EndorsementDataFieldsFragmentDoc = gql`
    fragment EndorsementDataFields on EndorsementData {
  endorsements {
    type
    grossCommissionPercentage
    agentCommissionPercentage
    premium
    brokerFee
    total
  }
  totalPremium
  totalRevenue
}
    `;
export const CreateAgentActionLogDocument = gql`
    mutation CreateAgentActionLog($agentActionId: String!, $type: String!, $fileId: String, $response: String) {
  createAgentActionLog(
    agentActionId: $agentActionId
    type: $type
    fileId: $fileId
    response: $response
  ) {
    id
    agentActionId
    type
    fileId
    response
  }
}
    `;
export type CreateAgentActionLogMutationFn = Apollo.MutationFunction<CreateAgentActionLogMutation, CreateAgentActionLogMutationVariables>;

/**
 * __useCreateAgentActionLogMutation__
 *
 * To run a mutation, you first call `useCreateAgentActionLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgentActionLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgentActionLogMutation, { data, loading, error }] = useCreateAgentActionLogMutation({
 *   variables: {
 *      agentActionId: // value for 'agentActionId'
 *      type: // value for 'type'
 *      fileId: // value for 'fileId'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useCreateAgentActionLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgentActionLogMutation, CreateAgentActionLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgentActionLogMutation, CreateAgentActionLogMutationVariables>(CreateAgentActionLogDocument, options);
      }
export type CreateAgentActionLogMutationHookResult = ReturnType<typeof useCreateAgentActionLogMutation>;
export type CreateAgentActionLogMutationResult = Apollo.MutationResult<CreateAgentActionLogMutation>;
export type CreateAgentActionLogMutationOptions = Apollo.BaseMutationOptions<CreateAgentActionLogMutation, CreateAgentActionLogMutationVariables>;
export const AddAssignmentGroupToBrokerDocument = gql`
    mutation AddAssignmentGroupToBroker($input: AddAssignmentGroupToBrokerDTO!) {
  addAssignmentGroupToBroker(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;
export type AddAssignmentGroupToBrokerMutationFn = Apollo.MutationFunction<AddAssignmentGroupToBrokerMutation, AddAssignmentGroupToBrokerMutationVariables>;

/**
 * __useAddAssignmentGroupToBrokerMutation__
 *
 * To run a mutation, you first call `useAddAssignmentGroupToBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAssignmentGroupToBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAssignmentGroupToBrokerMutation, { data, loading, error }] = useAddAssignmentGroupToBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAssignmentGroupToBrokerMutation(baseOptions?: Apollo.MutationHookOptions<AddAssignmentGroupToBrokerMutation, AddAssignmentGroupToBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAssignmentGroupToBrokerMutation, AddAssignmentGroupToBrokerMutationVariables>(AddAssignmentGroupToBrokerDocument, options);
      }
export type AddAssignmentGroupToBrokerMutationHookResult = ReturnType<typeof useAddAssignmentGroupToBrokerMutation>;
export type AddAssignmentGroupToBrokerMutationResult = Apollo.MutationResult<AddAssignmentGroupToBrokerMutation>;
export type AddAssignmentGroupToBrokerMutationOptions = Apollo.BaseMutationOptions<AddAssignmentGroupToBrokerMutation, AddAssignmentGroupToBrokerMutationVariables>;
export const AddAttachmentToInboxDraftDocument = gql`
    mutation AddAttachmentToInboxDraft($input: AddAttachmentToDraftInputDto!) {
  addAttachmentToInboxDraft(input: $input) {
    ...DraftMessageAttachment
  }
}
    ${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type AddAttachmentToInboxDraftMutationFn = Apollo.MutationFunction<AddAttachmentToInboxDraftMutation, AddAttachmentToInboxDraftMutationVariables>;

/**
 * __useAddAttachmentToInboxDraftMutation__
 *
 * To run a mutation, you first call `useAddAttachmentToInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAttachmentToInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAttachmentToInboxDraftMutation, { data, loading, error }] = useAddAttachmentToInboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAttachmentToInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<AddAttachmentToInboxDraftMutation, AddAttachmentToInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAttachmentToInboxDraftMutation, AddAttachmentToInboxDraftMutationVariables>(AddAttachmentToInboxDraftDocument, options);
      }
export type AddAttachmentToInboxDraftMutationHookResult = ReturnType<typeof useAddAttachmentToInboxDraftMutation>;
export type AddAttachmentToInboxDraftMutationResult = Apollo.MutationResult<AddAttachmentToInboxDraftMutation>;
export type AddAttachmentToInboxDraftMutationOptions = Apollo.BaseMutationOptions<AddAttachmentToInboxDraftMutation, AddAttachmentToInboxDraftMutationVariables>;
export const AddCarrierContactToAppetiteProductDocument = gql`
    mutation AddCarrierContactToAppetiteProduct($input: CarrierContactConnectorInput!) {
  addCarrierContactToAppetiteProduct(input: $input) {
    ...CarrierContact
  }
}
    ${CarrierContactFragmentDoc}`;
export type AddCarrierContactToAppetiteProductMutationFn = Apollo.MutationFunction<AddCarrierContactToAppetiteProductMutation, AddCarrierContactToAppetiteProductMutationVariables>;

/**
 * __useAddCarrierContactToAppetiteProductMutation__
 *
 * To run a mutation, you first call `useAddCarrierContactToAppetiteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarrierContactToAppetiteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarrierContactToAppetiteProductMutation, { data, loading, error }] = useAddCarrierContactToAppetiteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCarrierContactToAppetiteProductMutation(baseOptions?: Apollo.MutationHookOptions<AddCarrierContactToAppetiteProductMutation, AddCarrierContactToAppetiteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCarrierContactToAppetiteProductMutation, AddCarrierContactToAppetiteProductMutationVariables>(AddCarrierContactToAppetiteProductDocument, options);
      }
export type AddCarrierContactToAppetiteProductMutationHookResult = ReturnType<typeof useAddCarrierContactToAppetiteProductMutation>;
export type AddCarrierContactToAppetiteProductMutationResult = Apollo.MutationResult<AddCarrierContactToAppetiteProductMutation>;
export type AddCarrierContactToAppetiteProductMutationOptions = Apollo.BaseMutationOptions<AddCarrierContactToAppetiteProductMutation, AddCarrierContactToAppetiteProductMutationVariables>;
export const AddInboxConversationLabelDocument = gql`
    mutation AddInboxConversationLabel($input: AddConversationLabelInput!) {
  addInboxConversationLabel(input: $input) {
    ...InboxConversationsListConversation
  }
}
    ${InboxConversationsListConversationFragmentDoc}
${InboxConversationsConversationFragmentDoc}`;
export type AddInboxConversationLabelMutationFn = Apollo.MutationFunction<AddInboxConversationLabelMutation, AddInboxConversationLabelMutationVariables>;

/**
 * __useAddInboxConversationLabelMutation__
 *
 * To run a mutation, you first call `useAddInboxConversationLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInboxConversationLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInboxConversationLabelMutation, { data, loading, error }] = useAddInboxConversationLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInboxConversationLabelMutation(baseOptions?: Apollo.MutationHookOptions<AddInboxConversationLabelMutation, AddInboxConversationLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInboxConversationLabelMutation, AddInboxConversationLabelMutationVariables>(AddInboxConversationLabelDocument, options);
      }
export type AddInboxConversationLabelMutationHookResult = ReturnType<typeof useAddInboxConversationLabelMutation>;
export type AddInboxConversationLabelMutationResult = Apollo.MutationResult<AddInboxConversationLabelMutation>;
export type AddInboxConversationLabelMutationOptions = Apollo.BaseMutationOptions<AddInboxConversationLabelMutation, AddInboxConversationLabelMutationVariables>;
export const AddPlaybookToSetDocument = gql`
    mutation AddPlaybookToSet($playbookId: String!, $setId: ID!) {
  addPlaybookToSet(playbookId: $playbookId, setId: $setId)
}
    `;
export type AddPlaybookToSetMutationFn = Apollo.MutationFunction<AddPlaybookToSetMutation, AddPlaybookToSetMutationVariables>;

/**
 * __useAddPlaybookToSetMutation__
 *
 * To run a mutation, you first call `useAddPlaybookToSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPlaybookToSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPlaybookToSetMutation, { data, loading, error }] = useAddPlaybookToSetMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useAddPlaybookToSetMutation(baseOptions?: Apollo.MutationHookOptions<AddPlaybookToSetMutation, AddPlaybookToSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPlaybookToSetMutation, AddPlaybookToSetMutationVariables>(AddPlaybookToSetDocument, options);
      }
export type AddPlaybookToSetMutationHookResult = ReturnType<typeof useAddPlaybookToSetMutation>;
export type AddPlaybookToSetMutationResult = Apollo.MutationResult<AddPlaybookToSetMutation>;
export type AddPlaybookToSetMutationOptions = Apollo.BaseMutationOptions<AddPlaybookToSetMutation, AddPlaybookToSetMutationVariables>;
export const AddSubmissionRuleOutReasonDocument = gql`
    mutation AddSubmissionRuleOutReason($input: AddSubmissionRuleOutReasonInput!) {
  addSubmissionRuleOutReason(input: $input) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}
${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;
export type AddSubmissionRuleOutReasonMutationFn = Apollo.MutationFunction<AddSubmissionRuleOutReasonMutation, AddSubmissionRuleOutReasonMutationVariables>;

/**
 * __useAddSubmissionRuleOutReasonMutation__
 *
 * To run a mutation, you first call `useAddSubmissionRuleOutReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSubmissionRuleOutReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSubmissionRuleOutReasonMutation, { data, loading, error }] = useAddSubmissionRuleOutReasonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddSubmissionRuleOutReasonMutation(baseOptions?: Apollo.MutationHookOptions<AddSubmissionRuleOutReasonMutation, AddSubmissionRuleOutReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSubmissionRuleOutReasonMutation, AddSubmissionRuleOutReasonMutationVariables>(AddSubmissionRuleOutReasonDocument, options);
      }
export type AddSubmissionRuleOutReasonMutationHookResult = ReturnType<typeof useAddSubmissionRuleOutReasonMutation>;
export type AddSubmissionRuleOutReasonMutationResult = Apollo.MutationResult<AddSubmissionRuleOutReasonMutation>;
export type AddSubmissionRuleOutReasonMutationOptions = Apollo.BaseMutationOptions<AddSubmissionRuleOutReasonMutation, AddSubmissionRuleOutReasonMutationVariables>;
export const UseAlbyQuoteDocument = gql`
    mutation UseAlbyQuote($input: AlbyQuoteConversionInput!) {
  useAlbyQuote(input: $input) {
    ...AlbyQuoteDecisionOutcome
    quote {
      ...AlbyQuoteDecisionIdentity
    }
  }
}
    ${AlbyQuoteDecisionOutcomeFragmentDoc}
${AlbyQuoteDecisionIdentityFragmentDoc}`;
export type UseAlbyQuoteMutationFn = Apollo.MutationFunction<UseAlbyQuoteMutation, UseAlbyQuoteMutationVariables>;

/**
 * __useUseAlbyQuoteMutation__
 *
 * To run a mutation, you first call `useUseAlbyQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseAlbyQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useAlbyQuoteMutation, { data, loading, error }] = useUseAlbyQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUseAlbyQuoteMutation(baseOptions?: Apollo.MutationHookOptions<UseAlbyQuoteMutation, UseAlbyQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseAlbyQuoteMutation, UseAlbyQuoteMutationVariables>(UseAlbyQuoteDocument, options);
      }
export type UseAlbyQuoteMutationHookResult = ReturnType<typeof useUseAlbyQuoteMutation>;
export type UseAlbyQuoteMutationResult = Apollo.MutationResult<UseAlbyQuoteMutation>;
export type UseAlbyQuoteMutationOptions = Apollo.BaseMutationOptions<UseAlbyQuoteMutation, UseAlbyQuoteMutationVariables>;
export const EditAlbyQuoteInPortalDocument = gql`
    mutation EditAlbyQuoteInPortal($input: AlbyQuoteConversionInput!) {
  editAlbyQuoteInPortal(input: $input) {
    ...AlbyQuoteDecisionOutcome
    quote {
      ...AlbyQuoteDecisionIdentity
    }
  }
}
    ${AlbyQuoteDecisionOutcomeFragmentDoc}
${AlbyQuoteDecisionIdentityFragmentDoc}`;
export type EditAlbyQuoteInPortalMutationFn = Apollo.MutationFunction<EditAlbyQuoteInPortalMutation, EditAlbyQuoteInPortalMutationVariables>;

/**
 * __useEditAlbyQuoteInPortalMutation__
 *
 * To run a mutation, you first call `useEditAlbyQuoteInPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAlbyQuoteInPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAlbyQuoteInPortalMutation, { data, loading, error }] = useEditAlbyQuoteInPortalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAlbyQuoteInPortalMutation(baseOptions?: Apollo.MutationHookOptions<EditAlbyQuoteInPortalMutation, EditAlbyQuoteInPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAlbyQuoteInPortalMutation, EditAlbyQuoteInPortalMutationVariables>(EditAlbyQuoteInPortalDocument, options);
      }
export type EditAlbyQuoteInPortalMutationHookResult = ReturnType<typeof useEditAlbyQuoteInPortalMutation>;
export type EditAlbyQuoteInPortalMutationResult = Apollo.MutationResult<EditAlbyQuoteInPortalMutation>;
export type EditAlbyQuoteInPortalMutationOptions = Apollo.BaseMutationOptions<EditAlbyQuoteInPortalMutation, EditAlbyQuoteInPortalMutationVariables>;
export const RejectAlbyQuoteDocument = gql`
    mutation RejectAlbyQuote($input: RejectAlbyQuoteInput!) {
  rejectAlbyQuote(input: $input) {
    ...AlbyQuoteDecisionOutcome
  }
}
    ${AlbyQuoteDecisionOutcomeFragmentDoc}`;
export type RejectAlbyQuoteMutationFn = Apollo.MutationFunction<RejectAlbyQuoteMutation, RejectAlbyQuoteMutationVariables>;

/**
 * __useRejectAlbyQuoteMutation__
 *
 * To run a mutation, you first call `useRejectAlbyQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAlbyQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAlbyQuoteMutation, { data, loading, error }] = useRejectAlbyQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectAlbyQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RejectAlbyQuoteMutation, RejectAlbyQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAlbyQuoteMutation, RejectAlbyQuoteMutationVariables>(RejectAlbyQuoteDocument, options);
      }
export type RejectAlbyQuoteMutationHookResult = ReturnType<typeof useRejectAlbyQuoteMutation>;
export type RejectAlbyQuoteMutationResult = Apollo.MutationResult<RejectAlbyQuoteMutation>;
export type RejectAlbyQuoteMutationOptions = Apollo.BaseMutationOptions<RejectAlbyQuoteMutation, RejectAlbyQuoteMutationVariables>;
export const ApplyDefaultSecondaryAgentsToAllInsuredsDocument = gql`
    mutation ApplyDefaultSecondaryAgentsToAllInsureds($agencyId: ID!) {
  applyDefaultSecondaryAgentsToAllInsureds(agencyId: $agencyId)
}
    `;
export type ApplyDefaultSecondaryAgentsToAllInsuredsMutationFn = Apollo.MutationFunction<ApplyDefaultSecondaryAgentsToAllInsuredsMutation, ApplyDefaultSecondaryAgentsToAllInsuredsMutationVariables>;

/**
 * __useApplyDefaultSecondaryAgentsToAllInsuredsMutation__
 *
 * To run a mutation, you first call `useApplyDefaultSecondaryAgentsToAllInsuredsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyDefaultSecondaryAgentsToAllInsuredsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyDefaultSecondaryAgentsToAllInsuredsMutation, { data, loading, error }] = useApplyDefaultSecondaryAgentsToAllInsuredsMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useApplyDefaultSecondaryAgentsToAllInsuredsMutation(baseOptions?: Apollo.MutationHookOptions<ApplyDefaultSecondaryAgentsToAllInsuredsMutation, ApplyDefaultSecondaryAgentsToAllInsuredsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyDefaultSecondaryAgentsToAllInsuredsMutation, ApplyDefaultSecondaryAgentsToAllInsuredsMutationVariables>(ApplyDefaultSecondaryAgentsToAllInsuredsDocument, options);
      }
export type ApplyDefaultSecondaryAgentsToAllInsuredsMutationHookResult = ReturnType<typeof useApplyDefaultSecondaryAgentsToAllInsuredsMutation>;
export type ApplyDefaultSecondaryAgentsToAllInsuredsMutationResult = Apollo.MutationResult<ApplyDefaultSecondaryAgentsToAllInsuredsMutation>;
export type ApplyDefaultSecondaryAgentsToAllInsuredsMutationOptions = Apollo.BaseMutationOptions<ApplyDefaultSecondaryAgentsToAllInsuredsMutation, ApplyDefaultSecondaryAgentsToAllInsuredsMutationVariables>;
export const ArchiveFileUploadDocument = gql`
    mutation ArchiveFileUpload($input: DeleteFileUploadInput!) {
  archiveFileUpload(input: $input) {
    id
  }
}
    `;
export type ArchiveFileUploadMutationFn = Apollo.MutationFunction<ArchiveFileUploadMutation, ArchiveFileUploadMutationVariables>;

/**
 * __useArchiveFileUploadMutation__
 *
 * To run a mutation, you first call `useArchiveFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveFileUploadMutation, { data, loading, error }] = useArchiveFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveFileUploadMutation, ArchiveFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveFileUploadMutation, ArchiveFileUploadMutationVariables>(ArchiveFileUploadDocument, options);
      }
export type ArchiveFileUploadMutationHookResult = ReturnType<typeof useArchiveFileUploadMutation>;
export type ArchiveFileUploadMutationResult = Apollo.MutationResult<ArchiveFileUploadMutation>;
export type ArchiveFileUploadMutationOptions = Apollo.BaseMutationOptions<ArchiveFileUploadMutation, ArchiveFileUploadMutationVariables>;
export const CreateAttributionProducerBaseIncentiveDocument = gql`
    mutation CreateAttributionProducerBaseIncentive($input: JSONObject!) {
  createAttributionProducerBaseIncentive(input: $input) {
    id
    producerEmails
    startDate
    endDate
    bandStart
    bandEnd
    incentivePayPercentage
    createdAt
    updatedAt
  }
}
    `;
export type CreateAttributionProducerBaseIncentiveMutationFn = Apollo.MutationFunction<CreateAttributionProducerBaseIncentiveMutation, CreateAttributionProducerBaseIncentiveMutationVariables>;

/**
 * __useCreateAttributionProducerBaseIncentiveMutation__
 *
 * To run a mutation, you first call `useCreateAttributionProducerBaseIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttributionProducerBaseIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttributionProducerBaseIncentiveMutation, { data, loading, error }] = useCreateAttributionProducerBaseIncentiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttributionProducerBaseIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttributionProducerBaseIncentiveMutation, CreateAttributionProducerBaseIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttributionProducerBaseIncentiveMutation, CreateAttributionProducerBaseIncentiveMutationVariables>(CreateAttributionProducerBaseIncentiveDocument, options);
      }
export type CreateAttributionProducerBaseIncentiveMutationHookResult = ReturnType<typeof useCreateAttributionProducerBaseIncentiveMutation>;
export type CreateAttributionProducerBaseIncentiveMutationResult = Apollo.MutationResult<CreateAttributionProducerBaseIncentiveMutation>;
export type CreateAttributionProducerBaseIncentiveMutationOptions = Apollo.BaseMutationOptions<CreateAttributionProducerBaseIncentiveMutation, CreateAttributionProducerBaseIncentiveMutationVariables>;
export const UpdateAttributionProducerBaseIncentiveDocument = gql`
    mutation UpdateAttributionProducerBaseIncentive($id: String!, $input: JSONObject!) {
  updateAttributionProducerBaseIncentive(id: $id, input: $input) {
    id
    producerEmails
    startDate
    endDate
    bandStart
    bandEnd
    incentivePayPercentage
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAttributionProducerBaseIncentiveMutationFn = Apollo.MutationFunction<UpdateAttributionProducerBaseIncentiveMutation, UpdateAttributionProducerBaseIncentiveMutationVariables>;

/**
 * __useUpdateAttributionProducerBaseIncentiveMutation__
 *
 * To run a mutation, you first call `useUpdateAttributionProducerBaseIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributionProducerBaseIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributionProducerBaseIncentiveMutation, { data, loading, error }] = useUpdateAttributionProducerBaseIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttributionProducerBaseIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributionProducerBaseIncentiveMutation, UpdateAttributionProducerBaseIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributionProducerBaseIncentiveMutation, UpdateAttributionProducerBaseIncentiveMutationVariables>(UpdateAttributionProducerBaseIncentiveDocument, options);
      }
export type UpdateAttributionProducerBaseIncentiveMutationHookResult = ReturnType<typeof useUpdateAttributionProducerBaseIncentiveMutation>;
export type UpdateAttributionProducerBaseIncentiveMutationResult = Apollo.MutationResult<UpdateAttributionProducerBaseIncentiveMutation>;
export type UpdateAttributionProducerBaseIncentiveMutationOptions = Apollo.BaseMutationOptions<UpdateAttributionProducerBaseIncentiveMutation, UpdateAttributionProducerBaseIncentiveMutationVariables>;
export const DeleteAttributionProducerBaseIncentiveDocument = gql`
    mutation DeleteAttributionProducerBaseIncentive($id: String!) {
  deleteAttributionProducerBaseIncentive(id: $id) {
    success
  }
}
    `;
export type DeleteAttributionProducerBaseIncentiveMutationFn = Apollo.MutationFunction<DeleteAttributionProducerBaseIncentiveMutation, DeleteAttributionProducerBaseIncentiveMutationVariables>;

/**
 * __useDeleteAttributionProducerBaseIncentiveMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionProducerBaseIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionProducerBaseIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionProducerBaseIncentiveMutation, { data, loading, error }] = useDeleteAttributionProducerBaseIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttributionProducerBaseIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionProducerBaseIncentiveMutation, DeleteAttributionProducerBaseIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionProducerBaseIncentiveMutation, DeleteAttributionProducerBaseIncentiveMutationVariables>(DeleteAttributionProducerBaseIncentiveDocument, options);
      }
export type DeleteAttributionProducerBaseIncentiveMutationHookResult = ReturnType<typeof useDeleteAttributionProducerBaseIncentiveMutation>;
export type DeleteAttributionProducerBaseIncentiveMutationResult = Apollo.MutationResult<DeleteAttributionProducerBaseIncentiveMutation>;
export type DeleteAttributionProducerBaseIncentiveMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionProducerBaseIncentiveMutation, DeleteAttributionProducerBaseIncentiveMutationVariables>;
export const CreateAttributionProducerBookBasedIncentiveDocument = gql`
    mutation CreateAttributionProducerBookBasedIncentive($input: JSONObject!) {
  createAttributionProducerBookBasedIncentive(input: $input) {
    id
    producerEmail
    bindhqLobs
    bindhqLobsInclude
    bindhqPolicyBusinessType
    naicsCode
    naicsCodeInclude
    cglCode
    cglCodeInclude
    startDate
    endDate
    incentivePayPercentage
    createdAt
    updatedAt
  }
}
    `;
export type CreateAttributionProducerBookBasedIncentiveMutationFn = Apollo.MutationFunction<CreateAttributionProducerBookBasedIncentiveMutation, CreateAttributionProducerBookBasedIncentiveMutationVariables>;

/**
 * __useCreateAttributionProducerBookBasedIncentiveMutation__
 *
 * To run a mutation, you first call `useCreateAttributionProducerBookBasedIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttributionProducerBookBasedIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttributionProducerBookBasedIncentiveMutation, { data, loading, error }] = useCreateAttributionProducerBookBasedIncentiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttributionProducerBookBasedIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttributionProducerBookBasedIncentiveMutation, CreateAttributionProducerBookBasedIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttributionProducerBookBasedIncentiveMutation, CreateAttributionProducerBookBasedIncentiveMutationVariables>(CreateAttributionProducerBookBasedIncentiveDocument, options);
      }
export type CreateAttributionProducerBookBasedIncentiveMutationHookResult = ReturnType<typeof useCreateAttributionProducerBookBasedIncentiveMutation>;
export type CreateAttributionProducerBookBasedIncentiveMutationResult = Apollo.MutationResult<CreateAttributionProducerBookBasedIncentiveMutation>;
export type CreateAttributionProducerBookBasedIncentiveMutationOptions = Apollo.BaseMutationOptions<CreateAttributionProducerBookBasedIncentiveMutation, CreateAttributionProducerBookBasedIncentiveMutationVariables>;
export const UpdateAttributionProducerBookBasedIncentiveDocument = gql`
    mutation UpdateAttributionProducerBookBasedIncentive($id: String!, $input: JSONObject!) {
  updateAttributionProducerBookBasedIncentive(id: $id, input: $input) {
    id
    producerEmail
    bindhqLobs
    bindhqLobsInclude
    bindhqPolicyBusinessType
    naicsCode
    naicsCodeInclude
    cglCode
    cglCodeInclude
    startDate
    endDate
    incentivePayPercentage
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAttributionProducerBookBasedIncentiveMutationFn = Apollo.MutationFunction<UpdateAttributionProducerBookBasedIncentiveMutation, UpdateAttributionProducerBookBasedIncentiveMutationVariables>;

/**
 * __useUpdateAttributionProducerBookBasedIncentiveMutation__
 *
 * To run a mutation, you first call `useUpdateAttributionProducerBookBasedIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributionProducerBookBasedIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributionProducerBookBasedIncentiveMutation, { data, loading, error }] = useUpdateAttributionProducerBookBasedIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttributionProducerBookBasedIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributionProducerBookBasedIncentiveMutation, UpdateAttributionProducerBookBasedIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributionProducerBookBasedIncentiveMutation, UpdateAttributionProducerBookBasedIncentiveMutationVariables>(UpdateAttributionProducerBookBasedIncentiveDocument, options);
      }
export type UpdateAttributionProducerBookBasedIncentiveMutationHookResult = ReturnType<typeof useUpdateAttributionProducerBookBasedIncentiveMutation>;
export type UpdateAttributionProducerBookBasedIncentiveMutationResult = Apollo.MutationResult<UpdateAttributionProducerBookBasedIncentiveMutation>;
export type UpdateAttributionProducerBookBasedIncentiveMutationOptions = Apollo.BaseMutationOptions<UpdateAttributionProducerBookBasedIncentiveMutation, UpdateAttributionProducerBookBasedIncentiveMutationVariables>;
export const DeleteAttributionProducerBookBasedIncentiveDocument = gql`
    mutation DeleteAttributionProducerBookBasedIncentive($id: String!) {
  deleteAttributionProducerBookBasedIncentive(id: $id) {
    success
  }
}
    `;
export type DeleteAttributionProducerBookBasedIncentiveMutationFn = Apollo.MutationFunction<DeleteAttributionProducerBookBasedIncentiveMutation, DeleteAttributionProducerBookBasedIncentiveMutationVariables>;

/**
 * __useDeleteAttributionProducerBookBasedIncentiveMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionProducerBookBasedIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionProducerBookBasedIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionProducerBookBasedIncentiveMutation, { data, loading, error }] = useDeleteAttributionProducerBookBasedIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttributionProducerBookBasedIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionProducerBookBasedIncentiveMutation, DeleteAttributionProducerBookBasedIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionProducerBookBasedIncentiveMutation, DeleteAttributionProducerBookBasedIncentiveMutationVariables>(DeleteAttributionProducerBookBasedIncentiveDocument, options);
      }
export type DeleteAttributionProducerBookBasedIncentiveMutationHookResult = ReturnType<typeof useDeleteAttributionProducerBookBasedIncentiveMutation>;
export type DeleteAttributionProducerBookBasedIncentiveMutationResult = Apollo.MutationResult<DeleteAttributionProducerBookBasedIncentiveMutation>;
export type DeleteAttributionProducerBookBasedIncentiveMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionProducerBookBasedIncentiveMutation, DeleteAttributionProducerBookBasedIncentiveMutationVariables>;
export const BulkDeleteAttributionProducerBookBasedIncentivesDocument = gql`
    mutation BulkDeleteAttributionProducerBookBasedIncentives($ids: [String!]!) {
  bulkDeleteAttributionProducerBookBasedIncentives(ids: $ids) {
    success
    deletedCount
  }
}
    `;
export type BulkDeleteAttributionProducerBookBasedIncentivesMutationFn = Apollo.MutationFunction<BulkDeleteAttributionProducerBookBasedIncentivesMutation, BulkDeleteAttributionProducerBookBasedIncentivesMutationVariables>;

/**
 * __useBulkDeleteAttributionProducerBookBasedIncentivesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteAttributionProducerBookBasedIncentivesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteAttributionProducerBookBasedIncentivesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteAttributionProducerBookBasedIncentivesMutation, { data, loading, error }] = useBulkDeleteAttributionProducerBookBasedIncentivesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDeleteAttributionProducerBookBasedIncentivesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteAttributionProducerBookBasedIncentivesMutation, BulkDeleteAttributionProducerBookBasedIncentivesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteAttributionProducerBookBasedIncentivesMutation, BulkDeleteAttributionProducerBookBasedIncentivesMutationVariables>(BulkDeleteAttributionProducerBookBasedIncentivesDocument, options);
      }
export type BulkDeleteAttributionProducerBookBasedIncentivesMutationHookResult = ReturnType<typeof useBulkDeleteAttributionProducerBookBasedIncentivesMutation>;
export type BulkDeleteAttributionProducerBookBasedIncentivesMutationResult = Apollo.MutationResult<BulkDeleteAttributionProducerBookBasedIncentivesMutation>;
export type BulkDeleteAttributionProducerBookBasedIncentivesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteAttributionProducerBookBasedIncentivesMutation, BulkDeleteAttributionProducerBookBasedIncentivesMutationVariables>;
export const CreateAttributionProducerManagementBasedIncentiveDocument = gql`
    mutation CreateAttributionProducerManagementBasedIncentive($input: JSONObject!) {
  createAttributionProducerManagementBasedIncentive(input: $input) {
    id
    managerEmail
    producerEmail
    startDate
    endDate
    revenuePercentage
    createdAt
    updatedAt
  }
}
    `;
export type CreateAttributionProducerManagementBasedIncentiveMutationFn = Apollo.MutationFunction<CreateAttributionProducerManagementBasedIncentiveMutation, CreateAttributionProducerManagementBasedIncentiveMutationVariables>;

/**
 * __useCreateAttributionProducerManagementBasedIncentiveMutation__
 *
 * To run a mutation, you first call `useCreateAttributionProducerManagementBasedIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttributionProducerManagementBasedIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttributionProducerManagementBasedIncentiveMutation, { data, loading, error }] = useCreateAttributionProducerManagementBasedIncentiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttributionProducerManagementBasedIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttributionProducerManagementBasedIncentiveMutation, CreateAttributionProducerManagementBasedIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttributionProducerManagementBasedIncentiveMutation, CreateAttributionProducerManagementBasedIncentiveMutationVariables>(CreateAttributionProducerManagementBasedIncentiveDocument, options);
      }
export type CreateAttributionProducerManagementBasedIncentiveMutationHookResult = ReturnType<typeof useCreateAttributionProducerManagementBasedIncentiveMutation>;
export type CreateAttributionProducerManagementBasedIncentiveMutationResult = Apollo.MutationResult<CreateAttributionProducerManagementBasedIncentiveMutation>;
export type CreateAttributionProducerManagementBasedIncentiveMutationOptions = Apollo.BaseMutationOptions<CreateAttributionProducerManagementBasedIncentiveMutation, CreateAttributionProducerManagementBasedIncentiveMutationVariables>;
export const UpdateAttributionProducerManagementBasedIncentiveDocument = gql`
    mutation UpdateAttributionProducerManagementBasedIncentive($id: String!, $input: JSONObject!) {
  updateAttributionProducerManagementBasedIncentive(id: $id, input: $input) {
    id
    managerEmail
    producerEmail
    startDate
    endDate
    revenuePercentage
    createdAt
    updatedAt
  }
}
    `;
export type UpdateAttributionProducerManagementBasedIncentiveMutationFn = Apollo.MutationFunction<UpdateAttributionProducerManagementBasedIncentiveMutation, UpdateAttributionProducerManagementBasedIncentiveMutationVariables>;

/**
 * __useUpdateAttributionProducerManagementBasedIncentiveMutation__
 *
 * To run a mutation, you first call `useUpdateAttributionProducerManagementBasedIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributionProducerManagementBasedIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributionProducerManagementBasedIncentiveMutation, { data, loading, error }] = useUpdateAttributionProducerManagementBasedIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttributionProducerManagementBasedIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributionProducerManagementBasedIncentiveMutation, UpdateAttributionProducerManagementBasedIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributionProducerManagementBasedIncentiveMutation, UpdateAttributionProducerManagementBasedIncentiveMutationVariables>(UpdateAttributionProducerManagementBasedIncentiveDocument, options);
      }
export type UpdateAttributionProducerManagementBasedIncentiveMutationHookResult = ReturnType<typeof useUpdateAttributionProducerManagementBasedIncentiveMutation>;
export type UpdateAttributionProducerManagementBasedIncentiveMutationResult = Apollo.MutationResult<UpdateAttributionProducerManagementBasedIncentiveMutation>;
export type UpdateAttributionProducerManagementBasedIncentiveMutationOptions = Apollo.BaseMutationOptions<UpdateAttributionProducerManagementBasedIncentiveMutation, UpdateAttributionProducerManagementBasedIncentiveMutationVariables>;
export const DeleteAttributionProducerManagementBasedIncentiveDocument = gql`
    mutation DeleteAttributionProducerManagementBasedIncentive($id: String!) {
  deleteAttributionProducerManagementBasedIncentive(id: $id) {
    success
  }
}
    `;
export type DeleteAttributionProducerManagementBasedIncentiveMutationFn = Apollo.MutationFunction<DeleteAttributionProducerManagementBasedIncentiveMutation, DeleteAttributionProducerManagementBasedIncentiveMutationVariables>;

/**
 * __useDeleteAttributionProducerManagementBasedIncentiveMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionProducerManagementBasedIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionProducerManagementBasedIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionProducerManagementBasedIncentiveMutation, { data, loading, error }] = useDeleteAttributionProducerManagementBasedIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttributionProducerManagementBasedIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionProducerManagementBasedIncentiveMutation, DeleteAttributionProducerManagementBasedIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionProducerManagementBasedIncentiveMutation, DeleteAttributionProducerManagementBasedIncentiveMutationVariables>(DeleteAttributionProducerManagementBasedIncentiveDocument, options);
      }
export type DeleteAttributionProducerManagementBasedIncentiveMutationHookResult = ReturnType<typeof useDeleteAttributionProducerManagementBasedIncentiveMutation>;
export type DeleteAttributionProducerManagementBasedIncentiveMutationResult = Apollo.MutationResult<DeleteAttributionProducerManagementBasedIncentiveMutation>;
export type DeleteAttributionProducerManagementBasedIncentiveMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionProducerManagementBasedIncentiveMutation, DeleteAttributionProducerManagementBasedIncentiveMutationVariables>;
export const BulkDeleteAttributionProducerManagementBasedIncentivesDocument = gql`
    mutation BulkDeleteAttributionProducerManagementBasedIncentives($ids: [String!]!) {
  bulkDeleteAttributionProducerManagementBasedIncentives(ids: $ids) {
    success
    deletedCount
  }
}
    `;
export type BulkDeleteAttributionProducerManagementBasedIncentivesMutationFn = Apollo.MutationFunction<BulkDeleteAttributionProducerManagementBasedIncentivesMutation, BulkDeleteAttributionProducerManagementBasedIncentivesMutationVariables>;

/**
 * __useBulkDeleteAttributionProducerManagementBasedIncentivesMutation__
 *
 * To run a mutation, you first call `useBulkDeleteAttributionProducerManagementBasedIncentivesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteAttributionProducerManagementBasedIncentivesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteAttributionProducerManagementBasedIncentivesMutation, { data, loading, error }] = useBulkDeleteAttributionProducerManagementBasedIncentivesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBulkDeleteAttributionProducerManagementBasedIncentivesMutation(baseOptions?: Apollo.MutationHookOptions<BulkDeleteAttributionProducerManagementBasedIncentivesMutation, BulkDeleteAttributionProducerManagementBasedIncentivesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkDeleteAttributionProducerManagementBasedIncentivesMutation, BulkDeleteAttributionProducerManagementBasedIncentivesMutationVariables>(BulkDeleteAttributionProducerManagementBasedIncentivesDocument, options);
      }
export type BulkDeleteAttributionProducerManagementBasedIncentivesMutationHookResult = ReturnType<typeof useBulkDeleteAttributionProducerManagementBasedIncentivesMutation>;
export type BulkDeleteAttributionProducerManagementBasedIncentivesMutationResult = Apollo.MutationResult<BulkDeleteAttributionProducerManagementBasedIncentivesMutation>;
export type BulkDeleteAttributionProducerManagementBasedIncentivesMutationOptions = Apollo.BaseMutationOptions<BulkDeleteAttributionProducerManagementBasedIncentivesMutation, BulkDeleteAttributionProducerManagementBasedIncentivesMutationVariables>;
export const CreateAttributionArmIncentiveDocument = gql`
    mutation CreateAttributionArmIncentive($input: JSONObject!) {
  createAttributionArmIncentive(input: $input) {
    incentive {
      id
      armEmails
      startDate
      endDate
      renewalBaseRate
      newBusinessBaseRate
      agencyGraduationThreshold
      agencyGraduationBonusRate
      previousYearEstimatedRevenue
      previousYearEstimatedVariable
      kickerTiers {
        targetAchievementPercent
        kickerRate
      }
      updatedByEmail
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateAttributionArmIncentiveMutationFn = Apollo.MutationFunction<CreateAttributionArmIncentiveMutation, CreateAttributionArmIncentiveMutationVariables>;

/**
 * __useCreateAttributionArmIncentiveMutation__
 *
 * To run a mutation, you first call `useCreateAttributionArmIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAttributionArmIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAttributionArmIncentiveMutation, { data, loading, error }] = useCreateAttributionArmIncentiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAttributionArmIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateAttributionArmIncentiveMutation, CreateAttributionArmIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAttributionArmIncentiveMutation, CreateAttributionArmIncentiveMutationVariables>(CreateAttributionArmIncentiveDocument, options);
      }
export type CreateAttributionArmIncentiveMutationHookResult = ReturnType<typeof useCreateAttributionArmIncentiveMutation>;
export type CreateAttributionArmIncentiveMutationResult = Apollo.MutationResult<CreateAttributionArmIncentiveMutation>;
export type CreateAttributionArmIncentiveMutationOptions = Apollo.BaseMutationOptions<CreateAttributionArmIncentiveMutation, CreateAttributionArmIncentiveMutationVariables>;
export const UpdateAttributionArmIncentiveDocument = gql`
    mutation UpdateAttributionArmIncentive($id: String!, $input: JSONObject!) {
  updateAttributionArmIncentive(id: $id, input: $input) {
    incentive {
      id
      armEmails
      startDate
      endDate
      renewalBaseRate
      newBusinessBaseRate
      agencyGraduationThreshold
      agencyGraduationBonusRate
      previousYearEstimatedRevenue
      previousYearEstimatedVariable
      kickerTiers {
        targetAchievementPercent
        kickerRate
      }
      updatedByEmail
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateAttributionArmIncentiveMutationFn = Apollo.MutationFunction<UpdateAttributionArmIncentiveMutation, UpdateAttributionArmIncentiveMutationVariables>;

/**
 * __useUpdateAttributionArmIncentiveMutation__
 *
 * To run a mutation, you first call `useUpdateAttributionArmIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributionArmIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributionArmIncentiveMutation, { data, loading, error }] = useUpdateAttributionArmIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttributionArmIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributionArmIncentiveMutation, UpdateAttributionArmIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributionArmIncentiveMutation, UpdateAttributionArmIncentiveMutationVariables>(UpdateAttributionArmIncentiveDocument, options);
      }
export type UpdateAttributionArmIncentiveMutationHookResult = ReturnType<typeof useUpdateAttributionArmIncentiveMutation>;
export type UpdateAttributionArmIncentiveMutationResult = Apollo.MutationResult<UpdateAttributionArmIncentiveMutation>;
export type UpdateAttributionArmIncentiveMutationOptions = Apollo.BaseMutationOptions<UpdateAttributionArmIncentiveMutation, UpdateAttributionArmIncentiveMutationVariables>;
export const DeleteAttributionArmIncentiveDocument = gql`
    mutation DeleteAttributionArmIncentive($id: String!) {
  deleteAttributionArmIncentive(id: $id) {
    success
  }
}
    `;
export type DeleteAttributionArmIncentiveMutationFn = Apollo.MutationFunction<DeleteAttributionArmIncentiveMutation, DeleteAttributionArmIncentiveMutationVariables>;

/**
 * __useDeleteAttributionArmIncentiveMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionArmIncentiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionArmIncentiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionArmIncentiveMutation, { data, loading, error }] = useDeleteAttributionArmIncentiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAttributionArmIncentiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionArmIncentiveMutation, DeleteAttributionArmIncentiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionArmIncentiveMutation, DeleteAttributionArmIncentiveMutationVariables>(DeleteAttributionArmIncentiveDocument, options);
      }
export type DeleteAttributionArmIncentiveMutationHookResult = ReturnType<typeof useDeleteAttributionArmIncentiveMutation>;
export type DeleteAttributionArmIncentiveMutationResult = Apollo.MutationResult<DeleteAttributionArmIncentiveMutation>;
export type DeleteAttributionArmIncentiveMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionArmIncentiveMutation, DeleteAttributionArmIncentiveMutationVariables>;
export const UpsertAttributionProducerLabelDocument = gql`
    mutation UpsertAttributionProducerLabel($input: UpsertAttributionProducerLabelInput!) {
  upsertAttributionProducerLabel(input: $input) {
    producerEmail
    label
    updatedByEmail
    updatedAt
  }
}
    `;
export type UpsertAttributionProducerLabelMutationFn = Apollo.MutationFunction<UpsertAttributionProducerLabelMutation, UpsertAttributionProducerLabelMutationVariables>;

/**
 * __useUpsertAttributionProducerLabelMutation__
 *
 * To run a mutation, you first call `useUpsertAttributionProducerLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAttributionProducerLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAttributionProducerLabelMutation, { data, loading, error }] = useUpsertAttributionProducerLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAttributionProducerLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAttributionProducerLabelMutation, UpsertAttributionProducerLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAttributionProducerLabelMutation, UpsertAttributionProducerLabelMutationVariables>(UpsertAttributionProducerLabelDocument, options);
      }
export type UpsertAttributionProducerLabelMutationHookResult = ReturnType<typeof useUpsertAttributionProducerLabelMutation>;
export type UpsertAttributionProducerLabelMutationResult = Apollo.MutationResult<UpsertAttributionProducerLabelMutation>;
export type UpsertAttributionProducerLabelMutationOptions = Apollo.BaseMutationOptions<UpsertAttributionProducerLabelMutation, UpsertAttributionProducerLabelMutationVariables>;
export const DeleteAttributionProducerLabelDocument = gql`
    mutation DeleteAttributionProducerLabel($producerEmail: String!) {
  deleteAttributionProducerLabel(producerEmail: $producerEmail)
}
    `;
export type DeleteAttributionProducerLabelMutationFn = Apollo.MutationFunction<DeleteAttributionProducerLabelMutation, DeleteAttributionProducerLabelMutationVariables>;

/**
 * __useDeleteAttributionProducerLabelMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionProducerLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionProducerLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionProducerLabelMutation, { data, loading, error }] = useDeleteAttributionProducerLabelMutation({
 *   variables: {
 *      producerEmail: // value for 'producerEmail'
 *   },
 * });
 */
export function useDeleteAttributionProducerLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionProducerLabelMutation, DeleteAttributionProducerLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionProducerLabelMutation, DeleteAttributionProducerLabelMutationVariables>(DeleteAttributionProducerLabelDocument, options);
      }
export type DeleteAttributionProducerLabelMutationHookResult = ReturnType<typeof useDeleteAttributionProducerLabelMutation>;
export type DeleteAttributionProducerLabelMutationResult = Apollo.MutationResult<DeleteAttributionProducerLabelMutation>;
export type DeleteAttributionProducerLabelMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionProducerLabelMutation, DeleteAttributionProducerLabelMutationVariables>;
export const EditAttributionEndorsementReassignmentDocument = gql`
    mutation EditAttributionEndorsementReassignment($input: EditAttributionEndorsementReassignmentInput!) {
  editAttributionEndorsementReassignment(input: $input) {
    success
    message
    count
  }
}
    `;
export type EditAttributionEndorsementReassignmentMutationFn = Apollo.MutationFunction<EditAttributionEndorsementReassignmentMutation, EditAttributionEndorsementReassignmentMutationVariables>;

/**
 * __useEditAttributionEndorsementReassignmentMutation__
 *
 * To run a mutation, you first call `useEditAttributionEndorsementReassignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAttributionEndorsementReassignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAttributionEndorsementReassignmentMutation, { data, loading, error }] = useEditAttributionEndorsementReassignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditAttributionEndorsementReassignmentMutation(baseOptions?: Apollo.MutationHookOptions<EditAttributionEndorsementReassignmentMutation, EditAttributionEndorsementReassignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAttributionEndorsementReassignmentMutation, EditAttributionEndorsementReassignmentMutationVariables>(EditAttributionEndorsementReassignmentDocument, options);
      }
export type EditAttributionEndorsementReassignmentMutationHookResult = ReturnType<typeof useEditAttributionEndorsementReassignmentMutation>;
export type EditAttributionEndorsementReassignmentMutationResult = Apollo.MutationResult<EditAttributionEndorsementReassignmentMutation>;
export type EditAttributionEndorsementReassignmentMutationOptions = Apollo.BaseMutationOptions<EditAttributionEndorsementReassignmentMutation, EditAttributionEndorsementReassignmentMutationVariables>;
export const BulkEditAttributionEndorsementReassignmentsDocument = gql`
    mutation BulkEditAttributionEndorsementReassignments($input: BulkEditAttributionEndorsementReassignmentsInput!) {
  bulkEditAttributionEndorsementReassignments(input: $input) {
    success
    message
    count
  }
}
    `;
export type BulkEditAttributionEndorsementReassignmentsMutationFn = Apollo.MutationFunction<BulkEditAttributionEndorsementReassignmentsMutation, BulkEditAttributionEndorsementReassignmentsMutationVariables>;

/**
 * __useBulkEditAttributionEndorsementReassignmentsMutation__
 *
 * To run a mutation, you first call `useBulkEditAttributionEndorsementReassignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditAttributionEndorsementReassignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditAttributionEndorsementReassignmentsMutation, { data, loading, error }] = useBulkEditAttributionEndorsementReassignmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkEditAttributionEndorsementReassignmentsMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditAttributionEndorsementReassignmentsMutation, BulkEditAttributionEndorsementReassignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditAttributionEndorsementReassignmentsMutation, BulkEditAttributionEndorsementReassignmentsMutationVariables>(BulkEditAttributionEndorsementReassignmentsDocument, options);
      }
export type BulkEditAttributionEndorsementReassignmentsMutationHookResult = ReturnType<typeof useBulkEditAttributionEndorsementReassignmentsMutation>;
export type BulkEditAttributionEndorsementReassignmentsMutationResult = Apollo.MutationResult<BulkEditAttributionEndorsementReassignmentsMutation>;
export type BulkEditAttributionEndorsementReassignmentsMutationOptions = Apollo.BaseMutationOptions<BulkEditAttributionEndorsementReassignmentsMutation, BulkEditAttributionEndorsementReassignmentsMutationVariables>;
export const UpsertAttributionProducerRevenueTargetsDocument = gql`
    mutation UpsertAttributionProducerRevenueTargets($input: UpsertAttributionProducerRevenueTargetsInput!) {
  upsertAttributionProducerRevenueTargets(input: $input) {
    targets {
      id
      producerEmail
      year
      month
      revenueTarget
      updatedByEmail
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpsertAttributionProducerRevenueTargetsMutationFn = Apollo.MutationFunction<UpsertAttributionProducerRevenueTargetsMutation, UpsertAttributionProducerRevenueTargetsMutationVariables>;

/**
 * __useUpsertAttributionProducerRevenueTargetsMutation__
 *
 * To run a mutation, you first call `useUpsertAttributionProducerRevenueTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAttributionProducerRevenueTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAttributionProducerRevenueTargetsMutation, { data, loading, error }] = useUpsertAttributionProducerRevenueTargetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAttributionProducerRevenueTargetsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAttributionProducerRevenueTargetsMutation, UpsertAttributionProducerRevenueTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAttributionProducerRevenueTargetsMutation, UpsertAttributionProducerRevenueTargetsMutationVariables>(UpsertAttributionProducerRevenueTargetsDocument, options);
      }
export type UpsertAttributionProducerRevenueTargetsMutationHookResult = ReturnType<typeof useUpsertAttributionProducerRevenueTargetsMutation>;
export type UpsertAttributionProducerRevenueTargetsMutationResult = Apollo.MutationResult<UpsertAttributionProducerRevenueTargetsMutation>;
export type UpsertAttributionProducerRevenueTargetsMutationOptions = Apollo.BaseMutationOptions<UpsertAttributionProducerRevenueTargetsMutation, UpsertAttributionProducerRevenueTargetsMutationVariables>;
export const UpsertAttributionArmRevenueTargetsDocument = gql`
    mutation UpsertAttributionArmRevenueTargets($input: UpsertAttributionArmRevenueTargetsInput!) {
  upsertAttributionArmRevenueTargets(input: $input) {
    targets {
      id
      producerEmail
      year
      month
      revenueTarget
      updatedByEmail
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpsertAttributionArmRevenueTargetsMutationFn = Apollo.MutationFunction<UpsertAttributionArmRevenueTargetsMutation, UpsertAttributionArmRevenueTargetsMutationVariables>;

/**
 * __useUpsertAttributionArmRevenueTargetsMutation__
 *
 * To run a mutation, you first call `useUpsertAttributionArmRevenueTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAttributionArmRevenueTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAttributionArmRevenueTargetsMutation, { data, loading, error }] = useUpsertAttributionArmRevenueTargetsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAttributionArmRevenueTargetsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAttributionArmRevenueTargetsMutation, UpsertAttributionArmRevenueTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAttributionArmRevenueTargetsMutation, UpsertAttributionArmRevenueTargetsMutationVariables>(UpsertAttributionArmRevenueTargetsDocument, options);
      }
export type UpsertAttributionArmRevenueTargetsMutationHookResult = ReturnType<typeof useUpsertAttributionArmRevenueTargetsMutation>;
export type UpsertAttributionArmRevenueTargetsMutationResult = Apollo.MutationResult<UpsertAttributionArmRevenueTargetsMutation>;
export type UpsertAttributionArmRevenueTargetsMutationOptions = Apollo.BaseMutationOptions<UpsertAttributionArmRevenueTargetsMutation, UpsertAttributionArmRevenueTargetsMutationVariables>;
export const DeleteAttributionProducerRevenueTargetsDocument = gql`
    mutation DeleteAttributionProducerRevenueTargets($producerEmail: String!, $year: Int!) {
  deleteAttributionProducerRevenueTargets(
    producerEmail: $producerEmail
    year: $year
  ) {
    success
    deletedCount
  }
}
    `;
export type DeleteAttributionProducerRevenueTargetsMutationFn = Apollo.MutationFunction<DeleteAttributionProducerRevenueTargetsMutation, DeleteAttributionProducerRevenueTargetsMutationVariables>;

/**
 * __useDeleteAttributionProducerRevenueTargetsMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionProducerRevenueTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionProducerRevenueTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionProducerRevenueTargetsMutation, { data, loading, error }] = useDeleteAttributionProducerRevenueTargetsMutation({
 *   variables: {
 *      producerEmail: // value for 'producerEmail'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDeleteAttributionProducerRevenueTargetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionProducerRevenueTargetsMutation, DeleteAttributionProducerRevenueTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionProducerRevenueTargetsMutation, DeleteAttributionProducerRevenueTargetsMutationVariables>(DeleteAttributionProducerRevenueTargetsDocument, options);
      }
export type DeleteAttributionProducerRevenueTargetsMutationHookResult = ReturnType<typeof useDeleteAttributionProducerRevenueTargetsMutation>;
export type DeleteAttributionProducerRevenueTargetsMutationResult = Apollo.MutationResult<DeleteAttributionProducerRevenueTargetsMutation>;
export type DeleteAttributionProducerRevenueTargetsMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionProducerRevenueTargetsMutation, DeleteAttributionProducerRevenueTargetsMutationVariables>;
export const DeleteAttributionArmRevenueTargetsDocument = gql`
    mutation DeleteAttributionArmRevenueTargets($armEmail: String!, $year: Int!) {
  deleteAttributionArmRevenueTargets(armEmail: $armEmail, year: $year) {
    success
    deletedCount
  }
}
    `;
export type DeleteAttributionArmRevenueTargetsMutationFn = Apollo.MutationFunction<DeleteAttributionArmRevenueTargetsMutation, DeleteAttributionArmRevenueTargetsMutationVariables>;

/**
 * __useDeleteAttributionArmRevenueTargetsMutation__
 *
 * To run a mutation, you first call `useDeleteAttributionArmRevenueTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttributionArmRevenueTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttributionArmRevenueTargetsMutation, { data, loading, error }] = useDeleteAttributionArmRevenueTargetsMutation({
 *   variables: {
 *      armEmail: // value for 'armEmail'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDeleteAttributionArmRevenueTargetsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttributionArmRevenueTargetsMutation, DeleteAttributionArmRevenueTargetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttributionArmRevenueTargetsMutation, DeleteAttributionArmRevenueTargetsMutationVariables>(DeleteAttributionArmRevenueTargetsDocument, options);
      }
export type DeleteAttributionArmRevenueTargetsMutationHookResult = ReturnType<typeof useDeleteAttributionArmRevenueTargetsMutation>;
export type DeleteAttributionArmRevenueTargetsMutationResult = Apollo.MutationResult<DeleteAttributionArmRevenueTargetsMutation>;
export type DeleteAttributionArmRevenueTargetsMutationOptions = Apollo.BaseMutationOptions<DeleteAttributionArmRevenueTargetsMutation, DeleteAttributionArmRevenueTargetsMutationVariables>;
export const BatchAddLabelToInboxConversationsDocument = gql`
    mutation BatchAddLabelToInboxConversations($input: BatchAddLabelToConversationsInput!) {
  batchAddLabelToInboxConversations(input: $input) {
    ...InboxConversationsListConversation
  }
}
    ${InboxConversationsListConversationFragmentDoc}
${InboxConversationsConversationFragmentDoc}`;
export type BatchAddLabelToInboxConversationsMutationFn = Apollo.MutationFunction<BatchAddLabelToInboxConversationsMutation, BatchAddLabelToInboxConversationsMutationVariables>;

/**
 * __useBatchAddLabelToInboxConversationsMutation__
 *
 * To run a mutation, you first call `useBatchAddLabelToInboxConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchAddLabelToInboxConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchAddLabelToInboxConversationsMutation, { data, loading, error }] = useBatchAddLabelToInboxConversationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchAddLabelToInboxConversationsMutation(baseOptions?: Apollo.MutationHookOptions<BatchAddLabelToInboxConversationsMutation, BatchAddLabelToInboxConversationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchAddLabelToInboxConversationsMutation, BatchAddLabelToInboxConversationsMutationVariables>(BatchAddLabelToInboxConversationsDocument, options);
      }
export type BatchAddLabelToInboxConversationsMutationHookResult = ReturnType<typeof useBatchAddLabelToInboxConversationsMutation>;
export type BatchAddLabelToInboxConversationsMutationResult = Apollo.MutationResult<BatchAddLabelToInboxConversationsMutation>;
export type BatchAddLabelToInboxConversationsMutationOptions = Apollo.BaseMutationOptions<BatchAddLabelToInboxConversationsMutation, BatchAddLabelToInboxConversationsMutationVariables>;
export const BatchDeleteInboxConversationsDocument = gql`
    mutation BatchDeleteInboxConversations($input: BatchDeleteConversationsInput!) {
  batchDeleteInboxConversations(input: $input) {
    count
  }
}
    `;
export type BatchDeleteInboxConversationsMutationFn = Apollo.MutationFunction<BatchDeleteInboxConversationsMutation, BatchDeleteInboxConversationsMutationVariables>;

/**
 * __useBatchDeleteInboxConversationsMutation__
 *
 * To run a mutation, you first call `useBatchDeleteInboxConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteInboxConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteInboxConversationsMutation, { data, loading, error }] = useBatchDeleteInboxConversationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchDeleteInboxConversationsMutation(baseOptions?: Apollo.MutationHookOptions<BatchDeleteInboxConversationsMutation, BatchDeleteInboxConversationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchDeleteInboxConversationsMutation, BatchDeleteInboxConversationsMutationVariables>(BatchDeleteInboxConversationsDocument, options);
      }
export type BatchDeleteInboxConversationsMutationHookResult = ReturnType<typeof useBatchDeleteInboxConversationsMutation>;
export type BatchDeleteInboxConversationsMutationResult = Apollo.MutationResult<BatchDeleteInboxConversationsMutation>;
export type BatchDeleteInboxConversationsMutationOptions = Apollo.BaseMutationOptions<BatchDeleteInboxConversationsMutation, BatchDeleteInboxConversationsMutationVariables>;
export const BatchDeleteInboxDraftsDocument = gql`
    mutation BatchDeleteInboxDrafts($input: BatchDeleteDraftsInputDto!) {
  batchDeleteInboxDrafts(input: $input) {
    count
  }
}
    `;
export type BatchDeleteInboxDraftsMutationFn = Apollo.MutationFunction<BatchDeleteInboxDraftsMutation, BatchDeleteInboxDraftsMutationVariables>;

/**
 * __useBatchDeleteInboxDraftsMutation__
 *
 * To run a mutation, you first call `useBatchDeleteInboxDraftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchDeleteInboxDraftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchDeleteInboxDraftsMutation, { data, loading, error }] = useBatchDeleteInboxDraftsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchDeleteInboxDraftsMutation(baseOptions?: Apollo.MutationHookOptions<BatchDeleteInboxDraftsMutation, BatchDeleteInboxDraftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchDeleteInboxDraftsMutation, BatchDeleteInboxDraftsMutationVariables>(BatchDeleteInboxDraftsDocument, options);
      }
export type BatchDeleteInboxDraftsMutationHookResult = ReturnType<typeof useBatchDeleteInboxDraftsMutation>;
export type BatchDeleteInboxDraftsMutationResult = Apollo.MutationResult<BatchDeleteInboxDraftsMutation>;
export type BatchDeleteInboxDraftsMutationOptions = Apollo.BaseMutationOptions<BatchDeleteInboxDraftsMutation, BatchDeleteInboxDraftsMutationVariables>;
export const BatchRemoveLabelFromInboxConversationsDocument = gql`
    mutation BatchRemoveLabelFromInboxConversations($input: BatchRemoveLabelFromConversationsInput!) {
  batchRemoveLabelFromInboxConversations(input: $input) {
    ...InboxConversationsListConversation
  }
}
    ${InboxConversationsListConversationFragmentDoc}
${InboxConversationsConversationFragmentDoc}`;
export type BatchRemoveLabelFromInboxConversationsMutationFn = Apollo.MutationFunction<BatchRemoveLabelFromInboxConversationsMutation, BatchRemoveLabelFromInboxConversationsMutationVariables>;

/**
 * __useBatchRemoveLabelFromInboxConversationsMutation__
 *
 * To run a mutation, you first call `useBatchRemoveLabelFromInboxConversationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchRemoveLabelFromInboxConversationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchRemoveLabelFromInboxConversationsMutation, { data, loading, error }] = useBatchRemoveLabelFromInboxConversationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchRemoveLabelFromInboxConversationsMutation(baseOptions?: Apollo.MutationHookOptions<BatchRemoveLabelFromInboxConversationsMutation, BatchRemoveLabelFromInboxConversationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchRemoveLabelFromInboxConversationsMutation, BatchRemoveLabelFromInboxConversationsMutationVariables>(BatchRemoveLabelFromInboxConversationsDocument, options);
      }
export type BatchRemoveLabelFromInboxConversationsMutationHookResult = ReturnType<typeof useBatchRemoveLabelFromInboxConversationsMutation>;
export type BatchRemoveLabelFromInboxConversationsMutationResult = Apollo.MutationResult<BatchRemoveLabelFromInboxConversationsMutation>;
export type BatchRemoveLabelFromInboxConversationsMutationOptions = Apollo.BaseMutationOptions<BatchRemoveLabelFromInboxConversationsMutation, BatchRemoveLabelFromInboxConversationsMutationVariables>;
export const BindQuoteDocument = gql`
    mutation BindQuote($input: BindQuoteInput!) {
  bindQuote(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;
export type BindQuoteMutationFn = Apollo.MutationFunction<BindQuoteMutation, BindQuoteMutationVariables>;

/**
 * __useBindQuoteMutation__
 *
 * To run a mutation, you first call `useBindQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBindQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bindQuoteMutation, { data, loading, error }] = useBindQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBindQuoteMutation(baseOptions?: Apollo.MutationHookOptions<BindQuoteMutation, BindQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BindQuoteMutation, BindQuoteMutationVariables>(BindQuoteDocument, options);
      }
export type BindQuoteMutationHookResult = ReturnType<typeof useBindQuoteMutation>;
export type BindQuoteMutationResult = Apollo.MutationResult<BindQuoteMutation>;
export type BindQuoteMutationOptions = Apollo.BaseMutationOptions<BindQuoteMutation, BindQuoteMutationVariables>;
export const BrokerCreateAgentActionDocument = gql`
    mutation BrokerCreateAgentAction($input: BrokerCreateAgentAction!) {
  brokerCreateAgentAction(input: $input) {
    id
  }
}
    `;
export type BrokerCreateAgentActionMutationFn = Apollo.MutationFunction<BrokerCreateAgentActionMutation, BrokerCreateAgentActionMutationVariables>;

/**
 * __useBrokerCreateAgentActionMutation__
 *
 * To run a mutation, you first call `useBrokerCreateAgentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrokerCreateAgentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brokerCreateAgentActionMutation, { data, loading, error }] = useBrokerCreateAgentActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerCreateAgentActionMutation(baseOptions?: Apollo.MutationHookOptions<BrokerCreateAgentActionMutation, BrokerCreateAgentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrokerCreateAgentActionMutation, BrokerCreateAgentActionMutationVariables>(BrokerCreateAgentActionDocument, options);
      }
export type BrokerCreateAgentActionMutationHookResult = ReturnType<typeof useBrokerCreateAgentActionMutation>;
export type BrokerCreateAgentActionMutationResult = Apollo.MutationResult<BrokerCreateAgentActionMutation>;
export type BrokerCreateAgentActionMutationOptions = Apollo.BaseMutationOptions<BrokerCreateAgentActionMutation, BrokerCreateAgentActionMutationVariables>;
export const ClearInspectionOrderedElsewhereDocument = gql`
    mutation ClearInspectionOrderedElsewhere($inspectionOrderId: ID!) {
  clearInspectionOrderedElsewhere(inspectionOrderId: $inspectionOrderId) {
    ...InspectionOrder
  }
}
    ${InspectionOrderFragmentDoc}`;
export type ClearInspectionOrderedElsewhereMutationFn = Apollo.MutationFunction<ClearInspectionOrderedElsewhereMutation, ClearInspectionOrderedElsewhereMutationVariables>;

/**
 * __useClearInspectionOrderedElsewhereMutation__
 *
 * To run a mutation, you first call `useClearInspectionOrderedElsewhereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearInspectionOrderedElsewhereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearInspectionOrderedElsewhereMutation, { data, loading, error }] = useClearInspectionOrderedElsewhereMutation({
 *   variables: {
 *      inspectionOrderId: // value for 'inspectionOrderId'
 *   },
 * });
 */
export function useClearInspectionOrderedElsewhereMutation(baseOptions?: Apollo.MutationHookOptions<ClearInspectionOrderedElsewhereMutation, ClearInspectionOrderedElsewhereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearInspectionOrderedElsewhereMutation, ClearInspectionOrderedElsewhereMutationVariables>(ClearInspectionOrderedElsewhereDocument, options);
      }
export type ClearInspectionOrderedElsewhereMutationHookResult = ReturnType<typeof useClearInspectionOrderedElsewhereMutation>;
export type ClearInspectionOrderedElsewhereMutationResult = Apollo.MutationResult<ClearInspectionOrderedElsewhereMutation>;
export type ClearInspectionOrderedElsewhereMutationOptions = Apollo.BaseMutationOptions<ClearInspectionOrderedElsewhereMutation, ClearInspectionOrderedElsewhereMutationVariables>;
export const CompleteAgentActionDocument = gql`
    mutation CompleteAgentAction($input: CompleteAgentActionInput!) {
  completeAgentAction(input: $input) {
    id
  }
}
    `;
export type CompleteAgentActionMutationFn = Apollo.MutationFunction<CompleteAgentActionMutation, CompleteAgentActionMutationVariables>;

/**
 * __useCompleteAgentActionMutation__
 *
 * To run a mutation, you first call `useCompleteAgentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAgentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAgentActionMutation, { data, loading, error }] = useCompleteAgentActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteAgentActionMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAgentActionMutation, CompleteAgentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAgentActionMutation, CompleteAgentActionMutationVariables>(CompleteAgentActionDocument, options);
      }
export type CompleteAgentActionMutationHookResult = ReturnType<typeof useCompleteAgentActionMutation>;
export type CompleteAgentActionMutationResult = Apollo.MutationResult<CompleteAgentActionMutation>;
export type CompleteAgentActionMutationOptions = Apollo.BaseMutationOptions<CompleteAgentActionMutation, CompleteAgentActionMutationVariables>;
export const CreateBindHqMarketingCompanyDocument = gql`
    mutation CreateBindHqMarketingCompany($input: CreateMarketingCompanyInput!) {
  createBindHqMarketingCompany(input: $input) {
    id
    name
  }
}
    `;
export type CreateBindHqMarketingCompanyMutationFn = Apollo.MutationFunction<CreateBindHqMarketingCompanyMutation, CreateBindHqMarketingCompanyMutationVariables>;

/**
 * __useCreateBindHqMarketingCompanyMutation__
 *
 * To run a mutation, you first call `useCreateBindHqMarketingCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBindHqMarketingCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBindHqMarketingCompanyMutation, { data, loading, error }] = useCreateBindHqMarketingCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBindHqMarketingCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateBindHqMarketingCompanyMutation, CreateBindHqMarketingCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBindHqMarketingCompanyMutation, CreateBindHqMarketingCompanyMutationVariables>(CreateBindHqMarketingCompanyDocument, options);
      }
export type CreateBindHqMarketingCompanyMutationHookResult = ReturnType<typeof useCreateBindHqMarketingCompanyMutation>;
export type CreateBindHqMarketingCompanyMutationResult = Apollo.MutationResult<CreateBindHqMarketingCompanyMutation>;
export type CreateBindHqMarketingCompanyMutationOptions = Apollo.BaseMutationOptions<CreateBindHqMarketingCompanyMutation, CreateBindHqMarketingCompanyMutationVariables>;
export const CreateCarrierContactDocument = gql`
    mutation CreateCarrierContact($input: CreateCarrierContactInput!) {
  createCarrierContact(input: $input) {
    ...CarrierContact
  }
}
    ${CarrierContactFragmentDoc}`;
export type CreateCarrierContactMutationFn = Apollo.MutationFunction<CreateCarrierContactMutation, CreateCarrierContactMutationVariables>;

/**
 * __useCreateCarrierContactMutation__
 *
 * To run a mutation, you first call `useCreateCarrierContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCarrierContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCarrierContactMutation, { data, loading, error }] = useCreateCarrierContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCarrierContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCarrierContactMutation, CreateCarrierContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCarrierContactMutation, CreateCarrierContactMutationVariables>(CreateCarrierContactDocument, options);
      }
export type CreateCarrierContactMutationHookResult = ReturnType<typeof useCreateCarrierContactMutation>;
export type CreateCarrierContactMutationResult = Apollo.MutationResult<CreateCarrierContactMutation>;
export type CreateCarrierContactMutationOptions = Apollo.BaseMutationOptions<CreateCarrierContactMutation, CreateCarrierContactMutationVariables>;
export const CreateChatSessionDocument = gql`
    mutation CreateChatSession($input: CreateChatSessionInput) {
  createChatSession(input: $input) {
    ...ChatSession
  }
}
    ${ChatSessionFragmentDoc}
${ChatMessageFragmentDoc}`;
export type CreateChatSessionMutationFn = Apollo.MutationFunction<CreateChatSessionMutation, CreateChatSessionMutationVariables>;

/**
 * __useCreateChatSessionMutation__
 *
 * To run a mutation, you first call `useCreateChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatSessionMutation, { data, loading, error }] = useCreateChatSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatSessionMutation, CreateChatSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatSessionMutation, CreateChatSessionMutationVariables>(CreateChatSessionDocument, options);
      }
export type CreateChatSessionMutationHookResult = ReturnType<typeof useCreateChatSessionMutation>;
export type CreateChatSessionMutationResult = Apollo.MutationResult<CreateChatSessionMutation>;
export type CreateChatSessionMutationOptions = Apollo.BaseMutationOptions<CreateChatSessionMutation, CreateChatSessionMutationVariables>;
export const CreateClientDataDocument = gql`
    mutation CreateClientData($input: CreateClientDataInput!) {
  createClientData(input: $input) {
    ...ClientData
  }
}
    ${ClientDataFragmentDoc}`;
export type CreateClientDataMutationFn = Apollo.MutationFunction<CreateClientDataMutation, CreateClientDataMutationVariables>;

/**
 * __useCreateClientDataMutation__
 *
 * To run a mutation, you first call `useCreateClientDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientDataMutation, { data, loading, error }] = useCreateClientDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientDataMutation, CreateClientDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientDataMutation, CreateClientDataMutationVariables>(CreateClientDataDocument, options);
      }
export type CreateClientDataMutationHookResult = ReturnType<typeof useCreateClientDataMutation>;
export type CreateClientDataMutationResult = Apollo.MutationResult<CreateClientDataMutation>;
export type CreateClientDataMutationOptions = Apollo.BaseMutationOptions<CreateClientDataMutation, CreateClientDataMutationVariables>;
export const CreateClientDataPdfDocument = gql`
    mutation CreateClientDataPDF($input: CreateClientDataPDFInput!) {
  createClientDataPDF(input: $input) {
    ...FileUpload
  }
}
    ${FileUploadFragmentDoc}`;
export type CreateClientDataPdfMutationFn = Apollo.MutationFunction<CreateClientDataPdfMutation, CreateClientDataPdfMutationVariables>;

/**
 * __useCreateClientDataPdfMutation__
 *
 * To run a mutation, you first call `useCreateClientDataPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientDataPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientDataPdfMutation, { data, loading, error }] = useCreateClientDataPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientDataPdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientDataPdfMutation, CreateClientDataPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientDataPdfMutation, CreateClientDataPdfMutationVariables>(CreateClientDataPdfDocument, options);
      }
export type CreateClientDataPdfMutationHookResult = ReturnType<typeof useCreateClientDataPdfMutation>;
export type CreateClientDataPdfMutationResult = Apollo.MutationResult<CreateClientDataPdfMutation>;
export type CreateClientDataPdfMutationOptions = Apollo.BaseMutationOptions<CreateClientDataPdfMutation, CreateClientDataPdfMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    ...OpportunityEvent
  }
}
    ${OpportunityEventFragmentDoc}
${UserCommentFragmentDoc}
${UserAccountFragmentDoc}
${AssignmentChangeEventFragmentDoc}
${CollaboratorsChangedEventFragmentDoc}
${TriageAssignmentEventFragmentDoc}
${EmailEventFragmentDoc}
${GmailMessageEventFragmentDoc}
${GmailMessageFragmentDoc}
${FileUploadFragmentDoc}
${GmailRelayEventFragmentDoc}
${FileUploadEventFragmentDoc}
${StatusChangeEventFragmentDoc}
${SubmissionStatusChangeEventFragmentDoc}
${CreatedEventFragmentDoc}
${OutcomeChangeEventFragmentDoc}
${DesiredEffectiveDateChangeEventFragmentDoc}
${ApplicationSubmittedEventFragmentDoc}
${ProductsAddedEventFragmentDoc}
${ProductsRemovedEventFragmentDoc}
${BotCommentEventFragmentDoc}
${AlbyUpdateEventFragmentDoc}
${AutomatedFollowUpEventFragmentDoc}
${ActionRequestedEventFragmentDoc}
${ActionApprovedEventFragmentDoc}
${ActionRejectedEventFragmentDoc}
${ActionDismissedEventFragmentDoc}
${CoveragesChangedEventFragmentDoc}
${BusinessClassCodesChangedEventFragmentDoc}
${RequirementAddedEventFragmentDoc}
${PolicyRenewabilityChangedEventFragmentDoc}
${AgencyTransferEventFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateEmailDraftDocument = gql`
    mutation CreateEmailDraft($input: CreateEmailDraftInput!) {
  createEmailDraft(input: $input)
}
    `;
export type CreateEmailDraftMutationFn = Apollo.MutationFunction<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>;

/**
 * __useCreateEmailDraftMutation__
 *
 * To run a mutation, you first call `useCreateEmailDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailDraftMutation, { data, loading, error }] = useCreateEmailDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>(CreateEmailDraftDocument, options);
      }
export type CreateEmailDraftMutationHookResult = ReturnType<typeof useCreateEmailDraftMutation>;
export type CreateEmailDraftMutationResult = Apollo.MutationResult<CreateEmailDraftMutation>;
export type CreateEmailDraftMutationOptions = Apollo.BaseMutationOptions<CreateEmailDraftMutation, CreateEmailDraftMutationVariables>;
export const CreateEmailTemplateDraftDocument = gql`
    mutation CreateEmailTemplateDraft($input: CreateEmailTemplateDraftInput!) {
  createEmailTemplateDraft(input: $input)
}
    `;
export type CreateEmailTemplateDraftMutationFn = Apollo.MutationFunction<CreateEmailTemplateDraftMutation, CreateEmailTemplateDraftMutationVariables>;

/**
 * __useCreateEmailTemplateDraftMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateDraftMutation, { data, loading, error }] = useCreateEmailTemplateDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailTemplateDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTemplateDraftMutation, CreateEmailTemplateDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTemplateDraftMutation, CreateEmailTemplateDraftMutationVariables>(CreateEmailTemplateDraftDocument, options);
      }
export type CreateEmailTemplateDraftMutationHookResult = ReturnType<typeof useCreateEmailTemplateDraftMutation>;
export type CreateEmailTemplateDraftMutationResult = Apollo.MutationResult<CreateEmailTemplateDraftMutation>;
export type CreateEmailTemplateDraftMutationOptions = Apollo.BaseMutationOptions<CreateEmailTemplateDraftMutation, CreateEmailTemplateDraftMutationVariables>;
export const CreateInboxDraftDocument = gql`
    mutation CreateInboxDraft($input: CreateDraftMessageInputDto!) {
  createInboxDraft(input: $input) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type CreateInboxDraftMutationFn = Apollo.MutationFunction<CreateInboxDraftMutation, CreateInboxDraftMutationVariables>;

/**
 * __useCreateInboxDraftMutation__
 *
 * To run a mutation, you first call `useCreateInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboxDraftMutation, { data, loading, error }] = useCreateInboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateInboxDraftMutation, CreateInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInboxDraftMutation, CreateInboxDraftMutationVariables>(CreateInboxDraftDocument, options);
      }
export type CreateInboxDraftMutationHookResult = ReturnType<typeof useCreateInboxDraftMutation>;
export type CreateInboxDraftMutationResult = Apollo.MutationResult<CreateInboxDraftMutation>;
export type CreateInboxDraftMutationOptions = Apollo.BaseMutationOptions<CreateInboxDraftMutation, CreateInboxDraftMutationVariables>;
export const CreateInboxForwardDraftDocument = gql`
    mutation CreateInboxForwardDraft($input: CreateForwardDraftInputDto!) {
  createInboxForwardDraft(input: $input) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type CreateInboxForwardDraftMutationFn = Apollo.MutationFunction<CreateInboxForwardDraftMutation, CreateInboxForwardDraftMutationVariables>;

/**
 * __useCreateInboxForwardDraftMutation__
 *
 * To run a mutation, you first call `useCreateInboxForwardDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboxForwardDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboxForwardDraftMutation, { data, loading, error }] = useCreateInboxForwardDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboxForwardDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateInboxForwardDraftMutation, CreateInboxForwardDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInboxForwardDraftMutation, CreateInboxForwardDraftMutationVariables>(CreateInboxForwardDraftDocument, options);
      }
export type CreateInboxForwardDraftMutationHookResult = ReturnType<typeof useCreateInboxForwardDraftMutation>;
export type CreateInboxForwardDraftMutationResult = Apollo.MutationResult<CreateInboxForwardDraftMutation>;
export type CreateInboxForwardDraftMutationOptions = Apollo.BaseMutationOptions<CreateInboxForwardDraftMutation, CreateInboxForwardDraftMutationVariables>;
export const CreateInboxLabelDocument = gql`
    mutation CreateInboxLabel($input: CreateEmailLabelInput!) {
  createInboxLabel(input: $input) {
    ...InboxLabel
  }
}
    ${InboxLabelFragmentDoc}`;
export type CreateInboxLabelMutationFn = Apollo.MutationFunction<CreateInboxLabelMutation, CreateInboxLabelMutationVariables>;

/**
 * __useCreateInboxLabelMutation__
 *
 * To run a mutation, you first call `useCreateInboxLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboxLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboxLabelMutation, { data, loading, error }] = useCreateInboxLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboxLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateInboxLabelMutation, CreateInboxLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInboxLabelMutation, CreateInboxLabelMutationVariables>(CreateInboxLabelDocument, options);
      }
export type CreateInboxLabelMutationHookResult = ReturnType<typeof useCreateInboxLabelMutation>;
export type CreateInboxLabelMutationResult = Apollo.MutationResult<CreateInboxLabelMutation>;
export type CreateInboxLabelMutationOptions = Apollo.BaseMutationOptions<CreateInboxLabelMutation, CreateInboxLabelMutationVariables>;
export const CreateInboxMessageClassificationDocument = gql`
    mutation CreateInboxMessageClassification($input: CreateMessageClassificationInput!) {
  createInboxMessageClassification(input: $input) {
    id
    label
    description
    autoRunPlaybook
    source
  }
}
    `;
export type CreateInboxMessageClassificationMutationFn = Apollo.MutationFunction<CreateInboxMessageClassificationMutation, CreateInboxMessageClassificationMutationVariables>;

/**
 * __useCreateInboxMessageClassificationMutation__
 *
 * To run a mutation, you first call `useCreateInboxMessageClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboxMessageClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboxMessageClassificationMutation, { data, loading, error }] = useCreateInboxMessageClassificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboxMessageClassificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInboxMessageClassificationMutation, CreateInboxMessageClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInboxMessageClassificationMutation, CreateInboxMessageClassificationMutationVariables>(CreateInboxMessageClassificationDocument, options);
      }
export type CreateInboxMessageClassificationMutationHookResult = ReturnType<typeof useCreateInboxMessageClassificationMutation>;
export type CreateInboxMessageClassificationMutationResult = Apollo.MutationResult<CreateInboxMessageClassificationMutation>;
export type CreateInboxMessageClassificationMutationOptions = Apollo.BaseMutationOptions<CreateInboxMessageClassificationMutation, CreateInboxMessageClassificationMutationVariables>;
export const CreateInboxReplyDraftDocument = gql`
    mutation CreateInboxReplyDraft($input: CreateReplyDraftInputDto!) {
  createInboxReplyDraft(input: $input) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type CreateInboxReplyDraftMutationFn = Apollo.MutationFunction<CreateInboxReplyDraftMutation, CreateInboxReplyDraftMutationVariables>;

/**
 * __useCreateInboxReplyDraftMutation__
 *
 * To run a mutation, you first call `useCreateInboxReplyDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInboxReplyDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInboxReplyDraftMutation, { data, loading, error }] = useCreateInboxReplyDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInboxReplyDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateInboxReplyDraftMutation, CreateInboxReplyDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInboxReplyDraftMutation, CreateInboxReplyDraftMutationVariables>(CreateInboxReplyDraftDocument, options);
      }
export type CreateInboxReplyDraftMutationHookResult = ReturnType<typeof useCreateInboxReplyDraftMutation>;
export type CreateInboxReplyDraftMutationResult = Apollo.MutationResult<CreateInboxReplyDraftMutation>;
export type CreateInboxReplyDraftMutationOptions = Apollo.BaseMutationOptions<CreateInboxReplyDraftMutation, CreateInboxReplyDraftMutationVariables>;
export const CreateInsuredDocument = gql`
    mutation CreateInsured($input: CreateInsuredInput!) {
  createInsured(input: $input) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;
export type CreateInsuredMutationFn = Apollo.MutationFunction<CreateInsuredMutation, CreateInsuredMutationVariables>;

/**
 * __useCreateInsuredMutation__
 *
 * To run a mutation, you first call `useCreateInsuredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuredMutation, { data, loading, error }] = useCreateInsuredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsuredMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuredMutation, CreateInsuredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuredMutation, CreateInsuredMutationVariables>(CreateInsuredDocument, options);
      }
export type CreateInsuredMutationHookResult = ReturnType<typeof useCreateInsuredMutation>;
export type CreateInsuredMutationResult = Apollo.MutationResult<CreateInsuredMutation>;
export type CreateInsuredMutationOptions = Apollo.BaseMutationOptions<CreateInsuredMutation, CreateInsuredMutationVariables>;
export const CreateInsuredAndAgentDocument = gql`
    mutation CreateInsuredAndAgent($input: CreateInsuredAndAgentInput!) {
  createInsuredAndAgent(input: $input) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;
export type CreateInsuredAndAgentMutationFn = Apollo.MutationFunction<CreateInsuredAndAgentMutation, CreateInsuredAndAgentMutationVariables>;

/**
 * __useCreateInsuredAndAgentMutation__
 *
 * To run a mutation, you first call `useCreateInsuredAndAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsuredAndAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsuredAndAgentMutation, { data, loading, error }] = useCreateInsuredAndAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInsuredAndAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsuredAndAgentMutation, CreateInsuredAndAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsuredAndAgentMutation, CreateInsuredAndAgentMutationVariables>(CreateInsuredAndAgentDocument, options);
      }
export type CreateInsuredAndAgentMutationHookResult = ReturnType<typeof useCreateInsuredAndAgentMutation>;
export type CreateInsuredAndAgentMutationResult = Apollo.MutationResult<CreateInsuredAndAgentMutation>;
export type CreateInsuredAndAgentMutationOptions = Apollo.BaseMutationOptions<CreateInsuredAndAgentMutation, CreateInsuredAndAgentMutationVariables>;
export const CreateOpportunityDocument = gql`
    mutation CreateOpportunity($input: CreateOpportunityInput!) {
  createOpportunity(input: $input) {
    id
  }
}
    `;
export type CreateOpportunityMutationFn = Apollo.MutationFunction<CreateOpportunityMutation, CreateOpportunityMutationVariables>;

/**
 * __useCreateOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityMutation, { data, loading, error }] = useCreateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityMutation, CreateOpportunityMutationVariables>(CreateOpportunityDocument, options);
      }
export type CreateOpportunityMutationHookResult = ReturnType<typeof useCreateOpportunityMutation>;
export type CreateOpportunityMutationResult = Apollo.MutationResult<CreateOpportunityMutation>;
export type CreateOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>;
export const CreateOpportunityNoteDocument = gql`
    mutation CreateOpportunityNote($input: CreateOpportunityNoteInput!) {
  createNote(input: $input) {
    id
  }
}
    `;
export type CreateOpportunityNoteMutationFn = Apollo.MutationFunction<CreateOpportunityNoteMutation, CreateOpportunityNoteMutationVariables>;

/**
 * __useCreateOpportunityNoteMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityNoteMutation, { data, loading, error }] = useCreateOpportunityNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpportunityNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityNoteMutation, CreateOpportunityNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityNoteMutation, CreateOpportunityNoteMutationVariables>(CreateOpportunityNoteDocument, options);
      }
export type CreateOpportunityNoteMutationHookResult = ReturnType<typeof useCreateOpportunityNoteMutation>;
export type CreateOpportunityNoteMutationResult = Apollo.MutationResult<CreateOpportunityNoteMutation>;
export type CreateOpportunityNoteMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityNoteMutation, CreateOpportunityNoteMutationVariables>;
export const CreatePlaybookDocument = gql`
    mutation CreatePlaybook($input: CreatePlaybookInput!) {
  createPlaybook(input: $input) {
    id
    name
    description
    workflow
    type
    parametersDescription
    templateParamSchema
    modelTier
    updatedAt
  }
}
    `;
export type CreatePlaybookMutationFn = Apollo.MutationFunction<CreatePlaybookMutation, CreatePlaybookMutationVariables>;

/**
 * __useCreatePlaybookMutation__
 *
 * To run a mutation, you first call `useCreatePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaybookMutation, { data, loading, error }] = useCreatePlaybookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaybookMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaybookMutation, CreatePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaybookMutation, CreatePlaybookMutationVariables>(CreatePlaybookDocument, options);
      }
export type CreatePlaybookMutationHookResult = ReturnType<typeof useCreatePlaybookMutation>;
export type CreatePlaybookMutationResult = Apollo.MutationResult<CreatePlaybookMutation>;
export type CreatePlaybookMutationOptions = Apollo.BaseMutationOptions<CreatePlaybookMutation, CreatePlaybookMutationVariables>;
export const CreatePlaybookSetDocument = gql`
    mutation CreatePlaybookSet($input: CreatePlaybookSetInput!) {
  createPlaybookSet(input: $input) {
    ...PlaybookSet
  }
}
    ${PlaybookSetFragmentDoc}`;
export type CreatePlaybookSetMutationFn = Apollo.MutationFunction<CreatePlaybookSetMutation, CreatePlaybookSetMutationVariables>;

/**
 * __useCreatePlaybookSetMutation__
 *
 * To run a mutation, you first call `useCreatePlaybookSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlaybookSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlaybookSetMutation, { data, loading, error }] = useCreatePlaybookSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlaybookSetMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlaybookSetMutation, CreatePlaybookSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlaybookSetMutation, CreatePlaybookSetMutationVariables>(CreatePlaybookSetDocument, options);
      }
export type CreatePlaybookSetMutationHookResult = ReturnType<typeof useCreatePlaybookSetMutation>;
export type CreatePlaybookSetMutationResult = Apollo.MutationResult<CreatePlaybookSetMutation>;
export type CreatePlaybookSetMutationOptions = Apollo.BaseMutationOptions<CreatePlaybookSetMutation, CreatePlaybookSetMutationVariables>;
export const CreateProcessedBinderDocument = gql`
    mutation CreateProcessedBinder($input: CreateProcessedBinderInput!) {
  createProcessedBinder(input: $input) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type CreateProcessedBinderMutationFn = Apollo.MutationFunction<CreateProcessedBinderMutation, CreateProcessedBinderMutationVariables>;

/**
 * __useCreateProcessedBinderMutation__
 *
 * To run a mutation, you first call `useCreateProcessedBinderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessedBinderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessedBinderMutation, { data, loading, error }] = useCreateProcessedBinderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessedBinderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessedBinderMutation, CreateProcessedBinderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessedBinderMutation, CreateProcessedBinderMutationVariables>(CreateProcessedBinderDocument, options);
      }
export type CreateProcessedBinderMutationHookResult = ReturnType<typeof useCreateProcessedBinderMutation>;
export type CreateProcessedBinderMutationResult = Apollo.MutationResult<CreateProcessedBinderMutation>;
export type CreateProcessedBinderMutationOptions = Apollo.BaseMutationOptions<CreateProcessedBinderMutation, CreateProcessedBinderMutationVariables>;
export const CreateProcessedQuotePdfDocument = gql`
    mutation CreateProcessedQuotePDF($input: CreateProcessedQuoteInput!) {
  createProcessedQuotePDF(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;
export type CreateProcessedQuotePdfMutationFn = Apollo.MutationFunction<CreateProcessedQuotePdfMutation, CreateProcessedQuotePdfMutationVariables>;

/**
 * __useCreateProcessedQuotePdfMutation__
 *
 * To run a mutation, you first call `useCreateProcessedQuotePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessedQuotePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessedQuotePdfMutation, { data, loading, error }] = useCreateProcessedQuotePdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessedQuotePdfMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessedQuotePdfMutation, CreateProcessedQuotePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessedQuotePdfMutation, CreateProcessedQuotePdfMutationVariables>(CreateProcessedQuotePdfDocument, options);
      }
export type CreateProcessedQuotePdfMutationHookResult = ReturnType<typeof useCreateProcessedQuotePdfMutation>;
export type CreateProcessedQuotePdfMutationResult = Apollo.MutationResult<CreateProcessedQuotePdfMutation>;
export type CreateProcessedQuotePdfMutationOptions = Apollo.BaseMutationOptions<CreateProcessedQuotePdfMutation, CreateProcessedQuotePdfMutationVariables>;
export const CreateProductDocument = gql`
    mutation CreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    name
    workflow
    updatedAt
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateRenewalDocument = gql`
    mutation CreateRenewal($input: CreateRenewalInput!) {
  createRenewal(input: $input) {
    id
  }
}
    `;
export type CreateRenewalMutationFn = Apollo.MutationFunction<CreateRenewalMutation, CreateRenewalMutationVariables>;

/**
 * __useCreateRenewalMutation__
 *
 * To run a mutation, you first call `useCreateRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRenewalMutation, { data, loading, error }] = useCreateRenewalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRenewalMutation(baseOptions?: Apollo.MutationHookOptions<CreateRenewalMutation, CreateRenewalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRenewalMutation, CreateRenewalMutationVariables>(CreateRenewalDocument, options);
      }
export type CreateRenewalMutationHookResult = ReturnType<typeof useCreateRenewalMutation>;
export type CreateRenewalMutationResult = Apollo.MutationResult<CreateRenewalMutation>;
export type CreateRenewalMutationOptions = Apollo.BaseMutationOptions<CreateRenewalMutation, CreateRenewalMutationVariables>;
export const CreateStampedPolicyDocument = gql`
    mutation CreateStampedPolicy($input: CreateStampedPolicyInput!) {
  createStampedPolicy(input: $input) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type CreateStampedPolicyMutationFn = Apollo.MutationFunction<CreateStampedPolicyMutation, CreateStampedPolicyMutationVariables>;

/**
 * __useCreateStampedPolicyMutation__
 *
 * To run a mutation, you first call `useCreateStampedPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStampedPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStampedPolicyMutation, { data, loading, error }] = useCreateStampedPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStampedPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CreateStampedPolicyMutation, CreateStampedPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStampedPolicyMutation, CreateStampedPolicyMutationVariables>(CreateStampedPolicyDocument, options);
      }
export type CreateStampedPolicyMutationHookResult = ReturnType<typeof useCreateStampedPolicyMutation>;
export type CreateStampedPolicyMutationResult = Apollo.MutationResult<CreateStampedPolicyMutation>;
export type CreateStampedPolicyMutationOptions = Apollo.BaseMutationOptions<CreateStampedPolicyMutation, CreateStampedPolicyMutationVariables>;
export const CreateSubmissionMarketSummaryNoteDocument = gql`
    mutation CreateSubmissionMarketSummaryNote($input: CreateSubmissionMarketSummaryNoteInput!) {
  createSubmissionMarketSummaryNote(input: $input) {
    id
  }
}
    `;
export type CreateSubmissionMarketSummaryNoteMutationFn = Apollo.MutationFunction<CreateSubmissionMarketSummaryNoteMutation, CreateSubmissionMarketSummaryNoteMutationVariables>;

/**
 * __useCreateSubmissionMarketSummaryNoteMutation__
 *
 * To run a mutation, you first call `useCreateSubmissionMarketSummaryNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubmissionMarketSummaryNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubmissionMarketSummaryNoteMutation, { data, loading, error }] = useCreateSubmissionMarketSummaryNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubmissionMarketSummaryNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubmissionMarketSummaryNoteMutation, CreateSubmissionMarketSummaryNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubmissionMarketSummaryNoteMutation, CreateSubmissionMarketSummaryNoteMutationVariables>(CreateSubmissionMarketSummaryNoteDocument, options);
      }
export type CreateSubmissionMarketSummaryNoteMutationHookResult = ReturnType<typeof useCreateSubmissionMarketSummaryNoteMutation>;
export type CreateSubmissionMarketSummaryNoteMutationResult = Apollo.MutationResult<CreateSubmissionMarketSummaryNoteMutation>;
export type CreateSubmissionMarketSummaryNoteMutationOptions = Apollo.BaseMutationOptions<CreateSubmissionMarketSummaryNoteMutation, CreateSubmissionMarketSummaryNoteMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($input: CreateTagInput!) {
  createFileTag(input: $input) {
    label
    parentTags {
      label
    }
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const DeactivateAgentDocument = gql`
    mutation DeactivateAgent($input: DeactivateAgentInput!) {
  deactivateAgent(input: $input)
}
    `;
export type DeactivateAgentMutationFn = Apollo.MutationFunction<DeactivateAgentMutation, DeactivateAgentMutationVariables>;

/**
 * __useDeactivateAgentMutation__
 *
 * To run a mutation, you first call `useDeactivateAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateAgentMutation, { data, loading, error }] = useDeactivateAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateAgentMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateAgentMutation, DeactivateAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateAgentMutation, DeactivateAgentMutationVariables>(DeactivateAgentDocument, options);
      }
export type DeactivateAgentMutationHookResult = ReturnType<typeof useDeactivateAgentMutation>;
export type DeactivateAgentMutationResult = Apollo.MutationResult<DeactivateAgentMutation>;
export type DeactivateAgentMutationOptions = Apollo.BaseMutationOptions<DeactivateAgentMutation, DeactivateAgentMutationVariables>;
export const DeactivateUserAccountDocument = gql`
    mutation DeactivateUserAccount($id: ID!) {
  deactivateUser(id: $id) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;
export type DeactivateUserAccountMutationFn = Apollo.MutationFunction<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>;

/**
 * __useDeactivateUserAccountMutation__
 *
 * To run a mutation, you first call `useDeactivateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateUserAccountMutation, { data, loading, error }] = useDeactivateUserAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>(DeactivateUserAccountDocument, options);
      }
export type DeactivateUserAccountMutationHookResult = ReturnType<typeof useDeactivateUserAccountMutation>;
export type DeactivateUserAccountMutationResult = Apollo.MutationResult<DeactivateUserAccountMutation>;
export type DeactivateUserAccountMutationOptions = Apollo.BaseMutationOptions<DeactivateUserAccountMutation, DeactivateUserAccountMutationVariables>;
export const DeleteAgentActionDocument = gql`
    mutation DeleteAgentAction($id: ID!) {
  deleteAgentAction(id: $id) {
    id
  }
}
    `;
export type DeleteAgentActionMutationFn = Apollo.MutationFunction<DeleteAgentActionMutation, DeleteAgentActionMutationVariables>;

/**
 * __useDeleteAgentActionMutation__
 *
 * To run a mutation, you first call `useDeleteAgentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAgentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAgentActionMutation, { data, loading, error }] = useDeleteAgentActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAgentActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAgentActionMutation, DeleteAgentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAgentActionMutation, DeleteAgentActionMutationVariables>(DeleteAgentActionDocument, options);
      }
export type DeleteAgentActionMutationHookResult = ReturnType<typeof useDeleteAgentActionMutation>;
export type DeleteAgentActionMutationResult = Apollo.MutationResult<DeleteAgentActionMutation>;
export type DeleteAgentActionMutationOptions = Apollo.BaseMutationOptions<DeleteAgentActionMutation, DeleteAgentActionMutationVariables>;
export const DeleteCarrierContractDocument = gql`
    mutation DeleteCarrierContract($contractId: ID!) {
  deleteCarrierContract(contractId: $contractId)
}
    `;
export type DeleteCarrierContractMutationFn = Apollo.MutationFunction<DeleteCarrierContractMutation, DeleteCarrierContractMutationVariables>;

/**
 * __useDeleteCarrierContractMutation__
 *
 * To run a mutation, you first call `useDeleteCarrierContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCarrierContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCarrierContractMutation, { data, loading, error }] = useDeleteCarrierContractMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useDeleteCarrierContractMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCarrierContractMutation, DeleteCarrierContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCarrierContractMutation, DeleteCarrierContractMutationVariables>(DeleteCarrierContractDocument, options);
      }
export type DeleteCarrierContractMutationHookResult = ReturnType<typeof useDeleteCarrierContractMutation>;
export type DeleteCarrierContractMutationResult = Apollo.MutationResult<DeleteCarrierContractMutation>;
export type DeleteCarrierContractMutationOptions = Apollo.BaseMutationOptions<DeleteCarrierContractMutation, DeleteCarrierContractMutationVariables>;
export const DeleteClientDataRowDocument = gql`
    mutation DeleteClientDataRow($input: DeleteClientDataInput!) {
  deleteClientDataRow(input: $input) {
    ...ClientData
  }
}
    ${ClientDataFragmentDoc}`;
export type DeleteClientDataRowMutationFn = Apollo.MutationFunction<DeleteClientDataRowMutation, DeleteClientDataRowMutationVariables>;

/**
 * __useDeleteClientDataRowMutation__
 *
 * To run a mutation, you first call `useDeleteClientDataRowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientDataRowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientDataRowMutation, { data, loading, error }] = useDeleteClientDataRowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientDataRowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientDataRowMutation, DeleteClientDataRowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientDataRowMutation, DeleteClientDataRowMutationVariables>(DeleteClientDataRowDocument, options);
      }
export type DeleteClientDataRowMutationHookResult = ReturnType<typeof useDeleteClientDataRowMutation>;
export type DeleteClientDataRowMutationResult = Apollo.MutationResult<DeleteClientDataRowMutation>;
export type DeleteClientDataRowMutationOptions = Apollo.BaseMutationOptions<DeleteClientDataRowMutation, DeleteClientDataRowMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: ID!) {
  deleteComment(id: $id) {
    ...OpportunityEvent
  }
}
    ${OpportunityEventFragmentDoc}
${UserCommentFragmentDoc}
${UserAccountFragmentDoc}
${AssignmentChangeEventFragmentDoc}
${CollaboratorsChangedEventFragmentDoc}
${TriageAssignmentEventFragmentDoc}
${EmailEventFragmentDoc}
${GmailMessageEventFragmentDoc}
${GmailMessageFragmentDoc}
${FileUploadFragmentDoc}
${GmailRelayEventFragmentDoc}
${FileUploadEventFragmentDoc}
${StatusChangeEventFragmentDoc}
${SubmissionStatusChangeEventFragmentDoc}
${CreatedEventFragmentDoc}
${OutcomeChangeEventFragmentDoc}
${DesiredEffectiveDateChangeEventFragmentDoc}
${ApplicationSubmittedEventFragmentDoc}
${ProductsAddedEventFragmentDoc}
${ProductsRemovedEventFragmentDoc}
${BotCommentEventFragmentDoc}
${AlbyUpdateEventFragmentDoc}
${AutomatedFollowUpEventFragmentDoc}
${ActionRequestedEventFragmentDoc}
${ActionApprovedEventFragmentDoc}
${ActionRejectedEventFragmentDoc}
${ActionDismissedEventFragmentDoc}
${CoveragesChangedEventFragmentDoc}
${BusinessClassCodesChangedEventFragmentDoc}
${RequirementAddedEventFragmentDoc}
${PolicyRenewabilityChangedEventFragmentDoc}
${AgencyTransferEventFragmentDoc}`;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteInboxConversationDocument = gql`
    mutation DeleteInboxConversation($id: ID!) {
  deleteInboxConversation(id: $id) {
    id
  }
}
    `;
export type DeleteInboxConversationMutationFn = Apollo.MutationFunction<DeleteInboxConversationMutation, DeleteInboxConversationMutationVariables>;

/**
 * __useDeleteInboxConversationMutation__
 *
 * To run a mutation, you first call `useDeleteInboxConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInboxConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInboxConversationMutation, { data, loading, error }] = useDeleteInboxConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInboxConversationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInboxConversationMutation, DeleteInboxConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInboxConversationMutation, DeleteInboxConversationMutationVariables>(DeleteInboxConversationDocument, options);
      }
export type DeleteInboxConversationMutationHookResult = ReturnType<typeof useDeleteInboxConversationMutation>;
export type DeleteInboxConversationMutationResult = Apollo.MutationResult<DeleteInboxConversationMutation>;
export type DeleteInboxConversationMutationOptions = Apollo.BaseMutationOptions<DeleteInboxConversationMutation, DeleteInboxConversationMutationVariables>;
export const DeleteInboxDraftDocument = gql`
    mutation DeleteInboxDraft($id: ID!) {
  deleteInboxDraft(id: $id) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type DeleteInboxDraftMutationFn = Apollo.MutationFunction<DeleteInboxDraftMutation, DeleteInboxDraftMutationVariables>;

/**
 * __useDeleteInboxDraftMutation__
 *
 * To run a mutation, you first call `useDeleteInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInboxDraftMutation, { data, loading, error }] = useDeleteInboxDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInboxDraftMutation, DeleteInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInboxDraftMutation, DeleteInboxDraftMutationVariables>(DeleteInboxDraftDocument, options);
      }
export type DeleteInboxDraftMutationHookResult = ReturnType<typeof useDeleteInboxDraftMutation>;
export type DeleteInboxDraftMutationResult = Apollo.MutationResult<DeleteInboxDraftMutation>;
export type DeleteInboxDraftMutationOptions = Apollo.BaseMutationOptions<DeleteInboxDraftMutation, DeleteInboxDraftMutationVariables>;
export const DeleteInboxMessageClassificationDocument = gql`
    mutation DeleteInboxMessageClassification($id: String!) {
  deleteInboxMessageClassification(id: $id)
}
    `;
export type DeleteInboxMessageClassificationMutationFn = Apollo.MutationFunction<DeleteInboxMessageClassificationMutation, DeleteInboxMessageClassificationMutationVariables>;

/**
 * __useDeleteInboxMessageClassificationMutation__
 *
 * To run a mutation, you first call `useDeleteInboxMessageClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInboxMessageClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInboxMessageClassificationMutation, { data, loading, error }] = useDeleteInboxMessageClassificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInboxMessageClassificationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInboxMessageClassificationMutation, DeleteInboxMessageClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInboxMessageClassificationMutation, DeleteInboxMessageClassificationMutationVariables>(DeleteInboxMessageClassificationDocument, options);
      }
export type DeleteInboxMessageClassificationMutationHookResult = ReturnType<typeof useDeleteInboxMessageClassificationMutation>;
export type DeleteInboxMessageClassificationMutationResult = Apollo.MutationResult<DeleteInboxMessageClassificationMutation>;
export type DeleteInboxMessageClassificationMutationOptions = Apollo.BaseMutationOptions<DeleteInboxMessageClassificationMutation, DeleteInboxMessageClassificationMutationVariables>;
export const DeleteInsuredDocument = gql`
    mutation DeleteInsured($id: ID!) {
  deleteInsured(id: $id) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;
export type DeleteInsuredMutationFn = Apollo.MutationFunction<DeleteInsuredMutation, DeleteInsuredMutationVariables>;

/**
 * __useDeleteInsuredMutation__
 *
 * To run a mutation, you first call `useDeleteInsuredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsuredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsuredMutation, { data, loading, error }] = useDeleteInsuredMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsuredMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsuredMutation, DeleteInsuredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInsuredMutation, DeleteInsuredMutationVariables>(DeleteInsuredDocument, options);
      }
export type DeleteInsuredMutationHookResult = ReturnType<typeof useDeleteInsuredMutation>;
export type DeleteInsuredMutationResult = Apollo.MutationResult<DeleteInsuredMutation>;
export type DeleteInsuredMutationOptions = Apollo.BaseMutationOptions<DeleteInsuredMutation, DeleteInsuredMutationVariables>;
export const DeleteOpportunityDocument = gql`
    mutation DeleteOpportunity($id: ID!) {
  deleteOpportunity(id: $id) {
    id
  }
}
    `;
export type DeleteOpportunityMutationFn = Apollo.MutationFunction<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;

/**
 * __useDeleteOpportunityMutation__
 *
 * To run a mutation, you first call `useDeleteOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpportunityMutation, { data, loading, error }] = useDeleteOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>(DeleteOpportunityDocument, options);
      }
export type DeleteOpportunityMutationHookResult = ReturnType<typeof useDeleteOpportunityMutation>;
export type DeleteOpportunityMutationResult = Apollo.MutationResult<DeleteOpportunityMutation>;
export type DeleteOpportunityMutationOptions = Apollo.BaseMutationOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;
export const DeletePlaybookDocument = gql`
    mutation DeletePlaybook($id: String!) {
  deletePlaybook(id: $id)
}
    `;
export type DeletePlaybookMutationFn = Apollo.MutationFunction<DeletePlaybookMutation, DeletePlaybookMutationVariables>;

/**
 * __useDeletePlaybookMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookMutation, { data, loading, error }] = useDeletePlaybookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlaybookMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaybookMutation, DeletePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaybookMutation, DeletePlaybookMutationVariables>(DeletePlaybookDocument, options);
      }
export type DeletePlaybookMutationHookResult = ReturnType<typeof useDeletePlaybookMutation>;
export type DeletePlaybookMutationResult = Apollo.MutationResult<DeletePlaybookMutation>;
export type DeletePlaybookMutationOptions = Apollo.BaseMutationOptions<DeletePlaybookMutation, DeletePlaybookMutationVariables>;
export const DeletePlaybookSetDocument = gql`
    mutation DeletePlaybookSet($id: ID!) {
  deletePlaybookSet(id: $id)
}
    `;
export type DeletePlaybookSetMutationFn = Apollo.MutationFunction<DeletePlaybookSetMutation, DeletePlaybookSetMutationVariables>;

/**
 * __useDeletePlaybookSetMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookSetMutation, { data, loading, error }] = useDeletePlaybookSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlaybookSetMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaybookSetMutation, DeletePlaybookSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaybookSetMutation, DeletePlaybookSetMutationVariables>(DeletePlaybookSetDocument, options);
      }
export type DeletePlaybookSetMutationHookResult = ReturnType<typeof useDeletePlaybookSetMutation>;
export type DeletePlaybookSetMutationResult = Apollo.MutationResult<DeletePlaybookSetMutation>;
export type DeletePlaybookSetMutationOptions = Apollo.BaseMutationOptions<DeletePlaybookSetMutation, DeletePlaybookSetMutationVariables>;
export const DeletePlaybookTriggerDocument = gql`
    mutation DeletePlaybookTrigger($eventType: String!, $playbookId: String, $triggerConfig: JSONObject) {
  deletePlaybookTrigger(
    eventType: $eventType
    playbookId: $playbookId
    triggerConfig: $triggerConfig
  )
}
    `;
export type DeletePlaybookTriggerMutationFn = Apollo.MutationFunction<DeletePlaybookTriggerMutation, DeletePlaybookTriggerMutationVariables>;

/**
 * __useDeletePlaybookTriggerMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookTriggerMutation, { data, loading, error }] = useDeletePlaybookTriggerMutation({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      playbookId: // value for 'playbookId'
 *      triggerConfig: // value for 'triggerConfig'
 *   },
 * });
 */
export function useDeletePlaybookTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaybookTriggerMutation, DeletePlaybookTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaybookTriggerMutation, DeletePlaybookTriggerMutationVariables>(DeletePlaybookTriggerDocument, options);
      }
export type DeletePlaybookTriggerMutationHookResult = ReturnType<typeof useDeletePlaybookTriggerMutation>;
export type DeletePlaybookTriggerMutationResult = Apollo.MutationResult<DeletePlaybookTriggerMutation>;
export type DeletePlaybookTriggerMutationOptions = Apollo.BaseMutationOptions<DeletePlaybookTriggerMutation, DeletePlaybookTriggerMutationVariables>;
export const DeletePlaybookTriggerByIdDocument = gql`
    mutation DeletePlaybookTriggerById($triggerId: ID!) {
  deletePlaybookTriggerById(triggerId: $triggerId)
}
    `;
export type DeletePlaybookTriggerByIdMutationFn = Apollo.MutationFunction<DeletePlaybookTriggerByIdMutation, DeletePlaybookTriggerByIdMutationVariables>;

/**
 * __useDeletePlaybookTriggerByIdMutation__
 *
 * To run a mutation, you first call `useDeletePlaybookTriggerByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlaybookTriggerByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlaybookTriggerByIdMutation, { data, loading, error }] = useDeletePlaybookTriggerByIdMutation({
 *   variables: {
 *      triggerId: // value for 'triggerId'
 *   },
 * });
 */
export function useDeletePlaybookTriggerByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlaybookTriggerByIdMutation, DeletePlaybookTriggerByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlaybookTriggerByIdMutation, DeletePlaybookTriggerByIdMutationVariables>(DeletePlaybookTriggerByIdDocument, options);
      }
export type DeletePlaybookTriggerByIdMutationHookResult = ReturnType<typeof useDeletePlaybookTriggerByIdMutation>;
export type DeletePlaybookTriggerByIdMutationResult = Apollo.MutationResult<DeletePlaybookTriggerByIdMutation>;
export type DeletePlaybookTriggerByIdMutationOptions = Apollo.BaseMutationOptions<DeletePlaybookTriggerByIdMutation, DeletePlaybookTriggerByIdMutationVariables>;
export const DeleteFileTagDocument = gql`
    mutation DeleteFileTag($input: DeleteTagInput!) {
  deleteFileTag(input: $input) {
    label
  }
}
    `;
export type DeleteFileTagMutationFn = Apollo.MutationFunction<DeleteFileTagMutation, DeleteFileTagMutationVariables>;

/**
 * __useDeleteFileTagMutation__
 *
 * To run a mutation, you first call `useDeleteFileTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileTagMutation, { data, loading, error }] = useDeleteFileTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFileTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileTagMutation, DeleteFileTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileTagMutation, DeleteFileTagMutationVariables>(DeleteFileTagDocument, options);
      }
export type DeleteFileTagMutationHookResult = ReturnType<typeof useDeleteFileTagMutation>;
export type DeleteFileTagMutationResult = Apollo.MutationResult<DeleteFileTagMutation>;
export type DeleteFileTagMutationOptions = Apollo.BaseMutationOptions<DeleteFileTagMutation, DeleteFileTagMutationVariables>;
export const DeliverBinderDocument = gql`
    mutation DeliverBinder($input: IssuePolicyInput!) {
  deliverBinder(input: $input) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type DeliverBinderMutationFn = Apollo.MutationFunction<DeliverBinderMutation, DeliverBinderMutationVariables>;

/**
 * __useDeliverBinderMutation__
 *
 * To run a mutation, you first call `useDeliverBinderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeliverBinderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deliverBinderMutation, { data, loading, error }] = useDeliverBinderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeliverBinderMutation(baseOptions?: Apollo.MutationHookOptions<DeliverBinderMutation, DeliverBinderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeliverBinderMutation, DeliverBinderMutationVariables>(DeliverBinderDocument, options);
      }
export type DeliverBinderMutationHookResult = ReturnType<typeof useDeliverBinderMutation>;
export type DeliverBinderMutationResult = Apollo.MutationResult<DeliverBinderMutation>;
export type DeliverBinderMutationOptions = Apollo.BaseMutationOptions<DeliverBinderMutation, DeliverBinderMutationVariables>;
export const DisableAssignmentsForBrokerDocument = gql`
    mutation DisableAssignmentsForBroker($id: ID!) {
  disableAssignmentsForBroker(id: $id) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;
export type DisableAssignmentsForBrokerMutationFn = Apollo.MutationFunction<DisableAssignmentsForBrokerMutation, DisableAssignmentsForBrokerMutationVariables>;

/**
 * __useDisableAssignmentsForBrokerMutation__
 *
 * To run a mutation, you first call `useDisableAssignmentsForBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAssignmentsForBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAssignmentsForBrokerMutation, { data, loading, error }] = useDisableAssignmentsForBrokerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableAssignmentsForBrokerMutation(baseOptions?: Apollo.MutationHookOptions<DisableAssignmentsForBrokerMutation, DisableAssignmentsForBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableAssignmentsForBrokerMutation, DisableAssignmentsForBrokerMutationVariables>(DisableAssignmentsForBrokerDocument, options);
      }
export type DisableAssignmentsForBrokerMutationHookResult = ReturnType<typeof useDisableAssignmentsForBrokerMutation>;
export type DisableAssignmentsForBrokerMutationResult = Apollo.MutationResult<DisableAssignmentsForBrokerMutation>;
export type DisableAssignmentsForBrokerMutationOptions = Apollo.BaseMutationOptions<DisableAssignmentsForBrokerMutation, DisableAssignmentsForBrokerMutationVariables>;
export const DismissAttentionItemDocument = gql`
    mutation DismissAttentionItem($id: String!) {
  dismissAttentionItem(id: $id) {
    id
    success
  }
}
    `;
export type DismissAttentionItemMutationFn = Apollo.MutationFunction<DismissAttentionItemMutation, DismissAttentionItemMutationVariables>;

/**
 * __useDismissAttentionItemMutation__
 *
 * To run a mutation, you first call `useDismissAttentionItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAttentionItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAttentionItemMutation, { data, loading, error }] = useDismissAttentionItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissAttentionItemMutation(baseOptions?: Apollo.MutationHookOptions<DismissAttentionItemMutation, DismissAttentionItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAttentionItemMutation, DismissAttentionItemMutationVariables>(DismissAttentionItemDocument, options);
      }
export type DismissAttentionItemMutationHookResult = ReturnType<typeof useDismissAttentionItemMutation>;
export type DismissAttentionItemMutationResult = Apollo.MutationResult<DismissAttentionItemMutation>;
export type DismissAttentionItemMutationOptions = Apollo.BaseMutationOptions<DismissAttentionItemMutation, DismissAttentionItemMutationVariables>;
export const EditVaveQuoteDocument = gql`
    mutation EditVaveQuote($input: EditVaveQuoteInput!) {
  edit(input: $input) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type EditVaveQuoteMutationFn = Apollo.MutationFunction<EditVaveQuoteMutation, EditVaveQuoteMutationVariables>;

/**
 * __useEditVaveQuoteMutation__
 *
 * To run a mutation, you first call `useEditVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVaveQuoteMutation, { data, loading, error }] = useEditVaveQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<EditVaveQuoteMutation, EditVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditVaveQuoteMutation, EditVaveQuoteMutationVariables>(EditVaveQuoteDocument, options);
      }
export type EditVaveQuoteMutationHookResult = ReturnType<typeof useEditVaveQuoteMutation>;
export type EditVaveQuoteMutationResult = Apollo.MutationResult<EditVaveQuoteMutation>;
export type EditVaveQuoteMutationOptions = Apollo.BaseMutationOptions<EditVaveQuoteMutation, EditVaveQuoteMutationVariables>;
export const EnableAssignmentsForBrokerDocument = gql`
    mutation EnableAssignmentsForBroker($id: ID!) {
  enableAssignmentsForBroker(id: $id) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;
export type EnableAssignmentsForBrokerMutationFn = Apollo.MutationFunction<EnableAssignmentsForBrokerMutation, EnableAssignmentsForBrokerMutationVariables>;

/**
 * __useEnableAssignmentsForBrokerMutation__
 *
 * To run a mutation, you first call `useEnableAssignmentsForBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAssignmentsForBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAssignmentsForBrokerMutation, { data, loading, error }] = useEnableAssignmentsForBrokerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableAssignmentsForBrokerMutation(baseOptions?: Apollo.MutationHookOptions<EnableAssignmentsForBrokerMutation, EnableAssignmentsForBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableAssignmentsForBrokerMutation, EnableAssignmentsForBrokerMutationVariables>(EnableAssignmentsForBrokerDocument, options);
      }
export type EnableAssignmentsForBrokerMutationHookResult = ReturnType<typeof useEnableAssignmentsForBrokerMutation>;
export type EnableAssignmentsForBrokerMutationResult = Apollo.MutationResult<EnableAssignmentsForBrokerMutation>;
export type EnableAssignmentsForBrokerMutationOptions = Apollo.BaseMutationOptions<EnableAssignmentsForBrokerMutation, EnableAssignmentsForBrokerMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($authClientId: String!, $email: String!) {
  forgotPassword(authClientId: $authClientId, email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      authClientId: // value for 'authClientId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ImpersonateUserDocument = gql`
    mutation ImpersonateUser($authClientId: String!, $userIdToImpersonate: String, $emailToImpersonate: String) {
  impersonateUser(
    authClientId: $authClientId
    userIdToImpersonate: $userIdToImpersonate
    emailToImpersonate: $emailToImpersonate
  ) {
    accessToken
    user {
      id
      firstName
      lastName
      email
      roles
      agency {
        id
        name
      }
    }
  }
}
    `;
export type ImpersonateUserMutationFn = Apollo.MutationFunction<ImpersonateUserMutation, ImpersonateUserMutationVariables>;

/**
 * __useImpersonateUserMutation__
 *
 * To run a mutation, you first call `useImpersonateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateUserMutation, { data, loading, error }] = useImpersonateUserMutation({
 *   variables: {
 *      authClientId: // value for 'authClientId'
 *      userIdToImpersonate: // value for 'userIdToImpersonate'
 *      emailToImpersonate: // value for 'emailToImpersonate'
 *   },
 * });
 */
export function useImpersonateUserMutation(baseOptions?: Apollo.MutationHookOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImpersonateUserMutation, ImpersonateUserMutationVariables>(ImpersonateUserDocument, options);
      }
export type ImpersonateUserMutationHookResult = ReturnType<typeof useImpersonateUserMutation>;
export type ImpersonateUserMutationResult = Apollo.MutationResult<ImpersonateUserMutation>;
export type ImpersonateUserMutationOptions = Apollo.BaseMutationOptions<ImpersonateUserMutation, ImpersonateUserMutationVariables>;
export const ImportPlaybookFromUserDocument = gql`
    mutation ImportPlaybookFromUser($playbookId: String!) {
  importPlaybookFromUser(playbookId: $playbookId) {
    ...Playbook
  }
}
    ${PlaybookFragmentDoc}`;
export type ImportPlaybookFromUserMutationFn = Apollo.MutationFunction<ImportPlaybookFromUserMutation, ImportPlaybookFromUserMutationVariables>;

/**
 * __useImportPlaybookFromUserMutation__
 *
 * To run a mutation, you first call `useImportPlaybookFromUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPlaybookFromUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPlaybookFromUserMutation, { data, loading, error }] = useImportPlaybookFromUserMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *   },
 * });
 */
export function useImportPlaybookFromUserMutation(baseOptions?: Apollo.MutationHookOptions<ImportPlaybookFromUserMutation, ImportPlaybookFromUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPlaybookFromUserMutation, ImportPlaybookFromUserMutationVariables>(ImportPlaybookFromUserDocument, options);
      }
export type ImportPlaybookFromUserMutationHookResult = ReturnType<typeof useImportPlaybookFromUserMutation>;
export type ImportPlaybookFromUserMutationResult = Apollo.MutationResult<ImportPlaybookFromUserMutation>;
export type ImportPlaybookFromUserMutationOptions = Apollo.BaseMutationOptions<ImportPlaybookFromUserMutation, ImportPlaybookFromUserMutationVariables>;
export const IssuePolicyDocument = gql`
    mutation IssuePolicy($input: IssuePolicyInput!) {
  issuePolicy(input: $input) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type IssuePolicyMutationFn = Apollo.MutationFunction<IssuePolicyMutation, IssuePolicyMutationVariables>;

/**
 * __useIssuePolicyMutation__
 *
 * To run a mutation, you first call `useIssuePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssuePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issuePolicyMutation, { data, loading, error }] = useIssuePolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssuePolicyMutation(baseOptions?: Apollo.MutationHookOptions<IssuePolicyMutation, IssuePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssuePolicyMutation, IssuePolicyMutationVariables>(IssuePolicyDocument, options);
      }
export type IssuePolicyMutationHookResult = ReturnType<typeof useIssuePolicyMutation>;
export type IssuePolicyMutationResult = Apollo.MutationResult<IssuePolicyMutation>;
export type IssuePolicyMutationOptions = Apollo.BaseMutationOptions<IssuePolicyMutation, IssuePolicyMutationVariables>;
export const IssuePolicyInBindHqDocument = gql`
    mutation IssuePolicyInBindHq($policyId: ID!) {
  issuePolicyInBindHq(policyId: $policyId) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type IssuePolicyInBindHqMutationFn = Apollo.MutationFunction<IssuePolicyInBindHqMutation, IssuePolicyInBindHqMutationVariables>;

/**
 * __useIssuePolicyInBindHqMutation__
 *
 * To run a mutation, you first call `useIssuePolicyInBindHqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssuePolicyInBindHqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issuePolicyInBindHqMutation, { data, loading, error }] = useIssuePolicyInBindHqMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useIssuePolicyInBindHqMutation(baseOptions?: Apollo.MutationHookOptions<IssuePolicyInBindHqMutation, IssuePolicyInBindHqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssuePolicyInBindHqMutation, IssuePolicyInBindHqMutationVariables>(IssuePolicyInBindHqDocument, options);
      }
export type IssuePolicyInBindHqMutationHookResult = ReturnType<typeof useIssuePolicyInBindHqMutation>;
export type IssuePolicyInBindHqMutationResult = Apollo.MutationResult<IssuePolicyInBindHqMutation>;
export type IssuePolicyInBindHqMutationOptions = Apollo.BaseMutationOptions<IssuePolicyInBindHqMutation, IssuePolicyInBindHqMutationVariables>;
export const LinkConversationToInsuredDocument = gql`
    mutation LinkConversationToInsured($input: LinkConversationToInsuredInput!) {
  linkConversationToInsured(input: $input) {
    ...InboxConversation
    insuredLinkRedirect {
      insuredId
      name
      mergedAt
      depth
      survivorName
      message
    }
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;
export type LinkConversationToInsuredMutationFn = Apollo.MutationFunction<LinkConversationToInsuredMutation, LinkConversationToInsuredMutationVariables>;

/**
 * __useLinkConversationToInsuredMutation__
 *
 * To run a mutation, you first call `useLinkConversationToInsuredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkConversationToInsuredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkConversationToInsuredMutation, { data, loading, error }] = useLinkConversationToInsuredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkConversationToInsuredMutation(baseOptions?: Apollo.MutationHookOptions<LinkConversationToInsuredMutation, LinkConversationToInsuredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkConversationToInsuredMutation, LinkConversationToInsuredMutationVariables>(LinkConversationToInsuredDocument, options);
      }
export type LinkConversationToInsuredMutationHookResult = ReturnType<typeof useLinkConversationToInsuredMutation>;
export type LinkConversationToInsuredMutationResult = Apollo.MutationResult<LinkConversationToInsuredMutation>;
export type LinkConversationToInsuredMutationOptions = Apollo.BaseMutationOptions<LinkConversationToInsuredMutation, LinkConversationToInsuredMutationVariables>;
export const LinkConversationToOpportunityDocument = gql`
    mutation LinkConversationToOpportunity($input: LinkConversationToOpportunityInput!) {
  linkConversationToOpportunity(input: $input) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;
export type LinkConversationToOpportunityMutationFn = Apollo.MutationFunction<LinkConversationToOpportunityMutation, LinkConversationToOpportunityMutationVariables>;

/**
 * __useLinkConversationToOpportunityMutation__
 *
 * To run a mutation, you first call `useLinkConversationToOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkConversationToOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkConversationToOpportunityMutation, { data, loading, error }] = useLinkConversationToOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkConversationToOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<LinkConversationToOpportunityMutation, LinkConversationToOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkConversationToOpportunityMutation, LinkConversationToOpportunityMutationVariables>(LinkConversationToOpportunityDocument, options);
      }
export type LinkConversationToOpportunityMutationHookResult = ReturnType<typeof useLinkConversationToOpportunityMutation>;
export type LinkConversationToOpportunityMutationResult = Apollo.MutationResult<LinkConversationToOpportunityMutation>;
export type LinkConversationToOpportunityMutationOptions = Apollo.BaseMutationOptions<LinkConversationToOpportunityMutation, LinkConversationToOpportunityMutationVariables>;
export const LinkConversationToSubmissionDocument = gql`
    mutation LinkConversationToSubmission($input: LinkConversationToSubmissionInput!) {
  linkConversationToSubmission(input: $input) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;
export type LinkConversationToSubmissionMutationFn = Apollo.MutationFunction<LinkConversationToSubmissionMutation, LinkConversationToSubmissionMutationVariables>;

/**
 * __useLinkConversationToSubmissionMutation__
 *
 * To run a mutation, you first call `useLinkConversationToSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkConversationToSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkConversationToSubmissionMutation, { data, loading, error }] = useLinkConversationToSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkConversationToSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<LinkConversationToSubmissionMutation, LinkConversationToSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkConversationToSubmissionMutation, LinkConversationToSubmissionMutationVariables>(LinkConversationToSubmissionDocument, options);
      }
export type LinkConversationToSubmissionMutationHookResult = ReturnType<typeof useLinkConversationToSubmissionMutation>;
export type LinkConversationToSubmissionMutationResult = Apollo.MutationResult<LinkConversationToSubmissionMutation>;
export type LinkConversationToSubmissionMutationOptions = Apollo.BaseMutationOptions<LinkConversationToSubmissionMutation, LinkConversationToSubmissionMutationVariables>;
export const LoginEmailPasswordDocument = gql`
    mutation LoginEmailPassword($authClientId: String!, $email: String!, $password: String!) {
  loginEmailPassword(
    authClientId: $authClientId
    email: $email
    password: $password
  ) {
    token {
      ...AuthToken
    }
    user {
      id
      firstName
      lastName
      email
      roles
      agency {
        id
        name
      }
    }
  }
}
    ${AuthTokenFragmentDoc}`;
export type LoginEmailPasswordMutationFn = Apollo.MutationFunction<LoginEmailPasswordMutation, LoginEmailPasswordMutationVariables>;

/**
 * __useLoginEmailPasswordMutation__
 *
 * To run a mutation, you first call `useLoginEmailPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginEmailPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginEmailPasswordMutation, { data, loading, error }] = useLoginEmailPasswordMutation({
 *   variables: {
 *      authClientId: // value for 'authClientId'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginEmailPasswordMutation(baseOptions?: Apollo.MutationHookOptions<LoginEmailPasswordMutation, LoginEmailPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginEmailPasswordMutation, LoginEmailPasswordMutationVariables>(LoginEmailPasswordDocument, options);
      }
export type LoginEmailPasswordMutationHookResult = ReturnType<typeof useLoginEmailPasswordMutation>;
export type LoginEmailPasswordMutationResult = Apollo.MutationResult<LoginEmailPasswordMutation>;
export type LoginEmailPasswordMutationOptions = Apollo.BaseMutationOptions<LoginEmailPasswordMutation, LoginEmailPasswordMutationVariables>;
export const LoginIdentityProviderDocument = gql`
    mutation LoginIdentityProvider($authClientId: String!, $provider: KnownIdentityProviders!, $providerJwt: String!) {
  loginIdentityProvider(
    authClientId: $authClientId
    provider: $provider
    providerJwt: $providerJwt
  ) {
    token {
      ...AuthToken
    }
    user {
      id
      firstName
      lastName
      email
      roles
      agency {
        id
        name
      }
    }
  }
}
    ${AuthTokenFragmentDoc}`;
export type LoginIdentityProviderMutationFn = Apollo.MutationFunction<LoginIdentityProviderMutation, LoginIdentityProviderMutationVariables>;

/**
 * __useLoginIdentityProviderMutation__
 *
 * To run a mutation, you first call `useLoginIdentityProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginIdentityProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginIdentityProviderMutation, { data, loading, error }] = useLoginIdentityProviderMutation({
 *   variables: {
 *      authClientId: // value for 'authClientId'
 *      provider: // value for 'provider'
 *      providerJwt: // value for 'providerJwt'
 *   },
 * });
 */
export function useLoginIdentityProviderMutation(baseOptions?: Apollo.MutationHookOptions<LoginIdentityProviderMutation, LoginIdentityProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginIdentityProviderMutation, LoginIdentityProviderMutationVariables>(LoginIdentityProviderDocument, options);
      }
export type LoginIdentityProviderMutationHookResult = ReturnType<typeof useLoginIdentityProviderMutation>;
export type LoginIdentityProviderMutationResult = Apollo.MutationResult<LoginIdentityProviderMutation>;
export type LoginIdentityProviderMutationOptions = Apollo.BaseMutationOptions<LoginIdentityProviderMutation, LoginIdentityProviderMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout($refreshToken: String!) {
  logout(refreshToken: $refreshToken)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ManualAssignOpportunityDocument = gql`
    mutation ManualAssignOpportunity($input: ManualAssignOpportunityDTO!) {
  manualAssignOpportunity(input: $input) {
    id
    state
    broker {
      id
      firstName
      lastName
      email
      agency {
        id
        name
      }
    }
  }
}
    `;
export type ManualAssignOpportunityMutationFn = Apollo.MutationFunction<ManualAssignOpportunityMutation, ManualAssignOpportunityMutationVariables>;

/**
 * __useManualAssignOpportunityMutation__
 *
 * To run a mutation, you first call `useManualAssignOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManualAssignOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manualAssignOpportunityMutation, { data, loading, error }] = useManualAssignOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManualAssignOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<ManualAssignOpportunityMutation, ManualAssignOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManualAssignOpportunityMutation, ManualAssignOpportunityMutationVariables>(ManualAssignOpportunityDocument, options);
      }
export type ManualAssignOpportunityMutationHookResult = ReturnType<typeof useManualAssignOpportunityMutation>;
export type ManualAssignOpportunityMutationResult = Apollo.MutationResult<ManualAssignOpportunityMutation>;
export type ManualAssignOpportunityMutationOptions = Apollo.BaseMutationOptions<ManualAssignOpportunityMutation, ManualAssignOpportunityMutationVariables>;
export const MarkAlbyUpdatesSeenDocument = gql`
    mutation MarkAlbyUpdatesSeen($opportunityId: String!) {
  markAlbyUpdatesSeen(opportunityId: $opportunityId)
}
    `;
export type MarkAlbyUpdatesSeenMutationFn = Apollo.MutationFunction<MarkAlbyUpdatesSeenMutation, MarkAlbyUpdatesSeenMutationVariables>;

/**
 * __useMarkAlbyUpdatesSeenMutation__
 *
 * To run a mutation, you first call `useMarkAlbyUpdatesSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAlbyUpdatesSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAlbyUpdatesSeenMutation, { data, loading, error }] = useMarkAlbyUpdatesSeenMutation({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useMarkAlbyUpdatesSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkAlbyUpdatesSeenMutation, MarkAlbyUpdatesSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAlbyUpdatesSeenMutation, MarkAlbyUpdatesSeenMutationVariables>(MarkAlbyUpdatesSeenDocument, options);
      }
export type MarkAlbyUpdatesSeenMutationHookResult = ReturnType<typeof useMarkAlbyUpdatesSeenMutation>;
export type MarkAlbyUpdatesSeenMutationResult = Apollo.MutationResult<MarkAlbyUpdatesSeenMutation>;
export type MarkAlbyUpdatesSeenMutationOptions = Apollo.BaseMutationOptions<MarkAlbyUpdatesSeenMutation, MarkAlbyUpdatesSeenMutationVariables>;
export const MarkConversationWakeUpFollowedUpDocument = gql`
    mutation MarkConversationWakeUpFollowedUp($wakeUpId: UUID!) {
  markConversationWakeUpFollowedUp(wakeUpId: $wakeUpId) {
    id
    dueAt
    agentEmail
    agentPhone
    sourceReason
    conversationId
    displayMetadata
  }
}
    `;
export type MarkConversationWakeUpFollowedUpMutationFn = Apollo.MutationFunction<MarkConversationWakeUpFollowedUpMutation, MarkConversationWakeUpFollowedUpMutationVariables>;

/**
 * __useMarkConversationWakeUpFollowedUpMutation__
 *
 * To run a mutation, you first call `useMarkConversationWakeUpFollowedUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkConversationWakeUpFollowedUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markConversationWakeUpFollowedUpMutation, { data, loading, error }] = useMarkConversationWakeUpFollowedUpMutation({
 *   variables: {
 *      wakeUpId: // value for 'wakeUpId'
 *   },
 * });
 */
export function useMarkConversationWakeUpFollowedUpMutation(baseOptions?: Apollo.MutationHookOptions<MarkConversationWakeUpFollowedUpMutation, MarkConversationWakeUpFollowedUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkConversationWakeUpFollowedUpMutation, MarkConversationWakeUpFollowedUpMutationVariables>(MarkConversationWakeUpFollowedUpDocument, options);
      }
export type MarkConversationWakeUpFollowedUpMutationHookResult = ReturnType<typeof useMarkConversationWakeUpFollowedUpMutation>;
export type MarkConversationWakeUpFollowedUpMutationResult = Apollo.MutationResult<MarkConversationWakeUpFollowedUpMutation>;
export type MarkConversationWakeUpFollowedUpMutationOptions = Apollo.BaseMutationOptions<MarkConversationWakeUpFollowedUpMutation, MarkConversationWakeUpFollowedUpMutationVariables>;
export const MarkRenewalNotesAsReadDocument = gql`
    mutation MarkRenewalNotesAsRead($input: MarkRenewalNotesReadInput!) {
  markRenewalNotesAsRead(input: $input) {
    ...RenewalNote
  }
}
    ${RenewalNoteFragmentDoc}`;
export type MarkRenewalNotesAsReadMutationFn = Apollo.MutationFunction<MarkRenewalNotesAsReadMutation, MarkRenewalNotesAsReadMutationVariables>;

/**
 * __useMarkRenewalNotesAsReadMutation__
 *
 * To run a mutation, you first call `useMarkRenewalNotesAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkRenewalNotesAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markRenewalNotesAsReadMutation, { data, loading, error }] = useMarkRenewalNotesAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkRenewalNotesAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkRenewalNotesAsReadMutation, MarkRenewalNotesAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkRenewalNotesAsReadMutation, MarkRenewalNotesAsReadMutationVariables>(MarkRenewalNotesAsReadDocument, options);
      }
export type MarkRenewalNotesAsReadMutationHookResult = ReturnType<typeof useMarkRenewalNotesAsReadMutation>;
export type MarkRenewalNotesAsReadMutationResult = Apollo.MutationResult<MarkRenewalNotesAsReadMutation>;
export type MarkRenewalNotesAsReadMutationOptions = Apollo.BaseMutationOptions<MarkRenewalNotesAsReadMutation, MarkRenewalNotesAsReadMutationVariables>;
export const MergeInsuredDocument = gql`
    mutation MergeInsured($input: MergeInsuredInput!) {
  mergeInsured(input: $input) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;
export type MergeInsuredMutationFn = Apollo.MutationFunction<MergeInsuredMutation, MergeInsuredMutationVariables>;

/**
 * __useMergeInsuredMutation__
 *
 * To run a mutation, you first call `useMergeInsuredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeInsuredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeInsuredMutation, { data, loading, error }] = useMergeInsuredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeInsuredMutation(baseOptions?: Apollo.MutationHookOptions<MergeInsuredMutation, MergeInsuredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeInsuredMutation, MergeInsuredMutationVariables>(MergeInsuredDocument, options);
      }
export type MergeInsuredMutationHookResult = ReturnType<typeof useMergeInsuredMutation>;
export type MergeInsuredMutationResult = Apollo.MutationResult<MergeInsuredMutation>;
export type MergeInsuredMutationOptions = Apollo.BaseMutationOptions<MergeInsuredMutation, MergeInsuredMutationVariables>;
export const MergeFileTagsDocument = gql`
    mutation MergeFileTags($input: MergeTagsInput!) {
  mergeFileTags(input: $input) {
    label
    parentTags {
      label
    }
    childTags {
      label
    }
  }
}
    `;
export type MergeFileTagsMutationFn = Apollo.MutationFunction<MergeFileTagsMutation, MergeFileTagsMutationVariables>;

/**
 * __useMergeFileTagsMutation__
 *
 * To run a mutation, you first call `useMergeFileTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeFileTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeFileTagsMutation, { data, loading, error }] = useMergeFileTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeFileTagsMutation(baseOptions?: Apollo.MutationHookOptions<MergeFileTagsMutation, MergeFileTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeFileTagsMutation, MergeFileTagsMutationVariables>(MergeFileTagsDocument, options);
      }
export type MergeFileTagsMutationHookResult = ReturnType<typeof useMergeFileTagsMutation>;
export type MergeFileTagsMutationResult = Apollo.MutationResult<MergeFileTagsMutation>;
export type MergeFileTagsMutationOptions = Apollo.BaseMutationOptions<MergeFileTagsMutation, MergeFileTagsMutationVariables>;
export const OfferVaveQuoteDocument = gql`
    mutation OfferVaveQuote($submissionId: String!) {
  offer(submissionId: $submissionId) {
    id
    quoteId
  }
}
    `;
export type OfferVaveQuoteMutationFn = Apollo.MutationFunction<OfferVaveQuoteMutation, OfferVaveQuoteMutationVariables>;

/**
 * __useOfferVaveQuoteMutation__
 *
 * To run a mutation, you first call `useOfferVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerVaveQuoteMutation, { data, loading, error }] = useOfferVaveQuoteMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useOfferVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<OfferVaveQuoteMutation, OfferVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferVaveQuoteMutation, OfferVaveQuoteMutationVariables>(OfferVaveQuoteDocument, options);
      }
export type OfferVaveQuoteMutationHookResult = ReturnType<typeof useOfferVaveQuoteMutation>;
export type OfferVaveQuoteMutationResult = Apollo.MutationResult<OfferVaveQuoteMutation>;
export type OfferVaveQuoteMutationOptions = Apollo.BaseMutationOptions<OfferVaveQuoteMutation, OfferVaveQuoteMutationVariables>;
export const PasswordResetDocument = gql`
    mutation PasswordReset($changePasswordId: String!, $newPassword: String!) {
  passwordReset(changePasswordId: $changePasswordId, newPassword: $newPassword)
}
    `;
export type PasswordResetMutationFn = Apollo.MutationFunction<PasswordResetMutation, PasswordResetMutationVariables>;

/**
 * __usePasswordResetMutation__
 *
 * To run a mutation, you first call `usePasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordResetMutation, { data, loading, error }] = usePasswordResetMutation({
 *   variables: {
 *      changePasswordId: // value for 'changePasswordId'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function usePasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<PasswordResetMutation, PasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordResetMutation, PasswordResetMutationVariables>(PasswordResetDocument, options);
      }
export type PasswordResetMutationHookResult = ReturnType<typeof usePasswordResetMutation>;
export type PasswordResetMutationResult = Apollo.MutationResult<PasswordResetMutation>;
export type PasswordResetMutationOptions = Apollo.BaseMutationOptions<PasswordResetMutation, PasswordResetMutationVariables>;
export const PlaceInspectionOrderDocument = gql`
    mutation PlaceInspectionOrder($inspectionOrderId: ID!, $expectedUpdatedAt: DateTime!) {
  placeInspectionOrder(
    inspectionOrderId: $inspectionOrderId
    expectedUpdatedAt: $expectedUpdatedAt
  ) {
    ...InspectionOrder
  }
}
    ${InspectionOrderFragmentDoc}`;
export type PlaceInspectionOrderMutationFn = Apollo.MutationFunction<PlaceInspectionOrderMutation, PlaceInspectionOrderMutationVariables>;

/**
 * __usePlaceInspectionOrderMutation__
 *
 * To run a mutation, you first call `usePlaceInspectionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceInspectionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeInspectionOrderMutation, { data, loading, error }] = usePlaceInspectionOrderMutation({
 *   variables: {
 *      inspectionOrderId: // value for 'inspectionOrderId'
 *      expectedUpdatedAt: // value for 'expectedUpdatedAt'
 *   },
 * });
 */
export function usePlaceInspectionOrderMutation(baseOptions?: Apollo.MutationHookOptions<PlaceInspectionOrderMutation, PlaceInspectionOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PlaceInspectionOrderMutation, PlaceInspectionOrderMutationVariables>(PlaceInspectionOrderDocument, options);
      }
export type PlaceInspectionOrderMutationHookResult = ReturnType<typeof usePlaceInspectionOrderMutation>;
export type PlaceInspectionOrderMutationResult = Apollo.MutationResult<PlaceInspectionOrderMutation>;
export type PlaceInspectionOrderMutationOptions = Apollo.BaseMutationOptions<PlaceInspectionOrderMutation, PlaceInspectionOrderMutationVariables>;
export const PriceNewVaveQuoteDocument = gql`
    mutation PriceNewVaveQuote($input: CreateVaveQuoteInput!) {
  priceNew(input: $input) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type PriceNewVaveQuoteMutationFn = Apollo.MutationFunction<PriceNewVaveQuoteMutation, PriceNewVaveQuoteMutationVariables>;

/**
 * __usePriceNewVaveQuoteMutation__
 *
 * To run a mutation, you first call `usePriceNewVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceNewVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceNewVaveQuoteMutation, { data, loading, error }] = usePriceNewVaveQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePriceNewVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<PriceNewVaveQuoteMutation, PriceNewVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceNewVaveQuoteMutation, PriceNewVaveQuoteMutationVariables>(PriceNewVaveQuoteDocument, options);
      }
export type PriceNewVaveQuoteMutationHookResult = ReturnType<typeof usePriceNewVaveQuoteMutation>;
export type PriceNewVaveQuoteMutationResult = Apollo.MutationResult<PriceNewVaveQuoteMutation>;
export type PriceNewVaveQuoteMutationOptions = Apollo.BaseMutationOptions<PriceNewVaveQuoteMutation, PriceNewVaveQuoteMutationVariables>;
export const ReassignOpportunityDocument = gql`
    mutation ReassignOpportunity($id: ID!) {
  reassignOpportunity(id: $id) {
    ...OpportunityDetails
  }
}
    ${OpportunityDetailsFragmentDoc}
${MarketingPlanSubmissionFragmentDoc}
${MarketingPlanAppetiteProductFragmentDoc}
${SlimAppetiteProductFragmentFragmentDoc}
${CarrierContactFragmentDoc}
${MarketingPlanQuoteFragmentDoc}
${MarketingPlanMarketSummaryNoteFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;
export type ReassignOpportunityMutationFn = Apollo.MutationFunction<ReassignOpportunityMutation, ReassignOpportunityMutationVariables>;

/**
 * __useReassignOpportunityMutation__
 *
 * To run a mutation, you first call `useReassignOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignOpportunityMutation, { data, loading, error }] = useReassignOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReassignOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<ReassignOpportunityMutation, ReassignOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignOpportunityMutation, ReassignOpportunityMutationVariables>(ReassignOpportunityDocument, options);
      }
export type ReassignOpportunityMutationHookResult = ReturnType<typeof useReassignOpportunityMutation>;
export type ReassignOpportunityMutationResult = Apollo.MutationResult<ReassignOpportunityMutation>;
export type ReassignOpportunityMutationOptions = Apollo.BaseMutationOptions<ReassignOpportunityMutation, ReassignOpportunityMutationVariables>;
export const ReconcileInspectionOrderDocument = gql`
    mutation ReconcileInspectionOrder($inspectionOrderId: ID!) {
  reconcileInspectionOrder(inspectionOrderId: $inspectionOrderId) {
    ...InspectionOrder
  }
}
    ${InspectionOrderFragmentDoc}`;
export type ReconcileInspectionOrderMutationFn = Apollo.MutationFunction<ReconcileInspectionOrderMutation, ReconcileInspectionOrderMutationVariables>;

/**
 * __useReconcileInspectionOrderMutation__
 *
 * To run a mutation, you first call `useReconcileInspectionOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileInspectionOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileInspectionOrderMutation, { data, loading, error }] = useReconcileInspectionOrderMutation({
 *   variables: {
 *      inspectionOrderId: // value for 'inspectionOrderId'
 *   },
 * });
 */
export function useReconcileInspectionOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileInspectionOrderMutation, ReconcileInspectionOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileInspectionOrderMutation, ReconcileInspectionOrderMutationVariables>(ReconcileInspectionOrderDocument, options);
      }
export type ReconcileInspectionOrderMutationHookResult = ReturnType<typeof useReconcileInspectionOrderMutation>;
export type ReconcileInspectionOrderMutationResult = Apollo.MutationResult<ReconcileInspectionOrderMutation>;
export type ReconcileInspectionOrderMutationOptions = Apollo.BaseMutationOptions<ReconcileInspectionOrderMutation, ReconcileInspectionOrderMutationVariables>;
export const RecordSubmissionIndicationDocument = gql`
    mutation RecordSubmissionIndication($input: RecordSubmissionIndicationInput!) {
  recordSubmissionIndication(input: $input) {
    ...MarketingPlanSubmission
  }
}
    ${MarketingPlanSubmissionFragmentDoc}
${MarketingPlanAppetiteProductFragmentDoc}
${SlimAppetiteProductFragmentFragmentDoc}
${CarrierContactFragmentDoc}
${MarketingPlanQuoteFragmentDoc}
${MarketingPlanMarketSummaryNoteFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;
export type RecordSubmissionIndicationMutationFn = Apollo.MutationFunction<RecordSubmissionIndicationMutation, RecordSubmissionIndicationMutationVariables>;

/**
 * __useRecordSubmissionIndicationMutation__
 *
 * To run a mutation, you first call `useRecordSubmissionIndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSubmissionIndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSubmissionIndicationMutation, { data, loading, error }] = useRecordSubmissionIndicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSubmissionIndicationMutation(baseOptions?: Apollo.MutationHookOptions<RecordSubmissionIndicationMutation, RecordSubmissionIndicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSubmissionIndicationMutation, RecordSubmissionIndicationMutationVariables>(RecordSubmissionIndicationDocument, options);
      }
export type RecordSubmissionIndicationMutationHookResult = ReturnType<typeof useRecordSubmissionIndicationMutation>;
export type RecordSubmissionIndicationMutationResult = Apollo.MutationResult<RecordSubmissionIndicationMutation>;
export type RecordSubmissionIndicationMutationOptions = Apollo.BaseMutationOptions<RecordSubmissionIndicationMutation, RecordSubmissionIndicationMutationVariables>;
export const RecoverStrandedRecordsDocument = gql`
    mutation RecoverStrandedRecords($survivorId: UUID!, $previewHash: String!) {
  recoverStrandedRecords(survivorId: $survivorId, previewHash: $previewHash) {
    conversations
    drafts
    opportunities
    files
    gmailThreads
  }
}
    `;
export type RecoverStrandedRecordsMutationFn = Apollo.MutationFunction<RecoverStrandedRecordsMutation, RecoverStrandedRecordsMutationVariables>;

/**
 * __useRecoverStrandedRecordsMutation__
 *
 * To run a mutation, you first call `useRecoverStrandedRecordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecoverStrandedRecordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recoverStrandedRecordsMutation, { data, loading, error }] = useRecoverStrandedRecordsMutation({
 *   variables: {
 *      survivorId: // value for 'survivorId'
 *      previewHash: // value for 'previewHash'
 *   },
 * });
 */
export function useRecoverStrandedRecordsMutation(baseOptions?: Apollo.MutationHookOptions<RecoverStrandedRecordsMutation, RecoverStrandedRecordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecoverStrandedRecordsMutation, RecoverStrandedRecordsMutationVariables>(RecoverStrandedRecordsDocument, options);
      }
export type RecoverStrandedRecordsMutationHookResult = ReturnType<typeof useRecoverStrandedRecordsMutation>;
export type RecoverStrandedRecordsMutationResult = Apollo.MutationResult<RecoverStrandedRecordsMutation>;
export type RecoverStrandedRecordsMutationOptions = Apollo.BaseMutationOptions<RecoverStrandedRecordsMutation, RecoverStrandedRecordsMutationVariables>;
export const RefreshInboxDocument = gql`
    mutation RefreshInbox {
  refreshInbox {
    changeCount
    initialized
    startedWorkflowCount
  }
}
    `;
export type RefreshInboxMutationFn = Apollo.MutationFunction<RefreshInboxMutation, RefreshInboxMutationVariables>;

/**
 * __useRefreshInboxMutation__
 *
 * To run a mutation, you first call `useRefreshInboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshInboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshInboxMutation, { data, loading, error }] = useRefreshInboxMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshInboxMutation(baseOptions?: Apollo.MutationHookOptions<RefreshInboxMutation, RefreshInboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshInboxMutation, RefreshInboxMutationVariables>(RefreshInboxDocument, options);
      }
export type RefreshInboxMutationHookResult = ReturnType<typeof useRefreshInboxMutation>;
export type RefreshInboxMutationResult = Apollo.MutationResult<RefreshInboxMutation>;
export type RefreshInboxMutationOptions = Apollo.BaseMutationOptions<RefreshInboxMutation, RefreshInboxMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($token: AuthTokenInput!) {
  refreshToken(token: $token) {
    ...AuthToken
  }
}
    ${AuthTokenFragmentDoc}`;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RegenerateProcessedPdfDocument = gql`
    mutation RegenerateProcessedPdf($vaveQuoteId: String!) {
  regenerateProcessedPdf(vaveQuoteId: $vaveQuoteId) {
    id
  }
}
    `;
export type RegenerateProcessedPdfMutationFn = Apollo.MutationFunction<RegenerateProcessedPdfMutation, RegenerateProcessedPdfMutationVariables>;

/**
 * __useRegenerateProcessedPdfMutation__
 *
 * To run a mutation, you first call `useRegenerateProcessedPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateProcessedPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateProcessedPdfMutation, { data, loading, error }] = useRegenerateProcessedPdfMutation({
 *   variables: {
 *      vaveQuoteId: // value for 'vaveQuoteId'
 *   },
 * });
 */
export function useRegenerateProcessedPdfMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateProcessedPdfMutation, RegenerateProcessedPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateProcessedPdfMutation, RegenerateProcessedPdfMutationVariables>(RegenerateProcessedPdfDocument, options);
      }
export type RegenerateProcessedPdfMutationHookResult = ReturnType<typeof useRegenerateProcessedPdfMutation>;
export type RegenerateProcessedPdfMutationResult = Apollo.MutationResult<RegenerateProcessedPdfMutation>;
export type RegenerateProcessedPdfMutationOptions = Apollo.BaseMutationOptions<RegenerateProcessedPdfMutation, RegenerateProcessedPdfMutationVariables>;
export const RemoveAssignmentGroupFromBrokerDocument = gql`
    mutation RemoveAssignmentGroupFromBroker($input: RemoveAssignmentGroupFromBrokerDTO!) {
  removeAssignmentGroupFromBroker(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;
export type RemoveAssignmentGroupFromBrokerMutationFn = Apollo.MutationFunction<RemoveAssignmentGroupFromBrokerMutation, RemoveAssignmentGroupFromBrokerMutationVariables>;

/**
 * __useRemoveAssignmentGroupFromBrokerMutation__
 *
 * To run a mutation, you first call `useRemoveAssignmentGroupFromBrokerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAssignmentGroupFromBrokerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAssignmentGroupFromBrokerMutation, { data, loading, error }] = useRemoveAssignmentGroupFromBrokerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAssignmentGroupFromBrokerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAssignmentGroupFromBrokerMutation, RemoveAssignmentGroupFromBrokerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAssignmentGroupFromBrokerMutation, RemoveAssignmentGroupFromBrokerMutationVariables>(RemoveAssignmentGroupFromBrokerDocument, options);
      }
export type RemoveAssignmentGroupFromBrokerMutationHookResult = ReturnType<typeof useRemoveAssignmentGroupFromBrokerMutation>;
export type RemoveAssignmentGroupFromBrokerMutationResult = Apollo.MutationResult<RemoveAssignmentGroupFromBrokerMutation>;
export type RemoveAssignmentGroupFromBrokerMutationOptions = Apollo.BaseMutationOptions<RemoveAssignmentGroupFromBrokerMutation, RemoveAssignmentGroupFromBrokerMutationVariables>;
export const RemoveAttachmentFromInboxDraftDocument = gql`
    mutation RemoveAttachmentFromInboxDraft($input: RemoveAttachmentFromDraftInputDto!) {
  removeAttachmentFromInboxDraft(input: $input) {
    ...DraftMessageAttachment
  }
}
    ${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type RemoveAttachmentFromInboxDraftMutationFn = Apollo.MutationFunction<RemoveAttachmentFromInboxDraftMutation, RemoveAttachmentFromInboxDraftMutationVariables>;

/**
 * __useRemoveAttachmentFromInboxDraftMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentFromInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentFromInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentFromInboxDraftMutation, { data, loading, error }] = useRemoveAttachmentFromInboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAttachmentFromInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentFromInboxDraftMutation, RemoveAttachmentFromInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentFromInboxDraftMutation, RemoveAttachmentFromInboxDraftMutationVariables>(RemoveAttachmentFromInboxDraftDocument, options);
      }
export type RemoveAttachmentFromInboxDraftMutationHookResult = ReturnType<typeof useRemoveAttachmentFromInboxDraftMutation>;
export type RemoveAttachmentFromInboxDraftMutationResult = Apollo.MutationResult<RemoveAttachmentFromInboxDraftMutation>;
export type RemoveAttachmentFromInboxDraftMutationOptions = Apollo.BaseMutationOptions<RemoveAttachmentFromInboxDraftMutation, RemoveAttachmentFromInboxDraftMutationVariables>;
export const RemoveCarrierContactFromAppetiteProductDocument = gql`
    mutation RemoveCarrierContactFromAppetiteProduct($input: CarrierContactConnectorInput!) {
  removeCarrierContactFromAppetiteProduct(input: $input) {
    ...CarrierContact
  }
}
    ${CarrierContactFragmentDoc}`;
export type RemoveCarrierContactFromAppetiteProductMutationFn = Apollo.MutationFunction<RemoveCarrierContactFromAppetiteProductMutation, RemoveCarrierContactFromAppetiteProductMutationVariables>;

/**
 * __useRemoveCarrierContactFromAppetiteProductMutation__
 *
 * To run a mutation, you first call `useRemoveCarrierContactFromAppetiteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCarrierContactFromAppetiteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCarrierContactFromAppetiteProductMutation, { data, loading, error }] = useRemoveCarrierContactFromAppetiteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCarrierContactFromAppetiteProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCarrierContactFromAppetiteProductMutation, RemoveCarrierContactFromAppetiteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCarrierContactFromAppetiteProductMutation, RemoveCarrierContactFromAppetiteProductMutationVariables>(RemoveCarrierContactFromAppetiteProductDocument, options);
      }
export type RemoveCarrierContactFromAppetiteProductMutationHookResult = ReturnType<typeof useRemoveCarrierContactFromAppetiteProductMutation>;
export type RemoveCarrierContactFromAppetiteProductMutationResult = Apollo.MutationResult<RemoveCarrierContactFromAppetiteProductMutation>;
export type RemoveCarrierContactFromAppetiteProductMutationOptions = Apollo.BaseMutationOptions<RemoveCarrierContactFromAppetiteProductMutation, RemoveCarrierContactFromAppetiteProductMutationVariables>;
export const RemoveInboxConversationLabelDocument = gql`
    mutation RemoveInboxConversationLabel($input: RemoveConversationLabelInput!) {
  removeInboxConversationLabel(input: $input) {
    ...InboxConversationsListConversation
  }
}
    ${InboxConversationsListConversationFragmentDoc}
${InboxConversationsConversationFragmentDoc}`;
export type RemoveInboxConversationLabelMutationFn = Apollo.MutationFunction<RemoveInboxConversationLabelMutation, RemoveInboxConversationLabelMutationVariables>;

/**
 * __useRemoveInboxConversationLabelMutation__
 *
 * To run a mutation, you first call `useRemoveInboxConversationLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInboxConversationLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInboxConversationLabelMutation, { data, loading, error }] = useRemoveInboxConversationLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveInboxConversationLabelMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInboxConversationLabelMutation, RemoveInboxConversationLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInboxConversationLabelMutation, RemoveInboxConversationLabelMutationVariables>(RemoveInboxConversationLabelDocument, options);
      }
export type RemoveInboxConversationLabelMutationHookResult = ReturnType<typeof useRemoveInboxConversationLabelMutation>;
export type RemoveInboxConversationLabelMutationResult = Apollo.MutationResult<RemoveInboxConversationLabelMutation>;
export type RemoveInboxConversationLabelMutationOptions = Apollo.BaseMutationOptions<RemoveInboxConversationLabelMutation, RemoveInboxConversationLabelMutationVariables>;
export const RemovePlaybookFromSetDocument = gql`
    mutation RemovePlaybookFromSet($playbookId: String!, $setId: ID!) {
  removePlaybookFromSet(playbookId: $playbookId, setId: $setId)
}
    `;
export type RemovePlaybookFromSetMutationFn = Apollo.MutationFunction<RemovePlaybookFromSetMutation, RemovePlaybookFromSetMutationVariables>;

/**
 * __useRemovePlaybookFromSetMutation__
 *
 * To run a mutation, you first call `useRemovePlaybookFromSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePlaybookFromSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePlaybookFromSetMutation, { data, loading, error }] = useRemovePlaybookFromSetMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      setId: // value for 'setId'
 *   },
 * });
 */
export function useRemovePlaybookFromSetMutation(baseOptions?: Apollo.MutationHookOptions<RemovePlaybookFromSetMutation, RemovePlaybookFromSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePlaybookFromSetMutation, RemovePlaybookFromSetMutationVariables>(RemovePlaybookFromSetDocument, options);
      }
export type RemovePlaybookFromSetMutationHookResult = ReturnType<typeof useRemovePlaybookFromSetMutation>;
export type RemovePlaybookFromSetMutationResult = Apollo.MutationResult<RemovePlaybookFromSetMutation>;
export type RemovePlaybookFromSetMutationOptions = Apollo.BaseMutationOptions<RemovePlaybookFromSetMutation, RemovePlaybookFromSetMutationVariables>;
export const ReplaceMarketingPlanSubmissionsDocument = gql`
    mutation ReplaceMarketingPlanSubmissions($input: ReplaceMarketingPlanSubmissionsInput!) {
  replaceMarketingPlanSubmissions(input: $input) {
    id
  }
}
    `;
export type ReplaceMarketingPlanSubmissionsMutationFn = Apollo.MutationFunction<ReplaceMarketingPlanSubmissionsMutation, ReplaceMarketingPlanSubmissionsMutationVariables>;

/**
 * __useReplaceMarketingPlanSubmissionsMutation__
 *
 * To run a mutation, you first call `useReplaceMarketingPlanSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceMarketingPlanSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceMarketingPlanSubmissionsMutation, { data, loading, error }] = useReplaceMarketingPlanSubmissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplaceMarketingPlanSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceMarketingPlanSubmissionsMutation, ReplaceMarketingPlanSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceMarketingPlanSubmissionsMutation, ReplaceMarketingPlanSubmissionsMutationVariables>(ReplaceMarketingPlanSubmissionsDocument, options);
      }
export type ReplaceMarketingPlanSubmissionsMutationHookResult = ReturnType<typeof useReplaceMarketingPlanSubmissionsMutation>;
export type ReplaceMarketingPlanSubmissionsMutationResult = Apollo.MutationResult<ReplaceMarketingPlanSubmissionsMutation>;
export type ReplaceMarketingPlanSubmissionsMutationOptions = Apollo.BaseMutationOptions<ReplaceMarketingPlanSubmissionsMutation, ReplaceMarketingPlanSubmissionsMutationVariables>;
export const RescheduleSendInboxDraftDocument = gql`
    mutation RescheduleSendInboxDraft($input: RescheduleSendDraftInputDto!) {
  rescheduleSendInboxDraft(input: $input) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type RescheduleSendInboxDraftMutationFn = Apollo.MutationFunction<RescheduleSendInboxDraftMutation, RescheduleSendInboxDraftMutationVariables>;

/**
 * __useRescheduleSendInboxDraftMutation__
 *
 * To run a mutation, you first call `useRescheduleSendInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleSendInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleSendInboxDraftMutation, { data, loading, error }] = useRescheduleSendInboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleSendInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleSendInboxDraftMutation, RescheduleSendInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleSendInboxDraftMutation, RescheduleSendInboxDraftMutationVariables>(RescheduleSendInboxDraftDocument, options);
      }
export type RescheduleSendInboxDraftMutationHookResult = ReturnType<typeof useRescheduleSendInboxDraftMutation>;
export type RescheduleSendInboxDraftMutationResult = Apollo.MutationResult<RescheduleSendInboxDraftMutation>;
export type RescheduleSendInboxDraftMutationOptions = Apollo.BaseMutationOptions<RescheduleSendInboxDraftMutation, RescheduleSendInboxDraftMutationVariables>;
export const ResendVaveBindRequestDocument = gql`
    mutation ResendVaveBindRequest($vaveQuoteId: String!) {
  resendBindRequest(vaveQuoteId: $vaveQuoteId) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type ResendVaveBindRequestMutationFn = Apollo.MutationFunction<ResendVaveBindRequestMutation, ResendVaveBindRequestMutationVariables>;

/**
 * __useResendVaveBindRequestMutation__
 *
 * To run a mutation, you first call `useResendVaveBindRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVaveBindRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVaveBindRequestMutation, { data, loading, error }] = useResendVaveBindRequestMutation({
 *   variables: {
 *      vaveQuoteId: // value for 'vaveQuoteId'
 *   },
 * });
 */
export function useResendVaveBindRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResendVaveBindRequestMutation, ResendVaveBindRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVaveBindRequestMutation, ResendVaveBindRequestMutationVariables>(ResendVaveBindRequestDocument, options);
      }
export type ResendVaveBindRequestMutationHookResult = ReturnType<typeof useResendVaveBindRequestMutation>;
export type ResendVaveBindRequestMutationResult = Apollo.MutationResult<ResendVaveBindRequestMutation>;
export type ResendVaveBindRequestMutationOptions = Apollo.BaseMutationOptions<ResendVaveBindRequestMutation, ResendVaveBindRequestMutationVariables>;
export const RetryContractExtractionDocument = gql`
    mutation RetryContractExtraction($contractId: ID!) {
  retryContractExtraction(contractId: $contractId) {
    id
    extractionStatus
  }
}
    `;
export type RetryContractExtractionMutationFn = Apollo.MutationFunction<RetryContractExtractionMutation, RetryContractExtractionMutationVariables>;

/**
 * __useRetryContractExtractionMutation__
 *
 * To run a mutation, you first call `useRetryContractExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryContractExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryContractExtractionMutation, { data, loading, error }] = useRetryContractExtractionMutation({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useRetryContractExtractionMutation(baseOptions?: Apollo.MutationHookOptions<RetryContractExtractionMutation, RetryContractExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryContractExtractionMutation, RetryContractExtractionMutationVariables>(RetryContractExtractionDocument, options);
      }
export type RetryContractExtractionMutationHookResult = ReturnType<typeof useRetryContractExtractionMutation>;
export type RetryContractExtractionMutationResult = Apollo.MutationResult<RetryContractExtractionMutation>;
export type RetryContractExtractionMutationOptions = Apollo.BaseMutationOptions<RetryContractExtractionMutation, RetryContractExtractionMutationVariables>;
export const RetryInsuredMergeDriveDocument = gql`
    mutation RetryInsuredMergeDrive($eventId: String!) {
  retryInsuredMergeDrive(eventId: $eventId)
}
    `;
export type RetryInsuredMergeDriveMutationFn = Apollo.MutationFunction<RetryInsuredMergeDriveMutation, RetryInsuredMergeDriveMutationVariables>;

/**
 * __useRetryInsuredMergeDriveMutation__
 *
 * To run a mutation, you first call `useRetryInsuredMergeDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryInsuredMergeDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryInsuredMergeDriveMutation, { data, loading, error }] = useRetryInsuredMergeDriveMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useRetryInsuredMergeDriveMutation(baseOptions?: Apollo.MutationHookOptions<RetryInsuredMergeDriveMutation, RetryInsuredMergeDriveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryInsuredMergeDriveMutation, RetryInsuredMergeDriveMutationVariables>(RetryInsuredMergeDriveDocument, options);
      }
export type RetryInsuredMergeDriveMutationHookResult = ReturnType<typeof useRetryInsuredMergeDriveMutation>;
export type RetryInsuredMergeDriveMutationResult = Apollo.MutationResult<RetryInsuredMergeDriveMutation>;
export type RetryInsuredMergeDriveMutationOptions = Apollo.BaseMutationOptions<RetryInsuredMergeDriveMutation, RetryInsuredMergeDriveMutationVariables>;
export const SaveQuoteChangesDocument = gql`
    mutation SaveQuoteChanges($input: SaveVaveQuoteChangesInput!) {
  saveQuoteChanges(input: $input) {
    id
  }
}
    `;
export type SaveQuoteChangesMutationFn = Apollo.MutationFunction<SaveQuoteChangesMutation, SaveQuoteChangesMutationVariables>;

/**
 * __useSaveQuoteChangesMutation__
 *
 * To run a mutation, you first call `useSaveQuoteChangesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuoteChangesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuoteChangesMutation, { data, loading, error }] = useSaveQuoteChangesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuoteChangesMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuoteChangesMutation, SaveQuoteChangesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuoteChangesMutation, SaveQuoteChangesMutationVariables>(SaveQuoteChangesDocument, options);
      }
export type SaveQuoteChangesMutationHookResult = ReturnType<typeof useSaveQuoteChangesMutation>;
export type SaveQuoteChangesMutationResult = Apollo.MutationResult<SaveQuoteChangesMutation>;
export type SaveQuoteChangesMutationOptions = Apollo.BaseMutationOptions<SaveQuoteChangesMutation, SaveQuoteChangesMutationVariables>;
export const ScheduleSendInboxDraftDocument = gql`
    mutation ScheduleSendInboxDraft($input: ScheduleSendDraftInputDto!) {
  scheduleSendInboxDraft(input: $input) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type ScheduleSendInboxDraftMutationFn = Apollo.MutationFunction<ScheduleSendInboxDraftMutation, ScheduleSendInboxDraftMutationVariables>;

/**
 * __useScheduleSendInboxDraftMutation__
 *
 * To run a mutation, you first call `useScheduleSendInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleSendInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleSendInboxDraftMutation, { data, loading, error }] = useScheduleSendInboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleSendInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleSendInboxDraftMutation, ScheduleSendInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleSendInboxDraftMutation, ScheduleSendInboxDraftMutationVariables>(ScheduleSendInboxDraftDocument, options);
      }
export type ScheduleSendInboxDraftMutationHookResult = ReturnType<typeof useScheduleSendInboxDraftMutation>;
export type ScheduleSendInboxDraftMutationResult = Apollo.MutationResult<ScheduleSendInboxDraftMutation>;
export type ScheduleSendInboxDraftMutationOptions = Apollo.BaseMutationOptions<ScheduleSendInboxDraftMutation, ScheduleSendInboxDraftMutationVariables>;
export const SelectOpportunityCoveragesDocument = gql`
    mutation SelectOpportunityCoverages($input: OpportunitySelectCoveragesInput!) {
  selectOpportunityCoverages(input: $input) {
    id
    insuredId
  }
}
    `;
export type SelectOpportunityCoveragesMutationFn = Apollo.MutationFunction<SelectOpportunityCoveragesMutation, SelectOpportunityCoveragesMutationVariables>;

/**
 * __useSelectOpportunityCoveragesMutation__
 *
 * To run a mutation, you first call `useSelectOpportunityCoveragesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSelectOpportunityCoveragesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [selectOpportunityCoveragesMutation, { data, loading, error }] = useSelectOpportunityCoveragesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSelectOpportunityCoveragesMutation(baseOptions?: Apollo.MutationHookOptions<SelectOpportunityCoveragesMutation, SelectOpportunityCoveragesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SelectOpportunityCoveragesMutation, SelectOpportunityCoveragesMutationVariables>(SelectOpportunityCoveragesDocument, options);
      }
export type SelectOpportunityCoveragesMutationHookResult = ReturnType<typeof useSelectOpportunityCoveragesMutation>;
export type SelectOpportunityCoveragesMutationResult = Apollo.MutationResult<SelectOpportunityCoveragesMutation>;
export type SelectOpportunityCoveragesMutationOptions = Apollo.BaseMutationOptions<SelectOpportunityCoveragesMutation, SelectOpportunityCoveragesMutationVariables>;
export const SendBindRequestDocument = gql`
    mutation SendBindRequest($input: SendBindRequestInput!) {
  sendBindRequest(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;
export type SendBindRequestMutationFn = Apollo.MutationFunction<SendBindRequestMutation, SendBindRequestMutationVariables>;

/**
 * __useSendBindRequestMutation__
 *
 * To run a mutation, you first call `useSendBindRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendBindRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendBindRequestMutation, { data, loading, error }] = useSendBindRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendBindRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendBindRequestMutation, SendBindRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendBindRequestMutation, SendBindRequestMutationVariables>(SendBindRequestDocument, options);
      }
export type SendBindRequestMutationHookResult = ReturnType<typeof useSendBindRequestMutation>;
export type SendBindRequestMutationResult = Apollo.MutationResult<SendBindRequestMutation>;
export type SendBindRequestMutationOptions = Apollo.BaseMutationOptions<SendBindRequestMutation, SendBindRequestMutationVariables>;
export const SendInboxDraftDocument = gql`
    mutation SendInboxDraft($id: ID!) {
  sendInboxDraft(id: $id) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type SendInboxDraftMutationFn = Apollo.MutationFunction<SendInboxDraftMutation, SendInboxDraftMutationVariables>;

/**
 * __useSendInboxDraftMutation__
 *
 * To run a mutation, you first call `useSendInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInboxDraftMutation, { data, loading, error }] = useSendInboxDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<SendInboxDraftMutation, SendInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInboxDraftMutation, SendInboxDraftMutationVariables>(SendInboxDraftDocument, options);
      }
export type SendInboxDraftMutationHookResult = ReturnType<typeof useSendInboxDraftMutation>;
export type SendInboxDraftMutationResult = Apollo.MutationResult<SendInboxDraftMutation>;
export type SendInboxDraftMutationOptions = Apollo.BaseMutationOptions<SendInboxDraftMutation, SendInboxDraftMutationVariables>;
export const SendQuoteEmailDocument = gql`
    mutation SendQuoteEmail($input: SendQuoteInput!) {
  sendQuote(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;
export type SendQuoteEmailMutationFn = Apollo.MutationFunction<SendQuoteEmailMutation, SendQuoteEmailMutationVariables>;

/**
 * __useSendQuoteEmailMutation__
 *
 * To run a mutation, you first call `useSendQuoteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendQuoteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendQuoteEmailMutation, { data, loading, error }] = useSendQuoteEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendQuoteEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendQuoteEmailMutation, SendQuoteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendQuoteEmailMutation, SendQuoteEmailMutationVariables>(SendQuoteEmailDocument, options);
      }
export type SendQuoteEmailMutationHookResult = ReturnType<typeof useSendQuoteEmailMutation>;
export type SendQuoteEmailMutationResult = Apollo.MutationResult<SendQuoteEmailMutation>;
export type SendQuoteEmailMutationOptions = Apollo.BaseMutationOptions<SendQuoteEmailMutation, SendQuoteEmailMutationVariables>;
export const SendSubmissionToCarrierDocument = gql`
    mutation SendSubmissionToCarrier($input: SendSubmissionToCarrierInput!) {
  sendSubmissionToCarrier(input: $input) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}
${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;
export type SendSubmissionToCarrierMutationFn = Apollo.MutationFunction<SendSubmissionToCarrierMutation, SendSubmissionToCarrierMutationVariables>;

/**
 * __useSendSubmissionToCarrierMutation__
 *
 * To run a mutation, you first call `useSendSubmissionToCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubmissionToCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubmissionToCarrierMutation, { data, loading, error }] = useSendSubmissionToCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSubmissionToCarrierMutation(baseOptions?: Apollo.MutationHookOptions<SendSubmissionToCarrierMutation, SendSubmissionToCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSubmissionToCarrierMutation, SendSubmissionToCarrierMutationVariables>(SendSubmissionToCarrierDocument, options);
      }
export type SendSubmissionToCarrierMutationHookResult = ReturnType<typeof useSendSubmissionToCarrierMutation>;
export type SendSubmissionToCarrierMutationResult = Apollo.MutationResult<SendSubmissionToCarrierMutation>;
export type SendSubmissionToCarrierMutationOptions = Apollo.BaseMutationOptions<SendSubmissionToCarrierMutation, SendSubmissionToCarrierMutationVariables>;
export const SetInboxMessageClassificationDocument = gql`
    mutation SetInboxMessageClassification($input: SetMessageClassificationInput!) {
  setInboxMessageClassification(input: $input) {
    ...InboxMessage
  }
}
    ${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type SetInboxMessageClassificationMutationFn = Apollo.MutationFunction<SetInboxMessageClassificationMutation, SetInboxMessageClassificationMutationVariables>;

/**
 * __useSetInboxMessageClassificationMutation__
 *
 * To run a mutation, you first call `useSetInboxMessageClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInboxMessageClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInboxMessageClassificationMutation, { data, loading, error }] = useSetInboxMessageClassificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetInboxMessageClassificationMutation(baseOptions?: Apollo.MutationHookOptions<SetInboxMessageClassificationMutation, SetInboxMessageClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInboxMessageClassificationMutation, SetInboxMessageClassificationMutationVariables>(SetInboxMessageClassificationDocument, options);
      }
export type SetInboxMessageClassificationMutationHookResult = ReturnType<typeof useSetInboxMessageClassificationMutation>;
export type SetInboxMessageClassificationMutationResult = Apollo.MutationResult<SetInboxMessageClassificationMutation>;
export type SetInboxMessageClassificationMutationOptions = Apollo.BaseMutationOptions<SetInboxMessageClassificationMutation, SetInboxMessageClassificationMutationVariables>;
export const SetInspectionOrderedElsewhereDocument = gql`
    mutation SetInspectionOrderedElsewhere($input: SetInspectionOrderedElsewhereInput!) {
  setInspectionOrderedElsewhere(input: $input) {
    ...InspectionOrder
  }
}
    ${InspectionOrderFragmentDoc}`;
export type SetInspectionOrderedElsewhereMutationFn = Apollo.MutationFunction<SetInspectionOrderedElsewhereMutation, SetInspectionOrderedElsewhereMutationVariables>;

/**
 * __useSetInspectionOrderedElsewhereMutation__
 *
 * To run a mutation, you first call `useSetInspectionOrderedElsewhereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInspectionOrderedElsewhereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInspectionOrderedElsewhereMutation, { data, loading, error }] = useSetInspectionOrderedElsewhereMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetInspectionOrderedElsewhereMutation(baseOptions?: Apollo.MutationHookOptions<SetInspectionOrderedElsewhereMutation, SetInspectionOrderedElsewhereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetInspectionOrderedElsewhereMutation, SetInspectionOrderedElsewhereMutationVariables>(SetInspectionOrderedElsewhereDocument, options);
      }
export type SetInspectionOrderedElsewhereMutationHookResult = ReturnType<typeof useSetInspectionOrderedElsewhereMutation>;
export type SetInspectionOrderedElsewhereMutationResult = Apollo.MutationResult<SetInspectionOrderedElsewhereMutation>;
export type SetInspectionOrderedElsewhereMutationOptions = Apollo.BaseMutationOptions<SetInspectionOrderedElsewhereMutation, SetInspectionOrderedElsewhereMutationVariables>;
export const SetOpportunityCollaboratorsDocument = gql`
    mutation SetOpportunityCollaborators($input: SetOpportunityCollaboratorsInput!) {
  setOpportunityCollaborators(input: $input) {
    id
    collaborators {
      id
      firstName
      lastName
      email
      agency {
        id
        name
      }
    }
  }
}
    `;
export type SetOpportunityCollaboratorsMutationFn = Apollo.MutationFunction<SetOpportunityCollaboratorsMutation, SetOpportunityCollaboratorsMutationVariables>;

/**
 * __useSetOpportunityCollaboratorsMutation__
 *
 * To run a mutation, you first call `useSetOpportunityCollaboratorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOpportunityCollaboratorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOpportunityCollaboratorsMutation, { data, loading, error }] = useSetOpportunityCollaboratorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetOpportunityCollaboratorsMutation(baseOptions?: Apollo.MutationHookOptions<SetOpportunityCollaboratorsMutation, SetOpportunityCollaboratorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetOpportunityCollaboratorsMutation, SetOpportunityCollaboratorsMutationVariables>(SetOpportunityCollaboratorsDocument, options);
      }
export type SetOpportunityCollaboratorsMutationHookResult = ReturnType<typeof useSetOpportunityCollaboratorsMutation>;
export type SetOpportunityCollaboratorsMutationResult = Apollo.MutationResult<SetOpportunityCollaboratorsMutation>;
export type SetOpportunityCollaboratorsMutationOptions = Apollo.BaseMutationOptions<SetOpportunityCollaboratorsMutation, SetOpportunityCollaboratorsMutationVariables>;
export const SetPlaybookTriggerDocument = gql`
    mutation SetPlaybookTrigger($input: SetPlaybookTriggerInput!) {
  setPlaybookTrigger(input: $input) {
    ...PlaybookTrigger
  }
}
    ${PlaybookTriggerFragmentDoc}
${PlaybookFragmentDoc}`;
export type SetPlaybookTriggerMutationFn = Apollo.MutationFunction<SetPlaybookTriggerMutation, SetPlaybookTriggerMutationVariables>;

/**
 * __useSetPlaybookTriggerMutation__
 *
 * To run a mutation, you first call `useSetPlaybookTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlaybookTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlaybookTriggerMutation, { data, loading, error }] = useSetPlaybookTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPlaybookTriggerMutation(baseOptions?: Apollo.MutationHookOptions<SetPlaybookTriggerMutation, SetPlaybookTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlaybookTriggerMutation, SetPlaybookTriggerMutationVariables>(SetPlaybookTriggerDocument, options);
      }
export type SetPlaybookTriggerMutationHookResult = ReturnType<typeof useSetPlaybookTriggerMutation>;
export type SetPlaybookTriggerMutationResult = Apollo.MutationResult<SetPlaybookTriggerMutation>;
export type SetPlaybookTriggerMutationOptions = Apollo.BaseMutationOptions<SetPlaybookTriggerMutation, SetPlaybookTriggerMutationVariables>;
export const SetViewerInboxThreadReadStateDocument = gql`
    mutation SetViewerInboxThreadReadState($input: SetViewerThreadReadStateInput!) {
  setViewerInboxThreadReadState(input: $input)
}
    `;
export type SetViewerInboxThreadReadStateMutationFn = Apollo.MutationFunction<SetViewerInboxThreadReadStateMutation, SetViewerInboxThreadReadStateMutationVariables>;

/**
 * __useSetViewerInboxThreadReadStateMutation__
 *
 * To run a mutation, you first call `useSetViewerInboxThreadReadStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetViewerInboxThreadReadStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setViewerInboxThreadReadStateMutation, { data, loading, error }] = useSetViewerInboxThreadReadStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetViewerInboxThreadReadStateMutation(baseOptions?: Apollo.MutationHookOptions<SetViewerInboxThreadReadStateMutation, SetViewerInboxThreadReadStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetViewerInboxThreadReadStateMutation, SetViewerInboxThreadReadStateMutationVariables>(SetViewerInboxThreadReadStateDocument, options);
      }
export type SetViewerInboxThreadReadStateMutationHookResult = ReturnType<typeof useSetViewerInboxThreadReadStateMutation>;
export type SetViewerInboxThreadReadStateMutationResult = Apollo.MutationResult<SetViewerInboxThreadReadStateMutation>;
export type SetViewerInboxThreadReadStateMutationOptions = Apollo.BaseMutationOptions<SetViewerInboxThreadReadStateMutation, SetViewerInboxThreadReadStateMutationVariables>;
export const SnoozeOpportunityDocument = gql`
    mutation SnoozeOpportunity($input: SnoozeOpportunityInput!) {
  snoozeOpportunity(input: $input) {
    id
    state
    snoozeUntil
  }
}
    `;
export type SnoozeOpportunityMutationFn = Apollo.MutationFunction<SnoozeOpportunityMutation, SnoozeOpportunityMutationVariables>;

/**
 * __useSnoozeOpportunityMutation__
 *
 * To run a mutation, you first call `useSnoozeOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeOpportunityMutation, { data, loading, error }] = useSnoozeOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeOpportunityMutation, SnoozeOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeOpportunityMutation, SnoozeOpportunityMutationVariables>(SnoozeOpportunityDocument, options);
      }
export type SnoozeOpportunityMutationHookResult = ReturnType<typeof useSnoozeOpportunityMutation>;
export type SnoozeOpportunityMutationResult = Apollo.MutationResult<SnoozeOpportunityMutation>;
export type SnoozeOpportunityMutationOptions = Apollo.BaseMutationOptions<SnoozeOpportunityMutation, SnoozeOpportunityMutationVariables>;
export const StopImpersonatingUserDocument = gql`
    mutation StopImpersonatingUser($authClientId: String!, $impersonatorEmail: String!) {
  stopImpersonatingUser(
    authClientId: $authClientId
    impersonatorEmail: $impersonatorEmail
  ) {
    token {
      ...AuthToken
    }
    user {
      id
      firstName
      lastName
      email
      roles
      agency {
        id
        name
      }
    }
  }
}
    ${AuthTokenFragmentDoc}`;
export type StopImpersonatingUserMutationFn = Apollo.MutationFunction<StopImpersonatingUserMutation, StopImpersonatingUserMutationVariables>;

/**
 * __useStopImpersonatingUserMutation__
 *
 * To run a mutation, you first call `useStopImpersonatingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopImpersonatingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopImpersonatingUserMutation, { data, loading, error }] = useStopImpersonatingUserMutation({
 *   variables: {
 *      authClientId: // value for 'authClientId'
 *      impersonatorEmail: // value for 'impersonatorEmail'
 *   },
 * });
 */
export function useStopImpersonatingUserMutation(baseOptions?: Apollo.MutationHookOptions<StopImpersonatingUserMutation, StopImpersonatingUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopImpersonatingUserMutation, StopImpersonatingUserMutationVariables>(StopImpersonatingUserDocument, options);
      }
export type StopImpersonatingUserMutationHookResult = ReturnType<typeof useStopImpersonatingUserMutation>;
export type StopImpersonatingUserMutationResult = Apollo.MutationResult<StopImpersonatingUserMutation>;
export type StopImpersonatingUserMutationOptions = Apollo.BaseMutationOptions<StopImpersonatingUserMutation, StopImpersonatingUserMutationVariables>;
export const SubscribeToPlaybookDocument = gql`
    mutation SubscribeToPlaybook($playbookId: String!) {
  subscribeToPlaybook(playbookId: $playbookId)
}
    `;
export type SubscribeToPlaybookMutationFn = Apollo.MutationFunction<SubscribeToPlaybookMutation, SubscribeToPlaybookMutationVariables>;

/**
 * __useSubscribeToPlaybookMutation__
 *
 * To run a mutation, you first call `useSubscribeToPlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToPlaybookMutation, { data, loading, error }] = useSubscribeToPlaybookMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *   },
 * });
 */
export function useSubscribeToPlaybookMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToPlaybookMutation, SubscribeToPlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToPlaybookMutation, SubscribeToPlaybookMutationVariables>(SubscribeToPlaybookDocument, options);
      }
export type SubscribeToPlaybookMutationHookResult = ReturnType<typeof useSubscribeToPlaybookMutation>;
export type SubscribeToPlaybookMutationResult = Apollo.MutationResult<SubscribeToPlaybookMutation>;
export type SubscribeToPlaybookMutationOptions = Apollo.BaseMutationOptions<SubscribeToPlaybookMutation, SubscribeToPlaybookMutationVariables>;
export const SubscribeToPlaybookSetDocument = gql`
    mutation SubscribeToPlaybookSet($id: ID!) {
  subscribeToPlaybookSet(id: $id)
}
    `;
export type SubscribeToPlaybookSetMutationFn = Apollo.MutationFunction<SubscribeToPlaybookSetMutation, SubscribeToPlaybookSetMutationVariables>;

/**
 * __useSubscribeToPlaybookSetMutation__
 *
 * To run a mutation, you first call `useSubscribeToPlaybookSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToPlaybookSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToPlaybookSetMutation, { data, loading, error }] = useSubscribeToPlaybookSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscribeToPlaybookSetMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeToPlaybookSetMutation, SubscribeToPlaybookSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeToPlaybookSetMutation, SubscribeToPlaybookSetMutationVariables>(SubscribeToPlaybookSetDocument, options);
      }
export type SubscribeToPlaybookSetMutationHookResult = ReturnType<typeof useSubscribeToPlaybookSetMutation>;
export type SubscribeToPlaybookSetMutationResult = Apollo.MutationResult<SubscribeToPlaybookSetMutation>;
export type SubscribeToPlaybookSetMutationOptions = Apollo.BaseMutationOptions<SubscribeToPlaybookSetMutation, SubscribeToPlaybookSetMutationVariables>;
export const SyncBindHqAgenciesAndAgentsDocument = gql`
    mutation SyncBindHqAgenciesAndAgents {
  syncBindHqAgenciesAndAgents
}
    `;
export type SyncBindHqAgenciesAndAgentsMutationFn = Apollo.MutationFunction<SyncBindHqAgenciesAndAgentsMutation, SyncBindHqAgenciesAndAgentsMutationVariables>;

/**
 * __useSyncBindHqAgenciesAndAgentsMutation__
 *
 * To run a mutation, you first call `useSyncBindHqAgenciesAndAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBindHqAgenciesAndAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBindHqAgenciesAndAgentsMutation, { data, loading, error }] = useSyncBindHqAgenciesAndAgentsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncBindHqAgenciesAndAgentsMutation(baseOptions?: Apollo.MutationHookOptions<SyncBindHqAgenciesAndAgentsMutation, SyncBindHqAgenciesAndAgentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBindHqAgenciesAndAgentsMutation, SyncBindHqAgenciesAndAgentsMutationVariables>(SyncBindHqAgenciesAndAgentsDocument, options);
      }
export type SyncBindHqAgenciesAndAgentsMutationHookResult = ReturnType<typeof useSyncBindHqAgenciesAndAgentsMutation>;
export type SyncBindHqAgenciesAndAgentsMutationResult = Apollo.MutationResult<SyncBindHqAgenciesAndAgentsMutation>;
export type SyncBindHqAgenciesAndAgentsMutationOptions = Apollo.BaseMutationOptions<SyncBindHqAgenciesAndAgentsMutation, SyncBindHqAgenciesAndAgentsMutationVariables>;
export const SyncBindHqAgencyDocument = gql`
    mutation SyncBindHqAgency($id: String!) {
  syncBindHqAgency(id: $id)
}
    `;
export type SyncBindHqAgencyMutationFn = Apollo.MutationFunction<SyncBindHqAgencyMutation, SyncBindHqAgencyMutationVariables>;

/**
 * __useSyncBindHqAgencyMutation__
 *
 * To run a mutation, you first call `useSyncBindHqAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBindHqAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBindHqAgencyMutation, { data, loading, error }] = useSyncBindHqAgencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncBindHqAgencyMutation(baseOptions?: Apollo.MutationHookOptions<SyncBindHqAgencyMutation, SyncBindHqAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBindHqAgencyMutation, SyncBindHqAgencyMutationVariables>(SyncBindHqAgencyDocument, options);
      }
export type SyncBindHqAgencyMutationHookResult = ReturnType<typeof useSyncBindHqAgencyMutation>;
export type SyncBindHqAgencyMutationResult = Apollo.MutationResult<SyncBindHqAgencyMutation>;
export type SyncBindHqAgencyMutationOptions = Apollo.BaseMutationOptions<SyncBindHqAgencyMutation, SyncBindHqAgencyMutationVariables>;
export const SyncBindHqAgentDocument = gql`
    mutation SyncBindHqAgent($id: String!) {
  syncBindHqAgent(id: $id)
}
    `;
export type SyncBindHqAgentMutationFn = Apollo.MutationFunction<SyncBindHqAgentMutation, SyncBindHqAgentMutationVariables>;

/**
 * __useSyncBindHqAgentMutation__
 *
 * To run a mutation, you first call `useSyncBindHqAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBindHqAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBindHqAgentMutation, { data, loading, error }] = useSyncBindHqAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncBindHqAgentMutation(baseOptions?: Apollo.MutationHookOptions<SyncBindHqAgentMutation, SyncBindHqAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBindHqAgentMutation, SyncBindHqAgentMutationVariables>(SyncBindHqAgentDocument, options);
      }
export type SyncBindHqAgentMutationHookResult = ReturnType<typeof useSyncBindHqAgentMutation>;
export type SyncBindHqAgentMutationResult = Apollo.MutationResult<SyncBindHqAgentMutation>;
export type SyncBindHqAgentMutationOptions = Apollo.BaseMutationOptions<SyncBindHqAgentMutation, SyncBindHqAgentMutationVariables>;
export const SyncInboxDraftToExternalDraftDocument = gql`
    mutation SyncInboxDraftToExternalDraft($id: ID!) {
  syncInboxDraftToExternalDraft(id: $id) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type SyncInboxDraftToExternalDraftMutationFn = Apollo.MutationFunction<SyncInboxDraftToExternalDraftMutation, SyncInboxDraftToExternalDraftMutationVariables>;

/**
 * __useSyncInboxDraftToExternalDraftMutation__
 *
 * To run a mutation, you first call `useSyncInboxDraftToExternalDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncInboxDraftToExternalDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncInboxDraftToExternalDraftMutation, { data, loading, error }] = useSyncInboxDraftToExternalDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncInboxDraftToExternalDraftMutation(baseOptions?: Apollo.MutationHookOptions<SyncInboxDraftToExternalDraftMutation, SyncInboxDraftToExternalDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncInboxDraftToExternalDraftMutation, SyncInboxDraftToExternalDraftMutationVariables>(SyncInboxDraftToExternalDraftDocument, options);
      }
export type SyncInboxDraftToExternalDraftMutationHookResult = ReturnType<typeof useSyncInboxDraftToExternalDraftMutation>;
export type SyncInboxDraftToExternalDraftMutationResult = Apollo.MutationResult<SyncInboxDraftToExternalDraftMutation>;
export type SyncInboxDraftToExternalDraftMutationOptions = Apollo.BaseMutationOptions<SyncInboxDraftToExternalDraftMutation, SyncInboxDraftToExternalDraftMutationVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    id
    name
    description
    createdAt
    updatedAt
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation DeleteTeam($id: ID!) {
  deleteTeam(id: $id) {
    id
  }
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const AddTeamMemberDocument = gql`
    mutation AddTeamMember($teamId: String!, $userId: String!) {
  addTeamMember(teamId: $teamId, userId: $userId) {
    id
    name
    members {
      id
    }
  }
}
    `;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
      }
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>;
export const RemoveTeamMemberDocument = gql`
    mutation RemoveTeamMember($teamId: String!, $userId: String!) {
  removeTeamMember(teamId: $teamId, userId: $userId) {
    id
    name
    members {
      id
    }
  }
}
    `;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, options);
      }
export type RemoveTeamMemberMutationHookResult = ReturnType<typeof useRemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationResult = Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const TransitionMarketingPlanDocument = gql`
    mutation TransitionMarketingPlan($input: TransitionMarketingPlanInput!) {
  transitionMarketingPlan(input: $input) {
    id
  }
}
    `;
export type TransitionMarketingPlanMutationFn = Apollo.MutationFunction<TransitionMarketingPlanMutation, TransitionMarketingPlanMutationVariables>;

/**
 * __useTransitionMarketingPlanMutation__
 *
 * To run a mutation, you first call `useTransitionMarketingPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionMarketingPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionMarketingPlanMutation, { data, loading, error }] = useTransitionMarketingPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionMarketingPlanMutation(baseOptions?: Apollo.MutationHookOptions<TransitionMarketingPlanMutation, TransitionMarketingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransitionMarketingPlanMutation, TransitionMarketingPlanMutationVariables>(TransitionMarketingPlanDocument, options);
      }
export type TransitionMarketingPlanMutationHookResult = ReturnType<typeof useTransitionMarketingPlanMutation>;
export type TransitionMarketingPlanMutationResult = Apollo.MutationResult<TransitionMarketingPlanMutation>;
export type TransitionMarketingPlanMutationOptions = Apollo.BaseMutationOptions<TransitionMarketingPlanMutation, TransitionMarketingPlanMutationVariables>;
export const TransitionPolicyDocument = gql`
    mutation TransitionPolicy($input: TransitionPolicyInput!) {
  transitionPolicy(input: $input) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type TransitionPolicyMutationFn = Apollo.MutationFunction<TransitionPolicyMutation, TransitionPolicyMutationVariables>;

/**
 * __useTransitionPolicyMutation__
 *
 * To run a mutation, you first call `useTransitionPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionPolicyMutation, { data, loading, error }] = useTransitionPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionPolicyMutation(baseOptions?: Apollo.MutationHookOptions<TransitionPolicyMutation, TransitionPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransitionPolicyMutation, TransitionPolicyMutationVariables>(TransitionPolicyDocument, options);
      }
export type TransitionPolicyMutationHookResult = ReturnType<typeof useTransitionPolicyMutation>;
export type TransitionPolicyMutationResult = Apollo.MutationResult<TransitionPolicyMutation>;
export type TransitionPolicyMutationOptions = Apollo.BaseMutationOptions<TransitionPolicyMutation, TransitionPolicyMutationVariables>;
export const TransitionQuoteDocument = gql`
    mutation TransitionQuote($input: TransitionQuoteInput!) {
  transitionQuote(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;
export type TransitionQuoteMutationFn = Apollo.MutationFunction<TransitionQuoteMutation, TransitionQuoteMutationVariables>;

/**
 * __useTransitionQuoteMutation__
 *
 * To run a mutation, you first call `useTransitionQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionQuoteMutation, { data, loading, error }] = useTransitionQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionQuoteMutation(baseOptions?: Apollo.MutationHookOptions<TransitionQuoteMutation, TransitionQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransitionQuoteMutation, TransitionQuoteMutationVariables>(TransitionQuoteDocument, options);
      }
export type TransitionQuoteMutationHookResult = ReturnType<typeof useTransitionQuoteMutation>;
export type TransitionQuoteMutationResult = Apollo.MutationResult<TransitionQuoteMutation>;
export type TransitionQuoteMutationOptions = Apollo.BaseMutationOptions<TransitionQuoteMutation, TransitionQuoteMutationVariables>;
export const TransitionSubmissionDocument = gql`
    mutation TransitionSubmission($input: TransitionSubmissionInput!) {
  transitionSubmission(input: $input) {
    ...MarketingPlanSubmission
  }
}
    ${MarketingPlanSubmissionFragmentDoc}
${MarketingPlanAppetiteProductFragmentDoc}
${SlimAppetiteProductFragmentFragmentDoc}
${CarrierContactFragmentDoc}
${MarketingPlanQuoteFragmentDoc}
${MarketingPlanMarketSummaryNoteFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;
export type TransitionSubmissionMutationFn = Apollo.MutationFunction<TransitionSubmissionMutation, TransitionSubmissionMutationVariables>;

/**
 * __useTransitionSubmissionMutation__
 *
 * To run a mutation, you first call `useTransitionSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionSubmissionMutation, { data, loading, error }] = useTransitionSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransitionSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<TransitionSubmissionMutation, TransitionSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransitionSubmissionMutation, TransitionSubmissionMutationVariables>(TransitionSubmissionDocument, options);
      }
export type TransitionSubmissionMutationHookResult = ReturnType<typeof useTransitionSubmissionMutation>;
export type TransitionSubmissionMutationResult = Apollo.MutationResult<TransitionSubmissionMutation>;
export type TransitionSubmissionMutationOptions = Apollo.BaseMutationOptions<TransitionSubmissionMutation, TransitionSubmissionMutationVariables>;
export const TriggerPolicyExpirationCheckDocument = gql`
    mutation TriggerPolicyExpirationCheck {
  triggerPolicyExpirationCheck
}
    `;
export type TriggerPolicyExpirationCheckMutationFn = Apollo.MutationFunction<TriggerPolicyExpirationCheckMutation, TriggerPolicyExpirationCheckMutationVariables>;

/**
 * __useTriggerPolicyExpirationCheckMutation__
 *
 * To run a mutation, you first call `useTriggerPolicyExpirationCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerPolicyExpirationCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerPolicyExpirationCheckMutation, { data, loading, error }] = useTriggerPolicyExpirationCheckMutation({
 *   variables: {
 *   },
 * });
 */
export function useTriggerPolicyExpirationCheckMutation(baseOptions?: Apollo.MutationHookOptions<TriggerPolicyExpirationCheckMutation, TriggerPolicyExpirationCheckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TriggerPolicyExpirationCheckMutation, TriggerPolicyExpirationCheckMutationVariables>(TriggerPolicyExpirationCheckDocument, options);
      }
export type TriggerPolicyExpirationCheckMutationHookResult = ReturnType<typeof useTriggerPolicyExpirationCheckMutation>;
export type TriggerPolicyExpirationCheckMutationResult = Apollo.MutationResult<TriggerPolicyExpirationCheckMutation>;
export type TriggerPolicyExpirationCheckMutationOptions = Apollo.BaseMutationOptions<TriggerPolicyExpirationCheckMutation, TriggerPolicyExpirationCheckMutationVariables>;
export const UncompleteAgentActionDocument = gql`
    mutation UncompleteAgentAction($input: CompleteAgentActionInput!) {
  uncompleteAgentAction(input: $input) {
    id
  }
}
    `;
export type UncompleteAgentActionMutationFn = Apollo.MutationFunction<UncompleteAgentActionMutation, UncompleteAgentActionMutationVariables>;

/**
 * __useUncompleteAgentActionMutation__
 *
 * To run a mutation, you first call `useUncompleteAgentActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncompleteAgentActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncompleteAgentActionMutation, { data, loading, error }] = useUncompleteAgentActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUncompleteAgentActionMutation(baseOptions?: Apollo.MutationHookOptions<UncompleteAgentActionMutation, UncompleteAgentActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UncompleteAgentActionMutation, UncompleteAgentActionMutationVariables>(UncompleteAgentActionDocument, options);
      }
export type UncompleteAgentActionMutationHookResult = ReturnType<typeof useUncompleteAgentActionMutation>;
export type UncompleteAgentActionMutationResult = Apollo.MutationResult<UncompleteAgentActionMutation>;
export type UncompleteAgentActionMutationOptions = Apollo.BaseMutationOptions<UncompleteAgentActionMutation, UncompleteAgentActionMutationVariables>;
export const UndeleteOpportunityDocument = gql`
    mutation UndeleteOpportunity($id: ID!) {
  undeleteOpportunity(id: $id) {
    id
    state
    deletedAt
  }
}
    `;
export type UndeleteOpportunityMutationFn = Apollo.MutationFunction<UndeleteOpportunityMutation, UndeleteOpportunityMutationVariables>;

/**
 * __useUndeleteOpportunityMutation__
 *
 * To run a mutation, you first call `useUndeleteOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndeleteOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undeleteOpportunityMutation, { data, loading, error }] = useUndeleteOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUndeleteOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UndeleteOpportunityMutation, UndeleteOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndeleteOpportunityMutation, UndeleteOpportunityMutationVariables>(UndeleteOpportunityDocument, options);
      }
export type UndeleteOpportunityMutationHookResult = ReturnType<typeof useUndeleteOpportunityMutation>;
export type UndeleteOpportunityMutationResult = Apollo.MutationResult<UndeleteOpportunityMutation>;
export type UndeleteOpportunityMutationOptions = Apollo.BaseMutationOptions<UndeleteOpportunityMutation, UndeleteOpportunityMutationVariables>;
export const UnlinkConversationFromInsuredDocument = gql`
    mutation UnlinkConversationFromInsured($input: UnlinkConversationFromInsuredInput!) {
  unlinkConversationFromInsured(input: $input) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;
export type UnlinkConversationFromInsuredMutationFn = Apollo.MutationFunction<UnlinkConversationFromInsuredMutation, UnlinkConversationFromInsuredMutationVariables>;

/**
 * __useUnlinkConversationFromInsuredMutation__
 *
 * To run a mutation, you first call `useUnlinkConversationFromInsuredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkConversationFromInsuredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkConversationFromInsuredMutation, { data, loading, error }] = useUnlinkConversationFromInsuredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkConversationFromInsuredMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkConversationFromInsuredMutation, UnlinkConversationFromInsuredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkConversationFromInsuredMutation, UnlinkConversationFromInsuredMutationVariables>(UnlinkConversationFromInsuredDocument, options);
      }
export type UnlinkConversationFromInsuredMutationHookResult = ReturnType<typeof useUnlinkConversationFromInsuredMutation>;
export type UnlinkConversationFromInsuredMutationResult = Apollo.MutationResult<UnlinkConversationFromInsuredMutation>;
export type UnlinkConversationFromInsuredMutationOptions = Apollo.BaseMutationOptions<UnlinkConversationFromInsuredMutation, UnlinkConversationFromInsuredMutationVariables>;
export const UnlinkConversationFromOpportunityDocument = gql`
    mutation UnlinkConversationFromOpportunity($input: UnlinkConversationFromOpportunityInput!) {
  unlinkConversationFromOpportunity(input: $input) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;
export type UnlinkConversationFromOpportunityMutationFn = Apollo.MutationFunction<UnlinkConversationFromOpportunityMutation, UnlinkConversationFromOpportunityMutationVariables>;

/**
 * __useUnlinkConversationFromOpportunityMutation__
 *
 * To run a mutation, you first call `useUnlinkConversationFromOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkConversationFromOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkConversationFromOpportunityMutation, { data, loading, error }] = useUnlinkConversationFromOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkConversationFromOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkConversationFromOpportunityMutation, UnlinkConversationFromOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkConversationFromOpportunityMutation, UnlinkConversationFromOpportunityMutationVariables>(UnlinkConversationFromOpportunityDocument, options);
      }
export type UnlinkConversationFromOpportunityMutationHookResult = ReturnType<typeof useUnlinkConversationFromOpportunityMutation>;
export type UnlinkConversationFromOpportunityMutationResult = Apollo.MutationResult<UnlinkConversationFromOpportunityMutation>;
export type UnlinkConversationFromOpportunityMutationOptions = Apollo.BaseMutationOptions<UnlinkConversationFromOpportunityMutation, UnlinkConversationFromOpportunityMutationVariables>;
export const UnlinkConversationFromSubmissionDocument = gql`
    mutation UnlinkConversationFromSubmission($input: UnlinkConversationFromSubmissionInput!) {
  unlinkConversationFromSubmission(input: $input) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;
export type UnlinkConversationFromSubmissionMutationFn = Apollo.MutationFunction<UnlinkConversationFromSubmissionMutation, UnlinkConversationFromSubmissionMutationVariables>;

/**
 * __useUnlinkConversationFromSubmissionMutation__
 *
 * To run a mutation, you first call `useUnlinkConversationFromSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkConversationFromSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkConversationFromSubmissionMutation, { data, loading, error }] = useUnlinkConversationFromSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkConversationFromSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkConversationFromSubmissionMutation, UnlinkConversationFromSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkConversationFromSubmissionMutation, UnlinkConversationFromSubmissionMutationVariables>(UnlinkConversationFromSubmissionDocument, options);
      }
export type UnlinkConversationFromSubmissionMutationHookResult = ReturnType<typeof useUnlinkConversationFromSubmissionMutation>;
export type UnlinkConversationFromSubmissionMutationResult = Apollo.MutationResult<UnlinkConversationFromSubmissionMutation>;
export type UnlinkConversationFromSubmissionMutationOptions = Apollo.BaseMutationOptions<UnlinkConversationFromSubmissionMutation, UnlinkConversationFromSubmissionMutationVariables>;
export const UnscheduleSendInboxDraftDocument = gql`
    mutation UnscheduleSendInboxDraft($id: ID!) {
  unscheduleSendInboxDraft(id: $id) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type UnscheduleSendInboxDraftMutationFn = Apollo.MutationFunction<UnscheduleSendInboxDraftMutation, UnscheduleSendInboxDraftMutationVariables>;

/**
 * __useUnscheduleSendInboxDraftMutation__
 *
 * To run a mutation, you first call `useUnscheduleSendInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleSendInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleSendInboxDraftMutation, { data, loading, error }] = useUnscheduleSendInboxDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnscheduleSendInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleSendInboxDraftMutation, UnscheduleSendInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleSendInboxDraftMutation, UnscheduleSendInboxDraftMutationVariables>(UnscheduleSendInboxDraftDocument, options);
      }
export type UnscheduleSendInboxDraftMutationHookResult = ReturnType<typeof useUnscheduleSendInboxDraftMutation>;
export type UnscheduleSendInboxDraftMutationResult = Apollo.MutationResult<UnscheduleSendInboxDraftMutation>;
export type UnscheduleSendInboxDraftMutationOptions = Apollo.BaseMutationOptions<UnscheduleSendInboxDraftMutation, UnscheduleSendInboxDraftMutationVariables>;
export const UnsubscribeFromPlaybookDocument = gql`
    mutation UnsubscribeFromPlaybook($playbookId: String!) {
  unsubscribeFromPlaybook(playbookId: $playbookId)
}
    `;
export type UnsubscribeFromPlaybookMutationFn = Apollo.MutationFunction<UnsubscribeFromPlaybookMutation, UnsubscribeFromPlaybookMutationVariables>;

/**
 * __useUnsubscribeFromPlaybookMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromPlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromPlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromPlaybookMutation, { data, loading, error }] = useUnsubscribeFromPlaybookMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *   },
 * });
 */
export function useUnsubscribeFromPlaybookMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeFromPlaybookMutation, UnsubscribeFromPlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeFromPlaybookMutation, UnsubscribeFromPlaybookMutationVariables>(UnsubscribeFromPlaybookDocument, options);
      }
export type UnsubscribeFromPlaybookMutationHookResult = ReturnType<typeof useUnsubscribeFromPlaybookMutation>;
export type UnsubscribeFromPlaybookMutationResult = Apollo.MutationResult<UnsubscribeFromPlaybookMutation>;
export type UnsubscribeFromPlaybookMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromPlaybookMutation, UnsubscribeFromPlaybookMutationVariables>;
export const UnsubscribeFromPlaybookSetDocument = gql`
    mutation UnsubscribeFromPlaybookSet($id: ID!) {
  unsubscribeFromPlaybookSet(id: $id)
}
    `;
export type UnsubscribeFromPlaybookSetMutationFn = Apollo.MutationFunction<UnsubscribeFromPlaybookSetMutation, UnsubscribeFromPlaybookSetMutationVariables>;

/**
 * __useUnsubscribeFromPlaybookSetMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromPlaybookSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromPlaybookSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromPlaybookSetMutation, { data, loading, error }] = useUnsubscribeFromPlaybookSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsubscribeFromPlaybookSetMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeFromPlaybookSetMutation, UnsubscribeFromPlaybookSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeFromPlaybookSetMutation, UnsubscribeFromPlaybookSetMutationVariables>(UnsubscribeFromPlaybookSetDocument, options);
      }
export type UnsubscribeFromPlaybookSetMutationHookResult = ReturnType<typeof useUnsubscribeFromPlaybookSetMutation>;
export type UnsubscribeFromPlaybookSetMutationResult = Apollo.MutationResult<UnsubscribeFromPlaybookSetMutation>;
export type UnsubscribeFromPlaybookSetMutationOptions = Apollo.BaseMutationOptions<UnsubscribeFromPlaybookSetMutation, UnsubscribeFromPlaybookSetMutationVariables>;
export const UpdateAgencyDocument = gql`
    mutation UpdateAgency($input: UpdateAgencyInput!) {
  updateAgency(input: $input) {
    id
    name
    bindHqId
    isTest
    defaultSecondaryAgents {
      ...UserAccount
    }
  }
}
    ${UserAccountFragmentDoc}`;
export type UpdateAgencyMutationFn = Apollo.MutationFunction<UpdateAgencyMutation, UpdateAgencyMutationVariables>;

/**
 * __useUpdateAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyMutation, { data, loading, error }] = useUpdateAgencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyMutation, UpdateAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyMutation, UpdateAgencyMutationVariables>(UpdateAgencyDocument, options);
      }
export type UpdateAgencyMutationHookResult = ReturnType<typeof useUpdateAgencyMutation>;
export type UpdateAgencyMutationResult = Apollo.MutationResult<UpdateAgencyMutation>;
export type UpdateAgencyMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyMutation, UpdateAgencyMutationVariables>;
export const UpdateAgencyDefaultSecondaryAgentsDocument = gql`
    mutation UpdateAgencyDefaultSecondaryAgents($input: UpdateAgencyInput!) {
  updateAgency(input: $input) {
    id
    defaultSecondaryAgents {
      ...UserAccount
    }
  }
}
    ${UserAccountFragmentDoc}`;
export type UpdateAgencyDefaultSecondaryAgentsMutationFn = Apollo.MutationFunction<UpdateAgencyDefaultSecondaryAgentsMutation, UpdateAgencyDefaultSecondaryAgentsMutationVariables>;

/**
 * __useUpdateAgencyDefaultSecondaryAgentsMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyDefaultSecondaryAgentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyDefaultSecondaryAgentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyDefaultSecondaryAgentsMutation, { data, loading, error }] = useUpdateAgencyDefaultSecondaryAgentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyDefaultSecondaryAgentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyDefaultSecondaryAgentsMutation, UpdateAgencyDefaultSecondaryAgentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyDefaultSecondaryAgentsMutation, UpdateAgencyDefaultSecondaryAgentsMutationVariables>(UpdateAgencyDefaultSecondaryAgentsDocument, options);
      }
export type UpdateAgencyDefaultSecondaryAgentsMutationHookResult = ReturnType<typeof useUpdateAgencyDefaultSecondaryAgentsMutation>;
export type UpdateAgencyDefaultSecondaryAgentsMutationResult = Apollo.MutationResult<UpdateAgencyDefaultSecondaryAgentsMutation>;
export type UpdateAgencyDefaultSecondaryAgentsMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyDefaultSecondaryAgentsMutation, UpdateAgencyDefaultSecondaryAgentsMutationVariables>;
export const UpdateAgencyOwnerDocument = gql`
    mutation UpdateAgencyOwner($input: UpdateAgencyInput!) {
  updateAgency(input: $input) {
    id
    name
    isTest
    isPrivate
    owner {
      ...UserAccount
    }
  }
}
    ${UserAccountFragmentDoc}`;
export type UpdateAgencyOwnerMutationFn = Apollo.MutationFunction<UpdateAgencyOwnerMutation, UpdateAgencyOwnerMutationVariables>;

/**
 * __useUpdateAgencyOwnerMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyOwnerMutation, { data, loading, error }] = useUpdateAgencyOwnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyOwnerMutation, UpdateAgencyOwnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyOwnerMutation, UpdateAgencyOwnerMutationVariables>(UpdateAgencyOwnerDocument, options);
      }
export type UpdateAgencyOwnerMutationHookResult = ReturnType<typeof useUpdateAgencyOwnerMutation>;
export type UpdateAgencyOwnerMutationResult = Apollo.MutationResult<UpdateAgencyOwnerMutation>;
export type UpdateAgencyOwnerMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyOwnerMutation, UpdateAgencyOwnerMutationVariables>;
export const UpdateAppetiteProductDocument = gql`
    mutation UpdateAppetiteProduct($input: UpdateAppetiteProductInput!) {
  updateAppetiteProduct(input: $input) {
    ...AppetiteProduct
  }
}
    ${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type UpdateAppetiteProductMutationFn = Apollo.MutationFunction<UpdateAppetiteProductMutation, UpdateAppetiteProductMutationVariables>;

/**
 * __useUpdateAppetiteProductMutation__
 *
 * To run a mutation, you first call `useUpdateAppetiteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppetiteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppetiteProductMutation, { data, loading, error }] = useUpdateAppetiteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppetiteProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppetiteProductMutation, UpdateAppetiteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppetiteProductMutation, UpdateAppetiteProductMutationVariables>(UpdateAppetiteProductDocument, options);
      }
export type UpdateAppetiteProductMutationHookResult = ReturnType<typeof useUpdateAppetiteProductMutation>;
export type UpdateAppetiteProductMutationResult = Apollo.MutationResult<UpdateAppetiteProductMutation>;
export type UpdateAppetiteProductMutationOptions = Apollo.BaseMutationOptions<UpdateAppetiteProductMutation, UpdateAppetiteProductMutationVariables>;
export const UpdateBindHqAgencyDocument = gql`
    mutation UpdateBindHqAgency($input: UpdateBindHqAgencyInput!) {
  updateBindHqAgency(input: $input) {
    ...BindHqAgency
  }
}
    ${BindHqAgencyFragmentDoc}`;
export type UpdateBindHqAgencyMutationFn = Apollo.MutationFunction<UpdateBindHqAgencyMutation, UpdateBindHqAgencyMutationVariables>;

/**
 * __useUpdateBindHqAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateBindHqAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBindHqAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBindHqAgencyMutation, { data, loading, error }] = useUpdateBindHqAgencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBindHqAgencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBindHqAgencyMutation, UpdateBindHqAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBindHqAgencyMutation, UpdateBindHqAgencyMutationVariables>(UpdateBindHqAgencyDocument, options);
      }
export type UpdateBindHqAgencyMutationHookResult = ReturnType<typeof useUpdateBindHqAgencyMutation>;
export type UpdateBindHqAgencyMutationResult = Apollo.MutationResult<UpdateBindHqAgencyMutation>;
export type UpdateBindHqAgencyMutationOptions = Apollo.BaseMutationOptions<UpdateBindHqAgencyMutation, UpdateBindHqAgencyMutationVariables>;
export const UpdateCarrierDocument = gql`
    mutation UpdateCarrier($input: UpdateCarrierInput!) {
  updateCarrier(input: $input) {
    id
    url
    portalUrl
    qwAppointed
    phone
    fax
    email
    addressLine1
    addressLine2
    city
    state
    postalCode
  }
}
    `;
export type UpdateCarrierMutationFn = Apollo.MutationFunction<UpdateCarrierMutation, UpdateCarrierMutationVariables>;

/**
 * __useUpdateCarrierMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierMutation, { data, loading, error }] = useUpdateCarrierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarrierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierMutation, UpdateCarrierMutationVariables>(UpdateCarrierDocument, options);
      }
export type UpdateCarrierMutationHookResult = ReturnType<typeof useUpdateCarrierMutation>;
export type UpdateCarrierMutationResult = Apollo.MutationResult<UpdateCarrierMutation>;
export type UpdateCarrierMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierMutation, UpdateCarrierMutationVariables>;
export const UpdateCarrierContactDocument = gql`
    mutation UpdateCarrierContact($input: UpdateCarrierContactInput!) {
  updateCarrierContact(input: $input) {
    ...CarrierContact
  }
}
    ${CarrierContactFragmentDoc}`;
export type UpdateCarrierContactMutationFn = Apollo.MutationFunction<UpdateCarrierContactMutation, UpdateCarrierContactMutationVariables>;

/**
 * __useUpdateCarrierContactMutation__
 *
 * To run a mutation, you first call `useUpdateCarrierContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarrierContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarrierContactMutation, { data, loading, error }] = useUpdateCarrierContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCarrierContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarrierContactMutation, UpdateCarrierContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCarrierContactMutation, UpdateCarrierContactMutationVariables>(UpdateCarrierContactDocument, options);
      }
export type UpdateCarrierContactMutationHookResult = ReturnType<typeof useUpdateCarrierContactMutation>;
export type UpdateCarrierContactMutationResult = Apollo.MutationResult<UpdateCarrierContactMutation>;
export type UpdateCarrierContactMutationOptions = Apollo.BaseMutationOptions<UpdateCarrierContactMutation, UpdateCarrierContactMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($input: UpdateCommentInput!) {
  updateComment(input: $input) {
    ...OpportunityEvent
  }
}
    ${OpportunityEventFragmentDoc}
${UserCommentFragmentDoc}
${UserAccountFragmentDoc}
${AssignmentChangeEventFragmentDoc}
${CollaboratorsChangedEventFragmentDoc}
${TriageAssignmentEventFragmentDoc}
${EmailEventFragmentDoc}
${GmailMessageEventFragmentDoc}
${GmailMessageFragmentDoc}
${FileUploadFragmentDoc}
${GmailRelayEventFragmentDoc}
${FileUploadEventFragmentDoc}
${StatusChangeEventFragmentDoc}
${SubmissionStatusChangeEventFragmentDoc}
${CreatedEventFragmentDoc}
${OutcomeChangeEventFragmentDoc}
${DesiredEffectiveDateChangeEventFragmentDoc}
${ApplicationSubmittedEventFragmentDoc}
${ProductsAddedEventFragmentDoc}
${ProductsRemovedEventFragmentDoc}
${BotCommentEventFragmentDoc}
${AlbyUpdateEventFragmentDoc}
${AutomatedFollowUpEventFragmentDoc}
${ActionRequestedEventFragmentDoc}
${ActionApprovedEventFragmentDoc}
${ActionRejectedEventFragmentDoc}
${ActionDismissedEventFragmentDoc}
${CoveragesChangedEventFragmentDoc}
${BusinessClassCodesChangedEventFragmentDoc}
${RequirementAddedEventFragmentDoc}
${PolicyRenewabilityChangedEventFragmentDoc}
${AgencyTransferEventFragmentDoc}`;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateFileUploadTagsDocument = gql`
    mutation UpdateFileUploadTags($input: UpdateFileUploadTagInput!) {
  updateFileUploadTags(input: $input) {
    label
  }
}
    `;
export type UpdateFileUploadTagsMutationFn = Apollo.MutationFunction<UpdateFileUploadTagsMutation, UpdateFileUploadTagsMutationVariables>;

/**
 * __useUpdateFileUploadTagsMutation__
 *
 * To run a mutation, you first call `useUpdateFileUploadTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileUploadTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileUploadTagsMutation, { data, loading, error }] = useUpdateFileUploadTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileUploadTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileUploadTagsMutation, UpdateFileUploadTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileUploadTagsMutation, UpdateFileUploadTagsMutationVariables>(UpdateFileUploadTagsDocument, options);
      }
export type UpdateFileUploadTagsMutationHookResult = ReturnType<typeof useUpdateFileUploadTagsMutation>;
export type UpdateFileUploadTagsMutationResult = Apollo.MutationResult<UpdateFileUploadTagsMutation>;
export type UpdateFileUploadTagsMutationOptions = Apollo.BaseMutationOptions<UpdateFileUploadTagsMutation, UpdateFileUploadTagsMutationVariables>;
export const UpdateFileUploadDocument = gql`
    mutation UpdateFileUpload($input: UpdateFileUploadInput!) {
  updateFileUpload(input: $input) {
    id
  }
}
    `;
export type UpdateFileUploadMutationFn = Apollo.MutationFunction<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>;

/**
 * __useUpdateFileUploadMutation__
 *
 * To run a mutation, you first call `useUpdateFileUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileUploadMutation, { data, loading, error }] = useUpdateFileUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileUploadMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>(UpdateFileUploadDocument, options);
      }
export type UpdateFileUploadMutationHookResult = ReturnType<typeof useUpdateFileUploadMutation>;
export type UpdateFileUploadMutationResult = Apollo.MutationResult<UpdateFileUploadMutation>;
export type UpdateFileUploadMutationOptions = Apollo.BaseMutationOptions<UpdateFileUploadMutation, UpdateFileUploadMutationVariables>;
export const UpdateInboxDraftDocument = gql`
    mutation UpdateInboxDraft($input: UpdateDraftMessageInputDto!) {
  updateInboxDraft(input: $input) {
    ...DraftMessage
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type UpdateInboxDraftMutationFn = Apollo.MutationFunction<UpdateInboxDraftMutation, UpdateInboxDraftMutationVariables>;

/**
 * __useUpdateInboxDraftMutation__
 *
 * To run a mutation, you first call `useUpdateInboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInboxDraftMutation, { data, loading, error }] = useUpdateInboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInboxDraftMutation, UpdateInboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInboxDraftMutation, UpdateInboxDraftMutationVariables>(UpdateInboxDraftDocument, options);
      }
export type UpdateInboxDraftMutationHookResult = ReturnType<typeof useUpdateInboxDraftMutation>;
export type UpdateInboxDraftMutationResult = Apollo.MutationResult<UpdateInboxDraftMutation>;
export type UpdateInboxDraftMutationOptions = Apollo.BaseMutationOptions<UpdateInboxDraftMutation, UpdateInboxDraftMutationVariables>;
export const UpdateInboxMessageClassificationDocument = gql`
    mutation UpdateInboxMessageClassification($input: UpdateMessageClassificationInput!) {
  updateInboxMessageClassification(input: $input) {
    id
    label
    description
    autoRunPlaybook
    source
    associatedPlaybookId
    playbook {
      id
      name
    }
  }
}
    `;
export type UpdateInboxMessageClassificationMutationFn = Apollo.MutationFunction<UpdateInboxMessageClassificationMutation, UpdateInboxMessageClassificationMutationVariables>;

/**
 * __useUpdateInboxMessageClassificationMutation__
 *
 * To run a mutation, you first call `useUpdateInboxMessageClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInboxMessageClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInboxMessageClassificationMutation, { data, loading, error }] = useUpdateInboxMessageClassificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInboxMessageClassificationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInboxMessageClassificationMutation, UpdateInboxMessageClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInboxMessageClassificationMutation, UpdateInboxMessageClassificationMutationVariables>(UpdateInboxMessageClassificationDocument, options);
      }
export type UpdateInboxMessageClassificationMutationHookResult = ReturnType<typeof useUpdateInboxMessageClassificationMutation>;
export type UpdateInboxMessageClassificationMutationResult = Apollo.MutationResult<UpdateInboxMessageClassificationMutation>;
export type UpdateInboxMessageClassificationMutationOptions = Apollo.BaseMutationOptions<UpdateInboxMessageClassificationMutation, UpdateInboxMessageClassificationMutationVariables>;
export const UpdateInspectionPacketDocument = gql`
    mutation UpdateInspectionPacket($input: UpdateInspectionPacketInput!) {
  updateInspectionPacket(input: $input) {
    ...InspectionOrder
  }
}
    ${InspectionOrderFragmentDoc}`;
export type UpdateInspectionPacketMutationFn = Apollo.MutationFunction<UpdateInspectionPacketMutation, UpdateInspectionPacketMutationVariables>;

/**
 * __useUpdateInspectionPacketMutation__
 *
 * To run a mutation, you first call `useUpdateInspectionPacketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInspectionPacketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInspectionPacketMutation, { data, loading, error }] = useUpdateInspectionPacketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInspectionPacketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInspectionPacketMutation, UpdateInspectionPacketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInspectionPacketMutation, UpdateInspectionPacketMutationVariables>(UpdateInspectionPacketDocument, options);
      }
export type UpdateInspectionPacketMutationHookResult = ReturnType<typeof useUpdateInspectionPacketMutation>;
export type UpdateInspectionPacketMutationResult = Apollo.MutationResult<UpdateInspectionPacketMutation>;
export type UpdateInspectionPacketMutationOptions = Apollo.BaseMutationOptions<UpdateInspectionPacketMutation, UpdateInspectionPacketMutationVariables>;
export const UpdateInsuredDocument = gql`
    mutation UpdateInsured($input: UpdateInsuredInput!) {
  updateInsured(input: $input) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;
export type UpdateInsuredMutationFn = Apollo.MutationFunction<UpdateInsuredMutation, UpdateInsuredMutationVariables>;

/**
 * __useUpdateInsuredMutation__
 *
 * To run a mutation, you first call `useUpdateInsuredMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsuredMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsuredMutation, { data, loading, error }] = useUpdateInsuredMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInsuredMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsuredMutation, UpdateInsuredMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsuredMutation, UpdateInsuredMutationVariables>(UpdateInsuredDocument, options);
      }
export type UpdateInsuredMutationHookResult = ReturnType<typeof useUpdateInsuredMutation>;
export type UpdateInsuredMutationResult = Apollo.MutationResult<UpdateInsuredMutation>;
export type UpdateInsuredMutationOptions = Apollo.BaseMutationOptions<UpdateInsuredMutation, UpdateInsuredMutationVariables>;
export const UpdateOpportunityDocument = gql`
    mutation UpdateOpportunity($input: OpportunityUpdateInput!) {
  updateOpportunity(input: $input) {
    id
    state
    desiredEffectiveDate
  }
}
    `;
export type UpdateOpportunityMutationFn = Apollo.MutationFunction<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;

/**
 * __useUpdateOpportunityMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityMutation, { data, loading, error }] = useUpdateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>(UpdateOpportunityDocument, options);
      }
export type UpdateOpportunityMutationHookResult = ReturnType<typeof useUpdateOpportunityMutation>;
export type UpdateOpportunityMutationResult = Apollo.MutationResult<UpdateOpportunityMutation>;
export type UpdateOpportunityMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;
export const UpdatePlaybookDocument = gql`
    mutation UpdatePlaybook($id: String!, $input: UpdatePlaybookInput!) {
  updatePlaybook(id: $id, input: $input) {
    id
    name
    description
    workflow
    type
    parametersDescription
    templateParamSchema
    modelTier
    toolFilter {
      whitelist
      blacklist
    }
    updatedAt
  }
}
    `;
export type UpdatePlaybookMutationFn = Apollo.MutationFunction<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>;

/**
 * __useUpdatePlaybookMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookMutation, { data, loading, error }] = useUpdatePlaybookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaybookMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>(UpdatePlaybookDocument, options);
      }
export type UpdatePlaybookMutationHookResult = ReturnType<typeof useUpdatePlaybookMutation>;
export type UpdatePlaybookMutationResult = Apollo.MutationResult<UpdatePlaybookMutation>;
export type UpdatePlaybookMutationOptions = Apollo.BaseMutationOptions<UpdatePlaybookMutation, UpdatePlaybookMutationVariables>;
export const UpdatePlaybookSetDocument = gql`
    mutation UpdatePlaybookSet($id: ID!, $input: UpdatePlaybookSetInput!) {
  updatePlaybookSet(id: $id, input: $input) {
    ...PlaybookSet
  }
}
    ${PlaybookSetFragmentDoc}`;
export type UpdatePlaybookSetMutationFn = Apollo.MutationFunction<UpdatePlaybookSetMutation, UpdatePlaybookSetMutationVariables>;

/**
 * __useUpdatePlaybookSetMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookSetMutation, { data, loading, error }] = useUpdatePlaybookSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlaybookSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaybookSetMutation, UpdatePlaybookSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaybookSetMutation, UpdatePlaybookSetMutationVariables>(UpdatePlaybookSetDocument, options);
      }
export type UpdatePlaybookSetMutationHookResult = ReturnType<typeof useUpdatePlaybookSetMutation>;
export type UpdatePlaybookSetMutationResult = Apollo.MutationResult<UpdatePlaybookSetMutation>;
export type UpdatePlaybookSetMutationOptions = Apollo.BaseMutationOptions<UpdatePlaybookSetMutation, UpdatePlaybookSetMutationVariables>;
export const UpdatePlaybookSetsDocument = gql`
    mutation UpdatePlaybookSets($playbookId: String!, $setIds: [ID!]!) {
  updatePlaybookSets(playbookId: $playbookId, setIds: $setIds)
}
    `;
export type UpdatePlaybookSetsMutationFn = Apollo.MutationFunction<UpdatePlaybookSetsMutation, UpdatePlaybookSetsMutationVariables>;

/**
 * __useUpdatePlaybookSetsMutation__
 *
 * To run a mutation, you first call `useUpdatePlaybookSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlaybookSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlaybookSetsMutation, { data, loading, error }] = useUpdatePlaybookSetsMutation({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *      setIds: // value for 'setIds'
 *   },
 * });
 */
export function useUpdatePlaybookSetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlaybookSetsMutation, UpdatePlaybookSetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlaybookSetsMutation, UpdatePlaybookSetsMutationVariables>(UpdatePlaybookSetsDocument, options);
      }
export type UpdatePlaybookSetsMutationHookResult = ReturnType<typeof useUpdatePlaybookSetsMutation>;
export type UpdatePlaybookSetsMutationResult = Apollo.MutationResult<UpdatePlaybookSetsMutation>;
export type UpdatePlaybookSetsMutationOptions = Apollo.BaseMutationOptions<UpdatePlaybookSetsMutation, UpdatePlaybookSetsMutationVariables>;
export const UpdatePolicyDocument = gql`
    mutation UpdatePolicy($input: UpdatePolicyInput!) {
  updatePolicy(input: $input) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;
export type UpdatePolicyMutationFn = Apollo.MutationFunction<UpdatePolicyMutation, UpdatePolicyMutationVariables>;

/**
 * __useUpdatePolicyMutation__
 *
 * To run a mutation, you first call `useUpdatePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePolicyMutation, { data, loading, error }] = useUpdatePolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePolicyMutation, UpdatePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePolicyMutation, UpdatePolicyMutationVariables>(UpdatePolicyDocument, options);
      }
export type UpdatePolicyMutationHookResult = ReturnType<typeof useUpdatePolicyMutation>;
export type UpdatePolicyMutationResult = Apollo.MutationResult<UpdatePolicyMutation>;
export type UpdatePolicyMutationOptions = Apollo.BaseMutationOptions<UpdatePolicyMutation, UpdatePolicyMutationVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: ID!, $input: UpdateProductInput!) {
  updateProduct(id: $id, input: $input) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProductExclusionDocument = gql`
    mutation UpdateProductExclusion($input: ProductExclusionUpdateInput!) {
  productExclusionUpdate(input: $input) {
    id
  }
}
    `;
export type UpdateProductExclusionMutationFn = Apollo.MutationFunction<UpdateProductExclusionMutation, UpdateProductExclusionMutationVariables>;

/**
 * __useUpdateProductExclusionMutation__
 *
 * To run a mutation, you first call `useUpdateProductExclusionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductExclusionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductExclusionMutation, { data, loading, error }] = useUpdateProductExclusionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductExclusionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductExclusionMutation, UpdateProductExclusionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductExclusionMutation, UpdateProductExclusionMutationVariables>(UpdateProductExclusionDocument, options);
      }
export type UpdateProductExclusionMutationHookResult = ReturnType<typeof useUpdateProductExclusionMutation>;
export type UpdateProductExclusionMutationResult = Apollo.MutationResult<UpdateProductExclusionMutation>;
export type UpdateProductExclusionMutationOptions = Apollo.BaseMutationOptions<UpdateProductExclusionMutation, UpdateProductExclusionMutationVariables>;
export const UpdateRenewalNoteDocument = gql`
    mutation UpdateRenewalNote($input: UpdateRenewalNoteInput!) {
  updateRenewalNote(input: $input) {
    ...RenewalNote
  }
}
    ${RenewalNoteFragmentDoc}`;
export type UpdateRenewalNoteMutationFn = Apollo.MutationFunction<UpdateRenewalNoteMutation, UpdateRenewalNoteMutationVariables>;

/**
 * __useUpdateRenewalNoteMutation__
 *
 * To run a mutation, you first call `useUpdateRenewalNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRenewalNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRenewalNoteMutation, { data, loading, error }] = useUpdateRenewalNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRenewalNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRenewalNoteMutation, UpdateRenewalNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRenewalNoteMutation, UpdateRenewalNoteMutationVariables>(UpdateRenewalNoteDocument, options);
      }
export type UpdateRenewalNoteMutationHookResult = ReturnType<typeof useUpdateRenewalNoteMutation>;
export type UpdateRenewalNoteMutationResult = Apollo.MutationResult<UpdateRenewalNoteMutation>;
export type UpdateRenewalNoteMutationOptions = Apollo.BaseMutationOptions<UpdateRenewalNoteMutation, UpdateRenewalNoteMutationVariables>;
export const UpdateRenewalStatusDocument = gql`
    mutation UpdateRenewalStatus($input: UpdateRenewalStatusInput!) {
  updateRenewalStatus(input: $input) {
    status
    updatedAt
    latestLog {
      id
      previousStatus
      newStatus
      createdAt
    }
  }
}
    `;
export type UpdateRenewalStatusMutationFn = Apollo.MutationFunction<UpdateRenewalStatusMutation, UpdateRenewalStatusMutationVariables>;

/**
 * __useUpdateRenewalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRenewalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRenewalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRenewalStatusMutation, { data, loading, error }] = useUpdateRenewalStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRenewalStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRenewalStatusMutation, UpdateRenewalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRenewalStatusMutation, UpdateRenewalStatusMutationVariables>(UpdateRenewalStatusDocument, options);
      }
export type UpdateRenewalStatusMutationHookResult = ReturnType<typeof useUpdateRenewalStatusMutation>;
export type UpdateRenewalStatusMutationResult = Apollo.MutationResult<UpdateRenewalStatusMutation>;
export type UpdateRenewalStatusMutationOptions = Apollo.BaseMutationOptions<UpdateRenewalStatusMutation, UpdateRenewalStatusMutationVariables>;
export const UpdateSubmissionDocument = gql`
    mutation UpdateSubmission($input: UpdateSubmissionInput!) {
  updateSubmission(input: $input) {
    id
  }
}
    `;
export type UpdateSubmissionMutationFn = Apollo.MutationFunction<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;

/**
 * __useUpdateSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubmissionMutation, { data, loading, error }] = useUpdateSubmissionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>(UpdateSubmissionDocument, options);
      }
export type UpdateSubmissionMutationHookResult = ReturnType<typeof useUpdateSubmissionMutation>;
export type UpdateSubmissionMutationResult = Apollo.MutationResult<UpdateSubmissionMutation>;
export type UpdateSubmissionMutationOptions = Apollo.BaseMutationOptions<UpdateSubmissionMutation, UpdateSubmissionMutationVariables>;
export const UpdateFileTagDocument = gql`
    mutation UpdateFileTag($input: UpdateTagInput!) {
  updateFileTag(input: $input) {
    label
  }
}
    `;
export type UpdateFileTagMutationFn = Apollo.MutationFunction<UpdateFileTagMutation, UpdateFileTagMutationVariables>;

/**
 * __useUpdateFileTagMutation__
 *
 * To run a mutation, you first call `useUpdateFileTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileTagMutation, { data, loading, error }] = useUpdateFileTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFileTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileTagMutation, UpdateFileTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileTagMutation, UpdateFileTagMutationVariables>(UpdateFileTagDocument, options);
      }
export type UpdateFileTagMutationHookResult = ReturnType<typeof useUpdateFileTagMutation>;
export type UpdateFileTagMutationResult = Apollo.MutationResult<UpdateFileTagMutation>;
export type UpdateFileTagMutationOptions = Apollo.BaseMutationOptions<UpdateFileTagMutation, UpdateFileTagMutationVariables>;
export const UpdateTagsFindAndReplaceDocument = gql`
    mutation UpdateTagsFindAndReplace($input: UpdateTagsInput!) {
  updateTagsFindAndReplace(input: $input) {
    label
  }
}
    `;
export type UpdateTagsFindAndReplaceMutationFn = Apollo.MutationFunction<UpdateTagsFindAndReplaceMutation, UpdateTagsFindAndReplaceMutationVariables>;

/**
 * __useUpdateTagsFindAndReplaceMutation__
 *
 * To run a mutation, you first call `useUpdateTagsFindAndReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsFindAndReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsFindAndReplaceMutation, { data, loading, error }] = useUpdateTagsFindAndReplaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagsFindAndReplaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagsFindAndReplaceMutation, UpdateTagsFindAndReplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagsFindAndReplaceMutation, UpdateTagsFindAndReplaceMutationVariables>(UpdateTagsFindAndReplaceDocument, options);
      }
export type UpdateTagsFindAndReplaceMutationHookResult = ReturnType<typeof useUpdateTagsFindAndReplaceMutation>;
export type UpdateTagsFindAndReplaceMutationResult = Apollo.MutationResult<UpdateTagsFindAndReplaceMutation>;
export type UpdateTagsFindAndReplaceMutationOptions = Apollo.BaseMutationOptions<UpdateTagsFindAndReplaceMutation, UpdateTagsFindAndReplaceMutationVariables>;
export const UpdateTagsParentDocument = gql`
    mutation UpdateTagsParent($input: UpdateTagsInput!) {
  updateTagsParent(input: $input) {
    label
    parentTags {
      label
    }
  }
}
    `;
export type UpdateTagsParentMutationFn = Apollo.MutationFunction<UpdateTagsParentMutation, UpdateTagsParentMutationVariables>;

/**
 * __useUpdateTagsParentMutation__
 *
 * To run a mutation, you first call `useUpdateTagsParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagsParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagsParentMutation, { data, loading, error }] = useUpdateTagsParentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagsParentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagsParentMutation, UpdateTagsParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagsParentMutation, UpdateTagsParentMutationVariables>(UpdateTagsParentDocument, options);
      }
export type UpdateTagsParentMutationHookResult = ReturnType<typeof useUpdateTagsParentMutation>;
export type UpdateTagsParentMutationResult = Apollo.MutationResult<UpdateTagsParentMutation>;
export type UpdateTagsParentMutationOptions = Apollo.BaseMutationOptions<UpdateTagsParentMutation, UpdateTagsParentMutationVariables>;
export const UpdateUserAccountDocument = gql`
    mutation UpdateUserAccount($id: String!, $input: UserAccountUpdateInput!) {
  updateUserAccount(id: $id, input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;
export type UpdateUserAccountMutationFn = Apollo.MutationFunction<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;

/**
 * __useUpdateUserAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserAccountMutation, { data, loading, error }] = useUpdateUserAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>(UpdateUserAccountDocument, options);
      }
export type UpdateUserAccountMutationHookResult = ReturnType<typeof useUpdateUserAccountMutation>;
export type UpdateUserAccountMutationResult = Apollo.MutationResult<UpdateUserAccountMutation>;
export type UpdateUserAccountMutationOptions = Apollo.BaseMutationOptions<UpdateUserAccountMutation, UpdateUserAccountMutationVariables>;
export const UploadCarrierContractDocument = gql`
    mutation UploadCarrierContract($input: UploadCarrierContractInput!) {
  uploadCarrierContract(input: $input) {
    id
    carrierId
    fileUploadId
    extractionStatus
    appetiteProductIds
    createdAt
    fileUpload {
      id
      filename
      mimeType
      size
      createdAt
    }
    incentives {
      id
      incentiveType
      summary
      details
      appetiteProductId
      sortOrder
    }
  }
}
    `;
export type UploadCarrierContractMutationFn = Apollo.MutationFunction<UploadCarrierContractMutation, UploadCarrierContractMutationVariables>;

/**
 * __useUploadCarrierContractMutation__
 *
 * To run a mutation, you first call `useUploadCarrierContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCarrierContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCarrierContractMutation, { data, loading, error }] = useUploadCarrierContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCarrierContractMutation(baseOptions?: Apollo.MutationHookOptions<UploadCarrierContractMutation, UploadCarrierContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCarrierContractMutation, UploadCarrierContractMutationVariables>(UploadCarrierContractDocument, options);
      }
export type UploadCarrierContractMutationHookResult = ReturnType<typeof useUploadCarrierContractMutation>;
export type UploadCarrierContractMutationResult = Apollo.MutationResult<UploadCarrierContractMutation>;
export type UploadCarrierContractMutationOptions = Apollo.BaseMutationOptions<UploadCarrierContractMutation, UploadCarrierContractMutationVariables>;
export const AdminAccountsDocument = gql`
    query AdminAccounts($input: UserAccountFindManyFilter! = {roles: [Admin]}) {
  userAccounts(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useAdminAccountsQuery__
 *
 * To run a query within a React component, call `useAdminAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AdminAccountsQuery, AdminAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminAccountsQuery, AdminAccountsQueryVariables>(AdminAccountsDocument, options);
      }
export function useAdminAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminAccountsQuery, AdminAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminAccountsQuery, AdminAccountsQueryVariables>(AdminAccountsDocument, options);
        }
export type AdminAccountsQueryHookResult = ReturnType<typeof useAdminAccountsQuery>;
export type AdminAccountsLazyQueryHookResult = ReturnType<typeof useAdminAccountsLazyQuery>;
export type AdminAccountsQueryResult = Apollo.QueryResult<AdminAccountsQuery, AdminAccountsQueryVariables>;
export const AgenciesDocument = gql`
    query Agencies {
  agencies {
    ...Agency
  }
}
    ${AgencyFragmentDoc}`;

/**
 * __useAgenciesQuery__
 *
 * To run a query within a React component, call `useAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgenciesQuery(baseOptions?: Apollo.QueryHookOptions<AgenciesQuery, AgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgenciesQuery, AgenciesQueryVariables>(AgenciesDocument, options);
      }
export function useAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgenciesQuery, AgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgenciesQuery, AgenciesQueryVariables>(AgenciesDocument, options);
        }
export type AgenciesQueryHookResult = ReturnType<typeof useAgenciesQuery>;
export type AgenciesLazyQueryHookResult = ReturnType<typeof useAgenciesLazyQuery>;
export type AgenciesQueryResult = Apollo.QueryResult<AgenciesQuery, AgenciesQueryVariables>;
export const AgenciesWithOwnerDocument = gql`
    query AgenciesWithOwner {
  agencies {
    ...Agency
    owner {
      ...UserAccount
    }
  }
}
    ${AgencyFragmentDoc}
${UserAccountFragmentDoc}`;

/**
 * __useAgenciesWithOwnerQuery__
 *
 * To run a query within a React component, call `useAgenciesWithOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgenciesWithOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgenciesWithOwnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgenciesWithOwnerQuery(baseOptions?: Apollo.QueryHookOptions<AgenciesWithOwnerQuery, AgenciesWithOwnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgenciesWithOwnerQuery, AgenciesWithOwnerQueryVariables>(AgenciesWithOwnerDocument, options);
      }
export function useAgenciesWithOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgenciesWithOwnerQuery, AgenciesWithOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgenciesWithOwnerQuery, AgenciesWithOwnerQueryVariables>(AgenciesWithOwnerDocument, options);
        }
export type AgenciesWithOwnerQueryHookResult = ReturnType<typeof useAgenciesWithOwnerQuery>;
export type AgenciesWithOwnerLazyQueryHookResult = ReturnType<typeof useAgenciesWithOwnerLazyQuery>;
export type AgenciesWithOwnerQueryResult = Apollo.QueryResult<AgenciesWithOwnerQuery, AgenciesWithOwnerQueryVariables>;
export const AgencyDocument = gql`
    query Agency($id: ID!) {
  agency(id: $id) {
    ...Agency
    owner {
      id
      firstName
      lastName
    }
  }
}
    ${AgencyFragmentDoc}`;

/**
 * __useAgencyQuery__
 *
 * To run a query within a React component, call `useAgencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgencyQuery(baseOptions: Apollo.QueryHookOptions<AgencyQuery, AgencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyQuery, AgencyQueryVariables>(AgencyDocument, options);
      }
export function useAgencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyQuery, AgencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyQuery, AgencyQueryVariables>(AgencyDocument, options);
        }
export type AgencyQueryHookResult = ReturnType<typeof useAgencyQuery>;
export type AgencyLazyQueryHookResult = ReturnType<typeof useAgencyLazyQuery>;
export type AgencyQueryResult = Apollo.QueryResult<AgencyQuery, AgencyQueryVariables>;
export const AgencyAccountsDocument = gql`
    query AgencyAccounts($input: UserAccountFindManyFilter!) {
  agencyAccounts(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useAgencyAccountsQuery__
 *
 * To run a query within a React component, call `useAgencyAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgencyAccountsQuery(baseOptions: Apollo.QueryHookOptions<AgencyAccountsQuery, AgencyAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyAccountsQuery, AgencyAccountsQueryVariables>(AgencyAccountsDocument, options);
      }
export function useAgencyAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyAccountsQuery, AgencyAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyAccountsQuery, AgencyAccountsQueryVariables>(AgencyAccountsDocument, options);
        }
export type AgencyAccountsQueryHookResult = ReturnType<typeof useAgencyAccountsQuery>;
export type AgencyAccountsLazyQueryHookResult = ReturnType<typeof useAgencyAccountsLazyQuery>;
export type AgencyAccountsQueryResult = Apollo.QueryResult<AgencyAccountsQuery, AgencyAccountsQueryVariables>;
export const AgencyAffiliationDocument = gql`
    query AgencyAffiliation($id: ID!) {
  agency(id: $id) {
    ...Agency
    affiliations {
      ...AgencyAffiliation
    }
  }
}
    ${AgencyFragmentDoc}
${AgencyAffiliationFragmentDoc}`;

/**
 * __useAgencyAffiliationQuery__
 *
 * To run a query within a React component, call `useAgencyAffiliationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyAffiliationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyAffiliationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgencyAffiliationQuery(baseOptions: Apollo.QueryHookOptions<AgencyAffiliationQuery, AgencyAffiliationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyAffiliationQuery, AgencyAffiliationQueryVariables>(AgencyAffiliationDocument, options);
      }
export function useAgencyAffiliationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyAffiliationQuery, AgencyAffiliationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyAffiliationQuery, AgencyAffiliationQueryVariables>(AgencyAffiliationDocument, options);
        }
export type AgencyAffiliationQueryHookResult = ReturnType<typeof useAgencyAffiliationQuery>;
export type AgencyAffiliationLazyQueryHookResult = ReturnType<typeof useAgencyAffiliationLazyQuery>;
export type AgencyAffiliationQueryResult = Apollo.QueryResult<AgencyAffiliationQuery, AgencyAffiliationQueryVariables>;
export const AgencyAppointmentsDocument = gql`
    query AgencyAppointments($agencyId: String!) {
  agencyAppointments(agencyId: $agencyId) {
    id
    agencyId
    carrierSlug
  }
}
    `;

/**
 * __useAgencyAppointmentsQuery__
 *
 * To run a query within a React component, call `useAgencyAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyAppointmentsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useAgencyAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<AgencyAppointmentsQuery, AgencyAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyAppointmentsQuery, AgencyAppointmentsQueryVariables>(AgencyAppointmentsDocument, options);
      }
export function useAgencyAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyAppointmentsQuery, AgencyAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyAppointmentsQuery, AgencyAppointmentsQueryVariables>(AgencyAppointmentsDocument, options);
        }
export type AgencyAppointmentsQueryHookResult = ReturnType<typeof useAgencyAppointmentsQuery>;
export type AgencyAppointmentsLazyQueryHookResult = ReturnType<typeof useAgencyAppointmentsLazyQuery>;
export type AgencyAppointmentsQueryResult = Apollo.QueryResult<AgencyAppointmentsQuery, AgencyAppointmentsQueryVariables>;
export const AgencyOwnersDocument = gql`
    query AgencyOwners {
  agencyOwners {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useAgencyOwnersQuery__
 *
 * To run a query within a React component, call `useAgencyOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyOwnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgencyOwnersQuery(baseOptions?: Apollo.QueryHookOptions<AgencyOwnersQuery, AgencyOwnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyOwnersQuery, AgencyOwnersQueryVariables>(AgencyOwnersDocument, options);
      }
export function useAgencyOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyOwnersQuery, AgencyOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyOwnersQuery, AgencyOwnersQueryVariables>(AgencyOwnersDocument, options);
        }
export type AgencyOwnersQueryHookResult = ReturnType<typeof useAgencyOwnersQuery>;
export type AgencyOwnersLazyQueryHookResult = ReturnType<typeof useAgencyOwnersLazyQuery>;
export type AgencyOwnersQueryResult = Apollo.QueryResult<AgencyOwnersQuery, AgencyOwnersQueryVariables>;
export const AgencyWithDefaultSecondaryAgentsDocument = gql`
    query AgencyWithDefaultSecondaryAgents($id: ID!) {
  agency(id: $id) {
    ...Agency
    defaultSecondaryAgents {
      ...UserAccount
    }
  }
}
    ${AgencyFragmentDoc}
${UserAccountFragmentDoc}`;

/**
 * __useAgencyWithDefaultSecondaryAgentsQuery__
 *
 * To run a query within a React component, call `useAgencyWithDefaultSecondaryAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgencyWithDefaultSecondaryAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgencyWithDefaultSecondaryAgentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgencyWithDefaultSecondaryAgentsQuery(baseOptions: Apollo.QueryHookOptions<AgencyWithDefaultSecondaryAgentsQuery, AgencyWithDefaultSecondaryAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgencyWithDefaultSecondaryAgentsQuery, AgencyWithDefaultSecondaryAgentsQueryVariables>(AgencyWithDefaultSecondaryAgentsDocument, options);
      }
export function useAgencyWithDefaultSecondaryAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgencyWithDefaultSecondaryAgentsQuery, AgencyWithDefaultSecondaryAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgencyWithDefaultSecondaryAgentsQuery, AgencyWithDefaultSecondaryAgentsQueryVariables>(AgencyWithDefaultSecondaryAgentsDocument, options);
        }
export type AgencyWithDefaultSecondaryAgentsQueryHookResult = ReturnType<typeof useAgencyWithDefaultSecondaryAgentsQuery>;
export type AgencyWithDefaultSecondaryAgentsLazyQueryHookResult = ReturnType<typeof useAgencyWithDefaultSecondaryAgentsLazyQuery>;
export type AgencyWithDefaultSecondaryAgentsQueryResult = Apollo.QueryResult<AgencyWithDefaultSecondaryAgentsQuery, AgencyWithDefaultSecondaryAgentsQueryVariables>;
export const AgentAccountsDocument = gql`
    query AgentAccounts($input: UserAccountFindManyFilter! = {roles: [Agent]}) {
  userAccounts(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useAgentAccountsQuery__
 *
 * To run a query within a React component, call `useAgentAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgentAccountsQuery(baseOptions?: Apollo.QueryHookOptions<AgentAccountsQuery, AgentAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentAccountsQuery, AgentAccountsQueryVariables>(AgentAccountsDocument, options);
      }
export function useAgentAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentAccountsQuery, AgentAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentAccountsQuery, AgentAccountsQueryVariables>(AgentAccountsDocument, options);
        }
export type AgentAccountsQueryHookResult = ReturnType<typeof useAgentAccountsQuery>;
export type AgentAccountsLazyQueryHookResult = ReturnType<typeof useAgentAccountsLazyQuery>;
export type AgentAccountsQueryResult = Apollo.QueryResult<AgentAccountsQuery, AgentAccountsQueryVariables>;
export const AgentActionTitlesDocument = gql`
    query AgentActionTitles($actionType: String!) {
  agentActionTitles(actionType: $actionType)
}
    `;

/**
 * __useAgentActionTitlesQuery__
 *
 * To run a query within a React component, call `useAgentActionTitlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentActionTitlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentActionTitlesQuery({
 *   variables: {
 *      actionType: // value for 'actionType'
 *   },
 * });
 */
export function useAgentActionTitlesQuery(baseOptions: Apollo.QueryHookOptions<AgentActionTitlesQuery, AgentActionTitlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentActionTitlesQuery, AgentActionTitlesQueryVariables>(AgentActionTitlesDocument, options);
      }
export function useAgentActionTitlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentActionTitlesQuery, AgentActionTitlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentActionTitlesQuery, AgentActionTitlesQueryVariables>(AgentActionTitlesDocument, options);
        }
export type AgentActionTitlesQueryHookResult = ReturnType<typeof useAgentActionTitlesQuery>;
export type AgentActionTitlesLazyQueryHookResult = ReturnType<typeof useAgentActionTitlesLazyQuery>;
export type AgentActionTitlesQueryResult = Apollo.QueryResult<AgentActionTitlesQuery, AgentActionTitlesQueryVariables>;
export const AiGuessBusinessClassesDocument = gql`
    query AiGuessBusinessClasses($description: String!) {
  aiGuessBusinessClasses(description: $description) {
    ...BusinessClass
  }
}
    ${BusinessClassFragmentDoc}`;

/**
 * __useAiGuessBusinessClassesQuery__
 *
 * To run a query within a React component, call `useAiGuessBusinessClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAiGuessBusinessClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiGuessBusinessClassesQuery({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAiGuessBusinessClassesQuery(baseOptions: Apollo.QueryHookOptions<AiGuessBusinessClassesQuery, AiGuessBusinessClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AiGuessBusinessClassesQuery, AiGuessBusinessClassesQueryVariables>(AiGuessBusinessClassesDocument, options);
      }
export function useAiGuessBusinessClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AiGuessBusinessClassesQuery, AiGuessBusinessClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AiGuessBusinessClassesQuery, AiGuessBusinessClassesQueryVariables>(AiGuessBusinessClassesDocument, options);
        }
export type AiGuessBusinessClassesQueryHookResult = ReturnType<typeof useAiGuessBusinessClassesQuery>;
export type AiGuessBusinessClassesLazyQueryHookResult = ReturnType<typeof useAiGuessBusinessClassesLazyQuery>;
export type AiGuessBusinessClassesQueryResult = Apollo.QueryResult<AiGuessBusinessClassesQuery, AiGuessBusinessClassesQueryVariables>;
export const AlbyMarketsForPlanDocument = gql`
    query AlbyMarketsForPlan($opportunityId: ID!, $historyOffset: Int = 0, $historyLimit: Int = 50, $includeHistoryAnchor: Boolean! = false) {
  albyMarketsAwaitingLaunch(opportunityId: $opportunityId)
  albyMarkets(
    opportunityId: $opportunityId
    historyOffset: $historyOffset
    historyLimit: $historyLimit
  ) {
    opportunityId
    gate {
      opportunityId
      mode
      owned
      reason
    }
    evidenceError
    app2ReadAt
    quoteTotalCount
    quoteHistoryOffset
    quoteHistoryLimit
    quotesTruncated
    quoteHistory {
      ...AlbyMarketQuote
    }
    lanes {
      placementId
      runNumber
      generation
      currentnessGeneration
      laneId
      marketId
      productId
      productLine
      displayName
      status
      sourceStatus
      phase
      holds
      failureReason
      handoff {
        kind
        role
        wantedFacts
        moreFactsOmitted
        handoffTaskId
      }
      currentness
      currentnessReason
      app2StateFetchedAt
      assessment {
        id
        verdict
        reason
        accountState
        app2FirstReceivedAt
        currentness
        account {
          classCode {
            code
            description
          }
          reasons
          uncheckedExclusions
          uncheckedReferralReasons
          requiredConfirmations
        }
      }
      ending {
        sentence
        note
        saidBy
      }
      progress {
        milestone
        receiptEventId
        app2ReceivedAt
        generation
        attemptId
      }
      progressTruncated
      portalUrl
      quotesTruncated
      quotes {
        ...AlbyMarketQuote
      }
    }
  }
  historyAnchor: albyMarkets(
    opportunityId: $opportunityId
    historyOffset: 0
    historyLimit: $historyLimit
  ) @include(if: $includeHistoryAnchor) {
    opportunityId
    quoteTotalCount
    quoteHistoryLimit
    quoteHistory {
      id
      version
      currentnessReason
    }
  }
}
    ${AlbyMarketQuoteFragmentDoc}`;

/**
 * __useAlbyMarketsForPlanQuery__
 *
 * To run a query within a React component, call `useAlbyMarketsForPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlbyMarketsForPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlbyMarketsForPlanQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      historyOffset: // value for 'historyOffset'
 *      historyLimit: // value for 'historyLimit'
 *      includeHistoryAnchor: // value for 'includeHistoryAnchor'
 *   },
 * });
 */
export function useAlbyMarketsForPlanQuery(baseOptions: Apollo.QueryHookOptions<AlbyMarketsForPlanQuery, AlbyMarketsForPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlbyMarketsForPlanQuery, AlbyMarketsForPlanQueryVariables>(AlbyMarketsForPlanDocument, options);
      }
export function useAlbyMarketsForPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlbyMarketsForPlanQuery, AlbyMarketsForPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlbyMarketsForPlanQuery, AlbyMarketsForPlanQueryVariables>(AlbyMarketsForPlanDocument, options);
        }
export type AlbyMarketsForPlanQueryHookResult = ReturnType<typeof useAlbyMarketsForPlanQuery>;
export type AlbyMarketsForPlanLazyQueryHookResult = ReturnType<typeof useAlbyMarketsForPlanLazyQuery>;
export type AlbyMarketsForPlanQueryResult = Apollo.QueryResult<AlbyMarketsForPlanQuery, AlbyMarketsForPlanQueryVariables>;
export const AlbyQuoteDetailDocument = gql`
    query AlbyQuoteDetail($opportunityId: ID!, $quoteId: ID!) {
  opportunity(id: $opportunityId) {
    id
    insuredId
    selectedLinesOfBusiness
  }
  albyQuote(opportunityId: $opportunityId, quoteId: $quoteId) {
    ...AlbyQuoteActionDetail
  }
}
    ${AlbyQuoteActionDetailFragmentDoc}`;

/**
 * __useAlbyQuoteDetailQuery__
 *
 * To run a query within a React component, call `useAlbyQuoteDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlbyQuoteDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlbyQuoteDetailQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useAlbyQuoteDetailQuery(baseOptions: Apollo.QueryHookOptions<AlbyQuoteDetailQuery, AlbyQuoteDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlbyQuoteDetailQuery, AlbyQuoteDetailQueryVariables>(AlbyQuoteDetailDocument, options);
      }
export function useAlbyQuoteDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlbyQuoteDetailQuery, AlbyQuoteDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlbyQuoteDetailQuery, AlbyQuoteDetailQueryVariables>(AlbyQuoteDetailDocument, options);
        }
export type AlbyQuoteDetailQueryHookResult = ReturnType<typeof useAlbyQuoteDetailQuery>;
export type AlbyQuoteDetailLazyQueryHookResult = ReturnType<typeof useAlbyQuoteDetailLazyQuery>;
export type AlbyQuoteDetailQueryResult = Apollo.QueryResult<AlbyQuoteDetailQuery, AlbyQuoteDetailQueryVariables>;
export const AlbyQuoteOriginalFileDocument = gql`
    query AlbyQuoteOriginalFile($opportunityId: ID!, $quoteId: ID!, $disposition: AlbyQuoteFileDisposition!) {
  albyQuoteFile(
    opportunityId: $opportunityId
    quoteId: $quoteId
    disposition: $disposition
  ) {
    url
    app2ExpiresAt
    sha256
    size
    mimeType
  }
}
    `;

/**
 * __useAlbyQuoteOriginalFileQuery__
 *
 * To run a query within a React component, call `useAlbyQuoteOriginalFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useAlbyQuoteOriginalFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAlbyQuoteOriginalFileQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      quoteId: // value for 'quoteId'
 *      disposition: // value for 'disposition'
 *   },
 * });
 */
export function useAlbyQuoteOriginalFileQuery(baseOptions: Apollo.QueryHookOptions<AlbyQuoteOriginalFileQuery, AlbyQuoteOriginalFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AlbyQuoteOriginalFileQuery, AlbyQuoteOriginalFileQueryVariables>(AlbyQuoteOriginalFileDocument, options);
      }
export function useAlbyQuoteOriginalFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AlbyQuoteOriginalFileQuery, AlbyQuoteOriginalFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AlbyQuoteOriginalFileQuery, AlbyQuoteOriginalFileQueryVariables>(AlbyQuoteOriginalFileDocument, options);
        }
export type AlbyQuoteOriginalFileQueryHookResult = ReturnType<typeof useAlbyQuoteOriginalFileQuery>;
export type AlbyQuoteOriginalFileLazyQueryHookResult = ReturnType<typeof useAlbyQuoteOriginalFileLazyQuery>;
export type AlbyQuoteOriginalFileQueryResult = Apollo.QueryResult<AlbyQuoteOriginalFileQuery, AlbyQuoteOriginalFileQueryVariables>;
export const AllMyPlaybooksDocument = gql`
    query AllMyPlaybooks {
  myPlaybooks {
    ...Playbook
  }
  mySubscribedPlaybooks {
    ...Playbook
  }
}
    ${PlaybookFragmentDoc}`;

/**
 * __useAllMyPlaybooksQuery__
 *
 * To run a query within a React component, call `useAllMyPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMyPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMyPlaybooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMyPlaybooksQuery(baseOptions?: Apollo.QueryHookOptions<AllMyPlaybooksQuery, AllMyPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMyPlaybooksQuery, AllMyPlaybooksQueryVariables>(AllMyPlaybooksDocument, options);
      }
export function useAllMyPlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMyPlaybooksQuery, AllMyPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMyPlaybooksQuery, AllMyPlaybooksQueryVariables>(AllMyPlaybooksDocument, options);
        }
export type AllMyPlaybooksQueryHookResult = ReturnType<typeof useAllMyPlaybooksQuery>;
export type AllMyPlaybooksLazyQueryHookResult = ReturnType<typeof useAllMyPlaybooksLazyQuery>;
export type AllMyPlaybooksQueryResult = Apollo.QueryResult<AllMyPlaybooksQuery, AllMyPlaybooksQueryVariables>;
export const AllPlaybookRunsDocument = gql`
    query AllPlaybookRuns($input: AllPlaybookRunsInput!) {
  allPlaybookRuns(input: $input) {
    playbookRuns {
      ...PlaybookRun
    }
    numRecords
    numPages
  }
}
    ${PlaybookRunFragmentDoc}`;

/**
 * __useAllPlaybookRunsQuery__
 *
 * To run a query within a React component, call `useAllPlaybookRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllPlaybookRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPlaybookRunsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAllPlaybookRunsQuery(baseOptions: Apollo.QueryHookOptions<AllPlaybookRunsQuery, AllPlaybookRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllPlaybookRunsQuery, AllPlaybookRunsQueryVariables>(AllPlaybookRunsDocument, options);
      }
export function useAllPlaybookRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllPlaybookRunsQuery, AllPlaybookRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllPlaybookRunsQuery, AllPlaybookRunsQueryVariables>(AllPlaybookRunsDocument, options);
        }
export type AllPlaybookRunsQueryHookResult = ReturnType<typeof useAllPlaybookRunsQuery>;
export type AllPlaybookRunsLazyQueryHookResult = ReturnType<typeof useAllPlaybookRunsLazyQuery>;
export type AllPlaybookRunsQueryResult = Apollo.QueryResult<AllPlaybookRunsQuery, AllPlaybookRunsQueryVariables>;
export const AppetiteFilterOptionsDocument = gql`
    query AppetiteFilterOptions {
  appetiteFilterOptions {
    linesOfBusiness {
      id
      name
    }
  }
}
    `;

/**
 * __useAppetiteFilterOptionsQuery__
 *
 * To run a query within a React component, call `useAppetiteFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppetiteFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppetiteFilterOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppetiteFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AppetiteFilterOptionsQuery, AppetiteFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppetiteFilterOptionsQuery, AppetiteFilterOptionsQueryVariables>(AppetiteFilterOptionsDocument, options);
      }
export function useAppetiteFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppetiteFilterOptionsQuery, AppetiteFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppetiteFilterOptionsQuery, AppetiteFilterOptionsQueryVariables>(AppetiteFilterOptionsDocument, options);
        }
export type AppetiteFilterOptionsQueryHookResult = ReturnType<typeof useAppetiteFilterOptionsQuery>;
export type AppetiteFilterOptionsLazyQueryHookResult = ReturnType<typeof useAppetiteFilterOptionsLazyQuery>;
export type AppetiteFilterOptionsQueryResult = Apollo.QueryResult<AppetiteFilterOptionsQuery, AppetiteFilterOptionsQueryVariables>;
export const AppetiteGuidesForOpportunityDocument = gql`
    query AppetiteGuidesForOpportunity($opportunityId: ID!) {
  appetiteGuidesForOpportunity(id: $opportunityId) {
    carrierName
    authority
    code
    lob
    state
    parsedText
    googleDriveUrl
    fileType
  }
}
    `;

/**
 * __useAppetiteGuidesForOpportunityQuery__
 *
 * To run a query within a React component, call `useAppetiteGuidesForOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppetiteGuidesForOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppetiteGuidesForOpportunityQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useAppetiteGuidesForOpportunityQuery(baseOptions: Apollo.QueryHookOptions<AppetiteGuidesForOpportunityQuery, AppetiteGuidesForOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppetiteGuidesForOpportunityQuery, AppetiteGuidesForOpportunityQueryVariables>(AppetiteGuidesForOpportunityDocument, options);
      }
export function useAppetiteGuidesForOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppetiteGuidesForOpportunityQuery, AppetiteGuidesForOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppetiteGuidesForOpportunityQuery, AppetiteGuidesForOpportunityQueryVariables>(AppetiteGuidesForOpportunityDocument, options);
        }
export type AppetiteGuidesForOpportunityQueryHookResult = ReturnType<typeof useAppetiteGuidesForOpportunityQuery>;
export type AppetiteGuidesForOpportunityLazyQueryHookResult = ReturnType<typeof useAppetiteGuidesForOpportunityLazyQuery>;
export type AppetiteGuidesForOpportunityQueryResult = Apollo.QueryResult<AppetiteGuidesForOpportunityQuery, AppetiteGuidesForOpportunityQueryVariables>;
export const AppetiteProductLinesDocument = gql`
    query AppetiteProductLines {
  appetiteProductLines
}
    `;

/**
 * __useAppetiteProductLinesQuery__
 *
 * To run a query within a React component, call `useAppetiteProductLinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppetiteProductLinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppetiteProductLinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppetiteProductLinesQuery(baseOptions?: Apollo.QueryHookOptions<AppetiteProductLinesQuery, AppetiteProductLinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppetiteProductLinesQuery, AppetiteProductLinesQueryVariables>(AppetiteProductLinesDocument, options);
      }
export function useAppetiteProductLinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppetiteProductLinesQuery, AppetiteProductLinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppetiteProductLinesQuery, AppetiteProductLinesQueryVariables>(AppetiteProductLinesDocument, options);
        }
export type AppetiteProductLinesQueryHookResult = ReturnType<typeof useAppetiteProductLinesQuery>;
export type AppetiteProductLinesLazyQueryHookResult = ReturnType<typeof useAppetiteProductLinesLazyQuery>;
export type AppetiteProductLinesQueryResult = Apollo.QueryResult<AppetiteProductLinesQuery, AppetiteProductLinesQueryVariables>;
export const AppetiteProductsDocument = gql`
    query AppetiteProducts {
  appetiteProducts {
    ...AppetiteProduct
  }
}
    ${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;

/**
 * __useAppetiteProductsQuery__
 *
 * To run a query within a React component, call `useAppetiteProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppetiteProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppetiteProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppetiteProductsQuery(baseOptions?: Apollo.QueryHookOptions<AppetiteProductsQuery, AppetiteProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppetiteProductsQuery, AppetiteProductsQueryVariables>(AppetiteProductsDocument, options);
      }
export function useAppetiteProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppetiteProductsQuery, AppetiteProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppetiteProductsQuery, AppetiteProductsQueryVariables>(AppetiteProductsDocument, options);
        }
export type AppetiteProductsQueryHookResult = ReturnType<typeof useAppetiteProductsQuery>;
export type AppetiteProductsLazyQueryHookResult = ReturnType<typeof useAppetiteProductsLazyQuery>;
export type AppetiteProductsQueryResult = Apollo.QueryResult<AppetiteProductsQuery, AppetiteProductsQueryVariables>;
export const AppetiteProductsCountDocument = gql`
    query AppetiteProductsCount {
  productsCount
}
    `;

/**
 * __useAppetiteProductsCountQuery__
 *
 * To run a query within a React component, call `useAppetiteProductsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppetiteProductsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppetiteProductsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppetiteProductsCountQuery(baseOptions?: Apollo.QueryHookOptions<AppetiteProductsCountQuery, AppetiteProductsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppetiteProductsCountQuery, AppetiteProductsCountQueryVariables>(AppetiteProductsCountDocument, options);
      }
export function useAppetiteProductsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppetiteProductsCountQuery, AppetiteProductsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppetiteProductsCountQuery, AppetiteProductsCountQueryVariables>(AppetiteProductsCountDocument, options);
        }
export type AppetiteProductsCountQueryHookResult = ReturnType<typeof useAppetiteProductsCountQuery>;
export type AppetiteProductsCountLazyQueryHookResult = ReturnType<typeof useAppetiteProductsCountLazyQuery>;
export type AppetiteProductsCountQueryResult = Apollo.QueryResult<AppetiteProductsCountQuery, AppetiteProductsCountQueryVariables>;
export const AttentionFeedDocument = gql`
    query AttentionFeed {
  attentionFeed {
    items {
      id
      itemType
      displayTitle
      chatSessionId
      occurredAt
      insuredId
      inboxConversationId
      playbookId
      productId
      rootChatSessionId
    }
    hasMore
    totalCount
  }
}
    `;

/**
 * __useAttentionFeedQuery__
 *
 * To run a query within a React component, call `useAttentionFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttentionFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttentionFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttentionFeedQuery(baseOptions?: Apollo.QueryHookOptions<AttentionFeedQuery, AttentionFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttentionFeedQuery, AttentionFeedQueryVariables>(AttentionFeedDocument, options);
      }
export function useAttentionFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttentionFeedQuery, AttentionFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttentionFeedQuery, AttentionFeedQueryVariables>(AttentionFeedDocument, options);
        }
export type AttentionFeedQueryHookResult = ReturnType<typeof useAttentionFeedQuery>;
export type AttentionFeedLazyQueryHookResult = ReturnType<typeof useAttentionFeedLazyQuery>;
export type AttentionFeedQueryResult = Apollo.QueryResult<AttentionFeedQuery, AttentionFeedQueryVariables>;
export const AttributionUserViewRoleDocument = gql`
    query AttributionUserViewRole($email: String) {
  attributionUserViewRole(email: $email) {
    id
    email
    name
    viewRole
  }
}
    `;

/**
 * __useAttributionUserViewRoleQuery__
 *
 * To run a query within a React component, call `useAttributionUserViewRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionUserViewRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionUserViewRoleQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAttributionUserViewRoleQuery(baseOptions?: Apollo.QueryHookOptions<AttributionUserViewRoleQuery, AttributionUserViewRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionUserViewRoleQuery, AttributionUserViewRoleQueryVariables>(AttributionUserViewRoleDocument, options);
      }
export function useAttributionUserViewRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionUserViewRoleQuery, AttributionUserViewRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionUserViewRoleQuery, AttributionUserViewRoleQueryVariables>(AttributionUserViewRoleDocument, options);
        }
export type AttributionUserViewRoleQueryHookResult = ReturnType<typeof useAttributionUserViewRoleQuery>;
export type AttributionUserViewRoleLazyQueryHookResult = ReturnType<typeof useAttributionUserViewRoleLazyQuery>;
export type AttributionUserViewRoleQueryResult = Apollo.QueryResult<AttributionUserViewRoleQuery, AttributionUserViewRoleQueryVariables>;
export const AttributionUsersDocument = gql`
    query AttributionUsers {
  attributionUsers {
    users {
      id
      email
      name
      viewRole
    }
    count
  }
}
    `;

/**
 * __useAttributionUsersQuery__
 *
 * To run a query within a React component, call `useAttributionUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionUsersQuery(baseOptions?: Apollo.QueryHookOptions<AttributionUsersQuery, AttributionUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionUsersQuery, AttributionUsersQueryVariables>(AttributionUsersDocument, options);
      }
export function useAttributionUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionUsersQuery, AttributionUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionUsersQuery, AttributionUsersQueryVariables>(AttributionUsersDocument, options);
        }
export type AttributionUsersQueryHookResult = ReturnType<typeof useAttributionUsersQuery>;
export type AttributionUsersLazyQueryHookResult = ReturnType<typeof useAttributionUsersLazyQuery>;
export type AttributionUsersQueryResult = Apollo.QueryResult<AttributionUsersQuery, AttributionUsersQueryVariables>;
export const AttributionProducersDocument = gql`
    query AttributionProducers {
  attributionProducers {
    producers {
      id
      email
      name
    }
    count
  }
}
    `;

/**
 * __useAttributionProducersQuery__
 *
 * To run a query within a React component, call `useAttributionProducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducersQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionProducersQuery(baseOptions?: Apollo.QueryHookOptions<AttributionProducersQuery, AttributionProducersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducersQuery, AttributionProducersQueryVariables>(AttributionProducersDocument, options);
      }
export function useAttributionProducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducersQuery, AttributionProducersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducersQuery, AttributionProducersQueryVariables>(AttributionProducersDocument, options);
        }
export type AttributionProducersQueryHookResult = ReturnType<typeof useAttributionProducersQuery>;
export type AttributionProducersLazyQueryHookResult = ReturnType<typeof useAttributionProducersLazyQuery>;
export type AttributionProducersQueryResult = Apollo.QueryResult<AttributionProducersQuery, AttributionProducersQueryVariables>;
export const AttributionLobsDocument = gql`
    query AttributionLobs {
  attributionLobs {
    lobs
    count
  }
}
    `;

/**
 * __useAttributionLobsQuery__
 *
 * To run a query within a React component, call `useAttributionLobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionLobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionLobsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionLobsQuery(baseOptions?: Apollo.QueryHookOptions<AttributionLobsQuery, AttributionLobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionLobsQuery, AttributionLobsQueryVariables>(AttributionLobsDocument, options);
      }
export function useAttributionLobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionLobsQuery, AttributionLobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionLobsQuery, AttributionLobsQueryVariables>(AttributionLobsDocument, options);
        }
export type AttributionLobsQueryHookResult = ReturnType<typeof useAttributionLobsQuery>;
export type AttributionLobsLazyQueryHookResult = ReturnType<typeof useAttributionLobsLazyQuery>;
export type AttributionLobsQueryResult = Apollo.QueryResult<AttributionLobsQuery, AttributionLobsQueryVariables>;
export const AttributionNaicsCodesDocument = gql`
    query AttributionNaicsCodes {
  attributionNaicsCodes {
    naicsCodes {
      code
      description
    }
    count
  }
}
    `;

/**
 * __useAttributionNaicsCodesQuery__
 *
 * To run a query within a React component, call `useAttributionNaicsCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionNaicsCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionNaicsCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionNaicsCodesQuery(baseOptions?: Apollo.QueryHookOptions<AttributionNaicsCodesQuery, AttributionNaicsCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionNaicsCodesQuery, AttributionNaicsCodesQueryVariables>(AttributionNaicsCodesDocument, options);
      }
export function useAttributionNaicsCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionNaicsCodesQuery, AttributionNaicsCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionNaicsCodesQuery, AttributionNaicsCodesQueryVariables>(AttributionNaicsCodesDocument, options);
        }
export type AttributionNaicsCodesQueryHookResult = ReturnType<typeof useAttributionNaicsCodesQuery>;
export type AttributionNaicsCodesLazyQueryHookResult = ReturnType<typeof useAttributionNaicsCodesLazyQuery>;
export type AttributionNaicsCodesQueryResult = Apollo.QueryResult<AttributionNaicsCodesQuery, AttributionNaicsCodesQueryVariables>;
export const AttributionCglCodesDocument = gql`
    query AttributionCglCodes {
  attributionCglCodes {
    cglCodes {
      code
      description
    }
    count
  }
}
    `;

/**
 * __useAttributionCglCodesQuery__
 *
 * To run a query within a React component, call `useAttributionCglCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionCglCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionCglCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionCglCodesQuery(baseOptions?: Apollo.QueryHookOptions<AttributionCglCodesQuery, AttributionCglCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionCglCodesQuery, AttributionCglCodesQueryVariables>(AttributionCglCodesDocument, options);
      }
export function useAttributionCglCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionCglCodesQuery, AttributionCglCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionCglCodesQuery, AttributionCglCodesQueryVariables>(AttributionCglCodesDocument, options);
        }
export type AttributionCglCodesQueryHookResult = ReturnType<typeof useAttributionCglCodesQuery>;
export type AttributionCglCodesLazyQueryHookResult = ReturnType<typeof useAttributionCglCodesLazyQuery>;
export type AttributionCglCodesQueryResult = Apollo.QueryResult<AttributionCglCodesQuery, AttributionCglCodesQueryVariables>;
export const AttributionDataFreshnessDocument = gql`
    query AttributionDataFreshness {
  attributionDataFreshness {
    lastUpdated
  }
}
    `;

/**
 * __useAttributionDataFreshnessQuery__
 *
 * To run a query within a React component, call `useAttributionDataFreshnessQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionDataFreshnessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionDataFreshnessQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionDataFreshnessQuery(baseOptions?: Apollo.QueryHookOptions<AttributionDataFreshnessQuery, AttributionDataFreshnessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionDataFreshnessQuery, AttributionDataFreshnessQueryVariables>(AttributionDataFreshnessDocument, options);
      }
export function useAttributionDataFreshnessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionDataFreshnessQuery, AttributionDataFreshnessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionDataFreshnessQuery, AttributionDataFreshnessQueryVariables>(AttributionDataFreshnessDocument, options);
        }
export type AttributionDataFreshnessQueryHookResult = ReturnType<typeof useAttributionDataFreshnessQuery>;
export type AttributionDataFreshnessLazyQueryHookResult = ReturnType<typeof useAttributionDataFreshnessLazyQuery>;
export type AttributionDataFreshnessQueryResult = Apollo.QueryResult<AttributionDataFreshnessQuery, AttributionDataFreshnessQueryVariables>;
export const AttributionAdminCheckDocument = gql`
    query AttributionAdminCheck {
  attributionAdminCheck {
    isAdmin
    email
  }
}
    `;

/**
 * __useAttributionAdminCheckQuery__
 *
 * To run a query within a React component, call `useAttributionAdminCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionAdminCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionAdminCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionAdminCheckQuery(baseOptions?: Apollo.QueryHookOptions<AttributionAdminCheckQuery, AttributionAdminCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionAdminCheckQuery, AttributionAdminCheckQueryVariables>(AttributionAdminCheckDocument, options);
      }
export function useAttributionAdminCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionAdminCheckQuery, AttributionAdminCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionAdminCheckQuery, AttributionAdminCheckQueryVariables>(AttributionAdminCheckDocument, options);
        }
export type AttributionAdminCheckQueryHookResult = ReturnType<typeof useAttributionAdminCheckQuery>;
export type AttributionAdminCheckLazyQueryHookResult = ReturnType<typeof useAttributionAdminCheckLazyQuery>;
export type AttributionAdminCheckQueryResult = Apollo.QueryResult<AttributionAdminCheckQuery, AttributionAdminCheckQueryVariables>;
export const AttributionProducerIncentivesDocument = gql`
    query AttributionProducerIncentives($email: String!, $year: Int!) {
  attributionProducerIncentives(email: $email, year: $year) {
    bookBased {
      id
      producerEmail
      bindhqLobs
      bindhqLobsInclude
      bindhqPolicyBusinessType
      naicsCode
      naicsCodeInclude
      cglCode
      cglCodeInclude
      startDate
      endDate
      incentivePayPercentage
      createdAt
      updatedAt
    }
    managementBased {
      id
      managerEmail
      producerEmail
      startDate
      endDate
      revenuePercentage
      createdAt
      updatedAt
    }
    base {
      id
      producerEmails
      startDate
      endDate
      bandStart
      bandEnd
      incentivePayPercentage
      createdAt
      updatedAt
    }
    year
  }
}
    `;

/**
 * __useAttributionProducerIncentivesQuery__
 *
 * To run a query within a React component, call `useAttributionProducerIncentivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerIncentivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerIncentivesQuery({
 *   variables: {
 *      email: // value for 'email'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useAttributionProducerIncentivesQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerIncentivesQuery, AttributionProducerIncentivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerIncentivesQuery, AttributionProducerIncentivesQueryVariables>(AttributionProducerIncentivesDocument, options);
      }
export function useAttributionProducerIncentivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerIncentivesQuery, AttributionProducerIncentivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerIncentivesQuery, AttributionProducerIncentivesQueryVariables>(AttributionProducerIncentivesDocument, options);
        }
export type AttributionProducerIncentivesQueryHookResult = ReturnType<typeof useAttributionProducerIncentivesQuery>;
export type AttributionProducerIncentivesLazyQueryHookResult = ReturnType<typeof useAttributionProducerIncentivesLazyQuery>;
export type AttributionProducerIncentivesQueryResult = Apollo.QueryResult<AttributionProducerIncentivesQuery, AttributionProducerIncentivesQueryVariables>;
export const AttributionArmIncentivesDocument = gql`
    query AttributionArmIncentives($armEmail: String!, $year: Int!) {
  attributionArmIncentives(armEmail: $armEmail, year: $year) {
    incentives {
      id
      armEmails
      startDate
      endDate
      renewalBaseRate
      newBusinessBaseRate
      agencyGraduationThreshold
      agencyGraduationBonusRate
      previousYearEstimatedRevenue
      previousYearEstimatedVariable
      kickerTiers {
        targetAchievementPercent
        kickerRate
      }
      updatedByEmail
      createdAt
      updatedAt
    }
    defaultIncentives {
      id
      armEmails
    }
    specificIncentives {
      id
      armEmails
    }
    incentive {
      id
      armEmails
    }
    year
  }
}
    `;

/**
 * __useAttributionArmIncentivesQuery__
 *
 * To run a query within a React component, call `useAttributionArmIncentivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionArmIncentivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionArmIncentivesQuery({
 *   variables: {
 *      armEmail: // value for 'armEmail'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useAttributionArmIncentivesQuery(baseOptions: Apollo.QueryHookOptions<AttributionArmIncentivesQuery, AttributionArmIncentivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionArmIncentivesQuery, AttributionArmIncentivesQueryVariables>(AttributionArmIncentivesDocument, options);
      }
export function useAttributionArmIncentivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionArmIncentivesQuery, AttributionArmIncentivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionArmIncentivesQuery, AttributionArmIncentivesQueryVariables>(AttributionArmIncentivesDocument, options);
        }
export type AttributionArmIncentivesQueryHookResult = ReturnType<typeof useAttributionArmIncentivesQuery>;
export type AttributionArmIncentivesLazyQueryHookResult = ReturnType<typeof useAttributionArmIncentivesLazyQuery>;
export type AttributionArmIncentivesQueryResult = Apollo.QueryResult<AttributionArmIncentivesQuery, AttributionArmIncentivesQueryVariables>;
export const AttributionProducerLostDealsCancellationsDocument = gql`
    query AttributionProducerLostDealsCancellations($input: AttributionProducerLostDealsInput!) {
  attributionProducerLostDealsCancellations(input: $input) {
    records {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      applicationType
      policyId
      policyNumber
      policyStatus
      insuredId
      insuredName
      agencyName
      agentName
      brokerAssigned
      type
      segment
      endorsementPremium
      endorsementRevenue
      revenueFromPremium
      commissionRevenue
      feeRevenue
      yield
      endorsementType
      effectiveDate
      expirationDate
    }
    count
  }
}
    `;

/**
 * __useAttributionProducerLostDealsCancellationsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerLostDealsCancellationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerLostDealsCancellationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerLostDealsCancellationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerLostDealsCancellationsQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerLostDealsCancellationsQuery, AttributionProducerLostDealsCancellationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerLostDealsCancellationsQuery, AttributionProducerLostDealsCancellationsQueryVariables>(AttributionProducerLostDealsCancellationsDocument, options);
      }
export function useAttributionProducerLostDealsCancellationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerLostDealsCancellationsQuery, AttributionProducerLostDealsCancellationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerLostDealsCancellationsQuery, AttributionProducerLostDealsCancellationsQueryVariables>(AttributionProducerLostDealsCancellationsDocument, options);
        }
export type AttributionProducerLostDealsCancellationsQueryHookResult = ReturnType<typeof useAttributionProducerLostDealsCancellationsQuery>;
export type AttributionProducerLostDealsCancellationsLazyQueryHookResult = ReturnType<typeof useAttributionProducerLostDealsCancellationsLazyQuery>;
export type AttributionProducerLostDealsCancellationsQueryResult = Apollo.QueryResult<AttributionProducerLostDealsCancellationsQuery, AttributionProducerLostDealsCancellationsQueryVariables>;
export const AttributionProducerLostDealsNonRenewalsDocument = gql`
    query AttributionProducerLostDealsNonRenewals($input: AttributionProducerLostDealsInput!) {
  attributionProducerLostDealsNonRenewals(input: $input) {
    records {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      applicationType
      policyId
      policyNumber
      policyStatus
      insuredId
      insuredName
      agencyName
      agentName
      brokerAssigned
      type
      segment
      endorsementPremium
      endorsementRevenue
      revenueFromPremium
      commissionRevenue
      feeRevenue
      yield
      endorsementType
      effectiveDate
      expirationDate
    }
    count
  }
}
    `;

/**
 * __useAttributionProducerLostDealsNonRenewalsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerLostDealsNonRenewalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerLostDealsNonRenewalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerLostDealsNonRenewalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerLostDealsNonRenewalsQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerLostDealsNonRenewalsQuery, AttributionProducerLostDealsNonRenewalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerLostDealsNonRenewalsQuery, AttributionProducerLostDealsNonRenewalsQueryVariables>(AttributionProducerLostDealsNonRenewalsDocument, options);
      }
export function useAttributionProducerLostDealsNonRenewalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerLostDealsNonRenewalsQuery, AttributionProducerLostDealsNonRenewalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerLostDealsNonRenewalsQuery, AttributionProducerLostDealsNonRenewalsQueryVariables>(AttributionProducerLostDealsNonRenewalsDocument, options);
        }
export type AttributionProducerLostDealsNonRenewalsQueryHookResult = ReturnType<typeof useAttributionProducerLostDealsNonRenewalsQuery>;
export type AttributionProducerLostDealsNonRenewalsLazyQueryHookResult = ReturnType<typeof useAttributionProducerLostDealsNonRenewalsLazyQuery>;
export type AttributionProducerLostDealsNonRenewalsQueryResult = Apollo.QueryResult<AttributionProducerLostDealsNonRenewalsQuery, AttributionProducerLostDealsNonRenewalsQueryVariables>;
export const AttributionProducerLostDealsMetricsDocument = gql`
    query AttributionProducerLostDealsMetrics($input: AttributionProducerLostDealsMetricsInput!) {
  attributionProducerLostDealsMetrics(input: $input) {
    total {
      count
      cancellationRate
      nonRenewalRate
    }
    cancellations {
      count
      premium
      revenue
      originallyBookedPremium
      returnedPremium
      capturedPremium
      originallyBookedRevenue
      returnedRevenue
      capturedRevenue
    }
    nonRenewals {
      count
      premium
      revenue
    }
  }
}
    `;

/**
 * __useAttributionProducerLostDealsMetricsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerLostDealsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerLostDealsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerLostDealsMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerLostDealsMetricsQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerLostDealsMetricsQuery, AttributionProducerLostDealsMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerLostDealsMetricsQuery, AttributionProducerLostDealsMetricsQueryVariables>(AttributionProducerLostDealsMetricsDocument, options);
      }
export function useAttributionProducerLostDealsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerLostDealsMetricsQuery, AttributionProducerLostDealsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerLostDealsMetricsQuery, AttributionProducerLostDealsMetricsQueryVariables>(AttributionProducerLostDealsMetricsDocument, options);
        }
export type AttributionProducerLostDealsMetricsQueryHookResult = ReturnType<typeof useAttributionProducerLostDealsMetricsQuery>;
export type AttributionProducerLostDealsMetricsLazyQueryHookResult = ReturnType<typeof useAttributionProducerLostDealsMetricsLazyQuery>;
export type AttributionProducerLostDealsMetricsQueryResult = Apollo.QueryResult<AttributionProducerLostDealsMetricsQuery, AttributionProducerLostDealsMetricsQueryVariables>;
export const AttributionProducerMyBookDocument = gql`
    query AttributionProducerMyBook($input: AttributionProducerMyBookInput!) {
  attributionProducerMyBook(input: $input) {
    records {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      transactionDate
      applicationType
      policyId
      policyNumber
      policyStatus
      insuredId
      insuredName
      agencyId
      agencyName
      agentName
      brokerAssigned
      type
      isRenewable
      segment
      endorsementPremium
      endorsementRevenue
      revenueFromPremium
      commissionRevenue
      feeRevenue
      yield
      endorsementType
      effectiveDate
      expirationDate
    }
    count
  }
}
    `;

/**
 * __useAttributionProducerMyBookQuery__
 *
 * To run a query within a React component, call `useAttributionProducerMyBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerMyBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerMyBookQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerMyBookQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerMyBookQuery, AttributionProducerMyBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerMyBookQuery, AttributionProducerMyBookQueryVariables>(AttributionProducerMyBookDocument, options);
      }
export function useAttributionProducerMyBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerMyBookQuery, AttributionProducerMyBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerMyBookQuery, AttributionProducerMyBookQueryVariables>(AttributionProducerMyBookDocument, options);
        }
export type AttributionProducerMyBookQueryHookResult = ReturnType<typeof useAttributionProducerMyBookQuery>;
export type AttributionProducerMyBookLazyQueryHookResult = ReturnType<typeof useAttributionProducerMyBookLazyQuery>;
export type AttributionProducerMyBookQueryResult = Apollo.QueryResult<AttributionProducerMyBookQuery, AttributionProducerMyBookQueryVariables>;
export const AttributionArmMyBookDocument = gql`
    query AttributionArmMyBook($input: AttributionArmMyBookInput!) {
  attributionArmMyBook(input: $input) {
    records {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      transactionDate
      applicationType
      policyId
      policyNumber
      policyStatus
      insuredId
      insuredName
      agencyId
      agencyName
      agentName
      brokerAssigned
      type
      isRenewable
      segment
      endorsementPremium
      endorsementRevenue
      revenueFromPremium
      commissionRevenue
      feeRevenue
      yield
      endorsementType
      effectiveDate
      expirationDate
    }
    agencyMetrics {
      agencyId
      agencyName
      agencyTier
      agencySegment
      totalPolicyPremium
      coverageRequests
      submittedCoverageRequests
      quotedCoverageRequests
      boundCoverageRequests
      createToSubmit
      submitToQuote
      quoteToBind
      hitRatio
    }
    count
  }
}
    `;

/**
 * __useAttributionArmMyBookQuery__
 *
 * To run a query within a React component, call `useAttributionArmMyBookQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionArmMyBookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionArmMyBookQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionArmMyBookQuery(baseOptions: Apollo.QueryHookOptions<AttributionArmMyBookQuery, AttributionArmMyBookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionArmMyBookQuery, AttributionArmMyBookQueryVariables>(AttributionArmMyBookDocument, options);
      }
export function useAttributionArmMyBookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionArmMyBookQuery, AttributionArmMyBookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionArmMyBookQuery, AttributionArmMyBookQueryVariables>(AttributionArmMyBookDocument, options);
        }
export type AttributionArmMyBookQueryHookResult = ReturnType<typeof useAttributionArmMyBookQuery>;
export type AttributionArmMyBookLazyQueryHookResult = ReturnType<typeof useAttributionArmMyBookLazyQuery>;
export type AttributionArmMyBookQueryResult = Apollo.QueryResult<AttributionArmMyBookQuery, AttributionArmMyBookQueryVariables>;
export const AttributionProducerAttributedIncentivesDocument = gql`
    query AttributionProducerAttributedIncentives($input: AttributionProducerAttributedIncentivesInput!) {
  attributionProducerAttributedIncentives(input: $input) {
    chartData {
      month
      rules
    }
    ruleDetails
    transactionYear
    attributeToEmail
    armEmail
  }
}
    `;

/**
 * __useAttributionProducerAttributedIncentivesQuery__
 *
 * To run a query within a React component, call `useAttributionProducerAttributedIncentivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerAttributedIncentivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerAttributedIncentivesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerAttributedIncentivesQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerAttributedIncentivesQuery, AttributionProducerAttributedIncentivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerAttributedIncentivesQuery, AttributionProducerAttributedIncentivesQueryVariables>(AttributionProducerAttributedIncentivesDocument, options);
      }
export function useAttributionProducerAttributedIncentivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerAttributedIncentivesQuery, AttributionProducerAttributedIncentivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerAttributedIncentivesQuery, AttributionProducerAttributedIncentivesQueryVariables>(AttributionProducerAttributedIncentivesDocument, options);
        }
export type AttributionProducerAttributedIncentivesQueryHookResult = ReturnType<typeof useAttributionProducerAttributedIncentivesQuery>;
export type AttributionProducerAttributedIncentivesLazyQueryHookResult = ReturnType<typeof useAttributionProducerAttributedIncentivesLazyQuery>;
export type AttributionProducerAttributedIncentivesQueryResult = Apollo.QueryResult<AttributionProducerAttributedIncentivesQuery, AttributionProducerAttributedIncentivesQueryVariables>;
export const AttributionArmAttributedIncentivesDocument = gql`
    query AttributionArmAttributedIncentives($input: AttributionArmAttributedIncentivesInput!) {
  attributionArmAttributedIncentives(input: $input) {
    chartData {
      month
      rules
    }
    ruleDetails
    transactionYear
    attributeToEmail
    armEmail
  }
}
    `;

/**
 * __useAttributionArmAttributedIncentivesQuery__
 *
 * To run a query within a React component, call `useAttributionArmAttributedIncentivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionArmAttributedIncentivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionArmAttributedIncentivesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionArmAttributedIncentivesQuery(baseOptions: Apollo.QueryHookOptions<AttributionArmAttributedIncentivesQuery, AttributionArmAttributedIncentivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionArmAttributedIncentivesQuery, AttributionArmAttributedIncentivesQueryVariables>(AttributionArmAttributedIncentivesDocument, options);
      }
export function useAttributionArmAttributedIncentivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionArmAttributedIncentivesQuery, AttributionArmAttributedIncentivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionArmAttributedIncentivesQuery, AttributionArmAttributedIncentivesQueryVariables>(AttributionArmAttributedIncentivesDocument, options);
        }
export type AttributionArmAttributedIncentivesQueryHookResult = ReturnType<typeof useAttributionArmAttributedIncentivesQuery>;
export type AttributionArmAttributedIncentivesLazyQueryHookResult = ReturnType<typeof useAttributionArmAttributedIncentivesLazyQuery>;
export type AttributionArmAttributedIncentivesQueryResult = Apollo.QueryResult<AttributionArmAttributedIncentivesQuery, AttributionArmAttributedIncentivesQueryVariables>;
export const AttributionProducerPerformanceOverviewDetailsDocument = gql`
    query AttributionProducerPerformanceOverviewDetails($input: AttributionProducerPerformanceOverviewDetailsInput!) {
  attributionProducerPerformanceOverviewDetails(input: $input) {
    records {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      transactionDate
      applicationType
      policyId
      policyNumber
      policyStatus
      insuredName
      agencyName
      agentName
      brokerAssigned
      type
      segment
      endorsementPremium
      endorsementRevenue
      revenueFromPremium
      commissionRevenue
      feeRevenue
      yield
      endorsementType
      effectiveDate
      expirationDate
    }
    count
  }
}
    `;

/**
 * __useAttributionProducerPerformanceOverviewDetailsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerPerformanceOverviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerPerformanceOverviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerPerformanceOverviewDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerPerformanceOverviewDetailsQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerPerformanceOverviewDetailsQuery, AttributionProducerPerformanceOverviewDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerPerformanceOverviewDetailsQuery, AttributionProducerPerformanceOverviewDetailsQueryVariables>(AttributionProducerPerformanceOverviewDetailsDocument, options);
      }
export function useAttributionProducerPerformanceOverviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerPerformanceOverviewDetailsQuery, AttributionProducerPerformanceOverviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerPerformanceOverviewDetailsQuery, AttributionProducerPerformanceOverviewDetailsQueryVariables>(AttributionProducerPerformanceOverviewDetailsDocument, options);
        }
export type AttributionProducerPerformanceOverviewDetailsQueryHookResult = ReturnType<typeof useAttributionProducerPerformanceOverviewDetailsQuery>;
export type AttributionProducerPerformanceOverviewDetailsLazyQueryHookResult = ReturnType<typeof useAttributionProducerPerformanceOverviewDetailsLazyQuery>;
export type AttributionProducerPerformanceOverviewDetailsQueryResult = Apollo.QueryResult<AttributionProducerPerformanceOverviewDetailsQuery, AttributionProducerPerformanceOverviewDetailsQueryVariables>;
export const AttributionArmPerformanceOverviewDetailsDocument = gql`
    query AttributionArmPerformanceOverviewDetails($input: AttributionArmPerformanceOverviewDetailsInput!) {
  attributionArmPerformanceOverviewDetails(input: $input) {
    records {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      transactionDate
      applicationType
      policyId
      policyNumber
      policyStatus
      insuredName
      agencyName
      agentName
      brokerAssigned
      type
      segment
      endorsementPremium
      endorsementRevenue
      revenueFromPremium
      commissionRevenue
      feeRevenue
      yield
      endorsementType
      effectiveDate
      expirationDate
    }
    count
  }
}
    `;

/**
 * __useAttributionArmPerformanceOverviewDetailsQuery__
 *
 * To run a query within a React component, call `useAttributionArmPerformanceOverviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionArmPerformanceOverviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionArmPerformanceOverviewDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionArmPerformanceOverviewDetailsQuery(baseOptions: Apollo.QueryHookOptions<AttributionArmPerformanceOverviewDetailsQuery, AttributionArmPerformanceOverviewDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionArmPerformanceOverviewDetailsQuery, AttributionArmPerformanceOverviewDetailsQueryVariables>(AttributionArmPerformanceOverviewDetailsDocument, options);
      }
export function useAttributionArmPerformanceOverviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionArmPerformanceOverviewDetailsQuery, AttributionArmPerformanceOverviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionArmPerformanceOverviewDetailsQuery, AttributionArmPerformanceOverviewDetailsQueryVariables>(AttributionArmPerformanceOverviewDetailsDocument, options);
        }
export type AttributionArmPerformanceOverviewDetailsQueryHookResult = ReturnType<typeof useAttributionArmPerformanceOverviewDetailsQuery>;
export type AttributionArmPerformanceOverviewDetailsLazyQueryHookResult = ReturnType<typeof useAttributionArmPerformanceOverviewDetailsLazyQuery>;
export type AttributionArmPerformanceOverviewDetailsQueryResult = Apollo.QueryResult<AttributionArmPerformanceOverviewDetailsQuery, AttributionArmPerformanceOverviewDetailsQueryVariables>;
export const AttributionProducerAttributedPremiumDocument = gql`
    query AttributionProducerAttributedPremium($input: AttributionProducerAttributedPremiumInput!) {
  attributionProducerAttributedPremium(input: $input) {
    stats {
      totalRevenue
      newBusinessRevenue
      renewalRevenue
      totalCount
      newBusinessCount
      renewalCount
    }
    chartData {
      month
      total
      newBusiness
      renewal
    }
    transactionYear
    attributeToEmail
    armEmail
  }
}
    `;

/**
 * __useAttributionProducerAttributedPremiumQuery__
 *
 * To run a query within a React component, call `useAttributionProducerAttributedPremiumQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerAttributedPremiumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerAttributedPremiumQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerAttributedPremiumQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerAttributedPremiumQuery, AttributionProducerAttributedPremiumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerAttributedPremiumQuery, AttributionProducerAttributedPremiumQueryVariables>(AttributionProducerAttributedPremiumDocument, options);
      }
export function useAttributionProducerAttributedPremiumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerAttributedPremiumQuery, AttributionProducerAttributedPremiumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerAttributedPremiumQuery, AttributionProducerAttributedPremiumQueryVariables>(AttributionProducerAttributedPremiumDocument, options);
        }
export type AttributionProducerAttributedPremiumQueryHookResult = ReturnType<typeof useAttributionProducerAttributedPremiumQuery>;
export type AttributionProducerAttributedPremiumLazyQueryHookResult = ReturnType<typeof useAttributionProducerAttributedPremiumLazyQuery>;
export type AttributionProducerAttributedPremiumQueryResult = Apollo.QueryResult<AttributionProducerAttributedPremiumQuery, AttributionProducerAttributedPremiumQueryVariables>;
export const AttributionArmAttributedPremiumDocument = gql`
    query AttributionArmAttributedPremium($input: AttributionArmAttributedPremiumInput!) {
  attributionArmAttributedPremium(input: $input) {
    stats {
      totalRevenue
      newBusinessRevenue
      renewalRevenue
      totalCount
      newBusinessCount
      renewalCount
    }
    chartData {
      month
      total
      newBusiness
      renewal
    }
    transactionYear
    attributeToEmail
    armEmail
  }
}
    `;

/**
 * __useAttributionArmAttributedPremiumQuery__
 *
 * To run a query within a React component, call `useAttributionArmAttributedPremiumQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionArmAttributedPremiumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionArmAttributedPremiumQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionArmAttributedPremiumQuery(baseOptions: Apollo.QueryHookOptions<AttributionArmAttributedPremiumQuery, AttributionArmAttributedPremiumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionArmAttributedPremiumQuery, AttributionArmAttributedPremiumQueryVariables>(AttributionArmAttributedPremiumDocument, options);
      }
export function useAttributionArmAttributedPremiumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionArmAttributedPremiumQuery, AttributionArmAttributedPremiumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionArmAttributedPremiumQuery, AttributionArmAttributedPremiumQueryVariables>(AttributionArmAttributedPremiumDocument, options);
        }
export type AttributionArmAttributedPremiumQueryHookResult = ReturnType<typeof useAttributionArmAttributedPremiumQuery>;
export type AttributionArmAttributedPremiumLazyQueryHookResult = ReturnType<typeof useAttributionArmAttributedPremiumLazyQuery>;
export type AttributionArmAttributedPremiumQueryResult = Apollo.QueryResult<AttributionArmAttributedPremiumQuery, AttributionArmAttributedPremiumQueryVariables>;
export const AttributionProducerAttributedRollsDocument = gql`
    query AttributionProducerAttributedRolls($input: AttributionProducerAttributedRollsInput!) {
  attributionProducerAttributedRolls(input: $input) {
    data
    byEmail
  }
}
    `;

/**
 * __useAttributionProducerAttributedRollsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerAttributedRollsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerAttributedRollsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerAttributedRollsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionProducerAttributedRollsQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerAttributedRollsQuery, AttributionProducerAttributedRollsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerAttributedRollsQuery, AttributionProducerAttributedRollsQueryVariables>(AttributionProducerAttributedRollsDocument, options);
      }
export function useAttributionProducerAttributedRollsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerAttributedRollsQuery, AttributionProducerAttributedRollsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerAttributedRollsQuery, AttributionProducerAttributedRollsQueryVariables>(AttributionProducerAttributedRollsDocument, options);
        }
export type AttributionProducerAttributedRollsQueryHookResult = ReturnType<typeof useAttributionProducerAttributedRollsQuery>;
export type AttributionProducerAttributedRollsLazyQueryHookResult = ReturnType<typeof useAttributionProducerAttributedRollsLazyQuery>;
export type AttributionProducerAttributedRollsQueryResult = Apollo.QueryResult<AttributionProducerAttributedRollsQuery, AttributionProducerAttributedRollsQueryVariables>;
export const AttributionProducerLabelsDocument = gql`
    query AttributionProducerLabels {
  attributionProducerLabels {
    producerEmail
    producerName
    label
    updatedAt
  }
}
    `;

/**
 * __useAttributionProducerLabelsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionProducerLabelsQuery(baseOptions?: Apollo.QueryHookOptions<AttributionProducerLabelsQuery, AttributionProducerLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerLabelsQuery, AttributionProducerLabelsQueryVariables>(AttributionProducerLabelsDocument, options);
      }
export function useAttributionProducerLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerLabelsQuery, AttributionProducerLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerLabelsQuery, AttributionProducerLabelsQueryVariables>(AttributionProducerLabelsDocument, options);
        }
export type AttributionProducerLabelsQueryHookResult = ReturnType<typeof useAttributionProducerLabelsQuery>;
export type AttributionProducerLabelsLazyQueryHookResult = ReturnType<typeof useAttributionProducerLabelsLazyQuery>;
export type AttributionProducerLabelsQueryResult = Apollo.QueryResult<AttributionProducerLabelsQuery, AttributionProducerLabelsQueryVariables>;
export const AttributionProducerLabelDocument = gql`
    query AttributionProducerLabel($producerEmail: String!) {
  attributionProducerLabel(producerEmail: $producerEmail) {
    producerEmail
    label
    updatedByEmail
    updatedAt
  }
}
    `;

/**
 * __useAttributionProducerLabelQuery__
 *
 * To run a query within a React component, call `useAttributionProducerLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerLabelQuery({
 *   variables: {
 *      producerEmail: // value for 'producerEmail'
 *   },
 * });
 */
export function useAttributionProducerLabelQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerLabelQuery, AttributionProducerLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerLabelQuery, AttributionProducerLabelQueryVariables>(AttributionProducerLabelDocument, options);
      }
export function useAttributionProducerLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerLabelQuery, AttributionProducerLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerLabelQuery, AttributionProducerLabelQueryVariables>(AttributionProducerLabelDocument, options);
        }
export type AttributionProducerLabelQueryHookResult = ReturnType<typeof useAttributionProducerLabelQuery>;
export type AttributionProducerLabelLazyQueryHookResult = ReturnType<typeof useAttributionProducerLabelLazyQuery>;
export type AttributionProducerLabelQueryResult = Apollo.QueryResult<AttributionProducerLabelQuery, AttributionProducerLabelQueryVariables>;
export const AttributionProducerLabelOptionsDocument = gql`
    query AttributionProducerLabelOptions {
  attributionProducerLabelOptions
}
    `;

/**
 * __useAttributionProducerLabelOptionsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerLabelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerLabelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerLabelOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAttributionProducerLabelOptionsQuery(baseOptions?: Apollo.QueryHookOptions<AttributionProducerLabelOptionsQuery, AttributionProducerLabelOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerLabelOptionsQuery, AttributionProducerLabelOptionsQueryVariables>(AttributionProducerLabelOptionsDocument, options);
      }
export function useAttributionProducerLabelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerLabelOptionsQuery, AttributionProducerLabelOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerLabelOptionsQuery, AttributionProducerLabelOptionsQueryVariables>(AttributionProducerLabelOptionsDocument, options);
        }
export type AttributionProducerLabelOptionsQueryHookResult = ReturnType<typeof useAttributionProducerLabelOptionsQuery>;
export type AttributionProducerLabelOptionsLazyQueryHookResult = ReturnType<typeof useAttributionProducerLabelOptionsLazyQuery>;
export type AttributionProducerLabelOptionsQueryResult = Apollo.QueryResult<AttributionProducerLabelOptionsQuery, AttributionProducerLabelOptionsQueryVariables>;
export const AttributionQuotedNotBoundDocument = gql`
    query AttributionQuotedNotBound($input: AttributionQuotedNotBoundInput!) {
  attributionQuotedNotBound(input: $input) {
    records {
      id
      insuredName
      insuredId
      insuredPrimaryState
      lineOfBusiness
      desiredEffectiveDate
      createdAt
      earliestDeliveredAt
      agencyName
      agentName
      brokerName
      brokerEmail
      opportunityId
      isRenewal
      opportunitySource
      quotesDelivered
      minQuotePremium
      submitToQuoteHours
      quoteToBindHours
      carrierNames
      brokerType
    }
    count
    truncated
    summary {
      count
      distinctInsureds
      distinctInsuredLobPairs
      sumMinQuotePremium
    }
  }
}
    `;

/**
 * __useAttributionQuotedNotBoundQuery__
 *
 * To run a query within a React component, call `useAttributionQuotedNotBoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionQuotedNotBoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionQuotedNotBoundQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionQuotedNotBoundQuery(baseOptions: Apollo.QueryHookOptions<AttributionQuotedNotBoundQuery, AttributionQuotedNotBoundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionQuotedNotBoundQuery, AttributionQuotedNotBoundQueryVariables>(AttributionQuotedNotBoundDocument, options);
      }
export function useAttributionQuotedNotBoundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionQuotedNotBoundQuery, AttributionQuotedNotBoundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionQuotedNotBoundQuery, AttributionQuotedNotBoundQueryVariables>(AttributionQuotedNotBoundDocument, options);
        }
export type AttributionQuotedNotBoundQueryHookResult = ReturnType<typeof useAttributionQuotedNotBoundQuery>;
export type AttributionQuotedNotBoundLazyQueryHookResult = ReturnType<typeof useAttributionQuotedNotBoundLazyQuery>;
export type AttributionQuotedNotBoundQueryResult = Apollo.QueryResult<AttributionQuotedNotBoundQuery, AttributionQuotedNotBoundQueryVariables>;
export const AttributionReassignmentsDocument = gql`
    query AttributionReassignments($input: AttributionReassignmentsInput!) {
  attributionReassignments(input: $input) {
    reassignments {
      id
      endorsementId
      endorsementNumber
      adjustedPostingDate
      revenue
      revenueFromPremium
      premium
      quotewellCommission
      mgaFee
      applicationType
      isRenewal
      productMarketType
      policyId
      appPolicyId
      policyNumber
      policyStatus
      insuredId
      appInsuredId
      insuredName
      agencyName
      agentName
      attributeToName
      originalAttributeToEmail
      wasRenewed
      reattributeToEmail
      reassignedByEmail
      reassignmentCreatedAt
      reassignmentUpdatedAt
    }
    count
  }
}
    `;

/**
 * __useAttributionReassignmentsQuery__
 *
 * To run a query within a React component, call `useAttributionReassignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionReassignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionReassignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionReassignmentsQuery(baseOptions: Apollo.QueryHookOptions<AttributionReassignmentsQuery, AttributionReassignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionReassignmentsQuery, AttributionReassignmentsQueryVariables>(AttributionReassignmentsDocument, options);
      }
export function useAttributionReassignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionReassignmentsQuery, AttributionReassignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionReassignmentsQuery, AttributionReassignmentsQueryVariables>(AttributionReassignmentsDocument, options);
        }
export type AttributionReassignmentsQueryHookResult = ReturnType<typeof useAttributionReassignmentsQuery>;
export type AttributionReassignmentsLazyQueryHookResult = ReturnType<typeof useAttributionReassignmentsLazyQuery>;
export type AttributionReassignmentsQueryResult = Apollo.QueryResult<AttributionReassignmentsQuery, AttributionReassignmentsQueryVariables>;
export const AttributionProducerRevenueTargetsDocument = gql`
    query AttributionProducerRevenueTargets($producerEmail: String!, $year: Int!) {
  attributionProducerRevenueTargets(producerEmail: $producerEmail, year: $year) {
    targets {
      id
      producerEmail
      year
      month
      revenueTarget
      updatedByEmail
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useAttributionProducerRevenueTargetsQuery__
 *
 * To run a query within a React component, call `useAttributionProducerRevenueTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerRevenueTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerRevenueTargetsQuery({
 *   variables: {
 *      producerEmail: // value for 'producerEmail'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useAttributionProducerRevenueTargetsQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerRevenueTargetsQuery, AttributionProducerRevenueTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerRevenueTargetsQuery, AttributionProducerRevenueTargetsQueryVariables>(AttributionProducerRevenueTargetsDocument, options);
      }
export function useAttributionProducerRevenueTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerRevenueTargetsQuery, AttributionProducerRevenueTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerRevenueTargetsQuery, AttributionProducerRevenueTargetsQueryVariables>(AttributionProducerRevenueTargetsDocument, options);
        }
export type AttributionProducerRevenueTargetsQueryHookResult = ReturnType<typeof useAttributionProducerRevenueTargetsQuery>;
export type AttributionProducerRevenueTargetsLazyQueryHookResult = ReturnType<typeof useAttributionProducerRevenueTargetsLazyQuery>;
export type AttributionProducerRevenueTargetsQueryResult = Apollo.QueryResult<AttributionProducerRevenueTargetsQuery, AttributionProducerRevenueTargetsQueryVariables>;
export const AttributionArmRevenueTargetsDocument = gql`
    query AttributionArmRevenueTargets($armEmail: String!, $year: Int!) {
  attributionArmRevenueTargets(armEmail: $armEmail, year: $year) {
    targets {
      id
      producerEmail
      year
      month
      revenueTarget
      updatedByEmail
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useAttributionArmRevenueTargetsQuery__
 *
 * To run a query within a React component, call `useAttributionArmRevenueTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionArmRevenueTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionArmRevenueTargetsQuery({
 *   variables: {
 *      armEmail: // value for 'armEmail'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useAttributionArmRevenueTargetsQuery(baseOptions: Apollo.QueryHookOptions<AttributionArmRevenueTargetsQuery, AttributionArmRevenueTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionArmRevenueTargetsQuery, AttributionArmRevenueTargetsQueryVariables>(AttributionArmRevenueTargetsDocument, options);
      }
export function useAttributionArmRevenueTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionArmRevenueTargetsQuery, AttributionArmRevenueTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionArmRevenueTargetsQuery, AttributionArmRevenueTargetsQueryVariables>(AttributionArmRevenueTargetsDocument, options);
        }
export type AttributionArmRevenueTargetsQueryHookResult = ReturnType<typeof useAttributionArmRevenueTargetsQuery>;
export type AttributionArmRevenueTargetsLazyQueryHookResult = ReturnType<typeof useAttributionArmRevenueTargetsLazyQuery>;
export type AttributionArmRevenueTargetsQueryResult = Apollo.QueryResult<AttributionArmRevenueTargetsQuery, AttributionArmRevenueTargetsQueryVariables>;
export const AttributionProducerRevenueTargetsByTeamDocument = gql`
    query AttributionProducerRevenueTargetsByTeam($transactionYear: Int!, $period: String!, $label: String) {
  attributionProducerRevenueTargetsByTeam(
    transactionYear: $transactionYear
    period: $period
    label: $label
  ) {
    targets
    year
    period
  }
}
    `;

/**
 * __useAttributionProducerRevenueTargetsByTeamQuery__
 *
 * To run a query within a React component, call `useAttributionProducerRevenueTargetsByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionProducerRevenueTargetsByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionProducerRevenueTargetsByTeamQuery({
 *   variables: {
 *      transactionYear: // value for 'transactionYear'
 *      period: // value for 'period'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useAttributionProducerRevenueTargetsByTeamQuery(baseOptions: Apollo.QueryHookOptions<AttributionProducerRevenueTargetsByTeamQuery, AttributionProducerRevenueTargetsByTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionProducerRevenueTargetsByTeamQuery, AttributionProducerRevenueTargetsByTeamQueryVariables>(AttributionProducerRevenueTargetsByTeamDocument, options);
      }
export function useAttributionProducerRevenueTargetsByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionProducerRevenueTargetsByTeamQuery, AttributionProducerRevenueTargetsByTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionProducerRevenueTargetsByTeamQuery, AttributionProducerRevenueTargetsByTeamQueryVariables>(AttributionProducerRevenueTargetsByTeamDocument, options);
        }
export type AttributionProducerRevenueTargetsByTeamQueryHookResult = ReturnType<typeof useAttributionProducerRevenueTargetsByTeamQuery>;
export type AttributionProducerRevenueTargetsByTeamLazyQueryHookResult = ReturnType<typeof useAttributionProducerRevenueTargetsByTeamLazyQuery>;
export type AttributionProducerRevenueTargetsByTeamQueryResult = Apollo.QueryResult<AttributionProducerRevenueTargetsByTeamQuery, AttributionProducerRevenueTargetsByTeamQueryVariables>;
export const AttributionTeamAttributedPremiumDocument = gql`
    query AttributionTeamAttributedPremium($input: AttributionTeamAttributedPremiumInput!) {
  attributionTeamAttributedPremium(input: $input) {
    chartData
    transactionYear
    breakdownType
    filterLabel
    period
  }
}
    `;

/**
 * __useAttributionTeamAttributedPremiumQuery__
 *
 * To run a query within a React component, call `useAttributionTeamAttributedPremiumQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributionTeamAttributedPremiumQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributionTeamAttributedPremiumQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionTeamAttributedPremiumQuery(baseOptions: Apollo.QueryHookOptions<AttributionTeamAttributedPremiumQuery, AttributionTeamAttributedPremiumQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributionTeamAttributedPremiumQuery, AttributionTeamAttributedPremiumQueryVariables>(AttributionTeamAttributedPremiumDocument, options);
      }
export function useAttributionTeamAttributedPremiumLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributionTeamAttributedPremiumQuery, AttributionTeamAttributedPremiumQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributionTeamAttributedPremiumQuery, AttributionTeamAttributedPremiumQueryVariables>(AttributionTeamAttributedPremiumDocument, options);
        }
export type AttributionTeamAttributedPremiumQueryHookResult = ReturnType<typeof useAttributionTeamAttributedPremiumQuery>;
export type AttributionTeamAttributedPremiumLazyQueryHookResult = ReturnType<typeof useAttributionTeamAttributedPremiumLazyQuery>;
export type AttributionTeamAttributedPremiumQueryResult = Apollo.QueryResult<AttributionTeamAttributedPremiumQuery, AttributionTeamAttributedPremiumQueryVariables>;
export const BankanMarketingPlanColumnDocument = gql`
    query BankanMarketingPlanColumn($input: BankanMarketingPlanColumnInput!) {
  bankanMarketingPlanColumn(input: $input) {
    groupedMarketingPlans {
      insuredId
      insuredName
      insured {
        id
        name
        createdAt
        isoCglCodes
        agent {
          id
          firstName
          lastName
          email
          agency {
            id
            name
            affiliations {
              ...AgencyAffiliation
            }
          }
        }
      }
      marketingPlans {
        id
        insuredId
        createdAt
        state
        desiredEffectiveDate
        lastTransitionAt
        selectedLinesOfBusiness
        snoozeUntil
        hasUnseenAlbyUpdates
        broker {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    ${AgencyAffiliationFragmentDoc}`;

/**
 * __useBankanMarketingPlanColumnQuery__
 *
 * To run a query within a React component, call `useBankanMarketingPlanColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankanMarketingPlanColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankanMarketingPlanColumnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankanMarketingPlanColumnQuery(baseOptions: Apollo.QueryHookOptions<BankanMarketingPlanColumnQuery, BankanMarketingPlanColumnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankanMarketingPlanColumnQuery, BankanMarketingPlanColumnQueryVariables>(BankanMarketingPlanColumnDocument, options);
      }
export function useBankanMarketingPlanColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankanMarketingPlanColumnQuery, BankanMarketingPlanColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankanMarketingPlanColumnQuery, BankanMarketingPlanColumnQueryVariables>(BankanMarketingPlanColumnDocument, options);
        }
export type BankanMarketingPlanColumnQueryHookResult = ReturnType<typeof useBankanMarketingPlanColumnQuery>;
export type BankanMarketingPlanColumnLazyQueryHookResult = ReturnType<typeof useBankanMarketingPlanColumnLazyQuery>;
export type BankanMarketingPlanColumnQueryResult = Apollo.QueryResult<BankanMarketingPlanColumnQuery, BankanMarketingPlanColumnQueryVariables>;
export const BankanPolicyColumnDocument = gql`
    query BankanPolicyColumn($input: BankanPolicyColumnInput!) {
  bankanPolicyColumn(input: $input) {
    groupedPolicies {
      insuredId
      insuredName
      insured {
        id
        name
        createdAt
        isoCglCodes
        agent {
          id
          firstName
          lastName
          email
          agency {
            id
            name
            affiliations {
              ...AgencyAffiliation
            }
          }
        }
      }
      policies {
        id
        insuredId
        state
        policyNumber
        expirationDate
        lastTransitionAt
        appetiteProduct {
          id
          carrierName
          carrierProductName
          marketType
        }
      }
    }
  }
}
    ${AgencyAffiliationFragmentDoc}`;

/**
 * __useBankanPolicyColumnQuery__
 *
 * To run a query within a React component, call `useBankanPolicyColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankanPolicyColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankanPolicyColumnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankanPolicyColumnQuery(baseOptions: Apollo.QueryHookOptions<BankanPolicyColumnQuery, BankanPolicyColumnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankanPolicyColumnQuery, BankanPolicyColumnQueryVariables>(BankanPolicyColumnDocument, options);
      }
export function useBankanPolicyColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankanPolicyColumnQuery, BankanPolicyColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankanPolicyColumnQuery, BankanPolicyColumnQueryVariables>(BankanPolicyColumnDocument, options);
        }
export type BankanPolicyColumnQueryHookResult = ReturnType<typeof useBankanPolicyColumnQuery>;
export type BankanPolicyColumnLazyQueryHookResult = ReturnType<typeof useBankanPolicyColumnLazyQuery>;
export type BankanPolicyColumnQueryResult = Apollo.QueryResult<BankanPolicyColumnQuery, BankanPolicyColumnQueryVariables>;
export const BankanQuoteColumnDocument = gql`
    query BankanQuoteColumn($input: BankanQuoteColumnInput!) {
  bankanQuoteColumn(input: $input) {
    groupedQuotes {
      insuredId
      insuredName
      insured {
        id
        name
        createdAt
        isoCglCodes
        agent {
          id
          firstName
          lastName
          email
          agency {
            id
            name
            affiliations {
              ...AgencyAffiliation
            }
          }
        }
      }
      quotes {
        id
        insuredId
        state
        premium
        effectiveDate
        lastTransitionAt
        appetiteProduct {
          id
          carrierName
          carrierProductName
          marketType
        }
      }
    }
  }
}
    ${AgencyAffiliationFragmentDoc}`;

/**
 * __useBankanQuoteColumnQuery__
 *
 * To run a query within a React component, call `useBankanQuoteColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankanQuoteColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankanQuoteColumnQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankanQuoteColumnQuery(baseOptions: Apollo.QueryHookOptions<BankanQuoteColumnQuery, BankanQuoteColumnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BankanQuoteColumnQuery, BankanQuoteColumnQueryVariables>(BankanQuoteColumnDocument, options);
      }
export function useBankanQuoteColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BankanQuoteColumnQuery, BankanQuoteColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BankanQuoteColumnQuery, BankanQuoteColumnQueryVariables>(BankanQuoteColumnDocument, options);
        }
export type BankanQuoteColumnQueryHookResult = ReturnType<typeof useBankanQuoteColumnQuery>;
export type BankanQuoteColumnLazyQueryHookResult = ReturnType<typeof useBankanQuoteColumnLazyQuery>;
export type BankanQuoteColumnQueryResult = Apollo.QueryResult<BankanQuoteColumnQuery, BankanQuoteColumnQueryVariables>;
export const BindHqAgenciesDocument = gql`
    query BindHqAgencies {
  bindHqAgencies {
    id
    name
  }
}
    `;

/**
 * __useBindHqAgenciesQuery__
 *
 * To run a query within a React component, call `useBindHqAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindHqAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindHqAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBindHqAgenciesQuery(baseOptions?: Apollo.QueryHookOptions<BindHqAgenciesQuery, BindHqAgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindHqAgenciesQuery, BindHqAgenciesQueryVariables>(BindHqAgenciesDocument, options);
      }
export function useBindHqAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindHqAgenciesQuery, BindHqAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindHqAgenciesQuery, BindHqAgenciesQueryVariables>(BindHqAgenciesDocument, options);
        }
export type BindHqAgenciesQueryHookResult = ReturnType<typeof useBindHqAgenciesQuery>;
export type BindHqAgenciesLazyQueryHookResult = ReturnType<typeof useBindHqAgenciesLazyQuery>;
export type BindHqAgenciesQueryResult = Apollo.QueryResult<BindHqAgenciesQuery, BindHqAgenciesQueryVariables>;
export const BindHqAgencyDocument = gql`
    query BindHqAgency($id: String!) {
  bindHqAgency(id: $id) {
    ...BindHqAgency
  }
}
    ${BindHqAgencyFragmentDoc}`;

/**
 * __useBindHqAgencyQuery__
 *
 * To run a query within a React component, call `useBindHqAgencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindHqAgencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindHqAgencyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBindHqAgencyQuery(baseOptions: Apollo.QueryHookOptions<BindHqAgencyQuery, BindHqAgencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindHqAgencyQuery, BindHqAgencyQueryVariables>(BindHqAgencyDocument, options);
      }
export function useBindHqAgencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindHqAgencyQuery, BindHqAgencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindHqAgencyQuery, BindHqAgencyQueryVariables>(BindHqAgencyDocument, options);
        }
export type BindHqAgencyQueryHookResult = ReturnType<typeof useBindHqAgencyQuery>;
export type BindHqAgencyLazyQueryHookResult = ReturnType<typeof useBindHqAgencyLazyQuery>;
export type BindHqAgencyQueryResult = Apollo.QueryResult<BindHqAgencyQuery, BindHqAgencyQueryVariables>;
export const BindHqAgentsDocument = gql`
    query BindHqAgents($input: BindHqFetchAgentsInput!) {
  bindHqAgents(input: $input) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useBindHqAgentsQuery__
 *
 * To run a query within a React component, call `useBindHqAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindHqAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindHqAgentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBindHqAgentsQuery(baseOptions: Apollo.QueryHookOptions<BindHqAgentsQuery, BindHqAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindHqAgentsQuery, BindHqAgentsQueryVariables>(BindHqAgentsDocument, options);
      }
export function useBindHqAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindHqAgentsQuery, BindHqAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindHqAgentsQuery, BindHqAgentsQueryVariables>(BindHqAgentsDocument, options);
        }
export type BindHqAgentsQueryHookResult = ReturnType<typeof useBindHqAgentsQuery>;
export type BindHqAgentsLazyQueryHookResult = ReturnType<typeof useBindHqAgentsLazyQuery>;
export type BindHqAgentsQueryResult = Apollo.QueryResult<BindHqAgentsQuery, BindHqAgentsQueryVariables>;
export const BindHqCarriersDocument = gql`
    query BindHqCarriers {
  bindHqCarriers {
    id
    name
  }
}
    `;

/**
 * __useBindHqCarriersQuery__
 *
 * To run a query within a React component, call `useBindHqCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindHqCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindHqCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useBindHqCarriersQuery(baseOptions?: Apollo.QueryHookOptions<BindHqCarriersQuery, BindHqCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindHqCarriersQuery, BindHqCarriersQueryVariables>(BindHqCarriersDocument, options);
      }
export function useBindHqCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindHqCarriersQuery, BindHqCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindHqCarriersQuery, BindHqCarriersQueryVariables>(BindHqCarriersDocument, options);
        }
export type BindHqCarriersQueryHookResult = ReturnType<typeof useBindHqCarriersQuery>;
export type BindHqCarriersLazyQueryHookResult = ReturnType<typeof useBindHqCarriersLazyQuery>;
export type BindHqCarriersQueryResult = Apollo.QueryResult<BindHqCarriersQuery, BindHqCarriersQueryVariables>;
export const BindHqInsuredsDocument = gql`
    query BindHqInsureds {
  bindHqInsureds {
    id
    name
    type
  }
}
    `;

/**
 * __useBindHqInsuredsQuery__
 *
 * To run a query within a React component, call `useBindHqInsuredsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindHqInsuredsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindHqInsuredsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBindHqInsuredsQuery(baseOptions?: Apollo.QueryHookOptions<BindHqInsuredsQuery, BindHqInsuredsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindHqInsuredsQuery, BindHqInsuredsQueryVariables>(BindHqInsuredsDocument, options);
      }
export function useBindHqInsuredsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindHqInsuredsQuery, BindHqInsuredsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindHqInsuredsQuery, BindHqInsuredsQueryVariables>(BindHqInsuredsDocument, options);
        }
export type BindHqInsuredsQueryHookResult = ReturnType<typeof useBindHqInsuredsQuery>;
export type BindHqInsuredsLazyQueryHookResult = ReturnType<typeof useBindHqInsuredsLazyQuery>;
export type BindHqInsuredsQueryResult = Apollo.QueryResult<BindHqInsuredsQuery, BindHqInsuredsQueryVariables>;
export const BindHqMarketingCompaniesDocument = gql`
    query BindHqMarketingCompanies {
  bindHqMarketingCompanies {
    id
    name
  }
}
    `;

/**
 * __useBindHqMarketingCompaniesQuery__
 *
 * To run a query within a React component, call `useBindHqMarketingCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBindHqMarketingCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBindHqMarketingCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useBindHqMarketingCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<BindHqMarketingCompaniesQuery, BindHqMarketingCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BindHqMarketingCompaniesQuery, BindHqMarketingCompaniesQueryVariables>(BindHqMarketingCompaniesDocument, options);
      }
export function useBindHqMarketingCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BindHqMarketingCompaniesQuery, BindHqMarketingCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BindHqMarketingCompaniesQuery, BindHqMarketingCompaniesQueryVariables>(BindHqMarketingCompaniesDocument, options);
        }
export type BindHqMarketingCompaniesQueryHookResult = ReturnType<typeof useBindHqMarketingCompaniesQuery>;
export type BindHqMarketingCompaniesLazyQueryHookResult = ReturnType<typeof useBindHqMarketingCompaniesLazyQuery>;
export type BindHqMarketingCompaniesQueryResult = Apollo.QueryResult<BindHqMarketingCompaniesQuery, BindHqMarketingCompaniesQueryVariables>;
export const BinderCoverFiguresDocument = gql`
    query BinderCoverFigures($policyId: ID!) {
  binderCoverFigures(policyId: $policyId) {
    premium
    surplusLinesTax
    stampingFee
    surplusLinesServiceCharge
    fireMarshallTax
    municipalFee
    countyFee
    empaTax
    carrierFee
    inspectionFee
    brokerFee
    policyNumber
    effectiveDate
    expirationDate
    totalPremium
    outstandingSubjectivities
    reviewToken
    bindHqFigureChecks {
      fields
      status
      ours
      bindHq
    }
  }
}
    `;

/**
 * __useBinderCoverFiguresQuery__
 *
 * To run a query within a React component, call `useBinderCoverFiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `useBinderCoverFiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBinderCoverFiguresQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useBinderCoverFiguresQuery(baseOptions: Apollo.QueryHookOptions<BinderCoverFiguresQuery, BinderCoverFiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BinderCoverFiguresQuery, BinderCoverFiguresQueryVariables>(BinderCoverFiguresDocument, options);
      }
export function useBinderCoverFiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BinderCoverFiguresQuery, BinderCoverFiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BinderCoverFiguresQuery, BinderCoverFiguresQueryVariables>(BinderCoverFiguresDocument, options);
        }
export type BinderCoverFiguresQueryHookResult = ReturnType<typeof useBinderCoverFiguresQuery>;
export type BinderCoverFiguresLazyQueryHookResult = ReturnType<typeof useBinderCoverFiguresLazyQuery>;
export type BinderCoverFiguresQueryResult = Apollo.QueryResult<BinderCoverFiguresQuery, BinderCoverFiguresQueryVariables>;
export const BrokerAccountsDocument = gql`
    query BrokerAccounts($input: UserAccountFindManyFilter! = {roles: [Broker]}) {
  userAccounts(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useBrokerAccountsQuery__
 *
 * To run a query within a React component, call `useBrokerAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerAccountsQuery(baseOptions?: Apollo.QueryHookOptions<BrokerAccountsQuery, BrokerAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerAccountsQuery, BrokerAccountsQueryVariables>(BrokerAccountsDocument, options);
      }
export function useBrokerAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerAccountsQuery, BrokerAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerAccountsQuery, BrokerAccountsQueryVariables>(BrokerAccountsDocument, options);
        }
export type BrokerAccountsQueryHookResult = ReturnType<typeof useBrokerAccountsQuery>;
export type BrokerAccountsLazyQueryHookResult = ReturnType<typeof useBrokerAccountsLazyQuery>;
export type BrokerAccountsQueryResult = Apollo.QueryResult<BrokerAccountsQuery, BrokerAccountsQueryVariables>;
export const BrokerHasCollaborationsDocument = gql`
    query BrokerHasCollaborations($brokerId: String!) {
  brokerHasCollaborations(brokerId: $brokerId)
}
    `;

/**
 * __useBrokerHasCollaborationsQuery__
 *
 * To run a query within a React component, call `useBrokerHasCollaborationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerHasCollaborationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerHasCollaborationsQuery({
 *   variables: {
 *      brokerId: // value for 'brokerId'
 *   },
 * });
 */
export function useBrokerHasCollaborationsQuery(baseOptions: Apollo.QueryHookOptions<BrokerHasCollaborationsQuery, BrokerHasCollaborationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerHasCollaborationsQuery, BrokerHasCollaborationsQueryVariables>(BrokerHasCollaborationsDocument, options);
      }
export function useBrokerHasCollaborationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerHasCollaborationsQuery, BrokerHasCollaborationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerHasCollaborationsQuery, BrokerHasCollaborationsQueryVariables>(BrokerHasCollaborationsDocument, options);
        }
export type BrokerHasCollaborationsQueryHookResult = ReturnType<typeof useBrokerHasCollaborationsQuery>;
export type BrokerHasCollaborationsLazyQueryHookResult = ReturnType<typeof useBrokerHasCollaborationsLazyQuery>;
export type BrokerHasCollaborationsQueryResult = Apollo.QueryResult<BrokerHasCollaborationsQuery, BrokerHasCollaborationsQueryVariables>;
export const BrokerLostOpportunitiesDocument = gql`
    query BrokerLostOpportunities($input: BrokerLostOpportunitiesInput!) {
  brokerLostOpportunities(input: $input) {
    id
    desiredEffectiveDate
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
        email
        agency {
          id
          name
        }
      }
    }
    renewalStatus
  }
}
    `;

/**
 * __useBrokerLostOpportunitiesQuery__
 *
 * To run a query within a React component, call `useBrokerLostOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerLostOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerLostOpportunitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerLostOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<BrokerLostOpportunitiesQuery, BrokerLostOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerLostOpportunitiesQuery, BrokerLostOpportunitiesQueryVariables>(BrokerLostOpportunitiesDocument, options);
      }
export function useBrokerLostOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerLostOpportunitiesQuery, BrokerLostOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerLostOpportunitiesQuery, BrokerLostOpportunitiesQueryVariables>(BrokerLostOpportunitiesDocument, options);
        }
export type BrokerLostOpportunitiesQueryHookResult = ReturnType<typeof useBrokerLostOpportunitiesQuery>;
export type BrokerLostOpportunitiesLazyQueryHookResult = ReturnType<typeof useBrokerLostOpportunitiesLazyQuery>;
export type BrokerLostOpportunitiesQueryResult = Apollo.QueryResult<BrokerLostOpportunitiesQuery, BrokerLostOpportunitiesQueryVariables>;
export const BrokerOpportunitiesDocument = gql`
    query BrokerOpportunities($input: BrokerOpportunitiesInput!) {
  brokerOpportunities(input: $input) {
    id
    brokerId
    desiredEffectiveDate
    snoozeUntil
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
        email
        agency {
          id
          name
        }
      }
    }
    submissions {
      id
      state
      quotes {
        id
        state
      }
    }
    classificationLabels
    renewalStatus
  }
}
    `;

/**
 * __useBrokerOpportunitiesQuery__
 *
 * To run a query within a React component, call `useBrokerOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerOpportunitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<BrokerOpportunitiesQuery, BrokerOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerOpportunitiesQuery, BrokerOpportunitiesQueryVariables>(BrokerOpportunitiesDocument, options);
      }
export function useBrokerOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerOpportunitiesQuery, BrokerOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerOpportunitiesQuery, BrokerOpportunitiesQueryVariables>(BrokerOpportunitiesDocument, options);
        }
export type BrokerOpportunitiesQueryHookResult = ReturnType<typeof useBrokerOpportunitiesQuery>;
export type BrokerOpportunitiesLazyQueryHookResult = ReturnType<typeof useBrokerOpportunitiesLazyQuery>;
export type BrokerOpportunitiesQueryResult = Apollo.QueryResult<BrokerOpportunitiesQuery, BrokerOpportunitiesQueryVariables>;
export const BrokerPoliciesDocument = gql`
    query BrokerPolicies($input: BrokerPoliciesInput!) {
  brokerPolicies(input: $input) {
    id
    effectiveDate
    expirationDate
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
        email
        agency {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBrokerPoliciesQuery__
 *
 * To run a query within a React component, call `useBrokerPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerPoliciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerPoliciesQuery(baseOptions: Apollo.QueryHookOptions<BrokerPoliciesQuery, BrokerPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerPoliciesQuery, BrokerPoliciesQueryVariables>(BrokerPoliciesDocument, options);
      }
export function useBrokerPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerPoliciesQuery, BrokerPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerPoliciesQuery, BrokerPoliciesQueryVariables>(BrokerPoliciesDocument, options);
        }
export type BrokerPoliciesQueryHookResult = ReturnType<typeof useBrokerPoliciesQuery>;
export type BrokerPoliciesLazyQueryHookResult = ReturnType<typeof useBrokerPoliciesLazyQuery>;
export type BrokerPoliciesQueryResult = Apollo.QueryResult<BrokerPoliciesQuery, BrokerPoliciesQueryVariables>;
export const BrokerQuotesDocument = gql`
    query BrokerQuotes($input: BrokerQuotesInput) {
  brokerQuotes(input: $input) {
    id
    effectiveDate
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
        email
        agency {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBrokerQuotesQuery__
 *
 * To run a query within a React component, call `useBrokerQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerQuotesQuery(baseOptions?: Apollo.QueryHookOptions<BrokerQuotesQuery, BrokerQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerQuotesQuery, BrokerQuotesQueryVariables>(BrokerQuotesDocument, options);
      }
export function useBrokerQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerQuotesQuery, BrokerQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerQuotesQuery, BrokerQuotesQueryVariables>(BrokerQuotesDocument, options);
        }
export type BrokerQuotesQueryHookResult = ReturnType<typeof useBrokerQuotesQuery>;
export type BrokerQuotesLazyQueryHookResult = ReturnType<typeof useBrokerQuotesLazyQuery>;
export type BrokerQuotesQueryResult = Apollo.QueryResult<BrokerQuotesQuery, BrokerQuotesQueryVariables>;
export const BrokerRenewalsDocument = gql`
    query BrokerRenewals($input: BrokerOpportunitiesInput!) {
  brokerRenewals(input: $input) {
    id
    desiredEffectiveDate
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
        email
        agency {
          id
          name
        }
      }
    }
    submissions {
      id
      state
      quotes {
        id
        state
      }
    }
    classificationLabels
    renewalStatus
  }
}
    `;

/**
 * __useBrokerRenewalsQuery__
 *
 * To run a query within a React component, call `useBrokerRenewalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerRenewalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerRenewalsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrokerRenewalsQuery(baseOptions: Apollo.QueryHookOptions<BrokerRenewalsQuery, BrokerRenewalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerRenewalsQuery, BrokerRenewalsQueryVariables>(BrokerRenewalsDocument, options);
      }
export function useBrokerRenewalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerRenewalsQuery, BrokerRenewalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerRenewalsQuery, BrokerRenewalsQueryVariables>(BrokerRenewalsDocument, options);
        }
export type BrokerRenewalsQueryHookResult = ReturnType<typeof useBrokerRenewalsQuery>;
export type BrokerRenewalsLazyQueryHookResult = ReturnType<typeof useBrokerRenewalsLazyQuery>;
export type BrokerRenewalsQueryResult = Apollo.QueryResult<BrokerRenewalsQuery, BrokerRenewalsQueryVariables>;
export const BrokerUpcomingRenewalsDocument = gql`
    query BrokerUpcomingRenewals {
  brokerUpcomingRenewals {
    id
    effectiveDate
    expirationDate
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
        email
        agency {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBrokerUpcomingRenewalsQuery__
 *
 * To run a query within a React component, call `useBrokerUpcomingRenewalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrokerUpcomingRenewalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrokerUpcomingRenewalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrokerUpcomingRenewalsQuery(baseOptions?: Apollo.QueryHookOptions<BrokerUpcomingRenewalsQuery, BrokerUpcomingRenewalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrokerUpcomingRenewalsQuery, BrokerUpcomingRenewalsQueryVariables>(BrokerUpcomingRenewalsDocument, options);
      }
export function useBrokerUpcomingRenewalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrokerUpcomingRenewalsQuery, BrokerUpcomingRenewalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrokerUpcomingRenewalsQuery, BrokerUpcomingRenewalsQueryVariables>(BrokerUpcomingRenewalsDocument, options);
        }
export type BrokerUpcomingRenewalsQueryHookResult = ReturnType<typeof useBrokerUpcomingRenewalsQuery>;
export type BrokerUpcomingRenewalsLazyQueryHookResult = ReturnType<typeof useBrokerUpcomingRenewalsLazyQuery>;
export type BrokerUpcomingRenewalsQueryResult = Apollo.QueryResult<BrokerUpcomingRenewalsQuery, BrokerUpcomingRenewalsQueryVariables>;
export const CancelVaveQuoteDocument = gql`
    mutation CancelVaveQuote($input: CancelVaveQuoteInput!) {
  cancel(input: $input) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type CancelVaveQuoteMutationFn = Apollo.MutationFunction<CancelVaveQuoteMutation, CancelVaveQuoteMutationVariables>;

/**
 * __useCancelVaveQuoteMutation__
 *
 * To run a mutation, you first call `useCancelVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelVaveQuoteMutation, { data, loading, error }] = useCancelVaveQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<CancelVaveQuoteMutation, CancelVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelVaveQuoteMutation, CancelVaveQuoteMutationVariables>(CancelVaveQuoteDocument, options);
      }
export type CancelVaveQuoteMutationHookResult = ReturnType<typeof useCancelVaveQuoteMutation>;
export type CancelVaveQuoteMutationResult = Apollo.MutationResult<CancelVaveQuoteMutation>;
export type CancelVaveQuoteMutationOptions = Apollo.BaseMutationOptions<CancelVaveQuoteMutation, CancelVaveQuoteMutationVariables>;
export const CarrierContactsDocument = gql`
    query CarrierContacts {
  carrierContacts {
    ...CarrierContact
  }
}
    ${CarrierContactFragmentDoc}`;

/**
 * __useCarrierContactsQuery__
 *
 * To run a query within a React component, call `useCarrierContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCarrierContactsQuery(baseOptions?: Apollo.QueryHookOptions<CarrierContactsQuery, CarrierContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarrierContactsQuery, CarrierContactsQueryVariables>(CarrierContactsDocument, options);
      }
export function useCarrierContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarrierContactsQuery, CarrierContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarrierContactsQuery, CarrierContactsQueryVariables>(CarrierContactsDocument, options);
        }
export type CarrierContactsQueryHookResult = ReturnType<typeof useCarrierContactsQuery>;
export type CarrierContactsLazyQueryHookResult = ReturnType<typeof useCarrierContactsLazyQuery>;
export type CarrierContactsQueryResult = Apollo.QueryResult<CarrierContactsQuery, CarrierContactsQueryVariables>;
export const CarrierDetailDocument = gql`
    query CarrierDetail($id: ID!) {
  carrier(id: $id) {
    id
    name
    slug
    url
    portalUrl
    qwAppointed
    bindHqMarketingCompanyId
    bindHqMarketingCompanyName
    bindHqCarrierIds
    phone
    fax
    email
    addressLine1
    addressLine2
    city
    state
    postalCode
    backgroundColor
    foregroundColor
    contracts {
      id
      fileUploadId
      extractionStatus
      appetiteProductIds
      createdAt
      fileUpload {
        id
        filename
        mimeType
        size
        createdAt
      }
      incentives {
        id
        incentiveType
        summary
        details
        appetiteProductId
        sortOrder
      }
      commissions {
        id
        lineOfBusiness
        rate
        premiumThresholdMin
        premiumThresholdMax
        appetiteProductId
        notes
        sortOrder
      }
      agreementType
      effectiveDate
      expirationDate
      producerCode
      marketType
      contractStatus
      hasBindingAuthority
      bindingAuthorityLimit
      aggregateLimit
      maxPolicyTermMonths
      premiumFinanceAllowed
      premiumGuarantee
      paymentTerms
      terminationNoticeDays
      defaultCurePeriodDays
      eoMinimumCoverage
      eoRatingRequirement
      fidelityBondRequired
      dataBreachNotifyHours
      recordRetentionYears
      diligentSearchRequired
      subProducerAllowed
      changeOfControlPct
      governingLawState
      disputeMethod
      arbitrationVenue
      authorizedStates
    }
    incentives {
      id
      carrierContractId
      incentiveType
      summary
      details
      appetiteProductId
      sortOrder
    }
  }
}
    `;

/**
 * __useCarrierDetailQuery__
 *
 * To run a query within a React component, call `useCarrierDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarrierDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarrierDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCarrierDetailQuery(baseOptions: Apollo.QueryHookOptions<CarrierDetailQuery, CarrierDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarrierDetailQuery, CarrierDetailQueryVariables>(CarrierDetailDocument, options);
      }
export function useCarrierDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarrierDetailQuery, CarrierDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarrierDetailQuery, CarrierDetailQueryVariables>(CarrierDetailDocument, options);
        }
export type CarrierDetailQueryHookResult = ReturnType<typeof useCarrierDetailQuery>;
export type CarrierDetailLazyQueryHookResult = ReturnType<typeof useCarrierDetailLazyQuery>;
export type CarrierDetailQueryResult = Apollo.QueryResult<CarrierDetailQuery, CarrierDetailQueryVariables>;
export const ChatSessionDocument = gql`
    query ChatSession($id: String!) {
  chatSession(id: $id) {
    ...ChatSession
  }
}
    ${ChatSessionFragmentDoc}
${ChatMessageFragmentDoc}`;

/**
 * __useChatSessionQuery__
 *
 * To run a query within a React component, call `useChatSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatSessionQuery(baseOptions: Apollo.QueryHookOptions<ChatSessionQuery, ChatSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatSessionQuery, ChatSessionQueryVariables>(ChatSessionDocument, options);
      }
export function useChatSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatSessionQuery, ChatSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatSessionQuery, ChatSessionQueryVariables>(ChatSessionDocument, options);
        }
export type ChatSessionQueryHookResult = ReturnType<typeof useChatSessionQuery>;
export type ChatSessionLazyQueryHookResult = ReturnType<typeof useChatSessionLazyQuery>;
export type ChatSessionQueryResult = Apollo.QueryResult<ChatSessionQuery, ChatSessionQueryVariables>;
export const ChatSessionNotificationMetadataDocument = gql`
    query ChatSessionNotificationMetadata($chatSessionId: String!) {
  chatSessionNotificationMetadata(chatSessionId: $chatSessionId) {
    displayTitle
    insuredId
    inboxConversationId
    opportunityId
  }
}
    `;

/**
 * __useChatSessionNotificationMetadataQuery__
 *
 * To run a query within a React component, call `useChatSessionNotificationMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionNotificationMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionNotificationMetadataQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function useChatSessionNotificationMetadataQuery(baseOptions: Apollo.QueryHookOptions<ChatSessionNotificationMetadataQuery, ChatSessionNotificationMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatSessionNotificationMetadataQuery, ChatSessionNotificationMetadataQueryVariables>(ChatSessionNotificationMetadataDocument, options);
      }
export function useChatSessionNotificationMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatSessionNotificationMetadataQuery, ChatSessionNotificationMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatSessionNotificationMetadataQuery, ChatSessionNotificationMetadataQueryVariables>(ChatSessionNotificationMetadataDocument, options);
        }
export type ChatSessionNotificationMetadataQueryHookResult = ReturnType<typeof useChatSessionNotificationMetadataQuery>;
export type ChatSessionNotificationMetadataLazyQueryHookResult = ReturnType<typeof useChatSessionNotificationMetadataLazyQuery>;
export type ChatSessionNotificationMetadataQueryResult = Apollo.QueryResult<ChatSessionNotificationMetadataQuery, ChatSessionNotificationMetadataQueryVariables>;
export const ChatSessionStreamStateDocument = gql`
    query ChatSessionStreamState($chatSessionId: String!) {
  chatSessionStreamState(chatSessionId: $chatSessionId) {
    chatSessionId
    kind
    error
    userId
    formatVersion
  }
}
    `;

/**
 * __useChatSessionStreamStateQuery__
 *
 * To run a query within a React component, call `useChatSessionStreamStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionStreamStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionStreamStateQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function useChatSessionStreamStateQuery(baseOptions: Apollo.QueryHookOptions<ChatSessionStreamStateQuery, ChatSessionStreamStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatSessionStreamStateQuery, ChatSessionStreamStateQueryVariables>(ChatSessionStreamStateDocument, options);
      }
export function useChatSessionStreamStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatSessionStreamStateQuery, ChatSessionStreamStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatSessionStreamStateQuery, ChatSessionStreamStateQueryVariables>(ChatSessionStreamStateDocument, options);
        }
export type ChatSessionStreamStateQueryHookResult = ReturnType<typeof useChatSessionStreamStateQuery>;
export type ChatSessionStreamStateLazyQueryHookResult = ReturnType<typeof useChatSessionStreamStateLazyQuery>;
export type ChatSessionStreamStateQueryResult = Apollo.QueryResult<ChatSessionStreamStateQuery, ChatSessionStreamStateQueryVariables>;
export const ChatSessionUsageDocument = gql`
    query ChatSessionUsage($id: String!) {
  chatSessionUsage(id: $id) {
    id
    lastInputTokens
    contextLimit
  }
}
    `;

/**
 * __useChatSessionUsageQuery__
 *
 * To run a query within a React component, call `useChatSessionUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionUsageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatSessionUsageQuery(baseOptions: Apollo.QueryHookOptions<ChatSessionUsageQuery, ChatSessionUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatSessionUsageQuery, ChatSessionUsageQueryVariables>(ChatSessionUsageDocument, options);
      }
export function useChatSessionUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatSessionUsageQuery, ChatSessionUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatSessionUsageQuery, ChatSessionUsageQueryVariables>(ChatSessionUsageDocument, options);
        }
export type ChatSessionUsageQueryHookResult = ReturnType<typeof useChatSessionUsageQuery>;
export type ChatSessionUsageLazyQueryHookResult = ReturnType<typeof useChatSessionUsageLazyQuery>;
export type ChatSessionUsageQueryResult = Apollo.QueryResult<ChatSessionUsageQuery, ChatSessionUsageQueryVariables>;
export const ChatSessionsDocument = gql`
    query ChatSessions($input: ChatSessionFilterInput!) {
  chatSessions(input: $input) {
    ...ChatSession
  }
}
    ${ChatSessionFragmentDoc}
${ChatMessageFragmentDoc}`;

/**
 * __useChatSessionsQuery__
 *
 * To run a query within a React component, call `useChatSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatSessionsQuery(baseOptions: Apollo.QueryHookOptions<ChatSessionsQuery, ChatSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatSessionsQuery, ChatSessionsQueryVariables>(ChatSessionsDocument, options);
      }
export function useChatSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatSessionsQuery, ChatSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatSessionsQuery, ChatSessionsQueryVariables>(ChatSessionsDocument, options);
        }
export type ChatSessionsQueryHookResult = ReturnType<typeof useChatSessionsQuery>;
export type ChatSessionsLazyQueryHookResult = ReturnType<typeof useChatSessionsLazyQuery>;
export type ChatSessionsQueryResult = Apollo.QueryResult<ChatSessionsQuery, ChatSessionsQueryVariables>;
export const ChildPlaybookRunsDocument = gql`
    query ChildPlaybookRuns($parentPlaybookRunId: String!) {
  childPlaybookRuns(parentPlaybookRunId: $parentPlaybookRunId) {
    ...PlaybookRun
  }
}
    ${PlaybookRunFragmentDoc}`;

/**
 * __useChildPlaybookRunsQuery__
 *
 * To run a query within a React component, call `useChildPlaybookRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChildPlaybookRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChildPlaybookRunsQuery({
 *   variables: {
 *      parentPlaybookRunId: // value for 'parentPlaybookRunId'
 *   },
 * });
 */
export function useChildPlaybookRunsQuery(baseOptions: Apollo.QueryHookOptions<ChildPlaybookRunsQuery, ChildPlaybookRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChildPlaybookRunsQuery, ChildPlaybookRunsQueryVariables>(ChildPlaybookRunsDocument, options);
      }
export function useChildPlaybookRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChildPlaybookRunsQuery, ChildPlaybookRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChildPlaybookRunsQuery, ChildPlaybookRunsQueryVariables>(ChildPlaybookRunsDocument, options);
        }
export type ChildPlaybookRunsQueryHookResult = ReturnType<typeof useChildPlaybookRunsQuery>;
export type ChildPlaybookRunsLazyQueryHookResult = ReturnType<typeof useChildPlaybookRunsLazyQuery>;
export type ChildPlaybookRunsQueryResult = Apollo.QueryResult<ChildPlaybookRunsQuery, ChildPlaybookRunsQueryVariables>;
export const ClassCodesDocument = gql`
    query ClassCodes {
  classCodes {
    ...ClassCode
  }
}
    ${ClassCodeFragmentDoc}`;

/**
 * __useClassCodesQuery__
 *
 * To run a query within a React component, call `useClassCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClassCodesQuery(baseOptions?: Apollo.QueryHookOptions<ClassCodesQuery, ClassCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassCodesQuery, ClassCodesQueryVariables>(ClassCodesDocument, options);
      }
export function useClassCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassCodesQuery, ClassCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassCodesQuery, ClassCodesQueryVariables>(ClassCodesDocument, options);
        }
export type ClassCodesQueryHookResult = ReturnType<typeof useClassCodesQuery>;
export type ClassCodesLazyQueryHookResult = ReturnType<typeof useClassCodesLazyQuery>;
export type ClassCodesQueryResult = Apollo.QueryResult<ClassCodesQuery, ClassCodesQueryVariables>;
export const ClientDataDocument = gql`
    query ClientData($input: ClientDataFilterInput!) {
  clientData(input: $input) {
    ...ClientData
  }
}
    ${ClientDataFragmentDoc}`;

/**
 * __useClientDataQuery__
 *
 * To run a query within a React component, call `useClientDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientDataQuery(baseOptions: Apollo.QueryHookOptions<ClientDataQuery, ClientDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientDataQuery, ClientDataQueryVariables>(ClientDataDocument, options);
      }
export function useClientDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientDataQuery, ClientDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientDataQuery, ClientDataQueryVariables>(ClientDataDocument, options);
        }
export type ClientDataQueryHookResult = ReturnType<typeof useClientDataQuery>;
export type ClientDataLazyQueryHookResult = ReturnType<typeof useClientDataLazyQuery>;
export type ClientDataQueryResult = Apollo.QueryResult<ClientDataQuery, ClientDataQueryVariables>;
export const ConversationMessagesDocument = gql`
    query ConversationMessages($rootChatSessionId: String!) {
  conversationMessages(rootChatSessionId: $rootChatSessionId) {
    ... on ConversationMessages {
      messages {
        ...ConversationMessage
      }
    }
    ... on UnsupportedRuntime {
      reason
    }
  }
}
    ${ConversationMessageFragmentDoc}`;

/**
 * __useConversationMessagesQuery__
 *
 * To run a query within a React component, call `useConversationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationMessagesQuery({
 *   variables: {
 *      rootChatSessionId: // value for 'rootChatSessionId'
 *   },
 * });
 */
export function useConversationMessagesQuery(baseOptions: Apollo.QueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
      }
export function useConversationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationMessagesQuery, ConversationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationMessagesQuery, ConversationMessagesQueryVariables>(ConversationMessagesDocument, options);
        }
export type ConversationMessagesQueryHookResult = ReturnType<typeof useConversationMessagesQuery>;
export type ConversationMessagesLazyQueryHookResult = ReturnType<typeof useConversationMessagesLazyQuery>;
export type ConversationMessagesQueryResult = Apollo.QueryResult<ConversationMessagesQuery, ConversationMessagesQueryVariables>;
export const DefaultPromptDocument = gql`
    query DefaultPrompt($input: DefaultPromptInput!) {
  defaultPrompt(input: $input) {
    systemPrompt
    assistantMessage
    chatSession {
      ...ChatSession
    }
  }
}
    ${ChatSessionFragmentDoc}
${ChatMessageFragmentDoc}`;

/**
 * __useDefaultPromptQuery__
 *
 * To run a query within a React component, call `useDefaultPromptQuery` and pass it any options that fit your needs.
 * When your component renders, `useDefaultPromptQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDefaultPromptQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDefaultPromptQuery(baseOptions: Apollo.QueryHookOptions<DefaultPromptQuery, DefaultPromptQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DefaultPromptQuery, DefaultPromptQueryVariables>(DefaultPromptDocument, options);
      }
export function useDefaultPromptLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DefaultPromptQuery, DefaultPromptQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DefaultPromptQuery, DefaultPromptQueryVariables>(DefaultPromptDocument, options);
        }
export type DefaultPromptQueryHookResult = ReturnType<typeof useDefaultPromptQuery>;
export type DefaultPromptLazyQueryHookResult = ReturnType<typeof useDefaultPromptLazyQuery>;
export type DefaultPromptQueryResult = Apollo.QueryResult<DefaultPromptQuery, DefaultPromptQueryVariables>;
export const DiscoverPlaybooksDocument = gql`
    query DiscoverPlaybooks {
  discoverPlaybooks {
    ...Playbook
  }
}
    ${PlaybookFragmentDoc}`;

/**
 * __useDiscoverPlaybooksQuery__
 *
 * To run a query within a React component, call `useDiscoverPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverPlaybooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useDiscoverPlaybooksQuery(baseOptions?: Apollo.QueryHookOptions<DiscoverPlaybooksQuery, DiscoverPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverPlaybooksQuery, DiscoverPlaybooksQueryVariables>(DiscoverPlaybooksDocument, options);
      }
export function useDiscoverPlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverPlaybooksQuery, DiscoverPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverPlaybooksQuery, DiscoverPlaybooksQueryVariables>(DiscoverPlaybooksDocument, options);
        }
export type DiscoverPlaybooksQueryHookResult = ReturnType<typeof useDiscoverPlaybooksQuery>;
export type DiscoverPlaybooksLazyQueryHookResult = ReturnType<typeof useDiscoverPlaybooksLazyQuery>;
export type DiscoverPlaybooksQueryResult = Apollo.QueryResult<DiscoverPlaybooksQuery, DiscoverPlaybooksQueryVariables>;
export const EnabledProductsDocument = gql`
    query EnabledProducts {
  enabledProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useEnabledProductsQuery__
 *
 * To run a query within a React component, call `useEnabledProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledProductsQuery(baseOptions?: Apollo.QueryHookOptions<EnabledProductsQuery, EnabledProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledProductsQuery, EnabledProductsQueryVariables>(EnabledProductsDocument, options);
      }
export function useEnabledProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledProductsQuery, EnabledProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledProductsQuery, EnabledProductsQueryVariables>(EnabledProductsDocument, options);
        }
export type EnabledProductsQueryHookResult = ReturnType<typeof useEnabledProductsQuery>;
export type EnabledProductsLazyQueryHookResult = ReturnType<typeof useEnabledProductsLazyQuery>;
export type EnabledProductsQueryResult = Apollo.QueryResult<EnabledProductsQuery, EnabledProductsQueryVariables>;
export const FileDocument = gql`
    query File($input: FindFileInput!) {
  file(input: $input) {
    ...FileUpload
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useFileQuery__
 *
 * To run a query within a React component, call `useFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFileQuery(baseOptions: Apollo.QueryHookOptions<FileQuery, FileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileQuery, FileQueryVariables>(FileDocument, options);
      }
export function useFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileQuery, FileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileQuery, FileQueryVariables>(FileDocument, options);
        }
export type FileQueryHookResult = ReturnType<typeof useFileQuery>;
export type FileLazyQueryHookResult = ReturnType<typeof useFileLazyQuery>;
export type FileQueryResult = Apollo.QueryResult<FileQuery, FileQueryVariables>;
export const FileTagDocument = gql`
    query FileTag($input: GetTagInput!) {
  fileTag(input: $input) {
    label
    isSystem
    fileCount
    parentTags {
      label
    }
    childTags {
      label
    }
  }
}
    `;

/**
 * __useFileTagQuery__
 *
 * To run a query within a React component, call `useFileTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileTagQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFileTagQuery(baseOptions: Apollo.QueryHookOptions<FileTagQuery, FileTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileTagQuery, FileTagQueryVariables>(FileTagDocument, options);
      }
export function useFileTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileTagQuery, FileTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileTagQuery, FileTagQueryVariables>(FileTagDocument, options);
        }
export type FileTagQueryHookResult = ReturnType<typeof useFileTagQuery>;
export type FileTagLazyQueryHookResult = ReturnType<typeof useFileTagLazyQuery>;
export type FileTagQueryResult = Apollo.QueryResult<FileTagQuery, FileTagQueryVariables>;
export const FileTagsDocument = gql`
    query FileTags($input: FindTagsInput!) {
  fileTags(input: $input) {
    label
    parentTags {
      label
    }
    childTags {
      label
    }
  }
}
    `;

/**
 * __useFileTagsQuery__
 *
 * To run a query within a React component, call `useFileTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFileTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFileTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFileTagsQuery(baseOptions: Apollo.QueryHookOptions<FileTagsQuery, FileTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FileTagsQuery, FileTagsQueryVariables>(FileTagsDocument, options);
      }
export function useFileTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FileTagsQuery, FileTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FileTagsQuery, FileTagsQueryVariables>(FileTagsDocument, options);
        }
export type FileTagsQueryHookResult = ReturnType<typeof useFileTagsQuery>;
export type FileTagsLazyQueryHookResult = ReturnType<typeof useFileTagsLazyQuery>;
export type FileTagsQueryResult = Apollo.QueryResult<FileTagsQuery, FileTagsQueryVariables>;
export const FilePathsDocument = gql`
    query FilePaths {
  paths
}
    `;

/**
 * __useFilePathsQuery__
 *
 * To run a query within a React component, call `useFilePathsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilePathsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilePathsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilePathsQuery(baseOptions?: Apollo.QueryHookOptions<FilePathsQuery, FilePathsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilePathsQuery, FilePathsQueryVariables>(FilePathsDocument, options);
      }
export function useFilePathsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilePathsQuery, FilePathsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilePathsQuery, FilePathsQueryVariables>(FilePathsDocument, options);
        }
export type FilePathsQueryHookResult = ReturnType<typeof useFilePathsQuery>;
export type FilePathsLazyQueryHookResult = ReturnType<typeof useFilePathsLazyQuery>;
export type FilePathsQueryResult = Apollo.QueryResult<FilePathsQuery, FilePathsQueryVariables>;
export const FilesDocument = gql`
    query Files($input: FindManyFileUploadInput!) {
  files(input: $input) {
    ...FileUpload
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useFilesQuery__
 *
 * To run a query within a React component, call `useFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilesQuery(baseOptions: Apollo.QueryHookOptions<FilesQuery, FilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
      }
export function useFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesQuery, FilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesQuery, FilesQueryVariables>(FilesDocument, options);
        }
export type FilesQueryHookResult = ReturnType<typeof useFilesQuery>;
export type FilesLazyQueryHookResult = ReturnType<typeof useFilesLazyQuery>;
export type FilesQueryResult = Apollo.QueryResult<FilesQuery, FilesQueryVariables>;
export const FilesByInsuredDocument = gql`
    query FilesByInsured($input: FindFilesByInsuredInput!) {
  filesByInsured(input: $input) {
    ...FileUpload
    keyDocumentRole
    uploader {
      id
      firstName
      lastName
    }
    labels {
      label
      isSystem
      parentTags {
        label
        parentTags {
          label
          parentTags {
            label
          }
        }
      }
    }
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useFilesByInsuredQuery__
 *
 * To run a query within a React component, call `useFilesByInsuredQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesByInsuredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesByInsuredQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilesByInsuredQuery(baseOptions: Apollo.QueryHookOptions<FilesByInsuredQuery, FilesByInsuredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesByInsuredQuery, FilesByInsuredQueryVariables>(FilesByInsuredDocument, options);
      }
export function useFilesByInsuredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesByInsuredQuery, FilesByInsuredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesByInsuredQuery, FilesByInsuredQueryVariables>(FilesByInsuredDocument, options);
        }
export type FilesByInsuredQueryHookResult = ReturnType<typeof useFilesByInsuredQuery>;
export type FilesByInsuredLazyQueryHookResult = ReturnType<typeof useFilesByInsuredLazyQuery>;
export type FilesByInsuredQueryResult = Apollo.QueryResult<FilesByInsuredQuery, FilesByInsuredQueryVariables>;
export const FilesByLabelDocument = gql`
    query FilesByLabel($input: FindFilesByLabelInput!) {
  filesByLabel(input: $input) {
    ...FileUpload
    uploader {
      id
      firstName
      lastName
    }
    labels {
      label
      isSystem
    }
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useFilesByLabelQuery__
 *
 * To run a query within a React component, call `useFilesByLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesByLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesByLabelQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilesByLabelQuery(baseOptions: Apollo.QueryHookOptions<FilesByLabelQuery, FilesByLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesByLabelQuery, FilesByLabelQueryVariables>(FilesByLabelDocument, options);
      }
export function useFilesByLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesByLabelQuery, FilesByLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesByLabelQuery, FilesByLabelQueryVariables>(FilesByLabelDocument, options);
        }
export type FilesByLabelQueryHookResult = ReturnType<typeof useFilesByLabelQuery>;
export type FilesByLabelLazyQueryHookResult = ReturnType<typeof useFilesByLabelLazyQuery>;
export type FilesByLabelQueryResult = Apollo.QueryResult<FilesByLabelQuery, FilesByLabelQueryVariables>;
export const FilesByUserDocument = gql`
    query FilesByUser($input: FindManyFileUploadByUserInput!) {
  filesByUser(input: $input) {
    ...FileUpload
    insured {
      id
      name
    }
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useFilesByUserQuery__
 *
 * To run a query within a React component, call `useFilesByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesByUserQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFilesByUserQuery(baseOptions: Apollo.QueryHookOptions<FilesByUserQuery, FilesByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesByUserQuery, FilesByUserQueryVariables>(FilesByUserDocument, options);
      }
export function useFilesByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesByUserQuery, FilesByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesByUserQuery, FilesByUserQueryVariables>(FilesByUserDocument, options);
        }
export type FilesByUserQueryHookResult = ReturnType<typeof useFilesByUserQuery>;
export type FilesByUserLazyQueryHookResult = ReturnType<typeof useFilesByUserLazyQuery>;
export type FilesByUserQueryResult = Apollo.QueryResult<FilesByUserQuery, FilesByUserQueryVariables>;
export const FindFileUploadDocument = gql`
    query FindFileUpload($input: FindFileInput!) {
  findFile(input: $input) {
    ...FileUpload
    labels {
      label
      isSystem
    }
    audience
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useFindFileUploadQuery__
 *
 * To run a query within a React component, call `useFindFileUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFileUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFileUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindFileUploadQuery(baseOptions: Apollo.QueryHookOptions<FindFileUploadQuery, FindFileUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFileUploadQuery, FindFileUploadQueryVariables>(FindFileUploadDocument, options);
      }
export function useFindFileUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFileUploadQuery, FindFileUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFileUploadQuery, FindFileUploadQueryVariables>(FindFileUploadDocument, options);
        }
export type FindFileUploadQueryHookResult = ReturnType<typeof useFindFileUploadQuery>;
export type FindFileUploadLazyQueryHookResult = ReturnType<typeof useFindFileUploadLazyQuery>;
export type FindFileUploadQueryResult = Apollo.QueryResult<FindFileUploadQuery, FindFileUploadQueryVariables>;
export const FindProductExclusionsDocument = gql`
    query FindProductExclusions($where: ProductExclusionWhere) {
  productExclusionsFind(where: $where) {
    id
    reason
    state
    naicsCode
    appetiteProduct {
      id
      carrierName
      carrierProductName
      marketType
    }
    submission {
      id
      opportunityId
    }
  }
}
    `;

/**
 * __useFindProductExclusionsQuery__
 *
 * To run a query within a React component, call `useFindProductExclusionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindProductExclusionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindProductExclusionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindProductExclusionsQuery(baseOptions?: Apollo.QueryHookOptions<FindProductExclusionsQuery, FindProductExclusionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindProductExclusionsQuery, FindProductExclusionsQueryVariables>(FindProductExclusionsDocument, options);
      }
export function useFindProductExclusionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindProductExclusionsQuery, FindProductExclusionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindProductExclusionsQuery, FindProductExclusionsQueryVariables>(FindProductExclusionsDocument, options);
        }
export type FindProductExclusionsQueryHookResult = ReturnType<typeof useFindProductExclusionsQuery>;
export type FindProductExclusionsLazyQueryHookResult = ReturnType<typeof useFindProductExclusionsLazyQuery>;
export type FindProductExclusionsQueryResult = Apollo.QueryResult<FindProductExclusionsQuery, FindProductExclusionsQueryVariables>;
export const CarriersDocument = gql`
    query Carriers {
  carriers {
    id
    name
    slug
  }
}
    `;

/**
 * __useCarriersQuery__
 *
 * To run a query within a React component, call `useCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCarriersQuery(baseOptions?: Apollo.QueryHookOptions<CarriersQuery, CarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarriersQuery, CarriersQueryVariables>(CarriersDocument, options);
      }
export function useCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarriersQuery, CarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarriersQuery, CarriersQueryVariables>(CarriersDocument, options);
        }
export type CarriersQueryHookResult = ReturnType<typeof useCarriersQuery>;
export type CarriersLazyQueryHookResult = ReturnType<typeof useCarriersLazyQuery>;
export type CarriersQueryResult = Apollo.QueryResult<CarriersQuery, CarriersQueryVariables>;
export const LinesOfBusinessDocument = gql`
    query LinesOfBusiness {
  linesOfBusiness {
    id
    displayName
    code
  }
}
    `;

/**
 * __useLinesOfBusinessQuery__
 *
 * To run a query within a React component, call `useLinesOfBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinesOfBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinesOfBusinessQuery({
 *   variables: {
 *   },
 * });
 */
export function useLinesOfBusinessQuery(baseOptions?: Apollo.QueryHookOptions<LinesOfBusinessQuery, LinesOfBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinesOfBusinessQuery, LinesOfBusinessQueryVariables>(LinesOfBusinessDocument, options);
      }
export function useLinesOfBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinesOfBusinessQuery, LinesOfBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinesOfBusinessQuery, LinesOfBusinessQueryVariables>(LinesOfBusinessDocument, options);
        }
export type LinesOfBusinessQueryHookResult = ReturnType<typeof useLinesOfBusinessQuery>;
export type LinesOfBusinessLazyQueryHookResult = ReturnType<typeof useLinesOfBusinessLazyQuery>;
export type LinesOfBusinessQueryResult = Apollo.QueryResult<LinesOfBusinessQuery, LinesOfBusinessQueryVariables>;
export const GroupedMarketingPlansDocument = gql`
    query GroupedMarketingPlans($input: GroupedMarketingPlansInput!) {
  groupedMarketingPlans(input: $input) {
    groupedMarketingPlans {
      insuredId
      insuredName
      insured {
        id
        name
        createdAt
        isoCglCodes
        agent {
          id
          firstName
          lastName
          email
          agency {
            id
            name
          }
        }
      }
      marketingPlans {
        id
        insuredId
        createdAt
        state
        desiredEffectiveDate
        lastTransitionAt
        selectedLinesOfBusiness
        broker {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useGroupedMarketingPlansQuery__
 *
 * To run a query within a React component, call `useGroupedMarketingPlansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedMarketingPlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedMarketingPlansQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupedMarketingPlansQuery(baseOptions: Apollo.QueryHookOptions<GroupedMarketingPlansQuery, GroupedMarketingPlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedMarketingPlansQuery, GroupedMarketingPlansQueryVariables>(GroupedMarketingPlansDocument, options);
      }
export function useGroupedMarketingPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedMarketingPlansQuery, GroupedMarketingPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedMarketingPlansQuery, GroupedMarketingPlansQueryVariables>(GroupedMarketingPlansDocument, options);
        }
export type GroupedMarketingPlansQueryHookResult = ReturnType<typeof useGroupedMarketingPlansQuery>;
export type GroupedMarketingPlansLazyQueryHookResult = ReturnType<typeof useGroupedMarketingPlansLazyQuery>;
export type GroupedMarketingPlansQueryResult = Apollo.QueryResult<GroupedMarketingPlansQuery, GroupedMarketingPlansQueryVariables>;
export const GroupedQuotesDocument = gql`
    query GroupedQuotes($input: GroupedQuotesInput!) {
  groupedQuotes(input: $input) {
    groupedQuotes {
      insuredId
      insuredName
      quotes {
        id
        insuredId
        state
        premium
        effectiveDate
        lastTransitionAt
        appetiteProduct {
          id
          carrierName
          carrierProductName
          marketType
        }
      }
    }
  }
}
    `;

/**
 * __useGroupedQuotesQuery__
 *
 * To run a query within a React component, call `useGroupedQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupedQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGroupedQuotesQuery(baseOptions: Apollo.QueryHookOptions<GroupedQuotesQuery, GroupedQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedQuotesQuery, GroupedQuotesQueryVariables>(GroupedQuotesDocument, options);
      }
export function useGroupedQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedQuotesQuery, GroupedQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedQuotesQuery, GroupedQuotesQueryVariables>(GroupedQuotesDocument, options);
        }
export type GroupedQuotesQueryHookResult = ReturnType<typeof useGroupedQuotesQuery>;
export type GroupedQuotesLazyQueryHookResult = ReturnType<typeof useGroupedQuotesLazyQuery>;
export type GroupedQuotesQueryResult = Apollo.QueryResult<GroupedQuotesQuery, GroupedQuotesQueryVariables>;
export const ImpersonatableAccountsDocument = gql`
    query ImpersonatableAccounts {
  impersonatableAccounts {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useImpersonatableAccountsQuery__
 *
 * To run a query within a React component, call `useImpersonatableAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpersonatableAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpersonatableAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useImpersonatableAccountsQuery(baseOptions?: Apollo.QueryHookOptions<ImpersonatableAccountsQuery, ImpersonatableAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpersonatableAccountsQuery, ImpersonatableAccountsQueryVariables>(ImpersonatableAccountsDocument, options);
      }
export function useImpersonatableAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpersonatableAccountsQuery, ImpersonatableAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpersonatableAccountsQuery, ImpersonatableAccountsQueryVariables>(ImpersonatableAccountsDocument, options);
        }
export type ImpersonatableAccountsQueryHookResult = ReturnType<typeof useImpersonatableAccountsQuery>;
export type ImpersonatableAccountsLazyQueryHookResult = ReturnType<typeof useImpersonatableAccountsLazyQuery>;
export type ImpersonatableAccountsQueryResult = Apollo.QueryResult<ImpersonatableAccountsQuery, ImpersonatableAccountsQueryVariables>;
export const InboxDocument = gql`
    query Inbox {
  inbox {
    id
    email
  }
}
    `;

/**
 * __useInboxQuery__
 *
 * To run a query within a React component, call `useInboxQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxQuery(baseOptions?: Apollo.QueryHookOptions<InboxQuery, InboxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxQuery, InboxQueryVariables>(InboxDocument, options);
      }
export function useInboxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxQuery, InboxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxQuery, InboxQueryVariables>(InboxDocument, options);
        }
export type InboxQueryHookResult = ReturnType<typeof useInboxQuery>;
export type InboxLazyQueryHookResult = ReturnType<typeof useInboxLazyQuery>;
export type InboxQueryResult = Apollo.QueryResult<InboxQuery, InboxQueryVariables>;
export const InboxAgencySearchDocument = gql`
    query InboxAgencySearch($input: SearchInboxAgenciesInput!) {
  inboxAgencySearch(input: $input) {
    ...InboxAgencySearchResult
  }
}
    ${InboxAgencySearchResultFragmentDoc}`;

/**
 * __useInboxAgencySearchQuery__
 *
 * To run a query within a React component, call `useInboxAgencySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxAgencySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxAgencySearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxAgencySearchQuery(baseOptions: Apollo.QueryHookOptions<InboxAgencySearchQuery, InboxAgencySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxAgencySearchQuery, InboxAgencySearchQueryVariables>(InboxAgencySearchDocument, options);
      }
export function useInboxAgencySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxAgencySearchQuery, InboxAgencySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxAgencySearchQuery, InboxAgencySearchQueryVariables>(InboxAgencySearchDocument, options);
        }
export type InboxAgencySearchQueryHookResult = ReturnType<typeof useInboxAgencySearchQuery>;
export type InboxAgencySearchLazyQueryHookResult = ReturnType<typeof useInboxAgencySearchLazyQuery>;
export type InboxAgencySearchQueryResult = Apollo.QueryResult<InboxAgencySearchQuery, InboxAgencySearchQueryVariables>;
export const InboxAgentDocument = gql`
    query InboxAgent($agentId: ID!) {
  inboxAgent(agentId: $agentId) {
    ...InboxAgentContact
  }
}
    ${InboxAgentContactFragmentDoc}`;

/**
 * __useInboxAgentQuery__
 *
 * To run a query within a React component, call `useInboxAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxAgentQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *   },
 * });
 */
export function useInboxAgentQuery(baseOptions: Apollo.QueryHookOptions<InboxAgentQuery, InboxAgentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxAgentQuery, InboxAgentQueryVariables>(InboxAgentDocument, options);
      }
export function useInboxAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxAgentQuery, InboxAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxAgentQuery, InboxAgentQueryVariables>(InboxAgentDocument, options);
        }
export type InboxAgentQueryHookResult = ReturnType<typeof useInboxAgentQuery>;
export type InboxAgentLazyQueryHookResult = ReturnType<typeof useInboxAgentLazyQuery>;
export type InboxAgentQueryResult = Apollo.QueryResult<InboxAgentQuery, InboxAgentQueryVariables>;
export const InboxAgentSearchDocument = gql`
    query InboxAgentSearch($input: SearchInboxAgentsInput!) {
  inboxAgentSearch(input: $input) {
    ...InboxAgentSearchResult
  }
}
    ${InboxAgentSearchResultFragmentDoc}`;

/**
 * __useInboxAgentSearchQuery__
 *
 * To run a query within a React component, call `useInboxAgentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxAgentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxAgentSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxAgentSearchQuery(baseOptions: Apollo.QueryHookOptions<InboxAgentSearchQuery, InboxAgentSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxAgentSearchQuery, InboxAgentSearchQueryVariables>(InboxAgentSearchDocument, options);
      }
export function useInboxAgentSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxAgentSearchQuery, InboxAgentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxAgentSearchQuery, InboxAgentSearchQueryVariables>(InboxAgentSearchDocument, options);
        }
export type InboxAgentSearchQueryHookResult = ReturnType<typeof useInboxAgentSearchQuery>;
export type InboxAgentSearchLazyQueryHookResult = ReturnType<typeof useInboxAgentSearchLazyQuery>;
export type InboxAgentSearchQueryResult = Apollo.QueryResult<InboxAgentSearchQuery, InboxAgentSearchQueryVariables>;
export const InboxContactsDocument = gql`
    query InboxContacts {
  inboxContacts {
    ...InboxContact
  }
}
    ${InboxContactFragmentDoc}`;

/**
 * __useInboxContactsQuery__
 *
 * To run a query within a React component, call `useInboxContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxContactsQuery(baseOptions?: Apollo.QueryHookOptions<InboxContactsQuery, InboxContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxContactsQuery, InboxContactsQueryVariables>(InboxContactsDocument, options);
      }
export function useInboxContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxContactsQuery, InboxContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxContactsQuery, InboxContactsQueryVariables>(InboxContactsDocument, options);
        }
export type InboxContactsQueryHookResult = ReturnType<typeof useInboxContactsQuery>;
export type InboxContactsLazyQueryHookResult = ReturnType<typeof useInboxContactsLazyQuery>;
export type InboxContactsQueryResult = Apollo.QueryResult<InboxContactsQuery, InboxContactsQueryVariables>;
export const InboxConversationDocument = gql`
    query InboxConversation($input: GetConversationInput!) {
  inboxConversation(input: $input) {
    ...InboxConversation
  }
}
    ${InboxConversationFragmentDoc}
${InboxInsuredFragmentDoc}
${InboxOpportunityFragmentDoc}
${InboxAgentActionFragmentDoc}
${InboxSubmissionFragmentDoc}
${FileUploadFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}`;

/**
 * __useInboxConversationQuery__
 *
 * To run a query within a React component, call `useInboxConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxConversationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxConversationQuery(baseOptions: Apollo.QueryHookOptions<InboxConversationQuery, InboxConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxConversationQuery, InboxConversationQueryVariables>(InboxConversationDocument, options);
      }
export function useInboxConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxConversationQuery, InboxConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxConversationQuery, InboxConversationQueryVariables>(InboxConversationDocument, options);
        }
export type InboxConversationQueryHookResult = ReturnType<typeof useInboxConversationQuery>;
export type InboxConversationLazyQueryHookResult = ReturnType<typeof useInboxConversationLazyQuery>;
export type InboxConversationQueryResult = Apollo.QueryResult<InboxConversationQuery, InboxConversationQueryVariables>;
export const InboxConversationMessageBodiesDocument = gql`
    query InboxConversationMessageBodies($input: GetConversationInput!) {
  inboxConversationMessageBodies(input: $input) {
    ...InboxFullMessage
  }
}
    ${InboxFullMessageFragmentDoc}`;

/**
 * __useInboxConversationMessageBodiesQuery__
 *
 * To run a query within a React component, call `useInboxConversationMessageBodiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxConversationMessageBodiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxConversationMessageBodiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxConversationMessageBodiesQuery(baseOptions: Apollo.QueryHookOptions<InboxConversationMessageBodiesQuery, InboxConversationMessageBodiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxConversationMessageBodiesQuery, InboxConversationMessageBodiesQueryVariables>(InboxConversationMessageBodiesDocument, options);
      }
export function useInboxConversationMessageBodiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxConversationMessageBodiesQuery, InboxConversationMessageBodiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxConversationMessageBodiesQuery, InboxConversationMessageBodiesQueryVariables>(InboxConversationMessageBodiesDocument, options);
        }
export type InboxConversationMessageBodiesQueryHookResult = ReturnType<typeof useInboxConversationMessageBodiesQuery>;
export type InboxConversationMessageBodiesLazyQueryHookResult = ReturnType<typeof useInboxConversationMessageBodiesLazyQuery>;
export type InboxConversationMessageBodiesQueryResult = Apollo.QueryResult<InboxConversationMessageBodiesQuery, InboxConversationMessageBodiesQueryVariables>;
export const InboxConversationsDocument = gql`
    query InboxConversations($input: GetConversationsInput!) {
  inboxConversations(input: $input) {
    conversations {
      ...InboxConversationsListConversation
    }
    numRecords
    numPages
  }
}
    ${InboxConversationsListConversationFragmentDoc}
${InboxConversationsConversationFragmentDoc}`;

/**
 * __useInboxConversationsQuery__
 *
 * To run a query within a React component, call `useInboxConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxConversationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxConversationsQuery(baseOptions: Apollo.QueryHookOptions<InboxConversationsQuery, InboxConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxConversationsQuery, InboxConversationsQueryVariables>(InboxConversationsDocument, options);
      }
export function useInboxConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxConversationsQuery, InboxConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxConversationsQuery, InboxConversationsQueryVariables>(InboxConversationsDocument, options);
        }
export type InboxConversationsQueryHookResult = ReturnType<typeof useInboxConversationsQuery>;
export type InboxConversationsLazyQueryHookResult = ReturnType<typeof useInboxConversationsLazyQuery>;
export type InboxConversationsQueryResult = Apollo.QueryResult<InboxConversationsQuery, InboxConversationsQueryVariables>;
export const InboxConversationsByOpportunityDocument = gql`
    query InboxConversationsByOpportunity($input: GetConversationsByOpportunityInput!) {
  inboxConversationsByOpportunity(input: $input) {
    ...InboxConversationsByOpportunityConversation
    messages {
      ...InboxMessage
    }
  }
}
    ${InboxConversationsByOpportunityConversationFragmentDoc}
${InboxMessageFragmentDoc}
${MessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;

/**
 * __useInboxConversationsByOpportunityQuery__
 *
 * To run a query within a React component, call `useInboxConversationsByOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxConversationsByOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxConversationsByOpportunityQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxConversationsByOpportunityQuery(baseOptions: Apollo.QueryHookOptions<InboxConversationsByOpportunityQuery, InboxConversationsByOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxConversationsByOpportunityQuery, InboxConversationsByOpportunityQueryVariables>(InboxConversationsByOpportunityDocument, options);
      }
export function useInboxConversationsByOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxConversationsByOpportunityQuery, InboxConversationsByOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxConversationsByOpportunityQuery, InboxConversationsByOpportunityQueryVariables>(InboxConversationsByOpportunityDocument, options);
        }
export type InboxConversationsByOpportunityQueryHookResult = ReturnType<typeof useInboxConversationsByOpportunityQuery>;
export type InboxConversationsByOpportunityLazyQueryHookResult = ReturnType<typeof useInboxConversationsByOpportunityLazyQuery>;
export type InboxConversationsByOpportunityQueryResult = Apollo.QueryResult<InboxConversationsByOpportunityQuery, InboxConversationsByOpportunityQueryVariables>;
export const InboxDraftDocument = gql`
    query InboxDraft($id: ID!) {
  inboxDraft(id: $id) {
    ...DraftMessage
    opportunityId
    insuredId
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;

/**
 * __useInboxDraftQuery__
 *
 * To run a query within a React component, call `useInboxDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInboxDraftQuery(baseOptions: Apollo.QueryHookOptions<InboxDraftQuery, InboxDraftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxDraftQuery, InboxDraftQueryVariables>(InboxDraftDocument, options);
      }
export function useInboxDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxDraftQuery, InboxDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxDraftQuery, InboxDraftQueryVariables>(InboxDraftDocument, options);
        }
export type InboxDraftQueryHookResult = ReturnType<typeof useInboxDraftQuery>;
export type InboxDraftLazyQueryHookResult = ReturnType<typeof useInboxDraftLazyQuery>;
export type InboxDraftQueryResult = Apollo.QueryResult<InboxDraftQuery, InboxDraftQueryVariables>;
export const InboxDraftAttachmentsDocument = gql`
    query InboxDraftAttachments($id: ID!) {
  inboxDraftAttachments(id: $id) {
    attachments {
      ...DraftMessageAttachment
    }
    sizeSummary {
      totalSize
      sizeLimit
      exceedsSizeLimit
      isNearSizeLimit
    }
  }
}
    ${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;

/**
 * __useInboxDraftAttachmentsQuery__
 *
 * To run a query within a React component, call `useInboxDraftAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInboxDraftAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<InboxDraftAttachmentsQuery, InboxDraftAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxDraftAttachmentsQuery, InboxDraftAttachmentsQueryVariables>(InboxDraftAttachmentsDocument, options);
      }
export function useInboxDraftAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxDraftAttachmentsQuery, InboxDraftAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxDraftAttachmentsQuery, InboxDraftAttachmentsQueryVariables>(InboxDraftAttachmentsDocument, options);
        }
export type InboxDraftAttachmentsQueryHookResult = ReturnType<typeof useInboxDraftAttachmentsQuery>;
export type InboxDraftAttachmentsLazyQueryHookResult = ReturnType<typeof useInboxDraftAttachmentsLazyQuery>;
export type InboxDraftAttachmentsQueryResult = Apollo.QueryResult<InboxDraftAttachmentsQuery, InboxDraftAttachmentsQueryVariables>;
export const InboxDraftSignatureDocument = gql`
    query InboxDraftSignature {
  inboxDraftSignature {
    signature
  }
}
    `;

/**
 * __useInboxDraftSignatureQuery__
 *
 * To run a query within a React component, call `useInboxDraftSignatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftSignatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftSignatureQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxDraftSignatureQuery(baseOptions?: Apollo.QueryHookOptions<InboxDraftSignatureQuery, InboxDraftSignatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxDraftSignatureQuery, InboxDraftSignatureQueryVariables>(InboxDraftSignatureDocument, options);
      }
export function useInboxDraftSignatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxDraftSignatureQuery, InboxDraftSignatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxDraftSignatureQuery, InboxDraftSignatureQueryVariables>(InboxDraftSignatureDocument, options);
        }
export type InboxDraftSignatureQueryHookResult = ReturnType<typeof useInboxDraftSignatureQuery>;
export type InboxDraftSignatureLazyQueryHookResult = ReturnType<typeof useInboxDraftSignatureLazyQuery>;
export type InboxDraftSignatureQueryResult = Apollo.QueryResult<InboxDraftSignatureQuery, InboxDraftSignatureQueryVariables>;
export const InboxDraftsDocument = gql`
    query InboxDrafts($input: FindDraftsForEmailInputDto!) {
  inboxDrafts(input: $input) {
    drafts {
      ...DraftMessage
    }
    numRecords
    numPages
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;

/**
 * __useInboxDraftsQuery__
 *
 * To run a query within a React component, call `useInboxDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxDraftsQuery(baseOptions: Apollo.QueryHookOptions<InboxDraftsQuery, InboxDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxDraftsQuery, InboxDraftsQueryVariables>(InboxDraftsDocument, options);
      }
export function useInboxDraftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxDraftsQuery, InboxDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxDraftsQuery, InboxDraftsQueryVariables>(InboxDraftsDocument, options);
        }
export type InboxDraftsQueryHookResult = ReturnType<typeof useInboxDraftsQuery>;
export type InboxDraftsLazyQueryHookResult = ReturnType<typeof useInboxDraftsLazyQuery>;
export type InboxDraftsQueryResult = Apollo.QueryResult<InboxDraftsQuery, InboxDraftsQueryVariables>;
export const InboxDraftsCountDocument = gql`
    query InboxDraftsCount($input: FindDraftsForEmailInputDto!) {
  inboxDraftsCount(input: $input)
}
    `;

/**
 * __useInboxDraftsCountQuery__
 *
 * To run a query within a React component, call `useInboxDraftsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxDraftsCountQuery(baseOptions: Apollo.QueryHookOptions<InboxDraftsCountQuery, InboxDraftsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxDraftsCountQuery, InboxDraftsCountQueryVariables>(InboxDraftsCountDocument, options);
      }
export function useInboxDraftsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxDraftsCountQuery, InboxDraftsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxDraftsCountQuery, InboxDraftsCountQueryVariables>(InboxDraftsCountDocument, options);
        }
export type InboxDraftsCountQueryHookResult = ReturnType<typeof useInboxDraftsCountQuery>;
export type InboxDraftsCountLazyQueryHookResult = ReturnType<typeof useInboxDraftsCountLazyQuery>;
export type InboxDraftsCountQueryResult = Apollo.QueryResult<InboxDraftsCountQuery, InboxDraftsCountQueryVariables>;
export const InboxDraftsFailedScheduledSendsCountDocument = gql`
    query InboxDraftsFailedScheduledSendsCount {
  inboxDraftsFailedScheduledSendsCount
}
    `;

/**
 * __useInboxDraftsFailedScheduledSendsCountQuery__
 *
 * To run a query within a React component, call `useInboxDraftsFailedScheduledSendsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftsFailedScheduledSendsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftsFailedScheduledSendsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxDraftsFailedScheduledSendsCountQuery(baseOptions?: Apollo.QueryHookOptions<InboxDraftsFailedScheduledSendsCountQuery, InboxDraftsFailedScheduledSendsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxDraftsFailedScheduledSendsCountQuery, InboxDraftsFailedScheduledSendsCountQueryVariables>(InboxDraftsFailedScheduledSendsCountDocument, options);
      }
export function useInboxDraftsFailedScheduledSendsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxDraftsFailedScheduledSendsCountQuery, InboxDraftsFailedScheduledSendsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxDraftsFailedScheduledSendsCountQuery, InboxDraftsFailedScheduledSendsCountQueryVariables>(InboxDraftsFailedScheduledSendsCountDocument, options);
        }
export type InboxDraftsFailedScheduledSendsCountQueryHookResult = ReturnType<typeof useInboxDraftsFailedScheduledSendsCountQuery>;
export type InboxDraftsFailedScheduledSendsCountLazyQueryHookResult = ReturnType<typeof useInboxDraftsFailedScheduledSendsCountLazyQuery>;
export type InboxDraftsFailedScheduledSendsCountQueryResult = Apollo.QueryResult<InboxDraftsFailedScheduledSendsCountQuery, InboxDraftsFailedScheduledSendsCountQueryVariables>;
export const InboxInsuredDocument = gql`
    query InboxInsured($id: ID!) {
  insured(id: $id) {
    ...InboxInsured
    ...InboxInsuredDetail
  }
}
    ${InboxInsuredFragmentDoc}
${InboxInsuredDetailFragmentDoc}
${UserAccountFragmentDoc}`;

/**
 * __useInboxInsuredQuery__
 *
 * To run a query within a React component, call `useInboxInsuredQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxInsuredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxInsuredQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInboxInsuredQuery(baseOptions: Apollo.QueryHookOptions<InboxInsuredQuery, InboxInsuredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxInsuredQuery, InboxInsuredQueryVariables>(InboxInsuredDocument, options);
      }
export function useInboxInsuredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxInsuredQuery, InboxInsuredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxInsuredQuery, InboxInsuredQueryVariables>(InboxInsuredDocument, options);
        }
export type InboxInsuredQueryHookResult = ReturnType<typeof useInboxInsuredQuery>;
export type InboxInsuredLazyQueryHookResult = ReturnType<typeof useInboxInsuredLazyQuery>;
export type InboxInsuredQueryResult = Apollo.QueryResult<InboxInsuredQuery, InboxInsuredQueryVariables>;
export const InboxLabelUnreadCountsDocument = gql`
    query InboxLabelUnreadCounts($input: GetLabelUnreadCountsInput!) {
  inboxLabelUnreadCounts(input: $input) {
    label
    count
  }
}
    `;

/**
 * __useInboxLabelUnreadCountsQuery__
 *
 * To run a query within a React component, call `useInboxLabelUnreadCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxLabelUnreadCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxLabelUnreadCountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxLabelUnreadCountsQuery(baseOptions: Apollo.QueryHookOptions<InboxLabelUnreadCountsQuery, InboxLabelUnreadCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxLabelUnreadCountsQuery, InboxLabelUnreadCountsQueryVariables>(InboxLabelUnreadCountsDocument, options);
      }
export function useInboxLabelUnreadCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxLabelUnreadCountsQuery, InboxLabelUnreadCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxLabelUnreadCountsQuery, InboxLabelUnreadCountsQueryVariables>(InboxLabelUnreadCountsDocument, options);
        }
export type InboxLabelUnreadCountsQueryHookResult = ReturnType<typeof useInboxLabelUnreadCountsQuery>;
export type InboxLabelUnreadCountsLazyQueryHookResult = ReturnType<typeof useInboxLabelUnreadCountsLazyQuery>;
export type InboxLabelUnreadCountsQueryResult = Apollo.QueryResult<InboxLabelUnreadCountsQuery, InboxLabelUnreadCountsQueryVariables>;
export const InboxLabelsDocument = gql`
    query InboxLabels {
  inboxLabels {
    ...InboxLabel
  }
}
    ${InboxLabelFragmentDoc}`;

/**
 * __useInboxLabelsQuery__
 *
 * To run a query within a React component, call `useInboxLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxLabelsQuery(baseOptions?: Apollo.QueryHookOptions<InboxLabelsQuery, InboxLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxLabelsQuery, InboxLabelsQueryVariables>(InboxLabelsDocument, options);
      }
export function useInboxLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxLabelsQuery, InboxLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxLabelsQuery, InboxLabelsQueryVariables>(InboxLabelsDocument, options);
        }
export type InboxLabelsQueryHookResult = ReturnType<typeof useInboxLabelsQuery>;
export type InboxLabelsLazyQueryHookResult = ReturnType<typeof useInboxLabelsLazyQuery>;
export type InboxLabelsQueryResult = Apollo.QueryResult<InboxLabelsQuery, InboxLabelsQueryVariables>;
export const InboxMailHorizonDocument = gql`
    query InboxMailHorizon {
  inbox {
    id
    earliestMessageAt
  }
}
    `;

/**
 * __useInboxMailHorizonQuery__
 *
 * To run a query within a React component, call `useInboxMailHorizonQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxMailHorizonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMailHorizonQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxMailHorizonQuery(baseOptions?: Apollo.QueryHookOptions<InboxMailHorizonQuery, InboxMailHorizonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxMailHorizonQuery, InboxMailHorizonQueryVariables>(InboxMailHorizonDocument, options);
      }
export function useInboxMailHorizonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxMailHorizonQuery, InboxMailHorizonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxMailHorizonQuery, InboxMailHorizonQueryVariables>(InboxMailHorizonDocument, options);
        }
export type InboxMailHorizonQueryHookResult = ReturnType<typeof useInboxMailHorizonQuery>;
export type InboxMailHorizonLazyQueryHookResult = ReturnType<typeof useInboxMailHorizonLazyQuery>;
export type InboxMailHorizonQueryResult = Apollo.QueryResult<InboxMailHorizonQuery, InboxMailHorizonQueryVariables>;
export const InboxMessageDocument = gql`
    query InboxMessage($input: GetMessageByIdInput!) {
  inboxMessage(input: $input) {
    ...InboxFullMessage
  }
}
    ${InboxFullMessageFragmentDoc}`;

/**
 * __useInboxMessageQuery__
 *
 * To run a query within a React component, call `useInboxMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMessageQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxMessageQuery(baseOptions: Apollo.QueryHookOptions<InboxMessageQuery, InboxMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxMessageQuery, InboxMessageQueryVariables>(InboxMessageDocument, options);
      }
export function useInboxMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxMessageQuery, InboxMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxMessageQuery, InboxMessageQueryVariables>(InboxMessageDocument, options);
        }
export type InboxMessageQueryHookResult = ReturnType<typeof useInboxMessageQuery>;
export type InboxMessageLazyQueryHookResult = ReturnType<typeof useInboxMessageLazyQuery>;
export type InboxMessageQueryResult = Apollo.QueryResult<InboxMessageQuery, InboxMessageQueryVariables>;
export const InboxMessageClassificationsDocument = gql`
    query InboxMessageClassifications {
  inboxMessageClassifications {
    id
    label
    description
    autoRunPlaybook
    source
    associatedPlaybookId
    playbook {
      id
      name
    }
  }
}
    `;

/**
 * __useInboxMessageClassificationsQuery__
 *
 * To run a query within a React component, call `useInboxMessageClassificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxMessageClassificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMessageClassificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxMessageClassificationsQuery(baseOptions?: Apollo.QueryHookOptions<InboxMessageClassificationsQuery, InboxMessageClassificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxMessageClassificationsQuery, InboxMessageClassificationsQueryVariables>(InboxMessageClassificationsDocument, options);
      }
export function useInboxMessageClassificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxMessageClassificationsQuery, InboxMessageClassificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxMessageClassificationsQuery, InboxMessageClassificationsQueryVariables>(InboxMessageClassificationsDocument, options);
        }
export type InboxMessageClassificationsQueryHookResult = ReturnType<typeof useInboxMessageClassificationsQuery>;
export type InboxMessageClassificationsLazyQueryHookResult = ReturnType<typeof useInboxMessageClassificationsLazyQuery>;
export type InboxMessageClassificationsQueryResult = Apollo.QueryResult<InboxMessageClassificationsQuery, InboxMessageClassificationsQueryVariables>;
export const InboxSearchSuggestionsDocument = gql`
    query InboxSearchSuggestions($input: GetConversationsInput!) {
  inboxConversations(input: $input) {
    conversations {
      ...InboxSearchSuggestionConversation
    }
  }
}
    ${InboxSearchSuggestionConversationFragmentDoc}`;

/**
 * __useInboxSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useInboxSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxSearchSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInboxSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<InboxSearchSuggestionsQuery, InboxSearchSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxSearchSuggestionsQuery, InboxSearchSuggestionsQueryVariables>(InboxSearchSuggestionsDocument, options);
      }
export function useInboxSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxSearchSuggestionsQuery, InboxSearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxSearchSuggestionsQuery, InboxSearchSuggestionsQueryVariables>(InboxSearchSuggestionsDocument, options);
        }
export type InboxSearchSuggestionsQueryHookResult = ReturnType<typeof useInboxSearchSuggestionsQuery>;
export type InboxSearchSuggestionsLazyQueryHookResult = ReturnType<typeof useInboxSearchSuggestionsLazyQuery>;
export type InboxSearchSuggestionsQueryResult = Apollo.QueryResult<InboxSearchSuggestionsQuery, InboxSearchSuggestionsQueryVariables>;
export const InboxUnreadDocument = gql`
    query InboxUnread {
  inboxUnread
}
    `;

/**
 * __useInboxUnreadQuery__
 *
 * To run a query within a React component, call `useInboxUnreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxUnreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxUnreadQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxUnreadQuery(baseOptions?: Apollo.QueryHookOptions<InboxUnreadQuery, InboxUnreadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxUnreadQuery, InboxUnreadQueryVariables>(InboxUnreadDocument, options);
      }
export function useInboxUnreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxUnreadQuery, InboxUnreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxUnreadQuery, InboxUnreadQueryVariables>(InboxUnreadDocument, options);
        }
export type InboxUnreadQueryHookResult = ReturnType<typeof useInboxUnreadQuery>;
export type InboxUnreadLazyQueryHookResult = ReturnType<typeof useInboxUnreadLazyQuery>;
export type InboxUnreadQueryResult = Apollo.QueryResult<InboxUnreadQuery, InboxUnreadQueryVariables>;
export const InboxesDocument = gql`
    query Inboxes {
  inboxes {
    id
    email
  }
}
    `;

/**
 * __useInboxesQuery__
 *
 * To run a query within a React component, call `useInboxesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInboxesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInboxesQuery(baseOptions?: Apollo.QueryHookOptions<InboxesQuery, InboxesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InboxesQuery, InboxesQueryVariables>(InboxesDocument, options);
      }
export function useInboxesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InboxesQuery, InboxesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InboxesQuery, InboxesQueryVariables>(InboxesDocument, options);
        }
export type InboxesQueryHookResult = ReturnType<typeof useInboxesQuery>;
export type InboxesLazyQueryHookResult = ReturnType<typeof useInboxesLazyQuery>;
export type InboxesQueryResult = Apollo.QueryResult<InboxesQuery, InboxesQueryVariables>;
export const InformationRequestEmailDraftDocument = gql`
    query InformationRequestEmailDraft($opportunityId: ID!, $draftEmailId: ID!) {
  informationRequestDraft(
    opportunityId: $opportunityId
    draftEmailId: $draftEmailId
  ) {
    ...DraftMessage
    opportunityId
    insuredId
    sentAt
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;

/**
 * __useInformationRequestEmailDraftQuery__
 *
 * To run a query within a React component, call `useInformationRequestEmailDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useInformationRequestEmailDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInformationRequestEmailDraftQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      draftEmailId: // value for 'draftEmailId'
 *   },
 * });
 */
export function useInformationRequestEmailDraftQuery(baseOptions: Apollo.QueryHookOptions<InformationRequestEmailDraftQuery, InformationRequestEmailDraftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InformationRequestEmailDraftQuery, InformationRequestEmailDraftQueryVariables>(InformationRequestEmailDraftDocument, options);
      }
export function useInformationRequestEmailDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InformationRequestEmailDraftQuery, InformationRequestEmailDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InformationRequestEmailDraftQuery, InformationRequestEmailDraftQueryVariables>(InformationRequestEmailDraftDocument, options);
        }
export type InformationRequestEmailDraftQueryHookResult = ReturnType<typeof useInformationRequestEmailDraftQuery>;
export type InformationRequestEmailDraftLazyQueryHookResult = ReturnType<typeof useInformationRequestEmailDraftLazyQuery>;
export type InformationRequestEmailDraftQueryResult = Apollo.QueryResult<InformationRequestEmailDraftQuery, InformationRequestEmailDraftQueryVariables>;
export const UpdateInformationRequestDraftDocument = gql`
    mutation UpdateInformationRequestDraft($input: UpdateInformationRequestDraftInput!) {
  updateInformationRequestDraft(input: $input) {
    ...DraftMessage
    opportunityId
    insuredId
    sentAt
  }
}
    ${DraftMessageFragmentDoc}
${DraftMessageAttachmentFragmentDoc}
${FileUploadFragmentDoc}`;
export type UpdateInformationRequestDraftMutationFn = Apollo.MutationFunction<UpdateInformationRequestDraftMutation, UpdateInformationRequestDraftMutationVariables>;

/**
 * __useUpdateInformationRequestDraftMutation__
 *
 * To run a mutation, you first call `useUpdateInformationRequestDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInformationRequestDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInformationRequestDraftMutation, { data, loading, error }] = useUpdateInformationRequestDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInformationRequestDraftMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInformationRequestDraftMutation, UpdateInformationRequestDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInformationRequestDraftMutation, UpdateInformationRequestDraftMutationVariables>(UpdateInformationRequestDraftDocument, options);
      }
export type UpdateInformationRequestDraftMutationHookResult = ReturnType<typeof useUpdateInformationRequestDraftMutation>;
export type UpdateInformationRequestDraftMutationResult = Apollo.MutationResult<UpdateInformationRequestDraftMutation>;
export type UpdateInformationRequestDraftMutationOptions = Apollo.BaseMutationOptions<UpdateInformationRequestDraftMutation, UpdateInformationRequestDraftMutationVariables>;
export const InspectionOrderByPolicyDocument = gql`
    query InspectionOrderByPolicy($policyId: ID!) {
  inspectionOrderByPolicy(policyId: $policyId) {
    ...InspectionOrder
  }
}
    ${InspectionOrderFragmentDoc}`;

/**
 * __useInspectionOrderByPolicyQuery__
 *
 * To run a query within a React component, call `useInspectionOrderByPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionOrderByPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionOrderByPolicyQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useInspectionOrderByPolicyQuery(baseOptions: Apollo.QueryHookOptions<InspectionOrderByPolicyQuery, InspectionOrderByPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionOrderByPolicyQuery, InspectionOrderByPolicyQueryVariables>(InspectionOrderByPolicyDocument, options);
      }
export function useInspectionOrderByPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionOrderByPolicyQuery, InspectionOrderByPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionOrderByPolicyQuery, InspectionOrderByPolicyQueryVariables>(InspectionOrderByPolicyDocument, options);
        }
export type InspectionOrderByPolicyQueryHookResult = ReturnType<typeof useInspectionOrderByPolicyQuery>;
export type InspectionOrderByPolicyLazyQueryHookResult = ReturnType<typeof useInspectionOrderByPolicyLazyQuery>;
export type InspectionOrderByPolicyQueryResult = Apollo.QueryResult<InspectionOrderByPolicyQuery, InspectionOrderByPolicyQueryVariables>;
export const InspectionOrderMuellerCaseDocument = gql`
    query InspectionOrderMuellerCase($inspectionOrderId: ID!) {
  inspectionOrderMuellerCase(inspectionOrderId: $inspectionOrderId) {
    orderId
    status
    fieldAppointmentDate
    fieldRepresentativeName
    surveyRemarks
  }
}
    `;

/**
 * __useInspectionOrderMuellerCaseQuery__
 *
 * To run a query within a React component, call `useInspectionOrderMuellerCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionOrderMuellerCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionOrderMuellerCaseQuery({
 *   variables: {
 *      inspectionOrderId: // value for 'inspectionOrderId'
 *   },
 * });
 */
export function useInspectionOrderMuellerCaseQuery(baseOptions: Apollo.QueryHookOptions<InspectionOrderMuellerCaseQuery, InspectionOrderMuellerCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionOrderMuellerCaseQuery, InspectionOrderMuellerCaseQueryVariables>(InspectionOrderMuellerCaseDocument, options);
      }
export function useInspectionOrderMuellerCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionOrderMuellerCaseQuery, InspectionOrderMuellerCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionOrderMuellerCaseQuery, InspectionOrderMuellerCaseQueryVariables>(InspectionOrderMuellerCaseDocument, options);
        }
export type InspectionOrderMuellerCaseQueryHookResult = ReturnType<typeof useInspectionOrderMuellerCaseQuery>;
export type InspectionOrderMuellerCaseLazyQueryHookResult = ReturnType<typeof useInspectionOrderMuellerCaseLazyQuery>;
export type InspectionOrderMuellerCaseQueryResult = Apollo.QueryResult<InspectionOrderMuellerCaseQuery, InspectionOrderMuellerCaseQueryVariables>;
export const InspectionReportsDocument = gql`
    query InspectionReports($inspectionOrderId: ID!) {
  inspectionReports(inspectionOrderId: $inspectionOrderId) {
    ...InspectionReport
  }
}
    ${InspectionReportFragmentDoc}
${InspectionRecFragmentDoc}`;

/**
 * __useInspectionReportsQuery__
 *
 * To run a query within a React component, call `useInspectionReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionReportsQuery({
 *   variables: {
 *      inspectionOrderId: // value for 'inspectionOrderId'
 *   },
 * });
 */
export function useInspectionReportsQuery(baseOptions: Apollo.QueryHookOptions<InspectionReportsQuery, InspectionReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionReportsQuery, InspectionReportsQueryVariables>(InspectionReportsDocument, options);
      }
export function useInspectionReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionReportsQuery, InspectionReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionReportsQuery, InspectionReportsQueryVariables>(InspectionReportsDocument, options);
        }
export type InspectionReportsQueryHookResult = ReturnType<typeof useInspectionReportsQuery>;
export type InspectionReportsLazyQueryHookResult = ReturnType<typeof useInspectionReportsLazyQuery>;
export type InspectionReportsQueryResult = Apollo.QueryResult<InspectionReportsQuery, InspectionReportsQueryVariables>;
export const InsuredDocument = gql`
    query Insured($id: ID!) {
  insured(id: $id) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;

/**
 * __useInsuredQuery__
 *
 * To run a query within a React component, call `useInsuredQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsuredQuery(baseOptions: Apollo.QueryHookOptions<InsuredQuery, InsuredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredQuery, InsuredQueryVariables>(InsuredDocument, options);
      }
export function useInsuredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredQuery, InsuredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredQuery, InsuredQueryVariables>(InsuredDocument, options);
        }
export type InsuredQueryHookResult = ReturnType<typeof useInsuredQuery>;
export type InsuredLazyQueryHookResult = ReturnType<typeof useInsuredLazyQuery>;
export type InsuredQueryResult = Apollo.QueryResult<InsuredQuery, InsuredQueryVariables>;
export const InsuredAcquisitionDocument = gql`
    query InsuredAcquisition($id: ID!) {
  insured(id: $id) {
    id
    acquisition {
      canViewTransfer
      acquired {
        runId
        bookType
        movedAt
        acquiringAgencyId
        acquiringAgencyName
        sellingAgencyName
        insuredId
        originalInsuredId
        originalInsuredName
      }
      transferredOut {
        runId
        movedAt
        acquiringAgencyId
        acquiringAgencyName
        destinationInsuredId
        policyNumbers
        policyCount
        originalOpportunityIds
      }
    }
  }
}
    `;

/**
 * __useInsuredAcquisitionQuery__
 *
 * To run a query within a React component, call `useInsuredAcquisitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredAcquisitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredAcquisitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsuredAcquisitionQuery(baseOptions: Apollo.QueryHookOptions<InsuredAcquisitionQuery, InsuredAcquisitionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredAcquisitionQuery, InsuredAcquisitionQueryVariables>(InsuredAcquisitionDocument, options);
      }
export function useInsuredAcquisitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredAcquisitionQuery, InsuredAcquisitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredAcquisitionQuery, InsuredAcquisitionQueryVariables>(InsuredAcquisitionDocument, options);
        }
export type InsuredAcquisitionQueryHookResult = ReturnType<typeof useInsuredAcquisitionQuery>;
export type InsuredAcquisitionLazyQueryHookResult = ReturnType<typeof useInsuredAcquisitionLazyQuery>;
export type InsuredAcquisitionQueryResult = Apollo.QueryResult<InsuredAcquisitionQuery, InsuredAcquisitionQueryVariables>;
export const InsuredAcquisitionsDocument = gql`
    query InsuredAcquisitions($insuredIds: [UUID!]!) {
  insuredAcquisitions(insuredIds: $insuredIds) {
    insuredId
    runId
    bookType
    movedAt
    sellingAgencyName
    originalInsuredId
    originalInsuredName
  }
}
    `;

/**
 * __useInsuredAcquisitionsQuery__
 *
 * To run a query within a React component, call `useInsuredAcquisitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredAcquisitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredAcquisitionsQuery({
 *   variables: {
 *      insuredIds: // value for 'insuredIds'
 *   },
 * });
 */
export function useInsuredAcquisitionsQuery(baseOptions: Apollo.QueryHookOptions<InsuredAcquisitionsQuery, InsuredAcquisitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredAcquisitionsQuery, InsuredAcquisitionsQueryVariables>(InsuredAcquisitionsDocument, options);
      }
export function useInsuredAcquisitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredAcquisitionsQuery, InsuredAcquisitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredAcquisitionsQuery, InsuredAcquisitionsQueryVariables>(InsuredAcquisitionsDocument, options);
        }
export type InsuredAcquisitionsQueryHookResult = ReturnType<typeof useInsuredAcquisitionsQuery>;
export type InsuredAcquisitionsLazyQueryHookResult = ReturnType<typeof useInsuredAcquisitionsLazyQuery>;
export type InsuredAcquisitionsQueryResult = Apollo.QueryResult<InsuredAcquisitionsQuery, InsuredAcquisitionsQueryVariables>;
export const InsuredFileTagsDocument = gql`
    query InsuredFileTags($input: FindTagsInput!, $insuredId: ID!) {
  fileTags(input: $input) {
    label
    hasFile(insuredId: $insuredId)
    parentTags {
      label
    }
    childTags {
      label
    }
  }
}
    `;

/**
 * __useInsuredFileTagsQuery__
 *
 * To run a query within a React component, call `useInsuredFileTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredFileTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredFileTagsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      insuredId: // value for 'insuredId'
 *   },
 * });
 */
export function useInsuredFileTagsQuery(baseOptions: Apollo.QueryHookOptions<InsuredFileTagsQuery, InsuredFileTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredFileTagsQuery, InsuredFileTagsQueryVariables>(InsuredFileTagsDocument, options);
      }
export function useInsuredFileTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredFileTagsQuery, InsuredFileTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredFileTagsQuery, InsuredFileTagsQueryVariables>(InsuredFileTagsDocument, options);
        }
export type InsuredFileTagsQueryHookResult = ReturnType<typeof useInsuredFileTagsQuery>;
export type InsuredFileTagsLazyQueryHookResult = ReturnType<typeof useInsuredFileTagsLazyQuery>;
export type InsuredFileTagsQueryResult = Apollo.QueryResult<InsuredFileTagsQuery, InsuredFileTagsQueryVariables>;
export const InsuredMergeDriveFailuresDocument = gql`
    query InsuredMergeDriveFailures($id: ID!) {
  insured(id: $id) {
    id
    mergeDriveFailures {
      status
      eventId
      deprecatedName
      error
      createdAt
    }
  }
}
    `;

/**
 * __useInsuredMergeDriveFailuresQuery__
 *
 * To run a query within a React component, call `useInsuredMergeDriveFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredMergeDriveFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredMergeDriveFailuresQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsuredMergeDriveFailuresQuery(baseOptions: Apollo.QueryHookOptions<InsuredMergeDriveFailuresQuery, InsuredMergeDriveFailuresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredMergeDriveFailuresQuery, InsuredMergeDriveFailuresQueryVariables>(InsuredMergeDriveFailuresDocument, options);
      }
export function useInsuredMergeDriveFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredMergeDriveFailuresQuery, InsuredMergeDriveFailuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredMergeDriveFailuresQuery, InsuredMergeDriveFailuresQueryVariables>(InsuredMergeDriveFailuresDocument, options);
        }
export type InsuredMergeDriveFailuresQueryHookResult = ReturnType<typeof useInsuredMergeDriveFailuresQuery>;
export type InsuredMergeDriveFailuresLazyQueryHookResult = ReturnType<typeof useInsuredMergeDriveFailuresLazyQuery>;
export type InsuredMergeDriveFailuresQueryResult = Apollo.QueryResult<InsuredMergeDriveFailuresQuery, InsuredMergeDriveFailuresQueryVariables>;
export const InsuredMergePreviewDocument = gql`
    query InsuredMergePreview($deprecatedId: UUID!, $survivorId: UUID!) {
  insuredMergePreview(deprecatedId: $deprecatedId, survivorId: $survivorId) {
    deprecatedId
    survivorId
    deprecatedAgency {
      id
      name
    }
    survivorAgency {
      id
      name
    }
    crossAgency
    deprecatedDrive {
      hasFolder
      moveWillBeAttempted
    }
    survivorDrive {
      hasFolder
      moveWillBeAttempted
    }
    canMerge
    reason
    previewHash
    opportunities {
      count
      records {
        id
        name
        state
      }
    }
    files {
      count
      records {
        id
        name
      }
    }
    gmailThreads {
      count
      records {
        id
        subject
      }
    }
    clientData {
      count
      keys
    }
    conversations {
      count
      inboxes {
        inboxId
        email
        ownerId
        ownerName
        ownerEmail
        inboxDeleted
        userDeleted
        count
        conversations {
          id
          subject
        }
      }
    }
    drafts {
      count
      records {
        id
        subject
        sent
      }
    }
  }
}
    `;

/**
 * __useInsuredMergePreviewQuery__
 *
 * To run a query within a React component, call `useInsuredMergePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredMergePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredMergePreviewQuery({
 *   variables: {
 *      deprecatedId: // value for 'deprecatedId'
 *      survivorId: // value for 'survivorId'
 *   },
 * });
 */
export function useInsuredMergePreviewQuery(baseOptions: Apollo.QueryHookOptions<InsuredMergePreviewQuery, InsuredMergePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredMergePreviewQuery, InsuredMergePreviewQueryVariables>(InsuredMergePreviewDocument, options);
      }
export function useInsuredMergePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredMergePreviewQuery, InsuredMergePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredMergePreviewQuery, InsuredMergePreviewQueryVariables>(InsuredMergePreviewDocument, options);
        }
export type InsuredMergePreviewQueryHookResult = ReturnType<typeof useInsuredMergePreviewQuery>;
export type InsuredMergePreviewLazyQueryHookResult = ReturnType<typeof useInsuredMergePreviewLazyQuery>;
export type InsuredMergePreviewQueryResult = Apollo.QueryResult<InsuredMergePreviewQuery, InsuredMergePreviewQueryVariables>;
export const InsuredWithDuplicateFlagDocument = gql`
    query InsuredWithDuplicateFlag($id: ID!) {
  insured(id: $id) {
    ...Insured
    isTest
    possibleDuplicates {
      id
      createdAt
      name
    }
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;

/**
 * __useInsuredWithDuplicateFlagQuery__
 *
 * To run a query within a React component, call `useInsuredWithDuplicateFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredWithDuplicateFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredWithDuplicateFlagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsuredWithDuplicateFlagQuery(baseOptions: Apollo.QueryHookOptions<InsuredWithDuplicateFlagQuery, InsuredWithDuplicateFlagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredWithDuplicateFlagQuery, InsuredWithDuplicateFlagQueryVariables>(InsuredWithDuplicateFlagDocument, options);
      }
export function useInsuredWithDuplicateFlagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredWithDuplicateFlagQuery, InsuredWithDuplicateFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredWithDuplicateFlagQuery, InsuredWithDuplicateFlagQueryVariables>(InsuredWithDuplicateFlagDocument, options);
        }
export type InsuredWithDuplicateFlagQueryHookResult = ReturnType<typeof useInsuredWithDuplicateFlagQuery>;
export type InsuredWithDuplicateFlagLazyQueryHookResult = ReturnType<typeof useInsuredWithDuplicateFlagLazyQuery>;
export type InsuredWithDuplicateFlagQueryResult = Apollo.QueryResult<InsuredWithDuplicateFlagQuery, InsuredWithDuplicateFlagQueryVariables>;
export const InsuredsDocument = gql`
    query Insureds($input: InsuredFilterInput!) {
  insureds(input: $input) {
    ...Insured
  }
}
    ${InsuredFragmentDoc}
${BusinessClassFragmentDoc}
${UserAccountFragmentDoc}
${AgencyFragmentDoc}`;

/**
 * __useInsuredsQuery__
 *
 * To run a query within a React component, call `useInsuredsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuredsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuredsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsuredsQuery(baseOptions: Apollo.QueryHookOptions<InsuredsQuery, InsuredsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuredsQuery, InsuredsQueryVariables>(InsuredsDocument, options);
      }
export function useInsuredsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuredsQuery, InsuredsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuredsQuery, InsuredsQueryVariables>(InsuredsDocument, options);
        }
export type InsuredsQueryHookResult = ReturnType<typeof useInsuredsQuery>;
export type InsuredsLazyQueryHookResult = ReturnType<typeof useInsuredsLazyQuery>;
export type InsuredsQueryResult = Apollo.QueryResult<InsuredsQuery, InsuredsQueryVariables>;
export const LicensesDocument = gql`
    query Licenses {
  licenses {
    id
    name
    licenseState
    licenseNumber
    licenseType
    loa
    effectiveDate
    expirationDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useLicensesQuery__
 *
 * To run a query within a React component, call `useLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicensesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLicensesQuery(baseOptions?: Apollo.QueryHookOptions<LicensesQuery, LicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicensesQuery, LicensesQueryVariables>(LicensesDocument, options);
      }
export function useLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicensesQuery, LicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicensesQuery, LicensesQueryVariables>(LicensesDocument, options);
        }
export type LicensesQueryHookResult = ReturnType<typeof useLicensesQuery>;
export type LicensesLazyQueryHookResult = ReturnType<typeof useLicensesLazyQuery>;
export type LicensesQueryResult = Apollo.QueryResult<LicensesQuery, LicensesQueryVariables>;
export const LicenseDocument = gql`
    query License($id: ID!) {
  license(id: $id) {
    id
    name
    licenseState
    licenseNumber
    licenseType
    loa
    effectiveDate
    expirationDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useLicenseQuery__
 *
 * To run a query within a React component, call `useLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLicenseQuery(baseOptions: Apollo.QueryHookOptions<LicenseQuery, LicenseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicenseQuery, LicenseQueryVariables>(LicenseDocument, options);
      }
export function useLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicenseQuery, LicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicenseQuery, LicenseQueryVariables>(LicenseDocument, options);
        }
export type LicenseQueryHookResult = ReturnType<typeof useLicenseQuery>;
export type LicenseLazyQueryHookResult = ReturnType<typeof useLicenseLazyQuery>;
export type LicenseQueryResult = Apollo.QueryResult<LicenseQuery, LicenseQueryVariables>;
export const LicensesByStateDocument = gql`
    query LicensesByState($state: String!) {
  licensesByState(state: $state) {
    id
    name
    licenseState
    licenseNumber
    licenseType
    loa
    effectiveDate
    expirationDate
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useLicensesByStateQuery__
 *
 * To run a query within a React component, call `useLicensesByStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLicensesByStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLicensesByStateQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useLicensesByStateQuery(baseOptions: Apollo.QueryHookOptions<LicensesByStateQuery, LicensesByStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LicensesByStateQuery, LicensesByStateQueryVariables>(LicensesByStateDocument, options);
      }
export function useLicensesByStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LicensesByStateQuery, LicensesByStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LicensesByStateQuery, LicensesByStateQueryVariables>(LicensesByStateDocument, options);
        }
export type LicensesByStateQueryHookResult = ReturnType<typeof useLicensesByStateQuery>;
export type LicensesByStateLazyQueryHookResult = ReturnType<typeof useLicensesByStateLazyQuery>;
export type LicensesByStateQueryResult = Apollo.QueryResult<LicensesByStateQuery, LicensesByStateQueryVariables>;
export const McpToolsMetadataDocument = gql`
    query MCPToolsMetadata($input: MCPToolsMetadataInput) {
  mcpToolsMetadata(input: $input) {
    name
    description
    shortDescription
    platforms
  }
}
    `;

/**
 * __useMcpToolsMetadataQuery__
 *
 * To run a query within a React component, call `useMcpToolsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMcpToolsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMcpToolsMetadataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMcpToolsMetadataQuery(baseOptions?: Apollo.QueryHookOptions<McpToolsMetadataQuery, McpToolsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<McpToolsMetadataQuery, McpToolsMetadataQueryVariables>(McpToolsMetadataDocument, options);
      }
export function useMcpToolsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<McpToolsMetadataQuery, McpToolsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<McpToolsMetadataQuery, McpToolsMetadataQueryVariables>(McpToolsMetadataDocument, options);
        }
export type McpToolsMetadataQueryHookResult = ReturnType<typeof useMcpToolsMetadataQuery>;
export type McpToolsMetadataLazyQueryHookResult = ReturnType<typeof useMcpToolsMetadataLazyQuery>;
export type McpToolsMetadataQueryResult = Apollo.QueryResult<McpToolsMetadataQuery, McpToolsMetadataQueryVariables>;
export const MimeTypesDocument = gql`
    query MimeTypes {
  mimeTypes {
    mimeType
    count
  }
}
    `;

/**
 * __useMimeTypesQuery__
 *
 * To run a query within a React component, call `useMimeTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMimeTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMimeTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMimeTypesQuery(baseOptions?: Apollo.QueryHookOptions<MimeTypesQuery, MimeTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MimeTypesQuery, MimeTypesQueryVariables>(MimeTypesDocument, options);
      }
export function useMimeTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MimeTypesQuery, MimeTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MimeTypesQuery, MimeTypesQueryVariables>(MimeTypesDocument, options);
        }
export type MimeTypesQueryHookResult = ReturnType<typeof useMimeTypesQuery>;
export type MimeTypesLazyQueryHookResult = ReturnType<typeof useMimeTypesLazyQuery>;
export type MimeTypesQueryResult = Apollo.QueryResult<MimeTypesQuery, MimeTypesQueryVariables>;
export const ModelEvaluationDocument = gql`
    query ModelEvaluation($id: String!, $includeResults: Boolean!, $resultsLimit: Int!) {
  modelEvaluation(
    id: $id
    includeResults: $includeResults
    resultsLimit: $resultsLimit
  ) {
    ...ModelEvaluation
    results {
      id
      quoteId
      submissionId
      carrier
      product
      state
      actualPremium
      predictedPremium
      absoluteError
      percentageError
    }
  }
}
    ${ModelEvaluationFragmentDoc}`;

/**
 * __useModelEvaluationQuery__
 *
 * To run a query within a React component, call `useModelEvaluationQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelEvaluationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelEvaluationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeResults: // value for 'includeResults'
 *      resultsLimit: // value for 'resultsLimit'
 *   },
 * });
 */
export function useModelEvaluationQuery(baseOptions: Apollo.QueryHookOptions<ModelEvaluationQuery, ModelEvaluationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelEvaluationQuery, ModelEvaluationQueryVariables>(ModelEvaluationDocument, options);
      }
export function useModelEvaluationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelEvaluationQuery, ModelEvaluationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelEvaluationQuery, ModelEvaluationQueryVariables>(ModelEvaluationDocument, options);
        }
export type ModelEvaluationQueryHookResult = ReturnType<typeof useModelEvaluationQuery>;
export type ModelEvaluationLazyQueryHookResult = ReturnType<typeof useModelEvaluationLazyQuery>;
export type ModelEvaluationQueryResult = Apollo.QueryResult<ModelEvaluationQuery, ModelEvaluationQueryVariables>;
export const ModelEvaluationsDocument = gql`
    query ModelEvaluations($limit: Int!) {
  modelEvaluations(limit: $limit) {
    ...ModelEvaluation
  }
}
    ${ModelEvaluationFragmentDoc}`;

/**
 * __useModelEvaluationsQuery__
 *
 * To run a query within a React component, call `useModelEvaluationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelEvaluationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelEvaluationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useModelEvaluationsQuery(baseOptions: Apollo.QueryHookOptions<ModelEvaluationsQuery, ModelEvaluationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelEvaluationsQuery, ModelEvaluationsQueryVariables>(ModelEvaluationsDocument, options);
      }
export function useModelEvaluationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelEvaluationsQuery, ModelEvaluationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelEvaluationsQuery, ModelEvaluationsQueryVariables>(ModelEvaluationsDocument, options);
        }
export type ModelEvaluationsQueryHookResult = ReturnType<typeof useModelEvaluationsQuery>;
export type ModelEvaluationsLazyQueryHookResult = ReturnType<typeof useModelEvaluationsLazyQuery>;
export type ModelEvaluationsQueryResult = Apollo.QueryResult<ModelEvaluationsQuery, ModelEvaluationsQueryVariables>;
export const MuellerSurveyTypesDocument = gql`
    query MuellerSurveyTypes {
  muellerSurveyTypes {
    configured
    orderingEnabled
    surveyTypes {
      code
      name
    }
  }
}
    `;

/**
 * __useMuellerSurveyTypesQuery__
 *
 * To run a query within a React component, call `useMuellerSurveyTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMuellerSurveyTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMuellerSurveyTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMuellerSurveyTypesQuery(baseOptions?: Apollo.QueryHookOptions<MuellerSurveyTypesQuery, MuellerSurveyTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MuellerSurveyTypesQuery, MuellerSurveyTypesQueryVariables>(MuellerSurveyTypesDocument, options);
      }
export function useMuellerSurveyTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MuellerSurveyTypesQuery, MuellerSurveyTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MuellerSurveyTypesQuery, MuellerSurveyTypesQueryVariables>(MuellerSurveyTypesDocument, options);
        }
export type MuellerSurveyTypesQueryHookResult = ReturnType<typeof useMuellerSurveyTypesQuery>;
export type MuellerSurveyTypesLazyQueryHookResult = ReturnType<typeof useMuellerSurveyTypesLazyQuery>;
export type MuellerSurveyTypesQueryResult = Apollo.QueryResult<MuellerSurveyTypesQuery, MuellerSurveyTypesQueryVariables>;
export const MyAccountDocument = gql`
    query MyAccount {
  myAccount {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useMyAccountQuery__
 *
 * To run a query within a React component, call `useMyAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyAccountQuery(baseOptions?: Apollo.QueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
      }
export function useMyAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyAccountQuery, MyAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyAccountQuery, MyAccountQueryVariables>(MyAccountDocument, options);
        }
export type MyAccountQueryHookResult = ReturnType<typeof useMyAccountQuery>;
export type MyAccountLazyQueryHookResult = ReturnType<typeof useMyAccountLazyQuery>;
export type MyAccountQueryResult = Apollo.QueryResult<MyAccountQuery, MyAccountQueryVariables>;
export const MyInvokablePlaybooksDocument = gql`
    query MyInvokablePlaybooks {
  myInvokablePlaybooks {
    ...Playbook
  }
}
    ${PlaybookFragmentDoc}`;

/**
 * __useMyInvokablePlaybooksQuery__
 *
 * To run a query within a React component, call `useMyInvokablePlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyInvokablePlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyInvokablePlaybooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyInvokablePlaybooksQuery(baseOptions?: Apollo.QueryHookOptions<MyInvokablePlaybooksQuery, MyInvokablePlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyInvokablePlaybooksQuery, MyInvokablePlaybooksQueryVariables>(MyInvokablePlaybooksDocument, options);
      }
export function useMyInvokablePlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyInvokablePlaybooksQuery, MyInvokablePlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyInvokablePlaybooksQuery, MyInvokablePlaybooksQueryVariables>(MyInvokablePlaybooksDocument, options);
        }
export type MyInvokablePlaybooksQueryHookResult = ReturnType<typeof useMyInvokablePlaybooksQuery>;
export type MyInvokablePlaybooksLazyQueryHookResult = ReturnType<typeof useMyInvokablePlaybooksLazyQuery>;
export type MyInvokablePlaybooksQueryResult = Apollo.QueryResult<MyInvokablePlaybooksQuery, MyInvokablePlaybooksQueryVariables>;
export const MyPlaybookTriggerDocument = gql`
    query MyPlaybookTrigger($eventType: String!, $triggerConfig: JSONObject) {
  myPlaybookTrigger(eventType: $eventType, triggerConfig: $triggerConfig) {
    ...PlaybookTrigger
  }
}
    ${PlaybookTriggerFragmentDoc}
${PlaybookFragmentDoc}`;

/**
 * __useMyPlaybookTriggerQuery__
 *
 * To run a query within a React component, call `useMyPlaybookTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPlaybookTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPlaybookTriggerQuery({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      triggerConfig: // value for 'triggerConfig'
 *   },
 * });
 */
export function useMyPlaybookTriggerQuery(baseOptions: Apollo.QueryHookOptions<MyPlaybookTriggerQuery, MyPlaybookTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPlaybookTriggerQuery, MyPlaybookTriggerQueryVariables>(MyPlaybookTriggerDocument, options);
      }
export function useMyPlaybookTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPlaybookTriggerQuery, MyPlaybookTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPlaybookTriggerQuery, MyPlaybookTriggerQueryVariables>(MyPlaybookTriggerDocument, options);
        }
export type MyPlaybookTriggerQueryHookResult = ReturnType<typeof useMyPlaybookTriggerQuery>;
export type MyPlaybookTriggerLazyQueryHookResult = ReturnType<typeof useMyPlaybookTriggerLazyQuery>;
export type MyPlaybookTriggerQueryResult = Apollo.QueryResult<MyPlaybookTriggerQuery, MyPlaybookTriggerQueryVariables>;
export const MyPlaybookTriggersDocument = gql`
    query MyPlaybookTriggers {
  myPlaybookTriggers {
    ...PlaybookTrigger
  }
}
    ${PlaybookTriggerFragmentDoc}
${PlaybookFragmentDoc}`;

/**
 * __useMyPlaybookTriggersQuery__
 *
 * To run a query within a React component, call `useMyPlaybookTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPlaybookTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPlaybookTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPlaybookTriggersQuery(baseOptions?: Apollo.QueryHookOptions<MyPlaybookTriggersQuery, MyPlaybookTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPlaybookTriggersQuery, MyPlaybookTriggersQueryVariables>(MyPlaybookTriggersDocument, options);
      }
export function useMyPlaybookTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPlaybookTriggersQuery, MyPlaybookTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPlaybookTriggersQuery, MyPlaybookTriggersQueryVariables>(MyPlaybookTriggersDocument, options);
        }
export type MyPlaybookTriggersQueryHookResult = ReturnType<typeof useMyPlaybookTriggersQuery>;
export type MyPlaybookTriggersLazyQueryHookResult = ReturnType<typeof useMyPlaybookTriggersLazyQuery>;
export type MyPlaybookTriggersQueryResult = Apollo.QueryResult<MyPlaybookTriggersQuery, MyPlaybookTriggersQueryVariables>;
export const MyPlaybooksDocument = gql`
    query MyPlaybooks {
  myPlaybooks {
    ...Playbook
  }
}
    ${PlaybookFragmentDoc}`;

/**
 * __useMyPlaybooksQuery__
 *
 * To run a query within a React component, call `useMyPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPlaybooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPlaybooksQuery(baseOptions?: Apollo.QueryHookOptions<MyPlaybooksQuery, MyPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPlaybooksQuery, MyPlaybooksQueryVariables>(MyPlaybooksDocument, options);
      }
export function useMyPlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPlaybooksQuery, MyPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPlaybooksQuery, MyPlaybooksQueryVariables>(MyPlaybooksDocument, options);
        }
export type MyPlaybooksQueryHookResult = ReturnType<typeof useMyPlaybooksQuery>;
export type MyPlaybooksLazyQueryHookResult = ReturnType<typeof useMyPlaybooksLazyQuery>;
export type MyPlaybooksQueryResult = Apollo.QueryResult<MyPlaybooksQuery, MyPlaybooksQueryVariables>;
export const MySubscribedPlaybooksDocument = gql`
    query MySubscribedPlaybooks {
  mySubscribedPlaybooks {
    ...Playbook
  }
}
    ${PlaybookFragmentDoc}`;

/**
 * __useMySubscribedPlaybooksQuery__
 *
 * To run a query within a React component, call `useMySubscribedPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useMySubscribedPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMySubscribedPlaybooksQuery({
 *   variables: {
 *   },
 * });
 */
export function useMySubscribedPlaybooksQuery(baseOptions?: Apollo.QueryHookOptions<MySubscribedPlaybooksQuery, MySubscribedPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MySubscribedPlaybooksQuery, MySubscribedPlaybooksQueryVariables>(MySubscribedPlaybooksDocument, options);
      }
export function useMySubscribedPlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MySubscribedPlaybooksQuery, MySubscribedPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MySubscribedPlaybooksQuery, MySubscribedPlaybooksQueryVariables>(MySubscribedPlaybooksDocument, options);
        }
export type MySubscribedPlaybooksQueryHookResult = ReturnType<typeof useMySubscribedPlaybooksQuery>;
export type MySubscribedPlaybooksLazyQueryHookResult = ReturnType<typeof useMySubscribedPlaybooksLazyQuery>;
export type MySubscribedPlaybooksQueryResult = Apollo.QueryResult<MySubscribedPlaybooksQuery, MySubscribedPlaybooksQueryVariables>;
export const NotifyBindVaveQuoteDocument = gql`
    mutation NotifyBindVaveQuote($vaveQuoteId: String!) {
  bindNotification(vaveQuoteId: $vaveQuoteId) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type NotifyBindVaveQuoteMutationFn = Apollo.MutationFunction<NotifyBindVaveQuoteMutation, NotifyBindVaveQuoteMutationVariables>;

/**
 * __useNotifyBindVaveQuoteMutation__
 *
 * To run a mutation, you first call `useNotifyBindVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyBindVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyBindVaveQuoteMutation, { data, loading, error }] = useNotifyBindVaveQuoteMutation({
 *   variables: {
 *      vaveQuoteId: // value for 'vaveQuoteId'
 *   },
 * });
 */
export function useNotifyBindVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<NotifyBindVaveQuoteMutation, NotifyBindVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyBindVaveQuoteMutation, NotifyBindVaveQuoteMutationVariables>(NotifyBindVaveQuoteDocument, options);
      }
export type NotifyBindVaveQuoteMutationHookResult = ReturnType<typeof useNotifyBindVaveQuoteMutation>;
export type NotifyBindVaveQuoteMutationResult = Apollo.MutationResult<NotifyBindVaveQuoteMutation>;
export type NotifyBindVaveQuoteMutationOptions = Apollo.BaseMutationOptions<NotifyBindVaveQuoteMutation, NotifyBindVaveQuoteMutationVariables>;
export const OpportunitiesDocument = gql`
    query Opportunities($input: OpportunitiesInput!) {
  opportunities(input: $input) {
    id
    state
    deletedAt
    createdAt
    selectedLinesOfBusiness
    desiredEffectiveDate
    renewalOfPolicies
    insuredId
    broker {
      id
      firstName
      lastName
    }
    submissions {
      id
      state
      appetiteProduct {
        id
        carrierName
        carrierProductName
        marketType
        portalLink
        isApiSubmission
      }
      quotes {
        id
        policy {
          id
        }
      }
      stateTransitions {
        id
        state
        details
        createdAt
      }
    }
  }
}
    `;

/**
 * __useOpportunitiesQuery__
 *
 * To run a query within a React component, call `useOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<OpportunitiesQuery, OpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunitiesQuery, OpportunitiesQueryVariables>(OpportunitiesDocument, options);
      }
export function useOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunitiesQuery, OpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunitiesQuery, OpportunitiesQueryVariables>(OpportunitiesDocument, options);
        }
export type OpportunitiesQueryHookResult = ReturnType<typeof useOpportunitiesQuery>;
export type OpportunitiesLazyQueryHookResult = ReturnType<typeof useOpportunitiesLazyQuery>;
export type OpportunitiesQueryResult = Apollo.QueryResult<OpportunitiesQuery, OpportunitiesQueryVariables>;
export const OpportunityBrokerDocument = gql`
    query OpportunityBroker($id: ID!) {
  opportunity(id: $id) {
    id
    broker {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useOpportunityBrokerQuery__
 *
 * To run a query within a React component, call `useOpportunityBrokerQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityBrokerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityBrokerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityBrokerQuery(baseOptions: Apollo.QueryHookOptions<OpportunityBrokerQuery, OpportunityBrokerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityBrokerQuery, OpportunityBrokerQueryVariables>(OpportunityBrokerDocument, options);
      }
export function useOpportunityBrokerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityBrokerQuery, OpportunityBrokerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityBrokerQuery, OpportunityBrokerQueryVariables>(OpportunityBrokerDocument, options);
        }
export type OpportunityBrokerQueryHookResult = ReturnType<typeof useOpportunityBrokerQuery>;
export type OpportunityBrokerLazyQueryHookResult = ReturnType<typeof useOpportunityBrokerLazyQuery>;
export type OpportunityBrokerQueryResult = Apollo.QueryResult<OpportunityBrokerQuery, OpportunityBrokerQueryVariables>;
export const OpportunityDetailsDocument = gql`
    query OpportunityDetails($id: ID!) {
  opportunity(id: $id) {
    ...OpportunityDetails
    aiPlacementLaunched
  }
}
    ${OpportunityDetailsFragmentDoc}
${MarketingPlanSubmissionFragmentDoc}
${MarketingPlanAppetiteProductFragmentDoc}
${SlimAppetiteProductFragmentFragmentDoc}
${CarrierContactFragmentDoc}
${MarketingPlanQuoteFragmentDoc}
${MarketingPlanMarketSummaryNoteFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;

/**
 * __useOpportunityDetailsQuery__
 *
 * To run a query within a React component, call `useOpportunityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityDetailsQuery(baseOptions: Apollo.QueryHookOptions<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>(OpportunityDetailsDocument, options);
      }
export function useOpportunityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>(OpportunityDetailsDocument, options);
        }
export type OpportunityDetailsQueryHookResult = ReturnType<typeof useOpportunityDetailsQuery>;
export type OpportunityDetailsLazyQueryHookResult = ReturnType<typeof useOpportunityDetailsLazyQuery>;
export type OpportunityDetailsQueryResult = Apollo.QueryResult<OpportunityDetailsQuery, OpportunityDetailsQueryVariables>;
export const OpportunityEventDocument = gql`
    query OpportunityEvent($id: ID!) {
  opportunityEvent(id: $id) {
    ...OpportunityEvent
  }
}
    ${OpportunityEventFragmentDoc}
${UserCommentFragmentDoc}
${UserAccountFragmentDoc}
${AssignmentChangeEventFragmentDoc}
${CollaboratorsChangedEventFragmentDoc}
${TriageAssignmentEventFragmentDoc}
${EmailEventFragmentDoc}
${GmailMessageEventFragmentDoc}
${GmailMessageFragmentDoc}
${FileUploadFragmentDoc}
${GmailRelayEventFragmentDoc}
${FileUploadEventFragmentDoc}
${StatusChangeEventFragmentDoc}
${SubmissionStatusChangeEventFragmentDoc}
${CreatedEventFragmentDoc}
${OutcomeChangeEventFragmentDoc}
${DesiredEffectiveDateChangeEventFragmentDoc}
${ApplicationSubmittedEventFragmentDoc}
${ProductsAddedEventFragmentDoc}
${ProductsRemovedEventFragmentDoc}
${BotCommentEventFragmentDoc}
${AlbyUpdateEventFragmentDoc}
${AutomatedFollowUpEventFragmentDoc}
${ActionRequestedEventFragmentDoc}
${ActionApprovedEventFragmentDoc}
${ActionRejectedEventFragmentDoc}
${ActionDismissedEventFragmentDoc}
${CoveragesChangedEventFragmentDoc}
${BusinessClassCodesChangedEventFragmentDoc}
${RequirementAddedEventFragmentDoc}
${PolicyRenewabilityChangedEventFragmentDoc}
${AgencyTransferEventFragmentDoc}`;

/**
 * __useOpportunityEventQuery__
 *
 * To run a query within a React component, call `useOpportunityEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityEventQuery(baseOptions: Apollo.QueryHookOptions<OpportunityEventQuery, OpportunityEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityEventQuery, OpportunityEventQueryVariables>(OpportunityEventDocument, options);
      }
export function useOpportunityEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityEventQuery, OpportunityEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityEventQuery, OpportunityEventQueryVariables>(OpportunityEventDocument, options);
        }
export type OpportunityEventQueryHookResult = ReturnType<typeof useOpportunityEventQuery>;
export type OpportunityEventLazyQueryHookResult = ReturnType<typeof useOpportunityEventLazyQuery>;
export type OpportunityEventQueryResult = Apollo.QueryResult<OpportunityEventQuery, OpportunityEventQueryVariables>;
export const OpportunityEventsDocument = gql`
    query OpportunityEvents($input: OpportunityEventsFilterInput!) {
  opportunityEvents(input: $input) {
    ...OpportunityEvent
  }
}
    ${OpportunityEventFragmentDoc}
${UserCommentFragmentDoc}
${UserAccountFragmentDoc}
${AssignmentChangeEventFragmentDoc}
${CollaboratorsChangedEventFragmentDoc}
${TriageAssignmentEventFragmentDoc}
${EmailEventFragmentDoc}
${GmailMessageEventFragmentDoc}
${GmailMessageFragmentDoc}
${FileUploadFragmentDoc}
${GmailRelayEventFragmentDoc}
${FileUploadEventFragmentDoc}
${StatusChangeEventFragmentDoc}
${SubmissionStatusChangeEventFragmentDoc}
${CreatedEventFragmentDoc}
${OutcomeChangeEventFragmentDoc}
${DesiredEffectiveDateChangeEventFragmentDoc}
${ApplicationSubmittedEventFragmentDoc}
${ProductsAddedEventFragmentDoc}
${ProductsRemovedEventFragmentDoc}
${BotCommentEventFragmentDoc}
${AlbyUpdateEventFragmentDoc}
${AutomatedFollowUpEventFragmentDoc}
${ActionRequestedEventFragmentDoc}
${ActionApprovedEventFragmentDoc}
${ActionRejectedEventFragmentDoc}
${ActionDismissedEventFragmentDoc}
${CoveragesChangedEventFragmentDoc}
${BusinessClassCodesChangedEventFragmentDoc}
${RequirementAddedEventFragmentDoc}
${PolicyRenewabilityChangedEventFragmentDoc}
${AgencyTransferEventFragmentDoc}`;

/**
 * __useOpportunityEventsQuery__
 *
 * To run a query within a React component, call `useOpportunityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpportunityEventsQuery(baseOptions: Apollo.QueryHookOptions<OpportunityEventsQuery, OpportunityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityEventsQuery, OpportunityEventsQueryVariables>(OpportunityEventsDocument, options);
      }
export function useOpportunityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityEventsQuery, OpportunityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityEventsQuery, OpportunityEventsQueryVariables>(OpportunityEventsDocument, options);
        }
export type OpportunityEventsQueryHookResult = ReturnType<typeof useOpportunityEventsQuery>;
export type OpportunityEventsLazyQueryHookResult = ReturnType<typeof useOpportunityEventsLazyQuery>;
export type OpportunityEventsQueryResult = Apollo.QueryResult<OpportunityEventsQuery, OpportunityEventsQueryVariables>;
export const OpportunityJsonDocumentDocument = gql`
    query OpportunityJsonDocument($opportunityId: String!, $documentId: String!) {
  opportunityJsonDocument(opportunityId: $opportunityId, documentId: $documentId) {
    version
    document
  }
}
    `;

/**
 * __useOpportunityJsonDocumentQuery__
 *
 * To run a query within a React component, call `useOpportunityJsonDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityJsonDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityJsonDocumentQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useOpportunityJsonDocumentQuery(baseOptions: Apollo.QueryHookOptions<OpportunityJsonDocumentQuery, OpportunityJsonDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityJsonDocumentQuery, OpportunityJsonDocumentQueryVariables>(OpportunityJsonDocumentDocument, options);
      }
export function useOpportunityJsonDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityJsonDocumentQuery, OpportunityJsonDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityJsonDocumentQuery, OpportunityJsonDocumentQueryVariables>(OpportunityJsonDocumentDocument, options);
        }
export type OpportunityJsonDocumentQueryHookResult = ReturnType<typeof useOpportunityJsonDocumentQuery>;
export type OpportunityJsonDocumentLazyQueryHookResult = ReturnType<typeof useOpportunityJsonDocumentLazyQuery>;
export type OpportunityJsonDocumentQueryResult = Apollo.QueryResult<OpportunityJsonDocumentQuery, OpportunityJsonDocumentQueryVariables>;
export const OpportunityJsonDocumentsDocument = gql`
    query OpportunityJsonDocuments($opportunityId: String!) {
  opportunityJsonDocuments(opportunityId: $opportunityId) {
    id
    name
    entityLabel
    scope
    opportunityId
    submissionId
    version
    updatedAt
  }
}
    `;

/**
 * __useOpportunityJsonDocumentsQuery__
 *
 * To run a query within a React component, call `useOpportunityJsonDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityJsonDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityJsonDocumentsQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useOpportunityJsonDocumentsQuery(baseOptions: Apollo.QueryHookOptions<OpportunityJsonDocumentsQuery, OpportunityJsonDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityJsonDocumentsQuery, OpportunityJsonDocumentsQueryVariables>(OpportunityJsonDocumentsDocument, options);
      }
export function useOpportunityJsonDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityJsonDocumentsQuery, OpportunityJsonDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityJsonDocumentsQuery, OpportunityJsonDocumentsQueryVariables>(OpportunityJsonDocumentsDocument, options);
        }
export type OpportunityJsonDocumentsQueryHookResult = ReturnType<typeof useOpportunityJsonDocumentsQuery>;
export type OpportunityJsonDocumentsLazyQueryHookResult = ReturnType<typeof useOpportunityJsonDocumentsLazyQuery>;
export type OpportunityJsonDocumentsQueryResult = Apollo.QueryResult<OpportunityJsonDocumentsQuery, OpportunityJsonDocumentsQueryVariables>;
export const OpportunityNotesDocument = gql`
    query OpportunityNotes($id: ID!) {
  opportunity(id: $id) {
    ...OpportunityNotes
  }
}
    ${OpportunityNotesFragmentDoc}
${UserAccountFragmentDoc}`;

/**
 * __useOpportunityNotesQuery__
 *
 * To run a query within a React component, call `useOpportunityNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityNotesQuery(baseOptions: Apollo.QueryHookOptions<OpportunityNotesQuery, OpportunityNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityNotesQuery, OpportunityNotesQueryVariables>(OpportunityNotesDocument, options);
      }
export function useOpportunityNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityNotesQuery, OpportunityNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityNotesQuery, OpportunityNotesQueryVariables>(OpportunityNotesDocument, options);
        }
export type OpportunityNotesQueryHookResult = ReturnType<typeof useOpportunityNotesQuery>;
export type OpportunityNotesLazyQueryHookResult = ReturnType<typeof useOpportunityNotesLazyQuery>;
export type OpportunityNotesQueryResult = Apollo.QueryResult<OpportunityNotesQuery, OpportunityNotesQueryVariables>;
export const OpportunityRequirementDocument = gql`
    query OpportunityRequirement($id: ID!) {
  agentAction(id: $id) {
    id
    title
    description
    actionType
    supplementalForm
    complete
    expeditedRequirement
  }
}
    `;

/**
 * __useOpportunityRequirementQuery__
 *
 * To run a query within a React component, call `useOpportunityRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityRequirementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityRequirementQuery(baseOptions: Apollo.QueryHookOptions<OpportunityRequirementQuery, OpportunityRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityRequirementQuery, OpportunityRequirementQueryVariables>(OpportunityRequirementDocument, options);
      }
export function useOpportunityRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityRequirementQuery, OpportunityRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityRequirementQuery, OpportunityRequirementQueryVariables>(OpportunityRequirementDocument, options);
        }
export type OpportunityRequirementQueryHookResult = ReturnType<typeof useOpportunityRequirementQuery>;
export type OpportunityRequirementLazyQueryHookResult = ReturnType<typeof useOpportunityRequirementLazyQuery>;
export type OpportunityRequirementQueryResult = Apollo.QueryResult<OpportunityRequirementQuery, OpportunityRequirementQueryVariables>;
export const OpportunityRequirementsDocument = gql`
    query OpportunityRequirements($id: ID!) {
  opportunity(id: $id) {
    id
    state
    insured {
      id
      name
      agent {
        id
        firstName
        lastName
      }
    }
    agentActions {
      id
      title
      description
      actionType
      supplementalForm
      complete
      updatedAt
      completedAt
      expeditedRequirement
      ui {
        title
        description
        steps {
          title
          description
          elements {
            element
            clientDataKey
            array
            props
          }
        }
      }
      logs {
        id
        response
        file {
          ...FileUpload
          uploader {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __useOpportunityRequirementsQuery__
 *
 * To run a query within a React component, call `useOpportunityRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityRequirementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpportunityRequirementsQuery(baseOptions: Apollo.QueryHookOptions<OpportunityRequirementsQuery, OpportunityRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunityRequirementsQuery, OpportunityRequirementsQueryVariables>(OpportunityRequirementsDocument, options);
      }
export function useOpportunityRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunityRequirementsQuery, OpportunityRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunityRequirementsQuery, OpportunityRequirementsQueryVariables>(OpportunityRequirementsDocument, options);
        }
export type OpportunityRequirementsQueryHookResult = ReturnType<typeof useOpportunityRequirementsQuery>;
export type OpportunityRequirementsLazyQueryHookResult = ReturnType<typeof useOpportunityRequirementsLazyQuery>;
export type OpportunityRequirementsQueryResult = Apollo.QueryResult<OpportunityRequirementsQuery, OpportunityRequirementsQueryVariables>;
export const OpportunitySubmissionPlacementDocument = gql`
    query OpportunitySubmissionPlacement($opportunityId: ID!) {
  opportunity(id: $opportunityId) {
    id
    submissions {
      id
      createdByPlacement {
        taskId
        provenance
      }
    }
  }
}
    `;

/**
 * __useOpportunitySubmissionPlacementQuery__
 *
 * To run a query within a React component, call `useOpportunitySubmissionPlacementQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpportunitySubmissionPlacementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunitySubmissionPlacementQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useOpportunitySubmissionPlacementQuery(baseOptions: Apollo.QueryHookOptions<OpportunitySubmissionPlacementQuery, OpportunitySubmissionPlacementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpportunitySubmissionPlacementQuery, OpportunitySubmissionPlacementQueryVariables>(OpportunitySubmissionPlacementDocument, options);
      }
export function useOpportunitySubmissionPlacementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpportunitySubmissionPlacementQuery, OpportunitySubmissionPlacementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpportunitySubmissionPlacementQuery, OpportunitySubmissionPlacementQueryVariables>(OpportunitySubmissionPlacementDocument, options);
        }
export type OpportunitySubmissionPlacementQueryHookResult = ReturnType<typeof useOpportunitySubmissionPlacementQuery>;
export type OpportunitySubmissionPlacementLazyQueryHookResult = ReturnType<typeof useOpportunitySubmissionPlacementLazyQuery>;
export type OpportunitySubmissionPlacementQueryResult = Apollo.QueryResult<OpportunitySubmissionPlacementQuery, OpportunitySubmissionPlacementQueryVariables>;
export const PaginatedAgenciesDocument = gql`
    query PaginatedAgencies($args: AgenciesFilterInput, $pagination: PaginationInput!) {
  paginatedAgencies(args: $args, pagination: $pagination) {
    agencies {
      id
      name
      isTest
      createdAt
      owner {
        id
        firstName
        lastName
      }
    }
    numRecords
    numPages
  }
}
    `;

/**
 * __usePaginatedAgenciesQuery__
 *
 * To run a query within a React component, call `usePaginatedAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedAgenciesQuery({
 *   variables: {
 *      args: // value for 'args'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedAgenciesQuery(baseOptions: Apollo.QueryHookOptions<PaginatedAgenciesQuery, PaginatedAgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedAgenciesQuery, PaginatedAgenciesQueryVariables>(PaginatedAgenciesDocument, options);
      }
export function usePaginatedAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedAgenciesQuery, PaginatedAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedAgenciesQuery, PaginatedAgenciesQueryVariables>(PaginatedAgenciesDocument, options);
        }
export type PaginatedAgenciesQueryHookResult = ReturnType<typeof usePaginatedAgenciesQuery>;
export type PaginatedAgenciesLazyQueryHookResult = ReturnType<typeof usePaginatedAgenciesLazyQuery>;
export type PaginatedAgenciesQueryResult = Apollo.QueryResult<PaginatedAgenciesQuery, PaginatedAgenciesQueryVariables>;
export const PaginatedFilesDocument = gql`
    query PaginatedFiles($input: PaginatedFilesInput!) {
  paginatedFiles(input: $input) {
    files {
      ...FileUpload
    }
    numRecords
  }
}
    ${FileUploadFragmentDoc}`;

/**
 * __usePaginatedFilesQuery__
 *
 * To run a query within a React component, call `usePaginatedFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaginatedFilesQuery(baseOptions: Apollo.QueryHookOptions<PaginatedFilesQuery, PaginatedFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedFilesQuery, PaginatedFilesQueryVariables>(PaginatedFilesDocument, options);
      }
export function usePaginatedFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedFilesQuery, PaginatedFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedFilesQuery, PaginatedFilesQueryVariables>(PaginatedFilesDocument, options);
        }
export type PaginatedFilesQueryHookResult = ReturnType<typeof usePaginatedFilesQuery>;
export type PaginatedFilesLazyQueryHookResult = ReturnType<typeof usePaginatedFilesLazyQuery>;
export type PaginatedFilesQueryResult = Apollo.QueryResult<PaginatedFilesQuery, PaginatedFilesQueryVariables>;
export const PaginatedInsuredsDocument = gql`
    query PaginatedInsureds($args: InsuredFilterInput, $pagination: PaginationInput!) {
  paginatedInsureds(args: $args, pagination: $pagination) {
    insureds {
      id
      name
    }
    numRecords
    numPages
  }
}
    `;

/**
 * __usePaginatedInsuredsQuery__
 *
 * To run a query within a React component, call `usePaginatedInsuredsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedInsuredsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedInsuredsQuery({
 *   variables: {
 *      args: // value for 'args'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedInsuredsQuery(baseOptions: Apollo.QueryHookOptions<PaginatedInsuredsQuery, PaginatedInsuredsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginatedInsuredsQuery, PaginatedInsuredsQueryVariables>(PaginatedInsuredsDocument, options);
      }
export function usePaginatedInsuredsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginatedInsuredsQuery, PaginatedInsuredsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginatedInsuredsQuery, PaginatedInsuredsQueryVariables>(PaginatedInsuredsDocument, options);
        }
export type PaginatedInsuredsQueryHookResult = ReturnType<typeof usePaginatedInsuredsQuery>;
export type PaginatedInsuredsLazyQueryHookResult = ReturnType<typeof usePaginatedInsuredsLazyQuery>;
export type PaginatedInsuredsQueryResult = Apollo.QueryResult<PaginatedInsuredsQuery, PaginatedInsuredsQueryVariables>;
export const PlacementDeliveryResultsDocument = gql`
    query PlacementDeliveryResults($input: PlacementWorkflowDashboardInput) {
  placementDeliveryResults(input: $input) {
    totalCount
    offset
    limit
    hasMore
    windowStart
    createdBefore
    generatedAt
    rows {
      opportunity {
        id
        insuredId
        insuredName
        createdAt
        desiredEffectiveDate
        selectedLinesOfBusiness
        broker {
          id
          name
        }
      }
      delivery {
        ...PlacementDeliveryWitness
      }
    }
  }
}
    ${PlacementDeliveryWitnessFragmentDoc}`;

/**
 * __usePlacementDeliveryResultsQuery__
 *
 * To run a query within a React component, call `usePlacementDeliveryResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementDeliveryResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementDeliveryResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacementDeliveryResultsQuery(baseOptions?: Apollo.QueryHookOptions<PlacementDeliveryResultsQuery, PlacementDeliveryResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementDeliveryResultsQuery, PlacementDeliveryResultsQueryVariables>(PlacementDeliveryResultsDocument, options);
      }
export function usePlacementDeliveryResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementDeliveryResultsQuery, PlacementDeliveryResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementDeliveryResultsQuery, PlacementDeliveryResultsQueryVariables>(PlacementDeliveryResultsDocument, options);
        }
export type PlacementDeliveryResultsQueryHookResult = ReturnType<typeof usePlacementDeliveryResultsQuery>;
export type PlacementDeliveryResultsLazyQueryHookResult = ReturnType<typeof usePlacementDeliveryResultsLazyQuery>;
export type PlacementDeliveryResultsQueryResult = Apollo.QueryResult<PlacementDeliveryResultsQuery, PlacementDeliveryResultsQueryVariables>;
export const PlacementDeskDetailDocument = gql`
    query PlacementDeskDetail($opportunityId: ID!, $placementId: ID, $timelineLimit: Int, $timelineOffset: Int) {
  placementDeskDetail(
    opportunityId: $opportunityId
    placementId: $placementId
    timelineLimit: $timelineLimit
    timelineOffset: $timelineOffset
  ) {
    pinnedRun {
      requestedPlacementId
      placementId
      latestPlacementId
      runNumber
      runCount
      error
    }
    runs {
      placementId
      runNumber
      status
      createdAt
    }
    journey {
      placementId
      runNumber
      runCount
      launchedAt
      launchTimeBasis
      requestedCoverage
      personRequested
      evidenceErrors
      brokerageWorkError
      steps {
        kind
        marketId
        marketName
        state
        evidence
        at
        timeBasis
        actor
        resultCode
        detail
        carriedFromRun
      }
      brokerageWork {
        after
        error
        byHand {
          ...PlacementDeskWorkGroup
        }
        automatic {
          ...PlacementDeskWorkGroup
        }
        unattributed {
          ...PlacementDeskWorkGroup
        }
      }
    }
    timelineError
    onDesk
    source
    asOf
    error
    latestWake {
      placementId
      taskId
      status
      blockedReason
      reason
      createdAt
      updatedAt
      readAt
    }
    latestWakeError
    desk {
      ...PlacementDeskSnapshot
    }
    placement
    storedState
    timeline {
      limit
      offset
      hasMore
      items {
        id
        source
        kind
        occurredAt
        observedAt
        payload
        milestone {
          milestone
          settlementReason
          dispositionReasons {
            code
            text
          }
          marketId
          stage
          disposition
          terminal
          executionStatus
          attemptId
          targetRoleSlug
          detail
          attentionId
          attentionKind
          taskKey
          occurrence
          resolution
        }
      }
    }
  }
}
    ${PlacementDeskWorkGroupFragmentDoc}
${PlacementDeskSnapshotFragmentDoc}`;

/**
 * __usePlacementDeskDetailQuery__
 *
 * To run a query within a React component, call `usePlacementDeskDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementDeskDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementDeskDetailQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *      placementId: // value for 'placementId'
 *      timelineLimit: // value for 'timelineLimit'
 *      timelineOffset: // value for 'timelineOffset'
 *   },
 * });
 */
export function usePlacementDeskDetailQuery(baseOptions: Apollo.QueryHookOptions<PlacementDeskDetailQuery, PlacementDeskDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementDeskDetailQuery, PlacementDeskDetailQueryVariables>(PlacementDeskDetailDocument, options);
      }
export function usePlacementDeskDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementDeskDetailQuery, PlacementDeskDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementDeskDetailQuery, PlacementDeskDetailQueryVariables>(PlacementDeskDetailDocument, options);
        }
export type PlacementDeskDetailQueryHookResult = ReturnType<typeof usePlacementDeskDetailQuery>;
export type PlacementDeskDetailLazyQueryHookResult = ReturnType<typeof usePlacementDeskDetailLazyQuery>;
export type PlacementDeskDetailQueryResult = Apollo.QueryResult<PlacementDeskDetailQuery, PlacementDeskDetailQueryVariables>;
export const PlacementDeskSummaryDocument = gql`
    query PlacementDeskSummary($input: PlacementWorkflowSummaryInput, $carrier: String) {
  placementDeskSummary(input: $input, carrier: $carrier) {
    funnel {
      launched
      appetiteAnswered
      reachedPortal
      carrierAnswered
      inApp2
    }
    lastLaunchAt
    lastDeskActivityAt
    totalPlacements
    cohortStartedAt
    closedDealCount
    closedDealRunCount
    teamAsks {
      totalDeals
      groups {
        factKey
        label
        dealCount
      }
      rawMessages
    }
    carrierMetrics {
      marketId
      displayName
      metric {
        total {
          automatedSubmissions
          manualSubmissions
          automatedQuoted
          manualQuoted
        }
      }
    }
    blockers {
      id
      count
      label
      marketNames
      rawMessages
      filters {
        key
        value
      }
    }
    planReviews {
      count
      oldestMinutes
      tasks {
        opportunityId
        marketId
      }
    }
    generatedAt
    stallThresholdMinutes
    endedUndecidedQueue {
      opportunityId
    }
    steps {
      step
      everReachedCount
    }
    launchHealth {
      refusedByReason {
        reason
        count
      }
      failedByErrorCode {
        reason
        count
      }
    }
    freshness {
      lastSuccessAt
      lastError
    }
  }
}
    `;

/**
 * __usePlacementDeskSummaryQuery__
 *
 * To run a query within a React component, call `usePlacementDeskSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementDeskSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementDeskSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *      carrier: // value for 'carrier'
 *   },
 * });
 */
export function usePlacementDeskSummaryQuery(baseOptions?: Apollo.QueryHookOptions<PlacementDeskSummaryQuery, PlacementDeskSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementDeskSummaryQuery, PlacementDeskSummaryQueryVariables>(PlacementDeskSummaryDocument, options);
      }
export function usePlacementDeskSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementDeskSummaryQuery, PlacementDeskSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementDeskSummaryQuery, PlacementDeskSummaryQueryVariables>(PlacementDeskSummaryDocument, options);
        }
export type PlacementDeskSummaryQueryHookResult = ReturnType<typeof usePlacementDeskSummaryQuery>;
export type PlacementDeskSummaryLazyQueryHookResult = ReturnType<typeof usePlacementDeskSummaryLazyQuery>;
export type PlacementDeskSummaryQueryResult = Apollo.QueryResult<PlacementDeskSummaryQuery, PlacementDeskSummaryQueryVariables>;
export const PlacementOpportunityDeliveryEvidenceDocument = gql`
    query PlacementOpportunityDeliveryEvidence($opportunityId: ID!) {
  placementOpportunityDeliveryEvidence(opportunityId: $opportunityId) {
    opportunityId
    placementMember
    generatedAt
    witness {
      ...PlacementDeliveryWitness
    }
  }
}
    ${PlacementDeliveryWitnessFragmentDoc}`;

/**
 * __usePlacementOpportunityDeliveryEvidenceQuery__
 *
 * To run a query within a React component, call `usePlacementOpportunityDeliveryEvidenceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementOpportunityDeliveryEvidenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementOpportunityDeliveryEvidenceQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function usePlacementOpportunityDeliveryEvidenceQuery(baseOptions: Apollo.QueryHookOptions<PlacementOpportunityDeliveryEvidenceQuery, PlacementOpportunityDeliveryEvidenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementOpportunityDeliveryEvidenceQuery, PlacementOpportunityDeliveryEvidenceQueryVariables>(PlacementOpportunityDeliveryEvidenceDocument, options);
      }
export function usePlacementOpportunityDeliveryEvidenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementOpportunityDeliveryEvidenceQuery, PlacementOpportunityDeliveryEvidenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementOpportunityDeliveryEvidenceQuery, PlacementOpportunityDeliveryEvidenceQueryVariables>(PlacementOpportunityDeliveryEvidenceDocument, options);
        }
export type PlacementOpportunityDeliveryEvidenceQueryHookResult = ReturnType<typeof usePlacementOpportunityDeliveryEvidenceQuery>;
export type PlacementOpportunityDeliveryEvidenceLazyQueryHookResult = ReturnType<typeof usePlacementOpportunityDeliveryEvidenceLazyQuery>;
export type PlacementOpportunityDeliveryEvidenceQueryResult = Apollo.QueryResult<PlacementOpportunityDeliveryEvidenceQuery, PlacementOpportunityDeliveryEvidenceQueryVariables>;
export const PlacementOpportunityLaunchAttemptsDocument = gql`
    query PlacementOpportunityLaunchAttempts($opportunityId: ID!) {
  placementOpportunityLaunchAttempts(opportunityId: $opportunityId) {
    latestLaunchAttempt {
      outcome
      trigger
      reason
      classification
      errorDomainCode
      errorCode
      errorMessage
      failingOperation
      observedAt
    }
    attemptCount
    failedAttemptCount
    launchAttempts {
      outcome
      trigger
      reason
      classification
      errorDomainCode
      errorCode
      errorMessage
      failingOperation
      observedAt
    }
  }
}
    `;

/**
 * __usePlacementOpportunityLaunchAttemptsQuery__
 *
 * To run a query within a React component, call `usePlacementOpportunityLaunchAttemptsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementOpportunityLaunchAttemptsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementOpportunityLaunchAttemptsQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function usePlacementOpportunityLaunchAttemptsQuery(baseOptions: Apollo.QueryHookOptions<PlacementOpportunityLaunchAttemptsQuery, PlacementOpportunityLaunchAttemptsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementOpportunityLaunchAttemptsQuery, PlacementOpportunityLaunchAttemptsQueryVariables>(PlacementOpportunityLaunchAttemptsDocument, options);
      }
export function usePlacementOpportunityLaunchAttemptsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementOpportunityLaunchAttemptsQuery, PlacementOpportunityLaunchAttemptsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementOpportunityLaunchAttemptsQuery, PlacementOpportunityLaunchAttemptsQueryVariables>(PlacementOpportunityLaunchAttemptsDocument, options);
        }
export type PlacementOpportunityLaunchAttemptsQueryHookResult = ReturnType<typeof usePlacementOpportunityLaunchAttemptsQuery>;
export type PlacementOpportunityLaunchAttemptsLazyQueryHookResult = ReturnType<typeof usePlacementOpportunityLaunchAttemptsLazyQuery>;
export type PlacementOpportunityLaunchAttemptsQueryResult = Apollo.QueryResult<PlacementOpportunityLaunchAttemptsQuery, PlacementOpportunityLaunchAttemptsQueryVariables>;
export const PlacementWorkflowAttributedDeliveryDocument = gql`
    query PlacementWorkflowAttributedDelivery($input: PlacementWorkflowSummaryInput) {
  placementWorkflowSummary(input: $input) {
    generatedAt
    windowStart
    createdBefore
    quoteDelivery {
      placementCreatedDeliveredOpportunityCount
      placementCreatedDeliveredSubmissionCount
    }
  }
}
    `;

/**
 * __usePlacementWorkflowAttributedDeliveryQuery__
 *
 * To run a query within a React component, call `usePlacementWorkflowAttributedDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementWorkflowAttributedDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementWorkflowAttributedDeliveryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacementWorkflowAttributedDeliveryQuery(baseOptions?: Apollo.QueryHookOptions<PlacementWorkflowAttributedDeliveryQuery, PlacementWorkflowAttributedDeliveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementWorkflowAttributedDeliveryQuery, PlacementWorkflowAttributedDeliveryQueryVariables>(PlacementWorkflowAttributedDeliveryDocument, options);
      }
export function usePlacementWorkflowAttributedDeliveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementWorkflowAttributedDeliveryQuery, PlacementWorkflowAttributedDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementWorkflowAttributedDeliveryQuery, PlacementWorkflowAttributedDeliveryQueryVariables>(PlacementWorkflowAttributedDeliveryDocument, options);
        }
export type PlacementWorkflowAttributedDeliveryQueryHookResult = ReturnType<typeof usePlacementWorkflowAttributedDeliveryQuery>;
export type PlacementWorkflowAttributedDeliveryLazyQueryHookResult = ReturnType<typeof usePlacementWorkflowAttributedDeliveryLazyQuery>;
export type PlacementWorkflowAttributedDeliveryQueryResult = Apollo.QueryResult<PlacementWorkflowAttributedDeliveryQuery, PlacementWorkflowAttributedDeliveryQueryVariables>;
export const PlacementWorkflowDashboardDocument = gql`
    query PlacementWorkflowDashboard($input: PlacementWorkflowDashboardInput) {
  placementWorkflowDashboard(input: $input) {
    totalCount
    numRecords
    hasMore
    limit
    offset
    cohortStartedAt
    windowStart
    windowEnd
    generatedAt
    freshness {
      lastSuccessAt
      lastError
    }
    rows {
      ...PlacementWorkflowRow
    }
  }
}
    ${PlacementWorkflowRowFragmentDoc}
${PlacementDeskSnapshotFragmentDoc}`;

/**
 * __usePlacementWorkflowDashboardQuery__
 *
 * To run a query within a React component, call `usePlacementWorkflowDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementWorkflowDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementWorkflowDashboardQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacementWorkflowDashboardQuery(baseOptions?: Apollo.QueryHookOptions<PlacementWorkflowDashboardQuery, PlacementWorkflowDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementWorkflowDashboardQuery, PlacementWorkflowDashboardQueryVariables>(PlacementWorkflowDashboardDocument, options);
      }
export function usePlacementWorkflowDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementWorkflowDashboardQuery, PlacementWorkflowDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementWorkflowDashboardQuery, PlacementWorkflowDashboardQueryVariables>(PlacementWorkflowDashboardDocument, options);
        }
export type PlacementWorkflowDashboardQueryHookResult = ReturnType<typeof usePlacementWorkflowDashboardQuery>;
export type PlacementWorkflowDashboardLazyQueryHookResult = ReturnType<typeof usePlacementWorkflowDashboardLazyQuery>;
export type PlacementWorkflowDashboardQueryResult = Apollo.QueryResult<PlacementWorkflowDashboardQuery, PlacementWorkflowDashboardQueryVariables>;
export const PlacementWorkflowDispositionsDocument = gql`
    query PlacementWorkflowDispositions($input: PlacementWorkflowSummaryInput) {
  placementWorkflowSummary(input: $input) {
    generatedAt
    windowStart
    createdBefore
    reconciledDispositions {
      invalidEvidenceCount
      totalOpportunities
      noRecordedLaunchEvidence
      terminalStates {
        launched
        refused
        refusedUnmapped
        failed
        abandoned
        other
      }
      refusalReasons {
        reason
        count
      }
    }
  }
}
    `;

/**
 * __usePlacementWorkflowDispositionsQuery__
 *
 * To run a query within a React component, call `usePlacementWorkflowDispositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementWorkflowDispositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementWorkflowDispositionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacementWorkflowDispositionsQuery(baseOptions?: Apollo.QueryHookOptions<PlacementWorkflowDispositionsQuery, PlacementWorkflowDispositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementWorkflowDispositionsQuery, PlacementWorkflowDispositionsQueryVariables>(PlacementWorkflowDispositionsDocument, options);
      }
export function usePlacementWorkflowDispositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementWorkflowDispositionsQuery, PlacementWorkflowDispositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementWorkflowDispositionsQuery, PlacementWorkflowDispositionsQueryVariables>(PlacementWorkflowDispositionsDocument, options);
        }
export type PlacementWorkflowDispositionsQueryHookResult = ReturnType<typeof usePlacementWorkflowDispositionsQuery>;
export type PlacementWorkflowDispositionsLazyQueryHookResult = ReturnType<typeof usePlacementWorkflowDispositionsLazyQuery>;
export type PlacementWorkflowDispositionsQueryResult = Apollo.QueryResult<PlacementWorkflowDispositionsQuery, PlacementWorkflowDispositionsQueryVariables>;
export const PlacementWorkflowOpportunityDocument = gql`
    query PlacementWorkflowOpportunity($opportunityId: ID!) {
  placementWorkflowOpportunity(opportunityId: $opportunityId) {
    generatedAt
    row {
      ...PlacementWorkflowRow
    }
    submissions {
      id
      state
      createdAt
      appetiteProductId
      carrierName
      productName
    }
  }
}
    ${PlacementWorkflowRowFragmentDoc}
${PlacementDeskSnapshotFragmentDoc}`;

/**
 * __usePlacementWorkflowOpportunityQuery__
 *
 * To run a query within a React component, call `usePlacementWorkflowOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementWorkflowOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementWorkflowOpportunityQuery({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function usePlacementWorkflowOpportunityQuery(baseOptions: Apollo.QueryHookOptions<PlacementWorkflowOpportunityQuery, PlacementWorkflowOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementWorkflowOpportunityQuery, PlacementWorkflowOpportunityQueryVariables>(PlacementWorkflowOpportunityDocument, options);
      }
export function usePlacementWorkflowOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementWorkflowOpportunityQuery, PlacementWorkflowOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementWorkflowOpportunityQuery, PlacementWorkflowOpportunityQueryVariables>(PlacementWorkflowOpportunityDocument, options);
        }
export type PlacementWorkflowOpportunityQueryHookResult = ReturnType<typeof usePlacementWorkflowOpportunityQuery>;
export type PlacementWorkflowOpportunityLazyQueryHookResult = ReturnType<typeof usePlacementWorkflowOpportunityLazyQuery>;
export type PlacementWorkflowOpportunityQueryResult = Apollo.QueryResult<PlacementWorkflowOpportunityQuery, PlacementWorkflowOpportunityQueryVariables>;
export const PlacementWorkflowSummaryDocument = gql`
    query PlacementWorkflowSummary($input: PlacementWorkflowSummaryInput) {
  placementWorkflowSummary(input: $input) {
    totalOpportunities
    createdNotEvaluated
    quoteDelivery {
      opportunitiesReachedUploadQuote
      opportunitiesWithUploadQuoteEvidence
      deliveredSubmissionCount
      deliveredOpportunityCount
      deliveryRate
      observedDeliveryRate
    }
    terminalStates {
      launched
      refused
      refusedUnmapped
      failed
      abandoned
      other
    }
  }
}
    `;

/**
 * __usePlacementWorkflowSummaryQuery__
 *
 * To run a query within a React component, call `usePlacementWorkflowSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlacementWorkflowSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlacementWorkflowSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePlacementWorkflowSummaryQuery(baseOptions?: Apollo.QueryHookOptions<PlacementWorkflowSummaryQuery, PlacementWorkflowSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlacementWorkflowSummaryQuery, PlacementWorkflowSummaryQueryVariables>(PlacementWorkflowSummaryDocument, options);
      }
export function usePlacementWorkflowSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlacementWorkflowSummaryQuery, PlacementWorkflowSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlacementWorkflowSummaryQuery, PlacementWorkflowSummaryQueryVariables>(PlacementWorkflowSummaryDocument, options);
        }
export type PlacementWorkflowSummaryQueryHookResult = ReturnType<typeof usePlacementWorkflowSummaryQuery>;
export type PlacementWorkflowSummaryLazyQueryHookResult = ReturnType<typeof usePlacementWorkflowSummaryLazyQuery>;
export type PlacementWorkflowSummaryQueryResult = Apollo.QueryResult<PlacementWorkflowSummaryQuery, PlacementWorkflowSummaryQueryVariables>;
export const PlaybookDocument = gql`
    query Playbook($id: String!) {
  playbook(id: $id) {
    ...Playbook
    files {
      ...PlaybookFile
    }
  }
}
    ${PlaybookFragmentDoc}
${PlaybookFileFragmentDoc}`;

/**
 * __usePlaybookQuery__
 *
 * To run a query within a React component, call `usePlaybookQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaybookQuery(baseOptions: Apollo.QueryHookOptions<PlaybookQuery, PlaybookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookQuery, PlaybookQueryVariables>(PlaybookDocument, options);
      }
export function usePlaybookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookQuery, PlaybookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookQuery, PlaybookQueryVariables>(PlaybookDocument, options);
        }
export type PlaybookQueryHookResult = ReturnType<typeof usePlaybookQuery>;
export type PlaybookLazyQueryHookResult = ReturnType<typeof usePlaybookLazyQuery>;
export type PlaybookQueryResult = Apollo.QueryResult<PlaybookQuery, PlaybookQueryVariables>;
export const PlaybookRunDocument = gql`
    query PlaybookRun($id: String!) {
  playbookRun(id: $id) {
    ...PlaybookRun
  }
}
    ${PlaybookRunFragmentDoc}`;

/**
 * __usePlaybookRunQuery__
 *
 * To run a query within a React component, call `usePlaybookRunQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookRunQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaybookRunQuery(baseOptions: Apollo.QueryHookOptions<PlaybookRunQuery, PlaybookRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookRunQuery, PlaybookRunQueryVariables>(PlaybookRunDocument, options);
      }
export function usePlaybookRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookRunQuery, PlaybookRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookRunQuery, PlaybookRunQueryVariables>(PlaybookRunDocument, options);
        }
export type PlaybookRunQueryHookResult = ReturnType<typeof usePlaybookRunQuery>;
export type PlaybookRunLazyQueryHookResult = ReturnType<typeof usePlaybookRunLazyQuery>;
export type PlaybookRunQueryResult = Apollo.QueryResult<PlaybookRunQuery, PlaybookRunQueryVariables>;
export const PlaybookRunsDocument = gql`
    query PlaybookRuns($chatSessionId: String) {
  playbookRuns(chatSessionId: $chatSessionId) {
    ...PlaybookRun
  }
}
    ${PlaybookRunFragmentDoc}`;

/**
 * __usePlaybookRunsQuery__
 *
 * To run a query within a React component, call `usePlaybookRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookRunsQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function usePlaybookRunsQuery(baseOptions?: Apollo.QueryHookOptions<PlaybookRunsQuery, PlaybookRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookRunsQuery, PlaybookRunsQueryVariables>(PlaybookRunsDocument, options);
      }
export function usePlaybookRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookRunsQuery, PlaybookRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookRunsQuery, PlaybookRunsQueryVariables>(PlaybookRunsDocument, options);
        }
export type PlaybookRunsQueryHookResult = ReturnType<typeof usePlaybookRunsQuery>;
export type PlaybookRunsLazyQueryHookResult = ReturnType<typeof usePlaybookRunsLazyQuery>;
export type PlaybookRunsQueryResult = Apollo.QueryResult<PlaybookRunsQuery, PlaybookRunsQueryVariables>;
export const PlaybookRunsForConversationDocument = gql`
    query PlaybookRunsForConversation($conversationId: String!) {
  playbookRunsForConversation(conversationId: $conversationId) {
    ...PlaybookRun
  }
}
    ${PlaybookRunFragmentDoc}`;

/**
 * __usePlaybookRunsForConversationQuery__
 *
 * To run a query within a React component, call `usePlaybookRunsForConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookRunsForConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookRunsForConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function usePlaybookRunsForConversationQuery(baseOptions: Apollo.QueryHookOptions<PlaybookRunsForConversationQuery, PlaybookRunsForConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookRunsForConversationQuery, PlaybookRunsForConversationQueryVariables>(PlaybookRunsForConversationDocument, options);
      }
export function usePlaybookRunsForConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookRunsForConversationQuery, PlaybookRunsForConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookRunsForConversationQuery, PlaybookRunsForConversationQueryVariables>(PlaybookRunsForConversationDocument, options);
        }
export type PlaybookRunsForConversationQueryHookResult = ReturnType<typeof usePlaybookRunsForConversationQuery>;
export type PlaybookRunsForConversationLazyQueryHookResult = ReturnType<typeof usePlaybookRunsForConversationLazyQuery>;
export type PlaybookRunsForConversationQueryResult = Apollo.QueryResult<PlaybookRunsForConversationQuery, PlaybookRunsForConversationQueryVariables>;
export const PlaybookSetByIdDocument = gql`
    query PlaybookSetById($id: ID!) {
  playbookSet(id: $id) {
    ...PlaybookSetWithPlaybooks
  }
}
    ${PlaybookSetWithPlaybooksFragmentDoc}
${PlaybookFragmentDoc}`;

/**
 * __usePlaybookSetByIdQuery__
 *
 * To run a query within a React component, call `usePlaybookSetByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookSetByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookSetByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePlaybookSetByIdQuery(baseOptions: Apollo.QueryHookOptions<PlaybookSetByIdQuery, PlaybookSetByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookSetByIdQuery, PlaybookSetByIdQueryVariables>(PlaybookSetByIdDocument, options);
      }
export function usePlaybookSetByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookSetByIdQuery, PlaybookSetByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookSetByIdQuery, PlaybookSetByIdQueryVariables>(PlaybookSetByIdDocument, options);
        }
export type PlaybookSetByIdQueryHookResult = ReturnType<typeof usePlaybookSetByIdQuery>;
export type PlaybookSetByIdLazyQueryHookResult = ReturnType<typeof usePlaybookSetByIdLazyQuery>;
export type PlaybookSetByIdQueryResult = Apollo.QueryResult<PlaybookSetByIdQuery, PlaybookSetByIdQueryVariables>;
export const PlaybookSetMembershipsDocument = gql`
    query PlaybookSetMemberships($playbookId: String!) {
  playbookSetMemberships(playbookId: $playbookId)
}
    `;

/**
 * __usePlaybookSetMembershipsQuery__
 *
 * To run a query within a React component, call `usePlaybookSetMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookSetMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookSetMembershipsQuery({
 *   variables: {
 *      playbookId: // value for 'playbookId'
 *   },
 * });
 */
export function usePlaybookSetMembershipsQuery(baseOptions: Apollo.QueryHookOptions<PlaybookSetMembershipsQuery, PlaybookSetMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookSetMembershipsQuery, PlaybookSetMembershipsQueryVariables>(PlaybookSetMembershipsDocument, options);
      }
export function usePlaybookSetMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookSetMembershipsQuery, PlaybookSetMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookSetMembershipsQuery, PlaybookSetMembershipsQueryVariables>(PlaybookSetMembershipsDocument, options);
        }
export type PlaybookSetMembershipsQueryHookResult = ReturnType<typeof usePlaybookSetMembershipsQuery>;
export type PlaybookSetMembershipsLazyQueryHookResult = ReturnType<typeof usePlaybookSetMembershipsLazyQuery>;
export type PlaybookSetMembershipsQueryResult = Apollo.QueryResult<PlaybookSetMembershipsQuery, PlaybookSetMembershipsQueryVariables>;
export const PlaybookSetsDocument = gql`
    query PlaybookSets {
  playbookSets {
    ...PlaybookSetWithPlaybooks
  }
}
    ${PlaybookSetWithPlaybooksFragmentDoc}
${PlaybookFragmentDoc}`;

/**
 * __usePlaybookSetsQuery__
 *
 * To run a query within a React component, call `usePlaybookSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookSetsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlaybookSetsQuery(baseOptions?: Apollo.QueryHookOptions<PlaybookSetsQuery, PlaybookSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybookSetsQuery, PlaybookSetsQueryVariables>(PlaybookSetsDocument, options);
      }
export function usePlaybookSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybookSetsQuery, PlaybookSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybookSetsQuery, PlaybookSetsQueryVariables>(PlaybookSetsDocument, options);
        }
export type PlaybookSetsQueryHookResult = ReturnType<typeof usePlaybookSetsQuery>;
export type PlaybookSetsLazyQueryHookResult = ReturnType<typeof usePlaybookSetsLazyQuery>;
export type PlaybookSetsQueryResult = Apollo.QueryResult<PlaybookSetsQuery, PlaybookSetsQueryVariables>;
export const PoliciesListDocument = gql`
    query PoliciesList($input: PolicyFilterInput!) {
  policies(input: $input) {
    ...PolicyList
  }
}
    ${PolicyListFragmentDoc}
${SlimAppetiteProductFragmentFragmentDoc}`;

/**
 * __usePoliciesListQuery__
 *
 * To run a query within a React component, call `usePoliciesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePoliciesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePoliciesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePoliciesListQuery(baseOptions: Apollo.QueryHookOptions<PoliciesListQuery, PoliciesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PoliciesListQuery, PoliciesListQueryVariables>(PoliciesListDocument, options);
      }
export function usePoliciesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PoliciesListQuery, PoliciesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PoliciesListQuery, PoliciesListQueryVariables>(PoliciesListDocument, options);
        }
export type PoliciesListQueryHookResult = ReturnType<typeof usePoliciesListQuery>;
export type PoliciesListLazyQueryHookResult = ReturnType<typeof usePoliciesListLazyQuery>;
export type PoliciesListQueryResult = Apollo.QueryResult<PoliciesListQuery, PoliciesListQueryVariables>;
export const PolicyDocument = gql`
    query Policy($id: ID!) {
  policy(id: $id) {
    ...Policy
  }
}
    ${PolicyFragmentDoc}
${UserAccountFragmentDoc}
${FileUploadFragmentDoc}
${PolicyStateTransitionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}`;

/**
 * __usePolicyQuery__
 *
 * To run a query within a React component, call `usePolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePolicyQuery(baseOptions: Apollo.QueryHookOptions<PolicyQuery, PolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyQuery, PolicyQueryVariables>(PolicyDocument, options);
      }
export function usePolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyQuery, PolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyQuery, PolicyQueryVariables>(PolicyDocument, options);
        }
export type PolicyQueryHookResult = ReturnType<typeof usePolicyQuery>;
export type PolicyLazyQueryHookResult = ReturnType<typeof usePolicyLazyQuery>;
export type PolicyQueryResult = Apollo.QueryResult<PolicyQuery, PolicyQueryVariables>;
export const PolicyFileTypesDocument = gql`
    query PolicyFileTypes {
  policyFileTypes
}
    `;

/**
 * __usePolicyFileTypesQuery__
 *
 * To run a query within a React component, call `usePolicyFileTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyFileTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyFileTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePolicyFileTypesQuery(baseOptions?: Apollo.QueryHookOptions<PolicyFileTypesQuery, PolicyFileTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyFileTypesQuery, PolicyFileTypesQueryVariables>(PolicyFileTypesDocument, options);
      }
export function usePolicyFileTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyFileTypesQuery, PolicyFileTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyFileTypesQuery, PolicyFileTypesQueryVariables>(PolicyFileTypesDocument, options);
        }
export type PolicyFileTypesQueryHookResult = ReturnType<typeof usePolicyFileTypesQuery>;
export type PolicyFileTypesLazyQueryHookResult = ReturnType<typeof usePolicyFileTypesLazyQuery>;
export type PolicyFileTypesQueryResult = Apollo.QueryResult<PolicyFileTypesQuery, PolicyFileTypesQueryVariables>;
export const PolicyAgentEmailPreviewDocument = gql`
    query PolicyAgentEmailPreview($policyId: ID!, $kind: PolicyAgentEmailKind!) {
  policyAgentEmailPreview(policyId: $policyId, kind: $kind) {
    html
  }
}
    `;

/**
 * __usePolicyAgentEmailPreviewQuery__
 *
 * To run a query within a React component, call `usePolicyAgentEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyAgentEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyAgentEmailPreviewQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function usePolicyAgentEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<PolicyAgentEmailPreviewQuery, PolicyAgentEmailPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyAgentEmailPreviewQuery, PolicyAgentEmailPreviewQueryVariables>(PolicyAgentEmailPreviewDocument, options);
      }
export function usePolicyAgentEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyAgentEmailPreviewQuery, PolicyAgentEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyAgentEmailPreviewQuery, PolicyAgentEmailPreviewQueryVariables>(PolicyAgentEmailPreviewDocument, options);
        }
export type PolicyAgentEmailPreviewQueryHookResult = ReturnType<typeof usePolicyAgentEmailPreviewQuery>;
export type PolicyAgentEmailPreviewLazyQueryHookResult = ReturnType<typeof usePolicyAgentEmailPreviewLazyQuery>;
export type PolicyAgentEmailPreviewQueryResult = Apollo.QueryResult<PolicyAgentEmailPreviewQuery, PolicyAgentEmailPreviewQueryVariables>;
export const PolicyAscendInvoiceDocument = gql`
    query PolicyAscendInvoice($policyId: ID!) {
  policyAscendInvoice(policyId: $policyId) {
    outcome
    invoiceId
    invoiceNumber
    totalCents
    status
    emailLine
    pdfFilename
    matchedPolicyNumber
    ascendUrl
    candidateUrls
    policyPremium
  }
}
    `;

/**
 * __usePolicyAscendInvoiceQuery__
 *
 * To run a query within a React component, call `usePolicyAscendInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePolicyAscendInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePolicyAscendInvoiceQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function usePolicyAscendInvoiceQuery(baseOptions: Apollo.QueryHookOptions<PolicyAscendInvoiceQuery, PolicyAscendInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PolicyAscendInvoiceQuery, PolicyAscendInvoiceQueryVariables>(PolicyAscendInvoiceDocument, options);
      }
export function usePolicyAscendInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PolicyAscendInvoiceQuery, PolicyAscendInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PolicyAscendInvoiceQuery, PolicyAscendInvoiceQueryVariables>(PolicyAscendInvoiceDocument, options);
        }
export type PolicyAscendInvoiceQueryHookResult = ReturnType<typeof usePolicyAscendInvoiceQuery>;
export type PolicyAscendInvoiceLazyQueryHookResult = ReturnType<typeof usePolicyAscendInvoiceLazyQuery>;
export type PolicyAscendInvoiceQueryResult = Apollo.QueryResult<PolicyAscendInvoiceQuery, PolicyAscendInvoiceQueryVariables>;
export const ProcessVaveQuoteDocument = gql`
    mutation ProcessVaveQuote($input: ProcessVaveQuoteInput!) {
  processQuote(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;
export type ProcessVaveQuoteMutationFn = Apollo.MutationFunction<ProcessVaveQuoteMutation, ProcessVaveQuoteMutationVariables>;

/**
 * __useProcessVaveQuoteMutation__
 *
 * To run a mutation, you first call `useProcessVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processVaveQuoteMutation, { data, loading, error }] = useProcessVaveQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ProcessVaveQuoteMutation, ProcessVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessVaveQuoteMutation, ProcessVaveQuoteMutationVariables>(ProcessVaveQuoteDocument, options);
      }
export type ProcessVaveQuoteMutationHookResult = ReturnType<typeof useProcessVaveQuoteMutation>;
export type ProcessVaveQuoteMutationResult = Apollo.MutationResult<ProcessVaveQuoteMutation>;
export type ProcessVaveQuoteMutationOptions = Apollo.BaseMutationOptions<ProcessVaveQuoteMutation, ProcessVaveQuoteMutationVariables>;
export const ProductDocument = gql`
    query Product($id: ID!) {
  product(id: $id) {
    ...Product
    historicalInsights
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductsDocument = gql`
    query Products {
  products {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const ProductsByCarrierDocument = gql`
    query ProductsByCarrier($carrierSlug: String!) {
  productsByCarrier(carrierSlug: $carrierSlug) {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductsByCarrierQuery__
 *
 * To run a query within a React component, call `useProductsByCarrierQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsByCarrierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsByCarrierQuery({
 *   variables: {
 *      carrierSlug: // value for 'carrierSlug'
 *   },
 * });
 */
export function useProductsByCarrierQuery(baseOptions: Apollo.QueryHookOptions<ProductsByCarrierQuery, ProductsByCarrierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsByCarrierQuery, ProductsByCarrierQueryVariables>(ProductsByCarrierDocument, options);
      }
export function useProductsByCarrierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsByCarrierQuery, ProductsByCarrierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsByCarrierQuery, ProductsByCarrierQueryVariables>(ProductsByCarrierDocument, options);
        }
export type ProductsByCarrierQueryHookResult = ReturnType<typeof useProductsByCarrierQuery>;
export type ProductsByCarrierLazyQueryHookResult = ReturnType<typeof useProductsByCarrierLazyQuery>;
export type ProductsByCarrierQueryResult = Apollo.QueryResult<ProductsByCarrierQuery, ProductsByCarrierQueryVariables>;
export const ProposalValuesDocument = gql`
    query ProposalValues($input: QuoteProposalValuesInput!) {
  proposalValues(input: $input) {
    stampingFee
    mep
    carrierName
    premium
    subjectivities
    insuredName
    effectiveDate
    lines
    homeState
    agentFirstName
    agencyName
    agentCommission
    grossCommission
    surplusLinesTaxes
    brokerFee
    inspectionFee
    totalPremium
    admitted
  }
}
    `;

/**
 * __useProposalValuesQuery__
 *
 * To run a query within a React component, call `useProposalValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProposalValuesQuery(baseOptions: Apollo.QueryHookOptions<ProposalValuesQuery, ProposalValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalValuesQuery, ProposalValuesQueryVariables>(ProposalValuesDocument, options);
      }
export function useProposalValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalValuesQuery, ProposalValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalValuesQuery, ProposalValuesQueryVariables>(ProposalValuesDocument, options);
        }
export type ProposalValuesQueryHookResult = ReturnType<typeof useProposalValuesQuery>;
export type ProposalValuesLazyQueryHookResult = ReturnType<typeof useProposalValuesLazyQuery>;
export type ProposalValuesQueryResult = Apollo.QueryResult<ProposalValuesQuery, ProposalValuesQueryVariables>;
export const QuoteDocument = gql`
    query Quote($id: ID!) {
  quote(id: $id) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;

/**
 * __useQuoteQuery__
 *
 * To run a query within a React component, call `useQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteQuery(baseOptions: Apollo.QueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
      }
export function useQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteQuery, QuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteQuery, QuoteQueryVariables>(QuoteDocument, options);
        }
export type QuoteQueryHookResult = ReturnType<typeof useQuoteQuery>;
export type QuoteLazyQueryHookResult = ReturnType<typeof useQuoteLazyQuery>;
export type QuoteQueryResult = Apollo.QueryResult<QuoteQuery, QuoteQueryVariables>;
export const QuoteEmailPreviewDocument = gql`
    query QuoteEmailPreview($quoteId: ID!) {
  quoteEmailPreview(quoteId: $quoteId) {
    html
    newEmailSubject
    replyThreadCandidates {
      id
      subject
      lastMessageAt
    }
  }
}
    `;

/**
 * __useQuoteEmailPreviewQuery__
 *
 * To run a query within a React component, call `useQuoteEmailPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteEmailPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteEmailPreviewQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useQuoteEmailPreviewQuery(baseOptions: Apollo.QueryHookOptions<QuoteEmailPreviewQuery, QuoteEmailPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteEmailPreviewQuery, QuoteEmailPreviewQueryVariables>(QuoteEmailPreviewDocument, options);
      }
export function useQuoteEmailPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteEmailPreviewQuery, QuoteEmailPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteEmailPreviewQuery, QuoteEmailPreviewQueryVariables>(QuoteEmailPreviewDocument, options);
        }
export type QuoteEmailPreviewQueryHookResult = ReturnType<typeof useQuoteEmailPreviewQuery>;
export type QuoteEmailPreviewLazyQueryHookResult = ReturnType<typeof useQuoteEmailPreviewLazyQuery>;
export type QuoteEmailPreviewQueryResult = Apollo.QueryResult<QuoteEmailPreviewQuery, QuoteEmailPreviewQueryVariables>;
export const QuoteInspectionSurveyDocument = gql`
    query QuoteInspectionSurvey($id: ID!) {
  quote(id: $id) {
    id
    inspectionSurveyRequest
    inspectionSurveyNote
  }
}
    `;

/**
 * __useQuoteInspectionSurveyQuery__
 *
 * To run a query within a React component, call `useQuoteInspectionSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuoteInspectionSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuoteInspectionSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useQuoteInspectionSurveyQuery(baseOptions: Apollo.QueryHookOptions<QuoteInspectionSurveyQuery, QuoteInspectionSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuoteInspectionSurveyQuery, QuoteInspectionSurveyQueryVariables>(QuoteInspectionSurveyDocument, options);
      }
export function useQuoteInspectionSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuoteInspectionSurveyQuery, QuoteInspectionSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuoteInspectionSurveyQuery, QuoteInspectionSurveyQueryVariables>(QuoteInspectionSurveyDocument, options);
        }
export type QuoteInspectionSurveyQueryHookResult = ReturnType<typeof useQuoteInspectionSurveyQuery>;
export type QuoteInspectionSurveyLazyQueryHookResult = ReturnType<typeof useQuoteInspectionSurveyLazyQuery>;
export type QuoteInspectionSurveyQueryResult = Apollo.QueryResult<QuoteInspectionSurveyQuery, QuoteInspectionSurveyQueryVariables>;
export const QuotesDocument = gql`
    query Quotes($input: QuotesInput!) {
  quotes(input: $input) {
    ...Quote
  }
}
    ${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}`;

/**
 * __useQuotesQuery__
 *
 * To run a query within a React component, call `useQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuotesQuery(baseOptions: Apollo.QueryHookOptions<QuotesQuery, QuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotesQuery, QuotesQueryVariables>(QuotesDocument, options);
      }
export function useQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotesQuery, QuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotesQuery, QuotesQueryVariables>(QuotesDocument, options);
        }
export type QuotesQueryHookResult = ReturnType<typeof useQuotesQuery>;
export type QuotesLazyQueryHookResult = ReturnType<typeof useQuotesLazyQuery>;
export type QuotesQueryResult = Apollo.QueryResult<QuotesQuery, QuotesQueryVariables>;
export const RecentChatSessionsMenuItemsDocument = gql`
    query RecentChatSessionsMenuItems {
  recentChatSessionsMenuItems {
    id
    displayTitle
    insuredId
    inboxConversationId
    lastMessageAt
  }
}
    `;

/**
 * __useRecentChatSessionsMenuItemsQuery__
 *
 * To run a query within a React component, call `useRecentChatSessionsMenuItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentChatSessionsMenuItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentChatSessionsMenuItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecentChatSessionsMenuItemsQuery(baseOptions?: Apollo.QueryHookOptions<RecentChatSessionsMenuItemsQuery, RecentChatSessionsMenuItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentChatSessionsMenuItemsQuery, RecentChatSessionsMenuItemsQueryVariables>(RecentChatSessionsMenuItemsDocument, options);
      }
export function useRecentChatSessionsMenuItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentChatSessionsMenuItemsQuery, RecentChatSessionsMenuItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentChatSessionsMenuItemsQuery, RecentChatSessionsMenuItemsQueryVariables>(RecentChatSessionsMenuItemsDocument, options);
        }
export type RecentChatSessionsMenuItemsQueryHookResult = ReturnType<typeof useRecentChatSessionsMenuItemsQuery>;
export type RecentChatSessionsMenuItemsLazyQueryHookResult = ReturnType<typeof useRecentChatSessionsMenuItemsLazyQuery>;
export type RecentChatSessionsMenuItemsQueryResult = Apollo.QueryResult<RecentChatSessionsMenuItemsQuery, RecentChatSessionsMenuItemsQueryVariables>;
export const ReinstateVaveQuoteDocument = gql`
    mutation ReinstateVaveQuote($input: ReinstateVaveQuoteInput!) {
  reinstate(input: $input) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type ReinstateVaveQuoteMutationFn = Apollo.MutationFunction<ReinstateVaveQuoteMutation, ReinstateVaveQuoteMutationVariables>;

/**
 * __useReinstateVaveQuoteMutation__
 *
 * To run a mutation, you first call `useReinstateVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinstateVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinstateVaveQuoteMutation, { data, loading, error }] = useReinstateVaveQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReinstateVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ReinstateVaveQuoteMutation, ReinstateVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReinstateVaveQuoteMutation, ReinstateVaveQuoteMutationVariables>(ReinstateVaveQuoteDocument, options);
      }
export type ReinstateVaveQuoteMutationHookResult = ReturnType<typeof useReinstateVaveQuoteMutation>;
export type ReinstateVaveQuoteMutationResult = Apollo.MutationResult<ReinstateVaveQuoteMutation>;
export type ReinstateVaveQuoteMutationOptions = Apollo.BaseMutationOptions<ReinstateVaveQuoteMutation, ReinstateVaveQuoteMutationVariables>;
export const RenewalsDataDocument = gql`
    query RenewalsData($input: RenewalsDataInput) {
  renewalsData(input: $input) {
    id
    policyId
    state
    isRenewable
    policyHasRenewal
    attributedTo {
      firstName
      lastName
      attributionRole
    }
    renewalOpportunity {
      id
      renewalStatusRecord {
        status
        bindingStatus
        updatedAt
        latestLog {
          id
          previousStatus
          newStatus
          createdAt
        }
      }
      classificationLabels
      selectedLinesOfBusiness
      renewalNotes {
        ...RenewalNote
      }
      broker {
        id
        firstName
        lastName
      }
      submissions {
        id
        appetiteProduct {
          carrierName
          carrierProductName
        }
        quotes {
          id
          state
          premium
          brokerFee
          agentCommission
          grossCommission
          policy {
            id
            endorsementData {
              ...EndorsementDataFields
            }
          }
        }
      }
    }
    bindHqPolicy {
      id
      policyNumber
      businessType
      linesOfBusiness
      effectiveDate
      expirationDate
      status
      marketingCompanyName
      endorsementData {
        ...EndorsementDataFields
      }
    }
    quote {
      id
      premium
      brokerFee
      agentCommission
      grossCommission
      submission {
        id
        opportunity {
          id
          insured {
            id
            name
            agent {
              id
              firstName
              lastName
              email
              phone
              agency {
                id
                name
              }
            }
            secondaryAgents {
              id
              firstName
              lastName
              email
              phone
              agency {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    ${RenewalNoteFragmentDoc}
${EndorsementDataFieldsFragmentDoc}`;

/**
 * __useRenewalsDataQuery__
 *
 * To run a query within a React component, call `useRenewalsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewalsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewalsDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenewalsDataQuery(baseOptions?: Apollo.QueryHookOptions<RenewalsDataQuery, RenewalsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenewalsDataQuery, RenewalsDataQueryVariables>(RenewalsDataDocument, options);
      }
export function useRenewalsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenewalsDataQuery, RenewalsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenewalsDataQuery, RenewalsDataQueryVariables>(RenewalsDataDocument, options);
        }
export type RenewalsDataQueryHookResult = ReturnType<typeof useRenewalsDataQuery>;
export type RenewalsDataLazyQueryHookResult = ReturnType<typeof useRenewalsDataLazyQuery>;
export type RenewalsDataQueryResult = Apollo.QueryResult<RenewalsDataQuery, RenewalsDataQueryVariables>;
export const RequestBindVaveQuoteDocument = gql`
    mutation RequestBindVaveQuote($vaveQuoteId: String!) {
  bindRequest(vaveQuoteId: $vaveQuoteId) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;
export type RequestBindVaveQuoteMutationFn = Apollo.MutationFunction<RequestBindVaveQuoteMutation, RequestBindVaveQuoteMutationVariables>;

/**
 * __useRequestBindVaveQuoteMutation__
 *
 * To run a mutation, you first call `useRequestBindVaveQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestBindVaveQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestBindVaveQuoteMutation, { data, loading, error }] = useRequestBindVaveQuoteMutation({
 *   variables: {
 *      vaveQuoteId: // value for 'vaveQuoteId'
 *   },
 * });
 */
export function useRequestBindVaveQuoteMutation(baseOptions?: Apollo.MutationHookOptions<RequestBindVaveQuoteMutation, RequestBindVaveQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestBindVaveQuoteMutation, RequestBindVaveQuoteMutationVariables>(RequestBindVaveQuoteDocument, options);
      }
export type RequestBindVaveQuoteMutationHookResult = ReturnType<typeof useRequestBindVaveQuoteMutation>;
export type RequestBindVaveQuoteMutationResult = Apollo.MutationResult<RequestBindVaveQuoteMutation>;
export type RequestBindVaveQuoteMutationOptions = Apollo.BaseMutationOptions<RequestBindVaveQuoteMutation, RequestBindVaveQuoteMutationVariables>;
export const SearchAppetiteDocument = gql`
    query SearchAppetite($id: ID!) {
  appetiteSearchForOpportunity(id: $id) {
    scoredProducts {
      product {
        id
        carrierName
        carrierProductName
        marketType
        coverages
        endorsements
        coreLines
        productDescription
        portalLink
        submissionInstructions
        submissionCarrierContacts {
          ...CarrierContact
        }
        referenceCarrierContacts {
          ...CarrierContact
        }
        authority(id: $id)
        bindingGuideResults(id: $id) {
          id
          cgl
          lob
          result
          explanation
        }
      }
    }
  }
}
    ${CarrierContactFragmentDoc}`;

/**
 * __useSearchAppetiteQuery__
 *
 * To run a query within a React component, call `useSearchAppetiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppetiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppetiteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSearchAppetiteQuery(baseOptions: Apollo.QueryHookOptions<SearchAppetiteQuery, SearchAppetiteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppetiteQuery, SearchAppetiteQueryVariables>(SearchAppetiteDocument, options);
      }
export function useSearchAppetiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppetiteQuery, SearchAppetiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppetiteQuery, SearchAppetiteQueryVariables>(SearchAppetiteDocument, options);
        }
export type SearchAppetiteQueryHookResult = ReturnType<typeof useSearchAppetiteQuery>;
export type SearchAppetiteLazyQueryHookResult = ReturnType<typeof useSearchAppetiteLazyQuery>;
export type SearchAppetiteQueryResult = Apollo.QueryResult<SearchAppetiteQuery, SearchAppetiteQueryVariables>;
export const SearchAppetiteForOpportunityDocument = gql`
    query SearchAppetiteForOpportunity($id: ID!, $includeAiScores: Boolean = true) {
  appetiteSearchForOpportunity(id: $id, includeAiScores: $includeAiScores) {
    scoredProducts {
      ...ScoredAppetiteProduct
    }
  }
}
    ${ScoredAppetiteProductFragmentDoc}`;

/**
 * __useSearchAppetiteForOpportunityQuery__
 *
 * To run a query within a React component, call `useSearchAppetiteForOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAppetiteForOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAppetiteForOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeAiScores: // value for 'includeAiScores'
 *   },
 * });
 */
export function useSearchAppetiteForOpportunityQuery(baseOptions: Apollo.QueryHookOptions<SearchAppetiteForOpportunityQuery, SearchAppetiteForOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAppetiteForOpportunityQuery, SearchAppetiteForOpportunityQueryVariables>(SearchAppetiteForOpportunityDocument, options);
      }
export function useSearchAppetiteForOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAppetiteForOpportunityQuery, SearchAppetiteForOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAppetiteForOpportunityQuery, SearchAppetiteForOpportunityQueryVariables>(SearchAppetiteForOpportunityDocument, options);
        }
export type SearchAppetiteForOpportunityQueryHookResult = ReturnType<typeof useSearchAppetiteForOpportunityQuery>;
export type SearchAppetiteForOpportunityLazyQueryHookResult = ReturnType<typeof useSearchAppetiteForOpportunityLazyQuery>;
export type SearchAppetiteForOpportunityQueryResult = Apollo.QueryResult<SearchAppetiteForOpportunityQuery, SearchAppetiteForOpportunityQueryVariables>;
export const SearchBusinessClassesDocument = gql`
    query SearchBusinessClasses($input: BusinessClassificationsSearchInput!) {
  searchBusinessClasses(input: $input) {
    ...BusinessClass
  }
}
    ${BusinessClassFragmentDoc}`;

/**
 * __useSearchBusinessClassesQuery__
 *
 * To run a query within a React component, call `useSearchBusinessClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBusinessClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBusinessClassesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchBusinessClassesQuery(baseOptions: Apollo.QueryHookOptions<SearchBusinessClassesQuery, SearchBusinessClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBusinessClassesQuery, SearchBusinessClassesQueryVariables>(SearchBusinessClassesDocument, options);
      }
export function useSearchBusinessClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBusinessClassesQuery, SearchBusinessClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBusinessClassesQuery, SearchBusinessClassesQueryVariables>(SearchBusinessClassesDocument, options);
        }
export type SearchBusinessClassesQueryHookResult = ReturnType<typeof useSearchBusinessClassesQuery>;
export type SearchBusinessClassesLazyQueryHookResult = ReturnType<typeof useSearchBusinessClassesLazyQuery>;
export type SearchBusinessClassesQueryResult = Apollo.QueryResult<SearchBusinessClassesQuery, SearchBusinessClassesQueryVariables>;
export const SelectProductsOpportunityDocument = gql`
    query SelectProductsOpportunity {
  appetiteProductLines
}
    `;

/**
 * __useSelectProductsOpportunityQuery__
 *
 * To run a query within a React component, call `useSelectProductsOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectProductsOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectProductsOpportunityQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectProductsOpportunityQuery(baseOptions?: Apollo.QueryHookOptions<SelectProductsOpportunityQuery, SelectProductsOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectProductsOpportunityQuery, SelectProductsOpportunityQueryVariables>(SelectProductsOpportunityDocument, options);
      }
export function useSelectProductsOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectProductsOpportunityQuery, SelectProductsOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectProductsOpportunityQuery, SelectProductsOpportunityQueryVariables>(SelectProductsOpportunityDocument, options);
        }
export type SelectProductsOpportunityQueryHookResult = ReturnType<typeof useSelectProductsOpportunityQuery>;
export type SelectProductsOpportunityLazyQueryHookResult = ReturnType<typeof useSelectProductsOpportunityLazyQuery>;
export type SelectProductsOpportunityQueryResult = Apollo.QueryResult<SelectProductsOpportunityQuery, SelectProductsOpportunityQueryVariables>;
export const StampedPolicyFiguresDocument = gql`
    query StampedPolicyFigures($policyId: ID!) {
  stampedPolicyFigures(policyId: $policyId) {
    premium
    surplusLinesTax
    stampingFee
    surplusLinesServiceCharge
    fireMarshallTax
    municipalFee
    countyFee
    empaTax
    carrierFee
    inspectionFee
    brokerFee
    policyNumber
    effectiveDate
    expirationDate
    reviewToken
    bindHqFigureChecks {
      fields
      status
      ours
      bindHq
    }
  }
}
    `;

/**
 * __useStampedPolicyFiguresQuery__
 *
 * To run a query within a React component, call `useStampedPolicyFiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `useStampedPolicyFiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStampedPolicyFiguresQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useStampedPolicyFiguresQuery(baseOptions: Apollo.QueryHookOptions<StampedPolicyFiguresQuery, StampedPolicyFiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StampedPolicyFiguresQuery, StampedPolicyFiguresQueryVariables>(StampedPolicyFiguresDocument, options);
      }
export function useStampedPolicyFiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StampedPolicyFiguresQuery, StampedPolicyFiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StampedPolicyFiguresQuery, StampedPolicyFiguresQueryVariables>(StampedPolicyFiguresDocument, options);
        }
export type StampedPolicyFiguresQueryHookResult = ReturnType<typeof useStampedPolicyFiguresQuery>;
export type StampedPolicyFiguresLazyQueryHookResult = ReturnType<typeof useStampedPolicyFiguresLazyQuery>;
export type StampedPolicyFiguresQueryResult = Apollo.QueryResult<StampedPolicyFiguresQuery, StampedPolicyFiguresQueryVariables>;
export const StateTransitionsDocument = gql`
    query StateTransitions($id: ID!) {
  opportunity(id: $id) {
    id
    stateTransitions {
      ...MarketingPlanStateTransitionFragment
    }
    submissions {
      id
      appetiteProduct {
        ...SlimAppetiteProductFragment
      }
      stateTransitions {
        ...SubmissionStateTransitionFragment
      }
      quotes {
        id
        stateTransitions {
          ...QuoteStateTransitionFragment
        }
        policy {
          id
          stateTransitions {
            ...PolicyStateTransitionFragment
          }
        }
      }
    }
  }
}
    ${MarketingPlanStateTransitionFragmentFragmentDoc}
${SlimAppetiteProductFragmentFragmentDoc}
${SubmissionStateTransitionFragmentFragmentDoc}
${QuoteStateTransitionFragmentFragmentDoc}
${PolicyStateTransitionFragmentFragmentDoc}`;

/**
 * __useStateTransitionsQuery__
 *
 * To run a query within a React component, call `useStateTransitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateTransitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateTransitionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStateTransitionsQuery(baseOptions: Apollo.QueryHookOptions<StateTransitionsQuery, StateTransitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StateTransitionsQuery, StateTransitionsQueryVariables>(StateTransitionsDocument, options);
      }
export function useStateTransitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StateTransitionsQuery, StateTransitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StateTransitionsQuery, StateTransitionsQueryVariables>(StateTransitionsDocument, options);
        }
export type StateTransitionsQueryHookResult = ReturnType<typeof useStateTransitionsQuery>;
export type StateTransitionsLazyQueryHookResult = ReturnType<typeof useStateTransitionsLazyQuery>;
export type StateTransitionsQueryResult = Apollo.QueryResult<StateTransitionsQuery, StateTransitionsQueryVariables>;
export const StrandedRecordsBannerDocument = gql`
    query StrandedRecordsBanner($survivorId: UUID!) {
  strandedRecordsForInsured(survivorId: $survivorId, includePreview: false) {
    survivorId
    hasStrandedRecords
    unfinishedMerges {
      id
      name
    }
  }
}
    `;

/**
 * __useStrandedRecordsBannerQuery__
 *
 * To run a query within a React component, call `useStrandedRecordsBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrandedRecordsBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrandedRecordsBannerQuery({
 *   variables: {
 *      survivorId: // value for 'survivorId'
 *   },
 * });
 */
export function useStrandedRecordsBannerQuery(baseOptions: Apollo.QueryHookOptions<StrandedRecordsBannerQuery, StrandedRecordsBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrandedRecordsBannerQuery, StrandedRecordsBannerQueryVariables>(StrandedRecordsBannerDocument, options);
      }
export function useStrandedRecordsBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrandedRecordsBannerQuery, StrandedRecordsBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrandedRecordsBannerQuery, StrandedRecordsBannerQueryVariables>(StrandedRecordsBannerDocument, options);
        }
export type StrandedRecordsBannerQueryHookResult = ReturnType<typeof useStrandedRecordsBannerQuery>;
export type StrandedRecordsBannerLazyQueryHookResult = ReturnType<typeof useStrandedRecordsBannerLazyQuery>;
export type StrandedRecordsBannerQueryResult = Apollo.QueryResult<StrandedRecordsBannerQuery, StrandedRecordsBannerQueryVariables>;
export const StrandedRecordsForInsuredDocument = gql`
    query StrandedRecordsForInsured($survivorId: UUID!) {
  strandedRecordsForInsured(survivorId: $survivorId) {
    survivorId
    hasStrandedRecords
    previewHash
    totals {
      conversations
      drafts
      opportunities
      files
      gmailThreads
    }
    unfinishedMerges {
      id
      name
      reason
      unfinishedInsuredName
    }
    sources {
      id
      name
      crossAgency
      deprecatedAgency {
        id
        name
      }
      survivorAgency {
        id
        name
      }
      opportunities {
        count
        records {
          id
          name
          state
        }
      }
      files {
        count
        records {
          id
          name
        }
      }
      gmailThreads {
        count
        records {
          id
          subject
        }
      }
      drafts {
        count
        records {
          id
          subject
          sent
        }
      }
      conversations {
        count
        inboxes {
          inboxId
          email
          ownerId
          ownerName
          ownerEmail
          inboxDeleted
          userDeleted
          count
          conversations {
            id
            subject
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStrandedRecordsForInsuredQuery__
 *
 * To run a query within a React component, call `useStrandedRecordsForInsuredQuery` and pass it any options that fit your needs.
 * When your component renders, `useStrandedRecordsForInsuredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStrandedRecordsForInsuredQuery({
 *   variables: {
 *      survivorId: // value for 'survivorId'
 *   },
 * });
 */
export function useStrandedRecordsForInsuredQuery(baseOptions: Apollo.QueryHookOptions<StrandedRecordsForInsuredQuery, StrandedRecordsForInsuredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StrandedRecordsForInsuredQuery, StrandedRecordsForInsuredQueryVariables>(StrandedRecordsForInsuredDocument, options);
      }
export function useStrandedRecordsForInsuredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StrandedRecordsForInsuredQuery, StrandedRecordsForInsuredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StrandedRecordsForInsuredQuery, StrandedRecordsForInsuredQueryVariables>(StrandedRecordsForInsuredDocument, options);
        }
export type StrandedRecordsForInsuredQueryHookResult = ReturnType<typeof useStrandedRecordsForInsuredQuery>;
export type StrandedRecordsForInsuredLazyQueryHookResult = ReturnType<typeof useStrandedRecordsForInsuredLazyQuery>;
export type StrandedRecordsForInsuredQueryResult = Apollo.QueryResult<StrandedRecordsForInsuredQuery, StrandedRecordsForInsuredQueryVariables>;
export const SubmissionDocument = gql`
    query Submission($id: ID!) {
  submission(id: $id) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}
${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;

/**
 * __useSubmissionQuery__
 *
 * To run a query within a React component, call `useSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmissionQuery(baseOptions: Apollo.QueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
      }
export function useSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionQuery, SubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionQuery, SubmissionQueryVariables>(SubmissionDocument, options);
        }
export type SubmissionQueryHookResult = ReturnType<typeof useSubmissionQuery>;
export type SubmissionLazyQueryHookResult = ReturnType<typeof useSubmissionLazyQuery>;
export type SubmissionQueryResult = Apollo.QueryResult<SubmissionQuery, SubmissionQueryVariables>;
export const SubmissionContextDocument = gql`
    query SubmissionContext($id: ID!) {
  submission(id: $id) {
    id
    appetiteProduct {
      id
      carrierName
      carrierProductName
    }
    opportunity {
      id
      selectedLinesOfBusiness
      insured {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSubmissionContextQuery__
 *
 * To run a query within a React component, call `useSubmissionContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmissionContextQuery(baseOptions: Apollo.QueryHookOptions<SubmissionContextQuery, SubmissionContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionContextQuery, SubmissionContextQueryVariables>(SubmissionContextDocument, options);
      }
export function useSubmissionContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionContextQuery, SubmissionContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionContextQuery, SubmissionContextQueryVariables>(SubmissionContextDocument, options);
        }
export type SubmissionContextQueryHookResult = ReturnType<typeof useSubmissionContextQuery>;
export type SubmissionContextLazyQueryHookResult = ReturnType<typeof useSubmissionContextLazyQuery>;
export type SubmissionContextQueryResult = Apollo.QueryResult<SubmissionContextQuery, SubmissionContextQueryVariables>;
export const SubmissionDetailsDocument = gql`
    query SubmissionDetails($id: ID!) {
  submission(id: $id) {
    ...SubmissionDetails
  }
}
    ${SubmissionDetailsFragmentDoc}`;

/**
 * __useSubmissionDetailsQuery__
 *
 * To run a query within a React component, call `useSubmissionDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmissionDetailsQuery(baseOptions: Apollo.QueryHookOptions<SubmissionDetailsQuery, SubmissionDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionDetailsQuery, SubmissionDetailsQueryVariables>(SubmissionDetailsDocument, options);
      }
export function useSubmissionDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionDetailsQuery, SubmissionDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionDetailsQuery, SubmissionDetailsQueryVariables>(SubmissionDetailsDocument, options);
        }
export type SubmissionDetailsQueryHookResult = ReturnType<typeof useSubmissionDetailsQuery>;
export type SubmissionDetailsLazyQueryHookResult = ReturnType<typeof useSubmissionDetailsLazyQuery>;
export type SubmissionDetailsQueryResult = Apollo.QueryResult<SubmissionDetailsQuery, SubmissionDetailsQueryVariables>;
export const SubmissionsDocument = gql`
    query Submissions($args: SubmissionsFilterInput!) {
  submissions(args: $args) {
    ...SubmissionResponse
  }
}
    ${SubmissionResponseFragmentDoc}`;

/**
 * __useSubmissionsQuery__
 *
 * To run a query within a React component, call `useSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<SubmissionsQuery, SubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubmissionsQuery, SubmissionsQueryVariables>(SubmissionsDocument, options);
      }
export function useSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubmissionsQuery, SubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubmissionsQuery, SubmissionsQueryVariables>(SubmissionsDocument, options);
        }
export type SubmissionsQueryHookResult = ReturnType<typeof useSubmissionsQuery>;
export type SubmissionsLazyQueryHookResult = ReturnType<typeof useSubmissionsLazyQuery>;
export type SubmissionsQueryResult = Apollo.QueryResult<SubmissionsQuery, SubmissionsQueryVariables>;
export const TeamsDocument = gql`
    query Teams {
  teams {
    id
    name
    description
    createdAt
    updatedAt
    members {
      id
    }
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const TeamDocument = gql`
    query Team($id: ID!) {
  team(id: $id) {
    id
    name
    description
    createdAt
    updatedAt
    members {
      id
      firstName
      lastName
      email
      roles
    }
  }
}
    `;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export const TranscriptionContextDocument = gql`
    query TranscriptionContext($chatSessionId: String!) {
  transcriptionContext(chatSessionId: $chatSessionId) {
    prompt
  }
}
    `;

/**
 * __useTranscriptionContextQuery__
 *
 * To run a query within a React component, call `useTranscriptionContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranscriptionContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranscriptionContextQuery({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function useTranscriptionContextQuery(baseOptions: Apollo.QueryHookOptions<TranscriptionContextQuery, TranscriptionContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranscriptionContextQuery, TranscriptionContextQueryVariables>(TranscriptionContextDocument, options);
      }
export function useTranscriptionContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranscriptionContextQuery, TranscriptionContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranscriptionContextQuery, TranscriptionContextQueryVariables>(TranscriptionContextDocument, options);
        }
export type TranscriptionContextQueryHookResult = ReturnType<typeof useTranscriptionContextQuery>;
export type TranscriptionContextLazyQueryHookResult = ReturnType<typeof useTranscriptionContextLazyQuery>;
export type TranscriptionContextQueryResult = Apollo.QueryResult<TranscriptionContextQuery, TranscriptionContextQueryVariables>;
export const UnderwritingAssistantAccountsDocument = gql`
    query UnderwritingAssistantAccounts($input: UserAccountFindManyFilter! = {roles: [UnderwritingAssistant]}) {
  userAccounts(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useUnderwritingAssistantAccountsQuery__
 *
 * To run a query within a React component, call `useUnderwritingAssistantAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritingAssistantAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritingAssistantAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnderwritingAssistantAccountsQuery(baseOptions?: Apollo.QueryHookOptions<UnderwritingAssistantAccountsQuery, UnderwritingAssistantAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderwritingAssistantAccountsQuery, UnderwritingAssistantAccountsQueryVariables>(UnderwritingAssistantAccountsDocument, options);
      }
export function useUnderwritingAssistantAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderwritingAssistantAccountsQuery, UnderwritingAssistantAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderwritingAssistantAccountsQuery, UnderwritingAssistantAccountsQueryVariables>(UnderwritingAssistantAccountsDocument, options);
        }
export type UnderwritingAssistantAccountsQueryHookResult = ReturnType<typeof useUnderwritingAssistantAccountsQuery>;
export type UnderwritingAssistantAccountsLazyQueryHookResult = ReturnType<typeof useUnderwritingAssistantAccountsLazyQuery>;
export type UnderwritingAssistantAccountsQueryResult = Apollo.QueryResult<UnderwritingAssistantAccountsQuery, UnderwritingAssistantAccountsQueryVariables>;
export const UniversalSearchDocument = gql`
    query UniversalSearch($term: String!) {
  search(term: $term) {
    ...SearchResult
  }
}
    ${SearchResultFragmentDoc}`;

/**
 * __useUniversalSearchQuery__
 *
 * To run a query within a React component, call `useUniversalSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversalSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversalSearchQuery({
 *   variables: {
 *      term: // value for 'term'
 *   },
 * });
 */
export function useUniversalSearchQuery(baseOptions: Apollo.QueryHookOptions<UniversalSearchQuery, UniversalSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversalSearchQuery, UniversalSearchQueryVariables>(UniversalSearchDocument, options);
      }
export function useUniversalSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversalSearchQuery, UniversalSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversalSearchQuery, UniversalSearchQueryVariables>(UniversalSearchDocument, options);
        }
export type UniversalSearchQueryHookResult = ReturnType<typeof useUniversalSearchQuery>;
export type UniversalSearchLazyQueryHookResult = ReturnType<typeof useUniversalSearchLazyQuery>;
export type UniversalSearchQueryResult = Apollo.QueryResult<UniversalSearchQuery, UniversalSearchQueryVariables>;
export const UserAccountsDocument = gql`
    query UserAccounts($input: UserAccountFindManyFilter!) {
  userAccounts(input: $input) {
    ...UserAccount
  }
}
    ${UserAccountFragmentDoc}`;

/**
 * __useUserAccountsQuery__
 *
 * To run a query within a React component, call `useUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserAccountsQuery(baseOptions: Apollo.QueryHookOptions<UserAccountsQuery, UserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccountsQuery, UserAccountsQueryVariables>(UserAccountsDocument, options);
      }
export function useUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccountsQuery, UserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccountsQuery, UserAccountsQueryVariables>(UserAccountsDocument, options);
        }
export type UserAccountsQueryHookResult = ReturnType<typeof useUserAccountsQuery>;
export type UserAccountsLazyQueryHookResult = ReturnType<typeof useUserAccountsLazyQuery>;
export type UserAccountsQueryResult = Apollo.QueryResult<UserAccountsQuery, UserAccountsQueryVariables>;
export const UserPlaybooksDocument = gql`
    query UserPlaybooks($userId: String!) {
  userPlaybooks(userId: $userId) {
    id
    name
    description
    workflow
    type
    updatedAt
  }
}
    `;

/**
 * __useUserPlaybooksQuery__
 *
 * To run a query within a React component, call `useUserPlaybooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPlaybooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPlaybooksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPlaybooksQuery(baseOptions: Apollo.QueryHookOptions<UserPlaybooksQuery, UserPlaybooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPlaybooksQuery, UserPlaybooksQueryVariables>(UserPlaybooksDocument, options);
      }
export function useUserPlaybooksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPlaybooksQuery, UserPlaybooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPlaybooksQuery, UserPlaybooksQueryVariables>(UserPlaybooksDocument, options);
        }
export type UserPlaybooksQueryHookResult = ReturnType<typeof useUserPlaybooksQuery>;
export type UserPlaybooksLazyQueryHookResult = ReturnType<typeof useUserPlaybooksLazyQuery>;
export type UserPlaybooksQueryResult = Apollo.QueryResult<UserPlaybooksQuery, UserPlaybooksQueryVariables>;
export const VaveQuoteDocument = gql`
    query VaveQuote($id: String!) {
  vaveQuote(id: $id) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;

/**
 * __useVaveQuoteQuery__
 *
 * To run a query within a React component, call `useVaveQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaveQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaveQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVaveQuoteQuery(baseOptions: Apollo.QueryHookOptions<VaveQuoteQuery, VaveQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VaveQuoteQuery, VaveQuoteQueryVariables>(VaveQuoteDocument, options);
      }
export function useVaveQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VaveQuoteQuery, VaveQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VaveQuoteQuery, VaveQuoteQueryVariables>(VaveQuoteDocument, options);
        }
export type VaveQuoteQueryHookResult = ReturnType<typeof useVaveQuoteQuery>;
export type VaveQuoteLazyQueryHookResult = ReturnType<typeof useVaveQuoteLazyQuery>;
export type VaveQuoteQueryResult = Apollo.QueryResult<VaveQuoteQuery, VaveQuoteQueryVariables>;
export const VaveQuoteByPolicyDocument = gql`
    query VaveQuoteByPolicy($policyId: String!) {
  vaveQuoteByPolicyId(policyId: $policyId) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;

/**
 * __useVaveQuoteByPolicyQuery__
 *
 * To run a query within a React component, call `useVaveQuoteByPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaveQuoteByPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaveQuoteByPolicyQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useVaveQuoteByPolicyQuery(baseOptions: Apollo.QueryHookOptions<VaveQuoteByPolicyQuery, VaveQuoteByPolicyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VaveQuoteByPolicyQuery, VaveQuoteByPolicyQueryVariables>(VaveQuoteByPolicyDocument, options);
      }
export function useVaveQuoteByPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VaveQuoteByPolicyQuery, VaveQuoteByPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VaveQuoteByPolicyQuery, VaveQuoteByPolicyQueryVariables>(VaveQuoteByPolicyDocument, options);
        }
export type VaveQuoteByPolicyQueryHookResult = ReturnType<typeof useVaveQuoteByPolicyQuery>;
export type VaveQuoteByPolicyLazyQueryHookResult = ReturnType<typeof useVaveQuoteByPolicyLazyQuery>;
export type VaveQuoteByPolicyQueryResult = Apollo.QueryResult<VaveQuoteByPolicyQuery, VaveQuoteByPolicyQueryVariables>;
export const VaveQuoteByQuoteIdDocument = gql`
    query VaveQuoteByQuoteId($quoteId: String!) {
  vaveQuoteByQuoteId(quoteId: $quoteId) {
    ...VaveQuote
  }
}
    ${VaveQuoteFragmentDoc}`;

/**
 * __useVaveQuoteByQuoteIdQuery__
 *
 * To run a query within a React component, call `useVaveQuoteByQuoteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaveQuoteByQuoteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaveQuoteByQuoteIdQuery({
 *   variables: {
 *      quoteId: // value for 'quoteId'
 *   },
 * });
 */
export function useVaveQuoteByQuoteIdQuery(baseOptions: Apollo.QueryHookOptions<VaveQuoteByQuoteIdQuery, VaveQuoteByQuoteIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VaveQuoteByQuoteIdQuery, VaveQuoteByQuoteIdQueryVariables>(VaveQuoteByQuoteIdDocument, options);
      }
export function useVaveQuoteByQuoteIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VaveQuoteByQuoteIdQuery, VaveQuoteByQuoteIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VaveQuoteByQuoteIdQuery, VaveQuoteByQuoteIdQueryVariables>(VaveQuoteByQuoteIdDocument, options);
        }
export type VaveQuoteByQuoteIdQueryHookResult = ReturnType<typeof useVaveQuoteByQuoteIdQuery>;
export type VaveQuoteByQuoteIdLazyQueryHookResult = ReturnType<typeof useVaveQuoteByQuoteIdLazyQuery>;
export type VaveQuoteByQuoteIdQueryResult = Apollo.QueryResult<VaveQuoteByQuoteIdQuery, VaveQuoteByQuoteIdQueryVariables>;
export const VaveQuoteProposalDocument = gql`
    query VaveQuoteProposal($vaveQuoteId: String!) {
  vaveQuoteProposal(vaveQuoteId: $vaveQuoteId) {
    agentCommission
    agentFirstName
    agencyName
    brokerFee
    carrierFee
    carrierName
    effectiveDate
    grossCommission
    homeState
    inspectionFee
    insuredName
    lines
    mep
    premium
    subjectivities
  }
}
    `;

/**
 * __useVaveQuoteProposalQuery__
 *
 * To run a query within a React component, call `useVaveQuoteProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useVaveQuoteProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVaveQuoteProposalQuery({
 *   variables: {
 *      vaveQuoteId: // value for 'vaveQuoteId'
 *   },
 * });
 */
export function useVaveQuoteProposalQuery(baseOptions: Apollo.QueryHookOptions<VaveQuoteProposalQuery, VaveQuoteProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VaveQuoteProposalQuery, VaveQuoteProposalQueryVariables>(VaveQuoteProposalDocument, options);
      }
export function useVaveQuoteProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VaveQuoteProposalQuery, VaveQuoteProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VaveQuoteProposalQuery, VaveQuoteProposalQueryVariables>(VaveQuoteProposalDocument, options);
        }
export type VaveQuoteProposalQueryHookResult = ReturnType<typeof useVaveQuoteProposalQuery>;
export type VaveQuoteProposalLazyQueryHookResult = ReturnType<typeof useVaveQuoteProposalLazyQuery>;
export type VaveQuoteProposalQueryResult = Apollo.QueryResult<VaveQuoteProposalQuery, VaveQuoteProposalQueryVariables>;
export const AttentionFeedChangedDocument = gql`
    subscription AttentionFeedChanged($userId: String) {
  attentionFeedChanged(userId: $userId) {
    recipientId
    changeType
    attentionItemId
  }
}
    `;

/**
 * __useAttentionFeedChangedSubscription__
 *
 * To run a query within a React component, call `useAttentionFeedChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAttentionFeedChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttentionFeedChangedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAttentionFeedChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<AttentionFeedChangedSubscription, AttentionFeedChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AttentionFeedChangedSubscription, AttentionFeedChangedSubscriptionVariables>(AttentionFeedChangedDocument, options);
      }
export type AttentionFeedChangedSubscriptionHookResult = ReturnType<typeof useAttentionFeedChangedSubscription>;
export type AttentionFeedChangedSubscriptionResult = Apollo.SubscriptionResult<AttentionFeedChangedSubscription>;
export const ChatSessionCompletedDocument = gql`
    subscription ChatSessionCompleted($userId: String) {
  chatSessionCompleted(userId: $userId) {
    chatSessionId
    status
    userId
  }
}
    `;

/**
 * __useChatSessionCompletedSubscription__
 *
 * To run a query within a React component, call `useChatSessionCompletedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionCompletedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionCompletedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatSessionCompletedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatSessionCompletedSubscription, ChatSessionCompletedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatSessionCompletedSubscription, ChatSessionCompletedSubscriptionVariables>(ChatSessionCompletedDocument, options);
      }
export type ChatSessionCompletedSubscriptionHookResult = ReturnType<typeof useChatSessionCompletedSubscription>;
export type ChatSessionCompletedSubscriptionResult = Apollo.SubscriptionResult<ChatSessionCompletedSubscription>;
export const ChatSessionLiveStreamStartedDocument = gql`
    subscription ChatSessionLiveStreamStarted($userId: String) {
  chatSessionLiveStreamStarted(userId: $userId) {
    chatSessionId
    userId
  }
}
    `;

/**
 * __useChatSessionLiveStreamStartedSubscription__
 *
 * To run a query within a React component, call `useChatSessionLiveStreamStartedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionLiveStreamStartedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionLiveStreamStartedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatSessionLiveStreamStartedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatSessionLiveStreamStartedSubscription, ChatSessionLiveStreamStartedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatSessionLiveStreamStartedSubscription, ChatSessionLiveStreamStartedSubscriptionVariables>(ChatSessionLiveStreamStartedDocument, options);
      }
export type ChatSessionLiveStreamStartedSubscriptionHookResult = ReturnType<typeof useChatSessionLiveStreamStartedSubscription>;
export type ChatSessionLiveStreamStartedSubscriptionResult = Apollo.SubscriptionResult<ChatSessionLiveStreamStartedSubscription>;
export const ChatSessionStatusChangedDocument = gql`
    subscription ChatSessionStatusChanged($userId: String) {
  chatSessionStatusChanged(userId: $userId) {
    chatSessionId
    status
    userId
  }
}
    `;

/**
 * __useChatSessionStatusChangedSubscription__
 *
 * To run a query within a React component, call `useChatSessionStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionStatusChangedSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useChatSessionStatusChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<ChatSessionStatusChangedSubscription, ChatSessionStatusChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatSessionStatusChangedSubscription, ChatSessionStatusChangedSubscriptionVariables>(ChatSessionStatusChangedDocument, options);
      }
export type ChatSessionStatusChangedSubscriptionHookResult = ReturnType<typeof useChatSessionStatusChangedSubscription>;
export type ChatSessionStatusChangedSubscriptionResult = Apollo.SubscriptionResult<ChatSessionStatusChangedSubscription>;
export const ChatSessionStreamStateChangedDocument = gql`
    subscription ChatSessionStreamStateChanged($chatSessionId: String!) {
  chatSessionStreamStateChanged(chatSessionId: $chatSessionId) {
    chatSessionId
    kind
    error
    userId
    formatVersion
  }
}
    `;

/**
 * __useChatSessionStreamStateChangedSubscription__
 *
 * To run a query within a React component, call `useChatSessionStreamStateChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatSessionStreamStateChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSessionStreamStateChangedSubscription({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *   },
 * });
 */
export function useChatSessionStreamStateChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatSessionStreamStateChangedSubscription, ChatSessionStreamStateChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatSessionStreamStateChangedSubscription, ChatSessionStreamStateChangedSubscriptionVariables>(ChatSessionStreamStateChangedDocument, options);
      }
export type ChatSessionStreamStateChangedSubscriptionHookResult = ReturnType<typeof useChatSessionStreamStateChangedSubscription>;
export type ChatSessionStreamStateChangedSubscriptionResult = Apollo.SubscriptionResult<ChatSessionStreamStateChangedSubscription>;
export const ConversationHistoryChangedDocument = gql`
    subscription ConversationHistoryChanged($rootChatSessionId: String!) {
  conversationHistoryChanged(rootChatSessionId: $rootChatSessionId) {
    rootChatSessionId
  }
}
    `;

/**
 * __useConversationHistoryChangedSubscription__
 *
 * To run a query within a React component, call `useConversationHistoryChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useConversationHistoryChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationHistoryChangedSubscription({
 *   variables: {
 *      rootChatSessionId: // value for 'rootChatSessionId'
 *   },
 * });
 */
export function useConversationHistoryChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ConversationHistoryChangedSubscription, ConversationHistoryChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ConversationHistoryChangedSubscription, ConversationHistoryChangedSubscriptionVariables>(ConversationHistoryChangedDocument, options);
      }
export type ConversationHistoryChangedSubscriptionHookResult = ReturnType<typeof useConversationHistoryChangedSubscription>;
export type ConversationHistoryChangedSubscriptionResult = Apollo.SubscriptionResult<ConversationHistoryChangedSubscription>;
export const InboxConversationUpdatedDocument = gql`
    subscription InboxConversationUpdated($conversationId: String, $email: String, $inboxId: String) {
  inboxConversationUpdated(
    conversationId: $conversationId
    email: $email
    inboxId: $inboxId
  ) {
    conversationId
    email
    inboxId
  }
}
    `;

/**
 * __useInboxConversationUpdatedSubscription__
 *
 * To run a query within a React component, call `useInboxConversationUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxConversationUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxConversationUpdatedSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      email: // value for 'email'
 *      inboxId: // value for 'inboxId'
 *   },
 * });
 */
export function useInboxConversationUpdatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<InboxConversationUpdatedSubscription, InboxConversationUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxConversationUpdatedSubscription, InboxConversationUpdatedSubscriptionVariables>(InboxConversationUpdatedDocument, options);
      }
export type InboxConversationUpdatedSubscriptionHookResult = ReturnType<typeof useInboxConversationUpdatedSubscription>;
export type InboxConversationUpdatedSubscriptionResult = Apollo.SubscriptionResult<InboxConversationUpdatedSubscription>;
export const InboxDraftSentDocument = gql`
    subscription InboxDraftSent($email: String!) {
  inboxDraftSent(email: $email) {
    email
    draftId
  }
}
    `;

/**
 * __useInboxDraftSentSubscription__
 *
 * To run a query within a React component, call `useInboxDraftSentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxDraftSentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxDraftSentSubscription({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInboxDraftSentSubscription(baseOptions: Apollo.SubscriptionHookOptions<InboxDraftSentSubscription, InboxDraftSentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxDraftSentSubscription, InboxDraftSentSubscriptionVariables>(InboxDraftSentDocument, options);
      }
export type InboxDraftSentSubscriptionHookResult = ReturnType<typeof useInboxDraftSentSubscription>;
export type InboxDraftSentSubscriptionResult = Apollo.SubscriptionResult<InboxDraftSentSubscription>;
export const InboxLabelCountsUpdatedDocument = gql`
    subscription InboxLabelCountsUpdated($email: String!) {
  inboxLabelCountsUpdated(email: $email) {
    email
  }
}
    `;

/**
 * __useInboxLabelCountsUpdatedSubscription__
 *
 * To run a query within a React component, call `useInboxLabelCountsUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxLabelCountsUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxLabelCountsUpdatedSubscription({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInboxLabelCountsUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<InboxLabelCountsUpdatedSubscription, InboxLabelCountsUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxLabelCountsUpdatedSubscription, InboxLabelCountsUpdatedSubscriptionVariables>(InboxLabelCountsUpdatedDocument, options);
      }
export type InboxLabelCountsUpdatedSubscriptionHookResult = ReturnType<typeof useInboxLabelCountsUpdatedSubscription>;
export type InboxLabelCountsUpdatedSubscriptionResult = Apollo.SubscriptionResult<InboxLabelCountsUpdatedSubscription>;
export const InboxMessageCreatedDocument = gql`
    subscription InboxMessageCreated($email: String!) {
  inboxMessageCreated(email: $email) {
    email
    messageId
  }
}
    `;

/**
 * __useInboxMessageCreatedSubscription__
 *
 * To run a query within a React component, call `useInboxMessageCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxMessageCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMessageCreatedSubscription({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInboxMessageCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<InboxMessageCreatedSubscription, InboxMessageCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxMessageCreatedSubscription, InboxMessageCreatedSubscriptionVariables>(InboxMessageCreatedDocument, options);
      }
export type InboxMessageCreatedSubscriptionHookResult = ReturnType<typeof useInboxMessageCreatedSubscription>;
export type InboxMessageCreatedSubscriptionResult = Apollo.SubscriptionResult<InboxMessageCreatedSubscription>;
export const InboxMessageReadyDocument = gql`
    subscription InboxMessageReady($email: String!) {
  inboxMessageReady(email: $email) {
    email
    messageId
  }
}
    `;

/**
 * __useInboxMessageReadySubscription__
 *
 * To run a query within a React component, call `useInboxMessageReadySubscription` and pass it any options that fit your needs.
 * When your component renders, `useInboxMessageReadySubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInboxMessageReadySubscription({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useInboxMessageReadySubscription(baseOptions: Apollo.SubscriptionHookOptions<InboxMessageReadySubscription, InboxMessageReadySubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InboxMessageReadySubscription, InboxMessageReadySubscriptionVariables>(InboxMessageReadyDocument, options);
      }
export type InboxMessageReadySubscriptionHookResult = ReturnType<typeof useInboxMessageReadySubscription>;
export type InboxMessageReadySubscriptionResult = Apollo.SubscriptionResult<InboxMessageReadySubscription>;
export const OnOpportunityStateChangedDocument = gql`
    subscription OnOpportunityStateChanged($id: String!) {
  opportunityStateChanged(id: $id) {
    id
    state
  }
}
    `;

/**
 * __useOnOpportunityStateChangedSubscription__
 *
 * To run a query within a React component, call `useOnOpportunityStateChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnOpportunityStateChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnOpportunityStateChangedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnOpportunityStateChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnOpportunityStateChangedSubscription, OnOpportunityStateChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnOpportunityStateChangedSubscription, OnOpportunityStateChangedSubscriptionVariables>(OnOpportunityStateChangedDocument, options);
      }
export type OnOpportunityStateChangedSubscriptionHookResult = ReturnType<typeof useOnOpportunityStateChangedSubscription>;
export type OnOpportunityStateChangedSubscriptionResult = Apollo.SubscriptionResult<OnOpportunityStateChangedSubscription>;
export const OnSubmissionStateChangedDocument = gql`
    subscription OnSubmissionStateChanged($id: String!) {
  submissionStateChanged(id: $id) {
    ...Submission
  }
}
    ${SubmissionFragmentDoc}
${AppetiteProductFragmentDoc}
${CarrierContactFragmentDoc}
${QuoteFragmentDoc}
${FileUploadFragmentDoc}
${QuoteStateTransitionFragmentDoc}
${SubmissionStateTransitionFragmentDoc}`;

/**
 * __useOnSubmissionStateChangedSubscription__
 *
 * To run a query within a React component, call `useOnSubmissionStateChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnSubmissionStateChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSubmissionStateChangedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnSubmissionStateChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnSubmissionStateChangedSubscription, OnSubmissionStateChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnSubmissionStateChangedSubscription, OnSubmissionStateChangedSubscriptionVariables>(OnSubmissionStateChangedDocument, options);
      }
export type OnSubmissionStateChangedSubscriptionHookResult = ReturnType<typeof useOnSubmissionStateChangedSubscription>;
export type OnSubmissionStateChangedSubscriptionResult = Apollo.SubscriptionResult<OnSubmissionStateChangedSubscription>;
export const OpportunityChangedDocument = gql`
    subscription OpportunityChanged($insuredId: String!) {
  opportunityChanged(insuredId: $insuredId) {
    insuredId
    opportunityId
  }
}
    `;

/**
 * __useOpportunityChangedSubscription__
 *
 * To run a query within a React component, call `useOpportunityChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOpportunityChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpportunityChangedSubscription({
 *   variables: {
 *      insuredId: // value for 'insuredId'
 *   },
 * });
 */
export function useOpportunityChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<OpportunityChangedSubscription, OpportunityChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OpportunityChangedSubscription, OpportunityChangedSubscriptionVariables>(OpportunityChangedDocument, options);
      }
export type OpportunityChangedSubscriptionHookResult = ReturnType<typeof useOpportunityChangedSubscription>;
export type OpportunityChangedSubscriptionResult = Apollo.SubscriptionResult<OpportunityChangedSubscription>;
export const PlaybookRunsChangedDocument = gql`
    subscription PlaybookRunsChanged($chatSessionId: String, $conversationId: String) {
  playbookRunsChanged(
    chatSessionId: $chatSessionId
    conversationId: $conversationId
  ) {
    playbookRunId
  }
}
    `;

/**
 * __usePlaybookRunsChangedSubscription__
 *
 * To run a query within a React component, call `usePlaybookRunsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePlaybookRunsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybookRunsChangedSubscription({
 *   variables: {
 *      chatSessionId: // value for 'chatSessionId'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function usePlaybookRunsChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<PlaybookRunsChangedSubscription, PlaybookRunsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<PlaybookRunsChangedSubscription, PlaybookRunsChangedSubscriptionVariables>(PlaybookRunsChangedDocument, options);
      }
export type PlaybookRunsChangedSubscriptionHookResult = ReturnType<typeof usePlaybookRunsChangedSubscription>;
export type PlaybookRunsChangedSubscriptionResult = Apollo.SubscriptionResult<PlaybookRunsChangedSubscription>;
export const SubmissionChangedDocument = gql`
    subscription SubmissionChanged($opportunityId: String!) {
  submissionChanged(opportunityId: $opportunityId) {
    opportunityId
    submissionId
  }
}
    `;

/**
 * __useSubmissionChangedSubscription__
 *
 * To run a query within a React component, call `useSubmissionChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubmissionChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubmissionChangedSubscription({
 *   variables: {
 *      opportunityId: // value for 'opportunityId'
 *   },
 * });
 */
export function useSubmissionChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<SubmissionChangedSubscription, SubmissionChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubmissionChangedSubscription, SubmissionChangedSubscriptionVariables>(SubmissionChangedDocument, options);
      }
export type SubmissionChangedSubscriptionHookResult = ReturnType<typeof useSubmissionChangedSubscription>;
export type SubmissionChangedSubscriptionResult = Apollo.SubscriptionResult<SubmissionChangedSubscription>;
export const ToolInvocationsChangedDocument = gql`
    subscription ToolInvocationsChanged($playbookRunId: String!) {
  toolInvocationsChanged(playbookRunId: $playbookRunId) {
    playbookRunId
  }
}
    `;

/**
 * __useToolInvocationsChangedSubscription__
 *
 * To run a query within a React component, call `useToolInvocationsChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useToolInvocationsChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToolInvocationsChangedSubscription({
 *   variables: {
 *      playbookRunId: // value for 'playbookRunId'
 *   },
 * });
 */
export function useToolInvocationsChangedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ToolInvocationsChangedSubscription, ToolInvocationsChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ToolInvocationsChangedSubscription, ToolInvocationsChangedSubscriptionVariables>(ToolInvocationsChangedDocument, options);
      }
export type ToolInvocationsChangedSubscriptionHookResult = ReturnType<typeof useToolInvocationsChangedSubscription>;
export type ToolInvocationsChangedSubscriptionResult = Apollo.SubscriptionResult<ToolInvocationsChangedSubscription>;